(function () {
	'use strict';

	angular.module('services.upload',[]).factory('uploadService', uploadService);

	/** @ngInject */
	function uploadService(settings, base, storage, $rootScope, $http) {

		return {
			fileUpload: function (file, config, filename) {
				var fd = new FormData();
				fd.append('fileName', file, filename);
				return $http.post(settings.fileUpload.url, fd, config)
			},
			imgUpload: function (file, config) {
				var fd = new FormData(); 
				fd.append('fileName', file, settings.baseUploadConfig.name);
				return $http.post(settings.baseUploadConfig.url, fd, config)
			}
		}
	}
})();

(function () {
	'use strict';

	angular.module('services.storage', []).factory('storage', storage);
	/** @ngInject */
	function storage($q, $window) {
		var Deferrer = function () {
			this.defer = $q.defer();
			return this;
		};

		var storageReplacement = {};
		var hasStorageEnabled = hasStorageEnabled() && hasCookiesEnabled(); //this is called only once so is faster 

		function hasCookiesEnabled(){
			var cookieEnabled=(navigator.cookieEnabled)? true : false;
			if (typeof navigator.cookieEnabled==='undefined' && !cookieEnabled){ 
				document.cookie = 'testcookie';
				cookieEnabled = (document.cookie.indexOf('testcookie')!==-1)? true : false;
			}
		return cookieEnabled;
		}

		function hasStorageEnabled(){
			try {
				var testKey = 'test';
				var storage = window.sessionStorage;
				storage.setItem(testKey, '1');
				storage.removeItem(testKey);

				var local = window.localStorage;
				local.setItem(testKey, '1');
				local.removeItem(testKey);
					
				return true;
			}
			catch (error) {
				return false;
			}
		}

		function setToken(tkn) {
			if(!hasStorageEnabled){
				storageReplacement['__c3'] = tkn.b64encode();
				storageReplacement['tkn'] = tkn;
			}else{
				$window.localStorage.setItem('__c3', tkn.b64encode());		
				$window.localStorage.setItem('tkn', tkn);		
			}
		}

		function del(key, persist) {
			if(!hasStorageEnabled){
				delete storageReplacement[key];
			}else{
				persist ? $window.localStorage.removeItem(key) : $window.sessionStorage.removeItem(key);
			}
		}

		return {
			hasStorageEnabled: hasStorageEnabled,
			hasCookiesEnabled: hasCookiesEnabled,
			has: function (key, persist) {
				if(!hasStorageEnabled){
					return _.isObject(storageReplacement[key]) || _.isString(storageReplacement[key]);
				}else{
					return persist ? (_.isObject($window.localStorage.getItem(key)) || _.isString($window.localStorage.getItem(key))) : (_.isObject($window.sessionStorage.getItem(key)) || _.isString($window.sessionStorage.getItem(key)));
				}
			},
			set: function (key, value, persist) {
				if(!hasStorageEnabled){
					storageReplacement[key] = value;
				}else{
					persist ? $window.localStorage.setItem(key, angular.toJson(value)) : $window.sessionStorage.setItem(key, angular.toJson(value));
				}
			},
			get: function (key, persist, now) {
				if(!hasStorageEnabled){
					return storageReplacement[key];
				}else{
					var deferred = new Deferrer().defer, item;
					persist ? item = angular.fromJson(localStorage.getItem(key)) : item = angular.fromJson(sessionStorage.getItem(key));
					item !== null ? deferred.resolve(item) : deferred.reject();
					if (now) return item
					else return deferred.promise					
				}
			},
			setToken: setToken,
			getToken: function(){
				
				var memToken = '';

				if(!hasStorageEnabled){
					var temp = storageReplacement['__c3'];
					if (temp) {
						memToken = temp.b64decode();
					}
				}else{
					var temp = $window.localStorage.getItem('__c3');
					if (temp){
						memToken = temp.b64decode();
					}
				}
				return memToken;
			},
			del: del
		}
	}

})();

(function () {
	'use strict';

	/**
	 * @ngdoc function
	 * @name error handler
	 * @description intercepts $http errors and logs
	 * #
	 */
	angular.module('services.httpInterceptor', []).service('httpInterceptor', httpInterceptor);

	/** @ngInject */
	function httpInterceptor($q, $injector, $rootScope, $translate, storage, $cacheFactory, gaService) {
		var authService = function () { return $injector.get('authService') };
		var toastr = function () { return $injector.get('toastr') };
		var offlineShown = false;
		var errorShown = false;
		var retries = 0;
		var maxRetries = 3;
		var ignoreErrors = false;
		
		function err(message, name) {
			this.message = message;
			this.name = name;
		}

		function logError(res){
			var errorMessage;
			var status;

			try{
				errorMessage = res.data.error.message;
				status = res.status;
			}catch(exception){
				//meh
				errorMessage = "NO_MESSAGE";
				status = "NO_STATUS";
			}

			gaService.exception({
				exDescription: location.hash + ' '+ status + ' ' + errorMessage,
				exFatal: true
			});
		}

		return {
			request : function(config) {
				if (config.ignoreErrors) {
					ignoreErrors = config.ignoreErrors;
				}
				var xhr = config.xhr || false;				
				if(xhr && _.isString(storage.getToken())){
					config.headers['ClasslistToken'] = storage.getToken();
					
					if ($rootScope.active_user){
						config.headers['u'] = $rootScope.active_user.id;
					}

					if ($rootScope.active_school){
						config.headers['s'] = $rootScope.active_school.id;
					}
					
					config.headers['p'] = "web-parent";
					config.headers['v'] = getFrontendVersion ? getFrontendVersion() : 'no_version';
					config.headers['n'] = getIfNative();

					config.headers['x'] = (document.cookie.indexOf('X-Source=experiment') > -1);
				}
				return config
			},
			response : function(res) {
				return res
			},
			requestError : function (error) {
				if(error){
					throw new err(error.statusText, error.status)
				}
				return error
			},
			responseError : function (res) {
				switch (res.status) {
					case -1: {
						if(!offlineShown) {
							toastr().info('Sorry something went wrong, please check your internet connection');
							offlineShown = true;

							setTimeout(function() {
								offlineShown = false;
							}, 3000);

							// stacktrace
							try {
								errorHandler.report('-1 responseError => ' + location.href);
							}
							catch(ex) {
							//Skip for now.
							}
						}

						break;
					}

					case 400: {
						if(navigator.onLine && !errorShown) {
							toastr().info("We've encountered an error processing your request. Please try again later");
							
							errorShown = true;
							setTimeout(function() {
								errorShown = false;
							}, 3000);
						}

						break;
					}

					case 401: // Unauthorized
						if (!res.config.cache && res.config.method === 'GET') {
							authService().logout(true, "http-interceptor-endpoint-call-401");
						}
						// return;//it will return response ok, we need to handle this somehow in the logic, if we return error it will generate a toast error message
						break;
					case 500: // Internal server error
					case 503: // Service Unavailable
						if(res.config.method === 'POST' || res.config.method === 'PUT' || res.config.method === 'DELETE') {
							if(!errorShown) {
								toastr().info("We've encountered an error processing your request. Please try again later");
								
								errorShown = true;
								setTimeout(function() {
									errorShown = false;
								}, 3000);
							}

							logError(res);
						}
						else {
							if (retries < maxRetries) {
								retries++;
								console.log('Trying 500 fail ' + retries + ' times')
								var $http = $injector.get('$http');
								return $http(res.config);
							}	
						}
					break;

					case 410:
					case 404: // Not Found
							logError(res);
							$rootScope.$broadcast('NOT_FOUND');
						break;
					case 403: // Forbidden
							if (!ignoreErrors) {
								logError(res);
								if (!location.href.includes("#/welcome")) {
									$rootScope.nonmemberurl = location.href;
									location.href = '#/welcome';
								}
							}
						break;						
				}

				//Emese - 29/06/17
				//This includes 400 bad requests
				logError(res);
				retries = 0;
				return $q.reject(res);
			}
		}

	}

})();

(function () {
	'use strict';

	angular.module('services.ganalytics',[]).factory('gaService', gaService);

	/** @ngInject */
	function gaService($window, settings) {

		$window.ga('create', settings.gaUserId, 'auto');
		$window.ga('set', 'forceSSL', true);

		return {
			send: function (page) {

				if (page === null || page === '/' || _.isUndefined(page) || page === 'undefined'){
					var location = $window.location.hash;
					page = '/undefined error ' + location;
				}
				
				$window.ga('send', 'pageview', page);
			},
			exception: function (data) {
				$window.ga('send', 'exception', data);
			}
		}
	}
})();

(function () {
  'use strict';

  /**
    * @ngdoc function
    * @name error handler
    * @description intercepts Javascript errors and reports
    * #
    */

  angular.module('services.errorHandler', [])
		.factory('$exceptionHandler', ['$log', '$window', function($log, $window) {
			return function(exception, cause) {
				//StackdriverErrors.report(exception);
        try {
          errorHandler.report(exception);
        }
        catch(ex) {
        //Skip for now.
        }

				$log.warn('Reported error:', exception, cause);
			};
		}])
})();

(function () {
  'use strict';

  angular.module('services.base',[]).factory('base', base);

  /** @ngInject */
  function base($http, $log, $window, settings) {

    var notifications = {
      'js': [],
      'http':[],
			'badrequest':[]
    }, events = {};

    return {
      isReady: false,
      init: function () {

      },
      post:function (resource, payload, config) {
        var baseURL = settings.gae.url;
        if (resource.indexOf("payment/v1") > -1){
          baseURL = settings.gae.rootUrl;
        }
        return $http.post(baseURL + resource, angular.toJson(payload), _.assign(settings.http, config));
      },
			put:function (resource, payload, config) {
				return $http.put(settings.gae.url + resource, angular.toJson(payload), _.assign(settings.http, config));
			},
			delete:function (resource, config) {
				return $http.delete(settings.gae.url + resource, _.assign(settings.http, config));
			},
      subscribe: function(target, callback_fn){
        events[target] = callback_fn;
      },
			unsubscribe: function(target){
				delete events[target]
			},
      get:function (resource, config) {
        var baseURL = settings.gae.url;
        if (resource.indexOf("payment/v1") > -1){
          baseURL = settings.gae.rootUrl;
        }
        if (resource.indexOf("/preview") > -1){
          baseURL = settings.gae.rootUrl;
        }
        return $http.get(baseURL + resource, _.assign(settings.http, config));
      },
      notify: function (message, target) {
        events[target](message);
        notifications[target].push(message);
      },
      denotify: function (item, target) {
        notifications[target] = _.without(notifications[target], item);

      },
      flushNotifications: function (target) {
        notifications[target].length = 0;
      },
      flushAll: function(){
        notifications['js'].length = 0;
        notifications['http'].length = 0;
      },
      getNotifications: function(target){
        return notifications[target]
      },
      getPostImgBucketUrl: function(target){
        return settings.baseUploadConfig.url
      },
      extGet:function (resource, config) {
        return $http.get(resource,  _.assign(settings.http, config));
      }
    }
  }
})();

(function () {
	'use strict';

	angular.module('services.auth',[]).factory('authService', authService);

	/** @ngInject */
	function authService($window, settings, $rootScope, toastr, storage, base, $translate, $location) {

		function flush() {
			try{
				window.localStorage.clear();
			}catch(ex){
				//Skip for now.
			}
		}

		//isUnautorized means that was not the user to click but probably the server
		function redirectToLogin(isUnautorized, reason) {
			flush();
			var redirectUrl = settings.conf.ssoAppURL;
			
			if(isUnautorized) {
				var search = $location.search();

				if(search.e) {
					if (!getIfNative()){
						$rootScope.$broadcast('SECURITY_CHECK');
					} 
					else {
						console.log(1);
						//window.location = redirectUrl +'/#/?unauthorized=parent&redirection=1&returnURL=' + encodeURIComponent(window.location.href);
					}
				}
				else {
					console.log(2);
					//window.location = redirectUrl +'/#/?unauthorized=parent&redirection=1&returnURL=' + encodeURIComponent(window.location.href);
				}
			}
			else {
				window.location = redirectUrl +'/#/?force=true';
			}
		}
		return {
			logout: function (isUnautorized, reason) {
				
				if(!_.isNull(storage.getToken())) {
					var tkn = storage.getToken();

					base.post('sso/v1/signOut', { }, { 'headers': { 'ClasslistToken': tkn }}).then(function (response) {
						redirectToLogin(isUnautorized, reason);
					}, 
					function(error) {
						redirectToLogin(isUnautorized, reason);
					})
				} 
				else {
					redirectToLogin(isUnautorized, reason);
				}
			}
		}
	}

})();
/*
 * angular-ui-bootstrap
 * http://angular-ui.github.io/bootstrap/

 * Version: 2.0.1 - 2016-08-02
 * License: MIT
 */angular.module("ui.bootstrap",["ui.bootstrap.tpls","ui.bootstrap.datepickerPopup","ui.bootstrap.datepicker","ui.bootstrap.dateparser","ui.bootstrap.isClass","ui.bootstrap.position","ui.bootstrap.timepicker","ui.bootstrap.modal","ui.bootstrap.stackedMap","ui.bootstrap.typeahead","ui.bootstrap.debounce"]),angular.module("ui.bootstrap.tpls",["uib/template/datepickerPopup/popup.html","uib/template/datepicker/datepicker.html","uib/template/datepicker/day.html","uib/template/datepicker/month.html","uib/template/datepicker/year.html","uib/template/timepicker/timepicker.html","uib/template/modal/window.html","uib/template/typeahead/typeahead-match.html","uib/template/typeahead/typeahead-popup.html"]),angular.module("ui.bootstrap.datepickerPopup",["ui.bootstrap.datepicker","ui.bootstrap.position"]).value("$datepickerPopupLiteralWarning",!0).constant("uibDatepickerPopupConfig",{altInputFormats:[],appendToBody:!1,clearText:"Clear",closeOnDateSelection:!0,closeText:"Done",currentText:"Today",datepickerPopup:"yyyy-MM-dd",datepickerPopupTemplateUrl:"uib/template/datepickerPopup/popup.html",datepickerTemplateUrl:"uib/template/datepicker/datepicker.html",html5Types:{date:"yyyy-MM-dd","datetime-local":"yyyy-MM-ddTHH:mm:ss.sss",month:"yyyy-MM"},onOpenFocus:!0,showButtonBar:!0,placement:"auto bottom-left"}).controller("UibDatepickerPopupController",["$scope","$element","$attrs","$compile","$log","$parse","$window","$document","$rootScope","$uibPosition","dateFilter","uibDateParser","uibDatepickerPopupConfig","$timeout","uibDatepickerConfig","$datepickerPopupLiteralWarning",function(e,t,n,a,i,r,o,s,l,u,c,d,p,h,f,m){function g(t){var n=d.parse(t,k,e.date);if(isNaN(n))for(var a=0;a<N.length;a++)if(n=d.parse(t,N[a],e.date),!isNaN(n))return n;return n}function b(e){if(angular.isNumber(e)&&(e=new Date(e)),!e)return null;if(angular.isDate(e)&&!isNaN(e))return e;if(angular.isString(e)){var t=g(e);if(!isNaN(t))return t}return I.$options&&I.$options.allowInvalid?e:void 0}function v(e,t){var a=e||t;return n.ngRequired||a?(angular.isNumber(a)&&(a=new Date(a)),a?angular.isDate(a)&&!isNaN(a)?!0:angular.isString(a)?!isNaN(g(a)):!1:!0):!0}function y(n){if(e.isOpen||!e.disabled){var a=A[0],i=t[0].contains(n.target),r=void 0!==a.contains&&a.contains(n.target);!e.isOpen||i||r||e.$apply(function(){e.isOpen=!1})}}function w(n){27===n.which&&e.isOpen?(n.preventDefault(),n.stopPropagation(),e.$apply(function(){e.isOpen=!1}),t[0].focus()):40!==n.which||e.isOpen||(n.preventDefault(),n.stopPropagation(),e.$apply(function(){e.isOpen=!0}))}function $(){if(e.isOpen){var a=angular.element(A[0].querySelector(".uib-datepicker-popup")),i=n.popupPlacement?n.popupPlacement:p.placement,r=u.positionElements(t,a,i,M);a.css({top:r.top+"px",left:r.left+"px"}),a.hasClass("uib-position-measure")&&a.removeClass("uib-position-measure")}}var k,D,M,x,T,S,O,C,E,I,F,A,N,P=!1,U=[];this.init=function(i){if(I=i,F=i.$options,D=angular.isDefined(n.closeOnDateSelection)?e.$parent.$eval(n.closeOnDateSelection):p.closeOnDateSelection,M=angular.isDefined(n.datepickerAppendToBody)?e.$parent.$eval(n.datepickerAppendToBody):p.appendToBody,x=angular.isDefined(n.onOpenFocus)?e.$parent.$eval(n.onOpenFocus):p.onOpenFocus,T=angular.isDefined(n.datepickerPopupTemplateUrl)?n.datepickerPopupTemplateUrl:p.datepickerPopupTemplateUrl,S=angular.isDefined(n.datepickerTemplateUrl)?n.datepickerTemplateUrl:p.datepickerTemplateUrl,N=angular.isDefined(n.altInputFormats)?e.$parent.$eval(n.altInputFormats):p.altInputFormats,e.showButtonBar=angular.isDefined(n.showButtonBar)?e.$parent.$eval(n.showButtonBar):p.showButtonBar,p.html5Types[n.type]?(k=p.html5Types[n.type],P=!0):(k=n.uibDatepickerPopup||p.datepickerPopup,n.$observe("uibDatepickerPopup",function(e){var t=e||p.datepickerPopup;if(t!==k&&(k=t,I.$modelValue=null,!k))throw new Error("uibDatepickerPopup must have a date format specified.")})),!k)throw new Error("uibDatepickerPopup must have a date format specified.");if(P&&n.uibDatepickerPopup)throw new Error("HTML5 date input types do not support custom formats.");O=angular.element("<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>"),O.attr({"ng-model":"date","ng-change":"dateSelection(date)","template-url":T}),C=angular.element(O.children()[0]),C.attr("template-url",S),e.datepickerOptions||(e.datepickerOptions={}),P&&"month"===n.type&&(e.datepickerOptions.datepickerMode="month",e.datepickerOptions.minMode="month"),C.attr("datepicker-options","datepickerOptions"),P?I.$formatters.push(function(t){return e.date=t,t}):(I.$$parserName="date",I.$validators.date=v,I.$parsers.unshift(b),I.$formatters.push(function(t){return I.$isEmpty(t)?(e.date=t,t):(angular.isNumber(t)&&(t=new Date(t)),e.date=t,d.filter(e.date,k))})),I.$viewChangeListeners.push(function(){e.date=g(I.$viewValue)}),t.on("keydown",w),A=a(O)(e),O.remove(),M?s.find("body").append(A):t.after(A),e.$on("$destroy",function(){for(e.isOpen===!0&&(l.$$phase||e.$apply(function(){e.isOpen=!1})),A.remove(),t.off("keydown",w),s.off("click",y),E&&E.off("scroll",$),angular.element(o).off("resize",$);U.length;)U.shift()()})},e.getText=function(t){return e[t+"Text"]||p[t+"Text"]},e.isDisabled=function(t){"today"===t&&(t=new Date);var n={};return angular.forEach(["minDate","maxDate"],function(t){e.datepickerOptions[t]?angular.isDate(e.datepickerOptions[t])?n[t]=new Date(e.datepickerOptions[t]):(m&&i.warn("Literal date support has been deprecated, please switch to date object usage"),n[t]=new Date(c(e.datepickerOptions[t],"medium"))):n[t]=null}),e.datepickerOptions&&n.minDate&&e.compare(t,n.minDate)<0||n.maxDate&&e.compare(t,n.maxDate)>0},e.compare=function(e,t){return new Date(e.getFullYear(),e.getMonth(),e.getDate())-new Date(t.getFullYear(),t.getMonth(),t.getDate())},e.dateSelection=function(n){e.date=n;var a=e.date?d.filter(e.date,k):null;t.val(a),I.$setViewValue(a),D&&(e.isOpen=!1,t[0].focus())},e.keydown=function(n){27===n.which&&(n.stopPropagation(),e.isOpen=!1,t[0].focus())},e.select=function(t,n){if(n.stopPropagation(),"today"===t){var a=new Date;angular.isDate(e.date)?(t=new Date(e.date),t.setFullYear(a.getFullYear(),a.getMonth(),a.getDate())):t=new Date(a.setHours(0,0,0,0))}e.dateSelection(t)},e.close=function(n){n.stopPropagation(),e.isOpen=!1,t[0].focus()},e.disabled=angular.isDefined(n.disabled)||!1,n.ngDisabled&&U.push(e.$parent.$watch(r(n.ngDisabled),function(t){e.disabled=t})),e.$watch("isOpen",function(a){a?e.disabled?e.isOpen=!1:h(function(){$(),x&&e.$broadcast("uib:datepicker.focus"),s.on("click",y);var a=n.popupPlacement?n.popupPlacement:p.placement;M||u.parsePlacement(a)[2]?(E=E||angular.element(u.scrollParent(t)),E&&E.on("scroll",$)):E=null,angular.element(o).on("resize",$)},0,!1):(s.off("click",y),E&&E.off("scroll",$),angular.element(o).off("resize",$))}),e.$on("uib:datepicker.mode",function(){h($,0,!1)})}]).directive("uibDatepickerPopup",function(){return{require:["ngModel","uibDatepickerPopup"],controller:"UibDatepickerPopupController",scope:{datepickerOptions:"=?",isOpen:"=?",currentText:"@",clearText:"@",closeText:"@"},link:function(e,t,n,a){var i=a[0],r=a[1];r.init(i)}}}).directive("uibDatepickerPopupWrap",function(){return{restrict:"A",transclude:!0,templateUrl:function(e,t){return t.templateUrl||"uib/template/datepickerPopup/popup.html"}}}),angular.module("ui.bootstrap.datepicker",["ui.bootstrap.dateparser","ui.bootstrap.isClass"]).value("$datepickerSuppressError",!1).value("$datepickerLiteralWarning",!0).constant("uibDatepickerConfig",{datepickerMode:"day",formatDay:"dd",formatMonth:"MMMM",formatYear:"yyyy",formatDayHeader:"EEE",formatDayTitle:"MMMM yyyy",formatMonthTitle:"yyyy",maxDate:null,maxMode:"year",minDate:null,minMode:"day",monthColumns:3,ngModelOptions:{},shortcutPropagation:!1,showWeeks:!0,yearColumns:5,yearRows:4}).controller("UibDatepickerController",["$scope","$element","$attrs","$parse","$interpolate","$locale","$log","dateFilter","uibDatepickerConfig","$datepickerLiteralWarning","$datepickerSuppressError","uibDateParser",function(e,t,n,a,i,r,o,s,l,u,c,d){function p(t){e.datepickerMode=t,e.datepickerOptions.datepickerMode=t}var h=this,f={$setViewValue:angular.noop},m={},g=[];t.addClass("uib-datepicker"),n.$set("role","application"),e.datepickerOptions||(e.datepickerOptions={}),this.modes=["day","month","year"],["customClass","dateDisabled","datepickerMode","formatDay","formatDayHeader","formatDayTitle","formatMonth","formatMonthTitle","formatYear","maxDate","maxMode","minDate","minMode","monthColumns","showWeeks","shortcutPropagation","startingDay","yearColumns","yearRows"].forEach(function(t){switch(t){case"customClass":case"dateDisabled":e[t]=e.datepickerOptions[t]||angular.noop;break;case"datepickerMode":e.datepickerMode=angular.isDefined(e.datepickerOptions.datepickerMode)?e.datepickerOptions.datepickerMode:l.datepickerMode;break;case"formatDay":case"formatDayHeader":case"formatDayTitle":case"formatMonth":case"formatMonthTitle":case"formatYear":h[t]=angular.isDefined(e.datepickerOptions[t])?i(e.datepickerOptions[t])(e.$parent):l[t];break;case"monthColumns":case"showWeeks":case"shortcutPropagation":case"yearColumns":case"yearRows":h[t]=angular.isDefined(e.datepickerOptions[t])?e.datepickerOptions[t]:l[t];break;case"startingDay":h.startingDay=angular.isDefined(e.datepickerOptions.startingDay)?e.datepickerOptions.startingDay:angular.isNumber(l.startingDay)?l.startingDay:(r.DATETIME_FORMATS.FIRSTDAYOFWEEK+8)%7;break;case"maxDate":case"minDate":e.$watch("datepickerOptions."+t,function(e){e?angular.isDate(e)?h[t]=d.fromTimezone(new Date(e),m.timezone):(u&&o.warn("Literal date support has been deprecated, please switch to date object usage"),h[t]=new Date(s(e,"medium"))):h[t]=l[t]?d.fromTimezone(new Date(l[t]),m.timezone):null,h.refreshView()});break;case"maxMode":case"minMode":e.datepickerOptions[t]?e.$watch(function(){return e.datepickerOptions[t]},function(n){h[t]=e[t]=angular.isDefined(n)?n:datepickerOptions[t],("minMode"===t&&h.modes.indexOf(e.datepickerOptions.datepickerMode)<h.modes.indexOf(h[t])||"maxMode"===t&&h.modes.indexOf(e.datepickerOptions.datepickerMode)>h.modes.indexOf(h[t]))&&(e.datepickerMode=h[t],e.datepickerOptions.datepickerMode=h[t])}):h[t]=e[t]=l[t]||null}}),e.uniqueId="datepicker-"+e.$id+"-"+Math.floor(1e4*Math.random()),e.disabled=angular.isDefined(n.disabled)||!1,angular.isDefined(n.ngDisabled)&&g.push(e.$parent.$watch(n.ngDisabled,function(t){e.disabled=t,h.refreshView()})),e.isActive=function(t){return 0===h.compare(t.date,h.activeDate)?(e.activeDateId=t.uid,!0):!1},this.init=function(t){f=t,m=t.$options||e.datepickerOptions.ngModelOptions||l.ngModelOptions,e.datepickerOptions.initDate?(h.activeDate=d.fromTimezone(e.datepickerOptions.initDate,m.timezone)||new Date,e.$watch("datepickerOptions.initDate",function(e){e&&(f.$isEmpty(f.$modelValue)||f.$invalid)&&(h.activeDate=d.fromTimezone(e,m.timezone),h.refreshView())})):h.activeDate=new Date;var n=f.$modelValue?new Date(f.$modelValue):new Date;this.activeDate=isNaN(n)?d.fromTimezone(new Date,m.timezone):d.fromTimezone(n,m.timezone),f.$render=function(){h.render()}},this.render=function(){if(f.$viewValue){var e=new Date(f.$viewValue),t=!isNaN(e);t?this.activeDate=d.fromTimezone(e,m.timezone):c||o.error('Datepicker directive: "ng-model" value must be a Date object')}this.refreshView()},this.refreshView=function(){if(this.element){e.selectedDt=null,this._refreshView(),e.activeDt&&(e.activeDateId=e.activeDt.uid);var t=f.$viewValue?new Date(f.$viewValue):null;t=d.fromTimezone(t,m.timezone),f.$setValidity("dateDisabled",!t||this.element&&!this.isDisabled(t))}},this.createDateObject=function(t,n){var a=f.$viewValue?new Date(f.$viewValue):null;a=d.fromTimezone(a,m.timezone);var i=new Date;i=d.fromTimezone(i,m.timezone);var r=this.compare(t,i),o={date:t,label:d.filter(t,n),selected:a&&0===this.compare(t,a),disabled:this.isDisabled(t),past:0>r,current:0===r,future:r>0,customClass:this.customClass(t)||null};return a&&0===this.compare(t,a)&&(e.selectedDt=o),h.activeDate&&0===this.compare(o.date,h.activeDate)&&(e.activeDt=o),o},this.isDisabled=function(t){return e.disabled||this.minDate&&this.compare(t,this.minDate)<0||this.maxDate&&this.compare(t,this.maxDate)>0||e.dateDisabled&&e.dateDisabled({date:t,mode:e.datepickerMode})},this.customClass=function(t){return e.customClass({date:t,mode:e.datepickerMode})},this.split=function(e,t){for(var n=[];e.length>0;)n.push(e.splice(0,t));return n},e.select=function(t){if(e.datepickerMode===h.minMode){var n=f.$viewValue?d.fromTimezone(new Date(f.$viewValue),m.timezone):new Date(0,0,0,0,0,0,0);n.setFullYear(t.getFullYear(),t.getMonth(),t.getDate()),n=d.toTimezone(n,m.timezone),f.$setViewValue(n),f.$render()}else h.activeDate=t,p(h.modes[h.modes.indexOf(e.datepickerMode)-1]),e.$emit("uib:datepicker.mode");e.$broadcast("uib:datepicker.focus")},e.move=function(e){var t=h.activeDate.getFullYear()+e*(h.step.years||0),n=h.activeDate.getMonth()+e*(h.step.months||0);h.activeDate.setFullYear(t,n,1),h.refreshView()},e.toggleMode=function(t){t=t||1,e.datepickerMode===h.maxMode&&1===t||e.datepickerMode===h.minMode&&-1===t||(p(h.modes[h.modes.indexOf(e.datepickerMode)+t]),e.$emit("uib:datepicker.mode"))},e.keys={13:"enter",32:"space",33:"pageup",34:"pagedown",35:"end",36:"home",37:"left",38:"up",39:"right",40:"down"};var b=function(){h.element[0].focus()};e.$on("uib:datepicker.focus",b),e.keydown=function(t){var n=e.keys[t.which];if(n&&!t.shiftKey&&!t.altKey&&!e.disabled)if(t.preventDefault(),h.shortcutPropagation||t.stopPropagation(),"enter"===n||"space"===n){if(h.isDisabled(h.activeDate))return;e.select(h.activeDate)}else!t.ctrlKey||"up"!==n&&"down"!==n?(h.handleKeyDown(n,t),h.refreshView()):e.toggleMode("up"===n?1:-1)},t.on("keydown",function(t){e.$apply(function(){e.keydown(t)})}),e.$on("$destroy",function(){for(;g.length;)g.shift()()})}]).controller("UibDaypickerController",["$scope","$element","dateFilter",function(e,t,n){function a(e,t){return 1!==t||e%4!==0||e%100===0&&e%400!==0?r[t]:29}function i(e){var t=new Date(e);t.setDate(t.getDate()+4-(t.getDay()||7));var n=t.getTime();return t.setMonth(0),t.setDate(1),Math.floor(Math.round((n-t)/864e5)/7)+1}var r=[31,28,31,30,31,30,31,31,30,31,30,31];this.step={months:1},this.element=t,this.init=function(t){angular.extend(t,this),e.showWeeks=t.showWeeks,t.refreshView()},this.getDates=function(e,t){for(var n,a=new Array(t),i=new Date(e),r=0;t>r;)n=new Date(i),a[r++]=n,i.setDate(i.getDate()+1);return a},this._refreshView=function(){var t=this.activeDate.getFullYear(),a=this.activeDate.getMonth(),r=new Date(this.activeDate);r.setFullYear(t,a,1);var o=this.startingDay-r.getDay(),s=o>0?7-o:-o,l=new Date(r);s>0&&l.setDate(-s+1);for(var u=this.getDates(l,42),c=0;42>c;c++)u[c]=angular.extend(this.createDateObject(u[c],this.formatDay),{secondary:u[c].getMonth()!==a,uid:e.uniqueId+"-"+c});e.labels=new Array(7);for(var d=0;7>d;d++)e.labels[d]={abbr:n(u[d].date,this.formatDayHeader),full:n(u[d].date,"EEEE")};if(e.title=n(this.activeDate,this.formatDayTitle),e.rows=this.split(u,7),e.showWeeks){e.weekNumbers=[];for(var p=(11-this.startingDay)%7,h=e.rows.length,f=0;h>f;f++)e.weekNumbers.push(i(e.rows[f][p].date))}},this.compare=function(e,t){var n=new Date(e.getFullYear(),e.getMonth(),e.getDate()),a=new Date(t.getFullYear(),t.getMonth(),t.getDate());return n.setFullYear(e.getFullYear()),a.setFullYear(t.getFullYear()),n-a},this.handleKeyDown=function(e){var t=this.activeDate.getDate();if("left"===e)t-=1;else if("up"===e)t-=7;else if("right"===e)t+=1;else if("down"===e)t+=7;else if("pageup"===e||"pagedown"===e){var n=this.activeDate.getMonth()+("pageup"===e?-1:1);this.activeDate.setMonth(n,1),t=Math.min(a(this.activeDate.getFullYear(),this.activeDate.getMonth()),t)}else"home"===e?t=1:"end"===e&&(t=a(this.activeDate.getFullYear(),this.activeDate.getMonth()));this.activeDate.setDate(t)}}]).controller("UibMonthpickerController",["$scope","$element","dateFilter",function(e,t,n){this.step={years:1},this.element=t,this.init=function(e){angular.extend(e,this),e.refreshView()},this._refreshView=function(){for(var t,a=new Array(12),i=this.activeDate.getFullYear(),r=0;12>r;r++)t=new Date(this.activeDate),t.setFullYear(i,r,1),a[r]=angular.extend(this.createDateObject(t,this.formatMonth),{uid:e.uniqueId+"-"+r});e.title=n(this.activeDate,this.formatMonthTitle),e.rows=this.split(a,this.monthColumns),e.yearHeaderColspan=this.monthColumns>3?this.monthColumns-2:1},this.compare=function(e,t){var n=new Date(e.getFullYear(),e.getMonth()),a=new Date(t.getFullYear(),t.getMonth());return n.setFullYear(e.getFullYear()),a.setFullYear(t.getFullYear()),n-a},this.handleKeyDown=function(e){var t=this.activeDate.getMonth();if("left"===e)t-=1;else if("up"===e)t-=this.monthColumns;else if("right"===e)t+=1;else if("down"===e)t+=this.monthColumns;else if("pageup"===e||"pagedown"===e){var n=this.activeDate.getFullYear()+("pageup"===e?-1:1);this.activeDate.setFullYear(n)}else"home"===e?t=0:"end"===e&&(t=11);this.activeDate.setMonth(t)}}]).controller("UibYearpickerController",["$scope","$element","dateFilter",function(e,t){function n(e){return parseInt((e-1)/i,10)*i+1}var a,i;this.element=t,this.yearpickerInit=function(){a=this.yearColumns,i=this.yearRows*a,this.step={years:i}},this._refreshView=function(){for(var t,r=new Array(i),o=0,s=n(this.activeDate.getFullYear());i>o;o++)t=new Date(this.activeDate),t.setFullYear(s+o,0,1),r[o]=angular.extend(this.createDateObject(t,this.formatYear),{uid:e.uniqueId+"-"+o});e.title=[r[0].label,r[i-1].label].join(" - "),e.rows=this.split(r,a),e.columns=a},this.compare=function(e,t){return e.getFullYear()-t.getFullYear()},this.handleKeyDown=function(e){var t=this.activeDate.getFullYear();"left"===e?t-=1:"up"===e?t-=a:"right"===e?t+=1:"down"===e?t+=a:"pageup"===e||"pagedown"===e?t+=("pageup"===e?-1:1)*i:"home"===e?t=n(this.activeDate.getFullYear()):"end"===e&&(t=n(this.activeDate.getFullYear())+i-1),this.activeDate.setFullYear(t)}}]).directive("uibDatepicker",function(){return{templateUrl:function(e,t){return t.templateUrl||"uib/template/datepicker/datepicker.html"},scope:{datepickerOptions:"=?"},require:["uibDatepicker","^ngModel"],restrict:"A",controller:"UibDatepickerController",controllerAs:"datepicker",link:function(e,t,n,a){var i=a[0],r=a[1];i.init(r)}}}).directive("uibDaypicker",function(){return{templateUrl:function(e,t){return t.templateUrl||"uib/template/datepicker/day.html"},require:["^uibDatepicker","uibDaypicker"],restrict:"A",controller:"UibDaypickerController",link:function(e,t,n,a){var i=a[0],r=a[1];r.init(i)}}}).directive("uibMonthpicker",function(){return{templateUrl:function(e,t){return t.templateUrl||"uib/template/datepicker/month.html"},require:["^uibDatepicker","uibMonthpicker"],restrict:"A",controller:"UibMonthpickerController",link:function(e,t,n,a){var i=a[0],r=a[1];r.init(i)}}}).directive("uibYearpicker",function(){return{templateUrl:function(e,t){return t.templateUrl||"uib/template/datepicker/year.html"},require:["^uibDatepicker","uibYearpicker"],restrict:"A",controller:"UibYearpickerController",link:function(e,t,n,a){var i=a[0];angular.extend(i,a[1]),i.yearpickerInit(),i.refreshView()}}}),angular.module("ui.bootstrap.dateparser",[]).service("uibDateParser",["$log","$locale","dateFilter","orderByFilter",function(e,t,n,a){function i(e){var t=[],n=e.split(""),i=e.indexOf("'");if(i>-1){var r=!1;e=e.split("");for(var o=i;o<e.length;o++)r?("'"===e[o]&&(o+1<e.length&&"'"===e[o+1]?(e[o+1]="$",n[o+1]=""):(n[o]="",r=!1)),e[o]="$"):"'"===e[o]&&(e[o]="$",n[o]="",r=!0);e=e.join("")}return angular.forEach(g,function(a){var i=e.indexOf(a.key);if(i>-1){e=e.split(""),n[i]="("+a.regex+")",e[i]="$";for(var r=i+1,o=i+a.key.length;o>r;r++)n[r]="",e[r]="$";e=e.join(""),t.push({index:i,key:a.key,apply:a.apply,matcher:a.regex})}}),{regex:new RegExp("^"+n.join("")+"$"),map:a(t,"index")}}function r(e){for(var t,n,a=[],i=0;i<e.length;)if(angular.isNumber(n)){if("'"===e.charAt(i))(i+1>=e.length||"'"!==e.charAt(i+1))&&(a.push(o(e,n,i)),n=null);else if(i===e.length)for(;n<e.length;)t=s(e,n),a.push(t),n=t.endIdx;i++}else"'"!==e.charAt(i)?(t=s(e,i),a.push(t.parser),i=t.endIdx):(n=i,i++);return a}function o(e,t,n){return function(){return e.substr(t+1,n-t-1)}}function s(e,t){for(var n=e.substr(t),a=0;a<g.length;a++)if(new RegExp("^"+g[a].key).test(n)){var i=g[a];return{endIdx:t+i.key.length,parser:i.formatter}}return{endIdx:t+1,parser:function(){return n.charAt(0)}}}function l(e,t,n){return 1>n?!1:1===t&&n>28?29===n&&(e%4===0&&e%100!==0||e%400===0):3===t||5===t||8===t||10===t?31>n:!0}function u(e){return parseInt(e,10)}function c(e,t){return e&&t?f(e,t):e}function d(e,t){return e&&t?f(e,t,!0):e}function p(e,t){e=e.replace(/:/g,"");var n=Date.parse("Jan 01, 1970 00:00:00 "+e)/6e4;return isNaN(n)?t:n}function h(e,t){return e=new Date(e.getTime()),e.setMinutes(e.getMinutes()+t),e}function f(e,t,n){n=n?-1:1;var a=e.getTimezoneOffset(),i=p(t,a);return h(e,n*(i-a))}var m,g,b=/[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;this.init=function(){m=t.id,this.parsers={},this.formatters={},g=[{key:"yyyy",regex:"\\d{4}",apply:function(e){this.year=+e},formatter:function(e){var t=new Date;return t.setFullYear(Math.abs(e.getFullYear())),n(t,"yyyy")}},{key:"yy",regex:"\\d{2}",apply:function(e){e=+e,this.year=69>e?e+2e3:e+1900},formatter:function(e){var t=new Date;return t.setFullYear(Math.abs(e.getFullYear())),n(t,"yy")}},{key:"y",regex:"\\d{1,4}",apply:function(e){this.year=+e},formatter:function(e){var t=new Date;return t.setFullYear(Math.abs(e.getFullYear())),n(t,"y")}},{key:"M!",regex:"0?[1-9]|1[0-2]",apply:function(e){this.month=e-1},formatter:function(e){var t=e.getMonth();return/^[0-9]$/.test(t)?n(e,"MM"):n(e,"M")}},{key:"MMMM",regex:t.DATETIME_FORMATS.MONTH.join("|"),apply:function(e){this.month=t.DATETIME_FORMATS.MONTH.indexOf(e)},formatter:function(e){return n(e,"MMMM")}},{key:"MMM",regex:t.DATETIME_FORMATS.SHORTMONTH.join("|"),apply:function(e){this.month=t.DATETIME_FORMATS.SHORTMONTH.indexOf(e)},formatter:function(e){return n(e,"MMM")}},{key:"MM",regex:"0[1-9]|1[0-2]",apply:function(e){this.month=e-1},formatter:function(e){return n(e,"MM")}},{key:"M",regex:"[1-9]|1[0-2]",apply:function(e){this.month=e-1},formatter:function(e){return n(e,"M")}},{key:"d!",regex:"[0-2]?[0-9]{1}|3[0-1]{1}",apply:function(e){this.date=+e},formatter:function(e){var t=e.getDate();return/^[1-9]$/.test(t)?n(e,"dd"):n(e,"d")}},{key:"dd",regex:"[0-2][0-9]{1}|3[0-1]{1}",apply:function(e){this.date=+e},formatter:function(e){return n(e,"dd")}},{key:"d",regex:"[1-2]?[0-9]{1}|3[0-1]{1}",apply:function(e){this.date=+e},formatter:function(e){return n(e,"d")}},{key:"EEEE",regex:t.DATETIME_FORMATS.DAY.join("|"),formatter:function(e){return n(e,"EEEE")}},{key:"EEE",regex:t.DATETIME_FORMATS.SHORTDAY.join("|"),formatter:function(e){return n(e,"EEE")}},{key:"HH",regex:"(?:0|1)[0-9]|2[0-3]",apply:function(e){this.hours=+e},formatter:function(e){return n(e,"HH")}},{key:"hh",regex:"0[0-9]|1[0-2]",apply:function(e){this.hours=+e},formatter:function(e){return n(e,"hh")}},{key:"H",regex:"1?[0-9]|2[0-3]",apply:function(e){this.hours=+e},formatter:function(e){return n(e,"H")}},{key:"h",regex:"[0-9]|1[0-2]",apply:function(e){this.hours=+e},formatter:function(e){return n(e,"h")}},{key:"mm",regex:"[0-5][0-9]",apply:function(e){this.minutes=+e},formatter:function(e){return n(e,"mm")}},{key:"m",regex:"[0-9]|[1-5][0-9]",apply:function(e){this.minutes=+e},formatter:function(e){return n(e,"m")}},{key:"sss",regex:"[0-9][0-9][0-9]",apply:function(e){this.milliseconds=+e},formatter:function(e){return n(e,"sss")}},{key:"ss",regex:"[0-5][0-9]",apply:function(e){this.seconds=+e},formatter:function(e){return n(e,"ss")}},{key:"s",regex:"[0-9]|[1-5][0-9]",apply:function(e){this.seconds=+e},formatter:function(e){return n(e,"s")}},{key:"a",regex:t.DATETIME_FORMATS.AMPMS.join("|"),apply:function(e){12===this.hours&&(this.hours=0),"PM"===e&&(this.hours+=12)},formatter:function(e){return n(e,"a")}},{key:"Z",regex:"[+-]\\d{4}",apply:function(e){var t=e.match(/([+-])(\d{2})(\d{2})/),n=t[1],a=t[2],i=t[3];this.hours+=u(n+a),this.minutes+=u(n+i)},formatter:function(e){return n(e,"Z")}},{key:"ww",regex:"[0-4][0-9]|5[0-3]",formatter:function(e){return n(e,"ww")}},{key:"w",regex:"[0-9]|[1-4][0-9]|5[0-3]",formatter:function(e){return n(e,"w")}},{key:"GGGG",regex:t.DATETIME_FORMATS.ERANAMES.join("|").replace(/\s/g,"\\s"),formatter:function(e){return n(e,"GGGG")}},{key:"GGG",regex:t.DATETIME_FORMATS.ERAS.join("|"),formatter:function(e){return n(e,"GGG")}},{key:"GG",regex:t.DATETIME_FORMATS.ERAS.join("|"),formatter:function(e){return n(e,"GG")}},{key:"G",regex:t.DATETIME_FORMATS.ERAS.join("|"),formatter:function(e){return n(e,"G")}}]},this.init(),this.filter=function(e,n){if(!angular.isDate(e)||isNaN(e)||!n)return"";n=t.DATETIME_FORMATS[n]||n,t.id!==m&&this.init(),this.formatters[n]||(this.formatters[n]=r(n));var a=this.formatters[n];return a.reduce(function(t,n){return t+n(e)},"")},this.parse=function(n,a,r){if(!angular.isString(n)||!a)return n;a=t.DATETIME_FORMATS[a]||a,a=a.replace(b,"\\$&"),t.id!==m&&this.init(),this.parsers[a]||(this.parsers[a]=i(a,"apply"));var o=this.parsers[a],s=o.regex,u=o.map,c=n.match(s),d=!1;if(c&&c.length){var p,h;angular.isDate(r)&&!isNaN(r.getTime())?p={year:r.getFullYear(),month:r.getMonth(),date:r.getDate(),hours:r.getHours(),minutes:r.getMinutes(),seconds:r.getSeconds(),milliseconds:r.getMilliseconds()}:(r&&e.warn("dateparser:","baseDate is not a valid date"),p={year:1900,month:0,date:1,hours:0,minutes:0,seconds:0,milliseconds:0});for(var f=1,g=c.length;g>f;f++){var v=u[f-1];"Z"===v.matcher&&(d=!0),v.apply&&v.apply.call(p,c[f])}var y=d?Date.prototype.setUTCFullYear:Date.prototype.setFullYear,w=d?Date.prototype.setUTCHours:Date.prototype.setHours;return l(p.year,p.month,p.date)&&(!angular.isDate(r)||isNaN(r.getTime())||d?(h=new Date(0),y.call(h,p.year,p.month,p.date),w.call(h,p.hours||0,p.minutes||0,p.seconds||0,p.milliseconds||0)):(h=new Date(r),y.call(h,p.year,p.month,p.date),w.call(h,p.hours,p.minutes,p.seconds,p.milliseconds))),h}},this.toTimezone=c,this.fromTimezone=d,this.timezoneToOffset=p,this.addDateMinutes=h,this.convertTimezoneToLocal=f}]),angular.module("ui.bootstrap.isClass",[]).directive("uibIsClass",["$animate",function(e){var t=/^\s*([\s\S]+?)\s+on\s+([\s\S]+?)\s*$/,n=/^\s*([\s\S]+?)\s+for\s+([\s\S]+?)\s*$/;return{restrict:"A",compile:function(a,i){function r(e,t){l.push(e),u.push({scope:e,element:t}),f.forEach(function(t){o(t,e)}),e.$on("$destroy",s)}function o(t,a){var i=t.match(n),r=a.$eval(i[1]),o=i[2],s=c[t];if(!s){var l=function(t){var n=null;u.some(function(e){var a=e.scope.$eval(p);return a===t?(n=e,!0):void 0}),s.lastActivated!==n&&(s.lastActivated&&e.removeClass(s.lastActivated.element,r),n&&e.addClass(n.element,r),s.lastActivated=n)};c[t]=s={lastActivated:null,scope:a,watchFn:l,compareWithExp:o,watcher:a.$watch(o,l)}}s.watchFn(a.$eval(o))}function s(e){var t=e.targetScope,n=l.indexOf(t);if(l.splice(n,1),u.splice(n,1),l.length){var a=l[0];angular.forEach(c,function(e){e.scope===t&&(e.watcher=a.$watch(e.compareWithExp,e.watchFn),e.scope=a)})}else c={}}var l=[],u=[],c={},d=i.uibIsClass.match(t),p=d[2],h=d[1],f=h.split(",");return r}}}]),angular.module("ui.bootstrap.position",[]).factory("$uibPosition",["$document","$window",function(e,t){var n,a,i={normal:/(auto|scroll)/,hidden:/(auto|scroll|hidden)/},r={auto:/\s?auto?\s?/i,primary:/^(top|bottom|left|right)$/,secondary:/^(top|bottom|left|right|center)$/,vertical:/^(top|bottom)$/},o=/(HTML|BODY)/;return{getRawNode:function(e){return e.nodeName?e:e[0]||e},parseStyle:function(e){return e=parseFloat(e),isFinite(e)?e:0},offsetParent:function(n){function a(e){return"static"===(t.getComputedStyle(e).position||"static")}n=this.getRawNode(n);for(var i=n.offsetParent||e[0].documentElement;i&&i!==e[0].documentElement&&a(i);)i=i.offsetParent;return i||e[0].documentElement},scrollbarWidth:function(i){if(i){if(angular.isUndefined(a)){var r=e.find("body");r.addClass("uib-position-body-scrollbar-measure"),a=t.innerWidth-r[0].clientWidth,a=isFinite(a)?a:0,r.removeClass("uib-position-body-scrollbar-measure")}return a}if(angular.isUndefined(n)){var o=angular.element('<div class="uib-position-scrollbar-measure"></div>');e.find("body").append(o),n=o[0].offsetWidth-o[0].clientWidth,n=isFinite(n)?n:0,o.remove()}return n},scrollbarPadding:function(e){e=this.getRawNode(e);var n=t.getComputedStyle(e),a=this.parseStyle(n.paddingRight),i=this.parseStyle(n.paddingBottom),r=this.scrollParent(e,!1,!0),s=this.scrollbarWidth(r,o.test(r.tagName));return{scrollbarWidth:s,widthOverflow:r.scrollWidth>r.clientWidth,right:a+s,originalRight:a,heightOverflow:r.scrollHeight>r.clientHeight,bottom:i+s,originalBottom:i}},isScrollable:function(e,n){e=this.getRawNode(e);var a=n?i.hidden:i.normal,r=t.getComputedStyle(e);return a.test(r.overflow+r.overflowY+r.overflowX)},scrollParent:function(n,a,r){n=this.getRawNode(n);var o=a?i.hidden:i.normal,s=e[0].documentElement,l=t.getComputedStyle(n);if(r&&o.test(l.overflow+l.overflowY+l.overflowX))return n;var u="absolute"===l.position,c=n.parentElement||s;if(c===s||"fixed"===l.position)return s;for(;c.parentElement&&c!==s;){var d=t.getComputedStyle(c);if(u&&"static"!==d.position&&(u=!1),!u&&o.test(d.overflow+d.overflowY+d.overflowX))break;c=c.parentElement}return c},position:function(n,a){n=this.getRawNode(n);var i=this.offset(n);if(a){var r=t.getComputedStyle(n);i.top-=this.parseStyle(r.marginTop),i.left-=this.parseStyle(r.marginLeft)}var o=this.offsetParent(n),s={top:0,left:0};return o!==e[0].documentElement&&(s=this.offset(o),s.top+=o.clientTop-o.scrollTop,s.left+=o.clientLeft-o.scrollLeft),{width:Math.round(angular.isNumber(i.width)?i.width:n.offsetWidth),height:Math.round(angular.isNumber(i.height)?i.height:n.offsetHeight),top:Math.round(i.top-s.top),left:Math.round(i.left-s.left)}},offset:function(n){n=this.getRawNode(n);var a=n.getBoundingClientRect();return{width:Math.round(angular.isNumber(a.width)?a.width:n.offsetWidth),height:Math.round(angular.isNumber(a.height)?a.height:n.offsetHeight),top:Math.round(a.top+(t.pageYOffset||e[0].documentElement.scrollTop)),left:Math.round(a.left+(t.pageXOffset||e[0].documentElement.scrollLeft))}},viewportOffset:function(n,a,i){n=this.getRawNode(n),i=i!==!1?!0:!1;var r=n.getBoundingClientRect(),o={top:0,left:0,bottom:0,right:0},s=a?e[0].documentElement:this.scrollParent(n),l=s.getBoundingClientRect();if(o.top=l.top+s.clientTop,o.left=l.left+s.clientLeft,s===e[0].documentElement&&(o.top+=t.pageYOffset,o.left+=t.pageXOffset),o.bottom=o.top+s.clientHeight,o.right=o.left+s.clientWidth,i){var u=t.getComputedStyle(s);o.top+=this.parseStyle(u.paddingTop),o.bottom-=this.parseStyle(u.paddingBottom),o.left+=this.parseStyle(u.paddingLeft),o.right-=this.parseStyle(u.paddingRight)}return{top:Math.round(r.top-o.top),bottom:Math.round(o.bottom-r.bottom),left:Math.round(r.left-o.left),right:Math.round(o.right-r.right)}},parsePlacement:function(e){var t=r.auto.test(e);return t&&(e=e.replace(r.auto,"")),e=e.split("-"),e[0]=e[0]||"top",r.primary.test(e[0])||(e[0]="top"),e[1]=e[1]||"center",r.secondary.test(e[1])||(e[1]="center"),e[2]=t?!0:!1,e},positionElements:function(e,n,a,i){e=this.getRawNode(e),n=this.getRawNode(n);var o=angular.isDefined(n.offsetWidth)?n.offsetWidth:n.prop("offsetWidth"),s=angular.isDefined(n.offsetHeight)?n.offsetHeight:n.prop("offsetHeight");a=this.parsePlacement(a);var l=i?this.offset(e):this.position(e),u={top:0,left:0,placement:""};if(a[2]){var c=this.viewportOffset(e,i),d=t.getComputedStyle(n),p={width:o+Math.round(Math.abs(this.parseStyle(d.marginLeft)+this.parseStyle(d.marginRight))),height:s+Math.round(Math.abs(this.parseStyle(d.marginTop)+this.parseStyle(d.marginBottom)))};if(a[0]="top"===a[0]&&p.height>c.top&&p.height<=c.bottom?"bottom":"bottom"===a[0]&&p.height>c.bottom&&p.height<=c.top?"top":"left"===a[0]&&p.width>c.left&&p.width<=c.right?"right":"right"===a[0]&&p.width>c.right&&p.width<=c.left?"left":a[0],a[1]="top"===a[1]&&p.height-l.height>c.bottom&&p.height-l.height<=c.top?"bottom":"bottom"===a[1]&&p.height-l.height>c.top&&p.height-l.height<=c.bottom?"top":"left"===a[1]&&p.width-l.width>c.right&&p.width-l.width<=c.left?"right":"right"===a[1]&&p.width-l.width>c.left&&p.width-l.width<=c.right?"left":a[1],"center"===a[1])if(r.vertical.test(a[0])){var h=l.width/2-o/2;
c.left+h<0&&p.width-l.width<=c.right?a[1]="left":c.right+h<0&&p.width-l.width<=c.left&&(a[1]="right")}else{var f=l.height/2-p.height/2;c.top+f<0&&p.height-l.height<=c.bottom?a[1]="top":c.bottom+f<0&&p.height-l.height<=c.top&&(a[1]="bottom")}}switch(a[0]){case"top":u.top=l.top-s;break;case"bottom":u.top=l.top+l.height;break;case"left":u.left=l.left-o;break;case"right":u.left=l.left+l.width}switch(a[1]){case"top":u.top=l.top;break;case"bottom":u.top=l.top+l.height-s;break;case"left":u.left=l.left;break;case"right":u.left=l.left+l.width-o;break;case"center":r.vertical.test(a[0])?u.left=l.left+l.width/2-o/2:u.top=l.top+l.height/2-s/2}return u.top=Math.round(u.top),u.left=Math.round(u.left),u.placement="center"===a[1]?a[0]:a[0]+"-"+a[1],u},adjustTop:function(e,t,n,a){return-1!==e.indexOf("top")&&n!==a?{top:t.top-a+"px"}:void 0},positionArrow:function(e,n){e=this.getRawNode(e);var a=e.querySelector(".tooltip-inner, .popover-inner");if(a){var i=angular.element(a).hasClass("tooltip-inner"),o=e.querySelector(i?".tooltip-arrow":".arrow");if(o){var s={top:"",bottom:"",left:"",right:""};if(n=this.parsePlacement(n),"center"===n[1])return void angular.element(o).css(s);var l="border-"+n[0]+"-width",u=t.getComputedStyle(o)[l],c="border-";c+=r.vertical.test(n[0])?n[0]+"-"+n[1]:n[1]+"-"+n[0],c+="-radius";var d=t.getComputedStyle(i?a:e)[c];switch(n[0]){case"top":s.bottom=i?"0":"-"+u;break;case"bottom":s.top=i?"0":"-"+u;break;case"left":s.right=i?"0":"-"+u;break;case"right":s.left=i?"0":"-"+u}s[n[1]]=d,angular.element(o).css(s)}}}}}]),angular.module("ui.bootstrap.timepicker",[]).constant("uibTimepickerConfig",{hourStep:1,minuteStep:1,secondStep:1,showMeridian:!0,showSeconds:!1,meridians:null,readonlyInput:!1,mousewheel:!0,arrowkeys:!0,showSpinners:!0,templateUrl:"uib/template/timepicker/timepicker.html"}).controller("UibTimepickerController",["$scope","$element","$attrs","$parse","$log","$locale","uibTimepickerConfig",function(e,t,n,a,i,r,o){function s(){var t=+e.hours,n=e.showMeridian?t>0&&13>t:t>=0&&24>t;return n&&""!==e.hours?(e.showMeridian&&(12===t&&(t=0),e.meridian===$[1]&&(t+=12)),t):void 0}function l(){var t=+e.minutes,n=t>=0&&60>t;return n&&""!==e.minutes?t:void 0}function u(){var t=+e.seconds;return t>=0&&60>t?t:void 0}function c(e,t){return null===e?"":angular.isDefined(e)&&e.toString().length<2&&!t?"0"+e:e.toString()}function d(e){p(),w.$setViewValue(new Date(v)),h(e)}function p(){w.$setValidity("time",!0),e.invalidHours=!1,e.invalidMinutes=!1,e.invalidSeconds=!1}function h(t){if(w.$modelValue){var n=v.getHours(),a=v.getMinutes(),i=v.getSeconds();e.showMeridian&&(n=0===n||12===n?12:n%12),e.hours="h"===t?n:c(n,!k),"m"!==t&&(e.minutes=c(a)),e.meridian=v.getHours()<12?$[0]:$[1],"s"!==t&&(e.seconds=c(i)),e.meridian=v.getHours()<12?$[0]:$[1]}else e.hours=null,e.minutes=null,e.seconds=null,e.meridian=$[0]}function f(e){v=g(v,e),d()}function m(e,t){return g(e,60*t)}function g(e,t){var n=new Date(e.getTime()+1e3*t),a=new Date(e);return a.setHours(n.getHours(),n.getMinutes(),n.getSeconds()),a}function b(){return!(null!==e.hours&&""!==e.hours||null!==e.minutes&&""!==e.minutes||e.showSeconds&&(!e.showSeconds||null!==e.seconds&&""!==e.seconds))}var v=new Date,y=[],w={$setViewValue:angular.noop},$=angular.isDefined(n.meridians)?e.$parent.$eval(n.meridians):o.meridians||r.DATETIME_FORMATS.AMPMS,k=angular.isDefined(n.padHours)?e.$parent.$eval(n.padHours):!0;e.tabindex=angular.isDefined(n.tabindex)?n.tabindex:0,t.removeAttr("tabindex"),this.init=function(t,a){w=t,w.$render=this.render,w.$formatters.unshift(function(e){return e?new Date(e):null});var i=a.eq(0),r=a.eq(1),s=a.eq(2),l=angular.isDefined(n.mousewheel)?e.$parent.$eval(n.mousewheel):o.mousewheel;l&&this.setupMousewheelEvents(i,r,s);var u=angular.isDefined(n.arrowkeys)?e.$parent.$eval(n.arrowkeys):o.arrowkeys;u&&this.setupArrowkeyEvents(i,r,s),e.readonlyInput=angular.isDefined(n.readonlyInput)?e.$parent.$eval(n.readonlyInput):o.readonlyInput,this.setupInputEvents(i,r,s)};var D=o.hourStep;n.hourStep&&y.push(e.$parent.$watch(a(n.hourStep),function(e){D=+e}));var M=o.minuteStep;n.minuteStep&&y.push(e.$parent.$watch(a(n.minuteStep),function(e){M=+e}));var x;y.push(e.$parent.$watch(a(n.min),function(e){var t=new Date(e);x=isNaN(t)?void 0:t}));var T;y.push(e.$parent.$watch(a(n.max),function(e){var t=new Date(e);T=isNaN(t)?void 0:t}));var S=!1;n.ngDisabled&&y.push(e.$parent.$watch(a(n.ngDisabled),function(e){S=e})),e.noIncrementHours=function(){var e=m(v,60*D);return S||e>T||v>e&&x>e},e.noDecrementHours=function(){var e=m(v,60*-D);return S||x>e||e>v&&e>T},e.noIncrementMinutes=function(){var e=m(v,M);return S||e>T||v>e&&x>e},e.noDecrementMinutes=function(){var e=m(v,-M);return S||x>e||e>v&&e>T},e.noIncrementSeconds=function(){var e=g(v,O);return S||e>T||v>e&&x>e},e.noDecrementSeconds=function(){var e=g(v,-O);return S||x>e||e>v&&e>T},e.noToggleMeridian=function(){return v.getHours()<12?S||m(v,720)>T:S||m(v,-720)<x};var O=o.secondStep;n.secondStep&&y.push(e.$parent.$watch(a(n.secondStep),function(e){O=+e})),e.showSeconds=o.showSeconds,n.showSeconds&&y.push(e.$parent.$watch(a(n.showSeconds),function(t){e.showSeconds=!!t})),e.showMeridian=o.showMeridian,n.showMeridian&&y.push(e.$parent.$watch(a(n.showMeridian),function(t){if(e.showMeridian=!!t,w.$error.time){var n=s(),a=l();angular.isDefined(n)&&angular.isDefined(a)&&(v.setHours(n),d())}else h()})),this.setupMousewheelEvents=function(t,n,a){var i=function(e){e.originalEvent&&(e=e.originalEvent);var t=e.wheelDelta?e.wheelDelta:-e.deltaY;return e.detail||t>0};t.bind("mousewheel wheel",function(t){S||e.$apply(i(t)?e.incrementHours():e.decrementHours()),t.preventDefault()}),n.bind("mousewheel wheel",function(t){S||e.$apply(i(t)?e.incrementMinutes():e.decrementMinutes()),t.preventDefault()}),a.bind("mousewheel wheel",function(t){S||e.$apply(i(t)?e.incrementSeconds():e.decrementSeconds()),t.preventDefault()})},this.setupArrowkeyEvents=function(t,n,a){t.bind("keydown",function(t){S||(38===t.which?(t.preventDefault(),e.incrementHours(),e.$apply()):40===t.which&&(t.preventDefault(),e.decrementHours(),e.$apply()))}),n.bind("keydown",function(t){S||(38===t.which?(t.preventDefault(),e.incrementMinutes(),e.$apply()):40===t.which&&(t.preventDefault(),e.decrementMinutes(),e.$apply()))}),a.bind("keydown",function(t){S||(38===t.which?(t.preventDefault(),e.incrementSeconds(),e.$apply()):40===t.which&&(t.preventDefault(),e.decrementSeconds(),e.$apply()))})},this.setupInputEvents=function(t,n,a){if(e.readonlyInput)return e.updateHours=angular.noop,e.updateMinutes=angular.noop,void(e.updateSeconds=angular.noop);var i=function(t,n,a){w.$setViewValue(null),w.$setValidity("time",!1),angular.isDefined(t)&&(e.invalidHours=t),angular.isDefined(n)&&(e.invalidMinutes=n),angular.isDefined(a)&&(e.invalidSeconds=a)};e.updateHours=function(){var e=s(),t=l();w.$setDirty(),angular.isDefined(e)&&angular.isDefined(t)?(v.setHours(e),v.setMinutes(t),x>v||v>T?i(!0):d("h")):i(!0)},t.bind("blur",function(){w.$setTouched(),b()?p():null===e.hours||""===e.hours?i(!0):!e.invalidHours&&e.hours<10&&e.$apply(function(){e.hours=c(e.hours,!k)})}),e.updateMinutes=function(){var e=l(),t=s();w.$setDirty(),angular.isDefined(e)&&angular.isDefined(t)?(v.setHours(t),v.setMinutes(e),x>v||v>T?i(void 0,!0):d("m")):i(void 0,!0)},n.bind("blur",function(){w.$setTouched(),b()?p():null===e.minutes?i(void 0,!0):!e.invalidMinutes&&e.minutes<10&&e.$apply(function(){e.minutes=c(e.minutes)})}),e.updateSeconds=function(){var e=u();w.$setDirty(),angular.isDefined(e)?(v.setSeconds(e),d("s")):i(void 0,void 0,!0)},a.bind("blur",function(){b()?p():!e.invalidSeconds&&e.seconds<10&&e.$apply(function(){e.seconds=c(e.seconds)})})},this.render=function(){var t=w.$viewValue;isNaN(t)?(w.$setValidity("time",!1),i.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.')):(t&&(v=t),x>v||v>T?(w.$setValidity("time",!1),e.invalidHours=!0,e.invalidMinutes=!0):p(),h())},e.showSpinners=angular.isDefined(n.showSpinners)?e.$parent.$eval(n.showSpinners):o.showSpinners,e.incrementHours=function(){e.noIncrementHours()||f(60*D*60)},e.decrementHours=function(){e.noDecrementHours()||f(60*-D*60)},e.incrementMinutes=function(){e.noIncrementMinutes()||f(60*M)},e.decrementMinutes=function(){e.noDecrementMinutes()||f(60*-M)},e.incrementSeconds=function(){e.noIncrementSeconds()||f(O)},e.decrementSeconds=function(){e.noDecrementSeconds()||f(-O)},e.toggleMeridian=function(){var t=l(),n=s();e.noToggleMeridian()||(angular.isDefined(t)&&angular.isDefined(n)?f(720*(v.getHours()<12?60:-60)):e.meridian=e.meridian===$[0]?$[1]:$[0])},e.blur=function(){w.$setTouched()},e.$on("$destroy",function(){for(;y.length;)y.shift()()})}]).directive("uibTimepicker",["uibTimepickerConfig",function(e){return{require:["uibTimepicker","?^ngModel"],restrict:"A",controller:"UibTimepickerController",controllerAs:"timepicker",scope:{},templateUrl:function(t,n){return n.templateUrl||e.templateUrl},link:function(e,t,n,a){var i=a[0],r=a[1];r&&i.init(r,t.find("input"))}}}]),angular.module("ui.bootstrap.modal",["ui.bootstrap.stackedMap","ui.bootstrap.position"]).factory("$$multiMap",function(){return{createNew:function(){var e={};return{entries:function(){return Object.keys(e).map(function(t){return{key:t,value:e[t]}})},get:function(t){return e[t]},hasKey:function(t){return!!e[t]},keys:function(){return Object.keys(e)},put:function(t,n){e[t]||(e[t]=[]),e[t].push(n)},remove:function(t,n){var a=e[t];if(a){var i=a.indexOf(n);-1!==i&&a.splice(i,1),a.length||delete e[t]}}}}}}).provider("$uibResolve",function(){var e=this;this.resolver=null,this.setResolver=function(e){this.resolver=e},this.$get=["$injector","$q",function(t,n){var a=e.resolver?t.get(e.resolver):null;return{resolve:function(e,i,r,o){if(a)return a.resolve(e,i,r,o);var s=[];return angular.forEach(e,function(e){s.push(angular.isFunction(e)||angular.isArray(e)?n.resolve(t.invoke(e)):angular.isString(e)?n.resolve(t.get(e)):n.resolve(e))}),n.all(s).then(function(t){var n={},a=0;return angular.forEach(e,function(e,i){n[i]=t[a++]}),n})}}}]}).directive("uibModalBackdrop",["$animate","$injector","$uibModalStack",function(e,t,n){function a(t,a,i){i.modalInClass&&(e.addClass(a,i.modalInClass),t.$on(n.NOW_CLOSING_EVENT,function(n,r){var o=r();t.modalOptions.animation?e.removeClass(a,i.modalInClass).then(o):o()}))}return{restrict:"A",compile:function(e,t){return e.addClass(t.backdropClass),a}}}]).directive("uibModalWindow",["$uibModalStack","$q","$animateCss","$document",function(e,t,n,a){return{scope:{index:"@"},restrict:"A",transclude:!0,templateUrl:function(e,t){return t.templateUrl||"uib/template/modal/window.html"},link:function(i,r,o){r.addClass(o.windowTopClass||""),i.size=o.size,i.close=function(t){var n=e.getTop();n&&n.value.backdrop&&"static"!==n.value.backdrop&&t.target===t.currentTarget&&(t.preventDefault(),t.stopPropagation(),e.dismiss(n.key,"backdrop click"))},r.on("click",i.close),i.$isRendered=!0;var s=t.defer();i.$$postDigest(function(){s.resolve()}),s.promise.then(function(){var s=null;o.modalInClass&&(s=n(r,{addClass:o.modalInClass}).start(),i.$on(e.NOW_CLOSING_EVENT,function(e,t){var a=t();n(r,{removeClass:o.modalInClass}).start().then(a)})),t.when(s).then(function(){var t=e.getTop();if(t&&e.modalRendered(t.key),!a[0].activeElement||!r[0].contains(a[0].activeElement)){var n=r[0].querySelector("[autofocus]");n?n.focus():r[0].focus()}})})}}}]).directive("uibModalAnimationClass",function(){return{compile:function(e,t){t.modalAnimation&&e.addClass(t.uibModalAnimationClass)}}}).directive("uibModalTransclude",["$animate",function(e){return{link:function(t,n,a,i,r){r(t.$parent,function(t){n.empty(),e.enter(t,n)})}}}]).factory("$uibModalStack",["$animate","$animateCss","$document","$compile","$rootScope","$q","$$multiMap","$$stackedMap","$uibPosition",function(e,t,n,a,i,r,o,s,l){function u(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)}function c(){for(var e=-1,t=$.keys(),n=0;n<t.length;n++)$.get(t[n]).value.backdrop&&(e=n);return e>-1&&M>e&&(e=M),e}function d(e,t){var n=$.get(e).value,a=n.appendTo;$.remove(e),x=$.top(),x&&(M=parseInt(x.value.modalDomEl.attr("index"),10)),f(n.modalDomEl,n.modalScope,function(){var t=n.openedClass||w;k.remove(t,e);var i=k.hasKey(t);a.toggleClass(t,i),!i&&y&&y.heightOverflow&&y.scrollbarWidth&&(a.css(y.originalRight?{paddingRight:y.originalRight+"px"}:{paddingRight:""}),y=null),p(!0)},n.closedDeferred),h(),t&&t.focus?t.focus():a.focus&&a.focus()}function p(e){var t;$.length()>0&&(t=$.top().value,t.modalDomEl.toggleClass(t.windowTopClass||"",e))}function h(){if(b&&-1===c()){var e=v;f(b,v,function(){e=null}),b=void 0,v=void 0}}function f(t,n,a,i){function o(){o.done||(o.done=!0,e.leave(t).then(function(){a&&a(),t.remove(),i&&i.resolve()}),n.$destroy())}var s,l=null,u=function(){return s||(s=r.defer(),l=s.promise),function(){s.resolve()}};return n.$broadcast(D.NOW_CLOSING_EVENT,u),r.when(l).then(o)}function m(e){if(e.isDefaultPrevented())return e;var t=$.top();if(t)switch(e.which){case 27:t.value.keyboard&&(e.preventDefault(),i.$apply(function(){D.dismiss(t.key,"escape key press")}));break;case 9:var n=D.loadFocusElementList(t),a=!1;e.shiftKey?(D.isFocusInFirstItem(e,n)||D.isModalFocused(e,t))&&(a=D.focusLastFocusableElement(n)):D.isFocusInLastItem(e,n)&&(a=D.focusFirstFocusableElement(n)),a&&(e.preventDefault(),e.stopPropagation())}}function g(e,t,n){return!e.value.modalScope.$broadcast("modal.closing",t,n).defaultPrevented}var b,v,y,w="modal-open",$=s.createNew(),k=o.createNew(),D={NOW_CLOSING_EVENT:"modal.stack.now-closing"},M=0,x=null,T="a[href], area[href], input:not([disabled]):not([tabindex='-1']), button:not([disabled]):not([tabindex='-1']),select:not([disabled]):not([tabindex='-1']), textarea:not([disabled]):not([tabindex='-1']), iframe, object, embed, *[tabindex]:not([tabindex='-1']), *[contenteditable=true]";return i.$watch(c,function(e){v&&(v.index=e)}),n.on("keydown",m),i.$on("$destroy",function(){n.off("keydown",m)}),D.open=function(t,r){var o=n[0].activeElement,s=r.openedClass||w;p(!1),x=$.top(),$.add(t,{deferred:r.deferred,renderDeferred:r.renderDeferred,closedDeferred:r.closedDeferred,modalScope:r.scope,backdrop:r.backdrop,keyboard:r.keyboard,openedClass:r.openedClass,windowTopClass:r.windowTopClass,animation:r.animation,appendTo:r.appendTo}),k.put(s,t);var u=r.appendTo,d=c();if(!u.length)throw new Error("appendTo element not found. Make sure that the element passed is in DOM.");d>=0&&!b&&(v=i.$new(!0),v.modalOptions=r,v.index=d,b=angular.element('<div uib-modal-backdrop="modal-backdrop"></div>'),b.attr({"class":"modal-backdrop","ng-style":"{'z-index': 1040 + (index && 1 || 0) + index*10}","uib-modal-animation-class":"fade","modal-in-class":"in"}),r.backdropClass&&b.addClass(r.backdropClass),r.animation&&b.attr("modal-animation","true"),a(b)(v),e.enter(b,u),l.isScrollable(u)&&(y=l.scrollbarPadding(u),y.heightOverflow&&y.scrollbarWidth&&u.css({paddingRight:y.right+"px"}))),M=x?parseInt(x.value.modalDomEl.attr("index"),10)+1:0;var h=angular.element('<div uib-modal-window="modal-window"></div>');h.attr({"class":"modal","template-url":r.windowTemplateUrl,"window-top-class":r.windowTopClass,role:"dialog",size:r.size,index:M,animate:"animate","ng-style":"{'z-index': 1050 + $$topModalIndex*10, display: 'block'}",tabindex:-1,"uib-modal-animation-class":"fade","modal-in-class":"in"}).html(r.content),r.windowClass&&h.addClass(r.windowClass),r.animation&&h.attr("modal-animation","true"),u.addClass(s),r.scope&&(r.scope.$$topModalIndex=M),e.enter(a(h)(r.scope),u),$.top().value.modalDomEl=h,$.top().value.modalOpener=o},D.close=function(e,t){var n=$.get(e);return n&&g(n,t,!0)?(n.value.modalScope.$$uibDestructionScheduled=!0,n.value.deferred.resolve(t),d(e,n.value.modalOpener),!0):!n},D.dismiss=function(e,t){var n=$.get(e);return n&&g(n,t,!1)?(n.value.modalScope.$$uibDestructionScheduled=!0,n.value.deferred.reject(t),d(e,n.value.modalOpener),!0):!n},D.dismissAll=function(e){for(var t=this.getTop();t&&this.dismiss(t.key,e);)t=this.getTop()},D.getTop=function(){return $.top()},D.modalRendered=function(e){var t=$.get(e);t&&t.value.renderDeferred.resolve()},D.focusFirstFocusableElement=function(e){return e.length>0?(e[0].focus(),!0):!1},D.focusLastFocusableElement=function(e){return e.length>0?(e[e.length-1].focus(),!0):!1},D.isModalFocused=function(e,t){if(e&&t){var n=t.value.modalDomEl;if(n&&n.length)return(e.target||e.srcElement)===n[0]}return!1},D.isFocusInFirstItem=function(e,t){return t.length>0?(e.target||e.srcElement)===t[0]:!1},D.isFocusInLastItem=function(e,t){return t.length>0?(e.target||e.srcElement)===t[t.length-1]:!1},D.loadFocusElementList=function(e){if(e){var t=e.value.modalDomEl;if(t&&t.length){var n=t[0].querySelectorAll(T);return n?Array.prototype.filter.call(n,function(e){return u(e)}):n}}},D}]).provider("$uibModal",function(){var e={options:{animation:!0,backdrop:!0,keyboard:!0},$get:["$rootScope","$q","$document","$templateRequest","$controller","$uibResolve","$uibModalStack",function(t,n,a,i,r,o,s){function l(e){return e.template?n.when(e.template):i(angular.isFunction(e.templateUrl)?e.templateUrl():e.templateUrl)}var u={},c=null;return u.getPromiseChain=function(){return c},u.open=function(i){function u(){return b}var d=n.defer(),p=n.defer(),h=n.defer(),f=n.defer(),m={result:d.promise,opened:p.promise,closed:h.promise,rendered:f.promise,close:function(e){return s.close(m,e)},dismiss:function(e){return s.dismiss(m,e)}};if(i=angular.extend({},e.options,i),i.resolve=i.resolve||{},i.appendTo=i.appendTo||a.find("body").eq(0),!i.template&&!i.templateUrl)throw new Error("One of template or templateUrl options is required.");var g,b=n.all([l(i),o.resolve(i.resolve,{},null,null)]);return g=c=n.all([c]).then(u,u).then(function(e){var n=i.scope||t,a=n.$new();a.$close=m.close,a.$dismiss=m.dismiss,a.$on("$destroy",function(){a.$$uibDestructionScheduled||a.$dismiss("$uibUnscheduledDestruction")});var o,l,u={};i.controller&&(u.$scope=a,u.$scope.$resolve={},u.$uibModalInstance=m,angular.forEach(e[1],function(e,t){u[t]=e,u.$scope.$resolve[t]=e}),l=r(i.controller,u,!0,i.controllerAs),i.controllerAs&&i.bindToController&&(o=l.instance,o.$close=a.$close,o.$dismiss=a.$dismiss,angular.extend(o,{$resolve:u.$scope.$resolve},n)),o=l(),angular.isFunction(o.$onInit)&&o.$onInit()),s.open(m,{scope:a,deferred:d,renderDeferred:f,closedDeferred:h,content:e[0],animation:i.animation,backdrop:i.backdrop,keyboard:i.keyboard,backdropClass:i.backdropClass,windowTopClass:i.windowTopClass,windowClass:i.windowClass,windowTemplateUrl:i.windowTemplateUrl,size:i.size,openedClass:i.openedClass,appendTo:i.appendTo}),p.resolve(!0)},function(e){p.reject(e),d.reject(e)})["finally"](function(){c===g&&(c=null)}),m},u}]};return e}),angular.module("ui.bootstrap.stackedMap",[]).factory("$$stackedMap",function(){return{createNew:function(){var e=[];return{add:function(t,n){e.push({key:t,value:n})},get:function(t){for(var n=0;n<e.length;n++)if(t===e[n].key)return e[n]},keys:function(){for(var t=[],n=0;n<e.length;n++)t.push(e[n].key);return t},top:function(){return e[e.length-1]},remove:function(t){for(var n=-1,a=0;a<e.length;a++)if(t===e[a].key){n=a;break}return e.splice(n,1)[0]},removeTop:function(){return e.pop()},length:function(){return e.length}}}}}),angular.module("ui.bootstrap.typeahead",["ui.bootstrap.debounce","ui.bootstrap.position"]).factory("uibTypeaheadParser",["$parse",function(e){var t=/^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;return{parse:function(n){var a=n.match(t);if(!a)throw new Error('Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_" but got "'+n+'".');return{itemName:a[3],source:e(a[4]),viewMapper:e(a[2]||a[1]),modelMapper:e(a[1])}}}}]).controller("UibTypeaheadController",["$scope","$element","$attrs","$compile","$parse","$q","$timeout","$document","$window","$rootScope","$$debounce","$uibPosition","uibTypeaheadParser",function(e,t,n,a,i,r,o,s,l,u,c,d,p){function h(){Y.moveInProgress||(Y.moveInProgress=!0,Y.$digest()),Z()}function f(){Y.position=E?d.offset(t):d.position(t),Y.position.top+=t.prop("offsetHeight")}var m,g,b=[9,13,27,38,40],v=200,y=e.$eval(n.typeaheadMinLength);y||0===y||(y=1),e.$watch(n.typeaheadMinLength,function(e){y=e||0===e?e:1});var w=e.$eval(n.typeaheadWaitMs)||0,$=e.$eval(n.typeaheadEditable)!==!1;e.$watch(n.typeaheadEditable,function(e){$=e!==!1});var k,D,M=i(n.typeaheadLoading).assign||angular.noop,x=n.typeaheadShouldSelect?i(n.typeaheadShouldSelect):function(e,t){var n=t.$event;return 13===n.which||9===n.which},T=i(n.typeaheadOnSelect),S=angular.isDefined(n.typeaheadSelectOnBlur)?e.$eval(n.typeaheadSelectOnBlur):!1,O=i(n.typeaheadNoResults).assign||angular.noop,C=n.typeaheadInputFormatter?i(n.typeaheadInputFormatter):void 0,E=n.typeaheadAppendToBody?e.$eval(n.typeaheadAppendToBody):!1,I=n.typeaheadAppendTo?e.$eval(n.typeaheadAppendTo):null,F=e.$eval(n.typeaheadFocusFirst)!==!1,A=n.typeaheadSelectOnExact?e.$eval(n.typeaheadSelectOnExact):!1,N=i(n.typeaheadIsOpen).assign||angular.noop,P=e.$eval(n.typeaheadShowHint)||!1,U=i(n.ngModel),H=i(n.ngModel+"($$$p)"),R=function(t,n){return angular.isFunction(U(e))&&g&&g.$options&&g.$options.getterSetter?H(t,{$$$p:n}):U.assign(t,n)},V=p.parse(n.uibTypeahead),Y=e.$new(),z=e.$on("$destroy",function(){Y.$destroy()});Y.$on("$destroy",z);var q="typeahead-"+Y.$id+"-"+Math.floor(1e4*Math.random());t.attr({"aria-autocomplete":"list","aria-expanded":!1,"aria-owns":q});var W,j;P&&(W=angular.element("<div></div>"),W.css("position","relative"),t.after(W),j=t.clone(),j.attr("placeholder",""),j.attr("tabindex","-1"),j.val(""),j.css({position:"absolute",top:"0px",left:"0px","border-color":"transparent","box-shadow":"none",opacity:1,background:"none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)",color:"#999"}),t.css({position:"relative","vertical-align":"top","background-color":"transparent"}),j.attr("id")&&j.removeAttr("id"),W.append(j),j.after(t));var _=angular.element("<div uib-typeahead-popup></div>");_.attr({id:q,matches:"matches",active:"activeIdx",select:"select(activeIdx, evt)","move-in-progress":"moveInProgress",query:"query",position:"position","assign-is-open":"assignIsOpen(isOpen)",debounce:"debounceUpdate"}),angular.isDefined(n.typeaheadTemplateUrl)&&_.attr("template-url",n.typeaheadTemplateUrl),angular.isDefined(n.typeaheadPopupTemplateUrl)&&_.attr("popup-template-url",n.typeaheadPopupTemplateUrl);var L=function(){P&&j.val("")},B=function(){Y.matches=[],Y.activeIdx=-1,t.attr("aria-expanded",!1),L()},G=function(e){return q+"-option-"+e};Y.$watch("activeIdx",function(e){0>e?t.removeAttr("aria-activedescendant"):t.attr("aria-activedescendant",G(e))});var K=function(e,t){return Y.matches.length>t&&e?e.toUpperCase()===Y.matches[t].label.toUpperCase():!1},X=function(n,a){var i={$viewValue:n};M(e,!0),O(e,!1),r.when(V.source(e,i)).then(function(r){var o=n===m.$viewValue;if(o&&k)if(r&&r.length>0){Y.activeIdx=F?0:-1,O(e,!1),Y.matches.length=0;for(var s=0;s<r.length;s++)i[V.itemName]=r[s],Y.matches.push({id:G(s),label:V.viewMapper(Y,i),model:r[s]});if(Y.query=n,f(),t.attr("aria-expanded",!0),A&&1===Y.matches.length&&K(n,0)&&(angular.isNumber(Y.debounceUpdate)||angular.isObject(Y.debounceUpdate)?c(function(){Y.select(0,a)},angular.isNumber(Y.debounceUpdate)?Y.debounceUpdate:Y.debounceUpdate["default"]):Y.select(0,a)),P){var l=Y.matches[0].label;j.val(angular.isString(n)&&n.length>0&&l.slice(0,n.length).toUpperCase()===n.toUpperCase()?n+l.slice(n.length):"")}}else B(),O(e,!0);o&&M(e,!1)},function(){B(),M(e,!1),O(e,!0)})};E&&(angular.element(l).on("resize",h),s.find("body").on("scroll",h));var Z=c(function(){Y.matches.length&&f(),Y.moveInProgress=!1},v);Y.moveInProgress=!1,Y.query=void 0;var J,Q=function(e){J=o(function(){X(e)},w)},et=function(){J&&o.cancel(J)};B(),Y.assignIsOpen=function(t){N(e,t)},Y.select=function(a,i){var r,s,l={};D=!0,l[V.itemName]=s=Y.matches[a].model,r=V.modelMapper(e,l),R(e,r),m.$setValidity("editable",!0),m.$setValidity("parse",!0),T(e,{$item:s,$model:r,$label:V.viewMapper(e,l),$event:i}),B(),Y.$eval(n.typeaheadFocusOnSelect)!==!1&&o(function(){t[0].focus()},0,!1)},t.on("keydown",function(t){if(0!==Y.matches.length&&-1!==b.indexOf(t.which)){var n=x(e,{$event:t});if(-1===Y.activeIdx&&n||9===t.which&&t.shiftKey)return B(),void Y.$digest();t.preventDefault();var a;switch(t.which){case 27:t.stopPropagation(),B(),e.$digest();break;case 38:Y.activeIdx=(Y.activeIdx>0?Y.activeIdx:Y.matches.length)-1,Y.$digest(),a=_[0].querySelectorAll(".uib-typeahead-match")[Y.activeIdx],a.parentNode.scrollTop=a.offsetTop;break;case 40:Y.activeIdx=(Y.activeIdx+1)%Y.matches.length,Y.$digest(),a=_[0].querySelectorAll(".uib-typeahead-match")[Y.activeIdx],a.parentNode.scrollTop=a.offsetTop;break;default:n&&Y.$apply(function(){angular.isNumber(Y.debounceUpdate)||angular.isObject(Y.debounceUpdate)?c(function(){Y.select(Y.activeIdx,t)},angular.isNumber(Y.debounceUpdate)?Y.debounceUpdate:Y.debounceUpdate["default"]):Y.select(Y.activeIdx,t)})}}}),t.bind("focus",function(e){k=!0,0!==y||m.$viewValue||o(function(){X(m.$viewValue,e)},0)}),t.bind("blur",function(e){S&&Y.matches.length&&-1!==Y.activeIdx&&!D&&(D=!0,Y.$apply(function(){angular.isObject(Y.debounceUpdate)&&angular.isNumber(Y.debounceUpdate.blur)?c(function(){Y.select(Y.activeIdx,e)},Y.debounceUpdate.blur):Y.select(Y.activeIdx,e)})),!$&&m.$error.editable&&(m.$setViewValue(),Y.$apply(function(){m.$setValidity("editable",!0),m.$setValidity("parse",!0)}),t.val("")),k=!1,D=!1});var tt=function(n){t[0]!==n.target&&3!==n.which&&0!==Y.matches.length&&(B(),u.$$phase||e.$digest())};s.on("click",tt),e.$on("$destroy",function(){s.off("click",tt),(E||I)&&nt.remove(),E&&(angular.element(l).off("resize",h),s.find("body").off("scroll",h)),_.remove(),P&&W.remove()});var nt=a(_)(Y);E?s.find("body").append(nt):I?angular.element(I).eq(0).append(nt):t.after(nt),this.init=function(t,n){m=t,g=n,Y.debounceUpdate=m.$options&&i(m.$options.debounce)(e),m.$parsers.unshift(function(t){return k=!0,0===y||t&&t.length>=y?w>0?(et(),Q(t)):X(t):(M(e,!1),et(),B()),$?t:t?void m.$setValidity("editable",!1):(m.$setValidity("editable",!0),null)}),m.$formatters.push(function(t){var n,a,i={};return $||m.$setValidity("editable",!0),C?(i.$model=t,C(e,i)):(i[V.itemName]=t,n=V.viewMapper(e,i),i[V.itemName]=void 0,a=V.viewMapper(e,i),n!==a?n:t)})}}]).directive("uibTypeahead",function(){return{controller:"UibTypeaheadController",require:["ngModel","^?ngModelOptions","uibTypeahead"],link:function(e,t,n,a){a[2].init(a[0],a[1])}}}).directive("uibTypeaheadPopup",["$$debounce",function(e){return{scope:{matches:"=",query:"=",active:"=",position:"&",moveInProgress:"=",select:"&",assignIsOpen:"&",debounce:"&"},replace:!0,templateUrl:function(e,t){return t.popupTemplateUrl||"uib/template/typeahead/typeahead-popup.html"},link:function(t,n,a){t.templateUrl=a.templateUrl,t.isOpen=function(){var e=t.matches.length>0;return t.assignIsOpen({isOpen:e}),e},t.isActive=function(e){return t.active===e},t.selectActive=function(e){t.active=e},t.selectMatch=function(n,a){var i=t.debounce();angular.isNumber(i)||angular.isObject(i)?e(function(){t.select({activeIdx:n,evt:a})},angular.isNumber(i)?i:i["default"]):t.select({activeIdx:n,evt:a})}}}}]).directive("uibTypeaheadMatch",["$templateRequest","$compile","$parse",function(e,t,n){return{scope:{index:"=",match:"=",query:"="},link:function(a,i,r){var o=n(r.templateUrl)(a.$parent)||"uib/template/typeahead/typeahead-match.html";e(o).then(function(e){var n=angular.element(e.trim());i.replaceWith(n),t(n)(a)})}}}]).filter("uibTypeaheadHighlight",["$sce","$injector","$log",function(e,t,n){function a(e){return e.replace(/([.?*+^$[\]\\(){}|-])/g,"\\$1")}function i(e){return/<.*>/g.test(e)}var r;return r=t.has("$sanitize"),function(t,o){return!r&&i(t)&&n.warn("Unsafe use of typeahead please use ngSanitize"),t=o?(""+t).replace(new RegExp(a(o),"gi"),"<strong>$&</strong>"):t,r||(t=e.trustAsHtml(t)),t}}]),angular.module("ui.bootstrap.debounce",[]).factory("$$debounce",["$timeout",function(e){return function(t,n){var a;return function(){var i=this,r=Array.prototype.slice.call(arguments);a&&e.cancel(a),a=e(function(){t.apply(i,r)},n)}}}]),angular.module("uib/template/datepickerPopup/popup.html",[]).run(["$templateCache",function(e){e.put("uib/template/datepickerPopup/popup.html",'<ul class="uib-datepicker-popup dropdown-menu uib-position-measure" dropdown-nested ng-if="isOpen" ng-keydown="keydown($event)" ng-click="$event.stopPropagation()">\n  <li ng-transclude></li>\n  <li ng-if="showButtonBar" class="uib-button-bar">\n    <span class="btn-group pull-left">\n      <button type="button" class="btn btn-sm btn-info uib-datepicker-current" ng-click="select(\'today\', $event)" ng-disabled="isDisabled(\'today\')">{{ getText(\'current\') }}</button>\n      <button type="button" class="btn btn-sm btn-danger uib-clear" ng-click="select(null, $event)">{{ getText(\'clear\') }}</button>\n    </span>\n    <button type="button" class="btn btn-sm btn-success pull-right uib-close" ng-click="close($event)">{{ getText(\'close\') }}</button>\n  </li>\n</ul>\n')}]),angular.module("uib/template/datepicker/datepicker.html",[]).run(["$templateCache",function(e){e.put("uib/template/datepicker/datepicker.html",'<div ng-switch="datepickerMode">\n  <div uib-daypicker ng-switch-when="day" tabindex="0" class="uib-daypicker"></div>\n  <div uib-monthpicker ng-switch-when="month" tabindex="0" class="uib-monthpicker"></div>\n  <div uib-yearpicker ng-switch-when="year" tabindex="0" class="uib-yearpicker"></div>\n</div>\n')}]),angular.module("uib/template/datepicker/day.html",[]).run(["$templateCache",function(e){e.put("uib/template/datepicker/day.html",'<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n  <thead>\n    <tr>\n      <th><button type="button" class="btn btn-default btn-sm pull-left uib-left" ng-click="move(-1)" tabindex="-1"><i class="dripicons-chevron-left"></i></button></th>\n      <th colspan="{{::5 + showWeeks}}"><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm uib-title" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1"><strong>{{title}}</strong></button></th>\n      <th><button type="button" class="btn btn-default btn-sm pull-right uib-right" ng-click="move(1)" tabindex="-1"><i class="dripicons-chevron-right"></i></button></th>\n    </tr>\n    <tr>\n      <th ng-if="showWeeks" class="text-center"></th>\n      <th ng-repeat="label in ::labels track by $index" class="text-center"><small aria-label="{{::label.full}}">{{::label.abbr}}</small></th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr class="uib-weeks" ng-repeat="row in rows track by $index">\n      <td ng-if="showWeeks" class="text-center h6"><em>{{ weekNumbers[$index] }}</em></td>\n      <td ng-repeat="dt in row" class="uib-day text-center" role="gridcell"\n        id="{{::dt.uid}}"\n        ng-class="::dt.customClass">\n        <button type="button" class="btn btn-default btn-sm"\n          uib-is-class="\n            \'btn-info\' for selectedDt,\n            \'active\' for activeDt\n            on dt"\n          ng-click="select(dt.date)"\n          ng-disabled="::dt.disabled"\n          tabindex="-1"><span ng-class="::{\'text-muted\': dt.secondary, \'text-info\': dt.current}">{{::dt.label}}</span></button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n')}]),angular.module("uib/template/datepicker/month.html",[]).run(["$templateCache",function(e){e.put("uib/template/datepicker/month.html",'<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n  <thead>\n    <tr>\n      <th><button type="button" class="btn btn-default btn-sm pull-left uib-left" ng-click="move(-1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-left"></i></button></th>\n      <th colspan="{{::yearHeaderColspan}}"><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm uib-title" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1"><strong>{{title}}</strong></button></th>\n      <th><button type="button" class="btn btn-default btn-sm pull-right uib-right" ng-click="move(1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-right"></i></button></th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr class="uib-months" ng-repeat="row in rows track by $index">\n      <td ng-repeat="dt in row" class="uib-month text-center" role="gridcell"\n        id="{{::dt.uid}}"\n        ng-class="::dt.customClass">\n        <button type="button" class="btn btn-default"\n          uib-is-class="\n            \'btn-info\' for selectedDt,\n            \'active\' for activeDt\n            on dt"\n          ng-click="select(dt.date)"\n          ng-disabled="::dt.disabled"\n          tabindex="-1"><span ng-class="::{\'text-info\': dt.current}">{{::dt.label}}</span></button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n')
}]),angular.module("uib/template/datepicker/year.html",[]).run(["$templateCache",function(e){e.put("uib/template/datepicker/year.html",'<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n  <thead>\n    <tr>\n      <th><button type="button" class="btn btn-default btn-sm pull-left uib-left" ng-click="move(-1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-left"></i></button></th>\n      <th colspan="{{::columns - 2}}"><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm uib-title" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1"><strong>{{title}}</strong></button></th>\n      <th><button type="button" class="btn btn-default btn-sm pull-right uib-right" ng-click="move(1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-right"></i></button></th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr class="uib-years" ng-repeat="row in rows track by $index">\n      <td ng-repeat="dt in row" class="uib-year text-center" role="gridcell"\n        id="{{::dt.uid}}"\n        ng-class="::dt.customClass">\n        <button type="button" class="btn btn-default"\n          uib-is-class="\n            \'btn-info\' for selectedDt,\n            \'active\' for activeDt\n            on dt"\n          ng-click="select(dt.date)"\n          ng-disabled="::dt.disabled"\n          tabindex="-1"><span ng-class="::{\'text-info\': dt.current}">{{::dt.label}}</span></button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n')}]),angular.module("uib/template/timepicker/timepicker.html",[]).run(["$templateCache",function(e){e.put("uib/template/timepicker/timepicker.html",'<table class="uib-timepicker">\n  <tbody>\n    <tr class="text-center" ng-show="::showSpinners">\n      <td class="uib-increment hours"><a ng-click="incrementHours()" ng-class="{disabled: noIncrementHours()}" class="btn btn-link" ng-disabled="noIncrementHours()" tabindex="-1"><span class="glyphicon glyphicon-chevron-up"></span></a></td>\n      <td>&nbsp;</td>\n      <td class="uib-increment minutes"><a ng-click="incrementMinutes()" ng-class="{disabled: noIncrementMinutes()}" class="btn btn-link" ng-disabled="noIncrementMinutes()" tabindex="-1"><span class="glyphicon glyphicon-chevron-up"></span></a></td>\n      <td ng-show="showSeconds">&nbsp;</td>\n      <td ng-show="showSeconds" class="uib-increment seconds"><a ng-click="incrementSeconds()" ng-class="{disabled: noIncrementSeconds()}" class="btn btn-link" ng-disabled="noIncrementSeconds()" tabindex="-1"><span class="glyphicon glyphicon-chevron-up"></span></a></td>\n      <td ng-show="showMeridian"></td>\n    </tr>\n    <tr>\n      <td class="form-group uib-time hours" ng-class="{\'has-error\': invalidHours}">\n        <input type="text" placeholder="HH" ng-model="hours" ng-change="updateHours()" class="form-control text-center" ng-readonly="::readonlyInput" maxlength="2" tabindex="{{::tabindex}}" ng-disabled="noIncrementHours()" ng-blur="blur()">\n      </td>\n      <td class="uib-separator">:</td>\n      <td class="form-group uib-time minutes" ng-class="{\'has-error\': invalidMinutes}">\n        <input type="text" placeholder="MM" ng-model="minutes" ng-change="updateMinutes()" class="form-control text-center" ng-readonly="::readonlyInput" maxlength="2" tabindex="{{::tabindex}}" ng-disabled="noIncrementMinutes()" ng-blur="blur()">\n      </td>\n      <td ng-show="showSeconds" class="uib-separator">:</td>\n      <td class="form-group uib-time seconds" ng-class="{\'has-error\': invalidSeconds}" ng-show="showSeconds">\n        <input type="text" placeholder="SS" ng-model="seconds" ng-change="updateSeconds()" class="form-control text-center" ng-readonly="readonlyInput" maxlength="2" tabindex="{{::tabindex}}" ng-disabled="noIncrementSeconds()" ng-blur="blur()">\n      </td>\n      <td ng-show="showMeridian" class="uib-time am-pm"><button type="button" ng-class="{disabled: noToggleMeridian()}" class="btn btn-default text-center" ng-click="toggleMeridian()" ng-disabled="noToggleMeridian()" tabindex="{{::tabindex}}">{{meridian}}</button></td>\n    </tr>\n    <tr class="text-center" ng-show="::showSpinners">\n      <td class="uib-decrement hours"><a ng-click="decrementHours()" ng-class="{disabled: noDecrementHours()}" class="btn btn-link" ng-disabled="noDecrementHours()" tabindex="-1"><span class="glyphicon glyphicon-chevron-down"></span></a></td>\n      <td>&nbsp;</td>\n      <td class="uib-decrement minutes"><a ng-click="decrementMinutes()" ng-class="{disabled: noDecrementMinutes()}" class="btn btn-link" ng-disabled="noDecrementMinutes()" tabindex="-1"><span class="glyphicon glyphicon-chevron-down"></span></a></td>\n      <td ng-show="showSeconds">&nbsp;</td>\n      <td ng-show="showSeconds" class="uib-decrement seconds"><a ng-click="decrementSeconds()" ng-class="{disabled: noDecrementSeconds()}" class="btn btn-link" ng-disabled="noDecrementSeconds()" tabindex="-1"><span class="glyphicon glyphicon-chevron-down"></span></a></td>\n      <td ng-show="showMeridian"></td>\n    </tr>\n  </tbody>\n</table>\n')}]),angular.module("uib/template/modal/window.html",[]).run(["$templateCache",function(e){e.put("uib/template/modal/window.html","<div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n")}]),angular.module("uib/template/typeahead/typeahead-match.html",[]).run(["$templateCache",function(e){e.put("uib/template/typeahead/typeahead-match.html",'<a href\n   tabindex="-1"\n   ng-bind-html="match.label | uibTypeaheadHighlight:query"\n   ng-attr-title="{{match.label}}"></a>\n')}]),angular.module("uib/template/typeahead/typeahead-popup.html",[]).run(["$templateCache",function(e){e.put("uib/template/typeahead/typeahead-popup.html",'<ul class="dropdown-menu" ng-show="isOpen() && !moveInProgress" ng-style="{top: position().top+\'px\', left: position().left+\'px\'}" role="listbox" aria-hidden="{{!isOpen()}}">\n    <li class="uib-typeahead-match" ng-repeat="match in matches track by $index" ng-class="{active: isActive($index) }" ng-mouseenter="selectActive($index)" ng-click="selectMatch($index, $event)" role="option" id="{{::match.id}}">\n        <div uib-typeahead-match index="$index" match="match" query="query" template-url="templateUrl"></div>\n    </li>\n</ul>\n')}]),angular.module("ui.bootstrap.datepickerPopup").run(function(){!angular.$$csp().noInlineStyle&&!angular.$$uibDatepickerpopupCss&&angular.element(document).find("head").prepend('<style type="text/css">.uib-datepicker-popup.dropdown-menu{display:block;float:none;margin:0;}.uib-button-bar{padding:10px 9px 2px;}</style>'),angular.$$uibDatepickerpopupCss=!0}),angular.module("ui.bootstrap.datepicker").run(function(){!angular.$$csp().noInlineStyle&&!angular.$$uibDatepickerCss&&angular.element(document).find("head").prepend('<style type="text/css">.uib-datepicker .uib-title{width:100%;}.uib-day button,.uib-month button,.uib-year button{min-width:100%;}.uib-left,.uib-right{width:100%}</style>'),angular.$$uibDatepickerCss=!0}),angular.module("ui.bootstrap.position").run(function(){!angular.$$csp().noInlineStyle&&!angular.$$uibPositionCss&&angular.element(document).find("head").prepend('<style type="text/css">.uib-position-measure{display:block !important;visibility:hidden !important;position:absolute !important;top:-9999px !important;left:-9999px !important;}.uib-position-scrollbar-measure{position:absolute !important;top:-9999px !important;width:50px !important;height:50px !important;overflow:scroll !important;}.uib-position-body-scrollbar-measure{overflow:scroll !important;}</style>'),angular.$$uibPositionCss=!0}),angular.module("ui.bootstrap.timepicker").run(function(){!angular.$$csp().noInlineStyle&&!angular.$$uibTimepickerCss&&angular.element(document).find("head").prepend('<style type="text/css">.uib-time input{width:50px;}</style>'),angular.$$uibTimepickerCss=!0}),angular.module("ui.bootstrap.typeahead").run(function(){!angular.$$csp().noInlineStyle&&!angular.$$uibTypeaheadCss&&angular.element(document).find("head").prepend('<style type="text/css">[uib-typeahead-popup].dropdown-menu{display:block;}</style>'),angular.$$uibTypeaheadCss=!0});
(function () {

   'use strict';

   /**
    * @ngdoc filter
    * @name prefix:prefix
    * @description
    * <ul>
    * <li>Displays a group array</li>
    * </ul>
    */

   angular.module('filters.parseUrlFilter', []).filter('parseUrlFilter', function(){
      return function (text, target) {
        var urlPattern = /(https?:\/\/[^\s]+)|(www?\.[^\s]+)/g;
        return "bla";
      };
   });
})();
(function () {

   'use strict';

   /**
    * @ngdoc filter
    * @name prefix:prefix
    * @description
    * <ul>
    * <li>Displays a group array</li>
    * </ul>
    */

   angular.module('filters.groupBy', []).filter('groupBy', function(){
      return function(items, groupSize) {
        var groups = [];

        if(items){
          var array = items.slice(0),
              inner, i,j;

          for(i=0, j=array.length; i<j; i+=groupSize) {
            inner = array.slice(i,i+groupSize);
            groups.push(inner);
          }
        }

        return groups;
      };
   });
})();
(function () {

	'use strict';
	/**
	 * @ngdoc directive
	 * @name zendesk:zendesk
	 * @description
	 * <ul>
	 * <li>Displays a Zendesk link based on the view user is looking at</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */
	angular.module('directives.zendesk', []).directive('zendesk', zendesk);
	/** @ngInject */
	function zendesk($state, zenLinks) {
		var directive =  {
			restrict: 'E',
			replace: true,
			template: '<a class="help-button" href="{{ _url }}" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24" stroke-width="2"><g stroke-width="2" transform="translate(0, 0)"><circle cx="12" cy="12" r="11" fill="none" stroke="#444444" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2" stroke-linejoin="miter"></circle><circle data-color="color-2" data-stroke="none" cx="12" cy="18" r="1" fill="#444444"></circle><path data-color="color-2" d="M9.853,6.56c1.98-.875,4.542-.771,5.417.645s.271,3.063-1.229,4.334S12,13.5,12,14.5" fill="none" stroke="#444444" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2" stroke-linejoin="miter"></path></g></svg><span class="text" translate="TOPNAV_TRAININGHELP"></span></a>', 
			//template: '<a class="help-button"><span class="icon dripicons-question dripicons-font-size-x-1_5"></span></a>',
			link: linkFunction
		};
		return directive;

		function linkFunction(scope, elem, attrs, $location) {
			scope.$watch(function() {
				return $state.current.name;

			}, function(value) {
				var url = zenLinks[$state.current.name] || '';
				scope._url;

				if($state.current.name !== '' && url.length > 0)
					scope._url = url;
				else
					scope._url = 'https://help.classlist.com';
			})
		}
	}

})();

(function () {

	'use strict';
	/**
	* @ngdoc directive
	* @name directives.validationIcons:validationIcons
	* @description
	* <ul>
	* <li>Watches and shows the validation icon based on valid/invalid and hides it field is pristine</li>
	* </ul>
	* @restrict E
	* @element
	*/
	angular.module('directives.validationIcons', []).directive('validationIcons', validationIcons);
	/** @ngInject */
	function validationIcons() {
		var directive = {
			restrict: 'AE',
			scope: {
				isValid: '=',
				isDirty: '='
			},
			replace: true,
			template: '<span class="validation-icons" ng-show="isDirty"><span class="dripicons-checkmark valid" ng-show="isValid"></span><span class="dripicons-wrong invalid" ng-show="!isValid"></span></span>'
		}
		return directive
	}

})();

(function () {

	'use strict';
	/**
   * @ngdoc directive
   * @name directives.validationErrors
   * @description Displays form validation errors from server
   */
	angular.module('directives.validationErrors', []).directive('validationErrors', validationErrors);
	/** @ngInject */
	function validationErrors(base) {

		var directive = {
			restrict: 'AE',
			replace: true,
			template: '<div class="alert alert-danger" ng-show="notifs.length > 0"><ul><li ng-repeat="err in notifs">{{err.msg}}</li></ul></div>',
			link: linkFunction
		};
		return directive;

		function linkFunction(scope, elem, attrs) {
			scope.notifs = [];
			base.subscribe('badrequest', function(response){
				scope.notifs = [];
				scope.notifs = response;
			});
			scope.$on('$destroy', function () {
				base.unsubscribe('badrequest')
			});
		}
	}

})();

(function () {

  'use strict';

  angular.module('directives.tooltip', []).directive('tooltip', function(){
      return {
          restrict: 'A',
          link: function(scope, elem, attrs) {
            var el = elem[0];

            el.addEventListener("mouseover", function(e) {

              if(window.innerWidth > 990) {
                var t = el.getElementsByClassName('tltp')[0];
                t.style.display = "block";
                t.style.marginLeft = '-' + ((t.offsetWidth / 2) - 10) + 'px';
                t.style.marginTop = (t.offsetHeight + 10) + 'px';
              }
            }, false);

            el.addEventListener("mouseout", function() {
                  var t = el.getElementsByClassName('tltp')[0];
                  t.style.display = "none";

            }, false);
          }
      };
  })
  
})();

(function () {

	'use strict';

	angular.module('directives.timeago', [])
	.filter('timeago', function () {
		return function (time, local, raw) {
			if (!time) return "never";

			if (!local) {
					(local = Date.now())
			}

			if (angular.isDate(time)) {
					time = time.getTime();
			} else if (typeof time === "string") {
					time = new Date(time).getTime();
			}

			if (angular.isDate(local)) {
					local = local.getTime();
			}else if (typeof local === "string") {
					local = new Date(local).getTime();
			}

			if (typeof time !== 'number' || typeof local !== 'number') {
					return;
			}

			var offset = Math.abs((local - time) / 1000),
			span = [],
			MINUTE = 60,
			HOUR = 3600,
			DAY = 86400,
			WEEK = 604800,
			MONTH = 2629744,
			YEAR = 31556926;

			if (offset <= MINUTE)              span = [ '', 'just now' ];
			else if (offset < (MINUTE * 60))   span = [ Math.round(Math.abs(offset / MINUTE)), 'min' ];
			else if (offset < (HOUR * 24))     span = [ Math.round(Math.abs(offset / HOUR)), 'hr' ];
			else if (offset < (DAY * 7))       span = [ Math.round(Math.abs(offset / DAY)), 'day' ];
			else if (offset < (WEEK * 4))     span = [ Math.round(Math.abs(offset / WEEK)), 'week' ];
			else if (offset < (MONTH * 12))     span = [ Math.round(Math.abs(offset / MONTH)), 'month' ];
			else if (offset < (YEAR * 10))     span = [ Math.round(Math.abs(offset / YEAR)), 'year' ];
			else                               span = [ '', 'a long time' ];

			span[1] += (span[0] === 0 || span[0] > 1) ? 's' : '';
			span = span.join(' ');

			if (raw === true || offset <= MINUTE) {
				return span;
			}

			return (time <= local) ? span + ' ago' : 'in ' + span;
		}
	})
})();

(function () {

	'use strict';
	/**
	 * @ngdoc directive
	 * @name directives.removeSpace:removeSpace
	 * @description
	 * <ul>
	 * <li>Watches the model and removes characters that doesn't pass the regex</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */

	angular.module('directives.removeSpace',	[]).directive('removeSpace',	removeSpace);
	/** @ngInject */
	function removeSpace()	{
		var directive = {
			restrict: 'A',
			link: linkFunction
		};
		return directive;

		function linkFunction(scope,	elem,	attrs)	{
			elem.on('keypress',	function	(event)	{
				if (event.charCode === 32)	{
					event.preventDefault();
				}
			})
		}
	}

})();

(function () {

	'use strict';
	/**
	* @ngdoc directive
	* @name directives.charRemover:charRemover
	* @description
	* <ul>
	* <li>Watches the model and removes characters that doesn't pass the regex</li>
	* </ul>
	* @restrict E
	* @element
	*/

	angular.module('directives.removeChars', []).directive('removeChars', removeChars);
	/** @ngInject */
	function removeChars (regexes) {
		var directive = {
			restrict: 'A',
			link: linkFunction
		};
		return directive;

		function linkFunction(scope, elem, attrs){
			var	regexp = new RegExp(regexes[attrs.removeChars]);

			elem.on('paste', function(event){
				event.preventDefault();
			});
			
			elem.on('keypress', function(event)	{
				if(event && (event.keyCode === 8 || event.keyCode === 9)) {return}
				var char = String.fromCharCode(event.which),
					currentValue = elem.val(),
					target = event.target,
					type = target.getAttribute('type'),
					testString = elem.val() + char;

				if (type !== 'number'){
					var	selectionStart = target.selectionStart,
						selectionEnd = target.selectionEnd,
						startFraction = currentValue.substring(0, selectionStart),
						endFraction = currentValue.substring(selectionEnd);

					testString = startFraction + char + endFraction;
				}

				if (!regexp.test(testString)) {
					event.preventDefault();
				}
			});
		}
	}
})();

(function () {

	'use strict';
	/**
	 * @ngdoc directive
	 * @name relationship:relationship
	 * @description
	 * <ul>
	 * <li>Displays list of relationship</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */
	angular.module('directives.relationship', []).directive('relationship', relationship);
	/** @ngInject */
	function relationship(base, $http, $rootScope) {
		var directive = {
			restrict: 'EA',
			replace: true,
			scope:{
				ngModel: '='
			},
			template: [
				'<select class="form-control" ng-required="isRequired">',
				'<option ng-repeat="r in relationships" value="{{::r.id}}">{{::r.longName}}</option>',
				'</select>'
			].join(''),
			link: linkFunction
		}
		return directive;

		function linkFunction(scope, elem, attrs) {
			scope.relationship = [];
			scope.isRequired=scope.$eval(attrs.isRequired);

			$http.get('i8n/locale-metadata-en-GB.json').then(function(data) {
				setTimeout(function(){
					scope.relationships = data.data.metadata.relationships;
					// we remove the 'other' option from relations if the school is not in integration
					if(!$rootScope.active_school || !$rootScope.active_school.integration){
						scope.relationships = scope.relationships.filter(function(item) {
							return item.id !== "1019"; // other option id
						});
					}
				}, 300)
				
			});
		}
	}

})();

(function () {

	'use strict';

	/**
	 * @ngdoc directive
	 * @name profileUpdater:profileUpdater
	 * @description
	 * <ul>
	 * <li>Listen to profile update event to update the name button and profile page</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */

	angular.module('directives.profileUpdater', []).directive('profileUpdater', profileUpdater);
	/** @ngInject */
	function profileUpdater(base, $timeout, $rootScope) {
		var directive = {
			restrict: 'EA',
			replace: false,
			link:linkFunction
		};
		return directive;

		function linkFunction(scope, elem, attrs) {

			scope.myUser = {
				firstName:'',
				lastName:'',
				email:'',
				pupils:[]
			};

			scope.$watch('active_user', function(newVal, oldVal){
				if(newVal && !_.isUndefined(newVal.firstName) && !_.isUndefined(newVal.lastName)){
					$timeout(function(){
						scope.myUser = newVal;
					},0)
				}
			})

			scope.$on('UPDATE_PROFILE',function (evt,args) {
				$timeout(function(){
					args.firstName ? $rootScope.active_user.firstName = args.firstName : _.noop();
					args.lastName ? $rootScope.active_user.lastName = args.lastName : _.noop();
					args.email ? $rootScope.active_user.email = args.email : _.noop()
				},0)
			});

		}
	}

})();

(function () {
	angular.module('directives.premiumAd', [])
	.directive('premiumAd', premiumAd);
	function premiumAd($uibModal, $timeout, settings, $rootScope) {

		var directive = {
			restrict: 'EA',
			replace: true,
			scope: true,
			link:linkFunction,
			templateUrl:'app/base/directives/premiumAd.directive.html'
		}

		return directive;
		function linkFunction(scope, elem, attrs) {
			
		}
	}
})();

(function() {

    'use strict';

    /**
     * @ngdoc directive
     * @name avatar:avatar
     * @description
     * <ul>
     * <li>Display a post nugget with avatar, likes, comments etc...</li>
     * </ul>
     * @restrict E
     * @element
     */

    angular.module('directives.postAsset', []).factory('postAssetService', ['base', function(base) {
        return _.create(base, {});
    }]).filter('to_trusted', ['$sce', function($sce) {
        return function(text) {
            return $sce.trustAsHtml(text);
        };
    }]).directive('postAsset', postAsset);

    /** @ngInject */
    function postAsset(postAssetService, toastr, $rootScope, $translate, regexes, settings, $sce, $state, $stateParams, $uibModal, $window, $compile) {
        var directive = {
            restrict: 'EA',
            replace: true,
            scope: {
                postContent: '=',
                postContext: '@',
                updateComments: '&updateComments',
                onGroupNameTap: '&',
                readonlyPost: '@',
                userAvatar: '=',
                userName: '=',
                postEvents: '=',
                userId: '=',
                postUserId: '=',
                commentOnly: '=',
                archivedGroup: '='
            },
            templateUrl: 'app/base/directives/postAsset.directive.html',
            link: linkFunction
        };
        return directive;

        function linkFunction(scope, elem, attrs) {
            // var stripe;
            // var card;
            scope.showReadMore = false;
            scope.post = scope.postContent;
            scope.isArchivedGroup = scope.archivedGroup || (scope.post && scope.post.archived);
            //console.log(scope.post);
            scope.draftComment = {};
            scope.draftReply = {};

            scope.trustAsHtml = function(string) {
                return $sce.trustAsHtml(string);
            };

            setTimeout(function() {
                var commentId = $rootScope.getQueryParam('cid')
                if (commentId) {
                    var found = false;
                    for (var i = 0; i < scope.post.comments.length; i++) {
                        var c = scope.post.comments[i]
                        if (c.id === commentId) {
                            found = true;
                            break;
                        }else if(c.replies && c.replies.length > 0){ // checks replies 
                            // check replies to find comment
                            for (var j = 0; j < c.replies.length; j++) {
                                var reply = c.replies[j]
                                if (reply.id === commentId) {
                                    found = true;
                                    break;
                                }
                            }
                        }
                    }

                    if (found) {
                        var scroll_to_comment = document.getElementById('comment_' + $rootScope.getQueryParam('cid'));
                        if (scroll_to_comment) {
                            scroll_to_comment.scrollIntoView();
                            window.scrollBy(0, -130);
                        }
                    } else {
                        toastr.info($translate.instant('COMMENT_BEEN_DELETED'));
                    }
                }
            }, 600);

            scope.context = scope.postContext;
            var el = angular.element(elem);

            scope.categories = [
                "general",
                "lost_found",
                "offer",
                "wanted",
                "free"
            ];

            var draft = localStorage.getItem("draftComment");
            if(draft) {
                setTimeout(function() {
                    var draftComment = JSON.parse(draft);
                    var time = new Date().getTime() - 24 * 60 * 60 * 1000; // now - 24 hours in miliseconds
                    if(time > draftComment.createdAt) {
                        localStorage.removeItem("draftComment");
                        scope.draftComment.body = '';
                    } else if(scope.post.id === draftComment.postId) {
                        if(!draftComment.replyingCommentId) {
                            scope.draftComment = draftComment;
                        } else {
                            scope.draftReply = draftComment;
                            var cmm = scope.post.comments.find(function (comment) {
                                return comment.id === draftComment.replyingCommentId;
                            });
                            scope.replyComment(cmm, null, null, true);
                        }
                    }
                }, 500);
            } else {
                scope.draftComment.body = '';
            }

            /*
            scope.initStripe = function() {
                try {
                    stripe = Stripe(settings.conf.stripeKey);
                    var elements = stripe.elements();

                    var style = {
                        base: {
                            color: '#32325d',
                            lineHeight: '18px',
                            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                            fontSmoothing: 'antialiased',
                            fontSize: '16px',
                            '::placeholder': {
                                color: '#aab7c4'
                            }
                        },
                        invalid: {
                            color: '#fa755a',
                            iconColor: '#fa755a'
                        }
                    };

                    // Create an instance of the card Element.
                    card = elements.create('card', { style: style });

                    // Add an instance of the card Element into the `card-element` <div>.
                    card.mount('#card-element-1');

                    // Handle real-time validation errors from the card Element.
                    card.addEventListener('change', function(event) {
                        var displayError = document.getElementById('card-errors-1');

                        if (event.error) {
                            displayError.textContent = event.error.message;
                        } else {
                            displayError.textContent = '';
                        }
                    });
                } catch (ex) {
                    //Skip for now.
                }
            }*/

            /*
            scope.stripeSubmit = function(p) {
                scope.paymentConfirmed = false;

                var payload = {
                    id: p.id,
                    token: ''
                };

                if (scope.buingTickets)
                    return;

                scope.buingTickets = true;

                stripe.createPaymentMethod('card', card).then(function(result) {
                    if (result.error) {
                        scope.buingTickets = false;
                        var errorElement = document.getElementById('card-errors-1');
                        if (errorElement)
                            errorElement.textContent = result.error.message;

                        setTimeout(function() {
                            scope.$apply()
                        }, 1);
                    } else {
                        payload.token = result.paymentMethod.id;
                        postAssetService.post('payment/v1/marketplace/payment/stripe', payload, {
                                'cache': false,
                                'xhr': true
                            })
                            .then(function(response) {
                                    if (response && response.data) {
                                        if (response.data.requiresAction) {
                                            handleAction(response.data);
                                            return;
                                        }
                                    }

                                    if (response.data) {
                                        if (response.data.logId) {
                                            scope.paymentConfirmed = true;
                                        }
                                    }

                                    setTimeout(function() {
                                        scope.$apply()
                                    }, 2);
                                },
                                function(error) {
                                    scope.buingTickets = false;

                                    if (error.data.error.message) {
                                        toastr.info(error.data.error.message);
                                    } else {
                                        toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
                                    }

                                    setTimeout(function() {
                                        scope.$apply()
                                    }, 3);
                                });
                    }
                });
            }

            function handleAction(response) {
                stripe.handleCardAction(response.clientSecret).then(function(result) {
                    if (result.error) {
                        scope.buingTickets = false;
                        toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
                    } else {
                        postAssetService.post('payment/v1/marketplace/paymentIntent/confirm', {
                                logId: response.logId
                            }, {
                                'Content-Type': 'application/json',
                                'cache': false,
                                'xhr': true
                            })
                            .then(function(resp) {
                                    scope.buingTickets = false;

                                    if (response) {
                                        if (response.logId) {
                                            scope.paymentConfirmed = true;
                                        }
                                    }

                                    setTimeout(function() {
                                        scope.$apply()
                                    }, 4);
                                },
                                function(error) {
                                    scope.buingTickets = false;

                                    if (error.data.error.message) {
                                        toastr.info(error.data.error.message);
                                    } else {
                                        toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
                                    }
                                });
                    }
                });
            }*/

            scope.isPostView = function() {
                return location.href.indexOf('#/post/') !== -1;
            }

            /*
            if (scope.isPostView()) {
                scope.initStripe()
            }*/

            scope.getPostGroups = function(post) {

                var modalInstance = $uibModal.open({
                    animation: true,
                    backdropClass: 'backdrop-zindexed',
                    templateUrl: 'app/home/views/post-groups-modal.html',
                    controller: function($scope) {

                        postAssetService.get('post/v1/get/' + post.id + '/groups', {}).then(function(res) {
                                $scope._groups = res.data.items;
                            },
                            function(error) {

                            });

                        scope.openGroup = function(group) {
                            modalInstance.close();
                            location.href = '#/groups/view/' + group.id;
                        }

                        $scope.close = function() {
                            modalInstance.close();
                        };
                    }
                });
            }
            scope.openGroup = function(group) {
                location.href = '#/groups/view/' + group;
            }

            scope.getAnnHeight = function() {
                var h = document.querySelector('[post-id="' + scope.post.id + '"]');
                var height = h ? h.offsetHeight : 0;
                scope.showReadMore = height > 600;

                setTimeout(function() {
                    scope.$apply();
                }, 100);
            }

            scope.openPicture = function(files, current) {
                if ($rootScope.isNative) {
                    var pictures = new Array()
                    pictures.push(current.url)

                    for (var i = 0; i < files.length; i++) {
                        var file = files[i];

                        if (file.name === current.name)
                            continue;

                        if (file.ext) {
                            if (file.ext.toLowerCase() !== 'png' &&
                                file.ext.toLowerCase() !== 'gif' &&
                                file.ext.toLowerCase() !== 'bmp' &&
                                file.ext.toLowerCase() !== 'jpg' &&
                                file.ext.toLowerCase() !== 'jpeg')
                                continue;
                        }

                        pictures.push(file.url)
                    }

                    previewImages(pictures)
                } else {
                    window.open(current.url + '=s0', '_blank')
                }
            }

            scope.getPostPictures = function(attachments) {
                var pictures = new Array()
                var cssclass = '';

                if (!attachments)
                    return {
                        cssclass: cssclass,
                        pictures: pictures
                    }

                for (var i = 0; i < attachments.length; i++) {
                    if (attachments[i].ext) {
                        if (attachments[i].ext.toLowerCase() === 'png' ||
                            attachments[i].ext.toLowerCase() === 'gif' ||
                            attachments[i].ext.toLowerCase() === 'bmp' ||
                            attachments[i].ext.toLowerCase() === 'jpg' ||
                            attachments[i].ext.toLowerCase() === 'jpeg') {
                            pictures.push(attachments[i])
                        }
                    } else {
                        pictures.push(attachments[i])
                    }
                }

                if (pictures.length === 1)
                    cssclass = 'single-picture';
                else if (pictures.length === 2)
                    cssclass = 'double-picture';
                else if (pictures.length === 3 || pictures.length > 3)
                    cssclass = 'multi-picture';

                return {
                    cssclass: cssclass,
                    pictures: pictures
                }
            }
            if (getMobileOperatingSystem() === 'Android') {
                handlePDF(scope.post);
            }
            /*
             * This function checks the attachment and if it's a PDF, change the url to open preview it in Google PDF Viewer.
             */
            function handlePDF(post) {
                if (post.files && post.files.length > 0) {
                    for (var i = 0; i < post.files.length; i++) {
                        if (post.files[i].ext == 'pdf' && post.files[i].url.indexOf("viewerng") === -1) {
                            post.files[i].url = 'https://docs.google.com/viewerng/viewer?url=' + post.files[i].url
                        }
                        continue;
                    }
                } else {
                    return;
                }
            }

            scope.getAttUrl = function() {
                return att.url;
            }

            scope.togglePostMenu = function(post) {
                if (post.menuOpened) {
                    post.menuOpened = false;
                } else {
                    post.menuOpened = true;
                }
            }

            scope.getPostPicture = function() {
                if (!scope.post || !scope.post.attachments)
                    return '';

                if (!scope.getPostPictures(scope.post.attachments))
                    return '';

                if (!scope.getPostPictures(scope.post.attachments).pictures || scope.getPostPictures(scope.post.attachments).pictures.length === 0)
                    return '';

                if (!scope.getPostPictures(scope.post.attachments).pictures[0])
                    return '';

                return scope.getPostPictures(scope.post.attachments).pictures[0].url + (!scope.post.event ? '=s0' : '');
            }

            scope.getEventDescription = function(descr) {
                descr = $rootScope.parseTagsToLinks(descr);
                descr = descr.replace(/\r?\n/g, '<br />');
                return descr;
            }

            scope.gotoListings = function(cat) {
                //Emese 19/09/17 - for callingwithout category
                if (_.isUndefined(cat)) {
                    location.href = '#/listings/list/'
                } else {
                    $rootScope.sListCategory = cat;
                    location.href = '#/listings/list/' + cat;
                }
            }

            scope.getDonationPrice = function() {
                if (scope.post.ptaPercentage === 0)
                    return 0;

                return ((scope.post.ptaPercentage) * hasPrice()).toFixed(2);
            }

            scope.hasPrice = function() {
                return scope.post.priceAsDouble;
            }

            function validator() {

                if (scope.postContent) {
                    var p = angular.fromJson(scope.postContent),
                        valid = p.hasOwnProperty('postedBy') && !_.isEmpty(p.postedBy) &&
                        p.hasOwnProperty('postedOn') && !_.isEmpty(p.postedOn) &&
                        //p.hasOwnProperty('avatar') && !_.isEmpty(p.avatar) &&
                        p.hasOwnProperty('userId') && !_.isUndefined(p.userId) &&
                        p.hasOwnProperty('isOwn') && !_.isUndefined(p.isOwn) &&
                        p.hasOwnProperty('isLiked') && !_.isUndefined(p.isLiked) &&
                        p.hasOwnProperty('likeCount') && !_.isUndefined(p.likeCount) &&
                        p.hasOwnProperty('commentCount') && !_.isUndefined(p.commentCount) &&
                        p.hasOwnProperty('id') && !_.isUndefined(p.id);

                    if (valid) {
                        scope.post = p;

                        if (scope.post.type === 'classlist') {
                            scope.post.body = scope.post.body;
                        } else {
                            scope.post.body = $rootScope.parseTagsToLinks(scope.post.body);
                            scope.post.body = $rootScope.parseMentionTags(scope.post.body);
                        }

                        if (scope.post.comments) {
                            _.each(scope.post.comments, function(item, i) {
                                item.body = $rootScope.parseTagsToLinks(item.body);
                                item.body = $rootScope.parseMentionTags(item.body);
                                item.hasReply = item.totalReplyCount > 0;
                                if(item.totalReplyCount > 0){
                                    _.each(item.replies, function(reply, j) {
                                        reply.body = $rootScope.parseTagsToLinks(reply.body);
                                        reply.body = $rootScope.parseMentionTags(reply.body);
                                    });
                                }
                            });
                        }
                        
                        setTimeout(function() {
                            scope.getAnnHeight();
                        }, 1000);
                    } else {
                        el.remove();
                        console.error('something wrong with post: ', p)
                    }

                } else {
                    el.remove();
                }
            }

            if (!angular.fromJson(scope.postContent).hasOwnProperty('isAdv'))
                validator()

            scope.likePost = function(post) {
                if (scope.post.isLiked) {
                    //remove yourself from the array
                    if (scope.post.lastLike) {
                        var index = scope.post.lastLike.indexOf($rootScope.active_user.firstName + ' ' + $rootScope.active_user.lastName);
                        if (index >= 0) {
                            scope.post.lastLike.splice(index, 1);
                        }
                    }
                    //then
                    scope.post.isLiked = false;
                    scope.post.likeCount--;
                } else {
                    scope.post.isLiked = true;
                    scope.post.likeCount++

                        if (!post.isFollowed)
                            scope.followPost()
                }

                postAssetService.put('post/v1/like/' + scope.post.id, {}).then(function(res) {
                        // post like response
                    },
                    function() {
                        scope.post.isLiked = false;
                    })
            }

            scope.thankPost = function(post) {

                if (!scope.post.thankCount)
                    scope.post.thankCount = 0;

                if (scope.post.isThanked) {
                    //remove yourself from the array
                    if (scope.post.lastThank) {
                        var index = scope.post.lastThank.indexOf($rootScope.active_user.firstName + ' ' + $rootScope.active_user.lastName);
                        if (index >= 0) {
                            scope.post.lastThank.splice(index, 1);
                        }
                    }
                    //then
                    scope.post.isThanked = false;
                    scope.post.thankCount--;
                } else {
                    scope.post.isThanked = true;
                    scope.post.thankCount++;
                }

                postAssetService.put('post/v1/thank/' + scope.post.id, {}).then(function(res) {
                        // post thank response
                    },
                    function() {
                        scope.post.isThank = false;
                    })
            }

            scope.likeComment = function(comm) {
                if (comm.liked) {
                    //remove yourself from the array
                    if (comm.lastLike) {
                        var index = comm.lastLike.indexOf($rootScope.active_user.firstName + ' ' + $rootScope.active_user.lastName);
                        if (index >= 0) {
                            comm.lastLike.splice(index, 1);
                        }
                    }
                    //then
                    comm.liked = false;
                    comm.likeCount--;
                } else {
                    comm.liked = true;

                    if (!comm.likeCount)
                        comm.likeCount = 0;

                    comm.likeCount++;

                    if (!scope.post.isFollowed)
                        scope.followPost()
                }

                postAssetService.put('post/v1/like/comment/' + comm.id, {}).then(function(res) {
                        // post like response
                        //there is no response
                    },
                    function() {
                        comm.liked = false;
                    })
            }

            scope.edit = function() {
                if (scope.post.type === 'listing') {
                    location.href = '#/marketplace/post/' + scope.post.id;
                } else if(scope.post.type === 'announcement') {
                    var schoolId = $rootScope.active_school ? $rootScope.active_school.id : 0;
                    location.href = settings.conf.schoolAppURL + '/#/announcements/edit/' + scope.post.reference + '?s='+ schoolId;
                } else {
                    location.href = '#/edit/' + scope.post.id;
                }
            };

            scope.gotoCategory = function(cat, groupid, isgroup) {
                    if (!isgroup) {
                        $rootScope.sListCategory = cat;
                        location.href = settings.conf.parentAppURL + '#/listings/list/' + cat;
                    } else {
                        location.href = settings.conf.parentAppURL + '#/groups/view/' + groupid;
                    }
                }
                //Take user to that group's stream.
            scope.onGroupTap = function(groupid) {
                scope.onGroupNameTap({ group: groupid });
            }

            scope.doInt = function(value) {
                if (!value)
                    return '';

                if (isNaN(value))
                    return '';

                return parseInt(value)
            }

            scope.previewPhoto = function(photo) {
                var photos = [photo];
                previewImages(photos);
            }

            scope.deletePost = function() {
                var modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: 'app/home/views/delete-post-modal.html',
                    backdropClass: 'backdrop-zindexed',
                    size: 'sm',
                    controller: function($scope) {

                        $scope.confirm = function() {
                            postAssetService.delete('post/v1/delete/' + scope.post.id, {}).then(function() {
                                toastr.info($translate.instant('POST_DELETED'));
                                el.remove();

                                if (location.href.includes('/post/')) {
                                    if (scope.post.type === 'listing') {
                                        location.href = '#/listings/list/';
                                    } else {
                                        location.href = '/#';
                                    }
                                }

                                if (location.href.includes('home')) {
                                    scope.postEvents.removeFromPosts(scope.post.id);
                                }

                                modalInstance.close();
                            }, function(error) {

                            });
                        }

                        $scope.close = function() {
                            modalInstance.close();
                        }
                    }
                })
            }

            scope.lockComments = function() {

                var modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: 'app/home/views/lock-comment-modal.html',
                    backdropClass: 'backdrop-zindexed',
                    size: 'sm',
                    controller: function($scope) {
                        $scope.isLocked = scope.post.commentLocked
                        $scope.confirm = function() {
                            postAssetService.put('post/v1/update/' + scope.post.id + '/commentLock', {}).then(function() {
                                if(scope.post.commentLocked){
                                    toastr.info($translate.instant('COMMENT_UNLOCKED'));
                                }
                                else toastr.info($translate.instant('COMMENT_LOCKED'));
                                
                                $state.reload();
                                modalInstance.close();
                            }, function(error) {

                            });
                        }

                        $scope.close = function() {
                            modalInstance.close();
                        }
                    }
                })

            } 

            scope.markSold = function() {
                var modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: 'app/home/views/mark-sold-modal.html',
                    backdropClass: 'backdrop-zindexed',
                    size: 'sm',
                    controller: function($scope) {

                        $scope.confirm = function() {
                            postAssetService.get('post/v1/mark/sold/' + scope.post.id, {}).then(function() {
                                    scope.post.sold = true;
                                    modalInstance.close();
                                },
                                function(error) {

                                });
                        }

                        $scope.close = function() {
                            modalInstance.close();
                        }
                    }
                })
            }

            scope.openMarketplace = function(post) {
                $rootScope.$broadcast('ON_POST_VIEW_OPEN');
                location.href = '#/post/' + post.id;
            }

            scope.composeTo = function(data) {
                $rootScope.composeTo(data)
            }

            scope.markUnsold = function() {
                postAssetService.get('post/v1/mark/sold/' + scope.post.id, {}).then(function() {
                        scope.post.sold = false;
                    },
                    function(error) {

                    });
            }

            scope.showLikers = function(post) {
                postAssetService.get('post/v1/likes/' + post.id, { 'cache': false }).then(function(response) {
                    scope.likers = response.data.payload;
                    scope.likers.type = post.type;
                    $rootScope.$broadcast('POST_LIKES', scope.likers);
                });
            }

            scope.showThankers = function(post) {
                postAssetService.get('post/v1/thanks/' + post.id, { 'cache': false }).then(function(response) {
                    scope.thanks = response.data.payload;
                    scope.thanks.type = 'thanks';
                    $rootScope.$broadcast('POST_LIKES', scope.thanks);
                });
            }

            scope.showCommLikers = function(comm) {
                postAssetService.get('post/v1/likes/comment/' + comm.id, { 'cache': false }).then(function(response) {
                    scope.likers = response.data.payload;
                    //scope.likers.type = post.type;
                    $rootScope.$broadcast('POST_LIKES', scope.likers);
                });
            }

            scope.sendMessage = function() {
                var name = scope.post.postedBy.split(' ');
                scope.$emit('COMPOSE_TO', {
                    'firstName': name[0] || '',
                    'lastName': name[1] || '',
                    'id': scope.post.userId,
                    'avatar': scope.post.avatar
                })
            }

            scope.openUserHome = function(id, post) {
                if (post) {
                    if (post.type === 'classlist') {
                        return;
                    }
                }

                $rootScope.$broadcast('ON_POST_VIEW_OPEN');
                location.href = '#/classlist/details/' + id + '/contact';
            }

            scope.openPost = function(post) {

                if (post.event) {
                    location.href = '#/events/view/' + post.event.id;
                    return;
                }

                if (post.type === 'listing') {
                    scope.openMarketplace(post)
                    return;
                }

                if (!post.attachments || post.attachments.length === 0)
                    return;

                if (post.attachments.length === 1) {
                    if ($rootScope.isNative) {
                        $rootScope.previewImage(post.attachments[0].url)
                    } else {
                        window.open(post.attachments[0].url + '=s0', '_blank')
                    }
                } else if (post.attachments.length > 1) {
                    $rootScope.$broadcast('ON_POST_VIEW_OPEN');
                    location.href = '#/post/' + post.id;
                }
            }
            scope.openCommentImage = function(url){
                if ($rootScope.isNative) {
                    $rootScope.previewImage(url)
                } else {
                    window.open(url + '=s0', '_blank')
                }
            }

            scope.openClasslistPost = function(post) {
                if (post.attachments.length > 0) {
                    if (post.attachments[0].redirection) {
                        window.open(post.attachments[0].redirection, '_blank')
                        return;
                    }
                }
            }

            scope.reportPost = function() {

                var modalInstance = $uibModal.open({
                    animation: true,
                    backdropClass: 'backdrop-zindexed',
                    templateUrl: 'app/base/directives/postAsset.confirmReportModal.directive.html',
                    controller: function($scope) {
                        $scope.viewState = {
                            isReady: true
                        };


                        $scope.close = function() {
                            modalInstance.close();
                        };

                        $scope.report = function() {
                            $scope.viewState.isReady = false;
                            postAssetService.put('post/v1/report/' + scope.post.id, {}).then(function() {
                                $scope.viewState.isReady = true;
                                toastr.info($translate.instant('REPORTED_POST'))
                                modalInstance.close();
                            }, function() {
                                $scope.viewState.isReady = true;
                            });
                        }

                    },
                    size: 'sm'
                });
            }

            scope.reportComment = function(commentId) {

                var modalInstance = $uibModal.open({
                    animation: true,
                    backdropClass: 'backdrop-zindexed',
                    templateUrl: 'app/base/directives/postAsset.confirmReportCommentModal.directive.html',
                    controller: function($scope) {
                        $scope.viewState = {
                            isReady: true
                        };


                        $scope.close = function() {
                            modalInstance.close();
                        };

                        $scope.report = function() {
                            $scope.viewState.isReady = false;
                            postAssetService.put('post/v1/report/comment/' + commentId, {}).then(function() {
                                $scope.viewState.isReady = true;
                                toastr.info($translate.instant('REPORTED_COMMENT'))
                                modalInstance.close();
                            }, function(error) {
                                //console.log(error);
                                $scope.viewState.isReady = true;
                            });
                        }

                    },
                    size: 'sm'
                });
            }

            scope.followPost = function(callapi) {
                if (!scope.post.isFollowed) {
                    scope.post.isFollowed = true;

                    if (callapi)
                        postAssetService.get('follow/v1/add/' + scope.post.id + '/follow/POST/' + $rootScope.active_school.id, {}).then(function(res) {

                        }, function() {});
                } else {
                    scope.post.isFollowed = false;

                    if (callapi)
                        postAssetService.delete('follow/v1/remove/' + scope.post.id + '/follow/POST/' + $rootScope.active_school.id, {}).then(function(res) {

                        }, function() {});
                }
            }

            scope.getMoreComments = function(post) {
                post.hideMoreComm = true;

                postAssetService.get('post/v1/comment/' + scope.post.id, {}).then(function(response) {
                    scope.post.comments = [];

                    var cmmnts = response.data.payload.comments;
                    _.each(cmmnts, function(item) {
                        item.body = $rootScope.parseTagsToLinks(item.body);
                        item.body = $rootScope.parseMentionTags(item.body);
                        _.each(item.replies, function(reply) {
                            reply.body = $rootScope.parseTagsToLinks(reply.body);
                            reply.body = $rootScope.parseMentionTags(reply.body);
                        });
                    });

                    scope.post.comments = cmmnts;
                }, function(error) {
                    console.log(error);
                })
            }

            scope.getMoreReplies = function(comment) {
                //post.hideMoreComm = true;

                postAssetService.get('post/v1/commentReplies/' + comment.id, {}).then(function(response) {
                    comment.replies = [];

                    var cmmnts = response.data.payload.comments;
                    _.each(cmmnts, function(item) {
                        item.body = $rootScope.parseTagsToLinks(item.body);
                        item.body = $rootScope.parseMentionTags(item.body);
                    });

                    comment.replies = cmmnts;
                }, function(error) {
                    console.log(error);
                })
            }

            scope.isCommentLinkVisible = function() {
                var totalNumReached = false;
                if (scope.post) {
                    if (scope.post.comments) {
                        totalNumReached = scope.post.comments.length === scope.post.commentCount;
                    }
                }
                return scope.post.commentCount > 2 && !totalNumReached && scope.postContext !== 'GROUP_LIST_VIEW';
            }

            scope.deleteComment = function(commentId) {
                _.each(scope.post.comments, function(item, i) {
                    if (item && item.id === commentId) {
                        scope.post.comments.splice(i, 1);
                        scope.post.commentCount--;
                        return;
                    }
                });
                postAssetService.delete('post/v1/comment/' + scope.post.id + '/delete/' + commentId, {}).then(function(response) {
                    toastr.info($translate.instant('COMMENT_DELETED'));

                }, function(error) {

                })
            }

            scope.deleteReplyComment = function(commentId, replyId) {
                _.each(scope.post.comments, function(item, i) {
                    if (item && item.id === commentId) {
                        _.each(item.replies, function(itemReplies, j) {
                            if (itemReplies && itemReplies.id === replyId) {
                                item.replies.splice(j, 1);
                                item.totalReplyCount--;
                                return;
                            }
                        });
                    }
                });

                postAssetService.delete('post/v1/comment/' + scope.post.id + '/delete/' + replyId, {}).then(function(response) {
                    toastr.info($translate.instant('COMMENT_DELETED'));

                }, function(error) {

                })
            }

            scope.replyComment = function(comment,mentionUserId,mentionUserName,draft,repliedCommentId) {
                if(!comment) return;
                var parent = document.getElementById("cmt_"+comment.id);

                var composer = document.getElementById("reply_"+comment.id);
                if(composer){
                    //if composer already defined..
                    //remove it
                    angular.element(composer).remove();
                }
                var elementHtml = "";
                if(!draft) {
                    if(mentionUserId && mentionUserName){
                        elementHtml = '<div id="reply_'+comment.id+'" class="vi-col-middle" style="width:90%; float: right; margin-right: 15px;"><div class="comment-composer"><comment-composer post-id="'+scope.post.id+'" reply-to-user-id="'+mentionUserId+'" reply-to-user-name="'+mentionUserName+'" comment-id="'+comment.id+'" user-avatar="userAvatar" events="events"></comment-composer></div></div>';
                    } else {
                        elementHtml = '<div id="reply_'+comment.id+'" class="vi-col-middle" style="width:90%; float: right; margin-right: 15px;"><div class="comment-composer"><comment-composer post-id="'+scope.post.id+'" comment-id="'+comment.id+'" user-avatar="userAvatar" events="events"></comment-composer></div></div>';
                    }
                } else {
                    elementHtml = '<div id="reply_'+comment.id+'" class="vi-col-middle" style="width:90%; float: right; margin-right: 15px;"><div class="comment-composer"><comment-composer post-id="'+scope.post.id+'" comment-id="'+comment.id+'" draft-comment="draftReply" user-avatar="userAvatar" events="events"></comment-composer></div></div>';
                }
                if(repliedCommentId){
                    scope.events.repliedCommentId = repliedCommentId
                    scope.events.repliedUserId = mentionUserId
                }else{
                    scope.events.isMainReply = true
                    scope.events.repliedCommentId = comment.id
                    scope.events.repliedUserId = comment.userId
                }
              
                //directive is ready to compile
                var el = $compile( elementHtml )( scope );
                angular.element(parent).append(el);
            }

            /*
            scope.buyNow = function() {
                if (!$stateParams.id)
                    return;

                scope.stripeSubmit({ id: $stateParams.id })
            }*/

            scope.events = {
                commentCallback: function(comment) {
                    if (!scope.post.comments) {
                        scope.post.comments = [];
                    }
                    comment.avatar = $rootScope.active_user.avatar;
                    comment.postedBy = $rootScope.active_user.firstName + ' ' + $rootScope.active_user.lastName;
                    comment.body = $rootScope.parseTagsToLinks(comment.body);
                    comment.body = $rootScope.parseMentionTags(comment.body);
                    scope.post.comments.push(comment);
                    scope.post.commentCount++;

                    scope.updateComments({ post: scope.post })
                    
                    if (!scope.post.isFollowed)
                        scope.followPost()
                },
                commentReplyCallback: function(comment, parentCommentId) {
                
                    comment.avatar = $rootScope.active_user.avatar;
                    comment.postedBy = $rootScope.active_user.firstName + ' ' + $rootScope.active_user.lastName;
                    comment.body = $rootScope.parseTagsToLinks(comment.body);
                    comment.body = $rootScope.parseMentionTags(comment.body);
                    _.each(scope.post.comments, function(item, i) {
                        if(item.id == parentCommentId){
                            if(!item.replies){
                                item.replies = [];
                                item.totalReplyCount = 0;
                            }
                            item.replies.push(comment);
                            item.totalReplyCount++;
                            item.replying = false;
                        }
                        
                    });
                    
                    if (!scope.post.isFollowed){
                        scope.followPost();
                    }

                    //hide reply section
                    document.getElementById('reply_'+parentCommentId).remove();
                }


            }
            scope.groups = $rootScope.active_user.groups;
        }
    }

})();
(function () {

	'use strict';

	/**
	 * @ngdoc directive
	 * @name avatar:avatar
	 * @description
	 * <ul>
	 * <li>Display a post nugget with avatar, likes, comments etc...</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */

	angular.module('directives.postAdv', []).factory('postAdvService', ['base', function (base) {
		return _.create(base, { });
	}]).directive('postAdv', postAdv);
	/** @ngInject */
	function postAdv(postAdvService, toastr, $translate, regexes, $sce, $uibModal){
		var directive = {
			restrict: 'EA',
			replace: true,
			scope:{
				postContent: '@',
				postContext:'@',
				title:'=',
				artwork: '=',
				body: '=',
				logo: '=',
				link: '=',
				domain: '=',
				linkName: '='
			},
			templateUrl:'app/base/directives/postAdv.directive.html',
			link:linkFunction
		};
		return directive;

		function linkFunction(scope, elem, attrs) {
			scope.context = scope.postContext;
		}
	}

})();

(function () {
	/**
	 * @ngdoc directive
	 * @name prefix:prefix
	 * @description
	 * <ul>
	 * <li>Opens a modal with dropzone directive in it</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */

	angular.module('directives.photoUpload', []).directive('photoUpload', photoUpload);
	/** @ngInject */
	function photoUpload($uibModal, $timeout) {

		var directive = {
			restrict: 'EA',
			replace: true,
			scope:{
				ngModel: '='
			},
			link:linkFunction
		}

		return directive;
		
		function linkFunction(scope, elem, attrs) {

			scope.$on('UPLOAD_PHOTO', function(event, args) {
				function init() {
					var modalInstance = $uibModal.open({
						animation: true,
						backdropClass: 'backdrop-zindexed',
						backdrop:'static',
						templateUrl:'app/base/directives/photoUpload.directive.html',
						controller: function($scope) {
							
							$scope.$root.nativeCamPerm();

							$scope.saveDisabled = true;
							$scope.showChoose = true;
						
							var translations = {
								'avatarUpload':{
									'title':'UPLOAD_PHOTO_TITLE',
									'help':'PHOTO_UPLOAD_HELPER'
								},
								'postUpload':{
									'title':'UPLOAD_A_POST_PHOTO_TITLE',
									'help':'UPLOAD_A_POST_PHOTO_HELP'
								},
								'listingUpload':{
									'title':'UPLOAD_A_LISTING_PHOTO_TITLE',
									'help':'UPLOAD_A_LISTING_PHOTO_HELP'
								},
								'eventUpload':{
									'title':'UPLOAD_A_EVENT_PHOTO_TITLE',
									'help':'UPLOAD_A_EVENT_PHOTO_HELP'
								},
								'groupUpload':{
									'title':'UPLOAD_A_GROUP_PHOTO_TITLE',
									'help':'UPLOAD_A_GROUP_PHOTO_HELP',
									'tips':'UPLOAD_A_GROUP_PHOTO_TIPS'
								}
							}
							
							$scope.translations = translations[args.action];
							$scope.error = '';

							$scope.events = {
								args:args,
								save:'',
								chooseAgain:'',
								cropPicture:'',
								hideChoose: function() {
									$scope.showChoose = false;
								},
								handleError:function(err) {
									$scope.error = err
								},
								rotate:'',
								close:function () {
									modalInstance.close()
								},
								enableButton: function() {
									$timeout(function(){
										$scope.saveDisabled = false
									},0)
								},
								disableButton: function() {
									$timeout(function() {
										$scope.saveDisabled = true
									},0)
								},
								resetErrorMessage: function() {
									$scope.error = '';
								}
							};

							$scope.save = function() {
								$scope.saveDisabled = true;
								
								$timeout(function() {
									$scope.events.save();
								},100)
							};

							$scope.rotate = function () {
								$scope.events.rotate()
							};

							$scope.chooseAgain = function() {
								modalInstance.close();
								init();
							}

							$scope.close = function() {
								if($scope.events.args.on_close)
									$scope.events.args.on_close();
								modalInstance.close();
							};
						},
						size: 'md'
					})
				}

				init();
			})
		}
	}

})();

(function () {

	'use strict';

	/**
	 * @ngdoc directive
	 * @name prefix:prefix
	 * @description
	 * <ul>
	 * <li>touch events</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */

	angular.module('directives.ngTouchstart', []).directive('ngTouchstart', ngTouchstart);
	/** @ngInject */

	function ngTouchstart(){
		return function(scope, element, attr) {
			element.on('touchstart', function(event) {
				scope.$apply(function() { 
					scope.$eval(attr.ngTouchstart); 
				});
			});
		};
	}

})();

(function () {

	'use strict';

	/**
	 * @ngdoc directive
	 * @name prefix:prefix
	 * @description
	 * <ul>
	 * <li>touch events</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */

	angular.module('directives.ngTouchend', []).directive('ngTouchend', ngTouchend);
	/** @ngInject */

	function ngTouchend(){
		return function(scope, element, attr) {
			element.on('touchend', function(event) {
				scope.$apply(function() { 
					scope.$eval(attr.ngTouchend); 
				});
			});
		};
	}

})();

(function () {

	'use strict';
	/**
	 * @ngdoc directive
	 * @name prefix:prefix
	 * @description
	 * <ul>
	 * <li>Displays list of months</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */
	angular.module('directives.months', []).directive('months', months);
	/** @ngInject */
	function months(base, $http) {
		var directive = {
			restrict: 'EA',
			replace: true,
			scope:{
				ngModel: '='
			},
			template: [
				'<select class="form-control" ng-required="isRequired">',
				'<option ng-repeat="m in months" value="{{::m.id}}">{{::m.longName}}</option>',
				'</select>'
			].join(''),
			link: linkFunction
		}
		return directive;

		function linkFunction(scope, elem, attrs) {
			scope.months = [];
			scope.isRequired=scope.$eval(attrs.isRequired);

			$http.get('i8n/locale-metadata-en-GB.json?v=12').then(function(data) {
				scope.months = data.data.metadata.months;
			});
		}
	}

})();

(function () {

    'use strict';
    angular.module('directives.mentionsuggestor', []).factory('networkService', ['base', function (base) {
        return _.create(base, {});
    }]).directive('mentionsuggestor', mentionsuggestor);
    /** @ngInject */
    function mentionsuggestor($rootScope, networkService,$compile) {

        var directive = {
            restrict: 'EA',
            replace: true,
            scope: {
                mention: "@",
                placeholder: '@',
                draftbody: '@',
                commentbody: "&",
                replyto: '@',
                postid:'@',
                type:'@'
            },
            templateUrl: 'app/base/directives/mentionsuggestor.directive.html',
            link: linkFunction
        };

        return directive;

        function linkFunction(scope, elem, attrs) {
            if (!$rootScope.contacts_list) {
                $rootScope.loadContactsStorage();
            }
            scope.htmlContent = '';
            scope.hint = "Write here...";
            
            scope.filteredPeople = [];
            

            scope.itemId = "cl-editor-" + scope.postid + new Date().getTime();
            scope.baseURL = "https://storage.googleapis.com/class-list-api-europe/"
            
            
            scope.editor = null;
            var editorElement;
            
            angular.element(document).ready(function () {
                
                if(scope.placeholder && !scope.replyto){
                    scope.hint = scope.placeholder;
                }
                
                if(scope.replyto){
                    scope.hint='';
                 //   scope.htmlContent = scope.replyto+'&nbsp;';
                }

                //document ready...
                editorElement = document.getElementById(scope.itemId);
                scope.editor = angular.element(editorElement);
                if(editorElement){
                    if(scope.replyto){
                        scope.hint='';
                        scope.editor.html(scope.replyto+'&nbsp;');
                    }

                    editorElement.addEventListener("paste", function (e) {
                        // cancel paste
                        e.preventDefault();

                        // get text representation of clipboard
                        var text = (e.originalEvent || e).clipboardData.getData('text/plain');

                        // insert text manually
                        text = text.replace(/\n/g, '<br>');
                        document.execCommand("insertHTML", false, text);
                        scope.keyup({keyCode: 1});
                    });

                    //cleanup the hint
                    editorElement.addEventListener("keypress", function (e) {
                        if (scope.hint == scope.placeholder) {
                            scope.hint = '';
                        }
                        editorElement.removeEventListener("keypress",null);
                    });

                    editorElement.addEventListener("focus", function (e) {
                        setEndOfContenteditable(editorElement);
                        editorElement.removeEventListener("focus",null);
                    });
                   
                    //if this is reply editor, so focus it direclty
                    if(angular.lowercase(scope.hint).includes('reply') || scope.replyto){
                        setTimeout(function() {
                            editorElement.focus();
                        }, 200);
                        //scope.onFocus();
                    }
                }
            
                scope.$watch('draftbody', function(newVal, oldVal){
                    scope.draftbody = attrs.draftbody;
                    if(scope.draftbody && scope.draftbody !== '') {
                        scope.hint = '';
                        scope.editor.html(scope.draftbody);
                    }
                });
            });
            
            scope.isSearchOn = function(){
                var result = false;
                if(scope.editor){
                    var selectedElement = getSelectionElement();
                    
                    var caretPos = getCaretPosition(editorElement);

                    //get html tags cleaned text
                    var currentText = scope.editor.text();// currentHTML.replace('<span id="peopleListAnchor"></span>','').replace("&nbsp;"," ");

                    // split using a regex as we get non space whitespace characters in the data. This solves the two mentions issue
                    var pieces = currentText.split('@');
                    if(pieces.length > 1){
                        var term;
                        var people = [];
                        var pObjects = [];
                        var index = 0;

                        for(var i=0; i < pieces.length; i++){
                            var pObject = {};
                            pObject.value = pieces[i];
                            pObject.sIndex = index;
                            pObject.eIndex = index + pieces[i].length;
                            
                            index = pObject.eIndex;
                            index++;
                            
                            pObjects.push(pObject);
                        }

                        //start from first one.. not from the zero index
                        var ci = pieces[0].length;
                        for(var i=1; i < pieces.length; i++){
                            var pObj = pieces[i];
                            
                            //find the difference
                            var n = (caretPos-1) - ci;
                            
                            //increase the current index
                            ci += pieces.length;

                            //get term
                            term = pObj.substring(0,n);
                            
                            people = scope.searchSimplePeople(term);
                            //we found what we are looking for...
                            if(people && people.length > 0){
                                break;
                            }   
                        }
                    }

                    //if we find something....
                    if(people && people.length > 0){
                        //set anchor
                        if(!document.getElementById("peopleListAnchor")){
                            selectedElement.innerHTML = selectedElement.innerHTML.replace("@"+term,"<span id=\"peopleListAnchor\"></span>"+"@"+term);
                            setCurrentCursorPosition(editorElement,caretPos);
                        }

                        result = true;
                        
                        //generate people list 
                        var domObject = scope.generateSearchList(people,term);
                        //get people list
                        var pList = document.getElementById('peopleList');
                        if(pList){
                            //if already is in the page, remove it
                            angular.element(pList).remove();
                            //set last position
                            domObject.style.top = pList.style.top;
                            domObject.style.left = pList.style.left;
                        }

                        if(domObject){
                            //convert it to angular object
                            var el = $compile( domObject )( scope );
                            //add people list object to document body... we do remove this on destroy...
                            angular.element(document.body).append(el);
                            //set position of search list on first time...
                            scope.setPositionOfSearchList(domObject);
                        }
                    }
                    
                }
                
                if(!result){
                    //if there is no result, remove the search list
                    scope.removeSearchList();
                }

                convertAndCallback(scope.editor.html());

                return result;   
            }

            scope.removeSearchList = function(){
                var pList = document.getElementById('peopleList');
                if(pList){
                    document.body.removeChild(pList);
                    //remove the anchor
                    var anchor = document.getElementById('peopleListAnchor');
                    if(anchor){
                        anchor.remove();
                    }
                } 
            }

            scope.setPositionOfSearchList = function(domObject){
                    var editorWidth = editorElement.getBoundingClientRect().width;
                    var editorLeft = editorElement.getBoundingClientRect().left;
                    
                    //add span object to get cursor position
                    var lastChild = editorElement.lastChild;
                    var spn = document.getElementById('peopleListAnchor');
                    if(!spn){
                        spn = document.createElement('span');
                        spn.id = "peopleListAnchor";
                        if(lastChild && lastChild.tagName && lastChild.tagName.toUpperCase() == 'DIV'){
                            lastChild.appendChild(spn);
                        } else {
                            editorElement.appendChild(spn);
                        }
                    }
                    
                    //cursor positions
                    var offsetTop = spn.getBoundingClientRect().top + window.scrollY;
                    var offsetLeft = spn.getBoundingClientRect().left + window.scrollX;
                    
                    var peopleListMinWidth = domObject.getBoundingClientRect().width;

                    if(((offsetLeft - editorLeft) + peopleListMinWidth) > editorWidth){
                        var l =  ((offsetLeft - editorLeft) + peopleListMinWidth) - editorWidth;
                        offsetLeft = offsetLeft - l;
                        
                    } else {
                        domObject.style.left = offsetLeft+'px';
                    }
                    
                    domObject.style.left = offsetLeft+'px';
                    domObject.style.top = (offsetTop+20)+'px';
            }

            function convertAndCallback(htmlContenter) {
                var bodyWithTags = $rootScope.parseLinksToTags(htmlContenter);
                scope.commentbody({
                    bodyWithTags: bodyWithTags,
                    draft: htmlContenter
                });
            }

            scope.activeUserinList = -1;
            scope.keydown = function($event) {
                if(($event.keyCode == 40 || $event.keyCode == 38 || $event.keyCode == 13)){
                    //handle enter, up, down keys
                    scope.handleSpecialCharsOnEditor($event);
                }
            }

            scope.keyup = function($event) {
                //scope.htmlContent = editor.html();
                if(!scope.editor || !scope.editor.text()) return;
                
                var currentContent = scope.editor.text().trim();
                if (editorElement.children.length === 0) {
                    var div = document.createElement("div");
                    div.innerText = currentContent;
                    scope.editor.html('')
                    editorElement.appendChild(div);
                    setEndOfContenteditable(editorElement)
                }
                if (scope.hint == scope.placeholder) {
                    scope.hint = '';
                }

                if(!currentContent || currentContent.length == 0){
                    scope.hint = scope.placeholder;
                } else {
                    scope.hint = '';
                }

                //generates the people list
                if(!($event.keyCode == 40 || $event.keyCode == 38 || $event.keyCode == 13)){
                    scope.isSearchOn();
                }   
                         
            };

            scope.handleSpecialCharsOnEditor = function ($event) {
                if(($event.keyCode == 40 || $event.keyCode == 38 || $event.keyCode == 13)){
                    var peopleList = document.getElementById('peopleList');
                    if(peopleList){
                        var list = peopleList.getElementsByTagName('LI');
                        if(list && list.length > 0){
                            // Check for a enter
                            if($event.keyCode == 13){
                                //13 is enter
                                var person = scope.simplePeople[scope.activeUserinList];
                                scope.mentionSelected($event,person.id,person.fN,person.lN, document.getElementById("mentionListItem"+person.id).getAttribute('term'));
                                
                            } else {
                                //40 is keydown, 38 is keyup
                                //we should move in to list
                                var inc = ($event.keyCode == 40)?1:-1;
    
                                //clean old active
                                if(scope.activeUserinList > -1){
                                    list[scope.activeUserinList].classList.remove("active");
                                }
    
                                //find next active item
                                scope.activeUserinList += inc;
    
                                if(scope.activeUserinList < 0){
                                    scope.activeUserinList = list.length -1; //last item selected
                                } else if (scope.activeUserinList > list.length -1){
                                    scope.activeUserinList = 0; //first item selected
                                }
                                
                                list[scope.activeUserinList].focus();
                                list[scope.activeUserinList].classList.add("active");
                            }
    
                            setEndOfContenteditable(editorElement);
                            $event.preventDefault();
                            return false;
                        }
                    }
                } 
            }

            scope.searchSimplePeople = function (term) {
                 
                if (!$rootScope.contacts_list)
                    return;
                scope.simplePeople = [];

                if(term == ' ' || term == ''){
                    return scope.simplePeople;
                }

                var terms = term.split('');
                for(var i=0; i < terms.length; i++){
                    if(terms[i].trim() == ''){
                        terms[i]="_";
                    }
                }
                term = terms.join('');

                scope.baseURL = $rootScope.contacts_list.baseUrl;

                for(var i=0 ;$rootScope.contacts_list.parents.length > i; i++){
                    var item = $rootScope.contacts_list.parents[i];
                    var fullName = (item.fN+" "+item.lN).replace(" ","_");
                    var firstName = item.fN.replace(" ","_");
                    var lastName = item.lN.replace(" ","_");
                    

                    var l = fullName.toUpperCase().indexOf(term.toUpperCase()) == 0;
                    var m = firstName.toUpperCase().indexOf(term.toUpperCase()) == 0;
                    var n = lastName.toUpperCase().indexOf(term.toUpperCase()) == 0;
                    var o = ((firstName.toUpperCase().indexOf(term.toUpperCase()) >= 0 || lastName.toUpperCase().indexOf(term.toUpperCase()) >= 0) && !scope.simplePeople.includes(item));

                    if(l || m || n || o){
                        scope.simplePeople.push(item);
                    }
                    if(scope.simplePeople.length > 4){
                        break;
                    }
                }
                return scope.simplePeople;
            };

            scope.$on(
                "$destroy",
                function handleDestroyEvent() {
                    //cleanup on directive destroy...
                    scope.simplePeople = [];
                    scope.removeSearchList();

                }
            );

            scope.generateSearchList = function(people,term){
                if(people && people.length > 0){
                    var listDOM = document.createElement('ul');
                    listDOM.className = "list-group user-search";
                    listDOM.id = "peopleList";
                    listDOM.style.position = 'absolute';
                    listDOM.style.zIndex = '15000';
                    listDOM.style.minWidth = '100px';
                    for(var i=0; i< people.length;i++){
                        listDOM.appendChild(scope.generateSearchListItem(people[i],term));
                    }
                    return listDOM;
                }
                return null;
            }

            scope.generateSearchListItem = function(person,term){
                var item = document.createElement('li');
                item.className = "list-group-item";
                item.id = "mentionListItem"+person.id;
                item.setAttribute("ng-click","mentionSelected($event,"+person.id+",'"+person.fN+"','"+person.lN+"','"+term+"')");
                item.setAttribute("term",term);
            
                var figure = document.createElement('div');
                figure.style.width = "40px";
                figure.style.height = "40px";
                figure.style.float = 'left';
                
                var avatar = document.createElement('avatar');
                avatar.setAttribute("source", person.a);
                avatar.setAttribute("name",person.fN + " "+person.lN);
                
                figure.appendChild(avatar);
                item.appendChild(figure);

                var name = document.createElement('div');
                name.className = "text-primary";
                name.innerHTML = person.fN + ' ' + person.lN;
                name.style.float = 'left';
                name.style.paddingTop = '10px';
                name.style.paddingLeft = '5px';
                item.appendChild(name);

                var clear = document.createElement('div');
                clear.style.clear = 'both';
                item.appendChild(clear);
                return item;
            }

            scope.mentionSelected = function($event,id,fn,ln,term){
                var currentContent = scope.editor.html();
                term = '@'+term;
                var newValue = " <a rel='userid' contenteditable='false'  alt='" + id + "' class='mentionLink'>" + (fn + ' ' + ln) + "</a>&nbsp;";  
                
                var anchor = document.getElementById('peopleListAnchor');
                if(anchor){
                    currentContent = currentContent.replace(anchor.outerHTML+term,newValue);
                }

                scope.editor.html(currentContent);

                scope.removeSearchList();

                //set cursor place  the end of the content
                setEndOfContenteditable(editorElement);
                
                //set list not selected again
                scope.activeUserinList = -1;

                convertAndCallback(scope.editor.html());
            }

            scope.onFocus = function () {
                var currentContent = scope.editor.text();
                if (scope.hint == scope.placeholder) {
                    scope.hint = '';
                }

                if(!currentContent || currentContent.length == 0){
                    scope.hint = scope.placeholder;
                } else {
                    scope.hint = '';
                }
            }

            scope.onBlur = function () {
                var currentContent = scope.editor.text();
                if (scope.editor.html() == '' || scope.editor.html() == "<br>") {
                    scope.hint = scope.placeholder;
                    scope.editor.html('');
                }

                if(!currentContent || currentContent.length == 0){
                    scope.hint = scope.placeholder;
                } else {
                    scope.hint = '';
                }
            }

            $rootScope.$on('removeInput', function (event, data) {
                scope.editor.html('');
                //scope.htmlContent = '';
                scope.hint = scope.placeholder;
            });

            //helper functions
            function createRange(node, chars, range) {
                if (!range) {
                    range = document.createRange()
                    range.selectNode(node);
                    range.setStart(node, 0);
                }
            
                if (chars.count === 0) {
                    range.setEnd(node, chars.count);
                } else if (node && chars.count >0) {
                    if (node.nodeType === Node.TEXT_NODE) {
                        if (node.textContent.length < chars.count) {
                            chars.count -= node.textContent.length;
                        } else {
                             range.setEnd(node, chars.count);
                             chars.count = 0;
                        }
                    } else {
                        for (var lp = 0; lp < node.childNodes.length; lp++) {
                            range = createRange(node.childNodes[lp], chars, range);
            
                            if (chars.count === 0) {
                               break;
                            }
                        }
                    }
               } 
            
               return range;
            }
            
            function setCurrentCursorPosition(element,chars) {
                if (chars >= 0) {
                    var selection = window.getSelection();
            
                    var range = createRange(element, { count: chars });
            
                    if (range) {
                        range.collapse(false);
                        selection.removeAllRanges();
                        selection.addRange(range);
                    }
                }
            }


            function setEndOfContenteditable(contentEditableElement){
                var range,selection;
                if(document.createRange)//Firefox, Chrome, Opera, Safari, IE 9+
                {
                    range = document.createRange();//Create a range (a range is a like the selection but invisible)
                    range.selectNodeContents(contentEditableElement);//Select the entire contents of the element with the range
                    range.collapse(false);//collapse the range to the end point. false means collapse to end rather than the start
                    selection = window.getSelection();//get the selection object (allows you to change selection)
                    selection.removeAllRanges();//remove any selections already made
                    selection.addRange(range);//make the range you have just created the visible selection
                }
                else if(document.selection)//IE 8 and lower
                {
                    range = document.body.createTextRange();//Create a range (a range is a like the selection but invisible)
                    range.moveToElementText(contentEditableElement);//Select the entire contents of the element with the range
                    range.collapse(false);//collapse the range to the end point. false means collapse to end rather than the start
                    range.select();//Select the range (make it the visible selection
                }
            }

            function getSelectionElement(){ 
                var selection = window.getSelection();  
                var container = selection.anchorNode; 
             
                if( container.nodeType !== 3 ){ 
                    return container; 
                } 
                else{ 
                    // return parent if text node 
                    return container.parentNode 
                } 
            } 

            function getCaretPosition(element) {
                var caretOffset = 0;
                var doc = element.ownerDocument || element.document;
                var win = doc.defaultView || doc.parentWindow;
                var sel;
                if (typeof win.getSelection != "undefined") {
                    sel = win.getSelection();
                    if (sel.rangeCount > 0) {
                        var range = win.getSelection().getRangeAt(0);
                        var preCaretRange = range.cloneRange();
                        preCaretRange.selectNodeContents(element);
                        preCaretRange.setEnd(range.endContainer, range.endOffset);
                        caretOffset = preCaretRange.toString().length;
                    }
                } else if ( (sel = doc.selection) && sel.type != "Control") {
                    var textRange = sel.createRange();
                    var preCaretTextRange = doc.body.createTextRange();
                    preCaretTextRange.moveToElementText(element);
                    preCaretTextRange.setEndPoint("EndToEnd", textRange);
                    caretOffset = preCaretTextRange.text.length;
                }
                return caretOffset;
            }
        }
    }
})();






(function () {

	'use strict';
	/**
	* @ngdoc directive
	* @name loader:loader
	* @description
	* <ul>
	* <li>Watches for $http.pendingRequests and displays / hides a loader</li>
	* <li>Flushes all notifications from the previous request</li>
	* </ul>
	* @restrict E
	* @element
	*/
	angular.module('directives.loader', []).directive('loader', loader);
	/** @ngInject */
	function loader($http, $rootScope, base, $state) {
		var directive =  {
			restrict: 'E',
			replace: true,
			template: '<div class="loader">'
						+ '<div class="load-bar loading"></div>'
					+ '</div>',
			link: linkFunction
		};
		return directive;

		function linkFunction(scope, elem, attrs) {
			scope.$watch(function () {
				return $http.pendingRequests.length > 0;
			},	function (hasPending) {

				var currentState = $state.current.name,
					noHeaderClass = '',
					shortHeaderClass = '';

				if(hasPending && $rootScope.loader) {
					if(!$rootScope.isinitialised){
						$rootScope.isinitialised = true;
					}
					else{ 
						angular.element(document.querySelector('.load-bar')).addClass('loading');
						angular.element(document.querySelector('.load-bar')).addClass(noHeaderClass);
						angular.element(document.querySelector('.load-bar')).addClass(shortHeaderClass);
					}					
					base.flushAll();
				}
				else {
					angular.element(document.querySelector('.load-bar')).removeClass('loading');
					angular.element(document.querySelector('.load-bar')).removeClass(noHeaderClass);
					angular.element(document.querySelector('.load-bar')).removeClass(shortHeaderClass);
				}
			});
		}
	}

})();

(function () {

	'use strict';
	angular.module('directives.linkpreview', []).factory('networkService' ['base', '$sce',function (base) {
		return _.create(base,$sce, { });
	}]).directive('linkpreview', linkpreview);
	/** @ngInject */
	function linkpreview($rootScope, networkService, $sce) {

		var directive =  {
			restrict: 'EA',
			replace: true,
			scope:{
                url:"@",
                onSuccess:"&"
			},
			templateUrl:'app/base/directives/linkpreview.directive.html',
			link: linkFunction
		};

        return directive;
        
		function linkFunction(scope, elem, attrs) {
            scope.preview = {
                title: "",
                description: "",
                image: "",
                domain: "",
                link: "",
                youtube:""
            }

            scope.openLink = function(link) {

                if(getMobileOperatingSystem() === 'iOS' && $rootScope.isNative) {
                    location.href = link
                }
                else {
                    window.open(link, "_blank");
                }
            }

            scope.trustSrc = function(src) {
                return $sce.trustAsResourceUrl(src);
            }

            scope.$watch('url',function() {
                if (!scope.url || scope.url === ''){
                    return;
                }
                networkService.get('generator/preview?url=' + encodeURIComponent(scope.url)).then(function(response) {
                    
                    if (!response || !response.data || !response.data.url || !response.data.title || response.data.title === '') {
                        scope.onSuccess({
                            url: ""
                        });
                        return;
                    }

                    scope.preview = {
                        title: response.data.title,
                        description: response.data.description,
                        image: response.data.image,
                        domain: response.data.domain,
                        link: response.data.url,
                        youtube: response.data.youtube
                    }

                    //Call onPreviewSuccess callback.
                    scope.onSuccess({
                        url: response.data.url
                    });
                }, 
                function(error){
                })
            })   
		}
	}

})();

(function () {

	!function(a){var b=/iPhone/i,c=/iPod/i,d=/iPad/i,e=/(?=.*\bAndroid\b)(?=.*\bMobile\b)/i,f=/Android/i,g=/(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,h=/(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,i=/IEMobile/i,j=/(?=.*\bWindows\b)(?=.*\bARM\b)/i,k=/BlackBerry/i,l=/BB10/i,m=/Opera Mini/i,n=/(CriOS|Chrome)(?=.*\bMobile\b)/i,o=/(?=.*\bFirefox\b)(?=.*\bMobile\b)/i,p=new RegExp("(?:Nexus 7|BNTV250|Kindle Fire|Silk|GT-P1000)","i"),q=function(a,b){return a.test(b)},r=function(a){var r=a||navigator.userAgent,s=r.split("[FBAN");return"undefined"!==typeof s[1]&&(r=s[0]),s=r.split("Twitter"),"undefined"!==typeof s[1]&&(r=s[0]),this.apple={phone:q(b,r),ipod:q(c,r),tablet:!q(b,r)&&q(d,r),device:q(b,r)||q(c,r)||q(d,r)},this.amazon={phone:q(g,r),tablet:!q(g,r)&&q(h,r),device:q(g,r)||q(h,r)},this.android={phone:q(g,r)||q(e,r),tablet:!q(g,r)&&!q(e,r)&&(q(h,r)||q(f,r)),device:q(g,r)||q(h,r)||q(e,r)||q(f,r)},this.windows={phone:q(i,r),tablet:q(j,r),device:q(i,r)||q(j,r)},this.other={blackberry:q(k,r),blackberry10:q(l,r),opera:q(m,r),firefox:q(o,r),chrome:q(n,r),device:q(k,r)||q(l,r)||q(m,r)||q(o,r)||q(n,r)},this.seven_inch=q(p,r),this.any=this.apple.device||this.android.device||this.windows.device||this.other.device||this.seven_inch,this.phone=this.apple.phone||this.android.phone||this.windows.phone,this.tablet=this.apple.tablet||this.android.tablet||this.windows.tablet,"undefined"===typeof window?this:void 0},s=function(){var a=new r;return a.Class=r,a};"undefined"!==typeof module&&module.exports&&"undefined"===typeof window?module.exports=r:"undefined"!==typeof module&&module.exports&&"undefined"!==typeof window?module.exports=s():"function"===typeof define&&define.amd?define("isMobile",[],a.isMobile=s()):a.isMobile=s()}(this);
	'use strict';
	/**
	 * @ngdoc directive
	 * @name featureDetection:featureDetection
	 * @description
	 * <ul>
	 * <li>Detects browser</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */
	angular.module('directives.linebreaksToHtml', ['ngSanitize']).directive('linebreaksToHtml', linebreaksToHtmlDirective);

function linebreaksToHtmlDirective($sce) {
  return {
    restrict: 'A',
    scope: {
      text: '=linebreaksToHtml'
    },
    link: function(scope, element) {
      scope.$watch('text', function(newText) {
        if (angular.isDefined(newText)) {
			var html = $sce.trustAsHtml(newText.replace(/\r?\n/g, '<br>'));
			element.html(html);
        }
      });
    }
  };
}

})();
(function () {

	'use strict';

	/**
	 * @ngdoc directive
	 * @name prefix:prefix
	 * @description
	 * <ul>
	 * <li>Displays a recursive list of tiers, with nested sub tiers</li>
	 * <li>Updates the model with selected tiers ID</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */

	angular.module('directives.googleMapsAutocomplete', []).factory('mapService', ['base', function (base) {
		return _.create(base, { });
		}]).directive('googleMapsAutocomplete', googleMapsAutocomplete);
	/** @ngInject */

	function googleMapsAutocomplete(base, $timeout, $translate, mapService){
		var directive = {
			restrict: 'E',
			replace: true,
			scope:{
				ngModel: '='
			},
			templateUrl:'app/base/directives/googleMapsAutocomplete.directive.html',
			link: linkFunction
		};
		return directive

		function linkFunction(scope, elem, attrs) {
			scope.isGettingaddresses = false;

			var pickedFromList = false;
			var placeId;

			scope.$on('SET_ADDRESS', function(e, value){
				scope.address = value;
			});

			scope.getResults = function(queryString){
				scope.isGettingaddresses = true;

				queryString = queryString.replace(/\//g, '&#47;');

				return base.get('shared/v1/places/autocomplete/'+queryString).then(function(response){
					scope.isGettingaddresses = false;

					var json = JSON.parse(response.data.payload.result);
					return json.predictions;

				}, function(error)	{
					scope.isGettingaddresses = false;
				});
			};

			scope.onFocusOut = function(){

				if (!_.isUndefined(scope.address)) {

					var addressResponse = {
						isRealAddress : angular.copy(pickedFromList),
						fullAddress : angular.copy(scope.address),
						locationId : angular.copy(placeId)
					}

					//return the data
					scope.ngModel = addressResponse;
				}
			}

			scope.onChanged = function(){
				pickedFromList = false;
				scope.onFocusOut();
			}

			scope.pickAddress = function(item){
				if (!_.isUndefined(item)) {
					scope.address = item.description;
					placeId = item.place_id;
					pickedFromList = true;
				}
			}
		}

	}
})();


(function () {

	'use strict';

	/**
	 * @ngdoc directive
	 * @name prefix:prefix
	 * @description
	 * <ul>
	 * <li>Needed for inbox compose / reply views to work</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */

	angular.module('directives.getHeight', []).directive('getHeight', getHeight);
	/** @ngInject */
	function getHeight($window, $timeout) {
		var directive = {
			restrict: 'A',
			link:linkFunction
		}
		return directive;

		function linkFunction(scope, elem, attrs) {
			var topHeader = document.getElementsByClassName('header-logged'),
				msgHeader = document.getElementsByClassName('messages-header') || angular.element('<div/>'),
				compose = document.getElementsByClassName('message-compose') || angular.element('<div/>'),
				composeBox = document.getElementsByClassName('composer') || angular.element('<div/>'),
				messages = document.getElementsByClassName('conversation-message-list') || angular.element('<div/>'),
				margin = 40,
				win = angular.element($window);

			function distribute() {
				try {
					var h = $window.innerHeight - angular.element(topHeader)[0].clientHeight - angular.element(msgHeader)[0].clientHeight - margin;
					var _compose = angular.element(compose);
					var _messages = angular.element(messages);
					var _composer = angular.element(composeBox);
					var _composerHeight = _composer[0].clientHeight;

					_compose.css('height',h+'px');
					_messages.css('height', h-_composerHeight-70+'px');
				}
				catch(e){
				//Skip for now.
				}
			}

			function stall(){
				$timeout(function(){
					distribute()
				},500)
			}
			stall();

			win.bind('resize', function(){
				distribute()
			})

			scope.$on('$destroy', function(){
				win.unbind('resize')
			})

			scope.$on('VIEW_CHANGED', function(evt, args){
				
			})

		}
	}

})();

(function () {

	'use strict';
	/**
	 * @ngdoc directive
	 * @name prefix:prefix
	 * @description
	 * <ul>
	 * <li>Displays list of genders</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */
	angular.module('directives.genders', []).directive('genders', genders);
	/** @ngInject */
	function genders(base, $http) {
		var directive = {
			restrict: 'EA',
			replace: true,
			scope:{
				ngModel: '='
			},
			template: [
				'<select class="form-control" ng-required="isRequired">',
				'<option ng-repeat="g in genders" value="{{::g.id}}">{{::g.longName}}</option>',
				'</select>'
			].join(''),
			link: linkFunction
		}
		return directive;

		function linkFunction(scope, elem, attrs) {
			scope.genders = [];
			scope.isRequired=scope.$eval(attrs.isRequired);

			$http.get('i8n/locale-metadata-en-GB.json?v=12').then(function(data) {
				scope.genders = data.data.metadata.genders;
			});
		}
	}

})();

(function () {
	/**
	 * @ngdoc directive
	 * @name prefix:prefix
	 * @description
	 * <ul>
	 * <li>Opens a modal with dropzone directive in it</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */

	angular.module('directives.galleryPicker', []).directive('galleryPicker', galleryPicker);
	/** @ngInject */
	function galleryPicker($uibModal, $timeout, settings) {

		var directive = {
			restrict: 'EA',
			replace: true,
			scope:{
				ngModel: '='
			},
			link:linkFunction
		}

		return directive;
		function linkFunction(scope, elem, attrs) {
			scope.$on('GALLERY_PICKER', function(event, args) {

				function init() {
					var modalInstance = $uibModal.open({
						animation: true,
						backdropClass: 'backdrop-zindexed',
						backdrop:'static',
						templateUrl:'app/base/directives/galleryPicker.directive.html',
						controller: function($scope) {
							$scope.$root.nativeCamPerm();
							
							$scope.def_gallery = settings.defaultGallery;

							$scope.add = function() {
								if(args.on_select)
									args.on_select($scope.selectedPic);
								
								modalInstance.close();
							};

							$scope.select = function(obj) {
								$scope.selectedPic = obj;
								$scope.add();
							}
							
							$scope.uploadImage = function() {
								if(args.on_upload)
									args.on_upload();
								modalInstance.close();
							}

							$scope.close = function() {
								modalInstance.close();
							};
						},
						size: 'md'
					})
				}

				init();
			})
		}
	}

})();

(function () {

	'use strict';

	/**
	 * @ngdoc directive
	 * @name focus:focus
	 * @description
	 * <ul>
	 * <li>Sets the focus ont the selected element</li>
	 * </ul>
	 * @restrict A
	 * @element
	 */

	angular.module('directives.focus', []).directive('focus', focus);
	/** @ngInject */
	function focus($timeout){
		var directive = {
			restrict: 'A',
			scope: {
				trigger : '@focus'
			},
			link:linkFunction
		};
		return directive;


		function linkFunction(scope, element) {
			scope.$watch('trigger', function(value) {
			if (value === "true") {
				$timeout(function() {
				element[0].focus();
				});
			}
			});
		}
	}

})();

(function () {

	!function(a){var b=/iPhone/i,c=/iPod/i,d=/iPad/i,e=/(?=.*\bAndroid\b)(?=.*\bMobile\b)/i,f=/Android/i,g=/(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,h=/(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,i=/IEMobile/i,j=/(?=.*\bWindows\b)(?=.*\bARM\b)/i,k=/BlackBerry/i,l=/BB10/i,m=/Opera Mini/i,n=/(CriOS|Chrome)(?=.*\bMobile\b)/i,o=/(?=.*\bFirefox\b)(?=.*\bMobile\b)/i,p=new RegExp("(?:Nexus 7|BNTV250|Kindle Fire|Silk|GT-P1000)","i"),q=function(a,b){return a.test(b)},r=function(a){var r=a||navigator.userAgent,s=r.split("[FBAN");return"undefined"!==typeof s[1]&&(r=s[0]),s=r.split("Twitter"),"undefined"!==typeof s[1]&&(r=s[0]),this.apple={phone:q(b,r),ipod:q(c,r),tablet:!q(b,r)&&q(d,r),device:q(b,r)||q(c,r)||q(d,r)},this.amazon={phone:q(g,r),tablet:!q(g,r)&&q(h,r),device:q(g,r)||q(h,r)},this.android={phone:q(g,r)||q(e,r),tablet:!q(g,r)&&!q(e,r)&&(q(h,r)||q(f,r)),device:q(g,r)||q(h,r)||q(e,r)||q(f,r)},this.windows={phone:q(i,r),tablet:q(j,r),device:q(i,r)||q(j,r)},this.other={blackberry:q(k,r),blackberry10:q(l,r),opera:q(m,r),firefox:q(o,r),chrome:q(n,r),device:q(k,r)||q(l,r)||q(m,r)||q(o,r)||q(n,r)},this.seven_inch=q(p,r),this.any=this.apple.device||this.android.device||this.windows.device||this.other.device||this.seven_inch,this.phone=this.apple.phone||this.android.phone||this.windows.phone,this.tablet=this.apple.tablet||this.android.tablet||this.windows.tablet,"undefined"===typeof window?this:void 0},s=function(){var a=new r;return a.Class=r,a};"undefined"!==typeof module&&module.exports&&"undefined"===typeof window?module.exports=r:"undefined"!==typeof module&&module.exports&&"undefined"!==typeof window?module.exports=s():"function"===typeof define&&define.amd?define("isMobile",[],a.isMobile=s()):a.isMobile=s()}(this);
	'use strict';
	/**
	 * @ngdoc directive
	 * @name featureDetection:featureDetection
	 * @description
	 * <ul>
	 * <li>Detects browser</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */
	angular.module('directives.featureDetection', []).directive('featureDetection', featureDetection);
	/** @ngInject */
	function featureDetection(base, $rootScope) {

		var directive =  {
			restrict: 'A',
			link: linkFunction
		};

		return directive;

		function linkFunction(scope, elem, attrs) {

			var ua = navigator.userAgent;

			if(ua.indexOf('Trident') > 0 ||
				ua.indexOf('MSIE') > 0 ||
				ua.indexOf('MSIE 9') > 0 ||
				ua.indexOf('MSIE 10') > 0 ||
				ua.indexOf('Edge') > 0)
			{
				elem.addClass('internetexplorer');
			}

			(isMobile.apple.phone || isMobile.apple.ipod || isMobile.apple.tablet || isMobile.apple.device) ? elem.addClass('apple') : '';
			(isMobile.apple.phone || isMobile.android.phone || isMobile.seven_inch) ? $rootScope.mobileInbox = true : $rootScope.mobileInbox = false;

		}
	}

})();

function iOS() {
	return [
	  'iPad Simulator',
	  'iPhone Simulator',
	  'iPod Simulator',
	  'iPad',
	  'iPhone',
	  'iPod'
	].includes(navigator.platform)
	// iPad on iOS 13 detection
	|| (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }
  
function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

	if(userAgent.includes('flutter-web-view')) {
		return "Flutter";
	}

      // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (iOS) {
        return "iOS";
    }

    return "unknown";
}

(function () {
    
    angular.module('directives.datepickerDirective', [ ])
    .directive('datepicker',function($document, $translate, $rootScope) {
        return {
            restrict:'E',
            replace: true,
            scope: {
                bigBanner: "=",
                minDate: "=",
                defaultOpen: "=",
                action: "=",
                timePicker: "=",
                defaultDate: "=ngModel",
                format: "@",
                headerTitle: "@",
                callback: "&onDateSelect"
            },
			templateUrl:'app/base/directives/datepicker.directive.html',
            link: function(scope, elem, attr) {
                setTimeout(function() {
                    var body = $document.find('body').eq(0);
                    body.append(elem);
                }, 500);

                $rootScope.$on("$locationChangeSuccess", function(e, currentLocation, previousLocation) {
                    scope.popover = false;
                });

                scope._action = scope.action || { };
                scope._action.open = function(options) {
                    if(scope.defaultDate)
                        scope.myDate = $rootScope.getUTCDatetime(scope.defaultDate);

                    if(scope.minDate)
                        scope.myDate = $rootScope.getUTCDatetime(new Date(scope.minDate));

                    scope.generateDays();
                    scope.popover = true;
                }
                
                scope.cal_days_labels = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
                scope.cal_full_days_lables = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
                scope.cal_months_labels = ['January', 'February', 'March', 'April',
                                'May', 'June', 'July', 'August', 'September',
                                'October', 'November', 'December'];
                scope.cal_months_labels_short = ['JAN', 'FEB', 'MAR', 'APR',
                                    'MAY', 'JUN', 'JUL', 'AUG', 'SEP',
                                    'OCT', 'NOV', 'DEC'];
                
                scope.cal_days_in_month = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];   
                
                setTimeout(function() {
                    scope.header = $translate.instant(scope.headerTitle);
                    scope.$apply();
                }, 1000);

                scope.myDate = scope.defaultDate 
                    ? $rootScope.getUTCDatetime(scope.defaultDate ? new Date(scope.defaultDate) : new Date())
                    : new Date(new Date());

                scope.timeViewDate = $rootScope.getUTCDatetime(scope.myDate);
                scope.hourValue = 0;
                scope.minValue = 0;
                scope.timeViewMeridian = "";
                scope.timeView = false;

                if(scope.myDate.getHours() <= 11 ){
                    scope.hourValue = scope.myDate.getHours();
                    scope.timeViewMeridian = "AM";
                }
                else{
                    scope.hourValue = scope.myDate.getHours() - 12;
                    scope.timeViewMeridian = "PM";
                }

                if(scope.myDate.getHours() === 0 || scope.myDate.getHours() === 12){
                    scope.hourValue = 12;
                }

                scope.minValue = scope.myDate.getMinutes();
                scope.today = new Date();
                scope.monthDays = [];
                scope.yearsList = [];

                if(scope.defaultOpen === true) {
                    scope.popover = true;
                }
                else {
                    scope.popover = false;
                }

                scope.generateDays = function() {
                      scope.monthDays = [];
                    var year = scope.myDate.getFullYear(),
                        month = scope.myDate.getMonth(),
                        current_day = scope.myDate.getDate(),
                        today = new Date();
                    var firstDay = new Date(year, month, 1);
                    var startingDay = firstDay.getDay();
                    var monthLength = scope.getMonthLength(month,year);
                    var day = 1;
                    var dateArr = [];
                    var dateRow =[];
                    // this loop is for is weeks (rows)
                    for (var i = 0; i < 9; i++) {
                        // this loop is for weekdays (cells)
                        dateRow = [];
                        for (var j = 0; j <= 6; j++) { 
                            var dateCell = 0;
                        if (day <= monthLength && (i > 0 || j >= startingDay)) {
                            dateCell = day;
                        if(day === parseInt(current_day)){
                           // dateCell.classList.add('selected-day');
                        }
                        if(day === parseInt(today.getDate()) &&  scope.myDate.getMonth() === today.getMonth() &&  scope.myDate.getFullYear() === today.getFullYear()){
                           // dateCell.classList.add('today');
                        }
                            day++;
                        }
                        dateRow.push(dateCell);
                        }
                        // stop making rows if we've run out of days
                        if (day > monthLength) {
                            dateArr.push(dateRow);
                        break;
                        } else {
                            dateArr.push(dateRow);
                        }
                    }
                      scope.monthDays = dateArr;
                }
    
                scope.getMonthLength = function(month,year){
                    var monthLength = scope.cal_days_in_month[month];
                    
                    // compensate for leap year
                    if (month === 1) { // February only!
                        if((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0){
                        monthLength = 29;
                        }
                    }
                    return monthLength;
                }
                scope.generateDays();
    
                scope.prevMonth = function(e){
                    e.stopPropagation();
                    if(scope.myDate.getMonth() === 0){
                        scope.myDate.setMonth(11);
                        scope.myDate.setFullYear(scope.myDate.getFullYear() - 1);
                    }else{
                        var prevmonthLength = scope.getMonthLength(scope.myDate.getMonth() - 1, scope.myDate.getFullYear());
                        var currentDate = scope.myDate.getDate();
                        if(currentDate > prevmonthLength ){
                            scope.myDate.setDate(prevmonthLength);
                        }
                        scope.myDate.setMonth(scope.myDate.getMonth() - 1);
                    }
                    scope.generateDays();
                }
                scope.nextMonth = function(e) {
                    e.stopPropagation();
                    if(scope.myDate.getMonth() === 11) {
                        scope.myDate.setMonth(0);
                        scope.myDate.setFullYear(scope.myDate.getFullYear() + 1);
                    }
                    else {
                        var nextmonthLength = scope.getMonthLength(scope.myDate.getMonth() + 1, scope.myDate.getFullYear());
                        var currentDate = scope.myDate.getDate();
                        if(currentDate > nextmonthLength) {
                            scope.myDate.setDate(nextmonthLength);
                        }

                        scope.myDate.setMonth(scope.myDate.getMonth() + 1);
                    }

                    scope.generateDays();
                }
                scope.generateYearList = function(param) {
                    var startYear = null;
                    var currentYear = null;
                    if(param === "next"){
                        startYear = scope.yearsList[8] + 1;
                    }
                    else if(param === "prev") {
                        startYear = scope.yearsList[0] - 9;
                    }
                    else {
                        currentYear = scope.myDate.getFullYear();
                        startYear = currentYear - 4;
                        scope.yearView = !scope.yearView;
                        scope.monthsView = false;
                    }
                    for(var k=0; k< 9; k++) {
                        scope.yearsList[k] = startYear + k;
                    }
                }
                scope.setYear = function(evt) {
                    var selectedYear = parseInt(evt.target.getAttribute('value'));
                    scope.myDate.setYear(selectedYear);
                    scope.yearView = !scope.yearView;

                    scope.generateDays();
                }
                scope.setMonth = function(evt) {

                    if(evt.target.getAttribute('value')) {
                        var selectedMonth = parseInt(scope.cal_months_labels_short.indexOf(evt.target.getAttribute('value')));
                        scope.myDate.setDate(1);
                        scope.myDate.setMonth(selectedMonth);
                        scope.monthsView = !scope.monthsView;

                        scope.generateDays();
                    }
                }
                scope.setDay = function(evt){
                    if(evt.target.getAttribute('value')){
                      var selectedDay = parseInt(evt.target.getAttribute('value'));
                      scope.myDate.setDate(selectedDay);  
                    }
                }
                scope.toggleMonthView = function(){
                    scope.yearView = false;
                    scope.monthsView =  !scope.monthsView;
                }
                scope.getAmPm = function (date) {
                    var hours = date.getHours();
                    var minutes = date.getMinutes();
                    var ampm = hours >= 12 ? 'PM' : 'AM';
                    return ampm;
                }
                scope.updateHours = function(type){
                    if(type === "increment"){
                        var hours = scope.myDate.getHours() + 1;
                        scope.myDate.setHours(hours);
                    }
                    else{
                        scope.myDate.setHours(scope.myDate.getHours() - 1);
                    }
                }
                scope.updateMinutes = function(type){
                    if(type === "increment"){
                        var minutes = scope.myDate.getMinutes() + 1;
                        scope.myDate.setMinutes(minutes);
                    }
                    else{
                        scope.myDate.setMinutes(scope.myDate.getMinutes() - 1);
                    }
                }
                scope.setMeridian = function(type){
                    var hour = scope.myDate.getHours();
                    var minute = scope.myDate.getMinutes();
                    if(type === "AM" && hour > 11){
                        var hourstoSet =      hour - 12;
                        scope.myDate.setHours(hourstoSet);
                    }
                    if(type === "PM"  && hour <= 11){
                            var hourstoSet =      hour + 12;
                            scope.myDate.setHours(hourstoSet);
                    }
                }
                scope.toggleTimeView = function(){
                  //  if(scope.timeView == false){
                    if(scope.myDate.getHours() <= 11 ){
                        scope.hourValue = scope.myDate.getHours();
                        scope.timeViewMeridian = "AM";
                    }
                    else{
                        scope.hourValue = scope.myDate.getHours() - 12;
                        scope.timeViewMeridian = "PM";
                    }
                    if(scope.myDate.getHours() === 0 || scope.myDate.getHours() === 12){
                        scope.hourValue = 12;
                    }
                    scope.minValue = scope.myDate.getMinutes();
                   // }
                    scope.timeView = !scope.timeView;

                    setTimeout(function() {
                        window.dispatchEvent(new Event('resize'));
                    });

                }
                scope.onHourUpdate = function(hour){
                    scope.hourValue = hour;
                    scope.timeViewDate.setHours(hour);
                };
                scope.onMinUpdate = function(minutes){
                    scope.minValue = minutes;
                    scope.timeViewDate.setMinutes(minutes);
                };
                scope.toggleMeridian = function(val){
                    scope.timeViewMeridian = val;
                }
                scope.setTimeView = function(){
                    if(scope.timeViewMeridian === "AM"){
                        if(scope.hourValue === 12){
                            scope.myDate.setHours(0);
                        }
                        else{
                            scope.myDate.setHours(scope.hourValue);
                        }
                        scope.myDate.setMinutes(scope.minValue);
                    }
                    else{
                        if(scope.hourValue === 12){
                            scope.myDate.setHours(scope.hourValue);
                        }
                        else{
                            scope.myDate.setHours(scope.hourValue + 12);
                        }
                        scope.myDate.setMinutes(scope.minValue);
                    }
                    scope.timeView = !scope.timeView;
                }

                scope.confirmDate = function() {
                    scope.popover = false; 
                    scope.callback({ "selectedDate": scope.myDate });
                }

                scope.cancel = function() {
                    scope.popover = false;
                }
            }
        }
    })
    .directive('rangeSlider', ['$timeout', function($timeout){
    
        var modes = {
          single  : 'SINGLE',
          range   : 'RANGE'
        };
    
        var events = {
          mouse: {
            start: 'mousedown',
            move: 'mousemove',
            end: 'mouseup'
          },
          touch: {
            start: 'touchstart',
            move: 'touchmove',
            end: 'touchend'
          }
        };
    
        function roundStep(value, precision, step, floor) {
          var remainder = (value - floor) % step;
          var steppedValue = remainder > (step / 2) ? value + step - remainder : value - remainder;
          var decimals = Math.pow(10, precision);
          var roundedValue = steppedValue * decimals / decimals;
          return parseFloat(roundedValue.toFixed(precision));
        }
    
        function offset(element, position) {
          return element.css({
            left: position
          });
        }
    
        function pixelize(position) {
          return position + "px";
        }
    
        function contain(value) {
          if (isNaN(value)) return value;
          return Math.min(Math.max(0, value), 100);
        }
    
        return {
    
          restrict: 'EA',
    
          scope: {
            floor       : '@',
            ceiling     : '@',
            step        : '@',
            highlight   : '@',
            precision   : '@',
            buffer      : '@',
            dragstop    : '@',
            ngModel     : '=?',
            ngModelLow  : '=?',
            ngModelHigh : '=?',
            onChange    : '&'
          },
    
          link : function(scope, element, attrs) {
    
            element.addClass('angular-range-slider');
    
            var currentMode = (attrs.ngModel === null) && (attrs.ngModelLow !== null) && (attrs.ngModelHigh !== null) ? modes.range : modes.single;
    
            // Dom Components
            var children = element.children();
            var bar         = angular.element(children[0]),
                lowPointer  = angular.element(children[1]),
                highPointer = angular.element(children[2]),
                floorBubble = angular.element(children[3]),
                ceilBubble  = angular.element(children[4]),
                lowBubble   = angular.element(children[5]),
                highBubble  = angular.element(children[6]),
                highlight   = angular.element(bar.children()[0]),
                ngDocument  = angular.element(document);
    
            var low, high;
            if (currentMode === modes.single) {
              low = 'ngModel';
              highPointer.remove();
              highBubble.remove();
            } else {
              low = 'ngModelLow';
              high = 'ngModelHigh';
            }
    
            scope.local = {};
            scope.local[low] = scope[low];
            scope.local[high] = scope[high];
    
            // Control Dimensions Used for Calculations
            var handleHalfWidth = 0,
                barWidth = 0,
                minOffset = 0,
                maxOffset = 0,
                minValue = 0,
                maxValue = 0,
                valueRange = 0,
                offsetRange = 0;
    
            var bindingsSet = false;
    
            var updateCalculations = function() {
    
              if (scope.step === undefined) scope.step = 1;
              if (scope.floor === undefined) scope.floor = 0;
              if (scope.ceiling === undefined) scope.ceiling = 100; //TODO: Make this more intelligent
              if (scope.precision === undefined) scope.precision = 0;
    
              if (currentMode === modes.single) {
                scope.ngModelLow = scope.ngModel;
                scope.onChange({"val":scope.ngModelLow});
              }
    
              scope.local[low] = scope[low];
              scope.local[high] = scope[high];
    
              scope.floor = roundStep(parseFloat(scope.floor), parseInt(scope.precision), parseFloat(scope.step), parseFloat(scope.floor));
              scope.ceiling = roundStep(parseFloat(scope.ceiling), parseInt(scope.precision), parseFloat(scope.step), parseFloat(scope.floor));
    
              if (currentMode === modes.range) {
                scope.ngModelLow = roundStep(parseFloat(scope.ngModelLow), parseInt(scope.precision), parseFloat(scope.step), parseFloat(scope.floor));
                scope.ngModelHigh = roundStep(parseFloat(scope.ngModelHigh), parseInt(scope.precision), parseFloat(scope.step), parseFloat(scope.floor));
              } else {
                scope.ngModel = roundStep(parseFloat(scope.ngModel), parseInt(scope.precision), parseFloat(scope.step), parseFloat(scope.floor));
              }
    
              handleHalfWidth = lowPointer[0].offsetWidth / 2;
              barWidth = bar[0].offsetWidth;
              minOffset = 0;
              maxOffset = barWidth - lowPointer[0].offsetWidth;
              minValue = parseFloat(scope.floor);
              maxValue = parseFloat(scope.ceiling);
              valueRange = maxValue - minValue;
              offsetRange = maxOffset - minOffset;
    
            };
    
            var updateDOM = function () {
              updateCalculations();
    
              var percentOffset = function (offset) {
                return contain(((offset - minOffset) / offsetRange) * 100);
              };
    
              var percentValue = function (value) {
                return contain(((value - minValue) / valueRange) * 100);
              };
    
              var pixelsToOffset = function (percent) {
                return pixelize(percent * offsetRange / 100);
              };
    
              var setPointers = function () {
                offset(ceilBubble, pixelize(barWidth - ceilBubble[0].offsetWidth));
    
                var newLowValue, newHighValue;
                newLowValue = percentValue(scope.local[low]);
                offset(lowPointer, pixelsToOffset(newLowValue));
                offset(lowBubble, pixelize(lowPointer[0].offsetLeft - (lowBubble[0].offsetWidth / 2) + handleHalfWidth));
                offset(highlight, pixelize(lowPointer[0].offsetLeft + handleHalfWidth));
    
                if (currentMode === modes.range) {
                  newHighValue = percentValue(scope.local[high]);
                  offset(highPointer, pixelsToOffset(newHighValue));
                  offset(highBubble, pixelize(highPointer[0].offsetLeft - (highBubble[0].offsetWidth / 2) + handleHalfWidth));
    
                  highlight.css({
                    width: pixelsToOffset(newHighValue - newLowValue)
                  });
    
                } else if (scope.highlight === 'right') {
    
                  highlight.css({
                    width: pixelsToOffset(110 - newLowValue)
                  });
    
                }
                else if (scope.highlight === 'left') {
    
                  highlight.css({
                    width: pixelsToOffset(newLowValue)
                  });
    
                  offset(highlight, 0);
                }
    
              };
    
              var bind = function (handle, bubble, ref, events) {
    
                var currentRef = ref;
    
                var onEnd = function () {
                  bubble.removeClass('active');
                  handle.removeClass('active');
                  ngDocument.unbind(events.move);
                  ngDocument.unbind(events.end);
                  if (scope.dragstop) {
                    scope[high] = scope.local[high];
                    scope[low] = scope.local[low];
                  }
                  currentRef = ref;
                  scope.$apply();
                };
    
                var onMove = function (event) {
    
                  // Suss out which event type we are capturing and get the x value
                  var eventX = 0;
                  if (event.clientX !== undefined) {
                    eventX = event.clientX;
                  }
                  else if ( event.touches !== undefined && event.touches.length) {
                    eventX = event.touches[0].clientX;
                  }
                  else if ( event.originalEvent !== undefined &&
                            event.originalEvent.changedTouches !== undefined &&
                            event.originalEvent.changedTouches.length) {
                    eventX = event.originalEvent.changedTouches[0].clientX;
                  }
    
                  var newOffset = Math.max(Math.min((eventX - element[0].getBoundingClientRect().left - handleHalfWidth), maxOffset), minOffset),
                      newPercent = percentOffset(newOffset),
                      newValue = minValue + (valueRange * newPercent / 100.0);
    
                  if (currentMode === modes.range) {
                    switch (currentRef) {
                      case low:
                        if (newValue > scope.local[high]) {
                          currentRef = high;
                          lowPointer.removeClass('active');
                          lowBubble.removeClass('active');
                          highPointer.addClass('active');
                          highBubble.addClass('active');
                          setPointers();
                        } else if (scope.buffer > 0) {
                          newValue = Math.min(newValue, scope.local[high] - scope.buffer);
                        }
                        break;
                      case high:
                        if (newValue < scope.local[low]) {
                          currentRef = low;
                          highPointer.removeClass('active');
                          highBubble.removeClass('active');
                          lowPointer.addClass('active');
                          lowBubble.addClass('active');
                          setPointers();
                        } else if (scope.buffer > 0) {
                          newValue = Math.max(newValue, parseInt(scope.local[low]) + parseInt(scope.buffer));
                        }
                    }
                  }
    
                  newValue = roundStep(newValue, parseInt(scope.precision), parseFloat(scope.step), parseFloat(scope.floor));
                  scope.local[currentRef] = newValue;
    
                  if (!scope.dragstop) {
                    scope[currentRef] = newValue;
                  }
    
                  setPointers();
                  scope.$apply();
                };
    
                var onStart = function (event) {
                  updateCalculations();
                  bubble.addClass('active');
                  handle.addClass('active');
                  setPointers();
                  event.stopPropagation();
                  event.preventDefault();
                  ngDocument.bind(events.move, onMove);
                  return ngDocument.bind(events.end, onEnd);
                };
    
                handle.bind(events.start, onStart);
              };
    
              var setBindings = function () {
                var method, i;
                var inputTypes = ['touch', 'mouse'];
                for (i = 0; i < inputTypes.length; i++) {
                  method = inputTypes[i];
    
                  if (currentMode === modes.range) {
                    bind(lowPointer, lowBubble, low, events[method]);
                    bind(highPointer, highBubble, high, events[method]);
                  } else {
                    bind(lowPointer, lowBubble, low, events[method]);
                  }
                }
    
                bindingsSet = true;
              };
    
              if (!bindingsSet) {
                setBindings();
              }
    
              setPointers();
            };
    
            // Watch Models based on mode
            scope.$watch(low, updateDOM);
    
            if (currentMode === modes.range) {
              scope.$watch(high, updateDOM);
            }
    
            window.addEventListener('resize', updateDOM);
        },

        template :  '<div class="bar"><div class="selection"></div></div>' +
                      '<div class="handle low {{ floor == 1 ? \'timepicker-drag-hours\' : \'timepicker-drag-minutes\' }}"><span style="display: block;margin-top: 3px;" class="bubble value low">{{ ngModelLow }}</span></div>' +
                      '<div class="handle high"></div>' +
                      '<div class="bubble limit low">{{ floor }}</div>' +
                      '<div class="bubble limit high">{{ ceiling }}</div>' +
                      '<div class="bubble value high">{{ ngModelHigh }}</div>'
        }
    }])
    .filter('numberFixedLen', function () {
        return function (n, len) {
            var num = parseInt(n, 10);
            len = parseInt(len, 10);
            if (isNaN(num) || isNaN(len)) {
                return n;
            }
            num = ''+num;
            while (num.length < len) {
                num = '0'+num;
            }
            return num;
        };
    });
})();
(function () {

	'use strict';

	/**
	 * @ngdoc directive
	 * @name filereader:filereader
	 * @description
	 * <ul>
	 * <li>Uses HTML5 filereader API</li>
	 * <li>Attaches Cropper JS to the upload result</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */

	function dataURItoBlob(dataURI) {
		var byteString = atob(dataURI.split(',')[1]);
		var ab = new ArrayBuffer(byteString.length);
		var ia = new Uint8Array(ab);
		for (var i = 0; i < byteString.length; i++) {
			ia[i] = byteString.charCodeAt(i);
		}
		return new Blob([ab], { type: 'image/jpeg' });
	}

	angular.module('directives.cropper', []).directive('cropper', cropper);
	/** @ngInject */
	function cropper(settings, storage, toastr, $translate, $rootScope, uploadService, $timeout) {
		var directive = {
			restrict: 'EA',
			replace: true,
			scope:{
				events: '='
			},
			templateUrl:'app/base/directives/cropper.directive.html',
			link:linkFunction
		};

		return directive;

		function linkFunction(scope, elem, attrs) {
			var args = scope.events.args || { };

			scope.viewState = {
				isReady:true
			};

			var imgUploader = document.getElementById('imgUploader'),
					imgPreviewer = document.getElementById('imgPreviewer'),
					imgPlaceholder = document.getElementById('imgPholder'),
					cropper;

			function handleLoad() {
				scope.viewState.isReady = false;
				
				$timeout(function() {
					var	file = imgUploader.files[0];
					var reader = new FileReader();

					reader.addEventListener('load', function () {
						handleImage(reader.result);
					}, false);

					if (file) {
						reader.readAsDataURL(file);
					}
				},100);
			}

			function showPholder() {
				imgPlaceholder.style.display = 'block';
			}

			function hidePholder() {
				imgPlaceholder.style.display = 'none';
			}

			function _base64ToArrayBuffer(base64) {
                var binary_string = window.atob(base64.split(",")[1]);
                var len = binary_string.length;
                var bytes = new Uint8Array(len);
                for (var i = 0; i < len; i++) {
                  bytes[i] = binary_string.charCodeAt(i);
                }
                return bytes.buffer;
            }

			function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
				var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
				return { width: srcWidth*ratio, height: srcHeight*ratio };
			}

			function handleImage(blob) {
				var img = document.createElement('img');
				img.src = blob;

				img.addEventListener('load', function() {
					var exif = EXIF.readFromBinaryFile(_base64ToArrayBuffer(img.src));

					if(img.width > settings[args.action].maxWidth) {
						hidePholder();

						var canvas = document.createElement('canvas'),
							context;

						var aratio = calculateAspectRatioFit(
							img.width, 
							img.height, 
							settings[args.action].maxWidth, 
							settings[args.action].maxWidth);

						context = canvas.getContext('2d');
						canvas.width = aratio.width;
						canvas.height = aratio.height;
						
						var x = 0;
						var y = 0;

						if (exif.Orientation !== 'undefined') {
							
							/*if (exif.Orientation > 4) {
								canvas.width = aratio.height;
								canvas.height = aratio.width;
							}

							switch (exif.Orientation) {
								case 2:
									context.translate(canvas.width, 0);
									context.scale(-1, 1);
									break;
								case 3:
									context.translate(canvas.width, canvas.height);
									context.rotate(Math.PI);
									break;
								case 4:
									context.translate(0, canvas.height);
									context.scale(1, -1);
									break;
								case 5:
									context.rotate(0.5 * Math.PI);
									context.scale(1, -1);
									break;
								case 6:
									context.rotate(0.5 * Math.PI);
									context.translate(0, -canvas.height);
									y = canvas.height-canvas.width;
									break;
								case 7:
									context.rotate(0.5 * Math.PI);
									context.translate(canvas.width, -canvas.height);
									context.scale(-1, 1);
									y = canvas.height-canvas.width;
									x = canvas.width-canvas.height;
									break;
								case 8:
									context.rotate(-0.5 * Math.PI);
									context.translate(-canvas.width, 0);
									x = canvas.width-canvas.height;
									break;
							}*/
				
							context.drawImage(img, x, y, aratio.width, aratio.height);
							context.restore();

							imgPreviewer.src = canvas.toDataURL('image/jpeg',settings[args.action].quality);
							attachCropper(imgPreviewer)
						}
						else {
							imgPreviewer.src = img.src;
							attachCropper(imgPreviewer)
						} 
					}
					else{
						hidePholder();
						imgPreviewer.src = blob;
						attachCropper(imgPreviewer);
					}
				});
			}

			function exporter() {
				var output = document.createElement('img'),
					canvas = document.createElement('canvas'),
					context = canvas.getContext('2d');

				output.src = cropper.getCroppedCanvas().toDataURL();

				output.onload = function() {

					canvas.width = output.width;
					canvas.height = output.height;

					context.drawImage(output, 0, 0, output.width, output.height);
					var optimized = canvas.toDataURL('image/jpeg',settings[args.action].quality);
					
					uploadService.imgUpload(dataURItoBlob(optimized),{
						headers: {
							'Content-Type': undefined,
							'ClasslistToken':storage.getToken() || '',
							'ClasslistCfg':angular.toJson({
								'type':settings[args.action].type
							})
						}
					}).then(function(response) {
						response.file_blob = optimized;
						args.callback_fn(response);

						scope.viewState.isReady = true;
						scope.events.close();
					}, function(error){
						console.log(error);
						scope.viewState.isReady = true;
						scope.events.enableButton();
					})
				}
			}

			scope.events.rotate = function() {
				cropper.rotate(45)
			}

			scope.events.save = function() {
				scope.viewState.isReady = false;

				$timeout(function() {
					exporter();
				},100);
				
			}

			scope.events.chooseAgain = function() {
				scope.events.handleError('');
				cropper.destroy();
				imgPreviewer.src = '';
				scope.events.disableButton();
				showPholder()
			}

			scope.events.cropPicture = function() {
				scope.events.editingPicture = true;
				cropper.crop();
			}

			function attachCropper(image) {
				scope.events.enableButton();
				cropper ? cropper.destroy() : _.noop();
				cropper = new Cropper(image, _.assign(settings.cropper,settings[args.config]));
				scope.events.resetErrorMessage();

				setTimeout(function() {
					if(settings[args.config].autoCrop === undefined)
						scope.events.cropPicture()
					scope.$apply();
				}, 100);

				scope.viewState.isReady = true;	
			}

			imgUploader.onchange = function() {
				handleLoad()
				setTimeout(function() {
					imgUploader.value = '';
				}, 1000);
			}
			
			if(args.file_blob) {
				hidePholder();
				imgPreviewer.src = args.file_blob;
				attachCropper(imgPreviewer)
				scope.events.hideChoose();
				
				setTimeout(function() {
					scope.$apply();
				}, 1);

				setTimeout(function() {
					scope.events.cropPicture()
					scope.$apply();
				}, 500);
			}
		}
	}

})();

(function () {

	'use strict';

	/**
	 * @ngdoc directive
	 * @name prefix:prefix
	 * @description
	 * <ul>
	 * <li>Displays list of country prefixes</li>
	 * <li>Flushes all notifications from the previous request</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */

	angular.module('directives.countries', []).directive('countries', countries);
	/** @ngInject */
	function countries(base, $http){
		var directive = {
			restrict: 'EA',
			replace: true,
			scope:{
				ngModel: '='
			},
			template: [
				'<div>',
				'<select class="form-control" ng-required="isRequired" ng-model="selection" ng-options="c.longName for c in countries" ng-change="changeOption()">',
				'</select>',
				'</div>'
			].join(''),
			link:linkFunction
		};
		return directive;

		function linkFunction(scope, elem, attrs) {
			scope.countries = [];
			scope.isRequired=scope.$eval(attrs.isRequired);
			(scope.ngModel === '' || _.isUndefined(scope.ngModel)) ? scope.ngModel = '826' : '';

			scope.changeOption = function() {
				scope.ngModel = scope.selection.id
			}

			scope.$on('SET_COUNTRY', function(e, value){
				scope.ngModel = value;
				setCountry();
			});

			function setCountry() {
				if (!_.isUndefined(scope.ngModel)) {
					var id = scope.ngModel
					for (var i = 0; i < scope.countries.length; i++) {
						if (scope.countries[i].id === id) {
							scope.selection = scope.countries[i];
						}
					}					
				} else {
					scope.selection = scope.countries[0];
				}
			}
			
			$http.get('i8n/locale-metadata-en-GB.json').then(function(data) {
				scope.countries = data.data.metadata.countries;
				setCountry();
			});
		}
	}

})();

(function () {

	'use strict';

	angular.module('directives.countchars', [])
	.directive('countChars', ['$timeout',
        function($timeout) {
            return {
                link: function(scope, elem, attrs) {
                    $timeout(function() {
                        if(elem.text().length > 143) {
							elem[0].className += " post-smaller-font";
                        }
                        else {
							elem[0].classList.remove("post-smaller-font");
                        }
                    });
                }
            };
        }
    ]);

})();

(function () {

	'use strict';
	/**
	 * @ngdoc directive
	 * @name commentComposer:commentComposer
	 * @description
	 * <ul>
	 * <li>Creates a comment</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */
	angular.module('directives.commentComposer', []).factory('commentService', ['base', function (base) {
		return _.create(base, { });
	}]).directive('commentComposer', commentComposer);
	/** @ngInject */
	function commentComposer($rootScope, commentService, regexes, toastr, $translate, $timeout, baseService, uploadService, storage, $state) {

		var directive =  {
			restrict: 'EA',
			replace: true,
			scope:{
				events: '=',
				userAvatar: '=',
				postId: '@',
				commentId: '=',
				replyToUserId: '@',
				replyToUserName: '@',
				draftComment: '=?'
			},
			templateUrl:'app/base/directives/commentComposer.directive.html',
			link: linkFunction
		};

		return directive;

		function linkFunction(scope, elem, attrs) {

			scope.height = '40'
			scope.groups = [];
			scope.regexes = regexes;
			var clean;
			//$rootScope.activePostId = '';
			scope.replyingToComment = false;

			scope.commentPlaceHolderText = $translate.instant('WRITE_A_COMMENT');

			if(attrs.commentId){
				scope.replyingToComment = true;	
				scope.replyingCommentId = attrs.commentId;
				scope.commentPlaceHolderText = $translate.instant('WRITE_A_REPLY');
				if(attrs.replyToUserId){
					scope.commentPlaceHolderText = '';
					scope.replyToAnchor = "<a rel=\"userid\" alt=\""+attrs.replyToUserId+"\" contenteditable='false' class=\"mentionLink\">" + attrs.replyToUserName + "</a>";
				}
			}
            
			scope.$watch('draftComment', function(newVal, oldVal){
				if (scope.draftComment && scope.draftComment.body) {
					scope.comment.body = $rootScope.parseLinksToTags(scope.draftComment.body);
					if(scope.draftComment.attachmentExist) {
						var url = commentService.getPostImgBucketUrl() + '/' + scope.draftComment.attachmentUniqueId;
						if (!scope.attachments) scope.attachments = new Array();
						if (scope.draftComment.isImage) {
							scope.attachments.unshift({ url: url, id: scope.draftComment.attachmentUniqueId || '' });
							scope.setAttachmentURL(url, scope.draftComment.isImage, scope.draftComment.attachmentUniqueId);
						} else {
							scope.attachments.unshift({ name: scope.draftComment.attachmentFileName, url: url, id: scope.draftComment.attachmentUniqueId || '' });
							scope.setAttachmentURL(scope.draftComment.attachmentFileName, scope.draftComment.isImage, scope.draftComment.attachmentUniqueId);
						}
					}
				}
			});

			baseService.app_directive_initialized = function(evt, args) {
				scope.comment = {
					body:'',
					id:'',
					own: true,
					avatar: '',
					created: Date.now(),
					userId: $rootScope.active_user.id,
					postedBy: '',
					fileId: ''
				};
				scope.activeUser = $rootScope.active_user;
				
				clean = angular.copy(scope.comment);
				var fileUploader;
				var activePreviewWrapper;
				var activeAttachmentButtonsWrapper;
				
				scope.filesToSend = new Array();

				scope.setAttachmentURL=function(url, isImage, uniqueAttId) {
					if(url != '' ){
						scope.attachmentUrl = url;
						setTimeout(function() {
							activePreviewWrapper = document.getElementById(scope.postId)
							activeAttachmentButtonsWrapper = document.getElementById(scope.postId + 'icons')
							activePreviewWrapper.setAttribute("style","display:block")
							activeAttachmentButtonsWrapper.setAttribute("style","display:none")
							var imageWrapper = activePreviewWrapper.querySelector('#test-id')
							if(isImage){
								imageWrapper.setAttribute("style","display:block")
								activePreviewWrapper.querySelector('#att-name').textContent = ''
								imageWrapper.src = url
								imageWrapper.setAttribute("alt",uniqueAttId)
							} else {
								activePreviewWrapper.querySelector('#att-name').textContent = url
								activePreviewWrapper.querySelector('#att-name').setAttribute("alt",uniqueAttId)
								imageWrapper.setAttribute("style","display:none")
								imageWrapper.src = ''
							}
						}, 100);
						
					}
					
				}
				scope.onUploaderClicked = function(url, isImage,uniqueAttId){
					setTimeout(function()  {
						scope.setAttachmentURL(url, isImage,uniqueAttId);
					}, 100);
					setTimeout(function()  {
						var draft = scope.getDraft();
						scope.setDraft(draft);
					}, 400);
				}

				scope.onChange = function() {
					var length = 0;
				
					function recursiveLoad(files, success) {

						var reader = new FileReader();
						var file = files[length];
						if (file) {
							if (file.type.indexOf('image') > -1) {
								var _URL = window.URL || window.webkitURL;
								var img = new Image();
				
								img.onload = function() {
									window.EXIF.getData(img, function() {
											reader.readAsDataURL(file);
											reader.addEventListener('load', function(e) {
												scope.filesToSend = new Array();
												scope.filesToSend.push({
													name: file.name,
													ext: file.name.split('.').pop(),
													type: file.type,
													src: e.target.result,
													url: URL.createObjectURL(file),
													blob: dataURItoBlob(reader.result)
												})
				
												if (!scope.attachments)
													scope.attachments = new Array()
				
												scope.attachUpload(URL.createObjectURL(file), function(resp) {
													var url = commentService.getPostImgBucketUrl() + '/' + resp.data;
				
													scope.attachments.unshift({ url: url, blob: URL.createObjectURL(file), id: resp.data || '' });
													
													if(scope.draftComment) {
														scope.draftComment.isImage = true;
													} else {
														scope.draftComment = {isImage: true}
													}
													scope.onUploaderClicked(url, true, resp.data);
				
													length += 1;
													scope.viewState.isReady = false;
													recursiveLoad(files, success)


													
												})
				
											}, false);
				
										}
									)
									
								};
								img.src = _URL.createObjectURL(file);
							} else {
								// Files
								reader.readAsDataURL(file);
				
								if (file.size > 8000000) {
									toastr.info($translate.instant('FILE_SIZE_TOO_BIG'));
									return;
								}
				
								reader.addEventListener('load', function(e) {
									scope.filesToSend = new Array();
									scope.filesToSend.push({
										name: file.name,
										ext: file.name.split('.').pop(),
										type: file.type,
										src: e.target.result,
										url: URL.createObjectURL(file),
										blob: dataURItoBlob(reader.result)
									})
				
									if (!scope.attachments)
										scope.attachments = new Array()
				
									scope.attachUpload(URL.createObjectURL(file), function(resp) {
										var url = commentService.getPostImgBucketUrl() + '/' + resp.data
										scope.attachments.unshift({ name: file.name, url: url, blob: URL.createObjectURL(file), id: resp.data || '' });
													
										if(scope.draftComment) {
											scope.draftComment.isImage = false;
										} else {
											scope.draftComment = {isImage: false}
										}

										scope.onUploaderClicked(file.name, false, resp.data);	
										length += 1;
				
										scope.viewState.isReady = false;
										recursiveLoad(files, success)
										
										
									})
				
								}, false);
							}
						} else {
							scope.viewState.isReady = true;
				
							if (success)
								success();
						}
					}
				
				
					recursiveLoad(fileUploader.files, function() {
						fileUploader.value = '';
					});
				};
				
				

				scope.attachUpload = function(blob, success, fail) {
					uploadService.fileUpload(scope.filesToSend[0].blob, {
							headers: {
								'Content-Type': undefined,
								'ClasslistToken': storage.getToken() || '',
								'ClasslistCfg': angular.toJson({
									'type': 'ATTACHMENT'
								})
							}
						}, scope.filesToSend[0].name)
						.then(function(response) {
								scope.isUploading = false;
								scope.filesToSend[0].file_id = response.data;
				
								if (success)
									success(response)
							},
							function(error) {
								if (error.status === 403 || error.status === 409) {
									toastr.error($translate.instant(error.data));
								} else {
									//Skip for now.
								}
				
								if (fail)
									fail()
				
								scope.isUploading = false;
							});
				}

				scope.uploadImage = function(id) {
					if (!$rootScope.active_user.emailVerified) {
						toastr.error($translate.instant('PLEASE_VERIFY_EMAIL'));
						$rootScope.verifyEmailDismissed = false;
						return; 
					}
					//$rootScope.activePostId = id;
					fileUploader = document.getElementById('postUploader');
					fileUploader.onchange = function() {
						scope.onChange();
					}
					fileUploader.setAttribute('accept', 'image/x-png,image/png,image/gif,image/jpeg,image/jpg');
					fileUploader.click();
					scope.$root.nativeCamPerm();
				}

				scope.uploadAttachment = function(id) {
					if (!$rootScope.active_user.emailVerified) {
						toastr.error($translate.instant('PLEASE_VERIFY_EMAIL'));
						$rootScope.verifyEmailDismissed = false;
						return; 
					}
					//$rootScope.activePostId = id;
					fileUploader = document.getElementById('postUploader');
					fileUploader.onchange = function() {
						scope.onChange();
					}
					fileUploader.setAttribute('accept', '*')
					fileUploader.click();
					scope.$root.nativeCamPerm();
				}

				scope.getCommentBody = function(bodyWithTags, draft){
					scope.comment.body = bodyWithTags;
					scope.setDraft(draft);
				}

				scope.removeAttachment = function (id) {
					var selectedDivWrapper = document.getElementById(id);
					scope.attachmentUrl = '';
					scope.attachments = [];
					selectedDivWrapper.setAttribute("style","display:none");
					selectedDivWrapper.querySelector('#test-id').setAttribute("alt","");
					selectedDivWrapper.querySelector('#att-name').setAttribute("alt","");
				}				
			}
	
			if($rootScope.active_school && $rootScope.app_base_ready) {
				baseService.app_directive_initialized();
			}

			scope.viewState = {
				isReady:true,
				previewActive:false,
				groupActive:false
			}
	
			scope.checkUploadedAttachments = function(postId){
				var selectedDivWrapper = document.getElementById(postId);
				scope.attachmentExist = false;
				scope.attachmentUniqueId = '';
				if(selectedDivWrapper && selectedDivWrapper.querySelector('#test-id') && selectedDivWrapper.querySelector('#test-id').src && selectedDivWrapper.querySelector('#test-id').src != '' && selectedDivWrapper.querySelector('#att-name').textContent == ''){
					if(selectedDivWrapper.querySelector('#test-id').getAttribute("alt") && selectedDivWrapper.querySelector('#test-id').getAttribute("alt") != ''){
						scope.attachmentExist = true;
						scope.attachmentUniqueId = selectedDivWrapper.querySelector('#test-id').getAttribute("alt");
					}
				} else {
					if(selectedDivWrapper && selectedDivWrapper.querySelector('#att-name') && selectedDivWrapper.querySelector('#att-name').textContent && selectedDivWrapper.querySelector('#att-name').textContent != ''){
						if(selectedDivWrapper.querySelector('#att-name').getAttribute("alt") && selectedDivWrapper.querySelector('#att-name').getAttribute("alt") != ''){
							scope.attachmentExist = true;
							scope.attachmentUniqueId = selectedDivWrapper.querySelector('#att-name').getAttribute("alt");
							scope.attachmentFileName = selectedDivWrapper.querySelector('#att-name').innerHTML;
						}
					}
				}
			}

			scope.setDraft = function(text) {
				scope.checkUploadedAttachments(scope.postId);
				var draftComment = {
					body: text,
					createdAt: new Date().getTime(),
					postId: scope.postId,
					attachmentExist: scope.attachmentExist,
					attachmentUniqueId: scope.attachmentUniqueId,
					attachmentFileName: scope.attachmentFileName
				};
				if (scope.draftComment) {
					draftComment.isImage = scope.draftComment.isImage;
				}
				if (scope.replyingToComment) {
					draftComment.replyingCommentId = scope.replyingCommentId;
				}
				localStorage.setItem("draftComment", JSON.stringify(draftComment));
			}

			scope.postComment = function(postId) {
                if (!$rootScope.active_user.emailVerified) {
					toastr.error($translate.instant('PLEASE_VERIFY_EMAIL'));
					$rootScope.verifyEmailDismissed = false;
                    return; 
                }
				scope.viewState.isReady = false;

				scope.checkUploadedAttachments(postId);

				if(!scope.comment.body && !scope.attachmentExist){
					return;
				}
				scope.sendingComment = true;
				
				if(scope.attachmentExist) {
					document.getElementById(postId).setAttribute("style","display:none")
				}
				if(scope.events.isMainReply == false && !scope.comment.body.includes(scope.events.repliedUserId)){
					scope.events.repliedCommentId = null
					scope.events.repliedUserId = null
				}
				//scope.comment.body = parseLinks(scope.comment.body);
				scope.comment.body = $rootScope.createEmailLinks(scope.comment.body);
				scope.comment.fileId = scope.attachmentUniqueId;
				scope.commentPayloadObject = {
					'payload': {
						'repliedCommentId': scope.events.repliedCommentId,
						'commentText': scope.comment.body,
						'fileId': scope.comment.fileId
					}
				}
				var endpointUrl = 'post/v1/comment/' + scope.postId + '/create';
				
				if(scope.replyingToComment){
					endpointUrl = 'post/v1/commentReply/' + scope.commentId + '/create';
				}

				commentService.post(endpointUrl,scope.commentPayloadObject,{'xhr':true}).then(function(response){
					
					scope.sendingComment = false;
					scope.viewState.isReady = true;
					scope.comment.id = response.data.id;
					scope.comment.created = Date.now();
					if(response.data.attachment){
						scope.comment.attachment = {
							'id': response.data.attachment.id,
							'url': response.data.attachment.url,
							'fileName': response.data.attachment.fileName,
							'fileView': response.data.attachment.fileView
						}
					}
					
					if(scope.replyingToComment){
						scope.events.commentReplyCallback(scope.comment,scope.commentId);
					} else {
						scope.events.commentCallback(scope.comment);
					}

					scope.discardComment();
					scope.comment.fileId = '';
					scope.attachmentUniqueId = '';
					scope.draftComment.body = '';
					$rootScope.$broadcast('RESIZE_NOW', function(someVar) { });
					$rootScope.$broadcast('removeInput');
					scope.removeAttachment(scope.postId);
				}, 
				function(error){
					scope.sendingComment = false;
					scope.viewState.isReady = true;
					toastr.error($translate.instant('COMMENT_ERROR'));
					$rootScope.$broadcast('removeInput');
				})
			}

			scope.discardComment = function(){
				scope.comment = angular.copy(clean);
				localStorage.removeItem("draftComment");
			}

			scope.getDraft = function(){
				var draft = localStorage.getItem("draftComment");
				var body = '';
				if(draft) {
					var draftComment = JSON.parse(draft);
					body = draftComment.body;
				}
				return body;
			}
		}
	}

})();

(function () {

	'use strict';

	/**
	 * @ngdoc directive
	 * @name prefix:prefix
	 * @description
	 * <ul>
	 * <li>Displays a recursive list of tiers, with nested sub tiers</li>
	 * <li>Updates the model with selected tiers ID</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */

	angular.module('directives.classPicker', []).directive('classPicker', classPicker);
	/** @ngInject */

	function classPicker(base, $timeout, $rootScope, $translate) {
		var directive = {
			restrict: 'E',
			replace: true,
			scope: {
				ngModel: '='
			},
			templateUrl:'app/base/directives/classPicker.directive.html',
			link: linkFunction
		};
		return directive

		function linkFunction(scope, elem, attrs) {
			scope.tier = { };

			var list = angular.element(elem[0].querySelector('.class-list'));
			scope.list = new Array();

			function traverse(data) {

				for(var i = 0; i < data.length; i++) {
					var d = data[i];
					var option;

					if(d.id === -1 || d.id === -2)
						continue;

					if(d.children) {
						option = angular.element('<optgroup/>');
						option.attr('label', d.name);

						for(var j = 0; j < d.children.length; j++) {
							var c = d.children[j];
							var opt = angular.element('<option/>');
							opt.data('object', c);
							opt.attr('value', c.id);
							opt.text(c.name);
							option.append(opt);
							scope.list.push(c.id);
						}
					}
					else {
						option = angular.element('<option/>');
						option.data('object', d);
						option.attr('value', d.id);
						option.text(d.name);
						scope.list.push(d.id);
					}

					list.append(option);
				}

				var option1 = angular.element('<option/>');
				option1.data('object', { id: -1 });
				option1.attr('value', -1);
				option1.text($translate.instant('I_AM_NOT_SURE'));
				scope.list.push(-1);

				var option2 = angular.element('<option/>');
				option2.data('object', { id: -2 });
				option2.attr('value', -2);
				option2.text($translate.instant('I_CANT_FIND_IT'));
				scope.list.push(-2);

				list.append(option1);
				list.append(option2);
			}

			
			setTimeout(function() {
				base.get('parent/v1/'+($rootScope.requestingSchoolId ? $rootScope.requestingSchoolId : $rootScope.active_school.id)+'/get/structure', { 'cache': false }).then(function(response) {
					traverse(response.data.items);
					
					scope.selectTier = function () {
						scope.showTiers = false;
						
						var c = document.getElementById('select-tier-directive');
						var a = angular.element(elem[0].querySelector('[value="'+c.options[c.selectedIndex].value+'"]'));
						scope.tier = a.data('object');

						$timeout(function () {
							scope.ngModel = scope.tier;
						},0);
					};

					scope.$watch('ngModel', function(newVal, oldVal) {
						if(newVal) {
							angular.element(elem[0].querySelector('#pupil_class_placeholder'))
							.css('display', 'none')
							
							var found = false;
							for(var i = 0; i < scope.list.length; i++) {
								if(scope.list[i] === newVal.id) {
									found = true;
									break;
								}
							}

							if(!found)
								newVal.id = -2;
							
							setTimeout(function() {
								var b = document.getElementById('select-tier-directive')
								b.value = newVal.id;
							}, 200);
						}
					});
				}, 
				function (error) { 

					var option1 = angular.element('<option/>');
					option1.data('object', { id: -1 });
					option1.attr('value', -1);
					option1.text($translate.instant('I_AM_NOT_SURE'));
					scope.list.push(-1);

					var option2 = angular.element('<option/>');
					option2.data('object', { id: -2 });
					option2.attr('value', -2);
					option2.text($translate.instant('I_CANT_FIND_IT'));
					scope.list.push(-2);

					list.append(option1);
					list.append(option2);
				});
			}, 300)
		}
	}
})();


(function () {
	angular.module('directives.carousel', []).directive('carousel', carousel);
	
	function carousel() {
		var directive = {
			restrict: 'EA',
			replace: true,
			link:linkFunction,
            templateUrl:'app/base/directives/carousel.directive.html',
            scope:{
                images: '<',
				link: '@',
				small: '<',
				rightside: '<'
            }
		}

		return directive;
		function linkFunction(scope, elem, attrs) {

			scope.isMobile = isThisMobile();

			scope.scrollLeft = function () {
				var offset = 200;
				if(!scope.isMobile) {
					offset = 450;
				}
				document.getElementById('ad-carousel').scrollLeft += offset;
			}

			scope.checkScroll = function () {
				var div = document.getElementById('ad_carousel');
				return div.scrollWidth > div.clientWidth;
			}
        }
	}	
})();

(function () {

	'use strict';

	/**
	 * @ngdoc directive
	 * @name avatar:avatar
	 * @description
	 * <ul>
	 * <li>Display an avatar from given url and dimensions</li>
	 * <li>Listen to refresh event and pull the image again if image has changed</li>
	 * <li>Display default image if url returns no image</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */

	angular.module('directives.avatar', []).directive('avatar', avatar);
	/** @ngInject */
	function avatar($http, $timeout, $compile, $rootScope) {
		var directive = {
			restrict: 'EA',
			replace: true,
			scope: {
				width: '@',
				height: '@',
				name: '@',
				source:'@'
			},
			templateUrl:'app/base/directives/avatar.directive.html',
			link:linkFunction
		};
		return directive;

		function linkFunction(scope, elem, attrs) {

			var interval = setInterval(function(){
				_.isEmpty(attrs.source) ? _.noop() : recompile()
			}, 300);

			scope.getInitials = function() {
				var result = '';
				
				if(scope.name) {
					if(scope.name.indexOf(' ') > -1) {
						var split = scope.name.split(/ (.+)/);
	
						if(split && split.length > 1) {
							if(split[0].length > 0)
								result = split[0].trim()[0];
	
							if(split[1].length > 0)
								result += split[1].trim()[0];
						}
					}
					else {
						if(scope.name && scope.name.length > 0)
							result = scope.name[0];
					}
				}
	
				return result;
			}

			scope.getInitial = function() {
				var result = '';
				
				if(scope.name && scope.name.length > 0)
				result = scope.name[0].toLowerCase();
	
				return result;  
			}

			scope.w = parseInt(attrs.width) || 250; //default value updated to 250
			scope.h = parseInt(attrs.height) || 250;
			scope.name = attrs.name ? attrs.name.toLowerCase() : '';

			function recompile(){
				//add 50px to size to get higher quality for rounded corner images
				if(attrs.source && attrs.source.indexOf('googleusercontent') > -1){
					scope.src = attrs.source + '=s'+(scope.w + 50)+'-c';
				} else {
					//keep al other usages safe for now...
					scope.src = attrs.source;
				}
				
				$timeout(function(){
					clearInterval(interval);
				},50)
			}

			scope.$watch('source', function(){
				scope.src = attrs.source;
			});

			if(attrs.my === 'true'){
				scope.$on('AVATAR_UPDATE', function(){
					//console.log("AVATAR_UPDATE - ON",attrs.source);
					$rootScope.updateAvatarOnRootContext();
					clearInterval(interval);
					$timeout(function(){
						scope.src = $rootScope.active_user.avatar;
						$rootScope.saveContextToCache();
					},50)
				})
			}

		}
	}

})();

(function () {
	'use strict';
	/**
	 * @ngdoc directive
	 * @name featureDetection:featureDetection
	 * @description
	 * <ul>
	 * <li>Autoresize textarea</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */
	angular.module('directives.autoresizeTextareaComment', []).directive('autoresizeTextareaComment', autoresizeTextareaComment);
	/** @ngInject */
	function autoresizeTextareaComment(base, $rootScope) {

		var directive =  {
			restrict: 'EA',
			replace: false,
			link: linkFunction
		};

		return directive;

		function linkFunction(scope, elem, attrs) {
			var a = elem[0];

			a.oninput = function() {
				a.style.height = "auto";
				a.style.height = Math.min(a.scrollHeight, 400) + "px";
				a.style.overflowY = 'auto';
			};

			$rootScope.$on('RESIZE_NOW',function(evt,args){
				a.style.overflowY = 'hidden';
				a.style.height = "auto";
				a.style.height = "40px";
			})
			
		}
	}

})();

(function () {
	'use strict';
	/**
	 * @ngdoc directive
	 * @name featureDetection:featureDetection
	 * @description
	 * <ul>
	 * <li>Autoresize textarea</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */
	angular.module('directives.autoresizeTextarea', []).directive('autoresizeTextarea', autoresizeTextarea);
	/** @ngInject */
	function autoresizeTextarea(base, $rootScope, $timeout) {

		var directive =  {
			restrict: 'EA',
			replace: false,
			link: linkFunction
		};

		return directive;

		function linkFunction(scope, elem, attrs) {
			var a = elem[0];
			var focused = 0;

			$rootScope.$on('RESIZE_TO_LARGE',function(evt,args){
				focused = 0;
				resizeUp();
			})

			a.oninput = function() {
				resizeUp();
			};

			a._focus = function() {
				$timeout(function () {
					resizeUp();
				},100);
			};

			a.onfocus = function(){
				$timeout(function () {
					resizeUp();
				},10);
			}

			function resizeUp(force) {
				$timeout(function () {
					if (focused  < 2){
						focused++;
						a._focus();
					}
				},100);

				a.style.height = "auto";
				a.style.height = Math.min(a.scrollHeight + 1, 400) + "px";
				a.style.overflowY = 'auto';
			}
		
		}
	}

})();

var contacts_scroll;

(function() {
    'use strict';

    angular.module('modules.baseModule', [])

    .factory('baseService', ['base', function(base) {
            return _.create(base, {});
        }])
        .directive('formatprice', ['$filter', function($filter) {
            return {
                require: 'ngModel',
                link: function(scope, elem, attr, ctrl) {
                    if (!ctrl) return;

                    ctrl.$parsers.unshift(function(viewValue, modelValue) {
                        var plainNumber = viewValue.replace(/[^-+0-9]/g, '');

                        if (plainNumber) {
                            var newVal = plainNumber.charAt(plainNumber.length - 1);
                            var positive = plainNumber.charAt(0) !== '-';
                            if (isNaN(plainNumber.charAt(plainNumber.length - 1))) {
                                plainNumber = plainNumber.substr(0, plainNumber.length - 1)
                            }

                            plainNumber = $filter('number')(plainNumber / 100, 2).replace(/,/g, '');
                            if (positive && newVal === '-') {
                                plainNumber = '-' + plainNumber;
                            } else if (!positive && newVal === '+') {
                                plainNumber = plainNumber.substr(1);
                            }

                            ctrl.$setViewValue(plainNumber);
                            ctrl.$render();
                        }
                        return plainNumber;
                    });
                }
            };
        }])
        .filter('filtercontacts', function($rootScope) {
            return function(list, filter) {
                var out = [];
                var out_response = [];
                var moreloading = false;

                if (!$rootScope.search_page || !$rootScope.search_page.simple) {
                    if (!filter.keyword || filter.keyword.length < 2) {
                        return out;
                    }
                }

                var searchKey = filter.keyword ? filter.keyword.replace(/\s/g, "") : '';
                searchKey = searchKey.toLowerCase();
                searchKey = searchKey.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

                if (searchKey) {
                    if (searchKey.indexOf('dad') > -1) {
                        searchKey = searchKey.replace('dad', '')
                    }

                    if (searchKey.indexOf('mum') > -1) {
                        searchKey = searchKey.replace('mum', '')
                    }

                    if (searchKey.indexOf('father') > -1) {
                        searchKey = searchKey.replace('father', '')
                    }

                    if (searchKey.indexOf('mother') > -1) {
                        searchKey = searchKey.replace('mother', '')
                    }

                    if (searchKey.indexOf("'s") > -1) {
                        searchKey = searchKey.replace("'s", '')
                    }

                    if (searchKey.indexOf("'") > -1) {
                        searchKey = searchKey.replace("'", '')
                    }
                }

                if (searchKey || filter.select) {
                    moreloading = false;
                }

                if (list) {
                    var list_length;

                    for (var i = 0; i < list.length; i++) {
                        var guest = list[i];
                        guest.ps_string = '';

                        if (guest.ps) {
                            for (var j = 0; j < guest.ps.length; j++) {
                                guest.ps_string += (guest.ps[j].fN.toLowerCase() + (guest.ps[j].lN ? guest.ps[j].lN.toLowerCase() : ''));
                                guest.ps_string = guest.ps_string.replace(/\s/g, "");
                                guest.ps_string = guest.ps_string.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                            }
                        }

                        if (searchKey) {
                            var val = guest.fN.toLowerCase() + guest.lN.toLowerCase();
                            val = val.replace(/\s/g, "");
                            val = val.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

                            if ((val.indexOf(searchKey) > -1) ||
                                (guest.ps_string.indexOf(searchKey) > -1)) {
                                out.push(guest)
                            }
                        } else if (filter.select && filter.select !== 0) {
                            if (guest.ps) {
                                for (var x = 0; x < guest.ps.length; x++) {

                                    if (guest.ps[x].fTI === filter.select || guest.ps[x].sTI === filter.select) {
                                        out.push(guest)
                                        break;
                                    }
                                }
                            }
                        } else {
                            out.push(guest)
                        }
                    }

                    list_length = 50;
                    list_length = (list_length * filter.load_search_contacts_index);

                    for (var p = 0; p < list_length; p++) {
                        if (out[p])
                            out_response.push(out[p])
                    }
                }

                contacts_scroll.onscroll = function() {
                    var top = (window.pageYOffset || contacts_scroll.scrollTop) - (contacts_scroll.clientTop || 0);
                    var here = contacts_scroll.scrollHeight - window.innerHeight;

                    if ((top >= here) || (top >= here - 250)) {

                        if (moreloading)
                            return;

                        moreloading = true;

                        $rootScope.selectedContactsFilter.load_search_contacts_index += 1;
                        setTimeout(function() {
                            $rootScope.$apply();
                        }, 12);
                    }
                }

                return out_response;
            }
        })
        .controller('baseController', baseController);

    /** @ngInject */
    function baseController($scope, $rootScope, $window, settings, $state, $translate, $uibModal, $location, authService, baseService, groupsService, $timeout, storage, toastr, gaService) {
        $rootScope.verifyEmailDismissed = false;

        var _psfa;
        var _psfp;
        var _onboarding;
        var internalRedirectURL;
        var loc;

        $scope.dismissVerfiyEmail = function() {
            $rootScope.verifyEmailDismissed = true;
        }

        $scope.onDoneThisVerificationTapped = function() {
            location.reload();
        }

        $scope.firstTimeLoading = true;

        $scope.frontend_v = getFrontendVersion ? getFrontendVersion() : 'no_version';
        $rootScope.isThisMobile = isThisMobile;

        $scope.filters = [];
        $rootScope.selectedContactsFilter = {};

        $rootScope.preventAdsLoading = true;

        $scope.showPlus = false;
        $scope.isMobile = isThisMobile();
        $scope.showMenu = false;
        $rootScope.adsLoaded = false;

        $scope.$state = $state;
        $scope.context = {};
        $scope.showProfileCard = false;
        $scope.showMobileMenu = false;
        var moreloading = false;

        $rootScope.loader = true;
        $rootScope.schoolSideNotifications = 0;

        $scope.ifShowSchoolSelector = false;
        $rootScope.context_loaded = false;
        $rootScope.temp_mess_contacts = [];

        var lastCheckForNewPosts = new Date().getTime();

        $rootScope.nativeNotificationsEnabled = true; // true by default until native calles us


        $scope.remainingDaysToTurnOffMobileBrowser = Math.round(Math.abs((new Date() - new Date(2020, 10, 9)) / (24 * 60 * 60 * 1000)));

        $rootScope.notifsContainer = {
            messages: 0,
            notifications: 0,
            version: 1,
            adsManager: "",
            events: 0,
            home: 0
        };
        $rootScope.checkTodo = function(type) {
            return baseService.get('shared/v1/todo/check/' + $rootScope.active_school.id + '/' + type)
        }

        $rootScope.dismissTodo = function(type) {
            return baseService.get('shared/v1/todo/dismiss/' + $rootScope.active_school.id + '/' + type)
        }

        /*
        * This function is responsible from handling the 
        * redirections from welcome to classlist page.

        	* If user is on desktop, 
        		* call sendAppDownloadLink endpoint,
        		* show 'check your inbox' message.

        	* If user is on native app,
        		* add 'nApp=true' to the url as postfix.
        	* If user is on mobile browser,
        		* take them to 
        		* respective store to download the app.

        * close the appcue.
        */
        $rootScope.onDownloadButtonClicked = function(dismissCue) {

            clearInterval($rootScope.welcomeAppcueInterval);
            $rootScope.welcomeImages = null;

            // PWA-8253 temp fix to stop users getting blocked
            dismissCustomAppcue();
            return;

            // var isNativeTemp = getIfNative() ? true : false;

            // console.log("native is " + isNativeTemp);

            // var appRedirectURL;
            // var userAgent = navigator.userAgent.toLowerCase()

            // if(getIfNative()) {
            // 	dismissCustomAppcue(true);
            // 	return;
            // }

            // if(isThisMobile()){
            // 	if(!isNativeTemp){
            // 		if(/android/i.test(userAgent)) {
            // 			alert('android redirect');
            // 			appRedirectURL = 'http://play.google.com/store/apps/details?id=com.classlist.parent';
            // 		} else {
            // 			alert('itunes redirect');
            // 			//in case something happens or the users clicks very fast
            // 			appRedirectURL = 'http://itunes.apple.com/gb/app/classlist/id1058636226?mt=8';
            // 		}
            // 		window.open(appRedirectURL);
            // 	}
            // 	else 
            // 	{
            // 		location.href='#/?nApp=true"';
            // 	}
            // }
            // else {
            // 	alert('sending a link')
            // 	baseService.get('parent/v1/sendAppDownloadLink/' + $rootScope.active_school.id, { 'cache': false }).then(function (response) {
            // 		toastr.success($translate.instant('CHECK_INBOX'));
            // 		dismissCustomAppcue();
            // 		showCustomAppcue('qr-code-appcue', {});
            // 	},
            // 		function (error) {

            // 		})
            // }
            // if(dismissCue) dismissCustomAppcue();
        }



        $scope.createNewMessage = function(type) {
            if (!$rootScope.active_user.emailVerified) {
                toastr.error($translate.instant('PLEASE_VERIFY_EMAIL'));
                $rootScope.verifyEmailDismissed = false;
                return;
            }
            var options = { reload: false };

            if (!$rootScope.contacts_list)
                return;

            if (window.innerWidth < 991)
                options.reload = true;

            $rootScope.new_message_type = type;
            $rootScope.temp_mess_contacts = [];

            for (var i = 0; i < $rootScope.contacts_list.parents.length; i++) {
                $rootScope.contacts_list.parents[i].selected = false;
            }

            $rootScope.selectedContactsFilter.load_search_contacts_index = 1;

            $scope.$emit('PICK_CONTACT', {
                simple: true
            });

            $rootScope.selectedContactsFilter.keyword = '';
            $rootScope.selectedContactsFilter.select = 0;

            setTimeout(function() {
                var contacts_scroll = document.getElementsByClassName('search-contacts-container')[0];
                contacts_scroll.scrollTop = 0;
            }, 1);
        }

        virtualRedirectPropagation = function() {
            $rootScope.search_page = { active: false };
            setTimeout(function() {
                $rootScope.$apply()
            }, 10);

            $scope.closePlusMenu();
        }

        virtualSendContext = function() {
            setTimeout(function() {
                if ($rootScope.active_user && $rootScope.active_user.id) {
                    pushContextToNative();
                }
            }, 10);
        }

        virtualOpenNewMessage = function() {
            $timeout(function() {
                $scope.createNewMessage(2)
            }, 10);
            return 'redirected';
        };

        virtualOpenNewGroup = function() {
            window.location.href = "/parent/#/groups/create"
            return 'redirected';
        };

        virtualOpenNewEvent = function() {
            $scope.checkCreateEvent();
            return 'redirected';
        };

        virtualOpenNewMkPlace = function() {
            $scope.postMarketplace();
            return 'redirected';
        };

        virtualPushNotificationsAreOff = function(notificationsEnabled) {
            $rootScope.nativeNotificationsEnabled = notificationsEnabled;
            return 'done';
        };

        jsToAngularRedirect = function(url) {
            if ($rootScope.context_loaded) {

                if (url.indexOf(location.href) > -1 &&
                    location.href.indexOf("inbox/view/") > -1 &&
                    url.indexOf("inbox/view/") > -1) {

                    setTimeout(function() {
                        $rootScope.$broadcast('ON_SOCKET_MESSAGE');
                    }, 500);

                } else {
                    window.location.href = url;
                }

                var schoolId = $rootScope.getQueryParam('school');
                if (!schoolId) {
                    schoolId = $rootScope.getQueryParam('s');
                }

                if (schoolId && $rootScope.active_school && $rootScope.active_school.id !== schoolId) {
                    $rootScope.refreshContext(schoolId);
                }
            }
        }

        //check to see if there is anything we need to redirect to
        $scope.$watch('context_loaded', function() {
            if ($rootScope.context_loaded) {
                if (lastNativeRedirect) {

                    if (lastNativeRedirect.indexOf(location.href) > -1 &&
                        location.href.indexOf("inbox/view/") > -1 &&
                        lastNativeRedirect.indexOf("inbox/view/") > -1) {

                        setTimeout(function() {
                            $rootScope.$broadcast('ON_SOCKET_MESSAGE');
                        }, 500);

                    } else {
                        window.location.href = lastNativeRedirect;
                    }

                    lastNativeRedirect = false;
                }
            }
        });

        $rootScope.nextCompose = function(parentArray) {

            var body = { participants: [] }
            if (!parentArray) {
                for (var i = 0; i < $rootScope.temp_mess_contacts.length; i++) {
                    if ($rootScope.temp_mess_contacts[i].id)
                        body.participants.push($rootScope.temp_mess_contacts[i].id)
                }
            } else {
                if (parentArray) {
                    if (parentArray.length) {
                        for (var i = 0; i < parentArray.length; i++) {
                            body.participants.push(parentArray[i].id)
                        }
                    } else body.participants.push(parentArray.id)
                }
            }
            baseService.post('parent/v1/conversation/start/' + $rootScope.active_school.id, body, {}).then(function(response) {
                    if (!response.data) { return; }
                    if (!response.data.id) { return; }

                    location.href = '#/inbox/view/' + response.data.id;
                },
                function(error) {

                })

            $rootScope.search_page = { active: false };
        }

        $rootScope.selectedContactsFilter.load_search_contacts_index = 1;
        $scope.pushMoreContacts = function(value) {

            if ($rootScope.temp_contacts_search.length >= $rootScope.contacts_list.parents.length)
                return;

            var cur_length = $rootScope.temp_contacts_search.length;
            if ($rootScope.contacts_list.parents.length > ($rootScope.temp_contacts_search.length + value)) {
                for (var i = cur_length; i < (cur_length + value); i++) {
                    $rootScope.temp_contacts_search.push($rootScope.contacts_list.parents[i])
                }
            } else {
                for (var x = cur_length; x < $rootScope.contacts_list.parents.length; x++) {
                    $rootScope.temp_contacts_search.push($rootScope.contacts_list.parents[x])
                }
            }

            setTimeout(function() {
                $scope.$apply();
            }, 14);

            moreloading = false;
        };

        $scope.tierChanged = function(tierId) {
            $scope.keyword = '';
            $rootScope.keywordEnteredClPage = '';
            $rootScope.tierSelectedClPage = tierId ? tierId : '';

            $rootScope.selectedContactsFilter.select = tierId;
        }

        $scope.beforeSearchKeyup = function() {
            $rootScope.selectedContactsFilter.load_search_contacts_index = 1;
            if ($rootScope.selectedContactsFilter.select !== 0)
                $rootScope.selectedContactsFilter.select = 0;

            var contacts_scroll = document.getElementsByClassName('search-contacts-container')[0];
            if (contacts_scroll)
                contacts_scroll.scrollTop = 0;
        }

        $scope.beforeTierChanged = function(tierId) {
            $rootScope.selectedContactsFilter.load_search_contacts_index = 1;
            $rootScope.selectedContactsFilter.keyword = '';
            $scope.tierChanged(tierId)

            var contacts_scroll = document.getElementsByClassName('search-contacts-container')[0];
            if (contacts_scroll)
                contacts_scroll.scrollTop = 0;

            if (tierId && tierId !== -1) {
                $rootScope.userTag('PARENT_FILTERED_BY_TIER')

                if (!$rootScope.search_page.simple) {
                    location.href = '#/classlist/all/' + tierId;
                }
            } else {
                if (!$rootScope.search_page.simple) {
                    location.href = '#/classlist/all/';
                }
            }

            setTimeout(function() {
                $scope.$apply()
            }, 100);
        }

        function fillFilters(data) {
            $scope.filters = data.filters || [];
            $scope.filters.unshift({
                'name': $translate.instant('ALL_CONTACTS_TXT'),
                'id': 0
            });

            $rootScope.storedFilters = $scope.filters;
        }

        $rootScope.$on('PICK_CONTACT', function(evt, args) {
            $rootScope.selectedContactsFilter.keyword = '';
            $rootScope.temp_mess_contacts = [];
            $rootScope.search_page = { active: true, simple: args.simple };

            $rootScope.resizeContactsList();

            // Load contacts from storage first
            if (localStorage.getItem('__c5') && localStorage.getItem('__c4') && localStorage.getItem('__c4').b64decode() === $rootScope.active_school.id) {
                fillFilters(JSON.parse(localStorage.getItem('__c5').b64decode()));
            }

            setTimeout(function() {
                var s_input = document.querySelector('.search-contacts-input')
                s_input.focus();
            });
        })

        $rootScope.isNative = getIfNative();
        $rootScope.os = getMobileOperatingSystem();

        //leave the function //18 mar 2019
        $scope.thisIsLatestNative = function() {};
        thisIsLatestNative = $scope.thisIsLatestNative;

        // Load globally contacts from storage
        if (localStorage.getItem('__c5')) {
            $rootScope.contacts_list = JSON.parse(decodeURIComponent(escape(window.atob(localStorage.getItem('__c5')))));
        }

        $rootScope.newGroupMessage = function() {
            $rootScope.new_message_type = 1;
        }

        $rootScope.removeTempSelected = function(contact) {
            if (contact.id === $rootScope.active_user.id)
                return;

            $rootScope.temp_mess_contacts.splice($rootScope.temp_mess_contacts.indexOf(contact), 1);
            $rootScope.resizeContactsList();

            for (var i = 0; i < $rootScope.contacts_list.parents.length; i++) {
                if ($rootScope.contacts_list.parents[i].id === contact.id)
                    $rootScope.contacts_list.parents[i].selected = false;
            }
        }

        $rootScope.gotoProfile = function(id, contact) {
            if (!$rootScope.search_page || !$rootScope.search_page.simple) {
                $rootScope.search_page = { active: false, keep_active: true };
                location.href = '#/classlist/details/' + id + '/contact';
            } else {
                if (!$rootScope.new_message_type || $rootScope.new_message_type === 2) {
                    $rootScope.composeTo(contact)
                } else {
                    if (contact.id === $rootScope.active_user.id)
                        return;

                    if (contact.selected) {
                        contact.selected = false;
                        $rootScope.temp_mess_contacts.splice($rootScope.temp_mess_contacts.indexOf(contact), 1);
                        $rootScope.resizeContactsList();
                    } else {
                        if ($rootScope.temp_mess_contacts.length >= 8) {
                            var modalInstance1 = $uibModal.open({
                                animation: true,
                                templateUrl: 'app/inbox/views/max-participants-modal.html',
                                size: 'sm',
                                controller: function($scope) {

                                    $scope.confirm = function() {
                                        $rootScope.userTag('CONVERSATION_GOTO_GROUPS')
                                        $rootScope.search_page = { active: false };
                                        location.href = '#/home';
                                    }

                                    $scope.close = function() {
                                        $rootScope.userTag('CONVERSATION_NOTNOW_GROUPS')
                                        modalInstance1.close();
                                    }
                                }
                            })
                            return;
                        }

                        $rootScope.selectedContactsFilter.keyword = '';
                        contact.selected = true;
                        $rootScope.temp_mess_contacts.push(contact)

                        $rootScope.resizeContactsList();

                        var sel_contacts_scroll = document.getElementsByClassName('mess-selected-contacts-scroll')[0];
                        if (sel_contacts_scroll) {
                            animate(sel_contacts_scroll, 'scrollLeft', "", sel_contacts_scroll.scrollLeft, sel_contacts_scroll.scrollWidth, 900, true);
                        }
                    }
                }
            }
        }

        $rootScope.resizeContactsList = function() {
            var height = 105;

            if ($rootScope.temp_mess_contacts && $rootScope.temp_mess_contacts.length > 0)
                height = 183;

            if (!$rootScope.search_page || !$rootScope.search_page.simple)
                height = 53;

            setTimeout(function() {
                var searchContactsScroll = document.querySelector('.search-contacts-container');
                var searchContactsPopup = document.querySelector('.search-page-popup');

                if (searchContactsScroll && searchContactsPopup)
                    searchContactsScroll.style.height = (searchContactsPopup.offsetHeight - height) + 'px';
            });
        }

        $rootScope.mapTo = function(p, tierId) {
            $rootScope.search_page = { active: false };
            location.href = '#/classlist/map/' + p.id + '/' + (tierId ? tierId : '');
        }

        $rootScope.gotoMyProfile = function() {
            location.href = '#/profile/settings';
            $rootScope.search_page = { active: false };
        }

        $rootScope.userTag = function(tag, extra) {
            baseService.post('shared/v1/add/userTag', {
                "tagName": tag,
                "referrer": extra ? extra : document.referrer,
                "schoolId": ($rootScope.active_school && $rootScope.active_school.id) ? $rootScope.active_school.id : -1,
                "source": "PARENT"
            }).then(function(response) {

            });
        }

        userTag = $rootScope.userTag;

        var timeoutPromise = null;
        var notificationSentFirstTime = true;
        // prevent notification request duplication
        function scheduleRefreshNotifications() {
            if (timeoutPromise) {
              $timeout.cancel(timeoutPromise);
            }
        
            timeoutPromise = $timeout(function() {
              refreshNotifications();
              timeoutPromise = null; 
              notificationSentFirstTime = false;
            }, notificationSentFirstTime ? 100 : 10000);
          }
        window.addEventListener('online', function(net) {
            if (navigator.onLine) {
                //init websocket
                WSS.init(settings.conf.wssURL + storage.getToken());

                if ($scope.firstTimeLoading)
                    return;

                scheduleRefreshNotifications();
            }
        });

        window.addEventListener('focus', function(event) {
            if (location.href.indexOf('inbox/view/') > -1) {
                setTimeout(function() {
                    if ($rootScope)
                        $rootScope.$broadcast('ON_SOCKET_MESSAGE');
                }, 500);
            }

            if (location.href.indexOf('/stream') > -1 && (new Date().getTime() - lastCheckForNewPosts > 60000)) {
                setTimeout(function() {
                    lastCheckForNewPosts = new Date().getTime();
                    callFirstPostInStream()
                }, 500);
            }

            if (location.href.indexOf('#/post/') > -1) {
                setTimeout(function() {
                    $rootScope.$broadcast('ON_SOCKET_POST');
                }, 500);
            }
        }, false);

        window.addEventListener('offline', function(net) {
            if (!navigator.onLine) {
                if (WSS && WSS.close)
                    WSS.close();
            }
        });

        var myPlatform = navigator.platform;
        var myValues = navigator.platform + window.screen.height + window.screen.width + window.screen.colorDepth;
        var htmlCorp = document.getElementById('CLRoot');

        function callFirstPostInStream() {

            if ($rootScope.firstPostIdInTheStream) {
                baseService.get('post/v1/get/' + $rootScope.active_school.id + '/' + $rootScope.firstPostIdInTheStream + '/is/latest', { 'cache': false }).then(function(resp) {
                    $rootScope.toggleHRL(false)
                    if (resp && resp.data && resp.data.payload && resp.data.payload.n && resp.data.payload.n === true) {
                        $rootScope.toggleHRL(true)
                    }
                });
            }
        }

        $scope.showSchoolSelector = function() {
            if (window.innerWidth <= 990) {
                $scope.ifShowSchoolSelector = !$scope.ifShowSchoolSelector;
            } else {
                setTimeout(function() {
                    $scope.ifShowSchoolSelector = !$scope.ifShowSchoolSelector;
                    $scope.$apply();
                }, 9);
            }

            $rootScope.refreshMySchools();
        }

        $rootScope.refreshMySchools = function() {
            baseService.get('parent/v1/get/context/v2/schools', { 'cache': false }).then(function(resp) {
                $scope.schools = resp.data.items;
            });
        }

        $rootScope.getSchools = function(success) {
            baseService.get('parent/v1/get/context/v2/schools', { 'cache': false }).then(function(resp) {
                if (success)
                    success(resp.data.items);
            });
        }

        $scope.enterSchoolSelector = function() {
            if (window.innerWidth > 990)
                $scope.ifShowSchoolSelector = true;
        }

        $scope.leaveSchoolSelector = function() {
            $scope.ifShowSchoolSelector = false;
        }

        $scope.closeSchoolSelector = function() {
            if (window.innerWidth > 990) {
                $scope.ifShowSchoolSelector = false;
            }
        }

        $scope.downloadApp = function() {
            $rootScope.userTag('FORCE_APP_DOWNLOAD');

            $rootScope.onDownloadButtonClicked(false);
        }
        $scope.openApp = function() {
            window.open(window.location.href);
        }

        $scope.continueBrowser = function() {


            $rootScope.userTag('QR_CODE_GOT_THE_APP');

            $rootScope.dismissTodo('PARENT_PRODUCT_GET_APP_NOW').then(function(resp) {}, function(error) {});

            dismissCustomAppcue();

        }

        $rootScope.updateAvatarOnRootContext = function() {
            baseService.get('parent/v1/get/context/v2/0', { 'cache': false }).then(function(resp) {
                $rootScope.active_user.avatar = resp.data.avatar;
                storage.set('__c2', window.btoa(JSON.stringify($rootScope.active_user)), true);
            });
        }

        $rootScope.adsDisabled = false;
        var adsDisabledCache = localStorage.getItem("adsDisabled");
        if (adsDisabledCache && adsDisabledCache === "true") {
            $rootScope.adsDisabled = true;
        }

        $scope.rootContext = function(stopPropagation, querySchoolId, force) {
            setTimeout(function() {
                contacts_scroll = document.getElementsByClassName('search-contacts-container')[0];
            }, 500);

            checkCacheForContext(querySchoolId);

            if (!$rootScope.active_school ||
                !$rootScope.active_user ||
                force ||
                !$rootScope.active_user.emailVerified ||
                !$rootScope.active_school.approved) {
                var _school_id = 0;
                try {
                    _school_id = isNaN(parseInt(querySchoolId)) ? 0 : parseInt(querySchoolId)
                } catch (ex) {
                    //Skip for now.
                }

                baseService.get('parent/v1/get/context/v2/' + _school_id, { 
                    'cache': false,
					headers: {
						"s": _school_id
					} }).then(function(resp) {
                    $scope.contextReady = true;
                    $rootScope.active_school = {
                        "id": resp.data.school.id,
                        "name": resp.data.school.name,
                        "logo": resp.data.school.logo + '?d=' + new Date().getTime(),
                        "admin": resp.data.school.admin,
                        "approved": resp.data.school.approved,
                        "budiEnabled": resp.data.school.budiEnabled,
                        "integration": resp.data.school.integration,
                        "paid": resp.data.school.paid,
                        "roles": resp.data.school.roles
                    }

                    $rootScope.active_user = {
                        "id": resp.data.id,
                        "firstName": resp.data.firstName,
                        "lastName": resp.data.lastName,
                        "avatar": resp.data.avatar + '?v=' + new Date().getTime(),
                        "email": resp.data.email,
                        "appcue": resp.data.appcue,
                        "emailVerified": resp.data.emailVerified,
                        "pushToken": resp.data.pt,
                        "verifyEmailIn": resp.data.verifyEmailIn
                    }

                    $rootScope.adsDisabled = resp.data.school.paid || resp.data.school.integration;
                    localStorage.setItem("adsDisabled", $rootScope.adsDisabled);

                    setTimeout(function() {
                        if (resp.data.firstVisit) {
                            showCustomAppcue('welcome-appcue', {});
                            switchWelcomeAppcueImages();
                        }
                    }, 300);

                    $rootScope.saveContextToCache();

                    postContextWork(stopPropagation);
                });
            } else {
                postContextWork(stopPropagation);
            }
        }

        function switchWelcomeAppcueImages() {

            var URLs = [
                "https://storage.googleapis.com/classlist-branding/app-assets/contacts.png",
                "https://storage.googleapis.com/classlist-branding/app-assets/events.png",
                "https://storage.googleapis.com/classlist-branding/app-assets/chat.png"
            ];

            $rootScope.welcomeImages = URLs.map(function(URL) {
                var img = new Image();
                img.src = URL;
                return img;
            });
            document.getElementById("welcomeappcueimg").src = $rootScope.welcomeImages[0].src;

            var currWelcomeImage = 0;

            $rootScope.welcomeAppcueInterval = setInterval(function() {

                if (++currWelcomeImage >= $rootScope.welcomeImages.length) {
                    currWelcomeImage = 0;
                }
                document.getElementById("welcomeappcueimg").src = $rootScope.welcomeImages[currWelcomeImage].src;
            }, 3000);
        }

        $rootScope.resendEmail = function(id_school) {
            if ($scope.sending)
                return;

            $scope.sending = true;
            baseService.get('shared/v1/resend/emailValidation/' + id_school, { 'cache': false }).then(function(resp) {
                    $scope.sending = false;
                    toastr.success($translate.instant('EMAIL_RESENT'));
                },
                function() {
                    $scope.sending = false;
                });
        }

        $rootScope.loadContactsStorage = function() {
            // Load globally contacts from storage
            if (!$rootScope.active_user || !$rootScope.active_school)
                return;

            if (!$rootScope.active_user.emailVerified || !$rootScope.active_school.approved)
                return;

            if (!localStorage.getItem('__c5') || !localStorage.getItem('__c4') || localStorage.getItem('__c4').b64decode() !== $rootScope.active_school.id) {
                baseService.get('parent/v1/' + $rootScope.active_school.id + '/listV2/classlist', { 'cache': false })
                    .then(function(response) {
                        var data = response.data;

                        var contacts_map = [];
                        if (data.parents) {
                            for (var i = 0; i < data.parents.length; i++) {
                                var p = data.parents[i];
                                if (p && p.rM)
                                    contacts_map.push(p);
                            }

                            try {
                                localStorage.setItem('__c5', JSON.stringify(data).b64encode());
                                localStorage.setItem('__c6', JSON.stringify(contacts_map).b64encode());
                            } catch (ex) {
                                //Skip for now.
                            }

                            if (!localStorage.getItem('__c4') || localStorage.getItem('__c4').b64decode() !== $rootScope.active_school.id) {
                                localStorage.setItem('__c4', $rootScope.active_school.id.b64encode());
                            }

                            if (localStorage.getItem('__c5')) {
                                $rootScope.contacts_list = JSON.parse(decodeURIComponent(escape(window.atob(localStorage.getItem('__c5')))));
                            }
                        } else {
                            localStorage.setItem('__c5', '');
                            localStorage.setItem('__c6', '');
                        }

                    }, function(error) {

                    });
            }
        }

        $rootScope.longPressCall = function(phone) {
            if (getIfNative() || isThisMobile()) {
                var _phone = (phone.indexOf('0') === 0) ? phone : ('0' + phone);

                if (getMobileOperatingSystem() === 'Android') {
                    if (window.AndroidBridge) {
                        window.AndroidBridge.dialPhoneNumber('tel:' + _phone)
                    }
                } else {
                    window.location = 'classlistnativeparent://dialPhoneNumber?number=' + _phone;
                }
            } else {
                toastr.info('Make calls on Classlist from your mobile');
            }
        }

        $rootScope.saveContextToCache = function() {
            try {
                storage.set('__c1', window.btoa(JSON.stringify($rootScope.active_school)), true);
                storage.set('__c2', window.btoa(JSON.stringify($rootScope.active_user)), true);
            } catch (ex) {
                //Skip for now.
            }
        }

        function postContextWork(stopPropagation) {

            setTimeout(function() {

                var showQRCue = true;

                $rootScope.checkTodo('PARENT_PRODUCT_GET_APP_NOW').then(function(resp) {
                    showQRCue = resp.data.payload.show;

                    // show the qr cue if not on mobile and we haven't shown it before
                    if (!isThisMobile() && showQRCue) {
                        showCustomAppcue('qr-code-appcue', {});
                    }
                });
            }, 300);

            $rootScope.loadContactsStorage()

            if (!stopPropagation) {
                $rootScope.app_base_ready = true;

                if (baseService.app_initialized)
                    baseService.app_initialized();

                if (baseService.app_directive_initialized)
                    baseService.app_directive_initialized();
            }

            $timeout(function() {
                if (window.innerWidth >= 990) {
                    $rootScope.getAds();
                    $rootScope.preventAdsLoading = false;
                }

                /*
                $rootScope.getAds();
                $rootScope.preventAdsLoading = false;
                */

                $rootScope.getPremiumAd();

            }, 200);

            refreshNotifications();

            //let the screen render for 200 ms
            $timeout(function() {

                 //analitics
                $rootScope.gaDimension = ($rootScope.active_school.name) + " - " + ($rootScope.active_school.id);
                $window.ga('set', 'dimension1', $rootScope.gaDimension);
                $window.ga('set', 'dimension2', $rootScope.active_user.id);
                $window.ga('set', 'dimension3', getFrontendVersion());
                $window.ga('set', 'dimension4', isExperimentCookie());

                if (location.host.indexOf('app.classlist.com')) {
                    $window.ga('set', 'dimension5', 'ps');
                }

                $window.ga('set', 'dimension6', new Date().getTime());

                gaService.send($rootScope.gaLoadPage || 'undefined');

                //init websocket
                WSS.init(settings.conf.wssURL + storage.getToken());
                WSS.onConnected = function() {
                    if ($scope.firstTimeLoading)
                        return;

                    scheduleRefreshNotifications()
                }
            }, 200);

            //register socket
            WSS.onPush = function(res) {
                if (res.indexOf('Connection Established') === -1) {
                    $rootScope.loader = false;

                    switch (res) {
                        case 'NEW_PRIVATE_MESSAGES':
                            //only if we are on the message page
                            if (location.href.indexOf("inbox/view/") !== -1) {
                                $rootScope.$broadcast('ON_SOCKET_MESSAGE', res);
                            }
                            if (location.href.indexOf("inbox/list") !== -1) {
                                $rootScope.$broadcast('ON_SOCKET_CONVERSATIONS', res);
                            }
                            break;
                        case 'MESSAGE_READ':
                            //only if we are on the message page
                            if (location.href.indexOf("inbox/view/") !== -1) {
                                $rootScope.$broadcast('ON_SOCKET_READ_MESSAGE', res);
                            }
                            break;
                        case 'SCHOOL_APPROVED':
                            $rootScope.refreshContext(0);
                            break;
                    }

                    setTimeout(function() {
                        refreshNotifications();
                    }, 1000);
                }
            }

            if (loc.includes('applyschool=true')) { //we should remove this adrian 11 jan 2018
                $state.go('schoolrequest.start');
            } else {
                //4. redirect in case we have some url
                if (internalRedirectURL && internalRedirectURL !== 'undefined') {
                    window.location.href = decodeURIComponent(internalRedirectURL);
                } else {
                    if (_psfa && _onboarding)
                        location.href = '/parent/#/home?psfa=' + _psfa + '&onboarding=' + _onboarding;
                    else if (_psfa)
                        location.href = '/parent/#/home?psfa=' + _psfa;
                    else if (_psfp)
                        location.href = '/parent/#/home?psfp=' + _psfp;
                    else
                    if (location.href.endsWith('/#/') || location.href.indexOf('/#/') === -1 || location.href.indexOf('?t=') > -1) {
                        //$state.go('home');
                        setTimeout(function() {
                            if ($state.current.name)
                                $state.go($state.current.name);
                            else
                                $state.go('home');
                        }, 500);
                    }
                }
            }

            if ($scope.virtualRedirectURL) {
                location.href = $scope.virtualRedirectURL;
                $scope.virtualRedirectURL = false;
            }

            $timeout(function() {
                $rootScope.context_loaded = true;
            }, 200);
        }

        $rootScope.toggleHRL = function(isopen) {
            var homeRefreshLabel = document.getElementsByClassName('home-refresh-label');

            if (homeRefreshLabel && homeRefreshLabel[0]) {
                if (isopen) {
                    homeRefreshLabel[0].classList.add('active-label')
                } else {
                    homeRefreshLabel[0].classList.remove('active-label')
                }
            }
        }

        function refreshRequired() {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/base/views/old-version-modal.html',
                backdropClass: 'backdrop-zindexed',
                backdrop: 'static',
                size: 'sm',
                controller: function($scope) {
                    $scope.confirm = function() {
                        location.reload(true)
                    }
                }
            })
        }

        function refreshNotifications(checkUpdate) {
            baseService.get('parent/v1/' + $rootScope.active_school.id + '/notification/list/new', { 'cache': false }).then(function(resp) {

                setTimeout(function() {
                    $scope.firstTimeLoading = false;
                    $scope.$apply()
                }, 1000);

                if (resp && resp.data && resp.data.payload) {
                    $rootScope.notifsContainer.messages = resp.data.payload.m;
                    $rootScope.notifsContainer.notifications = resp.data.payload.n;
                    $rootScope.notifsContainer.recommendations = resp.data.payload.r;
                    $rootScope.notifsContainer.home = resp.data.payload.h ? resp.data.payload.h : "0";
                    $rootScope.notifsContainer.events = resp.data.payload.e;
                    $rootScope.notifsContainer.marketplace = resp.data.payload.mp;
                    $rootScope.notifsContainer.adsManager = resp.data.payload.am ? resp.data.payload.am : "new";
                    $rootScope.schoolSideNotifications = resp.data.payload.s;

                    if (resp.data.payload.iV > 0) {
                        setTimeout(function() {
                            checkAppVersion(resp.data.payload.iV);
                        }, 3000);
                    }

                    //let the ui render
                    $timeout(function() {
                        pushContextToNative();
                    }, 100);

                    var refreshRequested = false;
                    if (getFrontendVersion() < resp.data.payload.v && resp.data.payload.x === false) {
                        //doServiceWorker(true)
                        refreshRequired()
                        refreshRequested = true;
                    }

                    if (document.cookie.indexOf('X-Source=experiment') > -1) {
                        if (resp.data.payload.x === false) {
                            if (!refreshRequested)
                                refreshRequired()
                        }
                    } else {
                        if (resp.data.payload.x === true) {
                            if (!refreshRequested)
                                refreshRequired()
                        }
                    }

                    // Set the 'experiment' flag for A/B testing
                    document.cookie = "X-Source=main; expires=Thu, 9 Dec 3000 12:00:00 UTC; path=/;";
                    $rootScope.active_user.x = false;

                    if (resp.data.payload.x === true) {
                        document.cookie = "X-Source=experiment; expires=Thu, 9 Dec 3000 12:00:00 UTC; path=/;";
                        $rootScope.active_user.x = true;
                    }

                    if ($rootScope.notifsContainer.home > 0) {
                        $rootScope.$broadcast('ON_GROUPS_LIST_BADGE_UPDATE');
                    }
                }
            });
        }

        $rootScope.refreshNotifications = refreshNotifications;

        function checkAppVersion(minimumIOSAppVersionRequired) {
            if (!getIfNative())
                return;

            //what the native says, it will be written down by the native app
            var nativeAppVersion = window.localStorage.getItem('iosappver');

            if (!nativeAppVersion)
                return;

            nativeAppVersion = nativeAppVersion.replace(/\./g, "");

            //if the native app is bigger then the frontend

            //native in prod                frontend
            if (parseInt(nativeAppVersion) < minimumIOSAppVersionRequired) {
                var modalInstance = $uibModal.open({
                    animation: true,
                    closeByEscape: false,
                    closeByDocument: false,
                    templateUrl: 'app/home/views/update-app-modal.html',
                    backdropClass: 'backdrop-zindexed',
                    size: 'sm',
                    controller: function($scope) {
                        $scope.confirm = function() {
                            window.open(getAppstoreUrl(), '_blank');
                        }

                        $scope.close = function() {
                            modalInstance.close();
                        }
                    }
                })
            }
        }

        function pushContextToNative() {
            //check version and invalidate if necessary
            if (!$rootScope.isNative) {
                return;
            }

            var os = getMobileOperatingSystem();

            var nativeStr = 'localNewNotification=' + $rootScope.notifsContainer.notifications +
                '&localNewMessage=' + $rootScope.notifsContainer.messages +
                '&localNewDirectory=0' +
                '&homeBadge=' + $rootScope.notifsContainer.home +
                '&adsManagerBadge=' + $rootScope.notifsContainer.adsManager +
                '&eventsBadge=' + $rootScope.notifsContainer.events +
                '&schoolId=' + $rootScope.active_school.id +
                '&school=' + ($rootScope.active_school.id + ' - ' + $rootScope.active_school.name) +
                '&userId=' + $rootScope.active_user.id +
                '&frontendVersion=' + (getFrontendVersion ? getFrontendVersion() : 'no_version') +
                '&pushToken=' + $rootScope.active_user.pushToken +
                '&isAdmin=' + $rootScope.active_school.admin;
            try {
                if (os === 'iOS') {
                    window.location = 'classlistnativeparent://context?' + nativeStr;
                } else if (os === 'Android') {
                    if (window.AndroidBridge) {
                        window.AndroidBridge.context(nativeStr);
                    }
                }
            } catch (ex) {
                //Skip for now.
            }
        }

        $scope.closeContactsSearch = function() {
            $rootScope.search_page = { active: false };
            $rootScope.$broadcast('ON_CLOSE_CONTACTS_SEARCH');
        }

        $rootScope.openNativeNotificationSettings = function() {
            var os = getMobileOperatingSystem();
            if (os === 'iOS') {
                window.location = 'classlistnativeparent://openSettings';
            } else if (os === 'Android') {
                if (window.AndroidBridge) {
                    window.AndroidBridge.openSettings();
                }
            }
        }

        $rootScope.checkIfPushSettingsAreOn = function() {
            var os = getMobileOperatingSystem();

            if (os == 'iOS' && $rootScope.isNative) {
                window.location = 'classlistnativeparent://arePushNotificationsEnabled';
            } else if (os === 'Android') {
                if (window.AndroidBridge) {
                    try {
                        window.AndroidBridge.arePushNotificationsEnabled();
                    } catch (ex) {
                        //Skip for now.
                    }
                }
            }
        }

        $scope.clearContactsSearch = function() {
            $rootScope.selectedContactsFilter.keyword = '';
            setTimeout(function() {
                var s_input = document.querySelector('.search-contacts-input')
                s_input.focus();
            });
        }

        $rootScope.$on('SECURITY_CHECK', function(evt, args) {
            var url = window.location.href.indexOf('?') > -1 ? window.location.href.split('?')[0] : window.location.href;
            location.href = settings.conf.ssoAppURL + '#/?ReturnUrl=' + encodeURIComponent(url);
        })

        $rootScope.$on('NOT_FOUND', function(evt, args) {
            $uibModal.open({
                animation: true,
                backdrop: 'static',
                backdropClass: 'backdrop-zindexed',
                templateUrl: 'app/base/views/not-found-modal.html',
                size: 'md',
                controller: function($scope) {
                    $scope.notFoundPost = false;

                    if (location.href.indexOf('#/post') > -1) {
                        $scope.notFoundPost = true;
                    }

                    gaService.send("/notfound/parent/view");

                    $scope.confirm = function() {
                        gaService.send("/notfound/parent/confirm");

                        setTimeout(function() {
                            location.reload(true);
                        }, 500);

                        location.href = settings.conf.parentAppURL;
                    };
                }
            })
        })

        //FIXME remove token from URL redirect
        $rootScope.switchSchoolById = function(schoolId) {
            storage.del('active_user', true);
            storage.del('active_school', true);
            storage.del('__c4', true);
            storage.del('__c5', true);

            var url = settings.conf.parentAppURL + '/#/?t=' + storage.getToken() + '&school=' + schoolId;

            if (storage.hasStorageEnabled) {
                $rootScope.writeParamsToLocalStorage(url);
                window.location = settings.conf.parentAppURL + "/";
            } else {
                window.location = url;
            }
        };

        $scope.switchSchool = function(object) {

            if (object.status === 'WAITING APPROVAL') {
                var modalInstance = $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    backdropClass: 'backdrop-zindexed',
                    templateUrl: 'app/base/views/pending-approval-modal.html',
                    size: 'md',
                    controller: function($scope) {
                        $scope.vm = {};
                        $scope.school_name = object.name;

                        $rootScope.getSchools(function(res) {
                            $scope.schools = res;
                        });

                        $scope.$watch('vm.password', function() {
                            $scope.deletingAccountError = '';
                        })

                        $scope.confirm = function() {
                            $scope.deletingAccount = true;

                            var values = navigator.platform + window.screen.height + window.screen.width + window.screen.colorDepth;
                            $scope.vm.dvcsgn = values;
                            $scope.vm.os = navigator.platform;
                            $scope.vm.email = $rootScope.active_user.email;
                            $scope.vm.school = object.id;

                            baseService.put('parent/v1/delete/myAccount', $scope.vm, {}).then(function(response) {
                                    authService.logout(false);
                                },
                                function(error) {
                                    $scope.deletingAccount = false;
                                    $scope.deletingAccountError = error.data.error.message;
                                });
                        }

                        // gaService.send("/notfound/parent/view");
                        $scope.close = function() {
                            modalInstance.close();
                        }
                    }
                })
            }

            if (object.status === 'DISABLED') {
                var modalInstance = $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    backdropClass: 'backdrop-zindexed',
                    templateUrl: 'app/base/views/disabled-modal.html',
                    size: 'md',
                    controller: function($scope) {
                        $scope.school = object.name;

                        $scope.close = function() {
                            modalInstance.close();
                        }

                        $scope.goToApply = function() {
                            location.href = settings.conf.parentAppURL + '#/apply/start'
                        }

                        $scope.gotoForgotPwd = function() {
                            window.location = settings.conf.ssoAppURL + '/#/forgot-password';
                        }

                        $scope.delete = function() {
                            $scope.deletingAccount = true;

                            var payload = {
                                dvcsgn: myValues,
                                os: myPlatform,
                                email: $rootScope.active_user.email,
                                school: object.id,
                                password: $scope.password
                            }

                            baseService.put('parent/v1/delete/myAccount', payload, {}).then(function(response) {
                                    toastr.info($translate.instant('DELETE_ACCOUNT_SUCCESS'));
                                    location.reload();
                                },
                                function(error) {
                                    $scope.deletingAccount = false;
                                    $scope.deletingAccountError = error.data.error.message;
                                });
                        }
                    }
                })
            }

            if (object.status === 'APPROVED') {
                $rootScope.switchSchoolById(object.id);
                return;
            }
        }


        $scope.toggleAccordion = function(accordion, section) {
            var currentState = accordion[section].open;

            $scope.closeAllAccordions(accordion);

            if (currentState) {
                accordion[section].open = false;
            } else {
                accordion[section].open = true;
            }
        }

        $scope.closeAllAccordions = function(accordion) {
            for (var key = 0; key < accordion.length; key++) {
                accordion[key].open = false;
            }
        }

        $scope.toggleProfileCard = function() {
            $scope.showProfileCard = !$scope.showProfileCard
        }

        $scope.closeProfileCard = function() {
            $scope.showProfileCard = false
        }

        $scope.toggleMenu = function() {
            $timeout(function() {
                $scope.showMobileMenu = !$scope.showMobileMenu;

                var container = document.getElementsByClassName('ui-view-container')[0];
                if ($scope.showMobileMenu) {
                    container.className = container.className + ' mobile-menu-open';
                } else {
                    container.className = container.className.replace(' mobile-menu-open', '');
                }
            }, 0)
        }

        $rootScope.switchApps = function(to) {
            $rootScope.switchingApps = true;

            var url = settings.conf.schoolAppURL;

            url += '/#/?t=' + storage.getToken() + '&school=' + $rootScope.active_school.id + '&switch=true';

            if (to) {
                url += '&url=' + encodeURIComponent(to);
            }

            $rootScope.writeParamsToLocalStorage(url);

            window.location.href = settings.conf.schoolAppURL + "?switch=true";
        }

        $scope.logout = function() {
            clearCache(false); //dont reload
            authService.logout();
        }

        $rootScope.composeTo = function(data, subject, baseURL) {
            $rootScope.nextCompose(data)
        }

        $scope.$on('COMPOSE_TO', function(evt, args) {
            $rootScope.composeTo(args)
        })

        $scope.uploadAvatar = function() {
            $scope.$broadcast('UPLOAD_PHOTO', {
                'callback_fn': function(response) {
                    $rootScope.$broadcast('AVATAR_UPDATE')
                },
                'action': 'avatarUpload',
                'config': 'avatarCropper'
            });
        }

        $rootScope.nativeCamPerm = function() {
            var os = getMobileOperatingSystem();
            try {
                if (os == 'iOS' && $rootScope.isNative) {
                    window.location = 'classlistnativeparent://campermission';
                } else if (os === 'Android') {
                    //Skip for now.
                }
            } catch (ex) {
                //Skip for now.
            }
        }

        $rootScope.getAds = function() {
            //try just in case we dont have active school etc
            try {
                if (!$rootScope.active_user || !$rootScope.active_school)
                    return;

                if (!$rootScope.active_user.emailVerified || !$rootScope.active_school.approved)
                    return;

                loadNextAdvert($rootScope.active_school.id, function(ads) {
                        $rootScope.ads = ads;
                        $rootScope.adsLoaded = true;
                    },
                    function() {

                    })
            } catch (ex) {
                //Skip for now.
            }
        }

        $rootScope.getPremiumAd = function() {
            try {
                loadPremiumAdvert($rootScope.active_school.id, function(ad) {
                        $rootScope.premium_ad = ad;
                    },
                    function() {

                    })
            } catch (ex) {
                //Skip for now.
            }
        }

        $scope.unauthorizedRedirection = function() {
            if (!window.location.href.includes('redirection=1') && isThisMobile()) {
                window.location = settings.conf.ssoAppURL + '/#/?unauthorized=parent&redirection=1&returnURL=' + encodeURIComponent(window.location.href);
            } else if (!isThisMobile()) {
                // if the link has /apply/start then redirect to the onboarding app
                if(window.location.href.includes('/apply/start')) {
                    window.location = settings.conf.onboardingAppURL;
                }else{
                    window.location = settings.conf.ssoAppURL + '/#/?unauthorized=parent';
                }
            }
        }

        //this is the entry point
        function entryPoint() {
            var school = $rootScope.getQueryParam('school');
            _psfa = $rootScope.getQueryParam('_psfa');
            _psfp = $rootScope.getQueryParam('_psfp');
            _onboarding = $rootScope.getQueryParam('_onboarding');
            internalRedirectURL = $rootScope.getQueryParam('url');
            loc = window.location.href;

            if (!school) {
                school = $rootScope.getQueryParam('s');
            }
            if (!school) {
                school = 0;
            }
            var isFromRedirect = true;
            var queryToken = $rootScope.getQueryParam('t');

            if (!queryToken) {
                queryToken = storage.getToken();
                isFromRedirect = false;
            }

            if (!queryToken) {
                $scope.unauthorizedRedirection();
                return;
            }

            var isNativeTemp = getIfNative() ? true : false;

            baseService.post('sso/v1/pusht', {
                'c': queryToken,
                'n': isNativeTemp
            }).then(function(response) {

                if (!response || !response.data || !response.data.c) {
                    $scope.unauthorizedRedirection();
                    return;
                }

                if (isFromRedirect) {
                    storage.del('__c1', true); //active school
                    storage.del('__c2', true); //active user
                }

                storage.del('tkn', true);
                storage.del('__c3', true);
                storage.setToken(response.data.c);

                if (isNativeTemp) {
                    if (getMobileOperatingSystem() === 'iOS') {
                        window.location = 'classlistnativeparent://pusht/' + storage.getToken();
                    } else if (getMobileOperatingSystem() === 'Android') {
                        if (window.AndroidBridge) {
                            window.AndroidBridge.pusht(storage.getToken());
                        }
                    }
                }
                $scope.rootContext(false, school);

            }, function(error) {
                console.log(error);
                $scope.unauthorizedRedirection();
            });
        }

        function loadNextAdvert(id_school, success, fail) {
            baseService.get('shared/v1/get/nextAdvert/' + id_school + '/BANNER/web_parent_banner', {}).then(function(response) {

                    var ads = response.data.items || [];
                    //we need to add the auth token to the links
                    for (var i = 0; i < ads.length; i++) {
                        var item = ads[i];
                        var randImage = Math.floor(Math.random() * item.artwork.length);
                        item.link = item.link + "&artI=" + randImage;
                        item.photo = item.artwork[randImage];
                    }
                    if (success)
                        success(ads);
                },
                function(error) {
                    if (fail)
                        fail();
                });
        }

        function loadPremiumAdvert(id_school, success, fail) {

            if (!$rootScope.active_user || !$rootScope.active_school)
                return;

            if (!$rootScope.active_user.emailVerified || !$rootScope.active_school.approved)
                return;

            baseService.get('shared/v1/get/nextAdvert/' + id_school + '/PREMIUM_BANNER/web_parent_banner', { 'cache': false }).then(function(response) {
                    var ads = response.data.items || [];
                    if (ads.length > 0) {
                        ads[0].link = ads[0].link;

                        if (success)
                            success(ads[0]);
                    } else {
                        if (success)
                            success();
                    }
                },
                function(error) {
                    if (fail)
                        fail();
                });
        }

        $rootScope.sendToNative = function() {
            $timeout(function() {
                pushContextToNative();
            }, 100)
        }

        $rootScope.refreshContext = function(schoolId) {
            if (!schoolId) {
                schoolId = $rootScope.active_school.id;
                if (!schoolId) {
                    schoolId = 0;
                }
            }
            $scope.rootContext(true, schoolId, true);
        }

        $rootScope.menuPlus = function(e, tierId) {
            if (e) {
                e.stopPropagation();
            }

            if (tierId && tierId > 0) {
                $rootScope.postingFrom = 'groups';
                $rootScope.postingFromGroupId = tierId;
            } else {
                $rootScope.postingFrom = 'home';
                $rootScope.postingFromGroupId = null;
            }
            location.href = "#/composer/post";
        }

        $scope.menuPlusMenu = function(e) {
            if (isThisMobile()) {
                $rootScope.userTag('PARENT_CREATE_BUTTON_CLICK_MOBILE');
            } else $rootScope.userTag('PARENT_CREATE_BUTTON_CLICK_DESKTOP');

            e.stopPropagation();

            $scope.showMenu = false;
            $scope.showPlus = !$scope.showPlus;
            document.body.classList.remove('overflow-hidden');
            htmlCorp.classList.remove('overflow-hidden');

            if ($scope.showPlus) {
                document.body.className += ' overflow-hidden';
                htmlCorp.className += ' overflow-hidden';
            }
        }

        $scope.menuMenu = function(e) {
            e.stopPropagation();
            $scope.showPlus = false;
            $scope.showMenu = !$scope.showMenu;
            document.body.classList.remove('overflow-hidden');
            htmlCorp.classList.remove('overflow-hidden');

            if ($scope.showMenu) {
                document.body.className += ' overflow-hidden';
                htmlCorp.className += ' overflow-hidden';
            }
        }

        $scope.closePlusMenu = function() {
            $scope.showPlus = false;
            $scope.showMenu = false;
            document.body.classList.remove('overflow-hidden');
            htmlCorp.classList.remove('overflow-hidden');
        }

        $scope.switchCommunityEvents = function() {
            $rootScope.switchApps('#/community-events/start?from=parent');
        }

        $scope.switchAnnouncement = function() {
            $rootScope.switchApps('#/announcements/list');
        }

        $scope.switchAnnouncementCreate = function() {
            $rootScope.switchApps('#/announcements/create');
        }

        $scope.postMarketplace = function() {
            $rootScope.postingFrom = 'listings';
            $state.go('listings.list');

            $rootScope.userTag('POST_INIT_FROM_PLUS_PAGE_WEB_MOBILE');
            //$state.reload();
        }

        $scope.help = function() {
            if (location.href.indexOf('/profile') > -1) {
                window.open('https://help.classlist.com/hc/en-us/articles/208434989-Lesson-5-Personal-Profile', '_blank');
                return;
            }

            window.open('https://help.classlist.com', '_blank');
        }

        $scope.adsManager = function() {
            window.open('https://app.classlist.com/business/#/?parent=true&utm_source=parent_web', '_blank');
        }

        $rootScope.getDomainFromUrl = function(url) {
            if (!url)
                return '';

            if (url.indexOf('www.') > -1)
                url = url.replace('www.', '');

            var a = document.createElement('a');
            a.href = url;
            return a.hostname;
        }

        $scope.checkCreateEvent = function() {
            var modalInstance = $uibModal.open({
                animation: true,
                scope: $scope,
                templateUrl: 'app/events/views/before-create-modal.html',
                backdropClass: 'backdrop-zindexed',
                size: 'md',
                controller: function($scope) {
                    $scope.switchRef = function() {
                        $rootScope.switchApps('#/community-events/start?from=parent');
                    }

                    $scope.close = function() {
                        modalInstance.close();
                        $scope.createEvent();
                    }
                }
            });
        }

        $scope.createEvent = function() {
            $scope.creatingEvent = true;
            baseService.get('event/v1/create/' + $rootScope.active_school.id + '/new', { 'cache': false }).then(function(response) {
                    $scope.creatingEvent = false;
                    $scope.event = response.data;
                    location.href = '/parent/#/events/create/' + $scope.event.id;
                },
                function(error) {

                })
        };

        //this is only called when client gets back the notifications
        function checkCache(force, version) {
            if (!window.applicationCache) {
                return;
            }

            if (force) {
                clearCache(true);
                return;
            }

            //https://stackoverflow.com/questions/1715568/how-to-properly-invalidate-an-html5-cache-manifest-for-online-offline-web-apps
            var cacheStatusValues = [];
            cacheStatusValues[0] = 'uncached';
            cacheStatusValues[1] = 'idle';
            cacheStatusValues[2] = 'checking';
            cacheStatusValues[3] = 'downloading';
            cacheStatusValues[4] = 'updateready';
            cacheStatusValues[5] = 'obsolete';

            // Listeners for all possible events
            var cache = window.applicationCache;

            cache.addEventListener('updateready', function(e) {
                if (cacheStatusValues[cache.status] !== 'idle') {
                    clearCache(true);
                }
            }, false);
        }

        function clearCache(forceReload) {
            if (!window.applicationCache) {
                return;
            }

            try {
                window.applicationCache.swapCache();
                //we need to clean local storage for requests as well
                for (var i = 0, len = localStorage.length; i < len; ++i) {
                    if (localStorage.key(i) && localStorage.key(i).indexOf('aHR0cHM') > -1) {
                        localStorage.removeItem(localStorage.key(i));
                    }
                }
            } catch (ex) {
                //ignore
            }

            if (forceReload) {
                if ($rootScope.isNative) {
                    var os = getMobileOperatingSystem();
                    if (os === 'iOS') {
                        window.location = 'classlistnativeparent://invalidate';
                    }
                }
            }
        }

        //this function will check the local storage and return a school and user if exists
        function checkCacheForContext(currentSchoolId) {
            var active_school = storage.get('__c1', true, true);
            var active_user = storage.get('__c2', true, true);

            if (active_user && active_school) {
                try {
                    //there is a new school so we need to refresh PWA-3778
                    var currentActiveSchool = JSON.parse(window.atob(active_school));
                    if (currentSchoolId !== 0 && currentActiveSchool && currentActiveSchool.id !== currentSchoolId) {
                        return;
                    }

                    var _active_user = JSON.parse(window.atob(active_user))
                    _active_user.avatar = _active_user.avatar + '?v=' + new Date().getTime()

                    // currentActiveSchool.logo = currentActiveSchool.logo + '?v=' + new Date().getTime()

                    $rootScope.active_user = _active_user;
                    $rootScope.active_school = currentActiveSchool;

                    Raven.setUserContext({
                        id: _active_user
                    });
                } catch (ex) {
                    //Skip for now.
                }
            }
        }

        $rootScope.isDevice = function() {
            var check = false;
            (function(a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
            return check;
        };

        $rootScope.openWhatsappNative = function(whatToShare) {
            if (!$rootScope.isNative) {
                return;
            }

            if (getMobileOperatingSystem() === 'iOS') {
                window.location = 'classlistnativeparent://share/' + whatToShare;
            } else if (getMobileOperatingSystem() === 'Android') {
                if (window.AndroidBridge) {
                    window.AndroidBridge.share(whatToShare);
                }
            }
        }

        $rootScope.openFacebookNative = function(whatToShare) {
            if (!$rootScope.isNative) {
                return;
            }
            if (getMobileOperatingSystem() === 'iOS') {
                window.location = 'classlistnativeparent://share/' + whatToShare;
            } else if (getMobileOperatingSystem() === 'Android') {
                if (window.AndroidBridge) {
                    window.AndroidBridge.share(whatToShare);
                }
            }
        }

        $rootScope.gotoAppStore = function() {
            window.location.href = 'https://itunes.apple.com/gb/app/classlist/id1058636226?mt=8';
        }

        $rootScope.gotoGooglePlay = function() {
            window.location.href = 'https://play.google.com/store/apps/details?id=com.classlist.parent&hl=en_GB'
        }

        $rootScope.previewImage = function(url) {
            previewImages([url])
        }

        /*
        $rootScope.previewImages = function (arrayOfImages) {
        	if (!arrayOfImages) {
        		return;
        	}

        	var isArray = Array.isArray(arrayOfImages);
        	if (!$rootScope.isNative || getMobileOperatingSystem() == 'Android') {
        		if (isArray) {
        			window.open(arrayOfImages[0] + '=s0', '_blank');
        		} else {
        			window.open(arrayOfImages, '_blank');
        		}
        		return;
        	} else {
        		if (getMobileOperatingSystem() === 'iOS') {
        			if (isArray) {
        				window.location = 'classlistnativeparent://images/' + arrayOfImages.join(',');
        			} else {
        				window.location = 'classlistnativeparent://images/' + arrayOfImages;
        			}
        		}
        	}
        }*/

        $rootScope.back = function(fallback) {
            if (document.referrer !== "") {
                $window.history.back();
            } else {
                if (fallback)
                    $window.location = fallback;
                else
                    location.href = '/parent/#/home';
            }
        };

        $rootScope.isNumeric = function(n) {
            return /\d/.test(n);
        }

        $rootScope.getInitials = function(name) {
            var result = '';

            if (name) {
                if (name.indexOf(' ') > -1) {
                    var split = name.split(/ (.+)/);

                    if (split && split.length > 1) {
                        if (split[0].length > 0)
                            result = split[0].trim()[0];

                        if (split[1].length > 0)
                            result += split[1].trim()[0];
                    }
                } else {
                    if (name && name.length > 0)
                        result = name[0];
                }
            }

            return result;
        }

        $rootScope.getInitial = function(name) {
            var result = '';

            if (name && name.length > 0)
                result = name[0];

            return result;
        }

        $rootScope.randomColor = function() {
            var num = Math.floor((Math.random() * 8) + 1)
            return num;
        }

        entryPoint();

        $rootScope.copyToClipboard = function(text) {
            if (!document.body)
                return;

            var copyElement = document.createElement("span");
            copyElement.appendChild(document.createTextNode(text));
            copyElement.id = 'tempCopyToClipboard';
            angular.element(document.body.append(copyElement));

            var range = document.createRange();
            range.selectNode(copyElement);
            window.getSelection().removeAllRanges();
            window.getSelection().addRange(range);

            document.execCommand('copy');
            window.getSelection().removeAllRanges();
            copyElement.remove();
        }

        $rootScope.goback = function() {
            if ($window.history.length > 2) {
                $window.history.back();
            } else {
                $window.location.href = '/parent/#/home';
            }
        }

        $rootScope.writeParamsToLocalStorage = function(url) {
            var urlParamsAsObject = $rootScope.getUrlParamsAsMap(url);
            for (var k in urlParamsAsObject) {
                if (urlParamsAsObject.hasOwnProperty(k)) {
                    window.localStorage.setItem(k, urlParamsAsObject[k]);
                }
            }
        }

        $rootScope.getUrlParamsAsMap = function(url) {
            // get query string from url (optional) or window
            var queryString = url ? url.split('?')[1] : window.location.search.slice(1);
            // we'll store the parameters here
            var obj = {};
            // if query string exists
            if (queryString) {
                // stuff after # is not part of query string, so get rid of it
                queryString = queryString.split('#')[0];
                // split our query string into its component parts
                var arr = queryString.split('&');
                for (var i = 0; i < arr.length; i++) {
                    // separate the keys and the values
                    var a = arr[i].split('=');

                    // set parameter name and value (use 'true' if empty)
                    var paramName = a[0];
                    var paramValue = typeof(a[1]) === 'undefined' ? true : a[1];

                    // if the paramName ends with square brackets, e.g. colors[] or colors[2]
                    if (paramName.match(/\[(\d+)?\]$/)) {

                        // create key if it doesn't exist
                        var key = paramName.replace(/\[(\d+)?\]/, '');
                        if (!obj[key]) obj[key] = [];

                        // if it's an indexed array e.g. colors[2]
                        if (paramName.match(/\[\d+\]$/)) {
                            // get the index value and add the entry at the appropriate position
                            var index = /\[(\d+)\]/.exec(paramName)[1];
                            obj[key][index] = paramValue;
                        } else {
                            // otherwise add the value to the end of the array
                            obj[key].push(paramValue);
                        }
                    } else {
                        // we're dealing with a string
                        if (!obj[paramName]) {
                            // if it doesn't exist, create property
                            obj[paramName] = paramValue;
                        } else if (obj[paramName] && typeof obj[paramName] === 'string') {
                            // if property does exist and it's a string, convert it to an array
                            obj[paramName] = [obj[paramName]];
                            obj[paramName].push(paramValue);
                        } else {
                            // otherwise add the property
                            obj[paramName].push(paramValue);
                        }
                    }
                }
            }
            return obj;
        }

        $rootScope.checkIfPostIsLegal = function(isMarketplace, post, onCancel, onContinue) {
            var open = function() {
                var template = isMarketplace ? 'app/base/views/before-posting-marketplace-modal.html' : 'app/base/views/before-posting-modal.html';
                var modalInstance = $uibModal.open({
                    animation: true,
                    scope: $scope,
                    templateUrl: template,
                    backdropClass: 'backdrop-zindexed',
                    controller: function() {
                        $scope.keepPostingHere = function() {
                            modalInstance.close();
                            onContinue(post);
                        };
                        $scope.createAd = function() {
                            modalInstance.close();
                            window.location.href = "https://app.classlist.com/business/#/?parent=true&utm_source=parent_web";
                        };
                        $scope.close = function() {
                            modalInstance.close();
                            onCancel(post);
                        };
                    },
                    size: 'md'
                });
            };

            var keyWords = [
                "looking for",
                "to register",
                "to book",
                "come and join",
                "go to our website",
                "fitness classes",
                "personal training",
                "services include",
                "offer gift",
                "workshop"
            ]

            var isPostLegal = function(post) {
                if (!post || !post.body) {
                    return true;
                }

                var body = post.body.toLowerCase();
                var regex = "\\[(.+?)\\](.+?)\\[/(.+?)\\]";
                body = body.replaceAll(regex, "");

                if (isMarketplace) {
                    //detect links 
                    var linkExpression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
                    var matches = body.match(linkExpression);
                    if (matches !== null) {
                        return false;
                    }

                    //detect keywords
                    for (var i = 0; i < keyWords.length; i++) {
                        if (body.indexOf(keyWords[i].toLowerCase()) > -1) {
                            return false;
                        }
                    }
                }

                //detect phone numbers			
                var phoneExpression = /(?:(?:\+?([1-9]|[0-9][0-9]|[0-9][0-9][0-9])\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([0-9][1-9]|[0-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?/gi;
                matches = body.match(phoneExpression);
                if (matches !== null) {
                    return false;
                }

                //detect email addresses
                var emailExpression = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])?/gi;
                matches = body.match(emailExpression);
                if (matches !== null) {
                    return false;
                }

                return true;
            }

            if (isPostLegal(post)) {
                onContinue(post);
            } else {
                open();
            }
        }

        $rootScope.openFriendshipBench = function() {
            window.location.href = settings.conf.api + "/friendshipRoomRedirect?sid=" + $rootScope.active_school.id;
        }

        $rootScope.isFriendshipBetaSchool = function() {
            if (!$rootScope.active_school) {
                return false;
            }
            if ($rootScope.active_school.budiEnabled) {
                return true;
            }
            return false;
        }

        /*
         * This function is responsible from truncating
         * the links inside the announcement body,
         * which are redirecting to classlist.
         * For example 'https://app.classlist.com/parent/#/events/view/5230857847570432'
         * will be truncated as '#/events/view/5230857847570432'
         */
        $rootScope.truncateClasslistLinks = function(post) {
            if (!post.body) {
                return;
            }
            var linkRx = /<a\s+(?:[^>]*?\s+)?href=(["'])(.*?)\1/;
            var thisRx = /href=\"(.*?)\"/g;
            var newLink = "";
            var matches = post.body.match(thisRx);
            var indexOfLastTruncatedLink = 0;
            if (matches !== null) {
                for (var i = 0; i < matches.length; i++) {
                    // Fix so that only links to the parent app in the right env get truncated
                    if (matches[i].includes(settings.conf.parentAppURL)) {
                        var idx = matches[i].indexOf('/parent/#');
                        // last character of matching is ", so don't take it to avoid duplicate.
                        newLink = matches[i].substring(idx, matches[i].length - 1);
                        var replacePart = post.body.substring(indexOfLastTruncatedLink).match(linkRx);
                        if(replacePart && replacePart.length > 1){
                            indexOfLastTruncatedLink = idx + newLink.length
                            post.body = post.body.replace(replacePart[2], newLink)
                            post.body = post.body.replace("target=\"_blank\"", 'newLink')
                        }
                    }
                }
            }
        }

        $rootScope.truncateClasslistPostsLinks = function(post) {
            if (!post.body) {
                return;
            }
            var linkRx = /<a\s+(?:[^>]*?\s+)?href=(["'])(.*?)\1/;
            var thisRx = /href=\"(.*?)\"/g;
            var newLink = "";
            var matches = post.body.match(linkRx);
            var indexOfLastTruncatedLink = 0;
            if (matches !== null) {
                for (var i = 0; i < matches.length; i++) {
                    // Fix so that only links to the parent app in the right env get truncated
                    if (matches[i].includes(settings.conf.parentAppURL)) {
                        var idx = matches[i].indexOf('/parent/#');
                        // last character of matching is ", so don't take it to avoid duplicate.
                        newLink = matches[i].substring(idx, matches[i].length - 1);
                        var replacePart = post.body.substring(indexOfLastTruncatedLink).match(thisRx);
                        if(replacePart && replacePart.length > 1){
                            indexOfLastTruncatedLink = idx + newLink.length
                            post.body = post.body.replace(replacePart[2], newLink)
                            post.body = post.body.replace("target=\"_blank\"", 'newLink')
                        }
                    }
                }
            }
        }

        $rootScope.goToGroup = function(group, isdiscover, groups) {
            if (group.status !== 'APPROVAL_NEEDED' && group.status !== 'PENDING_APPROVAL') {
                if (isdiscover) {
                    window.location.href = '#/groups/view/' + group.id;
                } else {
                    if (group.notificationCount) {
                        var notificationCountAsInt = parseInt(group.notificationCount);

                        var updatedCount = $rootScope.notifsContainer.home - notificationCountAsInt;
                        if (updatedCount < 0) {
                            updatedCount = 0;
                        }
                        $rootScope.notifsContainer.home = updatedCount;
                        $rootScope.sendToNative();
                    }

                    $rootScope.activityStreamTierId = group.id;
                    $rootScope.postingFrom = 'groups';
                    // If group clicked on is marketplace, take them to listing page.
                    if (group.type == 'MARKETPLACE') {
                        window.location.href = '#/listings/list'
                    } else window.location.href = '#/stream';
                }
            } else {
                if (group.status === 'PENDING_APPROVAL') {
                    toastr.info($translate.instant('REQUEST_SENT_INFO_LATER'))
                } else {
                    var open = function() {
                        var modalInstance = $uibModal.open({
                            animation: true,
                            scope: $scope,
                            templateUrl: 'app/groups/views/request-modal.html',
                            backdropClass: 'backdrop-zindexed',
                            controller: function() {
                                $scope.disableRequest = false;
                                $scope.group = group;

                                $scope.request = function() {
                                    $scope.disableRequest = true;
                                    groupsService.get('group/v1/parent/' + group.id + '/join').then(function(response) {
                                            if (groups) {
                                                var realGroups = groups[0]; //I dont know why
                                                if (!_.isUndefined(realGroups)) {
                                                    for (var i = 0; i < realGroups.length; i++) {
                                                        if (realGroups[i].id === group.id) {
                                                            realGroups[i].status = 'PENDING_APPROVAL';
                                                        }
                                                    }
                                                }
                                                groups[0] = realGroups;
                                            }
                                            toastr.info($translate.instant('REQUEST_SENT_INFO'))
                                            modalInstance.close();
                                        },
                                        function(error) {
                                            console.log(error)
                                        })
                                }

                                $scope.close = function() {
                                    modalInstance.close();
                                };
                            },
                            size: 'md'
                        });
                    }
                    open();
                }
            }
        }

        $rootScope.getServingURL = function(url, size, crop) {
            if (url && url.indexOf('googleusercontent') > -1) {
                var newURL = url.split("?")[0];
                newURL += '=s' + size;
                if (crop) {
                    newURL += '-c';
                }
                return newURL;
            } else {
                return url;
            }
        }
    }
})();
var google;

(function () {

	'use strict';
	/**
	 * @ngdoc directive
	 * @name runmap:runmap
	 * @description
	 * <ul>
	 * <li>Displays a Google Maps</li>
	 * <li>Centers the map on parent</li>
	 * <li>Displays pins on the map from a parents array lat-long pairs</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */
	angular.module('directives.runmap', []).directive('runmap', runmap);
	/** @ngInject */
	function runmap(settings, $timeout, storage, $rootScope) {

		var directive =  {
			restrict: 'EA',
			replace:true,
			scope:{
				config: '=',
				myname: '='
			},
			template:'<aside id="map"></aside>',
			link: linkFunction
		};

		return directive;

		function linkFunction(scope, elem, attrs) {
			var map;
			var markers = [];
			var sClassFilter = '', sParentFilter = {name:''};
			var currZoom;
			
			scope.$watch('config', function(newVal) {
				!_.isUndefined(newVal) ? init(setMap) : _.noop()
			});
			
			function addMarker(parent, isMe) {
				if(parent.lat && parent.lng && parent.id) {
					if(google) {
						var marker = new google.maps.Marker({
							position: { 'lat': parent.lat, 'lng': parent.lng },
							icon: (isMe ? 'assets/images/map-marker-me.svg' : 'assets/images/map-marker.svg'),
							animation: google.maps.Animation.DROP,
							map: map
						});
					}
				}
			}
			
			function addCLMarker(parent, args) {
				if(parent.lat && parent.lng) {
					var body;
					var m_icon;
					var tooltip;
					var img;
					var CL_Marker;

					CL_Marker = function(latlng, map, args) {
						this.latlng = latlng;	
						this.args = args;	
						this.setMap(map);	
					}

					if(google) {
						CL_Marker.prototype = new google.maps.OverlayView();

						CL_Marker.prototype.draw = function() {
							var self = this;
							
							if (parent.name.includes(scope.myname)) {
								scope.config.currentParent = parent;
								
							}

							if (!body) {
								body = this.body = document.createElement('div');
								body.className = this.args.cssClass;
							
								m_icon = this.m_icon = document.createElement('div');
								m_icon.className = 'vi-map-marker';

								var letter_avatar = document.createElement('div');
								letter_avatar.className = 'letter-avatar letter-map-avatar letter-color-'
									+ $rootScope.getInitial(parent.name.toLowerCase());
								
								var letter_avatar_div_1 = document.createElement('div');
								letter_avatar_div_1.style.cssText = 'position: relative;';
								
								var letter_avatar_div_2 = document.createElement('div');
								var letter_avatar_div_3 = document.createElement('div');

								letter_avatar_div_2.innerHTML = $rootScope.getInitials(parent.name)
								letter_avatar_div_3.className = 'avatar-picture';

								if(!this.args.school)
									letter_avatar_div_3.style.cssText = 'background-image: url(' + this.args.avatar + '?v=' + new Date().getTime() + ');';
								else
									letter_avatar_div_3.style.cssText = 'background-image: url("' + this.args.avatar + '"), url("assets/icons/default-school-logo.png");';

								letter_avatar_div_1.appendChild(letter_avatar_div_2);
								letter_avatar_div_1.appendChild(letter_avatar_div_3);

								letter_avatar.appendChild(letter_avatar_div_1);
								
								tooltip = this.tooltip = document.createElement('div');
								tooltip.className = 'vi-marker-tooltip';

								var ttip_text_name = document.createElement('a');
								ttip_text_name.className = 'vi-marker-ttp-text ttp-name';
								ttip_text_name.innerHTML = parent.name;
								ttip_text_name.onclick = function () {
									
									if (sParentFilter && sParentFilter.name) {
										storage.set('sParentFilter', sParentFilter, true);
									}
									
									storage.set('sClassFilter', sClassFilter, true);
									storage.set('currZoom', currZoom, true);
									storage.set('currParent', parent, true);

									location.href = settings.conf.parentAppURL + '#/classlist/details/'+parent.id+'/contact';
								};

								if(!this.args.school)
									tooltip.appendChild(ttip_text_name);

								var ttip_text_children = document.createElement('div');
								ttip_text_children.className = 'vi-marker-ttp-text';

								var tier_ids = '';
								
								if(parent.pupils) {
									for(var i = 0; i < parent.pupils.length; i++) {
										ttip_text_children.innerHTML 
											+= (parent.pupils[i].fN.toLowerCase() + ' ' + parent.pupils[i].lN.toLowerCase());

										if(i < parent.pupils.length-1)
											ttip_text_children.innerHTML += ', ';

										tier_ids += parent.pupils[i].fTI + ' ' + parent.pupils[i].sTI + ' ';
									} 
									tooltip.appendChild(ttip_text_children);
								}

								m_icon.appendChild(letter_avatar)

								body.appendChild(m_icon);
								body.appendChild(tooltip);
								
								if (typeof(self.args.marker_id) !== 'undefined') {
									body.dataset.marker_id = self.args.marker_id;
								}
								
								google.maps.event.addDomListener(m_icon, "click", function(event) {			
									google.maps.event.trigger(self, "click");
								});
								
								this.search = parent.name.toLowerCase() + ' '
									+ ttip_text_children.innerText + ' ' 
									+ tier_ids;

								var panes = this.getPanes();
								panes.overlayImage.appendChild(body);
							}
							
							var point = this.getProjection().fromLatLngToDivPixel(this.latlng);
							
							if (point) {
								body.style.left = point.x + 'px';
								body.style.top = point.y + 'px';
							}
						};

						CL_Marker.prototype.remove = function() {
							if (this.body) {
								this.body.parentNode.removeChild(this.body);
								this.body = null;
							}	
						};

						CL_Marker.prototype.getPosition = function() {
							return this.latlng;	
						};

						CL_Marker.prototype.hide = function() {
							if (this.body) {
								this.body.style.visibility = 'hidden';
							}
						};

						CL_Marker.prototype.show = function() {
							if (this.body) {
								this.body.style.visibility = 'visible';
							}
						};
						
						var overlay = new CL_Marker(
							new google.maps.LatLng(parent.lat, parent.lng), 
							map,
							args
						);
						
						overlay.addListener('click', function() {
							if(tooltip.innerText === '')
								return; 
							
							var tooltips = document.querySelectorAll('.vi-marker-tooltip')
							if(tooltips)
								for(var i = 0; i < tooltips.length; i++) {
									tooltips[i].style.display = 'none';
								}

							if(tooltip.style.display === 'block')
								tooltip.style.display = 'none';
							else
								tooltip.style.display = 'block';
						})

						markers.push(overlay);
					}
				}
			}
			
			function init(callback) {
				
				var googleMapApi = document.getElementById('googleMapApi');
				
				if(googleMapApi === null){
					var script = document.createElement('script');					
					script.setAttribute('id', 'googleMapApi');
					script.setAttribute('type', 'text/javascript');
					script.setAttribute('async', 'false');
					script.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBRu4QITo8XKFSpTDtQmDff_0IXqlDdWkI&force=canvas');
					script.onreadystatechange = script.onload = function() {
						if (!script.readyState || /loaded|complete/.test(script.readyState)) {
							callback();
						}
					};
					document.body.appendChild(script);

				}
				else {
					callback();
				}
			}

			function setMapPositionAndZoom(map, school){
				if(google) {
					if (school && school.lat &&  school.lng) {
						var location = storage.get('sMapCenter', true, true);
						if (location && location !== '') {
							try{
								location = JSON.parse(location);
								map.setCenter(new google.maps.LatLng(location.lat, location.lng));
							}catch (ex){
								map.setCenter(new google.maps.LatLng(school.lat, school.lng));
							}
							
						} else {
							map.setCenter(new google.maps.LatLng(school.lat, school.lng));
						}
					}
				}
			}

			function setMap() {
				var school = { };

				if(storage.get('currParent', true, true)) {
					school = { 
						'lat': parseFloat(storage.get('currParent', true, true).lat), 
						'lng': parseFloat(storage.get('currParent', true, true).lng)
					}
				}
				else {
					if(!scope.config.school) {
						if(scope.config.parents && scope.config.parents.length > 0) {
							for (var i = 0; i < scope.config.parents.length; i++) {
								if (scope.config.parents[i].name.includes(scope.myname)) {
									school = { 
										'lat': parseFloat(scope.config.parents[i].lat), 
										'lng': parseFloat(scope.config.parents[i].lng)
									}
								} 
							}

						}
					}
					else {
						school = { 
							'lat': parseFloat(scope.config.school.lat), 
							'lng': parseFloat(scope.config.school.lng)
						}
					}
				}
				
				currZoom = settings.runmap.zoom;
				var tempZoom = storage.get('currZoom', true, true);
				if (tempZoom && tempZoom > 1){
					currZoom = tempZoom;
				}

				try {
					if(google) {
						map = new google.maps.Map(elem[0], {
							zoom: currZoom,
							styles: [
								{
									featureType: "administrative",
									elementType: "labels",
									stylers: [
									{ visibility: "true" }
									]
								},{
									featureType: "poi",
									elementType: "labels",
									stylers: [
									{ visibility: "off" }
									]
								},{
									featureType: "transit.station",
									elementType: "labels",
									stylers: [
									{ visibility: "off" }
									]
								}
							]
						});

						google.maps.event.addListener(map, 'zoom_changed', function() {
							settings.runmap.zoom = map.getZoom();
							storage.set('currZoom', settings.runmap.zoom, true)
						});

						google.maps.event.addListener(map, 'idle', function() {
							if (map.getCenter()){
								storage.set('sMapCenter', JSON.stringify(map.getCenter()), true)
							}
						});
					}
				}
				catch(ex) {
					//Skip for now.
				}
				
				var parentsLength;
				if (_.isUndefined(scope.config.parents)) {
					parentsLength = 0;
				} 
				else {
					parentsLength = scope.config.parents.length
				}
				
				if(parentsLength > 0) {
					_.forEach(scope.config.parents, function(parent) {
						addCLMarker(parent, {
							cssClass: 'vi-map-body',
							avatar: parent.avatar,
							avatarError: '/assets/icons/default-avatar.png'
						});
					})
				}

				if(scope.config.school) {
					addCLMarker(scope.config.school, {
						cssClass: 'vi-map-school',
						avatar: scope.config.school.logo,
						avatarError: '/assets/icons/default-school-logo.png',
						school: true
					});
				}

				if(scope.config.currentParent) {
					if(scope.config.currentParent.lat) {
						school = scope.config.currentParent;
						addMarker(scope.config.currentParent, true);

						if(google) {
							google.maps.event.trigger(map, 'resize');
							setMapPositionAndZoom(map, school);
						}
					}
					
					scope.$watch('config', function(newVal) {
						school = scope.config.currentParent;
						addMarker(scope.config.currentParent, true);

						if(google) {
							google.maps.event.trigger(map, 'resize');
							setMapPositionAndZoom(map, school);
						}
					});
				}
				
				setTimeout(function() {
					if(google) {
						google.maps.event.trigger(map, 'resize');
						
						setMapPositionAndZoom(map, school);
					
						setTimeout(function() {
							if(storage.get('sClassFilter', true, true))
								scope.config.onClassFilter(storage.get('sClassFilter', true, true));
							
							if(storage.get('sParentFilter', true, true) && storage.get('sParentFilter', true, true).name)
								scope.config.onSearchSelected(storage.get('sParentFilter', true, true));
						}, 1)

						if(storage.get('currZoom', true, true))
							currZoom = storage.get('currZoom', true, true);
					
						map.setZoom(currZoom);

						google.maps.event.addListener(map, 'zoom_changed', function() {
							currZoom = map.getZoom();
						});

						scope.config.onClassFilter();
					}
				});

				setTimeout(function() {
					storage.set('sClassFilter', '', true)
					storage.set('sParentFilter', {}, true)
					storage.set('currZoom', '', true)
					storage.set('currParent', '', true)
					sParentFilter = { };
				}, 2000);
			
				scope.config.onClassFilter = function(value) {
					if(value) {
						sClassFilter = value;
						for (var i = 0; i < markers.length-1; i++) {
							
							//PWA-4778
							if (!markers[i].search){
								continue;
							}

							if (markers[i].search.toLowerCase().indexOf(sClassFilter.toLowerCase()) > -1) {
								if(markers[i].tooltip)
									markers[i].tooltip.style.display = 'none';
									markers[i].show();
							} 
							else {
								markers[i].hide();
							}
						}
					}
					else {
						sClassFilter = '';

						for (var i = 0; i < markers.length-1; i++) {
							if(markers[i].tooltip){
								markers[i].tooltip.style.display = 'none';
							}
							markers[i].show();
						}
					}

					setTimeout(function() {
						scope.$apply();
					}, 2);
				}

				scope.config.onSearchSelected = function(value) {
					if(google) {
						currZoom = 16;
						
						sParentFilter = value;

						map.setCenter(new google.maps.LatLng(value.lat, value.lng));
						map.setZoom(currZoom);
						
						for (var i = 0; i < markers.length-1; i++) {

							if(markers[i].tooltip){
								markers[i].tooltip.style.display = 'none';
							}
							markers[i].show();

							if(markers[i]) {
								if (markers[i].search && (markers[i].search.toLowerCase().indexOf(sParentFilter.name.toLowerCase()) > -1
									&& markers[i].search.toLowerCase().indexOf(sClassFilter.toLowerCase()) > -1)) {
									if(markers[i].tooltip){
										markers[i].tooltip.style.display = 'block';
									}
									markers[i].show();
								}
							}
						}

						scope.$apply();
					}
				}
			} //end set map?? adrian 1st aug 2018


		}
	}

})();

(function() {
	'use strict';

	angular.module('modules.events.paymentsuccess',[]).factory('eventTicketsService', ['base', function (base) {
		return _.create(base, { });
	}]).controller('eventPaymentSuccessController', eventPaymentSuccessController);

	/** @ngInject */
	function eventPaymentSuccessController(baseService, $scope, $state, regexes, $uibModal, settings, toastr, $translate, eventTicketsService, $location, $anchorScroll, $timeout, $rootScope, $window, $stateParams, storage) {
		$scope.id_event = $stateParams.id_event;
		$scope.lid = $stateParams.lid;
		$scope.isview = !$scope.lid;
		$scope.validateEmail = validateEmail;
		$scope.hasQuestions = true;
		$scope.viewState = {
			isReady: false
		};

		$scope.returnTicket = function(ticketId, index) {
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/events/views/return-ticket-modal.html',
				size:'md',
				controller: function($scope) {
					$scope.continue = function() {
						eventTicketsService.get('event/v1/return/' + ticketId + '/ticket', {'cache':false, 'xhr':true}).then(function(response) {
							$scope.event.tickets.splice(index, 1);
							modalInstance.close();
						}, function(error) {
							modalInstance.close();
						});
					}
					$scope.close = function() {
						modalInstance.close();
					};
				}
			})
		}

		// Init the beforeunlodpage on this page
		var onBeforeunload = $rootScope.$on('events.paymentsuccess', function(evt, args) {
			var anychange = false;

			if (!$scope.event || !$scope.event.tickets) return;
			
			for(var i = 0; i < $scope.event.tickets.length; i++) {
				var a = $scope.event.tickets[i]
				if(a.addNote) {
					anychange = true;
					break;
				}
			}

			if(anychange) {
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/base/views/window-beforeleave-modal.html',
					size:'md',
					controller: function($scope) {
						$scope.leave = function() {
							onBeforeunload();
							$state.go(args.toState.name, args.toParams);
						}
						$scope.stay = function() {
							modalInstance.close();
						};
					}
				})

				args.e.preventDefault();
			}
			else {
				onBeforeunload();
			}
		});

 
		$scope.getEvent = function() {
			angular.element(document).ready(function() {
				
				eventTicketsService.get('event/v1/get/private/' + $scope.id_event + '/v2', {'cache':false, 'xhr':true}).then(function(response) {
					$scope.event = response.data;
					
					if($scope.lid) {
						eventTicketsService.get('payment/v1/get/' + $scope.lid+'/v2', { 'cache': false, 'xhr': true }).then(function(response) {
							var new_tickets = []
							
							if(response.data.boughtTickets) {
								$scope.event.paymentProvider = response.data.paymentProvider;
								for(var i = 0; i < response.data.boughtTickets.length; i++) {
									var idx = response.data.boughtTickets[i]
							
									new_tickets.push({
										id: idx.id,
										ticketName: idx.ticketName,
										ticketPrice: idx.ticketPrice,
										confirmed: idx.confirmed,
										ticketCurrency: response.data.currency,
										questions: idx.questions
									})
								}
							}

							$scope.event.tickets = new_tickets;
							$scope.hasQuestions = $scope.event.tickets.some(function(ticket) {
								return ticket.questions && ticket.questions.length > 0;
							});
							$scope.viewState.isReady = true;
						}, 
						function(error) {
							
						})
					}
					else {
						$scope.viewState.isReady = true;
					}
				},
				function(error) {

				})
			});
		}

		$scope.putNote = function(ticketId, singleNote) {
			singleNote.addAnswer = false;

			var requestObj = {
				"note": singleNote.answerTitle,
				"questionId": singleNote.questionId
			}
			eventTicketsService.put('event/v1/update/' + ticketId + '/note/v2', requestObj, { }).then(function(response) {
				toastr.success('Your answer has been saved');
			},
			function (error) {
				ticket.addAnswer = true;
				toastr.success('We encountered a problem while saving your answer. Please try again.');
			});
		}

		$scope.getTicketsCount = function(list) {
			var count = 0;

			if(!list)
				return count;

			for(var i = 0; i < list.length; i++)
				count += list[i].quantity;

			return count;
		}
		
		baseService.app_initialized = function(evt, args) {
			$scope.getEvent()
		}

		if($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}
	}
})();

var WSS = {
    _socket: null,
    _server: null,

    init: function(server) {
        this._server = server;

        if (this._socket && this._socket.connected) {
            return;
        }

        this._socket = io(server, { upgrade: false, transports: ['websocket'] });

        var _this = this;

        this._socket.on('connect', function() {
			if (_this.onConnected) _this.onConnected();
        });

        this._socket.on('message', function(data) {
            if (_this.onPush) _this.onPush(data);
        });

        this._socket.on('disconnect', function() {
            if (_this.onClosed) _this.onClosed();
            setTimeout(function() {
                if (!document.hidden) {
                    _this.init(_this._server);
                }
            }, 5000);
        });

        if (document.addEventListener) {
            var tout;
            document.addEventListener("visibilitychange", function() {
                if (tout) clearTimeout(tout);
                if (document.hidden && _this._socket.connected) {
                    _this._socket.disconnect();
                }

                tout = setTimeout(function() {
                    if (!document.hidden && !_this._socket.connected) {
                        _this.init(_this._server);
                    }
                }, 5000);
            });
        }
    },

    send: function(object) {
        this._socket.emit('message', object);
    }
};

(function () {
	"use strict";

	angular
		.module("CLParent", [
			"ngAnimate",
			"ngTouch",
			"ngSanitize",
			"ui.router",
			"ui.bootstrap",
			"toastr",
			"angular-click-outside",
			"pascalprecht.translate",
			"services.base",
			"services.errorHandler",
			"services.httpInterceptor",
			"services.storage",
			"services.ganalytics",
			"services.auth",
			"services.upload",
			"directives.avatar",
			"directives.loader",
			"directives.validationIcons",
			"directives.validationErrors",
			"directives.countries",
			"directives.genders",
			"directives.relationship",
			"directives.featureDetection",
			"directives.tooltip",
			"directives.focus",
			"directives.cropper",
			"directives.months",
			"directives.removeChars",
			"directives.removeSpace",
			"directives.classPicker",
			"directives.zendesk",
			"directives.getHeight",
			"directives.photoUpload",
			"directives.galleryPicker",
			"directives.runmap",
			"directives.googleMapsAutocomplete",
			"directives.googleMapsAutocomplete",
			"directives.profileUpdater",
			"directives.postAsset",
			"directives.commentComposer",
			"directives.countchars",
			"directives.ngTouchstart",
			"directives.ngTouchend",
			"directives.autoresizeTextarea",
			"directives.autoresizeTextareaComment",
			"directives.postAdv",
			"directives.timeago",
			"directives.datepickerDirective",
			"directives.linebreaksToHtml",
			"directives.premiumAd",
			"directives.linkpreview",
			"directives.mentionsuggestor",
			"directives.carousel",
			"filters.groupBy",
			"modules.baseModule",
			"modules.pupilmanagement",
			"modules.classlist.all",
			"modules.classlist.details",
			"modules.classlist.map",
			"modules.post",
			"modules.post.edit",
			"modules.profile",
			"modules.profileSettings",
			"modules.profileSettings",
			"modules.profilePrivacy",
			"modules.profilePassword",
			"modules.profile.pupils",
			"modules.profile.family",
			"modules.profileNotifications",
			"modules.mailNotifications",
			"modules.invite",
			"modules.inbox",
			"modules.inbox.list",
			"modules.inbox.view",
			"modules.inbox.info",
			"modules.inbox.conversations",
			"modules.inbox.manageparticipants",
			"modules.schoolpage",
			"modules.schoolpage.details",
			"modules.runmap",
			"modules.events",
			"modules.events.create",
			"modules.events.list",
			"modules.events.view",
			"modules.events.tickets",
			"modules.events.buytickets",
			"modules.events.guests",
			"modules.events.invite",
			"modules.events.rota",
			"modules.raffle",
			"modules.raffle.details",
			"modules.raffle.enter",
			"modules.raffle.tickets",
			"modules.raffle.view",
			"modules.participants",
			"modules.grouptags",
			"modules.search",
			"modules.groups",
			"modules.groups.list",
			"modules.groups.view",
			"modules.home",
			"modules.stream",
			"modules.notifications",
			"modules.announcements",
			"modules.announcements.list",
			"modules.announcements.view",
			"modules.listings",
			"modules.listings.list",
			"modules.listings.view",
			"modules.post.likes",
			"modules.schoolrequest",
			"modules.composer.mobile",
			"modules.marketplace.mobile",
			"modules.recommendations",
			"modules.recommendations.view",
			"modules.events.paymentsuccess",
			"modules.nonmember",
			"mentio",
			"ngRaven",
		])
		.directive("contenteditable", [
			"$sce",
			function ($sce) {
				return {
					restrict: "A", // only activate on element attribute
					require: "?ngModel", // get a hold of NgModelController
					link: function (scope, element, attrs, ngModel) {
						function read() {
							var html = element.html();
							// When we clear the content editable the browser leaves a <br> behind
							// If strip-br attribute is provided then we strip this out
							if (attrs.stripBr && html === "<br>") {
								html = "";
							}
							ngModel.$setViewValue(html);
						}

						if (!ngModel) return; // do nothing if no ng-model

						// Specify how UI should be updated
						ngModel.$render = function () {
							if (ngModel.$viewValue !== element.html()) {
								element.html($sce.getTrustedHtml(ngModel.$viewValue || ""));
							}
						};

						// Listen for change events to enable binding
						element.on("blur keyup change", function () {
							scope.$apply(read);
						});
						read(); // initialize
					},
				};
			},
		])
		.filter("words", function () {
			return function (input, words) {
				if (isNaN(words)) {
					return input;
				}
				if (words <= 0) {
					return "";
				}
				if (input) {
					var inputWords = input.split(/\s+/);
					if (inputWords.length > words) {
						input = inputWords.slice(0, words).join(" ") + "\u2026";
					}
				}
				return input;
			};
		})
		.directive("contenteditable", [
			"$sce",
			function ($sce) {
				return {
					restrict: "A", // only activate on element attribute
					require: "?ngModel", // get a hold of NgModelController
					link: function (scope, element, attrs, ngModel) {
						function read() {
							var html = element.html();
							// When we clear the content editable the browser leaves a <br> behind
							// If strip-br attribute is provided then we strip this out
							if (attrs.stripBr && html === "<br>") {
								html = "";
							}
							ngModel.$setViewValue(html);
						}

						if (!ngModel) return; // do nothing if no ng-model

						// Specify how UI should be updated
						ngModel.$render = function () {
							if (ngModel.$viewValue !== element.html()) {
								element.html($sce.getTrustedHtml(ngModel.$viewValue || ""));
							}
						};

						// Listen for change events to enable binding
						element.on("blur keyup change", function () {
							scope.$apply(read);
						});
						read(); // initialize
					},
				};
			},
		])
		.filter("words", function () {
			return function (input, words) {
				if (isNaN(words)) {
					return input;
				}
				if (words <= 0) {
					return "";
				}
				if (input) {
					var inputWords = input.split(/\s+/);
					if (inputWords.length > words) {
						input = inputWords.slice(0, words).join(" ") + "\u2026";
					}
				}
				return input;
			};
		})
		.directive("myRightClick", function ($parse) {
			return {
				scope: false,
				restrict: "A",
				link: function (scope, element, attrs) {
					var fn = $parse(attrs.myRightClick);
					element.bind("contextmenu", function (event) {
						scope.$apply(function () {
							fn(scope, { $event: event });
						});
					});
				},
			};
		});
	angular.lowercase = angular.$$lowercase;
})();

(function() {
'use strict';

	angular.module('CLParent').run(runBlock);

	/** @ngInject */
	function runBlock($rootScope, regexes, $sce, storage, authService, gaService, $uibModalStack, $location, $window, settings, $uibModal, $timeout) {
		$rootScope.history = [];
		$rootScope.isDirty = false;

		//For turning off the scrollToTop if needed
		$rootScope.turnOnScrolling = true;
		$rootScope.isThisMobile = isThisMobile;

		$rootScope.$on('$stateChangeStart',function (event, toState, toParams, fromState, fromParams) {
			$rootScope.gaLoadPage = toState.params.gaPage;

			if (!_.isUndefined($rootScope.gaDimension) && !_.isUndefined(gaService)) {
				gaService.send(toState.params.gaPage || 'undefined');				
			}

			$uibModalStack.dismissAll();

			processScrollToTop(toParams);
			processBeforeunload(event, toState, toParams, fromState, fromParams);
			checkIfRightSchool();
		});

		$rootScope.$on('$stateChangeSuccess', function () {
			$rootScope.isDirty = false;

	//some ads
			if ($rootScope.preventAdsLoading){
				return;
			}
			
			if(window.innerWidth >= 990) {
				$rootScope.getAds();
			}

		});

		function leavePage(toPage) {
			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'app/base/views/leave-page-modal.html',
				backdropClass: 'backdrop-zindexed',
				size:'sm',
				controller: function($scope, $state){
		
					$scope.confirm = function(){
						$rootScope.isDirty = false;
						$state.go(toPage)
					}

					$scope.close = function(){
						modalInstance.close();
					}
				}
			})
		}

		function processScrollToTop(toParams) {
			if (toParams.scrollToTop){
				$timeout(function() {
				$window.scrollTo(0, 0);
				}, 0); 
			}
		}

		function checkIfRightSchool() {
			var school = $rootScope.getQueryParam('school');
			if (!school) {
				school = $rootScope.getQueryParam('s');
			}
			if (!school) {
				school = 0;
			}

			if (school > 0 && $rootScope.active_school && school !== $rootScope.active_school.id) {
				//check if is the same school
				$rootScope.refreshContext(school);
			}
		}
		
		function processBeforeunload(e, toState, toParams, fromState, fromParams) {
			$rootScope.$broadcast(fromState.name, {
				'e': e,
				'toState': toState,
				'toParams': toParams
			});
		}

		$rootScope.parseLinksToTags = function (cnt){
			if(!cnt || cnt.length == 0){
				return "";
			}
			//create temp element
			var temp = document.createElement('div');
			//set temp element inner html with htmlContent
			temp.innerHTML = cnt;
			//find all links in the element
			Array.from(temp.querySelectorAll('a')).forEach(function(link) {
				//if link has user-id attribute it mention. so replace with mention...
				if(link.getAttribute('rel') && link.getAttribute('rel') == "userid"){
					cnt = cnt.replace(link.outerHTML, "[MENTION userId=\"" + link.getAttribute('alt') + "\"]@" + link.innerHTML + "[/MENTION]");
				} else {
					//all other cases will be processed as normal link
					var linkWithTag = $rootScope.createEmailLinks(link.outerHTML)
					cnt = cnt.replace(link.outerHTML, linkWithTag);
				}
			});
			return cnt;
		}

		//Functions for link handling
		$rootScope.parseTagsToLinks = function(text) {
			if(!text)
				return text;

			if (!_.isUndefined(text)) {
				text = text.replace(regexes.openingTagStart, '<a');

				if(text.indexOf('_blank') > -1)
					text = text.replace(regexes.openingTagEnd, ' target="_blank">');
				else
					if(!text.includes('[MENTION')){
						text = text.replace(regexes.openingTagEndNotBlank, '">');
					}
				text = text.replace(regexes.closingTag, '</a>');
			}
			
			return text;
		}

		$rootScope.parseMentionTags = function(postBody) {
			if (!postBody) {
				return postBody;
			}

			var regexp = /\[MENTION(.+?)\](.+?)\[\/MENTION\]/g
			var regexp2 = /userId=\"(.*?)\"/
			
			var matches = window.searchString(postBody, regexp);

			for (var i = 0;i < matches.length; i++) {
				var match = matches[i];
				if (!match) {
					continue;
				}
				var all = match[0];
				var name = match[2];
				var userId = match[1];

				var umatches = window.searchString(userId, regexp2);

				for (var j = 0;j < umatches.length; j++) {
					var umatch = umatches[j];
					
					if (!umatch) {
						continue;
					}

					userId = umatch[1];
				}

				var MENTIONTEXT = "<a href=\"#/classlist/details/"+userId+"/contact\" class=\"mentionLink\">"+name+"</a>";
				postBody = postBody.replace(all, MENTIONTEXT);
			}
			return postBody;
		}
		$rootScope.parseMentionTagsToDiv = function(postBody) {
			if (!postBody) {
				return postBody;
			}

			var regexp = /\[MENTION(.+?)\](.+?)\[\/MENTION\]/g
			var regexp2 = /userId=\"(.*?)\"/
			
			var matches = window.searchString(postBody, regexp);

			for (var i = 0;i < matches.length; i++) {
				var match = matches[i];
				if (!match) {
					continue;
				}
				var all = match[0];
				var name = match[2];
				var userId = match[1];

				var umatches = window.searchString(userId, regexp2);

				for (var j = 0;j < umatches.length; j++) {
					var umatch = umatches[j];
					
					if (!umatch) {
						continue;
					}

					userId = umatch[1];
				}
				if(name){
					name = name.replace('@','')
				}
				var divValue =
				" <a rel='userid' contenteditable='false'  alt='" +
				userId +
				"' class='mentionLink'>" +
				(name) +
				"</a>&nbsp;";
				postBody = postBody.replace(all, divValue);
			}
			return postBody;
		}
		
		$rootScope.createEmailLinks = function(text) {
			if(!text){
				return text;
			}
			
			if(text.indexOf("http") > -1 || text.indexOf("www") > -1) { 
				return text.replace(regexes.url, function(url) {
					if(url.indexOf('http:') == -1 && url.indexOf('https:') == -1)
						url = 'http://' + url;
	
					return '[URL href="' + url + '" target="_blank"]' + url + '[/URL]';
				})
			} else {
				return text;
			}		
		}

		$rootScope.addUserInURL = function(originalURL){
			return originalURL + "&zu=" + $rootScope.active_user.id;
		}

		$rootScope.currentUserId = function() {
			return $rootScope.active_user.id;
		}

		$rootScope.removeLinks = function(text){
			if(!text)
				return text;

			var str = text.match(/"(https|http|www):?.*?"/gi);
			if (str !== null) {
				text = text.replace('[URL href=', '');
				text = text.replace(' target=\"_blank\"]', ' ');
				text = text.replace(regexes.closingTag, '');
				text = text.replace(str, '');
				for (var i = 0; i < str.length; i++) {
					text = text.replace('[URL href=', '');
					text = text.replace(' target=\"_blank\"]', ' ');
					text = text.replace(regexes.closingTag, '');
					text = text.replace(str[i], '');
				}	
				return text;
			} else {
				return text;
			}				
		}
		
		//track history
		if (!$rootScope.loadedHistory) {
			$rootScope.bodyViewAutoHeight = false;
			$rootScope.loadedHistory = true;

			$rootScope.$on("$locationChangeSuccess", function(e, currentLocation, previousLocation){
				$rootScope.hiddenHeader = false;
				$rootScope.history.push(previousLocation);

				if(currentLocation.indexOf('/apply/start') === -1)
					$rootScope.requestingSchoolId = null;

				if(window.innerWidth <= 991 && 
					(currentLocation.indexOf('/stream') > -1 || 
					currentLocation.indexOf('/composer/post')) > -1) {
					$rootScope.hiddenHeader = true;
				}

				if(currentLocation.indexOf('/classlist/map') !== -1) {
					$rootScope.bodyViewPadding = true;
				}
				else {
					$rootScope.bodyViewPadding = false;
				}

				setTimeout(function() {
					window.scrollTo(0, 0);
				}, 1);
				
				$rootScope.getPremiumAd();
			});
		}

		$rootScope.evaluateBack = function(redirectPages){
			var foundRedirect = false;
			for (var i = $rootScope.history.length - 1; i >= 0; i--) {
				var page = $rootScope.history[i];

				var matches = _.filter(redirectPages,function( s ) {
					return page.indexOf(s) !== -1; 
				});

				if (!_.isUndefined(matches) && matches.length > 0){
					$window.location.href = page;
					foundRedirect = true;
					break;
				}
			}
			if (!foundRedirect){
				$window.location.href = redirectPages[0];
			}
		}
		
		$rootScope.isInNewS3 = function () {
			return window.location.href.indexOf("classlist.com/parent") > -1;
			//&& $scope.isStorageEnabled;
		}

		$rootScope.getQueryParam = function(name, url) {
			var resultFromURL = readParamsFromURL(name, url);
			if ((!resultFromURL || resultFromURL === null || resultFromURL === '') && $rootScope.isInNewS3()){
				var storageItem = $window.localStorage.getItem(name);
				if (storageItem === null || !storageItem || storageItem === ''){
					return '';
				}

				$window.localStorage.removeItem(name);
				return storageItem;
			} 
			return resultFromURL;
		}

		function readParamsFromURL(name, url){
			if (!url) {
				url = window.location.href;
			}
			name = name.replace(/[\[\]]/g, "\\$&");
			var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
				results = regex.exec(url);
			if (!results) return null;
			if (!results[2]) return '';
			return decodeURIComponent(results[2].replace(/\+/g, " "));
		}
		
		$rootScope.getWithoutTimeZone = function(date) {
			var offset = timezone(date ? new Date(date) : new Date());
			var addHours = new Date(date ? new Date(date) : new Date()).getTime() + (offset * 3600000);
			return new Date(addHours);
		}

		$rootScope.getUTCDatetime = function(date) {
			var now = date ? new Date(date) : new Date(); 
            var now_utc = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(),  now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds());
            return now_utc;
		}

		function timezone(date) {
			var offset = date.getTimezoneOffset();
			var minutes = Math.abs(offset);
			var hours = Math.floor(minutes / 60);
			var prefix = offset < 0 ? "+" : "-";
			return prefix+hours;
		}

		window.onresize = function(event) {
			var zendeskframe = document.getElementById('launcher');

			if(zendeskframe) {
				if(window.innerWidth < 990) {
					angular.element(zendeskframe.contentWindow.document.body.querySelector('.src-component-Launcher-wrapper')).addClass('zendesk-padding')
				}
				else {
					angular.element(zendeskframe.contentWindow.document.body.querySelector('.src-component-Launcher-wrapper')).removeClass('zendesk-padding')
				}
			}

			var searchContactsScroll = document.querySelector('.search-contacts-container');
			var searchContactsPopup = document.querySelector('.search-page-popup');
			
			if(searchContactsScroll && searchContactsPopup)
				$rootScope.resizeContactsList()
		};
	}
})();

window.onbeforeunload = function() { 
	if(location.href.indexOf('#/inbox/view') === -1)
		window.scrollTo(0, 0); 
}

function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function validateLink(url){
    var re = new RegExp(
		"^" +
		  // protocol identifier (optional)
		  // short syntax // still required
		  "(?:(?:(?:https?|ftp):)?\\/\\/)" +
		  // user:pass BasicAuth (optional)
		  "(?:\\S+(?::\\S*)?@)?" +
		  "(?:" +
			// IP address exclusion
			// private & local networks
			"(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
			"(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
			"(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" +
			// IP address dotted notation octets
			// excludes loopback network 0.0.0.0
			// excludes reserved space >= 224.0.0.0
			// excludes network & broadcast addresses
			// (first & last IP address of each class)
			"(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
			"(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
			"(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
		  "|" +
			// host & domain names, may end with dot
			// can be replaced by a shortest alternative
			// (?![-_])(?:[-\\w\\u00a1-\\uffff]{0,63}[^-_]\\.)+
			"(?:" +
			  "(?:" +
				"[a-z0-9\\u00a1-\\uffff]" +
				"[a-z0-9\\u00a1-\\uffff_-]{0,62}" +
			  ")?" +
			  "[a-z0-9\\u00a1-\\uffff]\\." +
			")+" +
			// TLD identifier name, may end with dot
			"(?:[a-z\\u00a1-\\uffff]{2,}\\.?)" +
		  ")" +
		  // port number (optional)
		  "(?::\\d{2,5})?" +
		  // resource path (optional)
		  "(?:[/?#]\\S*)?" +
		"$", "i"
	  );
    return re.test(url);
}

function animate(elem, style, unit, from, to, time, prop) {
    if (!elem) {
        return;
    }
    var start = new Date().getTime(),
        timer = setInterval(function () {
            var step = Math.min(1, (new Date().getTime() - start) / time);
            if (prop) {
                elem[style] = (from + step * (to - from))+unit;
            } else {
                elem.style[style] = (from + step * (to - from))+unit;
            }
            if (step === 1) {
                clearInterval(timer);
            }
        }, 25);
    if (prop) {
          elem[style] = from+unit;
    } else {
          elem.style[style] = from+unit;
    }
}

function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
	var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
	return { width: srcWidth*ratio, height: srcHeight*ratio };
}

function dataURItoBlob(dataURI) {
	var byteString = atob(dataURI.split(',')[1]);
	var ab = new ArrayBuffer(byteString.length);
	var ia = new Uint8Array(ab);
	for (var i = 0; i < byteString.length; i++) {
		ia[i] = byteString.charCodeAt(i); 
	}
	return new Blob([ab], { type: 'image/jpeg' });
}

var freezeBody = function(e) {
	if(document.body.classList.contains('modal-open'))
		e.preventDefault();
};

function namePupilRelation(relationships, parent_relationships, _id, _gender) {

	if(_gender) {
		switch(_gender) {
			case '3001': // male
				switch(_id) {
					case '1003':
					case '1004':
						return parent_relationships[1013];
					case '1005':
						return parent_relationships[1012];
					case '1006':
						return parent_relationships[1009];
				}
				break;

			case '3002': // female
				switch(_id) {
					case '1003':
					case '1004':
						return parent_relationships[1014];
					case '1005':
						return parent_relationships[1011];
					case '1006':
						return parent_relationships[1010];
				}
				break;
		}
	}
	else {
		return relationships[_id]
	}
}


function isElementInViewport(success) {
	var els = document.getElementsByClassName('home-post-ad');

	for(var i = 0; i < els.length; i++) {
		var el = els[i];
		var rect = el.getBoundingClientRect();

		if(el.getAttribute('id')) {
			if(getComputedStyle(el).display !== "none" &&
				rect.top >= 0 &&
				rect.left >= 0 &&
				rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)+200 &&
				rect.right <= (window.innerWidth || document.documentElement.clientWidth)) 
				{
					var id = el.getAttribute('id');
					var index = el.getAttribute('post-index');
					el.removeAttribute('id');

					if(success)
						success(id, index)
				}
		}
	}
}

document.body.addEventListener("touchmove", freezeBody, false);

function showCustomAppcue(item, options) {
	var canshow = false;

	if(options) {
		if(options.isMobile) {
			canshow = isThisMobile()
		}
		else if(options.isDesktop) {
			canshow = !isThisMobile()
		}
		else {
			canshow = true;
		}
		
		if(canshow) {
			//if(options.urlCondition) {
				// if(location.href.indexOf(options.urlCondition) > -1)
				// 	canshow = true;
				// else 
				// 	canshow = false;
				canshow = true;
			// }
			// else {
			// 	canshow = false;
			// }
		}
	}

	if(canshow) {
		var cappcues = document.getElementsByClassName(item)
		if(cappcues) {
			cappcues[0].classList.add('active-appcue')
		}
	}
}

function dismissCustomAppcue() {
	var cappcues = document.getElementsByClassName('custom-appcues')
		if(cappcues) {
			for(var i = 0; i < cappcues.length; i++) {
				cappcues[i].classList.remove('active-appcue');
			}
	}
}

function getNearestHundred(distance) {
	//find distance in meters first...
	var rounded = Math.round(distance * 1000);
	//set suffix as meter
	var suffix = "m";
	var result = rounded + suffix;
	//if result is bigger than 1000, show in km with decimal 2 places.
	
	if(rounded > 1000) {
		suffix = "km";
		rounded = rounded / 1000;
		result = rounded + suffix;
	}
	
	//it returns in km.
	return rounded > 0 ? result : '';
}


(function () {
	"use strict";

	angular
		.module("CLParent")
		.factory("routerService", [
			"$http",
			"base",
			function ($http, base) {
				return _.create(base, {});
			},
		])
		.config(routerConfig);

	/** @ngInject */
	function routerConfig(
		$stateProvider,
		$urlRouterProvider,
		$qProvider,
		$provide,
		$locationProvider
	) {
		$qProvider.errorOnUnhandledRejections(false);
		$locationProvider.hashPrefix("");
		var metadataFilePath = "i8n/locale-metadata-en-GB.json?v=12";

		$stateProvider
			.state("classlist", {
				url: "/classlist",
				templateUrl: "app/classlist/views/wrapper.html",
				params: {
					needAuth: true,
					gaPage: "classlist",
				},
			})
			.state("classlist.all", {
				url: "/all",
				templateUrl: "app/classlist/views/all.html",
				controller: "classlistAllController",
				params: {
					needAuth: true,
					gaPage: "classlist/all",
					scrollToTop: true,
				},
				resolve: {
					metadata: function (routerService, $http) {
						return $http.get(metadataFilePath, { cache: true });
					},
				},
			})
			.state("classlist.all1", {
				url: "/all/:tierId",
				templateUrl: "app/classlist/views/all.html",
				controller: "classlistAllController",
				params: {
					needAuth: true,
					gaPage: "classlist/all/byTier",
					scrollToTop: true,
				},
				resolve: {
					metadata: function (routerService, $http) {
						return $http.get(metadataFilePath, { cache: true });
					},
				},
			})
			.state("classlist.map", {
				url: "/map/:id_parent/:tierId?",
				templateUrl: "app/classlist/views/map.html",
				controller: "classlistMapController",
				params: {
					needAuth: true,
					gaPage: "classlist/map",
					scrollToTop: true,
				},
				resolve: {
					metadata: function (routerService, $http) {
						return $http.get(metadataFilePath, { cache: true });
					},
				},
			})
			.state("classlist.details", {
				url: "/details/:id",
				templateUrl: "app/classlist/views/details.html",
				controller: "classlistDetailController",
				params: {
					needAuth: true,
					id: null,
					gaPage: "classlist/parent-details",
				},
				resolve: {
					metadata: function (routerService, $http) {
						return $http.get(metadataFilePath, { cache: true });
					},
				},
			})
			.state("classlist.details.pupils", {
				url: "/pupils",
				templateUrl: "app/classlist/views/partial.pupils.html",
				params: {
					needAuth: true,
					id: null,
					gaPage: "classlist/parent-details",
				},
			})
			.state("classlist.details.contact", {
				url: "/contact",
				templateUrl: "app/classlist/views/partial.contact.html",
				params: {
					needAuth: true,
					id: null,
					gaPage: "classlist/parent-details",
				},
			})
			.state("classlist.details.family", {
				url: "/family",
				templateUrl: "app/classlist/views/partial.family.html",
				params: {
					needAuth: true,
					id: null,
					gaPage: "classlist/parent-details",
				},
			})
			.state("school", {
				url: "/school",
				templateUrl: "app/schoolpage/views/wrapper.html",
				params: {
					needAuth: true,
					gaPage: "school",
				},
			})
			.state("school.details", {
				url: "/details",
				templateUrl: "app/schoolpage/views/school-page.html",
				controller: "schoolPageController",
				params: {
					needAuth: true,
					gaPage: "school/details",
					scrollToTop: true,
				},
			})
			.state("profile", {
				url: "/profile",
				templateUrl: "app/profile/views/wrapper.html",
				controller: "profileController",
				params: {
					needAuth: true,
					scrollToTop: true,
					gaPage: "profile",
				},
				resolve: {
					metadata: function (routerService, $http) {
						return $http.get(metadataFilePath, { cache: true });
					},
				},
			})
			.state("profileSettings", {
				url: "/profile/settings",
				templateUrl: "app/profile/views/profile-settings.html",
				controller: "prfSettingsController",
				params: {
					needAuth: true,
					gaPage: "profile/edit",
				},
			})
			.state("profilePassword", {
				url: "/profile/password",
				templateUrl: "app/profile/views/profile-password.html",
				controller: "prfPasswordController",
				params: {
					needAuth: true,
					gaPage: "profile/password",
				},
			})
			// .state('profile.pupils', {
			// 	url: '/pupils',
			// 	templateUrl: 'app/profile/views/manage-pupils.html',
			// 	controller: 'prfPupilsController',
			// 	params: {needAuth:true,
			// 		gaPage:'profile/manage-pupils'
			// 	}
			// })
			.state("profilePrivacy", {
				url: "/profile/privacy",
				templateUrl: "app/profile/views/privacy-settings.html",
				controller: "prfPrivacyController",
				params: {
					needAuth: true,
					gaPage: "profile/privacy-settings",
				},
			})
			// .state('profile.family', {
			// 	url: '/family',
			// 	templateUrl: 'app/profile/views/manage-family.html',
			// 	controller: 'prfFamilyController',
			// 	params: {
			// 		needAuth:true,
			// 		gaPage:'profile/manage-family'
			// 	}
			// })
			.state("profileNotifications", {
				url: "/profile/notifications",
				templateUrl: "app/profile/views/notification-settings.html",
				controller: "prfNotificationsController",
				params: {
					needAuth: true,
					gaPage: "profile/notification-settings",
				},
			})
			.state("mailNotifications", {
				url: "/profile/notifications/email",
				templateUrl: "app/profile/views/notification-mail-settings.html",
				controller: "mailNotificationsController",
				params: {
					needAuth: true,
					gaPage: "profile/notification-mail-settings",
				},
			})
			.state("pupilAdd", {
				url: "/pupil/add",
				templateUrl: "app/pupil/views/add-pupil.html",
				controller: "prfPupilController",
				params: {
					needAuth: true,
					gaPage: "pupil/add",
				},
			})
			.state("pupilEdit", {
				url: "/pupil/edit/:id",
				templateUrl: "app/pupil/views/add-pupil.html",
				controller: "prfPupilController",
				params: {
					needAuth: true,
					gaPage: "pupil/add",
				},
			})
			.state("familyAdd", {
				url: "/family/add",
				templateUrl: "app/profile/views/add-family.html",
				controller: "prfFamilyController",
				params: {
					needAuth: true,
					gaPage: "family/add",
				},
				resolve: {
					metadata: function (routerService, $http) {
						return $http.get(metadataFilePath, { cache: true });
					},
				},
			})
			.state("familyEdit", {
				url: "/family/edit/:id",
				templateUrl: "app/profile/views/add-family.html",
				controller: "prfFamilyController",
				params: {
					needAuth: true,
					gaPage: "family/edit",
				},
				resolve: {
					metadata: function (routerService, $http) {
						return $http.get(metadataFilePath, { cache: true });
					},
				},
			})
			.state("inbox", {
				url: "/inbox",
				templateUrl: "app/inbox/views/wrapper.html",
				controller: "inboxController",
				params: {
					needAuth: true,
				},
				resolve: {
					metadata: function (routerService, $http) {
						return $http.get(metadataFilePath, { cache: true });
					},
				},
			})
			.state("inbox.list", {
				url: "/list",
				templateUrl: "app/inbox/views/list.html",
				controller: "inboxListController",
				params: {
					needAuth: true,
					id: null,
					scrollToTop: false,
					gaPage: "conversations/view-conversations",
				},
			})
			.state("inbox.view", {
				url: "/view/:id",
				templateUrl: "app/inbox/views/view.html",
				controller: "inboxViewController",
				params: {
					needAuth: true,
					id: null,
					scrollToTop: false,
					gaPage: "conversations/view-thread",
				},
			})
			.state("inbox.info", {
				url: "/info/:id",
				templateUrl: "app/inbox/views/info.html",
				controller: "inboxInfoController",
				params: {
					needAuth: true,
					id: null,
					scrollToTop: false,
					gaPage: "conversations/view-thread-details",
				},
			})
			.state("invite", {
				url: "/invite",
				templateUrl: "app/invite/views/wrapper.html",
				controller: "inviteController",
				params: {
					needAuth: true,
					gaPage: "inviteparents",
					scrollToTop: true,
				},
			})
			.state("email", {
				url: "/invite/email",
				templateUrl: "app/invite/views/invite-email.html",
				controller: "inviteController",
				params: {
					needAuth: true,
					gaPage: "inviteparents",
					scrollToTop: true,
				},
			})
			.state("message", {
				url: "/invite/email/message",
				templateUrl: "app/invite/views/invite-email-message.html",
				controller: "inviteController",
				params: {
					needAuth: true,
					gaPage: "inviteparents",
					scrollToTop: true,
				},
			})
			.state("native", {
				url: "/native",
				templateUrl: "app/invite/views/invite-native.html",
				params: {
					needAuth: true,
					gaPage: "inviteparents",
				},
			})
			.state("runmap", {
				url: "/run-map",
				templateUrl: "app/runmap/views/wrapper.html",
				controller: "runmapController",
				params: {
					needAuth: true,
					gaPage: "runmap",
				},
				resolve: {
					metadata: function (routerService, $http) {
						return $http.get(metadataFilePath, { cache: true });
					},
				},
			})
			.state("schoolrunmap", {
				url: "/school-run-map",
				templateUrl: "app/runmap/views/school-run-map.html",
				params: {
					needAuth: true,
					gaPage: "schoolrunmap",
				},
			})
			.state("schoolrunmapaddress", {
				url: "/school-run-map-address",
				templateUrl: "app/runmap/views/school-run-map-address.html",
				params: {
					needAuth: true,
					gaPage: "schoolrunmapaddress",
				},
			})
			.state("events", {
				url: "/events",
				templateUrl: "app/events/views/wrapper.html",
				controller: "eventsController",
				params: {
					needAuth: true,
					gaPage: "events",
					scrollToTop: true,
				},
			})
			.state("events.list", {
				url: "/list",
				templateUrl: "app/events/views/list.html",
				controller: "eventsListController",
				params: {
					needAuth: true,
					gaPage: "events.list",
					scrollToTop: true,
				},
			})
			.state("events.view", {
				url: "/view/:id",
				templateUrl: "app/events/views/view.html",
				controller: "eventsViewController",
				params: {
					needAuth: true,
					id: null,
					gaPage: "events.view",
					redirectPages: ["/#/events/list", "/#/notifications"],
					scrollToTop: true,
				},
				reloadOnSearch: false,
			})
			.state("events.create", {
				url: "/create/:id?",
				templateUrl: "app/events/views/create.html",
				controller: "eventsCreateController",
				params: {
					needAuth: true,
					gaPage: "events.create",
					scrollToTop: true,
				},
			})
			.state("events.tickets", {
				url: "/tickets/:id_event",
				templateUrl: "app/events/views/tickets.html",
				controller: "eventTicketsController",
				params: {
					needAuth: true,
					gaPage: "events.tickets",
					scrollToTop: true,
				},
			})
			.state("events.buytickets", {
				url: "/buy/:id_event",
				templateUrl: "app/events/views/buy-tickets.html",
				controller: "eventBuyticketsController",
				params: {
					needAuth: true,
					gaPage: "events.buytickets",
					scrollToTop: true,
				},
			})
			.state("events.paymentsuccess", {
				url: "/ticket/:id_event/:lid?",
				templateUrl: "app/events/views/payment-success.html",
				controller: "eventPaymentSuccessController",
				params: {
					needAuth: true,
					gaPage: "events.paymentsuccess",
					scrollToTop: true,
				},
			})
			.state("events.ticketedguests", {
				url: "/ticketedguests/:id_event",
				templateUrl: "app/events/views/guests-ticketed.html",
				controller: "eventGuestsController",
				params: {
					needAuth: true,
					gaPage: "events.ticketedguests",
					scrollToTop: true,
				},
			})
			.state("events.nonticketedguests", {
				url: "/nonticketedguests/:id_event",
				templateUrl: "app/events/views/guests-nonticketed.html",
				controller: "eventGuestsController",
				params: {
					needAuth: true,
					gaPage: "events.nonticketedguests",
					scrollToTop: true,
				},
			})
			.state("events.invite", {
				url: "/invite/:id_event",
				templateUrl: "app/events/views/invite-guests.html",
				controller: "eventInviteController",
				params: {
					needAuth: true,
					gaPage: "events.invite",
					scrollToTop: true,
				},
			})
			.state("events.rota", {
				url: "/:id_event/signup/:id_rota?",
				templateUrl: "app/events/views/rota.html",
				controller: "eventsRotaController",
				params: {
					needAuth: true,
					id: null,
					gaPage: "events.rota",
					scrollToTop: true,
				},
				reloadOnSearch: false,
			})
			.state("raffle", {
				url: "/raffle",
				templateUrl: "app/raffle/views/wrapper.html",
				controller: "raffleController",
				params: {
					needAuth: true,
					gaPage: "raffle",
					scrollToTop: true,
				},
			})
			.state("raffle.details", {
				url: "/:raffle_id",
				templateUrl: "app/raffle/views/details.html",
				controller: "raffleDetailsController",
				params: {
					needAuth: true,
					gaPage: "raffle.details",
					scrollToTop: true,
				},
			})
			.state("raffle.enter", {
				url: "/:raffle_id/enter",
				templateUrl: "app/raffle/views/enter.html",
				controller: "raffleEnterController",
				params: {
					needAuth: true,
					gaPage: "raffle.enter",
					scrollToTop: true,
				},
			})
			.state("raffle.tickets", {
				url: "/:raffle_id/tickets",
				templateUrl: "app/raffle/views/select-tickets.html",
				controller: "raffleTicketsController",
				params: {
					needAuth: true,
					gaPage: "raffle.tickets",
					scrollToTop: true,
				},
			})
			.state("raffle.view", {
				url: "/:raffle_id/view",
				templateUrl: "app/raffle/views/view-tickets.html",
				controller: "raffleViewController",
				params: {
					needAuth: true,
					gaPage: "raffle.view",
					scrollToTop: true,
				},
			})
			.state("groups", {
				url: "/groups",
				templateUrl: "app/groups/views/wrapper.html",
				controller: "groupsController",
				params: {
					needAuth: true,
					gaPage: "groups",
				},
			})
			.state("search", {
				url: "/search",
				templateUrl: "app/search/views/search-list.html",
				controller: "searchController",
				params: {
					needAuth: true,
					gaPage: "search",
				},
			})
			.state("groups.list", {
				url: "/list",
				templateUrl: "app/groups/views/groups-list.html",
				controller: "groupsListController",
				params: {
					needAuth: true,
					gaPage: "groups.list",
				},
			})
			.state("groups.create", {
				url: "/create",
				templateUrl: "app/groups/views/create-group.html",
				controller: "groupsListController",
				params: {
					needAuth: true,
				},
			})
			.state("groups.members", {
				url: "/members/:id/:type",
				templateUrl: "app/groups/views/members.html",
				controller: "groupsViewController",
				params: {
					needAuth: true,
					id: null,
					gaPage: "groups.view.members",
				},
			})
			.state("groups.view", {
				url: "/view/:id",
				templateUrl: "app/groups/views/group-view.html",
				controller: "groupsViewController",
				params: {
					needAuth: true,
					id: null,
					gaPage: "groups.view",
				},
			})
			.state("groups.details", {
				url: "/details/:id",
				templateUrl: "app/groups/views/mobile-details.html",
				controller: "groupsViewController",
				params: {
					needAuth: true,
					id: null,
					gaPage: "groups.details",
				},
			})
			.state("home", {
				url: "/home",
				templateUrl: "app/home/views/wrapper.html",
				controller: "homeController",
				params: {
					needAuth: true,
					scrollToTop: true,
					gaPage: "home.groups",
				},
				resolve: {
					metadata: function (routerService, $http) {
						return $http.get(metadataFilePath, { cache: true });
					},
				},
			})
			.state("school-change", {
				url: "/school-change",
				onEnter: function($state) {
					$state.go("home");
				},
				params: {
					needAuth: true,
					scrollToTop: true,
					gaPage: "home.groups"
				}
			})
			.state("groups-discover", {
				url: "/groups/discover",
				onEnter: function($state) {
					$state.go("home");
				},
				params: {
					needAuth: true,
					scrollToTop: true,
					gaPage: "home.groups"
				}
			})
			.state("stream", {
				url: "/stream",
				templateUrl: "app/stream/views/wrapper.html",
				controller: "streamController",
				params: {
					needAuth: true,
					scrollToTop: true,
					gaPage: "home.groups.activity",
				},
				resolve: {
					metadata: function (routerService, $http) {
						return $http.get(metadataFilePath, { cache: true });
					},
				},
			})
			.state("notifications", {
				url: "/notifications",
				templateUrl: "app/notifications/views/wrapper.html",
				controller: "notificationsController",
				params: {
					needAuth: true,
					gaPage: "notifications",
				},
			})
			.state("post", {
				url: "/post",
				templateUrl: "app/post/views/wrapper.html",
				params: {
					needAuth: true,
					gaPage: "post.groups",
					redirectPages: ["/#/home", "/#/notifications"],
				},
			})
			.state("view", {
				url: "/post/:id",
				templateUrl: "app/post/views/post.html",
				controller: "postController",
				params: {
					needAuth: true,
					gaPage: "post.details",
					redirectPages: ["/#/home", "/#/notifications", "/#/listings/list"],
				},
			})
			.state("edit", {
				url: "/edit/:id",
				templateUrl: "app/post/views/edit.html",
				controller: "postEditController",
				params: {
					needAuth: true,
					gaPage: "post.edit",
					redirectPages: ["/#/home", "/#/listings/list"],
				},
			})
			.state("announcements", {
				url: "/announcements",
				templateUrl: "app/announcements/views/wrapper.html",
				controller: "announcementsController",
				params: {
					needAuth: true,
					gaPage: "announcements",
				},
			})
			.state("announcements.list", {
				url: "/list",
				templateUrl: "app/announcements/views/announcement-list.html",
				controller: "announcementsListController",
				params: {
					needAuth: true,
					gaPage: "announcements.list",
				},
			})
			.state("announcements.view", {
				url: "/view/:id",
				templateUrl: "app/announcements/views/announcement-view.html",
				controller: "announcementsViewController",
				params: {
					needAuth: true,
					gaPage: "announcements.view",
					redirectPages: [
						"/#/home",
						"/#/announcements/list",
						"/#/notifications",
						"/#/groups/view/",
					],
				},
			})
			.state("listings", {
				url: "/listings",
				templateUrl: "app/listings/views/wrapper.html",
				controller: "listingsController",
				params: {
					needAuth: true,
					gaPage: "listings",
				},
			})
			.state("listings.list", {
				url: "/list",
				templateUrl: "app/listings/views/listings-list.html",
				controller: "listingsListController",
				params: {
					needAuth: true,
					gaPage: "listings.list",
					scrollToTop: true,
				},
			})
			.state("listings.list2", {
				url: "/list/",
				templateUrl: "app/listings/views/listings-list.html",
				controller: "listingsListController",
				params: {
					needAuth: true,
					gaPage: "listings.list",
					scrollToTop: true,
				},
			})
			.state("listings.view", {
				url: "/:id",
				templateUrl: "app/listings/views/listings-view.html",
				controller: "listingsViewController",
				params: {
					needAuth: true,
					gaPage: "listings.view",
					scrollToTop: true,
				},
				resolve: {
					metadata: function ($http) {
						return $http.get(metadataFilePath, { cache: true });
					},
				},
			})
			.state("schoolrequest", {
				url: "/apply",
				templateUrl: "app/schoolrequest/wrapper.html",
				params: {
					gaPage: "schoolrequest",
					scrollToTop: true,
				},
			})
			.state("schoolrequest.start", {
				url: "/start",
				templateUrl: "app/schoolrequest/views/schoolrequest-start.html",
				params: {
					gaPage: "schoolrequest/start",
				},
				controller: "schoolrequestController",
				resolve: {
					metadata: function (routerService, $http) {
						return $http.get(metadataFilePath, { cache: true });
					},
				},
			})
			.state("composer_mkp", {
				url: "/marketplace",
				templateUrl: "app/composer_mkp/views/wrappermobile.html",
				params: {
					needAuth: true,
					gaPage: "composer_mkp",
				},
				resolve: {
					metadata: function ($http) {
						return $http.get(metadataFilePath, { cache: true });
					},
				},
			})
			.state("composer_mkp.categories", {
				url: "/categories",
				templateUrl: "app/composer_mkp/views/composer-mobile-categories.html",
				controller: "composerMkpMobileController",
				params: {
					needAuth: true,
					gaPage: "composer.categories",
					scrollToTop: true,
				},
			})
			.state("composer_mkp.post", {
				url: "/post/:id?",
				templateUrl: "app/composer_mkp/views/composer-mobile-post.html",
				controller: "composerMkpMobileController",
				params: {
					needAuth: true,
					gaPage: "marketplace/post",
					scrollToTop: true,
				},
			})
			.state("composer", {
				url: "/composer",
				templateUrl: "app/composer/views/wrappermobile.html",
				params: {
					needAuth: true,
					gaPage: "composer",
				},
			})
			.state("composer.categories", {
				url: "/categories",
				templateUrl: "app/composer/views/composer-mobile-categories.html",
				controller: "composerMobileController",
				params: {
					needAuth: true,
					gaPage: "composer.categories",
					scrollToTop: true,
				},
			})
			.state("composer.post", {
				url: "/post",
				templateUrl: "app/composer/views/composer-mobile-post.html",
				controller: "composerMobileController",
				params: {
					needAuth: true,
					gaPage: "composer/post",
					scrollToTop: true,
				},
			})
			.state("recommendations", {
				url: "/recommendations",
				templateUrl: "app/recommendations/views/wrapper.html",
				params: {
					needAuth: true,
					gaPage: "recommendations",
				},
			})
			.state("recommendations.view", {
				url: "/view/:type",
				templateUrl: "app/recommendations/views/view.html",
				controller: "recommendationsViewController",
				params: {
					needAuth: true,
					id: null,
					gaPage: "recommendations.view",
				},
				resolve: {
					metadata: function (routerService, $http) {
						return $http.get(metadataFilePath, { cache: true });
					},
				},
			})
			.state("recommendations.suggest", {
				url: "/suggest",
				templateUrl: "app/recommendations/views/suggest.html",
				controller: "recommendationsController",
				params: {
					needAuth: true,
					id: null,
					gaPage: "recommendations.suggest",
				},
				resolve: {
					metadata: function (routerService, $http) {
						return $http.get(metadataFilePath, { cache: true });
					},
				},
			})
			.state("nonmember", {
				url: "/welcome",
				templateUrl: "app/nonmember/views/wrapper.html",
				controller: "nonmemberController",
				params: {
					needAuth: true,
					gaPage: "nonmember",
				},
			});
	}
})();

(function() {
    'use strict';

    var conf = {
            'local': {
                'api': 'https://dev-api.classlist.com',
                'apiNoSecure': 'http://dev-api.classlist.com',
                'adminAppURL': 'http://localhost:3025',
                'parentAppURL': 'http://localhost:3021',
                'schoolAppURL': 'http://localhost:3020',
                'ssoAppURL': 'http://localhost:3022',
                'advertiserAppURL': 'http://localhost:3024',
                'wssURL': 'wss://flwebsocket.classlist.com?env=local&token=',
                'onboardingAppURL': 'http://localhost:4200',
                'stripeKey': 'pk_test_55h3Gt9gohwk87vcesAENKXn'
            },
            'dev': {
                'api': 'https://dev-api.classlist.com',
                'apiNoSecure': 'http://dev-api.classlist.com',
                'adminAppURL': 'https://internal-dev.classlist.com/superadmin',
                'parentAppURL': 'https://internal-dev.classlist.com/parent',
                'schoolAppURL': 'https://internal-dev.classlist.com/school',
                'advertiserAppURL': 'https://internal-dev.classlist.com/business',
                'ssoAppURL': 'https://internal-dev.classlist.com/login',
                'wssURL': 'wss://flwebsocket.classlist.com?env=dev&token=',
                'onboardingAppURL': 'https://internal-dev.classlist.com/start',
                'stripeKey': 'pk_test_55h3Gt9gohwk87vcesAENKXn'
            },
            'test': {
                'api': 'https://test-api.classlist.com',
                'apiNoSecure': 'http://test-api.classlist.com',
                'adminAppURL': 'https://internal-test.classlist.com/superadmin',
                'parentAppURL': 'https://internal-test.classlist.com/parent',
                'schoolAppURL': 'https://internal-test.classlist.com/school',
                'advertiserAppURL': 'https://internal-test.classlist.com/business',
                'ssoAppURL': 'https://internal-test.classlist.com/login',
                'wssURL': 'wss://flwebsocket.classlist.com?env=test&token=',
                'onboardingAppURL': 'https://internal-dev.classlist.com/start',
                'stripeKey': 'pk_test_55h3Gt9gohwk87vcesAENKXn'
            },
            'prod': {
                'api': 'https://api.classlist.com',
                'apiNoSecure': 'http://api.classlist.com',
                'wssURL': 'wss://flwebsocket.classlist.com?env=prod&token=',
                'stripeKey': 'pk_live_OjFbCGNoa9klxw3SJfxAWxHw',
                'ssoAppURL': 'https://app.classlist.com/login',
                'parentAppURL': 'https://app.classlist.com/parent',
                'schoolAppURL': 'https://app.classlist.com/school',
                'advertiserAppURL': 'https://app.classlist.com/business',
                'onboardingAppURL': 'https://app.classlist.com/start'
            },
            'preprod': {
                'api': 'https://preprod-api.classlist.com',
                'apiNoSecure': 'http://preprod-api.classlist.com',
                'adminAppURL': 'https://internal-preprod.classlist.com/superadmin',
                'parentAppURL': 'https://internal-preprod.classlist.com/parent',
                'schoolAppURL': 'https://internal-preprod.classlist.com/school',
                'advertiserAppURL': 'https://internal-preprod.classlist.com/business',
                'ssoAppURL': 'https://internal-preprod.classlist.com/login',
                'wssURL': 'wss://flwebsocket.classlist.com?env=preprod&token=',
                'onboardingAppURL': 'https://internal-preprod.classlist.com/start',
                'stripeKey': 'pk_live_OjFbCGNoa9klxw3SJfxAWxHw'
            }
        },
        env = '';

    var default_gallery = 'https://storage.googleapis.com/class-list-api-europe/';
    var default_gallery = [
        { id: 'event-sample/birthday', title: 'BIRTHDAY', url: default_gallery + 'event-sample/birthday' },
        { id: 'event-sample/coffee_morning', title: 'COFFEE_MORNING', url: default_gallery + 'event-sample/coffee_morning' },
        { id: 'event-sample/birthday_3', title: 'BIRTHDAY', url: default_gallery + 'event-sample/birthday_3' },
        { id: 'event-sample/charity', title: 'CHARITY', url: default_gallery + 'event-sample/charity' },
        { id: 'event-sample/christmas', title: 'CHRISTMAS', url: default_gallery + 'event-sample/christmas' },
        { id: 'event-sample/concert', title: 'CONCERT', url: default_gallery + 'event-sample/concert' },
        { id: 'event-sample/halloween', title: 'HALLOWEEN', url: default_gallery + 'event-sample/halloween' },
        { id: 'event-sample/book_club', title: 'BOOK_CLUB', url: default_gallery + 'event-sample/book_club' },
        { id: 'event-sample/school_fete', title: 'SCHOOL_FETE', url: default_gallery + 'event-sample/school_fete' },
        { id: 'event-sample/school_sport', title: 'SCHOOL_SPORT', url: default_gallery + 'event-sample/school_sport' },
        { id: 'event-sample/cake_sale', title: 'CAKE_SALE', url: default_gallery + 'event-sample/cake_sale' },
        { id: 'event-sample/christmas_2', title: 'CHRISTMAS', url: default_gallery + 'event-sample/christmas_2' },
        { id: 'event-sample/easter', title: 'EASTER', url: default_gallery + 'event-sample/easter' },
        { id: 'event-sample/birthday_2', title: 'BIRTHDAY', url: default_gallery + 'event-sample/birthday_2' },
        { id: 'event-sample/dinner', title: 'DINNER', url: default_gallery + 'event-sample/dinner' }
    ];

    function getTrackerId(env) {
        if (env === 'prod') {
            if (getIfNative()) {
                return "UA-79445442-6";
            } else {
                return "UA-79445442-2";
            }
        } else {
            return "";
        }
    }

    if (location.host.indexOf('localhost') > -1 || location.host.indexOf('192.168') > -1) { env = 'local' } else if (location.host.indexOf('internal-dev.classlist.com') > -1) {
        env = 'dev'
    } else if (location.host.indexOf('internal-test.classlist.com') > -1) {
        env = 'test'
    } else if (location.host.indexOf('internal-preprod.classlist.com') > -1) {
        env = 'preprod'
    } else if (location.host.indexOf('classlist.com') > -1) {
        env = 'prod'
    }
    var loadedEnv = conf[env];
    loadedEnv.type = env;

    angular.module('CLParent').constant('settings', {
        defaultLang: 'en-GB',
        conf: loadedEnv,
        defaultGallery: default_gallery,
        maxEventYear: 2,
        gae: {
            url: conf[env].api + '/_ah/api/',
            rootUrl: conf[env].api + '/'
        },
        gaUserId: getTrackerId(env),
        http: {
            timeout: 50000,
            withCredentials: true,
            contentType: 'application/json',
            xhr: true
        },
        baseUploadConfig: {
            url: conf[env].api + '/gcs',
            name: 'file.jpg'
        },
        avatarUpload: {
            minWidth: 160,
            maxWidth: 700,
            quality: 100,
            type: 'PROFILE_PIC'
        },
        postUpload: {
            url: conf[env].api + '/gcs',
            minWidth: 600,
            maxWidth: 1200,
            quality: 100,
            type: 'ATTACHMENT',
            name: 'post-photo.jpg'
        },
        listingUpload: {
            url: conf[env].api + '/gcs',
            minWidth: 600,
            maxWidth: 1200,
            quality: 100,
            type: 'LISTING_IMG',
            name: 'listing-photo.jpg'
        },
        eventUpload: {
            url: conf[env].api + '/gcs',
            minWidth: 600,
            maxWidth: 1200,
            quality: 100,
            type: 'EVENT_IMG',
            name: 'event-photo.jpg'
        },
        postCropper: {
            minCropBoxWidth: 100,
            minCropBoxHeight: 100,
            aspectRatio: 0,
            autoCrop: false
        },
        groupUpload: {
            url: conf[env].api + '/gcs',
            minWidth: 600,
            maxWidth: 1200,
            quality: 100,
            type: 'GROUP_AVATAR',
            name: 'group-avatar.jpg'
        },
        groupCropper: {
            minCropBoxWidth: 40,
            minCropBoxHeight: 40,
            aspectRatio: 1 / 1
        },
        eventCropper: {
            minCropBoxWidth: 40,
            minCropBoxHeight: 40,
            aspectRatio: 16 / 9
        },
        avatarCropper: {
            minCropBoxWidth: 40,
            minCropBoxHeight: 40,
            aspectRatio: 1
        },
        cropper: {
            guides: false,
            center: false,
            background: false,
            cropBoxMovable: true,
            zoomOnWheel: false,
            viewMode: 1,
            rotatable: true,
            movable: false,
            responsive: true,
            zoomOnTouch: true,
            dragMode: 'move',
            checkOrientation: false
        },
        fileUpload: {
            url: conf[env].api + '/gcs'
        },
        runmap: {
            zoom: 17,
            default: {
                london: {
                    lat: 51.5053134,
                    lng: -0.1141267
                }
            }
        }
    }).constant('regexes', {
        username: '[a-zA-Z0-9@._]',
        number: '[0-9]$',
        money: /^\d+(\.\d{0,2})?$/,
        address: '[a-zA-Z0-9 ,-/]$',
        address2: '[a-zA-Z0-9, -]$',
        nameField: "[a-zA-Z\u00C0-\u024F\u0370-\u03FF\u1E00-\u1EFF-' ]$",
        valCode: '[0-9]$',
        postcode: '[a-zA-Z0-9 ]$',
        memorable: '[a-zA-Z0-9]$',
        url: /(https|http|www):?.*?(?=(<div>|<\/div>|&nbsp|<br>)|\s|$)/g,
        openingTagStart: /(\[URL)/g,
        openingTagEnd: /(target="_blank"])/g,
        openingTagEndNotBlank: /("])/g,
        closingTag: /(\[\/URL])/g,
        mentionOpeningTag: /\[MENTION.*?\]/g,
        mentionClosingTag: /(\[\/MENTION])/g,
        userID: /\buserId\=\"(\w+\b)\"/g,
        password: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^_£/&*(),.?\-<>:;\“‘|\\{}\][+÷=±≤≥§`‘“’≠–œºª•µ¶§∞¢#€¡¥¨~^øåßΩ≈ß“:{}|<>]).{8,}$/,
        min: {
            eventTitle: 5,
            eventDescription: 5,
            listingTitle: 5,
            listingDescription: 5,
            userSearch: 3,
            msgSubject: 1,
            msgBody: 1,
            name: 2,
            pup_lastname: 1,
            email: 5,
            postcode: 3,
            address: 5,
            phone: 8,
            username: 3,
            password: 8,
            valdcode: 4,
            commentBody: 2,
            groupTitle: 3
        },
        max: {
            eventTitle: 66,
            eventDescription: 2000,
            listingTitle: 50,
            listingDescription: 2000,
            userSearch: 200,
            msgSubject: 100,
            msgBody: 999,
            name: 100,
            email: 100,
            postcode: 10,
            address: 50,
            fullAddress: 250,
            phone: 15,
            username: 50,
            password: 250,
            valdcode: 4,
            postPrice: 15,
            postBody: 1500,
            commentBody: 1500,
            eventLocDet: 100
        }
    }).constant('zenLinks', {
        'classlist.all': 'https://classlisthelp.zendesk.com/hc/en-us/articles/209157405-Topic-4-Classlist-Page',
        'classlist.all1': 'https://classlisthelp.zendesk.com/hc/en-us/articles/209157405-Topic-4-Classlist-Page',
        'classlist.details': 'https://classlisthelp.zendesk.com/hc/en-us/articles/209157405-Topic-4-Classlist-Page',
        'profileSettings': 'https://classlisthelp.zendesk.com/hc/en-us/articles/208434989-Lesson-5-Personal-Profile',
        'profile.pupils': 'https://classlisthelp.zendesk.com/hc/en-us/articles/209157505-Lesson-7-Manage-Pupils',
        'profile.family': 'https://classlisthelp.zendesk.com/hc/en-us/articles/209157485-Lesson-6-Family-Members',
        'profilePrivacy': 'https://help.classlist.com/hc/en-us/articles/115001362285-Privacy-can-I-hide-my-contact-details-',
        'profileNotifications': 'https://help.classlist.com/hc/en-us/articles/115000803371-My-notifications',
        'announcements.list': 'https://help.classlist.com/hc/en-us/articles/213267229/',
        'announcements.view': 'https://help.classlist.com/hc/en-us/articles/213267229/',
        'inbox': 'https://help.classlist.com/hc/en-us/articles/209157525-Messages-',
        'inbox.list': 'https://help.classlist.com/hc/en-us/articles/209157525-Messages-',
        'inbox.view': 'https://help.classlist.com/hc/en-us/articles/209157525-Messages-',
        'invite': 'https://help.classlist.com/hc/en-us/articles/115002804945-Inviting-other-parents-via-the-App-or-computer',
        'runmap': 'https://help.classlist.com/hc/en-us/articles/209336529-The-Parent-Map',
        'schoolrunmapaddress': 'https://help.classlist.com/hc/en-us/articles/209336529-The-Parent-Map',
        'groups.list': 'https://classlisthelp.zendesk.com/hc/en-us/articles/210630869-Topic-14-My-Groups',
        'groups.view': 'https://classlisthelp.zendesk.com/hc/en-us/articles/210630869-Topic-14-My-Groups',
        'events.list': 'https://classlisthelp.zendesk.com/hc/en-us/articles/209776409-Topic-13-The-Events-Page',
        'events.view': 'https://classlisthelp.zendesk.com/hc/en-us/articles/209776409-Topic-13-The-Events-Page',
        'events.create': 'https://classlisthelp.zendesk.com/hc/en-us/articles/209776409-Topic-13-The-Events-Page',
        'events.nonticketedguests': 'https://help.classlist.com/hc/en-us/articles/115002501231',
        'events.tickets': 'https://help.classlist.com/hc/en-us/articles/115002501231',
        'events.ticketedguests': 'https://help.classlist.com/hc/en-us/articles/115002501231',
        'home': 'https://help.classlist.com/hc/en-us/articles/212959425-Posting-to-the-Parent-Board',
        'notifications': 'https://help.classlist.com/hc/en-us/articles/115000803371-My-notifications',
        'listings.list': 'https://help.classlist.com/hc/en-us/articles/213988805',
        'listings.view': 'https://help.classlist.com/hc/en-us/articles/213988805',
        'listings.edit': 'https://help.classlist.com/hc/en-us/articles/213988805',
        'listings.create.typecategory': 'https://help.classlist.com/hc/en-us/articles/213259029',
        'listings.create.itemdetail': 'https://help.classlist.com/hc/en-us/articles/213259029',
        'listings.create.price': 'https://help.classlist.com/hc/en-us/articles/213259029',
        'listings.create.visibilitylocation': 'https://help.classlist.com/hc/en-us/articles/213259029',
        'listings.create.review': 'https://help.classlist.com/hc/en-us/articles/213259029',
        'school.details': 'https://help.classlist.com/hc/en-us/articles/115002225449-My-School',
        'recommendations': 'https://help.classlist.com/hc/en-us/articles/115003875752-The-Business-Directory',
        'recommendations.view': 'https://help.classlist.com/hc/en-us/articles/115003875752-The-Business-Directory'
    });

})();

function isExperimentCookie() {
    return document.cookie.indexOf("X-Source=experiment") > -1;
}
(function() {
  'use strict';

  angular.module('CLParent').config(config);

  /** @ngInject */
  function config($logProvider, $httpProvider, $translateProvider, toastrConfig, settings) {
    // Enable log
    $logProvider.debugEnabled(true);

    $translateProvider.useSanitizeValueStrategy('sanitize');

    $httpProvider.interceptors.push('httpInterceptor');

    $translateProvider.useStaticFilesLoader({
        prefix: 'i8n/locale-',
        suffix: '.json'
    });
    $translateProvider.preferredLanguage(settings.defaultLang);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 8000;
    toastrConfig.positionClass = 'toast-bottom-center';
    toastrConfig.preventDuplicates = false;
    toastrConfig.progressBar = true;
  }

})();

/*
* Fingerprintjs2 1.5.1 - Modern & flexible browser fingerprint library v2
* https://github.com/Valve/fingerprintjs2
* Copyright (c) 2015 Valentin Vasilyev (valentin.vasilyev@outlook.com)
* Licensed under the MIT (http://www.opensource.org/licenses/mit-license.php) license.
*
* THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
* AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
* IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
* ARE DISCLAIMED. IN NO EVENT SHALL VALENTIN VASILYEV BE LIABLE FOR ANY
* DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
* (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
* LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
* ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
* (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
* THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

(function (name, context, definition) {
  'use strict'
  if (typeof window.define === 'function' && window.define.amd) { window.define(definition) } else if (typeof module !== 'undefined' && module.exports) { module.exports = definition() } else if (context.exports) { context.exports = definition() } else { context[name] = definition() }
})('Fingerprint2', this, function () {
  'use strict'
  /**
   * @constructor
   * @param {Object=} options
   */
  var Fingerprint2 = function (options) {
    if (!(this instanceof Fingerprint2)) {
      return new Fingerprint2(options)
    }

    var defaultOptions = {
      swfContainerId: 'fingerprintjs2',
      swfPath: 'flash/compiled/FontList.swf',
      detectScreenOrientation: true,
      sortPluginsFor: [/palemoon/i],
      userDefinedFonts: []
    }
    this.options = this.extend(options, defaultOptions)
    this.nativeForEach = Array.prototype.forEach
    this.nativeMap = Array.prototype.map
  }
  Fingerprint2.prototype = {
    extend: function (source, target) {
      if (source === null) { return target }
      for (var k in source) {
        if (source[k] !== null && target[k] !== source[k]) {
          target[k] = source[k]
        }
      }
      return target
    },
    get: function (done) {
      var that = this
      var keys = {
        data: [],
        addPreprocessedComponent: function (pair) {
          var componentValue = pair.value
          if (typeof that.options.preprocessor === 'function') {
            componentValue = that.options.preprocessor(pair.key, componentValue)
          }
          keys.data.push({key: pair.key, value: componentValue})
        }
      }
      keys = this.userAgentKey(keys)
      keys = this.languageKey(keys)
      keys = this.colorDepthKey(keys)
      keys = this.deviceMemoryKey(keys)
      keys = this.pixelRatioKey(keys)
      keys = this.hardwareConcurrencyKey(keys)
      keys = this.screenResolutionKey(keys)
      keys = this.availableScreenResolutionKey(keys)
      keys = this.timezoneOffsetKey(keys)
      keys = this.sessionStorageKey(keys)
      keys = this.localStorageKey(keys)
      keys = this.indexedDbKey(keys)
      keys = this.addBehaviorKey(keys)
      keys = this.openDatabaseKey(keys)
      keys = this.cpuClassKey(keys)
      keys = this.platformKey(keys)
      keys = this.doNotTrackKey(keys)
      keys = this.pluginsKey(keys)
      keys = this.canvasKey(keys)
      keys = this.webglKey(keys)
      keys = this.webglVendorAndRendererKey(keys)
      keys = this.adBlockKey(keys)
      keys = this.hasLiedLanguagesKey(keys)
      keys = this.hasLiedResolutionKey(keys)
      keys = this.hasLiedOsKey(keys)
      keys = this.hasLiedBrowserKey(keys)
      keys = this.touchSupportKey(keys)
      keys = this.customEntropyFunction(keys)
      this.fontsKey(keys, function (newKeys) {
        var values = []
        that.each(newKeys.data, function (pair) {
          var value = pair.value
          if (value && typeof value.join === 'function') {
            value = value.join(';')
          }
          values.push(value)
        })
        var murmur = that.x64hash128(values.join('~~~'), 31)
        return done(murmur, newKeys.data)
      })
    },
    customEntropyFunction: function (keys) {
      if (typeof this.options.customFunction === 'function') {
        keys.addPreprocessedComponent({key: 'custom', value: this.options.customFunction()})
      }
      return keys
    },
    userAgentKey: function (keys) {
      if (!this.options.excludeUserAgent) {
        keys.addPreprocessedComponent({key: 'user_agent', value: this.getUserAgent()})
      }
      return keys
    },
    // for tests
    getUserAgent: function () {
      return navigator.userAgent
    },
    languageKey: function (keys) {
      if (!this.options.excludeLanguage) {
        // IE 9,10 on Windows 10 does not have the `navigator.language` property any longer
        keys.addPreprocessedComponent({ key: 'language', value: navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage || '' })
      }
      return keys
    },
    colorDepthKey: function (keys) {
      if (!this.options.excludeColorDepth) {
        keys.addPreprocessedComponent({key: 'color_depth', value: window.screen.colorDepth || -1})
      }
      return keys
    },
    deviceMemoryKey: function (keys) {
      if (!this.options.excludeDeviceMemory) {
        keys.addPreprocessedComponent({key: 'device_memory', value: this.getDeviceMemory()})
      }
      return keys
    },
    getDeviceMemory: function () {
      return navigator.deviceMemory || -1
    },
    pixelRatioKey: function (keys) {
      if (!this.options.excludePixelRatio) {
        keys.addPreprocessedComponent({key: 'pixel_ratio', value: this.getPixelRatio()})
      }
      return keys
    },
    getPixelRatio: function () {
      return window.devicePixelRatio || ''
    },
    screenResolutionKey: function (keys) {
      if (!this.options.excludeScreenResolution) {
        return this.getScreenResolution(keys)
      }
      return keys
    },
    getScreenResolution: function (keys) {
      var resolution
      if (this.options.detectScreenOrientation) {
        resolution = (window.screen.height > window.screen.width) ? [window.screen.height, window.screen.width] : [window.screen.width, window.screen.height]
      } else {
        resolution = [window.screen.width, window.screen.height]
      }
      keys.addPreprocessedComponent({key: 'resolution', value: resolution})
      return keys
    },
    availableScreenResolutionKey: function (keys) {
      if (!this.options.excludeAvailableScreenResolution) {
        return this.getAvailableScreenResolution(keys)
      }
      return keys
    },
    getAvailableScreenResolution: function (keys) {
      var available
      if (window.screen.availWidth && window.screen.availHeight) {
        if (this.options.detectScreenOrientation) {
          available = (window.screen.availHeight > window.screen.availWidth) ? [window.screen.availHeight, window.screen.availWidth] : [window.screen.availWidth, window.screen.availHeight]
        } else {
          available = [window.screen.availHeight, window.screen.availWidth]
        }
      }
      if (typeof available !== 'undefined') { // headless browsers
        keys.addPreprocessedComponent({key: 'available_resolution', value: available})
      }
      return keys
    },
    timezoneOffsetKey: function (keys) {
      if (!this.options.excludeTimezoneOffset) {
        keys.addPreprocessedComponent({key: 'timezone_offset', value: new Date().getTimezoneOffset()})
      }
      return keys
    },
    sessionStorageKey: function (keys) {
      if (!this.options.excludeSessionStorage && this.hasSessionStorage()) {
        keys.addPreprocessedComponent({key: 'session_storage', value: 1})
      }
      return keys
    },
    localStorageKey: function (keys) {
      if (!this.options.excludeSessionStorage && this.hasLocalStorage()) {
        keys.addPreprocessedComponent({key: 'local_storage', value: 1})
      }
      return keys
    },
    indexedDbKey: function (keys) {
      if (!this.options.excludeIndexedDB && this.hasIndexedDB()) {
        keys.addPreprocessedComponent({key: 'indexed_db', value: 1})
      }
      return keys
    },
    addBehaviorKey: function (keys) {
      // body might not be defined at this point or removed programmatically
      if (!this.options.excludeAddBehavior && document.body && document.body.addBehavior) {
        keys.addPreprocessedComponent({key: 'add_behavior', value: 1})
      }
      return keys
    },
    openDatabaseKey: function (keys) {
      if (!this.options.excludeOpenDatabase && window.openDatabase) {
        keys.addPreprocessedComponent({key: 'open_database', value: 1})
      }
      return keys
    },
    cpuClassKey: function (keys) {
      if (!this.options.excludeCpuClass) {
        keys.addPreprocessedComponent({key: 'cpu_class', value: this.getNavigatorCpuClass()})
      }
      return keys
    },
    platformKey: function (keys) {
      if (!this.options.excludePlatform) {
        keys.addPreprocessedComponent({key: 'navigator_platform', value: this.getNavigatorPlatform()})
      }
      return keys
    },
    doNotTrackKey: function (keys) {
      if (!this.options.excludeDoNotTrack) {
        keys.addPreprocessedComponent({key: 'do_not_track', value: this.getDoNotTrack()})
      }
      return keys
    },
    canvasKey: function (keys) {
      if (!this.options.excludeCanvas && this.isCanvasSupported()) {
        keys.addPreprocessedComponent({key: 'canvas', value: this.getCanvasFp()})
      }
      return keys
    },
    webglKey: function (keys) {
      if (!this.options.excludeWebGL && this.isWebGlSupported()) {
        keys.addPreprocessedComponent({key: 'webgl', value: this.getWebglFp()})
      }
      return keys
    },
    webglVendorAndRendererKey: function (keys) {
      if (!this.options.excludeWebGLVendorAndRenderer && this.isWebGlSupported()) {
        keys.addPreprocessedComponent({key: 'webgl_vendor', value: this.getWebglVendorAndRenderer()})
      }
      return keys
    },
    adBlockKey: function (keys) {
      if (!this.options.excludeAdBlock) {
        keys.addPreprocessedComponent({key: 'adblock', value: this.getAdBlock()})
      }
      return keys
    },
    hasLiedLanguagesKey: function (keys) {
      if (!this.options.excludeHasLiedLanguages) {
        keys.addPreprocessedComponent({key: 'has_lied_languages', value: this.getHasLiedLanguages()})
      }
      return keys
    },
    hasLiedResolutionKey: function (keys) {
      if (!this.options.excludeHasLiedResolution) {
        keys.addPreprocessedComponent({key: 'has_lied_resolution', value: this.getHasLiedResolution()})
      }
      return keys
    },
    hasLiedOsKey: function (keys) {
      if (!this.options.excludeHasLiedOs) {
        keys.addPreprocessedComponent({key: 'has_lied_os', value: this.getHasLiedOs()})
      }
      return keys
    },
    hasLiedBrowserKey: function (keys) {
      if (!this.options.excludeHasLiedBrowser) {
        keys.addPreprocessedComponent({key: 'has_lied_browser', value: this.getHasLiedBrowser()})
      }
      return keys
    },
    fontsKey: function (keys, done) {
      if (this.options.excludeJsFonts) {
        return this.flashFontsKey(keys, done)
      }
      return this.jsFontsKey(keys, done)
    },
    // flash fonts (will increase fingerprinting time 20X to ~ 130-150ms)
    flashFontsKey: function (keys, done) {
      if (this.options.excludeFlashFonts) {
        return done(keys)
      }
      // we do flash if swfobject is loaded
      if (!this.hasSwfObjectLoaded()) {
        return done(keys)
      }
      if (!this.hasMinFlashInstalled()) {
        return done(keys)
      }
      if (typeof this.options.swfPath === 'undefined') {
        return done(keys)
      }
      this.loadSwfAndDetectFonts(function (fonts) {
        keys.addPreprocessedComponent({key: 'swf_fonts', value: fonts.join(';')})
        done(keys)
      })
    },
    // kudos to http://www.lalit.org/lab/javascript-css-font-detect/
    jsFontsKey: function (keys, done) {
      var that = this
      // doing js fonts detection in a pseudo-async fashion
      return setTimeout(function () {
        // a font will be compared against all the three default fonts.
        // and if it doesn't match all 3 then that font is not available.
        var baseFonts = ['monospace', 'sans-serif', 'serif']

        var fontList = [
          'Andale Mono', 'Arial', 'Arial Black', 'Arial Hebrew', 'Arial MT', 'Arial Narrow', 'Arial Rounded MT Bold', 'Arial Unicode MS',
          'Bitstream Vera Sans Mono', 'Book Antiqua', 'Bookman Old Style',
          'Calibri', 'Cambria', 'Cambria Math', 'Century', 'Century Gothic', 'Century Schoolbook', 'Comic Sans', 'Comic Sans MS', 'Consolas', 'Courier', 'Courier New',
          'Garamond', 'Geneva', 'Georgia',
          'Helvetica', 'Helvetica Neue',
          'Impact',
          'Lucida Bright', 'Lucida Calligraphy', 'Lucida Console', 'Lucida Fax', 'LUCIDA GRANDE', 'Lucida Handwriting', 'Lucida Sans', 'Lucida Sans Typewriter', 'Lucida Sans Unicode',
          'Microsoft Sans Serif', 'Monaco', 'Monotype Corsiva', 'MS Gothic', 'MS Outlook', 'MS PGothic', 'MS Reference Sans Serif', 'MS Sans Serif', 'MS Serif', 'MYRIAD', 'MYRIAD PRO',
          'Palatino', 'Palatino Linotype',
          'Segoe Print', 'Segoe Script', 'Segoe UI', 'Segoe UI Light', 'Segoe UI Semibold', 'Segoe UI Symbol',
          'Tahoma', 'Times', 'Times New Roman', 'Times New Roman PS', 'Trebuchet MS',
          'Verdana', 'Wingdings', 'Wingdings 2', 'Wingdings 3'
        ]
        var extendedFontList = [
          'Abadi MT Condensed Light', 'Academy Engraved LET', 'ADOBE CASLON PRO', 'Adobe Garamond', 'ADOBE GARAMOND PRO', 'Agency FB', 'Aharoni', 'Albertus Extra Bold', 'Albertus Medium', 'Algerian', 'Amazone BT', 'American Typewriter',
          'American Typewriter Condensed', 'AmerType Md BT', 'Andalus', 'Angsana New', 'AngsanaUPC', 'Antique Olive', 'Aparajita', 'Apple Chancery', 'Apple Color Emoji', 'Apple SD Gothic Neo', 'Arabic Typesetting', 'ARCHER',
          'ARNO PRO', 'Arrus BT', 'Aurora Cn BT', 'AvantGarde Bk BT', 'AvantGarde Md BT', 'AVENIR', 'Ayuthaya', 'Bandy', 'Bangla Sangam MN', 'Bank Gothic', 'BankGothic Md BT', 'Baskerville',
          'Baskerville Old Face', 'Batang', 'BatangChe', 'Bauer Bodoni', 'Bauhaus 93', 'Bazooka', 'Bell MT', 'Bembo', 'Benguiat Bk BT', 'Berlin Sans FB', 'Berlin Sans FB Demi', 'Bernard MT Condensed', 'BernhardFashion BT', 'BernhardMod BT', 'Big Caslon', 'BinnerD',
          'Blackadder ITC', 'BlairMdITC TT', 'Bodoni 72', 'Bodoni 72 Oldstyle', 'Bodoni 72 Smallcaps', 'Bodoni MT', 'Bodoni MT Black', 'Bodoni MT Condensed', 'Bodoni MT Poster Compressed',
          'Bookshelf Symbol 7', 'Boulder', 'Bradley Hand', 'Bradley Hand ITC', 'Bremen Bd BT', 'Britannic Bold', 'Broadway', 'Browallia New', 'BrowalliaUPC', 'Brush Script MT', 'Californian FB', 'Calisto MT', 'Calligrapher', 'Candara',
          'CaslonOpnface BT', 'Castellar', 'Centaur', 'Cezanne', 'CG Omega', 'CG Times', 'Chalkboard', 'Chalkboard SE', 'Chalkduster', 'Charlesworth', 'Charter Bd BT', 'Charter BT', 'Chaucer',
          'ChelthmITC Bk BT', 'Chiller', 'Clarendon', 'Clarendon Condensed', 'CloisterBlack BT', 'Cochin', 'Colonna MT', 'Constantia', 'Cooper Black', 'Copperplate', 'Copperplate Gothic', 'Copperplate Gothic Bold',
          'Copperplate Gothic Light', 'CopperplGoth Bd BT', 'Corbel', 'Cordia New', 'CordiaUPC', 'Cornerstone', 'Coronet', 'Cuckoo', 'Curlz MT', 'DaunPenh', 'Dauphin', 'David', 'DB LCD Temp', 'DELICIOUS', 'Denmark',
          'DFKai-SB', 'Didot', 'DilleniaUPC', 'DIN', 'DokChampa', 'Dotum', 'DotumChe', 'Ebrima', 'Edwardian Script ITC', 'Elephant', 'English 111 Vivace BT', 'Engravers MT', 'EngraversGothic BT', 'Eras Bold ITC', 'Eras Demi ITC', 'Eras Light ITC', 'Eras Medium ITC',
          'EucrosiaUPC', 'Euphemia', 'Euphemia UCAS', 'EUROSTILE', 'Exotc350 Bd BT', 'FangSong', 'Felix Titling', 'Fixedsys', 'FONTIN', 'Footlight MT Light', 'Forte',
          'FrankRuehl', 'Fransiscan', 'Freefrm721 Blk BT', 'FreesiaUPC', 'Freestyle Script', 'French Script MT', 'FrnkGothITC Bk BT', 'Fruitger', 'FRUTIGER',
          'Futura', 'Futura Bk BT', 'Futura Lt BT', 'Futura Md BT', 'Futura ZBlk BT', 'FuturaBlack BT', 'Gabriola', 'Galliard BT', 'Gautami', 'Geeza Pro', 'Geometr231 BT', 'Geometr231 Hv BT', 'Geometr231 Lt BT', 'GeoSlab 703 Lt BT',
          'GeoSlab 703 XBd BT', 'Gigi', 'Gill Sans', 'Gill Sans MT', 'Gill Sans MT Condensed', 'Gill Sans MT Ext Condensed Bold', 'Gill Sans Ultra Bold', 'Gill Sans Ultra Bold Condensed', 'Gisha', 'Gloucester MT Extra Condensed', 'GOTHAM', 'GOTHAM BOLD',
          'Goudy Old Style', 'Goudy Stout', 'GoudyHandtooled BT', 'GoudyOLSt BT', 'Gujarati Sangam MN', 'Gulim', 'GulimChe', 'Gungsuh', 'GungsuhChe', 'Gurmukhi MN', 'Haettenschweiler', 'Harlow Solid Italic', 'Harrington', 'Heather', 'Heiti SC', 'Heiti TC', 'HELV',
          'Herald', 'High Tower Text', 'Hiragino Kaku Gothic ProN', 'Hiragino Mincho ProN', 'Hoefler Text', 'Humanst 521 Cn BT', 'Humanst521 BT', 'Humanst521 Lt BT', 'Imprint MT Shadow', 'Incised901 Bd BT', 'Incised901 BT',
          'Incised901 Lt BT', 'INCONSOLATA', 'Informal Roman', 'Informal011 BT', 'INTERSTATE', 'IrisUPC', 'Iskoola Pota', 'JasmineUPC', 'Jazz LET', 'Jenson', 'Jester', 'Jokerman', 'Juice ITC', 'Kabel Bk BT', 'Kabel Ult BT', 'Kailasa', 'KaiTi', 'Kalinga', 'Kannada Sangam MN',
          'Kartika', 'Kaufmann Bd BT', 'Kaufmann BT', 'Khmer UI', 'KodchiangUPC', 'Kokila', 'Korinna BT', 'Kristen ITC', 'Krungthep', 'Kunstler Script', 'Lao UI', 'Latha', 'Leelawadee', 'Letter Gothic', 'Levenim MT', 'LilyUPC', 'Lithograph', 'Lithograph Light', 'Long Island',
          'Lydian BT', 'Magneto', 'Maiandra GD', 'Malayalam Sangam MN', 'Malgun Gothic',
          'Mangal', 'Marigold', 'Marion', 'Marker Felt', 'Market', 'Marlett', 'Matisse ITC', 'Matura MT Script Capitals', 'Meiryo', 'Meiryo UI', 'Microsoft Himalaya', 'Microsoft JhengHei', 'Microsoft New Tai Lue', 'Microsoft PhagsPa', 'Microsoft Tai Le',
          'Microsoft Uighur', 'Microsoft YaHei', 'Microsoft Yi Baiti', 'MingLiU', 'MingLiU_HKSCS', 'MingLiU_HKSCS-ExtB', 'MingLiU-ExtB', 'Minion', 'Minion Pro', 'Miriam', 'Miriam Fixed', 'Mistral', 'Modern', 'Modern No. 20', 'Mona Lisa Solid ITC TT', 'Mongolian Baiti',
          'MONO', 'MoolBoran', 'Mrs Eaves', 'MS LineDraw', 'MS Mincho', 'MS PMincho', 'MS Reference Specialty', 'MS UI Gothic', 'MT Extra', 'MUSEO', 'MV Boli',
          'Nadeem', 'Narkisim', 'NEVIS', 'News Gothic', 'News GothicMT', 'NewsGoth BT', 'Niagara Engraved', 'Niagara Solid', 'Noteworthy', 'NSimSun', 'Nyala', 'OCR A Extended', 'Old Century', 'Old English Text MT', 'Onyx', 'Onyx BT', 'OPTIMA', 'Oriya Sangam MN',
          'OSAKA', 'OzHandicraft BT', 'Palace Script MT', 'Papyrus', 'Parchment', 'Party LET', 'Pegasus', 'Perpetua', 'Perpetua Titling MT', 'PetitaBold', 'Pickwick', 'Plantagenet Cherokee', 'Playbill', 'PMingLiU', 'PMingLiU-ExtB',
          'Poor Richard', 'Poster', 'PosterBodoni BT', 'PRINCETOWN LET', 'Pristina', 'PTBarnum BT', 'Pythagoras', 'Raavi', 'Rage Italic', 'Ravie', 'Ribbon131 Bd BT', 'Rockwell', 'Rockwell Condensed', 'Rockwell Extra Bold', 'Rod', 'Roman', 'Sakkal Majalla',
          'Santa Fe LET', 'Savoye LET', 'Sceptre', 'Script', 'Script MT Bold', 'SCRIPTINA', 'Serifa', 'Serifa BT', 'Serifa Th BT', 'ShelleyVolante BT', 'Sherwood',
          'Shonar Bangla', 'Showcard Gothic', 'Shruti', 'Signboard', 'SILKSCREEN', 'SimHei', 'Simplified Arabic', 'Simplified Arabic Fixed', 'SimSun', 'SimSun-ExtB', 'Sinhala Sangam MN', 'Sketch Rockwell', 'Skia', 'Small Fonts', 'Snap ITC', 'Snell Roundhand', 'Socket',
          'Souvenir Lt BT', 'Staccato222 BT', 'Steamer', 'Stencil', 'Storybook', 'Styllo', 'Subway', 'Swis721 BlkEx BT', 'Swiss911 XCm BT', 'Sylfaen', 'Synchro LET', 'System', 'Tamil Sangam MN', 'Technical', 'Teletype', 'Telugu Sangam MN', 'Tempus Sans ITC',
          'Terminal', 'Thonburi', 'Traditional Arabic', 'Trajan', 'TRAJAN PRO', 'Tristan', 'Tubular', 'Tunga', 'Tw Cen MT', 'Tw Cen MT Condensed', 'Tw Cen MT Condensed Extra Bold',
          'TypoUpright BT', 'Unicorn', 'Univers', 'Univers CE 55 Medium', 'Univers Condensed', 'Utsaah', 'Vagabond', 'Vani', 'Vijaya', 'Viner Hand ITC', 'VisualUI', 'Vivaldi', 'Vladimir Script', 'Vrinda', 'Westminster', 'WHITNEY', 'Wide Latin',
          'ZapfEllipt BT', 'ZapfHumnst BT', 'ZapfHumnst Dm BT', 'Zapfino', 'Zurich BlkEx BT', 'Zurich Ex BT', 'ZWAdobeF']

        if (that.options.extendedJsFonts) {
          fontList = fontList.concat(extendedFontList)
        }

        fontList = fontList.concat(that.options.userDefinedFonts)

        // we use m or w because these two characters take up the maximum width.
        // And we use a LLi so that the same matching fonts can get separated
        var testString = 'mmmmmmmmmmlli'

        // we test using 72px font size, we may use any size. I guess larger the better.
        var testSize = '72px'

        var h = document.getElementsByTagName('body')[0]

        // div to load spans for the base fonts
        var baseFontsDiv = document.createElement('div')

        // div to load spans for the fonts to detect
        var fontsDiv = document.createElement('div')

        var defaultWidth = {}
        var defaultHeight = {}

        // creates a span where the fonts will be loaded
        var createSpan = function () {
          var s = document.createElement('span')
            /*
             * We need this css as in some weird browser this
             * span elements shows up for a microSec which creates a
             * bad user experience
             */
          s.style.position = 'absolute'
          s.style.left = '-9999px'
          s.style.fontSize = testSize
          s.style.lineHeight = 'normal'
          s.innerHTML = testString
          return s
        }

        // creates a span and load the font to detect and a base font for fallback
        var createSpanWithFonts = function (fontToDetect, baseFont) {
          var s = createSpan()
          s.style.fontFamily = "'" + fontToDetect + "'," + baseFont
          return s
        }

        // creates spans for the base fonts and adds them to baseFontsDiv
        var initializeBaseFontsSpans = function () {
          var spans = []
          for (var index = 0, length = baseFonts.length; index < length; index++) {
            var s = createSpan()
            s.style.fontFamily = baseFonts[index]
            baseFontsDiv.appendChild(s)
            spans.push(s)
          }
          return spans
        }

        // creates spans for the fonts to detect and adds them to fontsDiv
        var initializeFontsSpans = function () {
          var spans = {}
          for (var i = 0, l = fontList.length; i < l; i++) {
            var fontSpans = []
            for (var j = 0, numDefaultFonts = baseFonts.length; j < numDefaultFonts; j++) {
              var s = createSpanWithFonts(fontList[i], baseFonts[j])
              fontsDiv.appendChild(s)
              fontSpans.push(s)
            }
            spans[fontList[i]] = fontSpans // Stores {fontName : [spans for that font]}
          }
          return spans
        }

        // checks if a font is available
        var isFontAvailable = function (fontSpans) {
          var detected = false
          for (var i = 0; i < baseFonts.length; i++) {
            detected = (fontSpans[i].offsetWidth !== defaultWidth[baseFonts[i]] || fontSpans[i].offsetHeight !== defaultHeight[baseFonts[i]])
            if (detected) {
              return detected
            }
          }
          return detected
        }

        // create spans for base fonts
        var baseFontsSpans = initializeBaseFontsSpans()

        // add the spans to the DOM
        h.appendChild(baseFontsDiv)

        // get the default width for the three base fonts
        for (var index = 0, length = baseFonts.length; index < length; index++) {
          defaultWidth[baseFonts[index]] = baseFontsSpans[index].offsetWidth // width for the default font
          defaultHeight[baseFonts[index]] = baseFontsSpans[index].offsetHeight // height for the default font
        }

        // create spans for fonts to detect
        var fontsSpans = initializeFontsSpans()

        // add all the spans to the DOM
        h.appendChild(fontsDiv)

        // check available fonts
        var available = []
        for (var i = 0, l = fontList.length; i < l; i++) {
          if (isFontAvailable(fontsSpans[fontList[i]])) {
            available.push(fontList[i])
          }
        }

        // remove spans from DOM
        h.removeChild(fontsDiv)
        h.removeChild(baseFontsDiv)

        keys.addPreprocessedComponent({key: 'js_fonts', value: available})
        done(keys)
      }, 1)
    },
    pluginsKey: function (keys) {
      if (!this.options.excludePlugins) {
        if (this.isIE()) {
          if (!this.options.excludeIEPlugins) {
            keys.addPreprocessedComponent({key: 'ie_plugins', value: this.getIEPlugins()})
          }
        } else {
          keys.addPreprocessedComponent({key: 'regular_plugins', value: this.getRegularPlugins()})
        }
      }
      return keys
    },
    getRegularPlugins: function () {
      var plugins = []
      if (navigator.plugins) {
        // plugins isn't defined in Node envs.
        for (var i = 0, l = navigator.plugins.length; i < l; i++) {
          if (navigator.plugins[i]) { plugins.push(navigator.plugins[i]) }
        }
      }
      // sorting plugins only for those user agents, that we know randomize the plugins
      // every time we try to enumerate them
      if (this.pluginsShouldBeSorted()) {
        plugins = plugins.sort(function (a, b) {
          if (a.name > b.name) { return 1 }
          if (a.name < b.name) { return -1 }
          return 0
        })
      }
      return this.map(plugins, function (p) {
        var mimeTypes = this.map(p, function (mt) {
          return [mt.type, mt.suffixes].join('~')
        }).join(',')
        return [p.name, p.description, mimeTypes].join('::')
      }, this)
    },
    getIEPlugins: function () {
      var result = []
      if ((Object.getOwnPropertyDescriptor && Object.getOwnPropertyDescriptor(window, 'ActiveXObject')) || ('ActiveXObject' in window)) {
        var names = [
          'AcroPDF.PDF', // Adobe PDF reader 7+
          'Adodb.Stream',
          'AgControl.AgControl', // Silverlight
          'DevalVRXCtrl.DevalVRXCtrl.1',
          'MacromediaFlashPaper.MacromediaFlashPaper',
          'Msxml2.DOMDocument',
          'Msxml2.XMLHTTP',
          'PDF.PdfCtrl', // Adobe PDF reader 6 and earlier, brrr
          'QuickTime.QuickTime', // QuickTime
          'QuickTimeCheckObject.QuickTimeCheck.1',
          'RealPlayer',
          'RealPlayer.RealPlayer(tm) ActiveX Control (32-bit)',
          'RealVideo.RealVideo(tm) ActiveX Control (32-bit)',
          'Scripting.Dictionary',
          'SWCtl.SWCtl', // ShockWave player
          'Shell.UIHelper',
          'ShockwaveFlash.ShockwaveFlash', // flash plugin
          'Skype.Detection',
          'TDCCtl.TDCCtl',
          'WMPlayer.OCX', // Windows media player
          'rmocx.RealPlayer G2 Control',
          'rmocx.RealPlayer G2 Control.1'
        ]
        // starting to detect plugins in IE
        result = this.map(names, function (name) {
          try {
            // eslint-disable-next-line no-new
            new window.ActiveXObject(name)
            return name
          } catch (e) {
            return null
          }
        })
      }
      if (navigator.plugins) {
        result = result.concat(this.getRegularPlugins())
      }
      return result
    },
    pluginsShouldBeSorted: function () {
      var should = false
      for (var i = 0, l = this.options.sortPluginsFor.length; i < l; i++) {
        var re = this.options.sortPluginsFor[i]
        if (navigator.userAgent.match(re)) {
          should = true
          break
        }
      }
      return should
    },
    touchSupportKey: function (keys) {
      if (!this.options.excludeTouchSupport) {
        keys.addPreprocessedComponent({key: 'touch_support', value: this.getTouchSupport()})
      }
      return keys
    },
    hardwareConcurrencyKey: function (keys) {
      if (!this.options.excludeHardwareConcurrency) {
        keys.addPreprocessedComponent({key: 'hardware_concurrency', value: this.getHardwareConcurrency()})
      }
      return keys
    },
    hasSessionStorage: function () {
      try {
        return !!window.sessionStorage
      } catch (e) {
        return true // SecurityError when referencing it means it exists
      }
    },
    // https://bugzilla.mozilla.org/show_bug.cgi?id=781447
    hasLocalStorage: function () {
      try {
        return !!window.localStorage
      } catch (e) {
        return true // SecurityError when referencing it means it exists
      }
    },
    hasIndexedDB: function () {
      try {
        return !!window.indexedDB
      } catch (e) {
        return true // SecurityError when referencing it means it exists
      }
    },
    getHardwareConcurrency: function () {
      if (navigator.hardwareConcurrency) {
        return navigator.hardwareConcurrency
      }
      return 'unknown'
    },
    getNavigatorCpuClass: function () {
      if (navigator.cpuClass) {
        return navigator.cpuClass
      } else {
        return 'unknown'
      }
    },
    getNavigatorPlatform: function () {
      if (navigator.platform) {
        return navigator.platform
      } else {
        return 'unknown'
      }
    },
    getDoNotTrack: function () {
      if (navigator.doNotTrack) {
        return navigator.doNotTrack
      } else if (navigator.msDoNotTrack) {
        return navigator.msDoNotTrack
      } else if (window.doNotTrack) {
        return window.doNotTrack
      } else {
        return 'unknown'
      }
    },
    // This is a crude and primitive touch screen detection.
    // It's not possible to currently reliably detect the  availability of a touch screen
    // with a JS, without actually subscribing to a touch event.
    // http://www.stucox.com/blog/you-cant-detect-a-touchscreen/
    // https://github.com/Modernizr/Modernizr/issues/548
    // method returns an array of 3 values:
    // maxTouchPoints, the success or failure of creating a TouchEvent,
    // and the availability of the 'ontouchstart' property
    getTouchSupport: function () {
      var maxTouchPoints = 0
      var touchEvent = false
      if (typeof navigator.maxTouchPoints !== 'undefined') {
        maxTouchPoints = navigator.maxTouchPoints
      } else if (typeof navigator.msMaxTouchPoints !== 'undefined') {
        maxTouchPoints = navigator.msMaxTouchPoints
      }
      try {
        document.createEvent('TouchEvent')
        touchEvent = true
      } catch (_) { /* squelch */ }
      var touchStart = 'ontouchstart' in window
      return [maxTouchPoints, touchEvent, touchStart]
    },
    // https://www.browserleaks.com/canvas#how-does-it-work
    getCanvasFp: function () {
      var result = []
      // Very simple now, need to make it more complex (geo shapes etc)
      var canvas = document.createElement('canvas')
      canvas.width = 2000
      canvas.height = 200
      canvas.style.display = 'inline'
      var ctx = canvas.getContext('2d')
      // detect browser support of canvas winding
      // http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
      // https://github.com/Modernizr/Modernizr/blob/master/feature-detects/canvas/winding.js
      ctx.rect(0, 0, 10, 10)
      ctx.rect(2, 2, 6, 6)
      result.push('canvas winding:' + ((ctx.isPointInPath(5, 5, 'evenodd') === false) ? 'yes' : 'no'))

      ctx.textBaseline = 'alphabetic'
      ctx.fillStyle = '#f60'
      ctx.fillRect(125, 1, 62, 20)
      ctx.fillStyle = '#069'
      // https://github.com/Valve/fingerprintjs2/issues/66
      if (this.options.dontUseFakeFontInCanvas) {
        ctx.font = '11pt Arial'
      } else {
        ctx.font = '11pt no-real-font-123'
      }
      ctx.fillText('Cwm fjordbank glyphs vext quiz, \ud83d\ude03', 2, 15)
      ctx.fillStyle = 'rgba(102, 204, 0, 0.2)'
      ctx.font = '18pt Arial'
      ctx.fillText('Cwm fjordbank glyphs vext quiz, \ud83d\ude03', 4, 45)

      // canvas blending
      // http://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/
      // http://jsfiddle.net/NDYV8/16/
      ctx.globalCompositeOperation = 'multiply'
      ctx.fillStyle = 'rgb(255,0,255)'
      ctx.beginPath()
      ctx.arc(50, 50, 50, 0, Math.PI * 2, true)
      ctx.closePath()
      ctx.fill()
      ctx.fillStyle = 'rgb(0,255,255)'
      ctx.beginPath()
      ctx.arc(100, 50, 50, 0, Math.PI * 2, true)
      ctx.closePath()
      ctx.fill()
      ctx.fillStyle = 'rgb(255,255,0)'
      ctx.beginPath()
      ctx.arc(75, 100, 50, 0, Math.PI * 2, true)
      ctx.closePath()
      ctx.fill()
      ctx.fillStyle = 'rgb(255,0,255)'
      // canvas winding
      // http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
      // http://jsfiddle.net/NDYV8/19/
      ctx.arc(75, 75, 75, 0, Math.PI * 2, true)
      ctx.arc(75, 75, 25, 0, Math.PI * 2, true)
      ctx.fill('evenodd')

      if (canvas.toDataURL) { result.push('canvas fp:' + canvas.toDataURL()) }
      return result.join('~')
    },

    getWebglFp: function () {
      var gl
      var fa2s = function (fa) {
        gl.clearColor(0.0, 0.0, 0.0, 1.0)
        gl.enable(gl.DEPTH_TEST)
        gl.depthFunc(gl.LEQUAL)
        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT)
        return '[' + fa[0] + ', ' + fa[1] + ']'
      }
      var maxAnisotropy = function (gl) {
        var ext = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic')
        if (ext) {
          var anisotropy = gl.getParameter(ext.MAX_TEXTURE_MAX_ANISOTROPY_EXT)
          if (anisotropy === 0) {
            anisotropy = 2
          }
          return anisotropy
        } else {
          return null
        }
      }
      gl = this.getWebglCanvas()
      if (!gl) { return null }
      // WebGL fingerprinting is a combination of techniques, found in MaxMind antifraud script & Augur fingerprinting.
      // First it draws a gradient object with shaders and convers the image to the Base64 string.
      // Then it enumerates all WebGL extensions & capabilities and appends them to the Base64 string, resulting in a huge WebGL string, potentially very unique on each device
      // Since iOS supports webgl starting from version 8.1 and 8.1 runs on several graphics chips, the results may be different across ios devices, but we need to verify it.
      var result = []
      var vShaderTemplate = 'attribute vec2 attrVertex;varying vec2 varyinTexCoordinate;uniform vec2 uniformOffset;void main(){varyinTexCoordinate=attrVertex+uniformOffset;gl_Position=vec4(attrVertex,0,1);}'
      var fShaderTemplate = 'precision mediump float;varying vec2 varyinTexCoordinate;void main() {gl_FragColor=vec4(varyinTexCoordinate,0,1);}'
      var vertexPosBuffer = gl.createBuffer()
      gl.bindBuffer(gl.ARRAY_BUFFER, vertexPosBuffer)
      var vertices = new Float32Array([-0.2, -0.9, 0, 0.4, -0.26, 0, 0, 0.732134444, 0])
      gl.bufferData(gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW)
      vertexPosBuffer.itemSize = 3
      vertexPosBuffer.numItems = 3
      var program = gl.createProgram()
      var vshader = gl.createShader(gl.VERTEX_SHADER)
      gl.shaderSource(vshader, vShaderTemplate)
      gl.compileShader(vshader)
      var fshader = gl.createShader(gl.FRAGMENT_SHADER)
      gl.shaderSource(fshader, fShaderTemplate)
      gl.compileShader(fshader)
      gl.attachShader(program, vshader)
      gl.attachShader(program, fshader)
      gl.linkProgram(program)
      gl.useProgram(program)
      program.vertexPosAttrib = gl.getAttribLocation(program, 'attrVertex')
      program.offsetUniform = gl.getUniformLocation(program, 'uniformOffset')
      gl.enableVertexAttribArray(program.vertexPosArray)
      gl.vertexAttribPointer(program.vertexPosAttrib, vertexPosBuffer.itemSize, gl.FLOAT, !1, 0, 0)
      gl.uniform2f(program.offsetUniform, 1, 1)
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, vertexPosBuffer.numItems)
      try {
        result.push(gl.canvas.toDataURL())
      } catch (e) {
        /* .toDataURL may be absent or broken (blocked by extension) */
      }
      result.push('extensions:' + (gl.getSupportedExtensions() || []).join(';'))
      result.push('webgl aliased line width range:' + fa2s(gl.getParameter(gl.ALIASED_LINE_WIDTH_RANGE)))
      result.push('webgl aliased point size range:' + fa2s(gl.getParameter(gl.ALIASED_POINT_SIZE_RANGE)))
      result.push('webgl alpha bits:' + gl.getParameter(gl.ALPHA_BITS))
      result.push('webgl antialiasing:' + (gl.getContextAttributes().antialias ? 'yes' : 'no'))
      result.push('webgl blue bits:' + gl.getParameter(gl.BLUE_BITS))
      result.push('webgl depth bits:' + gl.getParameter(gl.DEPTH_BITS))
      result.push('webgl green bits:' + gl.getParameter(gl.GREEN_BITS))
      result.push('webgl max anisotropy:' + maxAnisotropy(gl))
      result.push('webgl max combined texture image units:' + gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS))
      result.push('webgl max cube map texture size:' + gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE))
      result.push('webgl max fragment uniform vectors:' + gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS))
      result.push('webgl max render buffer size:' + gl.getParameter(gl.MAX_RENDERBUFFER_SIZE))
      result.push('webgl max texture image units:' + gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS))
      result.push('webgl max texture size:' + gl.getParameter(gl.MAX_TEXTURE_SIZE))
      result.push('webgl max varying vectors:' + gl.getParameter(gl.MAX_VARYING_VECTORS))
      result.push('webgl max vertex attribs:' + gl.getParameter(gl.MAX_VERTEX_ATTRIBS))
      result.push('webgl max vertex texture image units:' + gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS))
      result.push('webgl max vertex uniform vectors:' + gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS))
      result.push('webgl max viewport dims:' + fa2s(gl.getParameter(gl.MAX_VIEWPORT_DIMS)))
      result.push('webgl red bits:' + gl.getParameter(gl.RED_BITS))
      result.push('webgl renderer:' + gl.getParameter(gl.RENDERER))
      result.push('webgl shading language version:' + gl.getParameter(gl.SHADING_LANGUAGE_VERSION))
      result.push('webgl stencil bits:' + gl.getParameter(gl.STENCIL_BITS))
      result.push('webgl vendor:' + gl.getParameter(gl.VENDOR))
      result.push('webgl version:' + gl.getParameter(gl.VERSION))

      try {
        // Add the unmasked vendor and unmasked renderer if the debug_renderer_info extension is available
        var extensionDebugRendererInfo = gl.getExtension('WEBGL_debug_renderer_info')
        if (extensionDebugRendererInfo) {
          result.push('webgl unmasked vendor:' + gl.getParameter(extensionDebugRendererInfo.UNMASKED_VENDOR_WEBGL))
          result.push('webgl unmasked renderer:' + gl.getParameter(extensionDebugRendererInfo.UNMASKED_RENDERER_WEBGL))
        }
      } catch (e) { /* squelch */ }

      if (!gl.getShaderPrecisionFormat) {
        return result.join('~')
      }

      result.push('webgl vertex shader high float precision:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision)
      result.push('webgl vertex shader high float precision rangeMin:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).rangeMin)
      result.push('webgl vertex shader high float precision rangeMax:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).rangeMax)
      result.push('webgl vertex shader medium float precision:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision)
      result.push('webgl vertex shader medium float precision rangeMin:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).rangeMin)
      result.push('webgl vertex shader medium float precision rangeMax:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).rangeMax)
      result.push('webgl vertex shader low float precision:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.LOW_FLOAT).precision)
      result.push('webgl vertex shader low float precision rangeMin:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.LOW_FLOAT).rangeMin)
      result.push('webgl vertex shader low float precision rangeMax:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.LOW_FLOAT).rangeMax)
      result.push('webgl fragment shader high float precision:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision)
      result.push('webgl fragment shader high float precision rangeMin:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).rangeMin)
      result.push('webgl fragment shader high float precision rangeMax:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).rangeMax)
      result.push('webgl fragment shader medium float precision:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision)
      result.push('webgl fragment shader medium float precision rangeMin:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).rangeMin)
      result.push('webgl fragment shader medium float precision rangeMax:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).rangeMax)
      result.push('webgl fragment shader low float precision:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.LOW_FLOAT).precision)
      result.push('webgl fragment shader low float precision rangeMin:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.LOW_FLOAT).rangeMin)
      result.push('webgl fragment shader low float precision rangeMax:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.LOW_FLOAT).rangeMax)
      result.push('webgl vertex shader high int precision:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_INT).precision)
      result.push('webgl vertex shader high int precision rangeMin:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_INT).rangeMin)
      result.push('webgl vertex shader high int precision rangeMax:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_INT).rangeMax)
      result.push('webgl vertex shader medium int precision:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_INT).precision)
      result.push('webgl vertex shader medium int precision rangeMin:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_INT).rangeMin)
      result.push('webgl vertex shader medium int precision rangeMax:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_INT).rangeMax)
      result.push('webgl vertex shader low int precision:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.LOW_INT).precision)
      result.push('webgl vertex shader low int precision rangeMin:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.LOW_INT).rangeMin)
      result.push('webgl vertex shader low int precision rangeMax:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.LOW_INT).rangeMax)
      result.push('webgl fragment shader high int precision:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_INT).precision)
      result.push('webgl fragment shader high int precision rangeMin:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_INT).rangeMin)
      result.push('webgl fragment shader high int precision rangeMax:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_INT).rangeMax)
      result.push('webgl fragment shader medium int precision:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_INT).precision)
      result.push('webgl fragment shader medium int precision rangeMin:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_INT).rangeMin)
      result.push('webgl fragment shader medium int precision rangeMax:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_INT).rangeMax)
      result.push('webgl fragment shader low int precision:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.LOW_INT).precision)
      result.push('webgl fragment shader low int precision rangeMin:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.LOW_INT).rangeMin)
      result.push('webgl fragment shader low int precision rangeMax:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.LOW_INT).rangeMax)
      return result.join('~')
    },
    getWebglVendorAndRenderer: function () {
      /* This a subset of the WebGL fingerprint with a lot of entropy, while being reasonably browser-independent */
      try {
        var glContext = this.getWebglCanvas()
        var extensionDebugRendererInfo = glContext.getExtension('WEBGL_debug_renderer_info')
        return glContext.getParameter(extensionDebugRendererInfo.UNMASKED_VENDOR_WEBGL) + '~' + glContext.getParameter(extensionDebugRendererInfo.UNMASKED_RENDERER_WEBGL)
      } catch (e) {
        return null
      }
    },
    getAdBlock: function () {
      var ads = document.createElement('div')
      ads.innerHTML = '&nbsp;'
      ads.className = 'adsbox'
      var result = false
      try {
        // body may not exist, that's why we need try/catch
        document.body.appendChild(ads)
        result = document.getElementsByClassName('adsbox')[0].offsetHeight === 0
        document.body.removeChild(ads)
      } catch (e) {
        result = false
      }
      return result
    },
    getHasLiedLanguages: function () {
      // We check if navigator.language is equal to the first language of navigator.languages
      if (typeof navigator.languages !== 'undefined') {
        try {
          var firstLanguages = navigator.languages[0].substr(0, 2)
          if (firstLanguages !== navigator.language.substr(0, 2)) {
            return true
          }
        } catch (err) {
          return true
        }
      }
      return false
    },
    getHasLiedResolution: function () {
      if (window.screen.width < window.screen.availWidth) {
        return true
      }
      if (window.screen.height < window.screen.availHeight) {
        return true
      }
      return false
    },
    getHasLiedOs: function () {
      var userAgent = navigator.userAgent.toLowerCase()
      var oscpu = navigator.oscpu
      var platform = navigator.platform.toLowerCase()
      var os
      // We extract the OS from the user agent (respect the order of the if else if statement)
      if (userAgent.indexOf('windows phone') >= 0) {
        os = 'Windows Phone'
      } else if (userAgent.indexOf('win') >= 0) {
        os = 'Windows'
      } else if (userAgent.indexOf('android') >= 0) {
        os = 'Android'
      } else if (userAgent.indexOf('linux') >= 0) {
        os = 'Linux'
      } else if (userAgent.indexOf('iphone') >= 0 || userAgent.indexOf('ipad') >= 0) {
        os = 'iOS'
      } else if (userAgent.indexOf('mac') >= 0) {
        os = 'Mac'
      } else {
        os = 'Other'
      }
      // We detect if the person uses a mobile device
      var mobileDevice
      if (('ontouchstart' in window) ||
           (navigator.maxTouchPoints > 0) ||
           (navigator.msMaxTouchPoints > 0)) {
        mobileDevice = true
      } else {
        mobileDevice = false
      }

      if (mobileDevice && os !== 'Windows Phone' && os !== 'Android' && os !== 'iOS' && os !== 'Other') {
        return true
      }

      // We compare oscpu with the OS extracted from the UA
      if (typeof oscpu !== 'undefined') {
        oscpu = oscpu.toLowerCase()
        if (oscpu.indexOf('win') >= 0 && os !== 'Windows' && os !== 'Windows Phone') {
          return true
        } else if (oscpu.indexOf('linux') >= 0 && os !== 'Linux' && os !== 'Android') {
          return true
        } else if (oscpu.indexOf('mac') >= 0 && os !== 'Mac' && os !== 'iOS') {
          return true
        } else if ((oscpu.indexOf('win') === -1 && oscpu.indexOf('linux') === -1 && oscpu.indexOf('mac') === -1) !== (os === 'Other')) {
          return true
        }
      }

      // We compare platform with the OS extracted from the UA
      if (platform.indexOf('win') >= 0 && os !== 'Windows' && os !== 'Windows Phone') {
        return true
      } else if ((platform.indexOf('linux') >= 0 || platform.indexOf('android') >= 0 || platform.indexOf('pike') >= 0) && os !== 'Linux' && os !== 'Android') {
        return true
      } else if ((platform.indexOf('mac') >= 0 || platform.indexOf('ipad') >= 0 || platform.indexOf('ipod') >= 0 || platform.indexOf('iphone') >= 0) && os !== 'Mac' && os !== 'iOS') {
        return true
      } else if ((platform.indexOf('win') === -1 && platform.indexOf('linux') === -1 && platform.indexOf('mac') === -1) !== (os === 'Other')) {
        return true
      }

      if (typeof navigator.plugins === 'undefined' && os !== 'Windows' && os !== 'Windows Phone') {
        // We are are in the case where the person uses ie, therefore we can infer that it's windows
        return true
      }

      return false
    },
    getHasLiedBrowser: function () {
      var userAgent = navigator.userAgent.toLowerCase()
      var productSub = navigator.productSub

      // we extract the browser from the user agent (respect the order of the tests)
      var browser
      if (userAgent.indexOf('firefox') >= 0) {
        browser = 'Firefox'
      } else if (userAgent.indexOf('opera') >= 0 || userAgent.indexOf('opr') >= 0) {
        browser = 'Opera'
      } else if (userAgent.indexOf('chrome') >= 0) {
        browser = 'Chrome'
      } else if (userAgent.indexOf('safari') >= 0) {
        browser = 'Safari'
      } else if (userAgent.indexOf('trident') >= 0) {
        browser = 'Internet Explorer'
      } else {
        browser = 'Other'
      }

      if ((browser === 'Chrome' || browser === 'Safari' || browser === 'Opera') && productSub !== '20030107') {
        return true
      }

      // eslint-disable-next-line no-eval
      var tempRes = eval.toString().length
      if (tempRes === 37 && browser !== 'Safari' && browser !== 'Firefox' && browser !== 'Other') {
        return true
      } else if (tempRes === 39 && browser !== 'Internet Explorer' && browser !== 'Other') {
        return true
      } else if (tempRes === 33 && browser !== 'Chrome' && browser !== 'Opera' && browser !== 'Other') {
        return true
      }

      // We create an error to see how it is handled
      var errFirefox
      try {
        // eslint-disable-next-line no-throw-literal
        throw 'a'
      } catch (err) {
        try {
          err.toSource()
          errFirefox = true
        } catch (errOfErr) {
          errFirefox = false
        }
      }
      if (errFirefox && browser !== 'Firefox' && browser !== 'Other') {
        return true
      }
      return false
    },
    isCanvasSupported: function () {
      var elem = document.createElement('canvas')
      return !!(elem.getContext && elem.getContext('2d'))
    },
    isWebGlSupported: function () {
      // code taken from Modernizr
      if (!this.isCanvasSupported()) {
        return false
      }

      var glContext = this.getWebglCanvas()
      return !!window.WebGLRenderingContext && !!glContext
    },
    isIE: function () {
      if (navigator.appName === 'Microsoft Internet Explorer') {
        return true
      } else if (navigator.appName === 'Netscape' && /Trident/.test(navigator.userAgent)) { // IE 11
        return true
      }
      return false
    },
    hasSwfObjectLoaded: function () {
      return typeof window.swfobject !== 'undefined'
    },
    hasMinFlashInstalled: function () {
      return window.swfobject.hasFlashPlayerVersion('9.0.0')
    },
    addFlashDivNode: function () {
      var node = document.createElement('div')
      node.setAttribute('id', this.options.swfContainerId)
      document.body.appendChild(node)
    },
    loadSwfAndDetectFonts: function (done) {
      var hiddenCallback = '___fp_swf_loaded'
      window[hiddenCallback] = function (fonts) {
        done(fonts)
      }
      var id = this.options.swfContainerId
      this.addFlashDivNode()
      var flashvars = { onReady: hiddenCallback }
      var flashparams = { allowScriptAccess: 'always', menu: 'false' }
      window.swfobject.embedSWF(this.options.swfPath, id, '1', '1', '9.0.0', false, flashvars, flashparams, {})
    },
    getWebglCanvas: function () {
      var canvas = document.createElement('canvas')
      var gl = null
      try {
        gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl')
      } catch (e) { /* squelch */ }
      if (!gl) { gl = null }
      return gl
    },

    /**
     * @template T
     * @param {T=} context
     */
    each: function (obj, iterator, context) {
      if (obj === null) {
        return
      }
      if (this.nativeForEach && obj.forEach === this.nativeForEach) {
        obj.forEach(iterator, context)
      } else if (obj.length === +obj.length) {
        for (var i = 0, l = obj.length; i < l; i++) {
          if (iterator.call(context, obj[i], i, obj) === {}) { return }
        }
      } else {
        for (var key in obj) {
          if (obj.hasOwnProperty(key)) {
            if (iterator.call(context, obj[key], key, obj) === {}) { return }
          }
        }
      }
    },

    /**
     * @template T,V
     * @param {T=} context
     * @param {function(this:T, ?, (string|number), T=):V} iterator
     * @return {V}
     */
    map: function (obj, iterator, context) {
      var results = []
      // Not using strict equality so that this acts as a
      // shortcut to checking for `null` and `undefined`.
      if (obj === null) { return results }
      if (this.nativeMap && obj.map === this.nativeMap) { return obj.map(iterator, context) }
      this.each(obj, function (value, index, list) {
        results[results.length] = iterator.call(context, value, index, list)
      })
      return results
    },

    /// MurmurHash3 related functions

    //
    // Given two 64bit ints (as an array of two 32bit ints) returns the two
    // added together as a 64bit int (as an array of two 32bit ints).
    //
    x64Add: function (m, n) {
      m = [m[0] >>> 16, m[0] & 0xffff, m[1] >>> 16, m[1] & 0xffff]
      n = [n[0] >>> 16, n[0] & 0xffff, n[1] >>> 16, n[1] & 0xffff]
      var o = [0, 0, 0, 0]
      o[3] += m[3] + n[3]
      o[2] += o[3] >>> 16
      o[3] &= 0xffff
      o[2] += m[2] + n[2]
      o[1] += o[2] >>> 16
      o[2] &= 0xffff
      o[1] += m[1] + n[1]
      o[0] += o[1] >>> 16
      o[1] &= 0xffff
      o[0] += m[0] + n[0]
      o[0] &= 0xffff
      return [(o[0] << 16) | o[1], (o[2] << 16) | o[3]]
    },

    //
    // Given two 64bit ints (as an array of two 32bit ints) returns the two
    // multiplied together as a 64bit int (as an array of two 32bit ints).
    //
    x64Multiply: function (m, n) {
      m = [m[0] >>> 16, m[0] & 0xffff, m[1] >>> 16, m[1] & 0xffff]
      n = [n[0] >>> 16, n[0] & 0xffff, n[1] >>> 16, n[1] & 0xffff]
      var o = [0, 0, 0, 0]
      o[3] += m[3] * n[3]
      o[2] += o[3] >>> 16
      o[3] &= 0xffff
      o[2] += m[2] * n[3]
      o[1] += o[2] >>> 16
      o[2] &= 0xffff
      o[2] += m[3] * n[2]
      o[1] += o[2] >>> 16
      o[2] &= 0xffff
      o[1] += m[1] * n[3]
      o[0] += o[1] >>> 16
      o[1] &= 0xffff
      o[1] += m[2] * n[2]
      o[0] += o[1] >>> 16
      o[1] &= 0xffff
      o[1] += m[3] * n[1]
      o[0] += o[1] >>> 16
      o[1] &= 0xffff
      o[0] += (m[0] * n[3]) + (m[1] * n[2]) + (m[2] * n[1]) + (m[3] * n[0])
      o[0] &= 0xffff
      return [(o[0] << 16) | o[1], (o[2] << 16) | o[3]]
    },
    //
    // Given a 64bit int (as an array of two 32bit ints) and an int
    // representing a number of bit positions, returns the 64bit int (as an
    // array of two 32bit ints) rotated left by that number of positions.
    //
    x64Rotl: function (m, n) {
      n %= 64
      if (n === 32) {
        return [m[1], m[0]]
      } else if (n < 32) {
        return [(m[0] << n) | (m[1] >>> (32 - n)), (m[1] << n) | (m[0] >>> (32 - n))]
      } else {
        n -= 32
        return [(m[1] << n) | (m[0] >>> (32 - n)), (m[0] << n) | (m[1] >>> (32 - n))]
      }
    },
    //
    // Given a 64bit int (as an array of two 32bit ints) and an int
    // representing a number of bit positions, returns the 64bit int (as an
    // array of two 32bit ints) shifted left by that number of positions.
    //
    x64LeftShift: function (m, n) {
      n %= 64
      if (n === 0) {
        return m
      } else if (n < 32) {
        return [(m[0] << n) | (m[1] >>> (32 - n)), m[1] << n]
      } else {
        return [m[1] << (n - 32), 0]
      }
    },
    //
    // Given two 64bit ints (as an array of two 32bit ints) returns the two
    // xored together as a 64bit int (as an array of two 32bit ints).
    //
    x64Xor: function (m, n) {
      return [m[0] ^ n[0], m[1] ^ n[1]]
    },
    //
    // Given a block, returns murmurHash3's final x64 mix of that block.
    // (`[0, h[0] >>> 1]` is a 33 bit unsigned right shift. This is the
    // only place where we need to right shift 64bit ints.)
    //
    x64Fmix: function (h) {
      h = this.x64Xor(h, [0, h[0] >>> 1])
      h = this.x64Multiply(h, [0xff51afd7, 0xed558ccd])
      h = this.x64Xor(h, [0, h[0] >>> 1])
      h = this.x64Multiply(h, [0xc4ceb9fe, 0x1a85ec53])
      h = this.x64Xor(h, [0, h[0] >>> 1])
      return h
    },

    //
    // Given a string and an optional seed as an int, returns a 128 bit
    // hash using the x64 flavor of MurmurHash3, as an unsigned hex.
    //
    x64hash128: function (key, seed) {
      key = key || ''
      seed = seed || 0
      var remainder = key.length % 16
      var bytes = key.length - remainder
      var h1 = [0, seed]
      var h2 = [0, seed]
      var k1 = [0, 0]
      var k2 = [0, 0]
      var c1 = [0x87c37b91, 0x114253d5]
      var c2 = [0x4cf5ad43, 0x2745937f]
      for (var i = 0; i < bytes; i = i + 16) {
        k1 = [((key.charCodeAt(i + 4) & 0xff)) | ((key.charCodeAt(i + 5) & 0xff) << 8) | ((key.charCodeAt(i + 6) & 0xff) << 16) | ((key.charCodeAt(i + 7) & 0xff) << 24), ((key.charCodeAt(i) & 0xff)) | ((key.charCodeAt(i + 1) & 0xff) << 8) | ((key.charCodeAt(i + 2) & 0xff) << 16) | ((key.charCodeAt(i + 3) & 0xff) << 24)]
        k2 = [((key.charCodeAt(i + 12) & 0xff)) | ((key.charCodeAt(i + 13) & 0xff) << 8) | ((key.charCodeAt(i + 14) & 0xff) << 16) | ((key.charCodeAt(i + 15) & 0xff) << 24), ((key.charCodeAt(i + 8) & 0xff)) | ((key.charCodeAt(i + 9) & 0xff) << 8) | ((key.charCodeAt(i + 10) & 0xff) << 16) | ((key.charCodeAt(i + 11) & 0xff) << 24)]
        k1 = this.x64Multiply(k1, c1)
        k1 = this.x64Rotl(k1, 31)
        k1 = this.x64Multiply(k1, c2)
        h1 = this.x64Xor(h1, k1)
        h1 = this.x64Rotl(h1, 27)
        h1 = this.x64Add(h1, h2)
        h1 = this.x64Add(this.x64Multiply(h1, [0, 5]), [0, 0x52dce729])
        k2 = this.x64Multiply(k2, c2)
        k2 = this.x64Rotl(k2, 33)
        k2 = this.x64Multiply(k2, c1)
        h2 = this.x64Xor(h2, k2)
        h2 = this.x64Rotl(h2, 31)
        h2 = this.x64Add(h2, h1)
        h2 = this.x64Add(this.x64Multiply(h2, [0, 5]), [0, 0x38495ab5])
      }
      k1 = [0, 0]
      k2 = [0, 0]
      switch (remainder) {
        case 15:
          k2 = this.x64Xor(k2, this.x64LeftShift([0, key.charCodeAt(i + 14)], 48))
          // fallthrough
        case 14:
          k2 = this.x64Xor(k2, this.x64LeftShift([0, key.charCodeAt(i + 13)], 40))
          // fallthrough
        case 13:
          k2 = this.x64Xor(k2, this.x64LeftShift([0, key.charCodeAt(i + 12)], 32))
          // fallthrough
        case 12:
          k2 = this.x64Xor(k2, this.x64LeftShift([0, key.charCodeAt(i + 11)], 24))
          // fallthrough
        case 11:
          k2 = this.x64Xor(k2, this.x64LeftShift([0, key.charCodeAt(i + 10)], 16))
          // fallthrough
        case 10:
          k2 = this.x64Xor(k2, this.x64LeftShift([0, key.charCodeAt(i + 9)], 8))
          // fallthrough
        case 9:
          k2 = this.x64Xor(k2, [0, key.charCodeAt(i + 8)])
          k2 = this.x64Multiply(k2, c2)
          k2 = this.x64Rotl(k2, 33)
          k2 = this.x64Multiply(k2, c1)
          h2 = this.x64Xor(h2, k2)
          // fallthrough
        case 8:
          k1 = this.x64Xor(k1, this.x64LeftShift([0, key.charCodeAt(i + 7)], 56))
          // fallthrough
        case 7:
          k1 = this.x64Xor(k1, this.x64LeftShift([0, key.charCodeAt(i + 6)], 48))
          // fallthrough
        case 6:
          k1 = this.x64Xor(k1, this.x64LeftShift([0, key.charCodeAt(i + 5)], 40))
          // fallthrough
        case 5:
          k1 = this.x64Xor(k1, this.x64LeftShift([0, key.charCodeAt(i + 4)], 32))
          // fallthrough
        case 4:
          k1 = this.x64Xor(k1, this.x64LeftShift([0, key.charCodeAt(i + 3)], 24))
          // fallthrough
        case 3:
          k1 = this.x64Xor(k1, this.x64LeftShift([0, key.charCodeAt(i + 2)], 16))
          // fallthrough
        case 2:
          k1 = this.x64Xor(k1, this.x64LeftShift([0, key.charCodeAt(i + 1)], 8))
          // fallthrough
        case 1:
          k1 = this.x64Xor(k1, [0, key.charCodeAt(i)])
          k1 = this.x64Multiply(k1, c1)
          k1 = this.x64Rotl(k1, 31)
          k1 = this.x64Multiply(k1, c2)
          h1 = this.x64Xor(h1, k1)
          // fallthrough
      }
      h1 = this.x64Xor(h1, [0, key.length])
      h2 = this.x64Xor(h2, [0, key.length])
      h1 = this.x64Add(h1, h2)
      h2 = this.x64Add(h2, h1)
      h1 = this.x64Fmix(h1)
      h2 = this.x64Fmix(h2)
      h1 = this.x64Add(h1, h2)
      h2 = this.x64Add(h2, h1)
      return ('00000000' + (h1[0] >>> 0).toString(16)).slice(-8) + ('00000000' + (h1[1] >>> 0).toString(16)).slice(-8) + ('00000000' + (h2[0] >>> 0).toString(16)).slice(-8) + ('00000000' + (h2[1] >>> 0).toString(16)).slice(-8)
    }
  }
  Fingerprint2.VERSION = '1.5.1'
  return Fingerprint2
})

var DTOS = {

	Map: function(object, type) {

		if(Object.prototype.toString.call(object) === '[object Array]') {

			if(object.length > 0) {
				var list = new Array();

				for(var i = 0; i < object.length; i++)
					list.push(eval('this._map_'+type+'(object[i])'));

				return list;
			}
		}
		else
			return eval('this._map_'+type+'(object)');
	},

	_map_founds_rised: function(o) {
		return {
			amount: o.payload.amount,
			currency: o.payload.currency
		}
	},

	_map_notification: function(o) {

		this._validate(o, 'id', 'read', 'extra', 'timestamp', 'new');

		return {
			id: o.id,
			read: o.read,
			avatar: o.avatar,
			message: o.message,
			title: o.title,
			extra: o.extra,
			timestamp: o.timestamp,
			new: o.new,
			event: o.event,
			letters: o.letters
		}
	},

	_map_parents: function(o) {

		this._validate(o, 'id', 'name', 'status');

		return {
			id: o.id,
			firstName: o.name,
			yearClass: o.tiers,
			status: o.status,
			dash: '-'
		}
	},

	_map_school: function(o) {

		//this._validate(o, 'id', 'name', 'status');

		return {
			id: o.schoolId,
			city: o.city,
			country: o.country,
			email: o.email,
			parentCount: o.parentCount,
			phoneNumber: o.phoneNumber,
			postCode: o.postCode,
			pupilCount: o.pupilCount,
			name: o.schoolName,
			descr: o.schoolAbout,
			size: o.schoolSize,
			address: o.streetAddress,
			helpTitle: o.helpTitle,
			helpDescription: o.helpDescription,
			links: o.helpfulLinks,
			yearRepCount: o.yearRepCount,
			classRepCount: o.classRepCount,
			ambassadors: o.ambassadors,
			countryId: o.countryId,
			schoolStuff: o.schoolStuff,
			classesCount: o.classesCount,
			yearsCount: o.yearsCount,
			cover: o.schoolCover,
			logo: o.schoolLogo,
			communityReps: o.communityReps,
			parentPercentage: o.parentPercentage,
			newAnnouncements: o.newAnnouncements,
			defaultCurrency: o.currency
		}
	},

	_map_context_user: function(o) {

		this._validate(o, 'id', 'firstName', 'lastName', 'email', 'avatar');

		return {
			id: o.id,
			firstName: o.firstName,
			lastName: o.lastName,
			email: o.email,
			avatar: o.avatar,
			groups: o.groups,
			newNotifications: o.newNotifications,
			newMessages: o.newMessages
		}
	},

	_map_context_school: function(o) {

		this._validate(o, 'id', 'name', 'status', 'logo');

		return {
			id: o.id,
			name: o.name,
			admin: o.admin,
			status: o.status,
			logo: o.logo
		}
	},

	_map_composer: function(o) {

		// this._validate(o, 'currentUserId', 'body', 'postCategory', 'price', 'photoId', 'groupId');

		return {
			currentUserId: o.currentUserId,
			body: o.body,
			postCategory: o.postCategory,
			price: o.price,
			photoId: o.photoId,
			groupId: o.groupId,
			forceListing: o.forceListing,
			attachments: o.attachments,
			files: o.files,
			priceAsDouble: o.priceAsDouble,
			ptaPercentage: o.ptaPercentage,
			currency: o.currency,
			schoolId: o.schoolId,
			title: o.title,
			onlinePayment: o.onlinePayment,
			showPTADonation: o.showPTADonation,
			linkPreview: o.linkPreview
		}
	},

	_validate: function() {
		var o = arguments[0];

		for(var prop in o) {
		for (var i = 1; i < arguments.length; ++i) {
			if (!Object.prototype.hasOwnProperty.call(o, arguments[i])) {
					throw new Error('DTOS -> Missing object parameter: ' + arguments[i]);
				}
		}
	}
	}
};

(function() {
	'use strict';

	angular.module('modules.participants',[]).factory('participantsService', ['base', function (base) {
		return _.create(base, { });
	}]).directive('participants', participants);
	/** @ngInject */
	function participants( $translate, $rootScope, participantsService, toastr, $timeout) {

		var directive = {
			restrict: 'EA',
			replace: false,
			scope:{
				ngModel: '='
			},
			templateUrl:'app/base/directives/participants.module.html',
			link: linkFunction
		};

		return directive;

		function linkFunction(scope, elem, attrs) {
			scope.participants = scope.ngModel || [];
			scope.members = [];
			scope.showMembers = false;

			scope.inputPlaceholder = $translate.instant('ADD_RECIPIENT_SEARCH_PHOLDER');
			
			if(attrs.eventContext === 'true')
				scope.inputPlaceholder = $translate.instant('ADD_GUEST_SEARCH_PHOLDER');

			scope.$watch('participants', function(newVal, oldVal){
				scope.ngModel = scope.participants;
			})

			scope.getParticipants = function (string) {
				return 	participantsService.get('parent/v1/group/search/' + attrs.schoolId +
					'/' + encodeURIComponent(string) + '/' + attrs.showTiers, { }).then(function (response) {
					return response.data.items
				}, function (error) {
				})
			}

			scope.toggleGroup = function(className){
				var el = document.getElementsByClassName(className);
				_.forEach(el, function(item){
					var elm = angular.element(item);
					if(elm.hasClass('visible')){
						elm.removeClass('visible');
						return
					} else { elm.addClass('visible'); }
				})
			}

			function getMembersByGroupId(autocompleteResult) {
				participantsService.get('group/v1/parent/private/group/members/'+autocompleteResult.id,{'cache':true}).then(function (response) {
				
					if (_.isUndefined(response.data.resultList)){
						toastr.info($translate.instant('GROUPS_NO_MEMBERS'));
						return;
					}
	
					_.forEach(response.data.resultList, function(iteratorItem){
						scope.participants.push({
							id:iteratorItem.id,
							type: autocompleteResult.type,
							groupId: autocompleteResult.id,
							groupName: autocompleteResult.field1,
							groupSize: response.data.resultList.length,
							firstName: iteratorItem.firstName,
							lastName: iteratorItem.lastName,
							avatar: iteratorItem.avatar,
							pupils: iteratorItem.pupils
						})
					})
					
				}, function (error) {
					
				})
			}

			scope.filterGroupMembers = function(participants, groupId) {

				var members = []
				for (var i = 0; i < participants.length; i++) {
					if (participants[i].groupId === groupId) {
						members.push({
							id:participants[i].userId,
							type: participants[i].type,
							groupId: groupId,
							firstName: participants[i].firstName,
							lastName: participants[i].lastName,
							avatar: participants[i].avatar
						})
					}
				}
				scope.members = members;
			}

			scope.pickParticipant = function (autocompleteResult) {
				if (autocompleteResult.type === 'user') {
					scope.participants.push({
						id:autocompleteResult.id,
						type: autocompleteResult.type ,
						firstName: autocompleteResult.field1,
						lastName: autocompleteResult.field2,
						avatar:autocompleteResult.avatar,
						groupName: ''
					})
				} else {
					getMembersByGroupId(autocompleteResult);
				}
				scope.participant = null;
			}

			scope.removeParticipant = function (participant) {
				$rootScope.$broadcast('REMOVE_PARTICIPANT', participant);
				$timeout(function(){
					scope.participants = _.without(scope.participants, participant)
				},0)
			}

			scope.removeMember = function (participant) {
				$timeout(function(){
					scope.members = _.without(scope.members, participant)
				},0)
			}
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.grouptags',[]).factory('groupTagsService', ['base', function (base) {
		return _.create(base, { });
	}]).directive('grouptags', grouptags);
	/** @ngInject */
	function grouptags( $translate, $rootScope, groupTagsService, toastr, $timeout) {

		var directive = {
			restrict: 'EA',
			replace: false,
			scope:{
				ngModel: '='
			},
			templateUrl:'app/base/directives/grouptags.module.html',
			link: linkFunction
		};

		return directive;

		function linkFunction(scope, elem, attrs) {
			scope.tags = scope.ngModel || [];
			scope.inputPlaceholder = $translate.instant('ADD_TAGS_PLACEHOLDER');

			scope.$watch('tags', function(newVal, oldVal){
				scope.ngModel = scope.tags;
			})

			scope.getTags = function (string) {
				return groupTagsService.get('group/v1/parent/' + attrs.schoolId +
					'/tags/' + encodeURIComponent(string)).then(function (response) {
					return response.data.tags
				}, function (error) {
				})
			}

			scope.pickTag = function (tag) {
				if(scope.tags.indexOf(tag) < 0) {
					scope.tags.push(tag);
				}
				scope.tag = null;
			}

			scope.keyUp = function (event) {
				if(event.which === 13) {
					if(!!scope.tag && scope.tag !== '') {
						scope.tags.push(scope.tag);
					}
					scope.tag = null;
				}
			}

			scope.removeTags = function (i) {
				scope.tags.splice(i, 1);
			}
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.stream',[]).factory('streamService', ['base', function (base) {
		return _.create(base, { });
	}]).controller('streamController', streamController);

	/** @ngInject */
	function streamController(baseService, $scope, $rootScope, $location, metadata, $window, $uibModal, streamService, $timeout, toastr, $translate, storage, $state, settings) {
		$scope.postsLoaded = false;
		$scope.currentGroup = {};

		//dont init again
		//keep the old reference when we came back from post view
		if (_.isUndefined($rootScope.activityStreamTierId)){
			$rootScope.activityStreamTierId = -1;
		}

		if (!$rootScope.homeFilters){
			$rootScope.homeFilters = [{
				"title": "Newsfeed",
				"id": -1,
				"postEnabled": true
			}];
		}

		$scope.nopupilsshowed = false;
		$rootScope.isOnWizard = false;
		
		var moreloading = false;
		var cursor = 'none';
		var relationships = { };


		// TODO: keep here for now, need this to fix the ptaPercentage
		localStorage.removeItem('_draftMarketplace');
		
		$scope.viewState = { 
			isReady:true,
			isInitiated:false
		}

		_.each(metadata.data.metadata.relationships, function (obj, index) {
			relationships[obj.id] = obj.longName;
		});

		function isSameArray(newArray, oldArray){
			for(var i = 0; i < newArray.length; i++){
				var sameObject = false;

				for(var j = 0; j < oldArray.length; j++){
					if (oldArray[j].id === newArray[i].id && oldArray[j].title === newArray[i].title){
						sameObject = true;
						break;
					}
				}

				if (!sameObject){
					return false;
				}
			}
			return true;
		}

		$scope.$on('$destroy', function () {
			if (window.viewpostListener)
				window.viewpostListener();
		});

		$scope.onTiersChanged = function(item){
			if (item === -2){
				//announcements
				//move there
				window.location.href = '/parent/#/announcements/list';
				return;
			}
			if (item === -3){
				//groups
				//move there
				window.location.href = '/parent/#/home';
				return;
			}
			$rootScope.activityStreamTierId = item;
			$scope.preGetPosts();
		}
		
		$rootScope.nameRelation = function (_id) {
			return relationships[_id]
		};

		$scope.updatePostComments = function(post) {
			if($scope.posts) {
				for(var i = 0; i < $scope.posts.length; i++) {
					if($scope.posts[i].id === post.id) {
						$scope.posts[i].comments = post.comments;
						break;
					}
				}
			}
		}

		$scope.onBackArrowTap = function() {
			$rootScope.activityStreamTierId = -1;
			$window.location.href = "/parent/#/home";
		}

		// Check the home stream appcues here
		if(!localStorage.getItem('PARENT_PRODUCT_DISCOVERY_INTRODUCE')) {
			if($rootScope.active_school && $rootScope.active_school.id) {
				$rootScope.checkTodo('PARENT_PRODUCT_DISCOVERY_INTRODUCE').then(function(resp) {
					$scope.showAppcueIntroduce = resp.data.payload.show;
				});
			}
		}

		var appcueClicked = false;
		$scope.inlineAppcueStart = function(type) {
			switch(type) {
				case 'PARENT_PRODUCT_DISCOVERY_INTRODUCE':
					$rootScope.introduceDismissable = true;
					$scope.openMobilePostWriter();
					$rootScope.userTag('PARENT_PROMPT_INTRODUCE_YOURSELF', 'OK');
					break;
				
				case 'PARENT_PRODUCT_DISCOVERY_MEETUP':
					
					break;
			}
		}

		$scope.inlineAppcueDoLater = function(type) {
			switch(type) {
				case 'PARENT_PRODUCT_DISCOVERY_INTRODUCE':
					$scope.showAppcueIntroduce = false;
					$rootScope.userTag('PARENT_PROMPT_INTRODUCE_YOURSELF', 'LATER');
					break;
			}
		}

		$scope.inlineAppcueDontShowAgain = function(type) {
			if(appcueClicked)
				return;

			appcueClicked = true;
			$rootScope.dismissTodo(type).then(function(resp) { }, function(error) { });

			$rootScope.userTag('PARENT_PROMPT_INTRODUCE_YOURSELF', 'DONT_SHOW_AGAIN');

			switch(type) {
				case 'PARENT_PRODUCT_DISCOVERY_INTRODUCE':
					$scope.showAppcueIntroduce = false;
					localStorage.setItem('PARENT_PRODUCT_DISCOVERY_INTRODUCE', true);
					break;
			}
		}

		function getGroups() {
			streamService.get('group/v1/parent/'+$rootScope.active_school.id+'/list/activity', {'cache':false, 'xhr':true}).then(function(response) {

				var array = [{
					"title": "Newsfeed",
					"id": -1,
					"postEnabled": true
					}];

				array = array.concat(response.data.groups);
				
				array.push({
					"title": "Announcements",
					"id": "-2",
					"postEnabled": true
					});
				array.push({
					"title": "See all groups",
					"id": "-3",
					"postEnabled": true
					});
					
				//we need to make sure that activityStreamTierId exists in the new array
				if ($rootScope.activityStreamTierId > 0){
					var valueFound = false;
					for(var i = 0; i< array.length; i++){
						if (array[i].id === $rootScope.activityStreamTierId){
							valueFound = true;
							break;
						}
					}
					if (!valueFound){
						$rootScope.activityStreamTierId = -1;
					}
				}
				// set the new filters to the groups we have
				if (array.length !== $rootScope.homeFilters.length || !isSameArray(array, $rootScope.homeFilters)){
					$rootScope.homeFilters = array;
				}
				
				$scope.currentGroup = $scope.getGroupById($rootScope.activityStreamTierId);
			}, 
			function(error) {})
		}

		$scope.onGroupNameTap = function(group){
			$scope.onTiersChanged(group);
			getGroups();
		}
		//To go to group info. 
		$scope.onGroupTap = function(group){
			var groupObject = {
				id: group.id
			}
			$rootScope.goToGroup(groupObject, true, null);
		}
		
		$scope.openGroup = function(group) {
			window.location.href = '#/groups/view/' + group.id;
		}

		$scope.getGroupById = function(id) {
			for(var i = 0; i < $rootScope.homeFilters.length; i++) {
				if($rootScope.homeFilters[i].id === id) {
					return $rootScope.homeFilters[i];
				}
			}

			return {
				id: -1,
				title: 'Newsfeed',
				type: 'ALL_ACTIVITY',
				avatar: $rootScope.active_school.logo
			};
		}

		baseService.app_initialized = function(evt,args) {
			$scope.viewState.isInitiated = true;

			getGroups();

			window.viewpostListener = $rootScope.$on('ON_POST_VIEW_OPEN', function(evt, args) {
				$rootScope.tempPosts = {
					scroll: document.documentElement.scrollTop || document.body.scrollTop,
					posts: $scope.posts,
					cursor: cursor
				};
			})

			if($rootScope.backFromPost && $rootScope.tempPosts && $rootScope.tempPosts.posts) {
				$rootScope.backFromPost = false;
				$scope.posts = $rootScope.tempPosts.posts;
				cursor = $rootScope.tempPosts.cursor;
				setTimeout(function() {
					window.scrollBy(0, $rootScope.tempPosts.scroll);
				}, 1);
			}
			else {
				$rootScope.tempPosts = null;
				$scope.posts = [];
			}
			
			$scope.goto = function(link) {
				location.href = link;
			}
		
			$scope.openMobilePostWriter = function(groups) {
				$rootScope.postingFrom = 'home';
				location.href = "#/composer/post";

				if($rootScope.isNative) {
					$rootScope.userTag('POST_INIT_FROM_HOME_PAGE_NATIVE');
				}
				else if($rootScope.isThisMobile()) {
					$rootScope.userTag('POST_INIT_FROM_HOME_PAGE_WEB_MOBILE');
				}
				else {
					$rootScope.userTag('POST_INIT_FROM_HOME_PAGE_WEB_DESKTOP');
				}
			};

			function openMobilePostWriterWrap() {
				$rootScope.postingFrom = 'home';
				location.href = "#/composer/post";

				$rootScope.userTag('POST_INIT_FROM_PLUS_NATIVE');
			}

			openMobilePostWriter = openMobilePostWriterWrap;

			$scope.events = {
				postCallback : function (post) {
					// var payload = {
					// 	'postedBy': $rootScope.active_user.firstName+' '+$rootScope.active_user.lastName,
					// 	'userId': $rootScope.active_user.id,
					// 	'avatar': $rootScope.active_user.avatar,
					// 	'postedOn': new Date(),
					// 	'body': post.body,
					// 	'photo': post.photo,
					// 	'isOwn': true,
					// 	'isLiked': false,
					// 	'likeCount': post.likeCount,
					// 	'commentCount': post.commentCount,
					// 	'groupId': post.groupId,
					// 	'groupName': post.groupName,
					// 	'id': post.id,
					// 	'type': post.type
					// };
					
					$scope.posts.unshift(post);
				},
				removeFromPosts: function(id){
					$scope.posts = $scope.posts.filter(function(el) {
						return el.id !==  id;
					});
				}
			}

			$scope.getPosts = function(force) {
				$scope.getingPosts = true;
				$scope.showSpinner = true;

				var url = 'post/v1/activity/'+$rootScope.active_school.id+'/list/' + (!force ? cursor : 'none');
				
				if ($rootScope.activityStreamTierId > 0){
					url = 'group/v1/get/'+$rootScope.active_school.id+'/'+$rootScope.activityStreamTierId+'/posts/'+ (!force ? cursor : 'none');
				}
				
				streamService.get(url, { 'xhr': true, 'cache': false }).then(function(response) {
					$scope.postsLoaded = true;

					$scope.userName = $rootScope.active_user.firstName+' '+$rootScope.active_user.lastName;
					var data = response.data.payload || [];
					angular.forEach(data.posts, function(k,v) {
						$scope.posts.push(k);
					});

					if($scope.posts && $scope.posts.length > 0) {
						$rootScope.firstPostIdInTheStream = $scope.posts[0].id;
					}

					if(data.adPost) {
						data.adPost.isAdv = true;
						data.adPost.link = data.adPost.link;
						$scope.posts.push(data.adPost);
					}

					moreloading = false;
					
					cursor = data.cursor || 0;
					$scope.viewState.isInitiated = true;
					$scope.loadingMorePosts = false;

					$scope.getingPosts = false;
					$scope.showSpinner = false;

					setTimeout(function() {
						angular.forEach(data.posts, function(post) {
							$rootScope.truncateClasslistLinks(post)
						});
					}, 100);
					
				}, 
				function(error) {
					$scope.getingPosts = false;
					$scope.viewState.isInitiated = true;
					$scope.loadingMorePosts = false;
					$scope.showSpinner = false;
				});
			}

			$scope.preGetPosts = function() {
				$scope.postsLoaded = false;
				$rootScope.toggleHRL(false)
				$scope.posts = [];
				$scope.getPosts(true)
				$window.scrollTo(0, 0);
			}

			$scope.hasMorePosts = function() {
				return cursor && cursor !== 0; 
			}

			var scrollerElement;

			//entry point
			if(!$rootScope.tempPosts || !$rootScope.tempPosts.posts)
				$scope.getPosts();
		
			setTimeout(function() {
				scrollerElement = angular.element(document.querySelector('.right-scroller'));
			}, 100);

			var doc = document.documentElement;
			$window.onscroll = function() {
				if($scope.getingPosts)
					return;
				
				if($location.path() === '/stream') {
					$scope.loadingMorePosts = true;

					if(!$scope.hasMorePosts())
						return;

					var scrollPercent = (window.pageYOffset / (doc.scrollHeight - window.innerHeight)) * 100;
					if(scrollPercent >= 70) {
						if(moreloading)
							return;

						moreloading = true;

						$scope.getPosts();
					}

					isElementInViewport(function(id, index) {
						if(!$scope.posts[index])
							return;
	
						if(!$scope.posts[index].isAdv)
							return;
	
						streamService.get('shared/v1/hit/nextAdvert/' + $rootScope.active_school.id + '/' + $scope.posts[index].id + '/web_parent_post_feed', { 'xhr': true, 'cache': false }).then(function(response) {
							
						}, 
						function(error) {
							
						});
					})
				}
			}
		}
		
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.post.likes',[]).factory('pmService', ['base', function (base) {
		return _.create(base, { });
	}]).directive('postLikes', postLikes);

	/** @ngInject */
	function postLikes($uibModal, $rootScope, toastr, regexes, pmService) {
		var directive = {
			restrict: 'A',
			replace: true,
			link: linkFunction
		};
		return directive;

		function linkFunction(scope, elem, attrs) {

			scope.$on('POST_LIKES', function(event,	object) {
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/home/views/post-likes-modal.html',
					controller: function($scope) {
						$scope.object = object;
						
						setTimeout(function() {
							angular.element(document.querySelector('.likes-modal'))
							.parent().parent().addClass('modal-likes-size');
						}, 1);

						$scope.openLiker = function(liker) {
							modalInstance.close();

							if($rootScope.active_user.id === liker.userId)
								location.href = '#/profile';
							else
								location.href = '#/classlist/details/' + liker.userId + '/contact';
						}

						$scope.close = function() { 
							modalInstance.close();
						};
					}
				});

			});
		}
	}

})();

(function() {
	'use strict';

	angular.module('modules.search',[]).factory('searchService', ['base', function (base) {
		return _.create(base, { });
	}]).controller('searchController', searchController);

/** @ngInject */
function searchController(baseService, $scope, $rootScope, $window, searchService, $filter, $uibModal, toastr, $timeout, settings, $translate) {
	baseService.app_initialized = function(evt, args) {

		$scope.viewState = {
			isReady:false
		}
		var timer;

		$scope.posts = [];
		$scope.typingValue = "";

		$scope.openItem = function (item) {
			var redirectPath = "#/post/" + item.referenceId;

			switch(item.type) {
				case "post":
				case "announcement":
				case "group":
				case "listing":
					break;
				case "event":
					redirectPath = "#/events/view/" + item.referenceId;
					break;
				case "TIER_GROUP":
				case "COMM_GROUP":
				case "SCHOOL_GROUP":
				case "ADMIN_GROUP":
				case "PARENT_PRIVATE":
				case "PARENT_PUBLIC":
				case "MARKETPLACE":
					redirectPath = "#/groups/view/" + item.referenceId;
					break;
				default:
					//don't do anything about it
					return;
			}

			window.location.href = redirectPath;
		}

		$scope.searchForPosts = function(queryString){
	
			if (!queryString || queryString === ''){
				$scope.posts = [];
				$scope.typingValue = '';
				return;
			}

			if (queryString.length < 3){
				$scope.posts = [];
				return;
			}

			queryString = queryString.trim();
			
			if ($scope.typingValue === queryString){
				return;
			}

			$scope.typingValue = queryString;

			if(timer){
				$timeout.cancel(timer);
			}  
			timer= $timeout(function(){
				searchService.get('search/v1/global/'+ $rootScope.active_school.id + '/' + queryString, {'cache':false, 'xhr':true}).then(function(response) {
					if ($scope.typingValue === ''){
						$scope.posts = [];
						return;
					}
					$scope.posts = response.data.items;
				}, 
				function(error) {
				})
			},timer ? 500 : 0);
		};

		$scope.highlight = function(text) {
			//remove the links
			text = text.replace("target _blank ]", "");
			text = text.replace("target  _blank  ]", "");
			text = text.replace("[URL href","");
			text = text.replace("[/URL]","");
			
			//remove duplicate links
			var textWords = text.match(/\S+/g) || [];

			var tempWords = '';
			for (var i=0; i< textWords.length; i++) {

				if (textWords[i].indexOf("://") > -1 || textWords[i].indexOf("www.") > -1) {
					if (i + 1 < textWords.length && textWords[i] === textWords[i + 1]){
						continue;
					}
				}
				tempWords = tempWords + textWords[i]+" ";
			}

			text = tempWords;

			if ($scope.typingValue !== '') { 
				var words = $scope.typingValue.match(/\S+/g) || [];
				for (var i=0; i< words.length; i++) {
					var word = words[i];
					if (!word || word.length < 3) {
						return text;
					}
					
					word = word.trim();
					text = text.replace(new RegExp('('+word+')', 'gi'), '<span class="highlighted">$1</span>');
				}
			}
			return text;
		}

		if(!!$rootScope.searchTerm && $rootScope.searchTerm !== '') {
			$scope.keyword = $rootScope.searchTerm;
			$scope.searchForPosts($scope.keyword);
			$rootScope.searchTerm = null;
		}
	}

	if($rootScope.active_school && $rootScope.app_base_ready) { 
		baseService.app_initialized();

		var barElement = $window.document.getElementById('search-bar');
		if (barElement){
			barElement.focus();
		}

	}
}

})();


(function() {
	'use strict';

	angular.module('modules.schoolrequest',[])
	.factory('schoolrequestService', ['base','$http', function (base, $http) {
		return _.create(base, { });
	}])
	.factory('sharedService', ['base', function (base) {
		return _.create(base, { })
	}])
	.controller('schoolrequestController', schoolrequestController);

	/** @ngInject */
	function schoolrequestController(baseService, $scope, $rootScope, $location, $cacheFactory, metadata, $uibModal, schoolrequestService, toastr, $translate, $state, $http, regexes, settings) {
		
		baseService.app_initialized = function(evt, args) {
		
			$scope.activeSlide = 0;
			$scope.onTooltip = 0;

			$scope.pupils = new Array();
			var genders = { };
			$scope.id_school = $rootScope.active_school.id;
			$scope.noSchool = false;
			$scope.regexes = regexes;
			
			$scope.schoolId = '';
			$scope.schoolName = '';
			$scope.avatar = '';
			
			$scope.viewState = {
				isReady:true,
				isGettingSchools:false,
				isEmptyResults:false
			};
			$rootScope.isOnWizard = true;

			setLink();

			if($rootScope.getQueryParam('n') && $rootScope.getQueryParam('i')) {
				$scope.search = $rootScope.getQueryParam('n')
				$scope.schoolId = $rootScope.getQueryParam('i');
				$rootScope.requestingSchoolId = $rootScope.getQueryParam('i');
			}

			$scope.gotoSlide = function(index) {
				$scope.activeSlide = index;
			}

			$scope.$on("$destroy", function() {
				$rootScope.isOnWizard = false;
			});

			_.each(metadata.data.metadata.genders, function (obj, index) {
				genders[obj.id] = obj.longName;
			});

			$scope.addPupils = function() {
				if ($scope.pupils.length >= regexes.max.pupilNumber) {
					toastr.error($translate.instant('MAX_PUPILS_REACHED'))
				}else{
					$rootScope.$broadcast('ADD_PUPIL', function(pup) {
						$scope.pupils.push(pup);
					});
				}
			}

			$scope.removePupil = function (pup) {
				$scope.pupils = _.without($scope.pupils, pup);

				if($scope.pupils.length === 0)
					$scope.pupils = new Array();
			};

			function setCursor() {
				try {
					var input = document.getElementById('typeaheader');
					input.selectionStart = 0;
				}
				catch(e){
					//Skip for now.
				}
			}

			$scope.goToNewSchool = function(){
				baseService.get('parent/v1/get/context/v2/schools', {'cache': false}).then(function (resp) {
					
					if (!resp.data.items) {
						window.location.href = "#/home"
						return;
					}

					for (var i=0; i < resp.data.items.length; i++){
						if (resp.data.items[i].id !== $scope.schoolId){
							continue;
						}
						$rootScope.switchSchoolById($scope.schoolId);
						break;
					}
				});
				
			}

			$scope.pickSchool = function(school) {
				if(school.id === -1) {
					/* when new journey created on onboarding we will use something like this
					var url = settings.conf.onboardingAppURL + '/#/start?schoolName=' + school.name;
					url += '&email=' + $rootScope.active_user.email;
					url += '&firstName=' + $rootScope.active_user.firstName;
					url += '&lastName=' + $rootScope.active_user.lastName;
					*/
					var url = settings.conf.onboardingAppURL;
					if(isThisMobile()) {
						window.location.href = url;
					} else {
						window.open(url, "_blank");
					}
				} else {
					setCursor();
					$scope.schoolName = school.name;
					$scope.avatar = school.avatar;
					$scope.schoolId = school.id;
					$rootScope.requestingSchoolId = school.id;
					$scope.integrated = school.in
				}
			};

			$scope.confirmSchool = function() {
				$state.go('register.basicdetails', {
					'schoolId':$scope.schoolId,
					'schoolName': $scope.schoolName,
					'avatar':$scope.avatar
				})
			}

			$scope.searchNewSchool = function(school) {
				return schoolrequestService.post('parent/v1/searchForSchools', { 'searchString': school }, { } ).then(function(response) {
					var _list = new Array();

					if(response.data.schools) {
						_list = response.data.schools;
					}

					_list.push({
						id: -1,
						url: settings.conf.onboardingAppURL,
						name: school
					})

					return _list;

				}, function(error) {
					
				});
			};

			$scope.apply = function() {
				var object = {
					school: $scope.schoolId,
					pupils: $scope.pupils
				}

				var newObject = JSON.parse(JSON.stringify(object));
				
				for(var i = 0; i < newObject.pupils.length; i++) {
					newObject.pupils[i].tierId = newObject.pupils[i].tier.id;
					delete newObject.pupils[i]['tier'];
				}
				
				$scope.viewState.isReady = false;

				schoolrequestService.post('parent/v1/apply/school', newObject, { 'xhr':true, 'cache':false }).then(function(response) {
							
					$scope.gotoSlide(2);

					$scope.viewState.isAutoApproved = response.data && response.data.payload && response.data.payload.i;

					$scope.rootContext(true);

					setTimeout(function() {
						$scope.viewState.isReady = true;
						$scope.$apply();
					}, 100)

					setTimeout(function() {
						$rootScope.refreshMySchools()
					}, 1000);
				}, 
				function(error) {
					$scope.viewState.isReady = true;

					if(error.data.error.code === 400) {
						toastr.error($translate.instant(error.data.error.message));
					}
				});
			}

			function setLink(){
				var OS = getMobileOperatingSystem();
				if (OS.includes('Android')) {
					$scope.link = 'https://play.google.com/store/apps/details?id=com.classlist.parent&hl=en_GB';
				}else{
					$scope.link = 'https://itunes.apple.com/gb/app/classlist/id1058636226?mt=8';					
				}
			}
		}
		
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}

})();

(function() {
	'use strict';

	angular.module('modules.schoolpage.details',[])
	.factory('schoolPageService', ['base','$http', function (base, $http) {
		return _.create(base, { });
	}])
	.controller('schoolPageController', schoolPageController);

	/** @ngInject */
	function schoolPageController(baseService, $scope, $rootScope, $location, $stateParams, $uibModal, schoolPageService, toastr, $translate, $state, $http) {
		
		baseService.app_initialized = function(evt, args) {
			$rootScope.isOnWizard = false;
		
			$scope.viewState = {
				isReady: false
			};

			$scope.getSchool = function() {
				$scope.viewState.isReady = false;

				schoolPageService.get('parent/v1/get/' + $rootScope.active_school.id + '/details', { 'xhr': true, cache: false }).then(function (response) {
					$scope.viewState.isReady = true;
					$scope.school = DTOS.Map(response.data.payload || { }, 'school');
					$scope.school.cover = $scope.school.cover + '?v=' + new Date().getTime();
					// $scope.school.logo = $scope.school.logo + '?v=' + new Date().getTime(); 
				},
				function(error){
					console.log(error);
				})
			}

			$scope.getReps = function(type) {
				schoolPageService.get('parent/v1/get/' + $rootScope.active_school.id + '/reps/classes', { 'xhr':true, cache: false }).then(function (response) {
					$scope.reps_list = response.data.items;
				},
				function(error){
					console.log(error);
				})
			}

			$scope.openYearReps = function() {
				location.href = '#/school/years';
			}
			
			$scope.openClassReps = function() {
				location.href = '#/school/classes';
			}
			
			$scope.openUser = function(object) {
				if(object.id !== -1)
					location.href = '#/classlist/details/'+object.id+'/contact';
			}

			$scope.sendMessage = function(object, classname) {
				var ambassadors = [];
				var ambassadorObjects = [];
				if(object.length > 5 ){
					ambassadors = object.slice(0,5);
				}
				else ambassadors = object;
				
				for (var i = 0; i < ambassadors.length; i++) {
					var ambassadorObject = {
						'firstName': ambassadors[i].name || '',
						'id': ambassadors[i].id,
						'avatar': ambassadors[i].avatar,
						'subject': $translate.instant('ADMIN_VOLUNTEER_SUBJECT', { name: classname})
					}

					ambassadorObjects.push(ambassadorObject);
				}

				$scope.$emit('COMPOSE_TO', ambassadorObjects)
			}

			$scope.openInfo = function (e, type) {
				if (e) {
					e.stopImmediatePropagation();
					e.stopPropagation();
				}

				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/schoolpage/views/info-modal-' + type + '.html',
					controller: function ($scope) {

						$scope.close = function () {
							modalInstance.close();
						};
					},
					size: 'm'
				});
			}

			$scope.isExternalLink = function (link) {
				return (link.indexOf('classlist.com/parent') === -1) && (link.indexOf('classlist.com/school') === -1) && (link.indexOf('localhost') === -1);
			}

			$scope.createLink = function (link) {
				var newLink = (link.indexOf('https://') == -1 && link.indexOf('http://') == -1) ? 'http://'+link : link;
				if(!$scope.isExternalLink(link)) {
					newLink = newLink + '?s=' + $rootScope.active_school.id;
				}
				return newLink;
			}

			$scope.getSchool();
			$scope.getReps();
		}
		
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}

})();

(function() {
	'use strict';

	angular.module('modules.schoolpage',[])
	.factory('schoolPageService', ['base','$http', function (base, $http) {
		return _.create(base, { });
	}])
	.controller('schoolPageController', schoolPageController);

	/** @ngInject */
	function schoolPageController($scope, $location, $uibModal, schoolPageService, toastr, $translate, $state, $http) {
		
	}

})();

(function() {
	'use strict';

	angular.module('modules.runmap',[]).factory('runmapService', ['base', function (base) {
		return _.create(base, { });
	}]).controller('runmapController',runmapController);

	/** @ngInject */
	function runmapController(baseService, $scope, metadata, runmapService, $uibModal, $state, storage, profileService, regexes, $rootScope, toastr, $translate) {

		$scope.gPlace;
		$scope.mapConfig = {};
		$scope.parentDetails = {};
		$scope.regexes = regexes;
		$scope.myUser = {};
		$scope.selectedSearch = false;
		$scope.viewState = {
			isReady:false,
			isParentVisible:false
		};
		
		$scope.filter = { class: -1 }
		
		baseService.app_initialized = function(evt, args) {
			$scope.myname = $rootScope.active_user.firstName + ' '+$rootScope.active_user.lastName;

			if(storage.get('sClassFilter', true, true))
				$scope.filter.class = storage.get('sClassFilter', true, true);
			
			if(storage.get('sParentFilter', true, true) && storage.get('sParentFilter', true, true).name) {
				$scope.filter.search = storage.get('sParentFilter', true, true).name;
				setTimeout(function() {
					$scope.selectedSearch = false;
				}, 1000);
			}

			$scope.isOptInClicked = false;
			var showOptInError = false;

			var relationships = {};

			_.each(metadata.data.metadata.relationships, function (obj, index) {
				relationships[obj.id] = obj.longName;
			});

			$scope.$watch('filter.search', function (newValue, oldValue) {
				$scope.selectedSearch = false;

				setTimeout(function() {
					$scope.selectedSearch = newValue && newValue.length > 1;
					$scope.filterByClass(true);

					$scope.$apply();
				}, 500);
			});

			$scope.search = function(item) {
				var f = $scope.filter.class !== -1 ? $scope.filter.class : '';

				if ((item.name.toLowerCase().indexOf($scope.filter.search ? $scope.filter.search.toLowerCase() : '') !== -1)) {
					if(f) {
						var found = false;
						for(var i = 0; i < item.pupils.length; i++) {
							if(item.pupils[i].tiers.indexOf(f) > -1){
								return true;
							}
						}
					}
					else {
						return true;
					}

				}
				else {
					//if not check its pupils
					var found = false;
					for(var i = 0; i < item.pupils.length; i++) {
						//if there is a filter check by filter and name
						if(f) {
							if(item.pupils[i].tiers.indexOf(f) > -1 && (item.pupils[i].name.toLowerCase().indexOf($scope.filter.search ? $scope.filter.search.toLowerCase() : '') !== -1)) {
								return true;
							}
						}
						else {
							//if not just by name
							if (item.pupils[i].name.toLowerCase().indexOf($scope.filter.search) !== -1) {
								return true;
							}
						}
					}
				}
				return false;
			}
			
			$scope.setFindUser = function(u) {
				$scope.selectedSearch = false;
				var input = angular.element(document.querySelector('[type="search"]'))[0];
				input.value = u.name;

				if($scope.mapConfig.onSearchSelected)
					$scope.mapConfig.onSearchSelected(u)
			}

			$scope.filterByClass = function(fromAutocomplete) {
				if($scope.mapConfig.onClassFilter){
					$scope.mapConfig.onClassFilter($scope.filter.class !== -1 ? $scope.filter.class : '')
				}
				if (!fromAutocomplete){
					$scope.filter.search = '';
				}		
			}

			$scope.toggleParentOverlay = function(){
				$scope.viewState.isParentVisible = !$scope.viewState.isParentVisible
			}

			function checkRunMap(address, city, postCode, checkbox ) {
				var streetAddressLength, cityLength, postCodeLength;
				_.isUndefined(address) ? streetAddressLength = 0 : streetAddressLength = address.length;
				_.isUndefined(city) ? cityLength = 0 : cityLength =  city.length;
				_.isUndefined(postCode) ? postCodeLength = 0 : postCodeLength = postCode.length;

				if ( streetAddressLength > 0 && cityLength > 0 && postCodeLength > 0 
					&& checkbox === true ) {
					
					return showOptInError = false;
				} 
				else {
					return showOptInError = true;
				}
			}

			$scope.update = function () {
				$scope.isOptInClicked = true;

				checkRunMap($scope.myUser.address.streetAddress, $scope.myUser.address.city, 
					$scope.myUser.address.postCode, $scope.myUser.runSchoolShare)

				if (!showOptInError) {
					$scope.viewState.updating = true;

					profileService.put('parent/v1/update/parentMap', { 'personalInfo': $scope.myUser }, { }).then(function(response) {
						$scope.viewState.updating = false;
						$rootScope.isEnabled = true;

						if (response && response.data.locationFound === false){
							toastr.info($translate.instant('ADDRESS_NOT_GEODECODED'));
						}else{
							toastr.success($translate.instant('UPDATE_SUCCESSFUL'));
						}

						$rootScope.$broadcast('UPDATE_PROFILE', $scope.myUser);
						getMapConfig();
					}, 
					function (error) {
						$scope.viewState.updating = false;
						(error.status !== -1 ) ? toastr.error(error.data.error.message || $translate.instant('UPDATE_FAIL')) : _.noop();
						$scope.viewState.isReady = true;
						$rootScope.isEnabled = false;
					});
				}
			}
			
			function getMapConfig() {
				$scope.viewState.isReady = false;

				runmapService.get('parent/v1/'+$rootScope.active_school.id+'/get/runMap',{'cache':false}).then(function(response){
					$scope.mapConfig = response.data;
					response.data.enabled ? $rootScope.isEnabled = true : $rootScope.isEnabled = false;

					if (!$rootScope.isEnabled){
						fillInfo();
					}else{
						$scope.viewState.isReady = true;
					}

					if ($scope.mapConfig.filters){
						$scope.mapConfig.filters.unshift({id: -1, name: 'Whole school'})
					}

				}, 
				function(error) {
					$scope.viewState.isReady = true;
				})
			}

			function fillInfo(){
				runmapService.get('parent/v1/get/personalInfo', { 'cache': false }).then(function (response) {
					$scope.myUser = response.data.personalInfo;
					$scope.viewState.isReady = true;
				}, 
				function (error) {
					$scope.viewState.isReady = true;
				})
			}
			
			angular.element(document).ready(function(){
				getMapConfig();
			});
		}
	
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.recommendations.view',[]).controller('recommendationsViewController', recommendationsViewController);
	/** @ngInject */

	function recommendationsViewController(baseService, $scope, metadata, $state, $stateParams, recommendationsService, $rootScope, $uibModal, toastr, $translate, $window, settings, storage) {
		$scope.type = $stateParams.type;
		$scope.adlist = [ ];
		var token = storage.getToken();
		
		$scope.dashboardLink = settings.conf.advertiserAppURL;

		$scope.viewState = {
			isReady: false,
			isAdvertiser:0
		};

		if($scope.type) {
			$scope.categoryType = $scope.type;
		}

		$scope.blurSearch = function(e) {
			if(e.which === 13) {
                document.getElementsByClassName('recomm-search-input')[0].blur();
            }
		}

		baseService.app_initialized = function(evt, args) {

			if(!$scope.categoryType)
				$scope.getRecommendations("ALL");
			else
				$scope.getRecommendations($scope.categoryType);

			baseService.get('parent/v1/is/advertiser', { 'cache': false }).then(function (resp) {
				if (resp && resp.data && resp.data.payload){
					$scope.viewState.isAdvertiser = resp.data.payload.advertiser ? 1 : 2;
				}
			})
		}

		$scope.getTagsString = function(tags) {
			if (!tags){
				return ' ';
			}
			return tags.join();
		}

		$scope.getRecommendations = function(category, success) {
			recommendationsService.get('parent/v1/' + $rootScope.active_school.id + '/parentdirectory/' + category + '/list').then(function(response) {
				$scope.viewState.isReady = true;
				if (response.data.items){
					for (var i = 0; i < response.data.items.length; i++){
						response.data.items[i].link = response.data.items[i].link
					}
					$scope.adlist = response.data.items;
				}
				if(success)
					success();
			}, 
			function(error) {
				$scope.viewState.isReady = true;
			})
		}
		
		$scope.likeAd = function(ad) {
			ad.liked = !ad.liked;

			if(ad.liked)
				ad.like += 1;
			else
				ad.like -= 1;

			recommendationsService.get('parent/v1/like/' + ad.id + '/'+$rootScope.active_school.id + '/directory')
			.then(function(response) {
				
				if(success)
					success();
			}, 
			function(error) {
				
			})
		}

		$scope.suggest = function() {
			location.href = '#/recommendations/suggest';
		};

		$scope.openCategory = function(category) {
			location.href = '#/recommendations/view/' + (category ? category : $scope.categoryType);
		}
		
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}

})();

(function() {
	'use strict';

	angular.module('modules.recommendations',[]).factory('recommendationsService', ['base', function (base) {
		return _.create(base, { });
	}]).controller('recommendationsController', recommendationsController);

	/** @ngInject */
	function recommendationsController(baseService, $scope, $rootScope, metadata, recommendationsService, $translate, $timeout, $location, $state, $window, settings, toastr) {
		
		$scope.viewState = {
			isReady: true,
			isInitiated: false
		}

		$scope.business = {
			name:"",
			website:"",
			address:"",
			phone:""
		};

		$scope.isLoading = false;

		$scope.send = function() {
			$scope.isLoading = true;
			
			recommendationsService.post('parent/v1/create/advertiser/'+$rootScope.active_school.id+'/suggest',$scope.business,{'xhr':true}).then(function(response) {
				$scope.isLoading = false;
				toastr.info($translate.instant('SUGGEST_THANK_YOU'));
				$window.history.back();
			}, 
			function(error){
				$scope.isLoading = false;
			});
		}

		baseService.app_initialized = function(evt, args) {
			var	schoolId = $rootScope.active_school.id;
		}

		$scope.back = function() {
			$window.history.back();
		}
		
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();


		}
	}
})();

(function() {
    "use strict";

    angular
        .module("modules.raffle.view", [])
        .controller("raffleViewController", raffleViewController);

    /** @ngInject */


    function raffleViewController(baseService, $rootScope, $scope, raffleService, $state, $stateParams, $translate, toastr) {
        $scope.raffle_id = $stateParams.raffle_id;
        $scope.tickets = {};
        $scope.title = '';
        $scope.ticketsAvailable = false;
        $scope.purchaseTicketAvailable = true;



        baseService.app_initialized = function(evt, args) {
            if ($scope.raffle_id) {
                $scope.getTickets();
            } else {
                $state.go('home');
            }
        };

        $scope.getTickets = function() {
            raffleService.get('raffle/v1/get/tickets/' + $rootScope.active_school.id + '/' + $scope.raffle_id, { 'xhr': true, cache: false }).then(function(response) {
                    $scope.title = response.data.payload.title;
                    $scope.ticketsAvailable = response.data.payload.purchaseTicketAvailable;
                    $scope.tickets = response.data.payload.tickets || {};
                    $scope.getRaffle();
                },
                function(error) {
                    console.log(error);
                })
        }

        $scope.getRaffle = function() {
            raffleService.get('raffle/v1/get/' + $rootScope.active_school.id + '/' + $scope.raffle_id, { 'xhr': true, cache: false }).then(function(response) {
                    var raffle = response.data;
                    var now = new Date(raffle.now);
                    var drawDate = new Date(raffle.drawDate);
                    var difference = drawDate.getTime() - (1000 * 60 * 15);
                    $scope.ticketsAvailable = now.getTime() < difference;

                },
                function(error) {
                    console.log(error);
                })
        }

        if ($rootScope.active_school && $rootScope.app_base_ready) {
            baseService.app_initialized();
        }
    }
})();
(function() {
    "use strict";

    angular
        .module("modules.raffle.tickets", [])
        .controller("raffleTicketsController", raffleTicketsController);

    /** @ngInject */
    function raffleTicketsController(baseService, $rootScope, $scope, raffleService, $state, $stateParams, $translate, toastr, settings) {
        $scope.raffle_id = $stateParams.raffle_id;
        $scope.raffle = {};
        $scope.selectedTicket = {};
        $scope.tickets = {};
        $scope.title = '';
        $scope.ticketsAvailable = false;

        var stripe;
        var card;

        baseService.app_initialized = function(evt, args) {
            $scope.selectedOption = 0;
            if ($scope.raffle_id) {
                $scope.getRaffle();
            } else {
                $state.go('home');

            }
            if (!$rootScope.stripeLoaded) {
                $scope.loadStripe();
            }
        };

        // get tickets
        $scope.getTickets = function() {
            raffleService.get('raffle/v1/get/tickets/' + $rootScope.active_school.id + '/' + $scope.raffle_id, { 'xhr': true, cache: false }).then(function(response) {
                    $scope.title = response.data.payload.title;
                    $scope.ticketsAvailable = response.data.payload.purchaseTicketAvailable;
                    $scope.tickets = response.data.payload.tickets || {};
                    $scope.getRaffle();
                },
                function(error) {
                    console.log(error);
                })
        }

        $scope.getRaffle = function() {
            raffleService.get('raffle/v1/get/' + $rootScope.active_school.id + '/' + $scope.raffle_id, { 'xhr': true, cache: false }).then(function(response) {

                    $scope.raffle = response.data || {};
                    var raffle = response.data;
                    var now = new Date(raffle.now);
                    var drawDate = new Date(raffle.drawDate);
                    var difference = drawDate.getTime() - (1000 * 60 * 15);
                    $scope.ticketsAvailable = now.getTime() < difference;
                    $scope.raffle.description = $scope.raffle.description.replace(/\r?\n/g, '<br />');
                    $scope.raffle.description = $rootScope.parseTagsToLinks($scope.raffle.description);
                    $scope.customTicketCount = $scope.raffle.tickets[2].count +25;  // FMA-1793 max bundle + 25


                },
                function(error) {
                    console.log(error);
                })
        }

        $scope.selectTicket = function(ticket) {
            $scope.selectedTicket = ticket;

            $scope.initStripe($scope.raffle.stripeAccount);
            $scope.selectedOption = 0;
        }

        $scope.loadStripe = function() {
            var node = document.createElement('script');
            node.src = 'https://js.stripe.com/v3/';
            node.type = 'text/javascript';
            node.async = false;
            document.getElementsByTagName('head')[0].appendChild(node);
            $rootScope.stripeLoaded = true;
        }

        $scope.initStripe = function(accountId) {
            stripe = Stripe(settings.conf.stripeKey, {
                stripeAccount: accountId
            });
            var elements = stripe.elements();

            var style = {
                base: {
                    color: '#32325d',
                    lineHeight: '18px',
                    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                    fontSmoothing: 'antialiased',
                    fontSize: '16px',
                    '::placeholder': {
                        color: '#aab7c4'
                    }
                },
                invalid: {
                    color: '#fa755a',
                    iconColor: '#fa755a'
                }
            };

            // Create an instance of the card Element.
            card = elements.create('card', { style: style });

            // Add an instance of the card Element into the `card-element` <div>.
            card.mount('#card-element');

            // Handle real-time validation errors from the card Element.
            card.addEventListener('change', function(event) {
                var displayError = document.getElementById('card-errors');

                if (event.error) {
                    displayError.textContent = event.error.message;
                } else {
                    displayError.textContent = '';
                }
            });
        }
        $scope.onOptionChange = function () {
            if ($scope.selectedOption === -1) {
                if(!$scope.customTicketCount)
                    $scope.customTicketCount = $scope.raffle.tickets[2].count +25;  // FMA-1793 max bundle + 25
                $scope.selectedTicket = {id: -1, price: $scope.raffle.price * $scope.customTicketCount}; 
                $scope.initStripe($scope.raffle.stripeAccount);
            } else{
                this.selectedTicket = {}
            }
        };
        $scope.updateCustomTicket = function () {
            if ($scope.selectedOption !== -1){
                return;
            }

            // Parse the input and check if it is a valid number
            var parsedValue = parseInt($scope.customTicketCount, 10);

            if (isNaN(parsedValue) || parsedValue < $scope.raffle.tickets[0].count) {
                $scope.customTicketCount = $scope.raffle.tickets[0].count;
                toastr.info("Enter at least "+$scope.customTicketCount+" tickets or select a different option above.");
            }

            $scope.selectedTicket = {id: -1, price: $scope.raffle.price * $scope.customTicketCount}; 
            $scope.initStripe($scope.raffle.stripeAccount);
        };
        $scope.stripeSubmit = function() {
            $scope.buying = true;
            var payload = {
                raffleId: $scope.raffle_id,
                token: '',
                tickets: [
                    { ticketTypeId: $scope.selectedTicket.id, quantity: $scope.customTicketCount }
                ]
            };

            stripe.createPaymentMethod('card', card).then(function(result) {
                if (result.error) {
                    $scope.buying = false;
                    var errorElement = document.getElementById('card-errors');
                    if (errorElement)
                        errorElement.textContent = result.error.message;


                    $scope.buying = false;
                    setTimeout(function() {
                        $scope.$apply()
                    }, 3);
                } else {
                    if (result.paymentMethod.card.funding != 'debit' && $scope.raffle.onlyDebitPaymentAccepted == true) {
                        var errorElement = document.getElementById('card-errors');
                        errorElement.textContent = "Only debit cards can be used for raffles";
                        $scope.buying = false;
                        setTimeout(function() {
                            $scope.$apply()
                        }, 3);
                    } else {
                        payload.token = result.paymentMethod.id;
                        raffleService.post('payment/v1/raffle/payment/stripe', payload, {
                                'cache': false,
                                'xhr': true
                            })
                            .then(function(response) {

                                    setTimeout(function() {
                                        $scope.$apply()
                                    }, 4);

                                    if (response && response.data) {
                                        if (response.data.requiresAction) {
                                            handleAction(response.data)
                                            return;
                                        }
                                    }

                                    $scope.buying = false;
                                    $scope.paid = true;
                                    $scope.logId = response.data.logId;
                                },
                                function(error) {
                                    $scope.buying = false;
                                    $scope.error = true;

                                    if (error.data.error.message) {
                                        toastr.info(error.data.error.message);
                                    } else {
                                        toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
                                    }

                                    setTimeout(function() {
                                        $scope.$apply()
                                    }, 5);
                                });
                    }

                }
            });
        }

        function handleAction(response) {
            stripe.handleCardAction(response.clientSecret).then(function(result) {
                if (result.error) {
                    $scope.buying = false;
                    toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
                } else {
                    raffleService.post('payment/v1/raffle/paymentIntent/confirm', {
                            logId: response.logId
                        }, {
                            'Content-Type': 'application/json',
                            'cache': false,
                            'xhr': true
                        })
                        .then(function(resp) {
                                $scope.buying = false;
                                $scope.paid = true;
                                $scope.logId = response.logId;
                            },
                            function(error) {
                                $scope.buying = false;
                                $scope.error = true;

                                if (error.data.error.message) {
                                    toastr.info(error.data.error.message);
                                } else {
                                    toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
                                }
                            });
                }
            });
        }

        $scope.reset = function() {
            $scope.selectedTicket = {};
            $scope.paid = false;
            $scope.logId = null;
            $scope.error = false;
        }

        if ($rootScope.active_school && $rootScope.app_base_ready) {
            baseService.app_initialized();
        }
    }
})();
(function () {
	"use strict";

	angular
		.module("modules.raffle", [])
		.factory("raffleService", [
			"base",
			function (base) {
				return _.create(base, {});
			}
		])
		.controller("raffleController", raffleController);

	/** @ngInject */
	function raffleController(baseService) {
		baseService.app_initialized = function (evt, args) {};
	}
})();

(function () {
	"use strict";

	angular
		.module("modules.raffle.enter", [])
		.controller("raffleEnterController", raffleEnterController);

	/** @ngInject */
	function raffleEnterController(baseService, $rootScope, $scope, raffleService, $state, $stateParams, $translate, toastr) {
		$scope.raffle_id = $stateParams.raffle_id;
		$scope.raffle = {};
		$scope.selectedAnswer = {};

		baseService.app_initialized = function (evt, args) {
			if($scope.raffle_id) {
				$scope.getRaffle();
			} else {
				$state.go('home');
			}
		};

		$scope.getRaffle = function() {
			raffleService.get('raffle/v1/get/' + $rootScope.active_school.id + '/' + $scope.raffle_id, { 'xhr': true, cache: false }).then(function (response) {
				$scope.raffle = response.data || {};
			},
			function(error){
				console.log(error);
			})
		}

		$scope.checkAnswer = function(answer) {
			$scope.selectedAnswer = answer;
		}
		
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}
})();

(function() {
    "use strict";

    angular
        .module("modules.raffle.details", [])
        .controller("raffleDetailsController", raffleDetailsController);

    /** @ngInject */
    function raffleDetailsController(baseService, $rootScope, $scope, raffleService, $state, $stateParams, $translate, toastr) {
        $scope.raffle_id = $stateParams.raffle_id;
        $scope.prizeDisplayCount = 3;
        $scope.ticketsAvailable = false;
        $scope.raffle;
        $scope.prizes = [];
        baseService.app_initialized = function(evt, args) {
            if ($scope.raffle_id) {
                $scope.getRaffle();
            } else {
                $state.go('home');
            }
        };

        $scope.getRaffle = function() {
            raffleService.get('raffle/v1/get/' + $rootScope.active_school.id + '/' + $scope.raffle_id, { 'xhr': true, cache: false }).then(function(response) {
                    $scope.raffle = response.data || {};
                    $scope.setPrizeList(false);
                    if ($scope.raffle.status === 'ACTIVE') {
                        $scope.countdown($scope.raffle.drawDate, $scope.raffle.now);
                    }
                    $scope.raffle.description = $scope.raffle.description.replace(/\r?\n/g, '<br />');
                    $scope.raffle.description = $rootScope.parseTagsToLinks($scope.raffle.description);

                },
                function(error) {
                    console.log(error);
                })
        }

        $scope.setPrizeList = function(all) {
            if (all) {
                $scope.prizes = $scope.raffle.prizes;
            } else {
                $scope.prizes = $scope.raffle.prizes.slice(0, $scope.prizeDisplayCount);
            }

            for (var i = 0; i < $scope.prizes.lenght; i++) {
                if (!$scope.prizes[i].description) return;
                $scope.prizes[i].description = $scope.prizes[i].description.replace(/\r?\n/g, '<br />');
                $scope.prizes[i].description = $rootScope.parseTagsToLinks($scope.prizes[i].description);
            }
            $scope.prizes[i].description = $rootScope.removeLinks($scope.prizes[i].description);

        }

        $scope.countdown = function(date, current) {
            if (x) return;
            var second = 1000,
                minute = second * 60,
                hour = minute * 60,
                day = hour * 24;
            var countDown = new Date(date).getTime();
            var now = new Date(current).getTime();
            if (countDown - now > minute * 15) {
                $scope.ticketsAvailable = $scope.raffle.purchaseTicketAvailable && $scope.raffle.status === 'ACTIVE';
            }
            var x = setInterval(function() {
                var distance = countDown - now;
                var days = Math.floor(distance / day);
                var hours = Math.floor((distance % day) / hour);
                var minutes = Math.floor((distance % hour) / minute);
                var seconds = Math.floor((distance % minute) / second);

                document.getElementById("days").innerText = (days < 0) ? "00" : (days < 10 ? '0' : '') + days;
                document.getElementById("hours").innerText = (hours < 0) ? "00" : (hours < 10 ? '0' : '') + hours;
                document.getElementById("minutes").innerText = (minutes < 0) ? "00" : (minutes < 10 ? '0' : '') + minutes;
                document.getElementById("seconds").innerText = (seconds < 0) ? "00" : (seconds < 10 ? '0' : '') + seconds;
                now += second;

                // clear interval when date is reached
                if (distance < second) {
                    clearInterval(x);
                }
                // disable purchase when 15mins remains
                if (distance < minute * 15 && $scope.ticketsAvailable) {
                    $scope.ticketsAvailable = false;
                    $scope.$apply();
                }
                //seconds
            }, 1000);

            $scope.$on("$destroy", function() {
                if (x) {
                    clearInterval(x);
                }
            });
        }

        if ($rootScope.active_school && $rootScope.app_base_ready) {
            baseService.app_initialized();
        }
    }
})();
(function() {
	'use strict';

	angular.module('modules.pupilmanagement',[]).factory('pmService', ['base', function (base)	{
		return _.create(base, { });
	}])
	.controller('prfPupilController', prfPupilController)
	.directive('editPupil', editPupil).directive('addPupil', addPupil);

	function prfPupilController($scope, $uibModal, $rootScope, $stateParams, $window, toastr, regexes, pmService, baseService, $cacheFactory) {
		$scope.regexes = regexes;
		$scope.newPupil = { 
			firstName: '',
			lastName: ''
		};
		$scope.familyList = [];

		function cleanGroupsOnStream() {
			$rootScope.activityStreamTierId = -1;
			delete $rootScope.homeFilters;
		}

		function cleanHttpCache() {
			var $httpDefaultCache = $cacheFactory.get('$http');
			$httpDefaultCache.removeAll();
		}

		baseService.app_initialized = function(evt, args) {
			$scope.editingId = null;
			if($stateParams.id) {
				$scope.editingId = $stateParams.id;
				pmService.get('parent/v1/get/' + $stateParams.id + '/pupil', { 'xhr': true, 'cache': false })
				.then(function(response) {
					$scope.newPupil = response.data;
					$scope.newPupil.relationshipId = $scope.newPupil.relationshipId.toString();
					$scope.newPupil.monthId = $scope.newPupil.monthId.toString();
					if(!$scope.newPupil.genderId) $scope.newPupil.genderId = 0;
					$scope.newPupil.genderId = $scope.newPupil.genderId.toString();
					$scope.newPupil.tier = { id: $scope.newPupil.firstTierId, name: $scope.newPupil.firstTierName }
					$scope.familyList = response.data.familyMembers;
				}, 
				function(error){
					$scope.viewState.isReady = true;
				})
			}
			else {
				$scope.getFamilyCompact();
			}
		}

		$scope.getFamilyCompact = function() {
			pmService.get('parent/v1/list/' + $rootScope.active_school.id + '/familyMember/compact', { 'xhr': true, 'cache': false })
			.then(function(response) {
				if(response.data.items)
					$scope.familyList = response.data.items;
			}, 
			function(error){
				$scope.viewState.isReady = true;
			})
		}

		$scope.save = function() {
			var firstNameLength, lastNameLength;
			if ($scope.newPupil.firstName === null) {
				firstNameLength = 0;
			} else {
				firstNameLength = $scope.newPupil.firstName.length;
			}

			if ($scope.newPupil.lastName === null) {
				lastNameLength = 0;
			} else {
				lastNameLength = $scope.newPupil.lastName.length;
			}

			if (!($scope.newPupil.firstName === null || firstNameLength < regexes.min.name 
				|| $scope.newPupil.lastName === null || lastNameLength < regexes.min.pup_lastname)) { 

				if(!$scope.newPupil.tier)
					return;
				
				if(!$scope.newPupil.relationshipId)
					return;

				
				//in the directive, ng-change triggers only once. This is a quick fix for this issue.
				var c = document.getElementById('select-tier-directive');
				$scope.newPupil.tierId = c.options[c.selectedIndex].value;

				var selectedFamily = [];
				if($scope.familyList && $scope.familyList.length > 0) {
					for(var i = 0; i < $scope.familyList.length; i++) {
						$scope.familyList[i].invalid = false;

						if($scope.familyList[i].selected) {
							if($scope.familyList[i].relationshipId && $scope.familyList[i].relationshipId !== '0') {
								selectedFamily.push({
									familyMemberId: $scope.familyList[i].familyMemberId, 
									relationshipId: $scope.familyList[i].relationshipId,
									userId: $scope.familyList[i].userId
								})
							}
							else {
								$scope.familyList[i].invalid = true;
								return;
							}
						}
					}
				}

				$scope.newPupil.familyMembers = selectedFamily;
				
				$scope.saving = true;
				pmService.put('parent/v1/' + $rootScope.active_school.id + '/v2/create/pupil', $scope.newPupil, { }).then(function (response) {
					$scope.saving = false;
					$rootScope.refreshContext(); 
					$window.history.back();
					toastr.success('Successfully added the child')

				}, function (error) {
					$scope.saving = false;
					toastr.error($translate.instant(error.data.error.message))
				})
			}
			else {
				toastr.info('Please fill the mandatory fields')
			}
		};


		$scope.delete = function() {
			cleanGroupsOnStream();
			var _pupil = $scope.newPupil;

			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'app/profile/views/delete-pupil-modal.html',
				backdropClass: 'backdrop-zindexed',
				size:'sm',
				controller: function($scope) {
					$scope._pupil = _pupil;
					
					$scope.confirm = function() {
						$scope.deleting = true;
						cleanHttpCache();

						pmService.delete('parent/v1/delete/pupil/' + $stateParams.id, { 'cache':false }).then(function (response) {
							$scope.deleting = false;
							modalInstance.close();
							$rootScope.refreshContext();
							$window.history.back();
						},
						function (error) {
							
						})
					}

					$scope.close = function() {
						modalInstance.close();
					}
				}
			})
		}
	
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}	
	}

	function addPupil($uibModal,	toastr,	regexes, pmService)	{
		var directive = {
			restrict: 'A',
			replace: true,
			link: linkFunction
		};
		return directive;
		function linkFunction(scope,	elem,	attrs)	{
			scope.$on('ADD_PUPIL', function(event,	callback_fn){
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/pupil/views/add-pupil-modal.html',
					controller: function($scope){
						$scope.regexes = regexes;
						$scope.newPupil = {
							firstName:null,
							lastName:null,
							tier:null
						};

						$scope.save = function(){
							var firstNameLength, lastNameLength;
							if ($scope.newPupil.firstName === null) {
								firstNameLength = 0;
							} else {
								firstNameLength = $scope.newPupil.firstName.length;
							}

							if ($scope.newPupil.lastName === null) {
								lastNameLength = 0;
							} else {
								lastNameLength = $scope.newPupil.lastName.length;
							}

							if (!($scope.newPupil.firstName === null || firstNameLength < regexes.min.name 
								|| $scope.newPupil.lastName === null || lastNameLength < regexes.min.pup_lastname 
								|| $scope.newPupil.tier === null)) { 
								callback_fn($scope.newPupil);
								$scope.newPupil = {};
								modalInstance.close();
							}
						};
						$scope.close = function(){
							modalInstance.close();
						};
					},
					size: 'md'
				});

			});

		}

	}

	function editPupil($uibModal,	toastr,	regexes, pmService)	{
		var directive = {
			restrict: 'A',
			replace: true,
			link: linkFunction
		};
		return directive;
		function linkFunction(scope,	elem,	attrs)	{
			scope.$on('EDIT_PUPIL', function(event,	pupil, callback_fn){
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/pupil/views/edit-pupil-modal.html',
					controller: function($scope){
						$scope.regexes = regexes;
						$scope.newPupil = {
							firstName:pupil.firstName,
							lastName:pupil.lastName,
							genderId:pupil.genderId,
							monthId: pupil.monthId,
							id: pupil.id,
							tier: pupil.tier
						}

						$scope.save = function(){
							var firstNameLength, lastNameLength;
							if ($scope.newPupil.firstName === undefined) {
								firstNameLength = 0;
							} else {
								firstNameLength = $scope.newPupil.firstName.length;
							}

							if ($scope.newPupil.lastName === undefined) {
								lastNameLength = 0;
							} else {
								lastNameLength = $scope.newPupil.lastName.length;
							}

							if (!($scope.newPupil.firstName === undefined || firstNameLength < regexes.min.name 
								|| $scope.newPupil.lastName === undefined || lastNameLength < regexes.min.pup_lastname 
								|| $scope.newPupil.tier === null)){ 
								callback_fn($scope.newPupil);
								$scope.newPupil = {};
								modalInstance.close();
							}
						};
						$scope.close = function(){
							modalInstance.close();
						};
					},
					size: 'md'
				});
			});
		}
	}

})();

(function() {
	'use strict';

	angular.module('modules.profileSettings',[]).controller('prfSettingsController', prfSettingsController);

	/** @ngInject */
	function prfSettingsController(baseService, $window, $scope, $rootScope, profileService, toastr, regexes, $translate, $uibModal, authService) {

		$scope.regexes = regexes;
		$scope.myUser = {};

		$scope.pwd = {
			oldPassword:'',
			newPassword:''
		};

		$scope.viewState = {
			isReady: false
		};

		baseService.app_initialized = function(evt, args) {
			//init the groups on the home page
			function setGender(value) {
				$rootScope.$broadcast('SET_GENDER', value);
			}

			function setCountry(value) {
				$rootScope.$broadcast('SET_COUNTRY', value);
			}

			function getPersonalInfo() {
				$scope.viewState.isReady = false;

				profileService.get('parent/v1/contactInfo', { 'cache': false }).then(function (response) {
					$scope.myUser = response.data;
					$scope.oldEmail = response.data.email;
					$scope.viewState.isReady = true;
					
					$rootScope.getSchools(function(res) {
						$scope.schools = res;
					});
					$scope.integration = $rootScope.active_school.integration;
				}, 
				function (error) {
					$scope.viewState.isReady = true;
				})
			}

			getPersonalInfo();

			$scope.update = function() {
				$scope.invalidPhone = false;
				
				if($scope.myUser.phoneNumber) {
					if($scope.myUser.phoneNumber.length < 8) {
						$scope.invalidPhone = true;
						return;
					}
				}

				if(!$scope.bd.email.$valid) {
					toastr.warning('Please enter a valid email');
					return;
				}
				if($scope.integration && $scope.myUser.email !== $scope.oldEmail) {
					toastr.warning('Email cannot be changed in integration school');
					return;
				}

				$scope.viewState.isButtonDisabled = true;

				profileService.put('parent/v1/contactInfo', {
					email: $scope.myUser.email,
					phoneNumber: $scope.myUser.phoneNumber

				}, { }).then(function(response){
					$scope.viewState.isButtonDisabled = false;
					
					$scope.bd.$setPristine();

					localStorage.removeItem('__c4')
					localStorage.removeItem('__c5')
					localStorage.removeItem('__c6')

					$rootScope.active_user.email = $scope.myUser.email;
					$rootScope.active_user.phoneNumber = $scope.myUser.phoneNumber;
					$rootScope.saveContextToCache();
					
					$scope.rootContext(false, $rootScope.active_school.id, true);
					//$window.history.back();
					toastr.success('Contact information updated successfully');
				}, 
				function (error) {
					(error.status !== -1 ) ? toastr.error(error.data.error.message || $translate.instant('UPDATE_FAIL')) : _.noop();
					$scope.viewState.isReady = true;
					$scope.viewState.isButtonDisabled = false;
				});
			}

			$scope.logout = function() {
				authService.logout(false,'profile-settings');
			}

			$scope.deleteAccount = function(form) {
				$scope.deletingAccount = false;
				$scope.deletingAccountError = false;

				var modalInstance = $uibModal.open({
					animation: true,
					templateUrl: 'app/profile/views/delete-account-modal.html',
					backdropClass: 'backdrop-zindexed',
					size:'sm',
					controller: function($scope) {
						$scope.vm = { };

						$rootScope.getSchools(function(res) {
							$scope.schools = res;
						});

						$scope.$watch('vm.password', function(){
							$scope.deletingAccountError = '';
						})

						$scope.confirm = function() {
							$scope.deletingAccount = true;

							var values = navigator.platform + window.screen.height + window.screen.width + window.screen.colorDepth;
							$scope.vm.dvcsgn = values;
							$scope.vm.os = navigator.platform;
							$scope.vm.email = $rootScope.active_user.email;
							$scope.vm.school = $rootScope.active_school.id;

							profileService.put('parent/v1/delete/myAccount', $scope.vm, {'ignoreErrors': true}).then(function(response){
								authService.logout(false,'delete-my-account-profile-settings');
							}, 
							function (error) {
								$scope.deletingAccount = false;
								if (error.data.error.message === 'ONLY_AMBASSADOR_FOR_THE_SCHOOL') {
									modalInstance.close();
									$scope.openOnlyAmbassadorModal();
								} else {
									$scope.deletingAccountError = error.data.error.message;
								}
							});
						}

						$scope.close = function() {
							modalInstance.close();
						}

						$scope.openOnlyAmbassadorModal = function() {
							var modalInstance = $uibModal.open({
								animation: true,
								templateUrl: 'app/profile/views/only-ambassador-modal.html',
								backdropClass: 'backdrop-zindexed',
								size:'sm',
								controller: function($scope) {
									$scope.close = function() {
										modalInstance.close();
									}
								}
							})
						}
					}
				})
			}
		}
		
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}
})();
(function() {
	'use strict';

	angular.module('modules.profile.pupils',[]).controller('prfPupilsController', prfPupilsController);

	/** @ngInject */
	function prfPupilsController(baseService, $scope, metadata, $rootScope, profileService, toastr, $translate, regexes, $cacheFactory, $uibModal) {

		/**
		 * Because we are modifing pupils we have to clean the filters
		 */
		function cleanGroupsOnStream(){
			$rootScope.activityStreamTierId = -1;
			delete $rootScope.homeFilters;
		}

		baseService.app_initialized = function(evt, args) {
			cleanGroupsOnStream();

			if(window.innerWidth < 760) {
				var i = 0;
				var int = setInterval(function() {
				window.scrollTo(0, i);
				i += 5;
				if (i === 200) clearInterval(int);
				}, 1);
			}
			
			$scope.pupils = [];
			$scope.regexes = regexes;
			$scope.viewState = {
				isReady: true
			};
			var genders = {};

			_.each(metadata.data.metadata.genders, function (obj, index) {
				genders[obj.id] = obj.longName;
			});

			var nameGender = function (_id){
				return genders[_id]
			};

			var months = { };
			_.each(metadata.data.metadata.months, function (obj, index) {
				months[obj.id] = obj.longName;
			});

			var nameMonth = function (_id){
				return months[_id]
			};

			var relationships = { };
			_.each(metadata.data.metadata.relationships, function (obj, index) {
				relationships[obj.id] = obj.longName;
			});

			var parent_relationships = { };
			_.each(metadata.data.metadata.parent_relationships, function (obj, index) {
				parent_relationships[obj.id] = obj.longName;
			});
			
			$scope.relationToPupils = function (_id, _gender) {
				if(!relationships)
					return;

				if(!parent_relationships)
					return;

				return namePupilRelation(relationships, parent_relationships, _id, _gender)
			};

			$scope.removePupil = function(pupil) {
				cleanGroupsOnStream();

				var modalInstance = $uibModal.open({
					animation: true,
					templateUrl: 'app/profile/views/delete-pupil-modal.html',
					backdropClass: 'backdrop-zindexed',
					size:'sm',
					controller: function($scope) {
						$scope.confirm = function() {	
							
							$scope.deleting = true;
							cleanHttpCache();

							profileService.delete('parent/v1/delete/pupil/' + pupil.id, { 'cache':false }).then(function (response) {
								$scope.pupils = _.without($scope.pupils, pupil);
								$scope.deleting = false;
								modalInstance.close();

								if($scope.pupils.length === 0 ){
									$scope.pupils = []
								}
								
								$rootScope.refreshContext();
								getPupilsInfo();
							},function (error) {
							})
						}

						$scope.close = function() {
							modalInstance.close();
						}
					}
				})
			}

			$scope.openAddPupilModal = function () {
				cleanGroupsOnStream();

				$rootScope.$broadcast('ADD_PUPIL', function(newPupil){
					
					newPupil.tierId = newPupil.tier.id;
					cleanHttpCache();

					profileService.put('parent/v1/' + $rootScope.active_school.id + '/create/pupil', { 'pupil': newPupil }, { }).then(function (response) {
						newPupil.gender = nameGender(newPupil.genderId) || '';
						newPupil.id = response.data.id || '';
						$rootScope.refreshContext();
						getPupilsInfo();
					}, function (error) {
						toastr.error($translate.instant(error.data.error.message))
					})
				});
			};

			$scope.openEditPupil = function (pupil) {
				cleanGroupsOnStream();
				
				pupil.tier = {id: pupil.firstTierId, name: pupil.firstTierName};
				$rootScope.$broadcast('EDIT_PUPIL', pupil, function(newpupil){

					newpupil.tierId = newpupil.tier.id;
					cleanHttpCache();

					profileService.put('parent/v1/' + $rootScope.active_school.id + '/update/pupil', { 'pupil': newpupil },{ }).then(function (response) {
						newpupil.gender = nameGender(newpupil.genderId) || '';
						newpupil.month = nameMonth(newpupil.monthId) || '';
						newpupil.id = response.data.id || '';

						localStorage.removeItem('__c4')
						localStorage.removeItem('__c5')
						localStorage.removeItem('__c6')
						$rootScope.storedFilters = []

						getPupilsInfo();

					}, function (error) {
						toastr.error($translate.instant(error.data.error.message))
					})
				});
			};
		

			function getName(type, id) {
				return _.find(metadata[type], {'id':id}) || ''
			}

			function getPupilsInfo(){
				profileService.get('parent/v1/' + $rootScope.active_school.id + '/list/pupils',{'cache':false}).then(function (response) {
					$scope.pupils = response.data.pupils;
					_.forEach($scope.pupils , function(pupil){
						pupil.gender = nameGender(pupil.genderId) || '';
					})
				}, 
				function (error) {
					
				})
			}

			function cleanHttpCache(){
				var $httpDefaultCache = $cacheFactory.get('$http');
				$httpDefaultCache.removeAll();
			}
			
			setTimeout(function() {
				getPupilsInfo()
			}, 400)
		}
		
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.profilePrivacy',[]).controller('prfPrivacyController', prfPrivacyController);

	/** @ngInject */
	function prfPrivacyController($scope, $rootScope, profileService, toastr, $translate) {

		$scope.privacySettings = [];
		$scope.runSchoolShare = false;

		$scope.viewState = {
			isReady: false
		};

		function getPrivacy() {
			profileService.get('parent/v1/profile/get/privacy', { 'cache': false }).then(function(response){
				$scope.privacySettings = response.data.settings;
				$scope.runSchoolShare = response.data.runSchoolShare ? true : false;
				$scope.viewState.isReady = true;
			}, 
			function(error) {
				$scope.viewState.isReady = true;
			})
		}

		function setPristine(){
			$scope.ps.$setPristine();
		}

		getPrivacy()

		$scope.save = function() {

			profileService.put('parent/v1/profile/update/privacy', {
				'settings': $scope.privacySettings,
				'runSchoolShare': $scope.runSchoolShare
			}, { })
			.then(function(response) {
				toastr.success($translate.instant('PRIV_UPDATE_SUCCESS'));
				
				var _c = JSON.parse(localStorage.getItem('__c5').b64decode());
				_c.me.rM = $scope.runSchoolShare ? true : false;
				localStorage.setItem('__c5', JSON.stringify(_c).b64encode());
					
				setPristine();
				
			}, function(error) {
				$scope.runSchoolShare = false;

				if (error.status === 403 || error.status === 409) {
					toastr.error($translate.instant(error.data.error.message));
					//toastr.error($translate.instant('PRIV_UPDATE_FAIL'))
					//toastr.error($translate.instant(error.data));
				}
			})
		}

	}
})();

(function() {
	'use strict';

	angular.module('modules.profilePassword',[]).controller('prfPasswordController', prfPasswordController);

	/** @ngInject */
	function prfPasswordController(baseService, $scope, $rootScope, profileService, toastr, regexes, $translate, $uibModal, authService) {

		$scope.regexes = regexes;
		$scope.myUser = {};

		$scope.pwd = {
			oldPassword:'',
			newPassword:''
		};

		$scope.viewState = {
			isReady: true
		};

		baseService.app_initialized = function(evt, args) {

			$scope.updatePassword = function(form) {
				$scope.saving = true;
				profileService.post('parent/v1/changePassword', $scope.pwd, { }).then(function(response){
					$scope.saving = false;
					toastr.success('Password updated successfully');
					$scope.cp.$setPristine();
					$scope.cp.$setUntouched();
					$scope.pwd = { };
					$rootScope.back();
				}, 
				function (error) {
					$scope.saving = false;
					toastr.error(error.data.error.message);
				});
			}
			
		}
		
		$scope.validatePassword = function() {
			$scope.isPasswordRequired = !$scope.pwd.newPassword;
			$scope.isPasswordValid = $scope.regexes.password.test($scope.pwd.newPassword);
		};

		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}
})();
(function() {
	'use strict';

	angular.module('modules.profileNotifications',[]).controller('prfNotificationsController', prfNotificationsController);

	/** @ngInject */
	function prfNotificationsController($scope,$rootScope,  profileService, toastr, $translate) {
		$scope.notificationSettings = [];
		$scope.viewState = {
			isReady: false
		};
		
		function getNotifications() {
			$rootScope.checkIfPushSettingsAreOn();
			profileService.get('parent/v1/profile/get/notifications/notification',{'cache':false}).then(function(response){
				$scope.notificationSettings = response.data.payload.notifications || [];

				$scope.selectedAll = true;
				for(var i = 0; i < $scope.notificationSettings.length; i++) {
					for(var j = 0; j < $scope.notificationSettings[i].children.length; j++) {
						if(!$scope.notificationSettings[i].children[j].value) {
							$scope.selectedAll = false;
							break;
						}
					}
				}

				$scope.emailSettings = response.data.payload.email || [];
				$scope.digestSettings = response.data.payload.digest || [];

				$scope.marketingSettings = response.data.payload.marketing || [];
				$scope.viewState.isReady = true;
			}, 
			function(error) {
				$scope.viewState.isReady = true;
			})
		}

		function setPristine() {
			$scope.pn.$setPristine();
		}

		getNotifications()
		
		$scope.onChecked = function() {
			$scope.save();
		}
		
		$scope.onAllChecked = function() {
			$scope.save(true);
		}

		$scope.save = function(all) {
			var payload = {
				'settings': []
			}
			
			_.forEach($scope.notificationSettings, function(notif) {
				_.forEach(notif.children, function(n) {
					if(all) {
						n.value = $scope.selectedAll;
					}
					payload.settings.push(n)
				})
			})

			profileService.put('parent/v1/profile/update/notifications',{'payload':payload},{}).then(function(response){
				toastr.success($translate.instant('NOTIFICATIONS_UPDATE_SUCCESS'));
				setPristine();
			}, function(error){
				toastr.error($translate.instant('NOTIFICATIONS_UPDATE_FAIL'))
			})
		}

	}
})();

(function () {
	'use strict';

	angular.module('modules.profile', []).factory('profileService', ['base', function (base) {
		return _.create(base, {});
	}]).controller('profileController', profileController);

	/** @ngInject */
	function profileController(baseService, $scope, $rootScope, profileService, $state, toastr, authService, $uibModal) {

		$scope.sections = [
			{
				'icon': 'dripicons-user',
				'label': 'NAV_EDIT_PROFILE',
				'url': 'profileSettings'
			},
			{
				'icon': 'dripicons-lock',
				'label': 'NAV_MANAGE_PRIVACY',
				'url': 'profilePrivacy'
			},
			{
				'icon': 'dripicons-bell',
				'label': 'NAV_MANAGE_PUSH_NOTIFICATION_SETTINGS',
				'url': 'profileNotifications'
			},
			{
				'icon': 'dripicons-mail',
				'label': 'NAV_MANAGE_EMAIL_NOTIFICATION_SETTINGS',
				'url': 'mailNotifications'
			},
			{
				'icon': 'dripicons-password',
				'label': 'NAV_MANAGE_CHANGE_PASSWORD',
				'url': 'profilePassword'
			}
		];

		$scope.setActive = function (sec) {
			$scope.showDropdown = false;
			$scope.activeSection = sec;
		};

		$scope.setScrollToChildren = function () {
			$rootScope.scrollToChildren = true;
		};

		$scope.toggleDropdown = function () {
			$scope.showDropdown = !$scope.showDropdown;
		}

		baseService.app_initialized = function (evt, args) {
			// Display move up dialog or not?
			if ($rootScope.active_user.emailVerified) {
				checkAndDisplayMoveUpDialog();
			}
			$scope.integration = $rootScope.active_school.integration;
			getInfo();
			for (var i = 0; i < $scope.sections.length; ++i) {
				if ($scope.sections[i].url === $state.current.name) {
					$scope.setActive($scope.sections[i]);
					window.scroll(0, 0);
					break;
				}
			}

		}

		if ($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}

		$scope.logoutProfile = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				templateUrl: 'app/profile/views/logout-confirm-modal.html',
				backdropClass: 'backdrop-zindexed',
				size: 'sm',
				controller: function ($scope) {
					$scope.vm = {};

					$scope.confirm = function () {
						$scope.loggingOut = true;
						authService.logout(false, "logout-from-my-profile-confirm-dialog");
					}

					$scope.close = function () {
						modalInstance.close();
					}
				}
			})
		}

		//Emese 9/11/17 - Get pupil names for the profile header
		function getInfo() {
			profileService.get('parent/v1/' + $rootScope.active_school.id + '/list/pupils', { 'cache': false }).then(function (response) {
				$scope.pupils = response.data.pupils;
				_.forEach($scope.pupils, function (pupil) {
					pupil.gender = nameGender(pupil.genderId) || '';
				});
			},
				function (error) {

				})
		}
		/*
		 * This function is responsible from whether displaying the move up dialog or not.
		 * Will show the dialog until they dismiss it with
		 * don't show again box ticked. 
		 */
		function checkAndDisplayMoveUpDialog() {
			$scope.checkTodo('PARENT_TIME_TO_CHECK_PROFILE').then(function (resp) {
				if (resp.data.payload.show) {
					var modalInstance = $uibModal.open({
						animation: true,
						scope: $scope,
						backdropClass: 'backdrop-zindexed',
						templateUrl: 'app/profile/views/check-profile-modal.html',
						size: 'md',
						controller: function ($scope) {
							$scope.close = function () {
								if ($scope.showAgainCheck) {
									$scope.dismissTodo('PARENT_TIME_TO_CHECK_PROFILE').then(function (resp) { },
										function (error) { })
								}
								modalInstance.close();
							};
						}
					});
				}
			});
		}

	}
})();

(function() {
	'use strict';

	angular.module('modules.profile.family',[]).controller('prfFamilyController', prfFamilyController);

	/** @ngInject */
	function prfFamilyController($stateParams, baseService, $scope, $rootScope, profileService, metadata, toastr, regexes, $uibModal, $translate, $cacheFactory, $window) {
		var relationships = {};
		$scope.newFamily = {};
		$scope.pupilsList = [];
		$scope.viewState = {
			isReady: false,
			hasFamily:true
		};

		function cleanHttpCache() {
			var $httpDefaultCache = $cacheFactory.get('$http');
			$httpDefaultCache.removeAll();
		}

		$scope.nameRelation = function (_id) {
			return relationships[_id]
		};

		baseService.app_initialized = function(evt, args) {
			$scope.editingId = null;

			$scope.integration = $rootScope.active_school.integration;
			if($stateParams.id) {
				$scope.editingId = $stateParams.id;
				profileService.get('parent/v1/get/' + $stateParams.id + '/familyMember', { 'cache': false }).then(function (response) {
					$scope.newFamily = response.data;
					$scope.pupilsList = response.data.pupils;
				},
				function (error) {
					$scope.viewState.isReady = true;
				})
			}
			else {
				$scope.getPupilsCompact();
			}
		}

		$scope.delete = function() {
			var id = $stateParams.id;

			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'app/profile/views/delete-family-modal.html',
				backdropClass: 'backdrop-zindexed',
				size:'sm',
				controller: function($scope) {
					$scope.confirm = function() {
						$scope.deleting = true;
						//cleanHttpCache();

						profileService.delete('parent/v1/delete/familyMember/'+id, { 'cache': false }).then(function (response) {
							$window.history.back();
						},
						function (error) {
							$scope.viewState.isReady = true;
						})
					}

					$scope.close = function() {
						modalInstance.close();
					}
				}
			})
		}

		$scope.getParentRelationship = function(p) {
			if(!p.parents)
				return '';

			for(var i = 0; i < p.parents.length; i++) {
				if($scope.user.id === p.parents[i].user) {
					return p.parents[i].relationship + ' of';
				}
			}
		}
		
		$scope.getPupilsCompact = function() {
			profileService.get('parent/v1/list/' + $rootScope.active_school.id + '/pupils/compact', { 'xhr': true, 'cache': false })
			.then(function(response) {
				if(response.data.items)
					$scope.pupilsList = response.data.items;
			}, 
			function(error){
				$scope.viewState.isReady = true;
			})
		}

		$scope.save = function() {
			var firstNameLength, lastNameLength;
			if (($scope.newFamily.firstName === null) || _.isUndefined($scope.newFamily.firstName)) {
				firstNameLength = 0;
			}else {
				firstNameLength = $scope.newFamily.firstName.length;
			}
			if (($scope.newFamily.lastName === null) || _.isUndefined($scope.newFamily.lastName)) {
				lastNameLength = 0;
			}else {
				lastNameLength = $scope.newFamily.firstName.length;
			}
			if (!($scope.newFamily.firstName === null || firstNameLength < regexes.min.name ||
				$scope.newFamily.lastName === null || lastNameLength < regexes.min.name ||
				!$scope.newFamily.email )) {

				var selectedPupils = [];
				if($scope.pupilsList && $scope.pupilsList.length > 0) {
					for(var i = 0; i < $scope.pupilsList.length; i++) {
						$scope.pupilsList[i].invalid = false;

						if($scope.pupilsList[i].selected) {
							if($scope.pupilsList[i].relationshipId && $scope.pupilsList[i].relationshipId !== '0') {
								selectedPupils.push({
									pupilId: $scope.pupilsList[i].id, 
									relationshipId: $scope.pupilsList[i].relationshipId
								})
							}
							else {
								$scope.pupilsList[i].invalid = true;
								return;
							}
						}
					}
				}

				if(selectedPupils.length === 0) {
					toastr.info('Please select at least one child')
					return;
				}

				$scope.newFamily.pupils = selectedPupils;

				$scope.newFamily.sendInvite = true;
				$scope.saving = true;
				profileService.post('parent/v1/create/' + $rootScope.active_school.id + '/familyMember', $scope.newFamily, {}).then(function (response) {
					$scope.saving = false;
					$window.history.back();
					toastr.success('Successfully updated the family member')
				}, 
				function (error) {
					$scope.saving = false;
					toastr.error(error.data.error.message)
				});
			}
			else {
				toastr.info('Please fill the mandatory fields')
			}
		};
		
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}
})();


(function() {
	'use strict';

	angular.module('modules.mailNotifications',[]).controller('mailNotificationsController', mailNotificationsController);

	/** @ngInject */
	function mailNotificationsController($scope,$rootScope,  profileService, toastr, $translate) {
		$scope.notificationSettings = [];
		$scope.viewState = {
			isReady: false
		};
 
		var screenParam = $rootScope.getQueryParam('screen');
		
		if(screenParam === 'adminrole' || screenParam === 'profile'){
			location.href = '#/profile';
			return;
		}
		function getNotifications() {
			$rootScope.checkIfPushSettingsAreOn();
			profileService.get('parent/v1/profile/get/notifications/email',{'cache':false}).then(function(response){
				$scope.notificationSettings = response.data.payload.email || [];

				$scope.selectedAll = true;
				for(var i = 0; i < $scope.notificationSettings.length; i++) {
					for(var j = 0; j < $scope.notificationSettings[i].children.length; j++) {
						if(!$scope.notificationSettings[i].children[j].value) {
							$scope.selectedAll = false;
							break;
						}
					}
				}

				$scope.emailSettings = response.data.payload.email || [];
				$scope.digestSettings = response.data.payload.digest || [];

				$scope.marketingSettings = response.data.payload.marketing || [];
				$scope.viewState.isReady = true;
			}, 
			function(error) {
				$scope.viewState.isReady = true;
			})
		}

		function setPristine() {
			$scope.pn.$setPristine();
		}

		getNotifications();
		
		$scope.onChecked = function(e) {
			// If the changed setting is weekly or daily digest, 
			// refresh the values because
			// it affect other fields too.
			var refresh = false;
			if(e.name == 'EMAIL_DIGEST' || e.name == 'EMAIL_DAILY_DIGEST'){
				refresh = true;
			}
			$scope.save(false,refresh);	
		}
		
		$scope.onAllChecked = function() {
			$scope.save(true, false);
		}

		$scope.save = function(all,refresh) {
			var payload = {
				'settings': []
			}
			
			_.forEach($scope.emailSettings, function(email) {
				_.forEach(email.children, function(a) {
					if(all) {
						a.value = $scope.selectedAll;
					}
					payload.settings.push(a)
				})
			})

			profileService.put('parent/v1/profile/update/notifications',{'payload':payload},{}).then(function(response){
				toastr.success($translate.instant('NOTIFICATIONS_UPDATE_SUCCESS'));
				setPristine();
				if(refresh){
					getNotifications();
				}
			}, function(error){
				toastr.error($translate.instant('NOTIFICATIONS_UPDATE_FAIL'))
			})
		}

	}
})();

(function() {
	'use strict';

	angular.module('modules.post',[])
	.factory('homeService', ['base', function (base) {
		return _.create(base, { });
	}])
	.controller('postController', postController);

	/** @ngInject */
	function postController(baseService, $scope, homeService, $timeout, toastr, $translate, storage, $stateParams, $rootScope, $window, settings) {
		var post_listener;
		var postId = $stateParams.id;
		$scope.posts = {};

		$scope.viewState = {
			isReady:true,
			isInitiated:false
		}
		
		$scope.updatePostComments = function(post) {
			
		}
		
		post_listener = $rootScope.$on('ON_SOCKET_POST', function(evt, args) {
			var textarea = document.querySelector('.comment-composer-inner textarea');
			if(textarea && textarea.value)
				return;
			// $scope.getPost();
		})

		baseService.app_initialized = function(evt, args) {

			$scope.getPost = function() {
				$scope.getingPosts = true;

				homeService.get('shared/v1/get/nextStreamAdvert/' + $rootScope.active_school.id +'/web_parent_post_detail', {'cache': false}).then(function (response) {
					$scope.ad = response.data;
				});

				homeService.get('post/v1/get/'+ postId, { 'xhr': true, 'cache': false }).then(function(response) {
					setTimeout(function() {
						$scope.posts_array = [];
						$scope.posts = response.data.payload;
						$rootScope.truncateClasslistPostsLinks($scope.posts.post);
						$scope.posts_array.push($scope.posts.post);
						$scope.$apply();
					}, 2);
					

					setTimeout(function() {
						$scope.viewState.isInitiated = true;
						$scope.$apply();
					}, 100);
					
					if ($scope.posts.post.sentTo && $scope.posts.post.sentTo.length > 0){
						$scope.posts.post.groupName = $scope.posts.post.sentTo.join(', ');
					}
				}, 
				function(error) {
					$scope.viewState.isInitiated = true;
				});
				$scope.getingPosts = false;
			}
			
			var me = $rootScope.active_user;
			$scope.redirectPages = $stateParams.redirectPages;
			$scope.userName = me.firstName+' '+me.lastName;
			$scope.groups = $rootScope.active_user.groups;
			$scope.getPost();

			$scope.back = function() {
				if (document.referrer === '') {
					if ($window.history && $window.history.length > 2) {
						$window.history.back();
					}
					else {
						if($scope.posts) {
							if($scope.posts.post && $scope.posts.post.type === 'listing') {
								location.href = '/parent/#/listings/list/';
							}
							else {
								location.href = '/parent/#/home';
							}
						}
						else {
							location.href = '/parent/#/home';
						}
					}
				} 
				else {
					$window.history.back();
				}
				
				$rootScope.backFromPost = true;
			}

			$scope.seeMore = function() {
				if ($scope.posts && $scope.posts.post && $scope.posts.post.groupId > 0){
					$rootScope.activityStreamTierId =$scope.posts.post.groupId;
				} else {
					$rootScope.activityStreamTierId = -1;
				}

				if($scope.posts && $scope.posts.post && $scope.posts.post.type === 'listing') {
					location.href = '#/listings/list/';
				}
				else {
					location.href = '#/stream';
				}
			}

			$window.onscroll = function() {
				if($scope.getingPosts) return;

				isElementInViewport(function(id, index) {
					homeService.get('shared/v1/hit/nextAdvert/' + $rootScope.active_school.id + '/' + $scope.ad.id + '/web_parent_post_detail', { 'xhr': true, 'cache': false }).then(function(response) {
						
					}, 
					function(error) {
						
					});
				})
			}
		}

		$scope.onGroupNameTap = function(group){
			var groupObject = {
				id: group
			}
			$rootScope.goToGroup(groupObject,false,null);
		}
		
		$scope.dismissSample = function(announcement) {
			announcement.sample = false;
		}

		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}

		$scope.$on('$destroy', function () {
			if(post_listener)
				post_listener();
		});
		
	}
})();

(function () {
	"use strict";

	angular
		.module("modules.post.edit", [])
		.factory("homeService", [
			"base",
			function (base) {
				return _.create(base, {});
			},
		])
		.controller("postEditController", postEditController);

	/** @ngInject */
	function postEditController(
		baseService,
		$scope,
		homeService,
		regexes,
		$state,
		$window,
		settings,
		$timeout,
		toastr,
		$translate,
		storage,
		$stateParams,
		$rootScope,
		uploadService,
		$uibModal,
		postService
	) {
		baseService.app_initialized = function (evt, args) {
			var fileUploader = document.getElementById("postUploader");
			$scope.regexes = regexes;
			$scope.categories = ["general", "lost_found", "offer", "wanted"];
			$scope.draftPost = {};

			var me = $rootScope.active_user,
				schoolId = $rootScope.active_user.id;

			$scope.viewState = {
				isReady: true,
			};

			$scope.selectedGroup = {};

			// PWA-7806
			$scope.isNativeAndroid = function () {
				// PWA-7806 Hide the attachment link for posts on Android nativeg
				if ($rootScope.isNative && $rootScope.os === "Android") {
					return true;
				} else {
					return false;
				}
			};

			$scope.loadGroups = function () {
				$scope.groups = $rootScope.active_user.groups;
				
				for (var i = 0; i < $scope.groups.length; i++) {
					if ($scope.groups[i].id === $scope.post.groupId) {
						$scope.selectedGroup = $scope.groups[i];
						break;
					}
				}
			};

			$scope.selectGroup = function (group) {
				$scope.selectedGroup = group;
				$scope.post.groupId = group.id;
				$scope.showGroups = false;
			};

			$scope.selectCategory = function (value, prevent) {
				if (!prevent) $scope.post.price = "";

				if (
					value === "free" ||
					value === "jobs" ||
					value === "for_sale" ||
					value === "offer"
				) {
					$scope.hasPrice = true;

					if (value === "free") {
						if (!prevent) $scope.post.price = "FREE";
					}
				} else {
					$scope.hasPrice = false;
				}

				$scope.post.category = value;
			};

			$scope.removePhoto = function (index) {
				$scope.post.attachments.splice(index, 1);
			};

			$scope.removeFile = function (index) {
				$scope.post.files.splice(index, 1);
			};

			$scope.getPost = function () {
				$scope.viewState.isReady = false;

				homeService
					.get("post/v1/get/" + $stateParams.id, { xhr: true, cache: false })
					.then(
						function (response) {
							$scope.post = response.data.payload.post;
							$scope.post.body = $rootScope.removeLinks($scope.post.body);
							$scope.draftPost.body = $rootScope.parseMentionTagsToDiv(
								$scope.post.body
							);
							$scope.bodyWithoutEntities = decodeEntities($scope.post.body);
							$scope.viewState.isReady = true;
							$scope.post.price = $scope.post.priceAsDouble;
							$scope.post.category = $scope.post.listingCategory
								? $scope.post.listingCategory.toLowerCase()
								: "general";
							$scope.post.linkPreview = $scope.post.$linkpreview
								? $scope.post.$linkpreview
								: "";
							$scope.selectCategory($scope.post.category, true);
							$rootScope.$broadcast("RESIZE_TO_LARGE", function (someVar) {});
							//$scope.loadGroups();
						},
						function (error) {
							$scope.viewState.isReady = true;
						}
					);
			};

			$scope.uploadAttachment = function () {
				fileUploader.setAttribute("accept", "*");
				fileUploader.click();
				$scope.$root.nativeCamPerm();
			};
			var decodeEntities = (function () {
				// this prevents any overhead from creating the object each time
				var element = document.createElement("div");
				function decodeHTMLEntities(str) {
					if (str && typeof str === "string") {
						// strip script/html tags
						str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, "");
						str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, "");
						element.innerHTML = str;
						str = element.textContent;
						element.textContent = "";
					}

					return str;
				}
				return decodeHTMLEntities;
			})();

			$scope.getPostBody = function (bodyWithTags) {
				$scope.bodyWithoutEntities = decodeEntities(bodyWithTags);
				// string only contains whitespace
				if (!$scope.bodyWithoutEntities.replace(/\s/g, "").length) {
					$scope.isBodyAllSpace = true;
				} else $scope.isBodyAllSpace = false;
				$scope.post.body = bodyWithTags;
				$scope.checkForLinkPreviews(bodyWithTags);
			};

			//This function will check if post body matches with Link regex.
			$scope.checkForLinkPreviews = function (textToCheck) {
				//first check if we need to check

				if (
					!textToCheck ||
					textToCheck.length < 3 ||
					($scope.post.attachments && $scope.post.attachments.length > 0) ||
					($scope.post.files && $scope.post.files > 0)
				) {
					return;
				}

				//check if there is already a link
				if ($scope.post.previewLink && $scope.post.previewLink !== "") {
					return;
				}
				var expression =
					/[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
				var matches = textToCheck.match(expression);
				if (matches !== null) {
					for (var i = 0; i < matches.length; i++) {
						if (matches[i].indexOf("@") > -1) {
							continue;
						}
						$scope.firstLinkInPostBody = matches[i];
						break;
					}
				}
			};

			$scope.editPhoto = function (index) {
				$rootScope.$broadcast("UPLOAD_PHOTO", {
					file_blob: $scope.post.attachments[index].blob,
					callback_fn: function (response) {
						var url = postService.getPostImgBucketUrl() + "/" + response.data;

						if (!$scope.post.attachments) $scope.post.attachments = new Array();

						$scope.post.attachments[index] = {
							url: url,
							blob: response.file_blob,
							id: response.data || "",
						};
					},
					action: "postUpload",
					config: "postCropper",
				});
			};

			$scope.attachUpload = function (blob, success, fail) {
				uploadService
					.fileUpload(
						$scope.filesToSend[0].blob,
						{
							headers: {
								"Content-Type": undefined,
								ClasslistToken: storage.getToken() || "",
								ClasslistCfg: angular.toJson({
									type: "ATTACHMENT",
								}),
							},
						},
						$scope.filesToSend[0].name
					)
					.then(
						function (response) {
							$scope.isUploading = false;
							$scope.filesToSend[0].file_id = response.data;

							if (success) success(response);
						},
						function (error) {
							if (error.status === 403 || error.status === 409) {
								toastr.error($translate.instant(error.data));
							} else {
								//Skip for now.
							}

							if (fail) fail();

							$scope.isUploading = false;
						}
					);
			};

			$scope.filesToSend = new Array();
			fileUploader.onchange = function () {
				var length = 0;

				function recursiveLoad(files, success) {
					var reader = new FileReader();
					var file = files[length];

					if (file) {
						if (file.type.indexOf("image") > -1) {
							var _URL = window.URL || window.webkitURL;
							var img = new Image();

							img.onload = function () {
								window.EXIF.getData(img, function () {
									var orientation = EXIF.getTag(this, "Orientation");
									var canvas = document.createElement("canvas"),
										context;

									var aratio = calculateAspectRatioFit(
										img.width,
										img.height,
										1200,
										1200
									);

									context = canvas.getContext("2d");
									canvas.width = aratio.width;
									canvas.height = aratio.height;

									var x = 0;
									var y = 0;
									if (orientation !== "undefined") {
										/*if (orientation > 4) {
                                            canvas.width = aratio.height;
                                            canvas.height = aratio.width;
                                        }

                                        switch (orientation) {
                                            case 2:
                                                context.translate(canvas.width, 0);
                                                context.scale(-1, 1);
                                                break;
                                            case 3:
                                                context.translate(canvas.width, canvas.height);
                                                context.rotate(Math.PI);
                                                break;
                                            case 4:
                                                context.translate(0, canvas.height);
                                                context.scale(1, -1);
                                                break;
                                            case 5:
                                                context.rotate(0.5 * Math.PI);
                                                context.scale(1, -1);
                                                break;
                                            case 6:
                                                context.rotate(0.5 * Math.PI);
                                                context.translate(0, -canvas.height);
                                                y = canvas.height - canvas.width;
                                                break;
                                            case 7:
                                                context.rotate(0.5 * Math.PI);
                                                context.translate(canvas.width, -canvas.height);
                                                context.scale(-1, 1);
                                                y = canvas.height - canvas.width;
                                                x = canvas.width - canvas.height;
                                                break;
                                            case 8:
                                                context.rotate(-0.5 * Math.PI);
                                                context.translate(-canvas.width, 0);
                                                x = canvas.width - canvas.height;
                                                break;
                                        }*/

										context.drawImage(img, x, y, aratio.width, aratio.height);
										context.restore();

										reader.readAsDataURL(file);
										reader.addEventListener(
											"load",
											function (e) {
												$scope.filesToSend = new Array();

												$scope.filesToSend.push({
													width: canvas.width,
													height: canvas.height,
													name: file.name,
													ext: file.name.split(".").pop(),
													type: file.type,
													src: canvas.toDataURL("image/jpeg", 100),
													url: URL.createObjectURL(file),
													blob: dataURItoBlob(
														canvas.toDataURL("image/jpeg", 100)
													),
												});

												if (!$scope.post.attachments)
													$scope.post.attachments = new Array();

												$scope.attachUpload(
													URL.createObjectURL(file),
													function (resp) {
														var url =
															postService.getPostImgBucketUrl() +
															"/" +
															resp.data;
														$scope.post.attachments.unshift({
															url: url,
															blob: URL.createObjectURL(file),
															id: resp.data || "",
														});

														length += 1;

														$scope.viewState.isReady = false;
														recursiveLoad(files, success);
													}
												);
											},
											false
										);
									}
								});
							};
							img.src = _URL.createObjectURL(file);
						} else {
							// Files
							reader.readAsDataURL(file);

							if (file.size > 8000000) {
								toastr.info($translate.instant("FILE_SIZE_TOO_BIG"));
								return;
							}

							reader.addEventListener(
								"load",
								function (e) {
									$scope.filesToSend = new Array();
									$scope.filesToSend.push({
										name: file.name,
										ext: file.name.split(".").pop(),
										type: file.type,
										src: e.target.result,
										url: URL.createObjectURL(file),
										blob: dataURItoBlob(reader.result),
									});

									if (!$scope.post.files) $scope.post.files = new Array();

									$scope.attachUpload(
										URL.createObjectURL(file),
										function (resp) {
											var url =
												postService.getPostImgBucketUrl() + "/" + resp.data;
											$scope.post.files.unshift({
												name: file.name,
												url: url,
												blob: URL.createObjectURL(file),
												id: resp.data || "",
											});

											length += 1;

											$scope.viewState.isReady = false;
											recursiveLoad(files, success);
										}
									);
								},
								false
							);
						}
					} else {
						$scope.viewState.isReady = true;

						if (success) success();
					}
				}

				if (fileUploader.files.length > 20) {
					var modalInstance = $uibModal.open({
						animation: true,
						scope: $scope,
						templateUrl: "app/composer/views/max-upload-files-modal.html",
						backdropClass: "backdrop-zindexed",
						size: "md",
						controller: function ($scope) {
							$scope.close = function () {
								modalInstance.close();
							};
						},
					});

					return;
				}

				recursiveLoad(fileUploader.files, function () {
					fileUploader.value = "";
				});
			};

			$scope.uploadImage = function () {
				fileUploader.setAttribute(
					"accept",
					"image/x-png,image/png,image/gif,image/jpeg,image/jpg"
				);
				fileUploader.click();
				$scope.$root.nativeCamPerm();
			};
			$scope.deleteLinkPreview = function () {
				$scope.post.linkPreview = "";
			};

			$scope.update = function () {
				var attachs = new Array();
				if ($scope.post.attachments) {
					for (var i = 0; i < $scope.post.attachments.length; i++) {
						attachs.push($scope.post.attachments[i]);
					}
				}

				var file_attachs = new Array();
				if ($scope.post.files) {
					for (var i = 0; i < $scope.post.files.length; i++) {
						file_attachs.push($scope.post.files[i]);
					}
				}

				var payload = {
					currentUserId: $rootScope.active_user.id,
					body: $scope.post.body
						? $rootScope.createEmailLinks($scope.post.body)
						: "",
					postCategory: $scope.post.category.toUpperCase(),
					price: $scope.post.price,
					groupId: $scope.post.groupId,
					attachments: attachs,
					files: file_attachs,
					linkPreview: $scope.post.linkPreview,
				};

				// nbsp broke the post body so we need to remove it
				if(payload.body && payload.body.length > 0) {
					var s = String(payload.body);

                    s = s.replace(/(&nbsp;)+<\/div>/g, '</div>');

                    s = s.replace(/(&nbsp;)+\[URL/g, '[URL');

					payload.body = s;
				}

				$scope.viewState.isReady = false;
				homeService
					.post(
						"post/v1/updateV4/" + $stateParams.id,
						{ payload: DTOS.Map(payload, "composer") },
						{ xhr: true, cache: false }
					)
					.then(
						function (response) {
							$scope.viewState.isReady = true;
							$window.history.back();
						},
						function (error) {
							$scope.viewState.isReady = true;
							toastr.error(error.data.error.message);
						}
					);
			};

			$scope.getPost($stateParams.id);

			$scope.back = function () {
				$window.history.back();
			};
		};

		if ($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.notifications',[]).factory('notificationsService', ['base', function (base) {
		return _.create(base, { });
	}]).controller('notificationsController', notificationsController);

	/** @ngInject */
	function notificationsController(baseService, $scope, $rootScope, $location, $window, notificationsService, $timeout, toastr, $translate, storage, settings) {

		baseService.app_initialized = function(evt, args) {
			$rootScope.tempPosts = null;
			
			$scope.viewState = {
				isReady: true,
				isInitiated: false
			}
			
			$scope.groups = $rootScope.active_user.groups || [];

			$scope.getNotifications = function() {
				$scope.getingPosts = true;
				
				$rootScope.checkIfPushSettingsAreOn();

				notificationsService.get('shared/v1/get/nextStreamAdvert/' + $rootScope.active_school.id+'/web_parent_notification_list', {'cache': false}).then(function (response) {
					$scope.ad = response.data;
				});

				notificationsService.get('parent/v1/' + $rootScope.active_school.id + '/notification/list/-1', {'cache': false}).then(function (response) {

					$scope.notifications = DTOS.Map(response.data.items || [], 'notification');
					if (_.isUndefined($scope.notifications)) {
						$scope.notificationsLength = 0;
					}

					$rootScope.notifsContainer.notifications = 0;
					$rootScope.notifsContainer.home = 0;
					
					$scope.viewState.showNewNotifications = true;

					if($scope.notifications) {
						for (var i = 0; i < $scope.notifications.length; i++) {
							var not = $scope.notifications[i];

							if((not.event === "PARENT_SCHOOLREP_UNASSIGNED" || not.event === "PARENT_SCHOOLREP_ASSIGNED") && not.new){
								$rootScope.refreshContext($rootScope.active_school.id);
							}

							var oldSchoolBase = '';
							var oldParentBase = '';
							var newSchoolBase =  settings.conf.schoolAppURL;
							var newParentBase =  settings.conf.parentAppURL;

							if (settings.conf.type === 'prod'){
								oldSchoolBase = "https://school.classlist.com"
								oldParentBase = "https://parent.classlist.com"
							} else 
							if (settings.conf.type === 'preprod'){
								oldSchoolBase = "https://preprod-school.classlist.com"
								oldParentBase = "https://preprod-parent.classlist.com"
							} else 
							if (settings.conf.type === 'test'){
								oldSchoolBase = "https://test-school.classlist.com"
								oldParentBase = "https://test-parent.classlist.com"
							} else 
							if (settings.conf.type === 'dev'){
								oldSchoolBase = "https://dev-school.classlist.com"
								oldParentBase = "https://dev-parent.classlist.com"
							} else {
								oldSchoolBase = "https://school.classlist.com"
								oldParentBase = "https://parent.classlist.com"
							}
							$scope.notifications[i].extra = $scope.notifications[i].extra.replace(oldParentBase, newParentBase);
							$scope.notifications[i].extra = $scope.notifications[i].extra.replace(oldSchoolBase, newSchoolBase);
							$scope.notifications[i].message = $rootScope.parseTagsToLinks($scope.notifications[i].message);
							$scope.notifications[i].message = $rootScope.parseMentionTags($scope.notifications[i].message);
						}
					}
					
					$rootScope.sendToNative();

				});
				$scope.getingPosts = false;
			}
				
			$scope.markAllRead = function() {
				notificationsService.get('parent/v1/clear/notifications/' + $rootScope.active_school.id, { 'cache' : false }).then(function (response) {
				});

				$rootScope.notifsContainer.notifications = 0;
				$rootScope.notifsContainer.home = 0;

				if($scope.notifications) {
					for(var i = 0; i < $scope.notifications.length; i++) {
						$scope.notifications[i].read = true;
					}
				}

				$rootScope.sendToNative();
			}
				
			$scope.goNotificationSettings = function() {
				location.href = settings.conf.parentAppURL + '#/profile/notifications'
			}

			$scope.notifRedirect = function(object) {
				notificationsService.get('parent/v1/' + $rootScope.active_school.id + '/notification/read/' + object.id, {'cache':false}).then(function (response) {
					//if type is system then redirect to new page

					if(object.event === 'PARENT_REJECTED_GROUP') {
						if(data.userId) {
							$rootScope.nextCompose({ id: data.userId })
						}
					} 
					else if(object.event === 'PARENT_SYSTEM') { //old to be removed
						window.open(object.extra, '_blank'); 

					}
					else if(object.event === 'PARENT_APPROVED' || object.event === 'PARENT_WAITING_APPROVAL_GROUP'){
						window.location = object.extra; 

						setTimeout(function() {
							window.location.reload();
						}, 10)
					} 
					else if(object.event === 'PARENT_SYSTEM_UPDATE') {
						if (object.extra.startsWith(settings.conf.schoolAppURL)) {
							$rootScope.switchApps('#/dashboard/view?_ssfa=true');
						} else {
							location.href = object.extra;	
						}
					} 
					else if(object.event === 'SCHOOLREP_ASSIGNED') { //remove this 30 jan 2018
						$rootScope.switchApps();
					} 
					else if(object.event === 'PARENT_SCHOOLREP_ASSIGNED') {
						$rootScope.switchApps();
					} 
					else {
						location.href = object.extra;
					}
				}, 
				function(error){
					
				})
			}

			$window.onscroll = function() {
				if($scope.getingPosts) return;

				isElementInViewport(function(id, index) {
					notificationsService.get('shared/v1/hit/nextAdvert/' + $rootScope.active_school.id + '/' + $scope.ad.id + '/web_parent_notification_list', { 'xhr': true, 'cache': false }).then(function(response) {
						
					}, 
					function(error) {
						
					});
				})
			}

			$scope.getNotifications();
		}

		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.nonmember',[]).factory('nonmemberService', ['base', function (base) {
		return _.create(base, { });
	}]).controller('nonmemberController', nonmemberController);

	/** @ngInject */
	function nonmemberController(baseService, $scope, $rootScope) {
		$scope.loading = true;
		
		baseService.app_initialized = function(evt, args) {
			$rootScope.verifyEmailDismissed = false;
			$scope.localContext();
		}

		$scope.decideRedirection = function(){
			if($scope.current_user) {
				if($scope.current_user.approved && $scope.current_user.verifyEmailIn > 0) {
					$rootScope.switchSchoolById($scope.current_user.id_school);
				}
				$rootScope.active_user.emailVerified = $scope.current_user.emailVerified;
				$rootScope.active_school.approved = $scope.current_user.approved;
			}
		}

		$scope.localContext = function() {
			baseService.get('parent/v1/get/context/v2/0', { 'cache': false }).then(function (resp) {
				$scope.loading = false;

				$scope.current_user = {
					"id_school": resp.data.school.id,
					"approved": resp.data.school.approved,
					"emailVerified": resp.data.emailVerified,
					"verifyEmailIn": resp.data.verifyEmailIn
				}
				$scope.decideRedirection();					
			}, function() {
				$scope.loading = false;
			});
		}
		
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.post.likes',[]).factory('pmService', ['base', function (base) {
		return _.create(base, { });
	}]).directive('postLikes', postLikes);

	/** @ngInject */
	function postLikes($uibModal, $rootScope, toastr, regexes, pmService) {
		var directive = {
			restrict: 'A',
			replace: true,
			link: linkFunction
		};
		return directive;

		function linkFunction(scope, elem, attrs) {

			scope.$on('POST_LIKES', function(event,	object) {
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/home/views/post-likes-modal.html',
					controller: function($scope) {
						$scope.object = object;
						
						setTimeout(function() {
							angular.element(document.querySelector('.likes-modal'))
							.parent().parent().addClass('modal-likes-size');
						}, 1);

						$scope.openLiker = function(liker) {
							modalInstance.close();

							if($rootScope.active_user.id === liker.userId)
								location.href = '#/profile';
							else
								location.href = '#/classlist/details/' + liker.userId + '/contact';
						}

						$scope.close = function() { 
							modalInstance.close();
						};
					}
				});

			});
		}
	}

})();

(function() {
	'use strict';

	angular.module('modules.listings.view',[]).controller('listingsViewController', listingsViewController);

	/** @ngInject */
	function listingsViewController($scope, $document, $stateParams, $rootScope, $state, metadata, $uibModal, listingsService, toastr, $translate, settings, storage, $location, $window) {

		document.body.scrollTop = 0;
		document.documentElement.scrollTop = 0;

		var listingId = $stateParams.id;
		$scope.marketplaceCategories = metadata.data.metadata.marketplaceCategories || [];

		$scope.viewState = {
			isReady:true,
			isInitiated:false
		}

		$scope.types = [
			"FOR_SALE",
			"WANTED",
			"FREE",
			"LOST"
		];

		$scope.onBackArrowTap = function() {
			$state.go('listings.list');
		}

		$scope.togglePostMenu = function() {
			if ($scope.listing.menuOpened) {
				$scope.listing.menuOpened = false;
			} else {
				$scope.listing.menuOpened = true;
			}
		}

		function getListing(){

			angular.element(document).ready(function(){
				listingsService.get('marketplace/v1/get/' + listingId, {'cache':false, 'xhr':true}).then(function(response){
					$scope.listing = response.data || [];
					$scope.listing.description = $rootScope.parseTagsToLinks($scope.listing.description);
					$scope.listing.listingId = listingId;
					$scope.listing.createdByFirstName = $scope.listing.createdByName.split(' ')[0];
					$scope.viewState.isInitiated = true;

					if ($scope.listing.price % 1 !== 0){
						$scope.listing.price = $scope.listing.price.toFixed(2);
					}

					listingsService.get('shared/v1/get/nextStreamAdvert/' + $rootScope.active_school.id+'/web_parent_marketplace_list', {'cache': false}).then(function (response) {
						$scope.ad = response.data;
					});
				}, 
				function(error){
					
				});
			});
		}

		getListing();

		$scope.markSold = function(){
			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'app/listings/views/sold-modal.html',
				backdropClass: 'backdrop-zindexed',
				size:'sm',
				scope: $scope,
				controller: function(){
					$scope.confirm = function(){
						listingsService.get('marketplace/v1/markAsSold/' + listingId, {'cache':false, 'xhr':true}).then(function(response){
							toastr.info($translate.instant(($scope.listing.type !== "WANTED" && $scope.listing.type !== "LOST") ? 'LISTING_MARK_SOLD' : 'LISTING_MARK_CLAIMED'));
							$scope.listing.sold = true;
							modalInstance.close();
						}, function(error){
							
						});
					}

					$scope.close = function(){
						modalInstance.close();
					}
				}
			})
		}

		$scope.markAvailable = function(){
			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'app/listings/views/available-modal.html',
				backdropClass: 'backdrop-zindexed',
				size:'sm',
				scope: $scope,
				controller: function(){
					$scope.confirm = function(){
						listingsService.get('marketplace/v1/markAsAvailable/' + listingId, {'cache':false, 'xhr':true}).then(function(response){
							toastr.info($translate.instant(($scope.listing.type !== "WANTED" && $scope.listing.type !== "LOST") ? 'LISTING_MARK_UNSOLD' : 'LISTING_MARK_UNCLAIMED'));
							$scope.listing.sold = false;
							modalInstance.close();
						}, function(error){
							
						});
					}

					$scope.close = function(){
						modalInstance.close();
					}
				}
			})
		}

		$scope.delete = function(){
			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'app/listings/views/delete-listing-modal.html',
				backdropClass: 'backdrop-zindexed',
				size:'sm',
				controller: function($scope){
		
					$scope.confirm = function(){						
						
						listingsService.delete('marketplace/v1/delete/' + listingId, {'cache':false, 'xhr':true}).then(function(response){
							toastr.info($translate.instant('LISTING_DELETED'));
							modalInstance.close();
							$state.go('listings.list');
						}, function(error){
							
						});
					}

					$scope.close = function(){
						modalInstance.close();
					}
				}
			})
		}

		$scope.openPicture = function(url) {
			if ($rootScope.isNative) {
				previewImages($scope.listing.photos);
			} else {
				window.open(url + '=s0', '_blank')
			}
		}

		$scope.report = function() {

			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/listings/views/report-listing-modal.html',
				controller: function($scope) {
					$scope.viewState = {
						isReady: true
					};

					$scope.close = function() {
						modalInstance.close();
					};

					$scope.report = function() {
						$scope.viewState.isReady = false;
						listingsService.put('marketplace/v1/report/' + listingId, {"message": $scope.reportReason}).then(function() {
							$scope.viewState.isReady = true;
							toastr.info($translate.instant('LISTING_REPORTED'))
							modalInstance.close();
						}, function() {
							$scope.viewState.isReady = true;
						});
					}

				},
				size: 'md'
			});
		}

		$scope.getCategory = function(category) {
			var data = $scope.marketplaceCategories.find(function(c) {
				return c.name === category;
			});
			if(data) return data.value;
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.listings',[]).factory('listingsService', ['base', function (base) {
		return _.create(base, { });
	}]).controller('listingsController', listingsController);

	/** @ngInject */
	function listingsController($scope, $state, $translate, $uibModal, toastr, listingsService) {

		// remember to add translations when adding a new category (with "LISTING_CAT_" as an indicator), 
		// also do not forget to remove from when removing from here
		$scope.categories = [
			"general",
			"offer",
			"wanted",
			"lost_found"
		];
	}
})();

(function() {
	'use strict';

	angular.module('modules.listings.list',[]).controller('listingsListController', listingsListController);

	/** @ngInject */
	function listingsListController(baseService, $scope, $rootScope, $location, $window, $sce, regexes, settings, listingsService, $stateParams, $state, $translate, toastr, storage, $uibModal) {
		var moreloading = false;
		var cursor = 'none';

		$scope.$on('$destroy', function () {
			if (window.viewpostListener)
				window.viewpostListener();
		});

		$scope.updatePostComments = function(post) {
			if($scope.listings) {
				for(var i = 0; i < $scope.listings.length; i++) {
					if($scope.listings[i].id === post.id) {
						$scope.listings[i].comments = post.comments;
						break;
					}
				}
			}
		}

		$scope.onBackArrowTap = function() {
			$rootScope.activityStreamTierId = -1;
			$window.location.href = "/parent/#/home";
		}

		baseService.app_initialized = function(evt, args) {
			// Check the marketplace appcues here
			if(!localStorage.getItem('PARENT_PRODUCT_DISCOVERY_MARKETPLACE')) {
				if($rootScope.active_school && $rootScope.active_school.id) {
					$rootScope.checkTodo('PARENT_PRODUCT_DISCOVERY_MARKETPLACE').then(function(resp) {
						$scope.showAppcueMarketplaceInfo = resp.data.payload.show;
					});
				}
			}

			var appcueClicked = false;
			$scope.inlineAppcueDoLater = function(type) {
				switch(type) {
					case 'PARENT_PRODUCT_DISCOVERY_MARKETPLACE':
						$scope.showAppcueMarketplaceInfo = false;
						$rootScope.userTag('PARENT_PRODUCT_DISCOVERY_MARKETPLACE', 'LATER');
						break;
				}
			}

			$scope.inlineAppcueDontShowAgain = function(type) {
				if(appcueClicked)
					return;

				appcueClicked = true;
				$rootScope.dismissTodo(type).then(function(resp) { }, function(error) { });

				$rootScope.userTag('PARENT_PRODUCT_DISCOVERY_MARKETPLACE', 'DONT_SHOW_AGAIN');

				switch(type) {
					case 'PARENT_PRODUCT_DISCOVERY_MARKETPLACE':
						$scope.showAppcueMarketplaceInfo = false;
						localStorage.setItem('PARENT_PRODUCT_DISCOVERY_MARKETPLACE', true);
						break;
				}
			}

			window.viewpostListener = $rootScope.$on('ON_POST_VIEW_OPEN', function(evt, args) {
				$rootScope.tempPosts = {
					scroll: document.documentElement.scrollTop || document.body.scrollTop,
					posts: $scope.listings,
					cursor: cursor
				};
			})

			if($rootScope.backFromPost && $rootScope.tempPosts && $rootScope.tempPosts.posts) {
				$rootScope.backFromPost = false;
				$scope.listings = $rootScope.tempPosts.posts;
				cursor = $rootScope.tempPosts.cursor;
				setTimeout(function() {
					window.scrollBy(0, $rootScope.tempPosts.scroll);
				}, 1);
			}
			else {
				$rootScope.tempPosts = null;
				$scope.listings = [];
			}

			var schoolId = $rootScope.active_school.id;
			var me = $rootScope.active_user;
			$scope.searchCat = $stateParams.value;

			$scope.userName = me.firstName+' '+me.lastName;
			$scope.viewState = {
				isReady:false,
				isInitiated:false
			}

			function getCategoryFromUrl(){
				var cat = window.location.href.split('/')[6];
				if (cat) {
					return cat.toLowerCase();
				}else{
					return 'none';
				}
			}
			
			$scope.activeCategory = getCategoryFromUrl()

			$scope.searchTxt = '';

			if($scope.searchCat)
				$scope.searchTxt = $translate.instant('POST_CAT_'+$scope.searchCat.toUpperCase()).replace(/&amp;/g, '&');
			
			if($scope.searchCat)
				$scope.selectedCategory = $scope.searchCat;

			$scope.events = {
				removeFromPosts: function(id){
					$scope.listings = $scope.listings.filter(function(el) {
						return el.id !==  id;
					});
				}
			}
			
			$scope.gotoListings = function(cat) {
				//Emese 19/09/17 - for callingwithout category
				if (_.isUndefined(cat)) {
					location.href = '#/listings/list/'
				}
				else {
					$rootScope.sListCategory = cat;

					// if(cat == 'lost_found')
					// 	location.href = '#/listings/lostlist/lost_found';
					// else
						location.href = '#/listings/list/' + cat;					
				}
			}

			$scope.openMobilePostWriter = function(category) {
				$rootScope.postingFrom = 'listings';
				
				//FIXME 
				//Adrian 11 APR 19, changed this
				var temp = localStorage.getItem('_draftMarketplace');
				if (temp) {
					var storedMkpItem = JSON.parse(temp)
					storedMkpItem.type = category;
					try{
						localStorage.setItem('_draftMarketplace', JSON.stringify(storedMkpItem));
					} catch(error){
						//skip for now...
					}	
				} else {
					try{
						localStorage.setItem('_draftMarketplace', JSON.stringify({ 
						ptaPercentage: 10, 
						currency: 'GBP',
						type: category ? category : ''
						}));	
					} catch(error){
						//skip for now...
					}
				}

				$state.go('composer_mkp.post');

				if($rootScope.isNative)
					$rootScope.userTag('POST_INIT_FROM_MARKETPLACE_PAGE_NATIVE');
				else
					$rootScope.userTag('POST_INIT_FROM_MARKETPLACE_PAGE_WEB_MOBILE');
			}

			$scope.events = {
				postCallback : function (post) {
					// var payload = {
					// 	'postedBy': me.firstName+' '+me.lastName,
					// 	'userId': me.id,
					// 	'avatar': me.avatar,
					// 	'postedOn': new Date(),
					// 	'body': post.body,
					// 	'photo': post.photo,
					// 	'isOwn': true,
					// 	'isLiked': false,
					// 	'likeCount': post.likeCount,
					// 	'commentCount': post.commentCount,
					// 	'groupId': post.groupId,
					// 	'groupName': post.groupName,
					// 	'id': post.id,
					// 	'type': post.type
					// };

					$scope.listings.unshift(post);
				},
				removeFromPosts: function(id){
					$scope.listings = $scope.listings.filter(function(el) {
						return el.id !==  id;
					});
				}
			}

			$scope.getListings = function () {
				$scope.getingListings = true;

				$scope.viewState.isReady = false;
				listingsService.get('marketplace/v1/' + schoolId + '/list/SEE_ALL/' + cursor + '/false', {'cache':false, 'xhr':true}).then(function(response){
					var data = response.data;
 
					if(data) {
						angular.forEach(data.items, function(k,v) {
							$scope.listings.push(k)
						});

						if(data.adPost) {
							data.adPost.isAdv = true;
							data.adPost.link = data.adPost.link;
							$scope.listings.push(data.adPost);
						}

						cursor = data.cursor || 0;
					}
					else {
						cursor = '';
					}	

					moreloading = false;

					$scope.viewState.isInitiated = true;
					$scope.viewState.isReady = true;

					$scope.getingListings = false;
				}, 
				function(error){
					$scope.viewState.isReady = true;
					$scope.getingListings = false;
				})
			};
			
			$scope.gotoHelp = function() {
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					backdrop:'static',
					templateUrl:'app/listings/views/help-modal.html',
					controller: function($scope) {
						$scope.close = function() {
							modalInstance.close();
							localStorage.setItem("mkp-go-to-help", true);
						};
					},
					size: 'md'
				})
			}

			$scope.openSearch = function() {
				$scope.searchTxt = '';
				$scope.searchOpened = !$scope.searchOpened;
			}

			$scope.hasMoreListings = function() {
				return cursor && cursor !== 0; 
			}

			$scope.searchByConstant = function(value) {
				$scope.searchTxt = $translate.instant('LISTING_CAT_' + value.toUpperCase()).replace(/&amp;/g, '&');
			}

			$scope.$watch('searchTxt', function(newvalue,oldvalue) {
				if(newvalue !== 'LISTING_CAT_') {
					if(newvalue !== oldvalue){

						if(newvalue.length > 2) {
							$window.scrollTo(0, 0);
							$scope.listings = [];
							$scope.viewState.isReady = false;
							cursor = '';
							
							listingsService.get('marketplace/v1/' + schoolId + '/search/' + encodeURIComponent(newvalue), { 'xhr': true} ).then(function(response) {
								
								$scope.viewState.isReady = true;
								$scope.listings = response.data.items;
							}, 
							function(error) {
								$scope.viewState.isReady = true;
							})
						}

						if(newvalue.length === 0) {
							cursor = 'none';
							$scope.listings = [];
							$scope.getListings();
						}
					}
				}
				else {
					$scope.listings = [];
					$scope.getListings();
				}
			});

			$scope.search = function(value) {
				$scope.viewState.isReady = false;
				cursor = 'none';

				listingsService.get('post/v1/' + schoolId + '/search/' + encodeURIComponent(value), { 'xhr': true} ).then(function(response) {
					$scope.viewState.isReady = true;
					$scope.viewState.isInitiated = true;
					var data = response.data;
					data ? $scope.listings = data.payload.posts : $scope.listings = [];
				}, 
				function(error) {
					$scope.viewState.isReady = true;
				})
			}

			if($stateParams.value) {
				$scope.search($stateParams.value);
			}
			else {
				if(!$rootScope.tempPosts || !$rootScope.tempPosts.posts)
					$scope.getListings();
			}
			
			if($rootScope.getQueryParam('open')) {
				$rootScope.gid = $rootScope.getQueryParam('gid');
				$scope.openMobilePostWriter();
			}
		}

		var doc = document.documentElement;
		$window.onscroll = function() {
			if($scope.getingListings)
				return;

			if($location.path().indexOf('/listings/list') > -1) {

				if(!$scope.hasMoreListings())
					return;

				var scrollPercent = (window.pageYOffset / (doc.scrollHeight - window.innerHeight)) * 100;
				if(scrollPercent >= 70) {
					if(moreloading)
						return;

					moreloading = true;

					$scope.getListings();
				}

				isElementInViewport(function(id, index) {
					if(!$scope.listings[index])
						return;

					if(!$scope.listings[index].isAdv)
						return;

					listingsService.get('shared/v1/hit/nextAdvert/' + $rootScope.active_school.id + '/' + $scope.listings[index].id + '/web_parent_marketplace_list', { 'xhr': true, 'cache': false }).then(function(response) {
						
					}, 
					function(error) {
						
					});
				})
			}
		};

		$scope.openPost = function(postId){
			window.location.href = "#/listings/" + postId;
		}
		
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.listings.edit',[]).controller('listingsEditController', listingsEditController);

	/** @ngInject */
	function listingsEditController($scope, $stateParams, listingsService, toastr, $translate, settings, $rootScope, regexes) {

		var listingId = $stateParams.id;

		$scope.viewState = {
			isReady : false,
			tlform:{},
			hasErrors: false,
			errors:{},
			sdOpen:false,
			edOpen:false,
			showForm1:false,
			showForm2:false,
			showForm3:false,
			startLaterEnd:false,
			startDateInPast:false,
			showEndDate:false,
			isSame:false
		};

		$scope.listing = {
			listingId:'',
			title:'',
			description:'',
			address:''
		}

		$scope.removePhoto = function(e){
			$scope.viewState.previewActive = false;
			$scope.listing.photoId = '';
			$scope.listing.imageURL = '';
			$scope.viewState.elform.$pristine = false;
			e.stopPropagation();
		}

		$scope.uploadImage = function () {
			$rootScope.$broadcast('UPLOAD_PHOTO', {
				'callback_fn':function(response){
					var url = listingsService.getPostImgBucketUrl() + '/' + response.data;
					$scope.listing.imageURL = url;
					$scope.viewState.previewActive = true;
					$scope.listing.photoId = response.data || '';
					$scope.viewState.elform.$pristine = false;
				},
				'action':'listingUpload',
				'config':'postCropper'
			});
		}

		$scope.viewState.previewActive = false;

		function removeLinks(text){
			var str = text.match(/("(https?:\/\/+))(.*?)"/gi);
			if (str !== null) {
				text = text.replace('[URL href=', '');
				text = text.replace(' target=\"_blank\"]', ' ');
				text = text.replace(regexes.closingTag, '');
				text = text.replace(str, '');
				for (var i = 0; i < str.length; i++) {
					text = text.replace('[URL href=', '');
					text = text.replace(' target=\"_blank\"]', ' ');
					text = text.replace(regexes.closingTag, '');
					text = text.replace(str[i], '');
				}	
				return text;
			} else {
				return text;
			}	
			
		}

		function getListing(){
			listingsService.get('post/v1/get/' + listingId, {'cache':false, 'xhr':true}).then(function(response){
				$scope.listing = response.data || [];
				$scope.listing.description = removeLinks($scope.listing.description);
				$scope.listing.listingId = listingId;
				$scope.listing.id = listingId;
				if($scope.listing.imageURL){
					$scope.viewState.previewActive = true;
				}

				if($scope.listing.price){

					if ($scope.listing.price % 1 !== 0){
						$scope.listing.price = $scope.listing.price.toFixed(2);
					}
				}
				$scope.viewState.isReady = true;
			}, function(error){
				$scope.viewState.isReady = true;
			})
		}

		getListing();

		$scope.updateListing = function () {
			var payload = angular.copy($scope.listing);
			payload.description = payload.description ? $rootScope.createEmailLinks(payload.description) : '';
			$scope.viewState.isReady = false;
			listingsService.put('post/v1/update', payload, {'xhr':true}).then(function(response){
				$scope.viewState.isReady = true;
				$scope.viewState.elform.$setPristine();
				toastr.info($translate.instant('UPDATE_SUCCESSFUL'));
			}, function (error) {
				$scope.viewState.isReady = true;
			})
		}

	}
})();

(function() {
	'use strict';

	angular.module('modules.listings.create',[]).factory('listingsCreateService', ['base', function (base) {
		return _.create(base, { });
	}]).controller('listingsCreateController', listingsCreateController);

	/** @ngInject */
	function listingsCreateController($scope, $state, regexes, $uibModal, settings, toastr, listingsService, $location, $anchorScroll, $timeout, $rootScope, $translate, $window) {
		$scope.regexes = regexes;
		$scope.routerState = $state;

		$scope.$watchGroup(['listing.title.length','listing.description.length','listing.location.length'], function() {
		checkListings()
	});

	function checkListings() {
		if ($scope.listing.title.length !== 0 || $scope.listing.description.length !== 0) {
				$rootScope.isDirty = true;
			}else {
				$rootScope.isDirty = false;
			}
	}

		$scope.viewState = {
			isReady : true,
			hasErrors: false,
			submitDisabled:false,
			errors:{},
			sdOpen:false,
			edOpen:false,
			showForm1:false,
			showForm2:false,
			showForm3:false,
			showForm4:false
		};

		$scope.togglePicker = function(str){
			$scope.viewState[str] = !$scope.viewState[str];
		};

		$scope.$watch(function() {
		return $state.$current.name
		}, function(){
			// Are we on the review page? Then make it dirty
			$state.$current.name.includes("review") ? $rootScope.isDirty = true : $rootScope.isDirty = false;
		})

		//Do not trigger the dialog on the back button
		$scope.addWatch = function(){
		if( !$scope.isWatchAdded ) {
			$scope.$watch('[]', function () {
			$rootScope.isDirty = true;
			});    
			$scope.isWatchAdded = true;
			}
		}

		// For leaving the review page
		$scope.cleanUp = function(){
			$rootScope.isDirty = false;
		}

		function openSuccessModal(id){
			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: 'backdrop-zindexed',
				backdrop:'static',
				templateUrl: 'app/listings/views/listing-success-modal.html',
				size:'sm',
				controller: function($scope){
					$scope.id = id;
					$scope.close = function(){
						modalInstance.close();
					};
				}
			})
		}

		$scope.gotoAnchor('listings.create.typecategory',0);
	}

})();

(function() {
	'use strict';

	angular.module('modules.invite',[]).factory('inviteService', ['base', function (base) {
		return _.create(base, { });
	}]).controller('inviteController', inviteController);

	/** @ngInject */
	function inviteController(baseService, $scope, $window, toastr, $translate, inviteService, settings, $rootScope, gaService, $uibModal) {
		$scope.pressCopyLink = function() {
			$rootScope.copyToClipboard($scope.link);
			toastr.info($translate.instant('LINK_COPIED'));
			$rootScope.userTag('PARENT_INVITED', "BY_LINK:"+$scope.link);
		}

		$scope.copyLink = function() {
			$rootScope.userTag('PARENT_INVITED', "BY_LINK:"+$scope.link);
			$rootScope.copyToClipboard($scope.link);
			toastr.info($translate.instant('LINK_COPIED'));
		}

		$scope.shareWhatsapp = function() {
			$rootScope.userTag('PARENT_INVITED', "BY_LINK:"+$scope.link);
			var toShare = encodeURIComponent($scope.link_message + ' ' + $scope.link);

			if (!$rootScope.isNative){
				window.open("https://web.whatsapp.com/send?text=" + toShare, "_blank");
			}else{
				$rootScope.openWhatsappNative(toShare);
			}
		}

		$scope.shareFacebook = function() {
			$rootScope.userTag('PARENT_INVITED', "BY_LINK:"+$scope.link);
			var toShare = $scope.link;

			if (!$rootScope.isNative){
				window.open('https://www.facebook.com/sharer/sharer.php?u=' +toShare, '_blank');
			} else {
				$rootScope.openFacebookNative(encodeURIComponent(toShare));
			}

		}

		$scope.gotoInviteMail = function() {
			if($rootScope.active_school.admin){
				var modalInstance = $uibModal.open({
					animation: true,
					templateUrl: 'app/invite/views/admin-invite-parents.html',
					backdropClass: 'backdrop-zindexed',
					backdrop: 'static',
					size:'sm',
					controller: function($scope) {
						$scope.stay = function() {
							modalInstance.close();
						}
						$scope.close = function() {
							$rootScope.switchApps('#/invite/add-invite');
						}
					}
				})
			} else location.href = '#/invite/email';
		}

		$scope.nextInvite = function() {
			$rootScope._emails = $scope.emails;
			location.href = '#/invite/email/message';
		}

		$scope.getInviteLink = function(success) {
			baseService.get('parent/v1/invite/link/'+ $rootScope.active_school.id, {'cache': false}).then(function(response) {
				if(success)
					success(response.data.payload);
			}, 
			function(error){
				return null;
			});
		}

		baseService.app_initialized = function(evt, args) {
			$scope.isNative = getIfNative();
			$scope.facebookHTML = '';

			if(location.href.indexOf('/invite/email/message') > -1 && !$rootScope._emails)
				location.href = '#/invite';

			$scope.viewState = {
				isReady : true
			}

			$scope.getInviteLink(function(res) {
				$scope.link = res.url;
				$scope.link_message = res.message;
			})

			setTimeout(function() {
				$scope.defaultText = $translate.instant('INVITE_PARENTS_PLACEHOLDER');
				$scope.message = $scope.defaultText;
				$scope.inviteParentsPlaceholder = $translate.instant('INVITE_PARENTS_PHOLDER_M');
	
				if(window.innerWidth > 768) {
					$scope.inviteParentsPlaceholder = $translate.instant('INVITE_PARENTS_PHOLDER');
				}
				$scope.$apply();
			}, 100);

			//watch if there is change on the email field
			$scope.$watch('emails', function() {
				checkEmails();
			});

			$scope.back = function(){
				if ($window.history.length > 2){
					$window.history.back();
				}else{
					$window.location.href = "/parent/";
				}
			}

			function checkEmails() {
				var emailsLength;
				_.isUndefined($rootScope._emails) ? emailsLength = 0 : emailsLength = $rootScope._emails.length;
				emailsLength !== 0 ? $rootScope.isDirty = true : $rootScope.isDirty = false;

				if(!$scope.emails)
					return

				var emails_count = 0;
				var emails_split = $scope.emails.split(/[ ,]+/);

				if(!emails_split) {
					$scope.emailsCount = null;
					return;
				}

				for(var i = 0; i < emails_split.length; i++) {
					if(validateEmail(emails_split[i])) {
						emails_count += 1;
					}
				}

				$scope.emailsCount = emails_count;
			}
			
			$scope.shareMobile = function() {
				$rootScope.userTag('PARENT_CLICK_INVITE_MOBILE')

				inviteService.get('parent/v1/invite/link/'+ $rootScope.active_school.id, {'cache': false}).then(function(response){
					var whatToShare = encodeURIComponent(response.data.payload.message + " ") + encodeURIComponent(response.data.payload.url);

					if(getMobileOperatingSystem() === 'iOS') {
						window.location = 'classlistnativeparent://share/' + whatToShare;
					}
					else if (getMobileOperatingSystem() === 'Android') {
						if (window.AndroidBridge) {
							window.AndroidBridge.share(whatToShare);
							gaService.send("/parent/invite/native/android");
						}
					}
				},
				function(error){
					gaService.send("/parent/invite/native/error");
				});
			}

			$scope.invite = function() {
				if(!($rootScope._emails.length === 0 ||  $scope.message.length === 0 )) {	
					$scope.viewState.isReady = false;

					gaService.send("/parent/invite/emails/"+$rootScope._emails.length);

					$scope.sending = true;
					inviteService.post('parent/v1/invite/parents',{
						'schoolId':$rootScope.active_school.id,
						'emails':$rootScope._emails,
						'welcomeMessage':$scope.message
					},{})
					.then(function(response) {
						$scope.sending = false;
						var invited_count = response.data.payload.count;

						var modalInstance = $uibModal.open({
							animation: true,
							templateUrl: 'app/invite/views/success-invite-modal.html',
							backdropClass: 'backdrop-zindexed',
							backdrop: 'static',
							size:'sm',
							controller: function($scope) {
								$scope.invited_count = invited_count;

								$scope.close = function() {
									location.href = '#/classlist/all/-3';
								}
							}
						})

						$rootScope._emails = '';
						$scope.isClicked = 0;
						$scope.viewState.isReady = true;
						gaService.send("/parent/invite/emails/success");
					}, 
					function(error) {
						$scope.sending = false;
						gaService.send("/parent/invite/emails/failed");
						(error.status !== -1 ) ? toastr.error($translate.instant('INVITE_PARENTS_FAIL')) : _.noop();
						$scope.viewState.isReady = true;
					});
				}
			}
		}
		
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.inbox.view',[]).controller('inboxViewController', inboxViewController);

	/** @ngInject */
	function inboxViewController($scope, baseService, $rootScope, $stateParams, $uibModal, metadata, inboxService, regexes, $state, toastr, $translate, $window) {
		$scope.regexes = regexes;
		$scope.mediaList = new Array()
		var relationships = { };
		$scope.conversation = {
			messages:[],
			subject:''
		};
		$scope.creator = {
			id: '',
			firstName: '',
			lastName: '',
			avatar: ''
		};

		$scope.participants = [];
		$scope.body = '';
		$scope.viewState = {
			isReady:false
		};
		var cursor = '';
		$scope.canScrollBottom = true;
		var listener;
		var mess_listener;
		$scope.draftMessage = {};

		$scope.scrollToBottom = function() {
			if(location.href.indexOf('#/inbox/view') > -1) {
				if($scope.canScrollBottom) {
					window.scrollTo(0, document.body.scrollHeight);
				}
			}
		}

		// TODO: check in Dec 2018 and remove the function and references
		$scope.showOnlyNewDateTicks = function(date) {
			var d1 = new Date(date)
			var d2 = new Date('08/01/2018')
			return d1 > d2
		}
			
		function getMessages(id, smooth) {
			inboxService.get('parent/v1/conversationV2/' + id + '/messages/list', { }).then(function (response) {
				$scope.viewState.isReady = true;
				
				if (!_.isUndefined(response)) {
					var data = response.data;

					if(response.data.messages)
						for (var i = 0; i < response.data.messages.length; i++) {
							response.data.messages[i].body = $rootScope.parseTagsToLinks(response.data.messages[i].body);
							if(response.data.messages[i].replyTo) {
								response.data.messages[i].replyTo.body = $rootScope.parseTagsToLinks(response.data.messages[i].replyTo.body);
							}
						}

					$rootScope.message_data = data;

					if(data.messages)
						$scope.conversation.messages = data.messages;

					if(data.participants)
						$scope.participants = data.participants;
			
					$scope.sample = data.sample;
					$scope.conversation.subject = data.subject;
					$scope.conversation.mine = data.mine;

					cursor = data.cursor || '';

					setTimeout(function() {
						var _a = document.getElementsByClassName('conversation-message-list')[0];

						if(_a && document.body) {
							if(_a.offsetHeight >= (document.body.offsetHeight - 100 - 70 - 50 - 80)) {
								animate(document.scrollingElement || document.documentElement, "scrollTop", "", window.pageYOffset, document.body.scrollHeight, 200, true);
							}
						}
					}, 100);

					setTimeout(function() {
						$scope.canScrollBottom = false;
					}, 500);
					
					$scope.messagesloaded = true;
				}
			}, 
			function (error) {
				$scope.messagesloaded = true;
			})
		}

		mess_listener = $rootScope.$on('ON_SOCKET_MESSAGE', function(evt, args) {
			getMessages($stateParams.id, true);
		})

		baseService.app_initialized = function(evt, args) {
			$scope.messagesloaded = false;
			getMessages($stateParams.id);

			$rootScope.$on('UPDATE_MESSAGES',function(evt,args) { 
				$scope.messagesloaded = false;
				getMessages($stateParams.id);
			});
			
			// Init the beforeunlodpage on this page
			var onBeforeunload = $rootScope.$on('inbox.view', function(evt, args) {
				var anychange = $scope.body ? true : false;
				
				if(anychange) {
					var modalInstance = $uibModal.open({
						animation: true,
						scope: $scope,
						backdropClass: 'backdrop-zindexed',
						templateUrl: 'app/base/views/window-beforeleave-modal.html',
						size:'md',
						controller: function($scope) {
							$scope.leave = function() {
								onBeforeunload();
								$state.go(args.toState.name, args.toParams);
							}
							$scope.stay = function() {
								modalInstance.close();
							};
						}
					})

					args.e.preventDefault();
				}
				else {
					onBeforeunload();
				}
			});

			function addParticipants(arr) {
				$scope.viewState.isReady = false;
				
				inboxService.put('parent/v1/conversation/'+$stateParams.id+'/add/participants', {
					'conversationId':$stateParams.id,
					'participants': _.map(arr, 'id')
				}, 
				{ })
				.then(function(response) {
					$scope.viewState.isReady = true;
					$scope.messagesloaded = false;
					getMessages($stateParams.id);
				}, 
				function(error) {
					$scope.viewState.isReady = true;
					
				})
			}
			
			_.each(metadata.data.metadata.relationships, function (obj, index) {
				relationships[obj.id] = obj.longName;
			});
			
			$rootScope.nameRelation = function (_id) {
				return relationships[_id]
			};

			
			listener = $rootScope.$on('ON_PICK_CONTACT', function(evt, args) {
				// var user = {
				// 	avatar: $rootScope.contacts_list.baseUrl + args.contact.id,
				// 	firstName: args.contact.fN,
				// 	lastName: args.contact.lN,
				// 	id: args.contact.id,
				// 	type: 'user'
				// };

				// addParticipants([user])
			})

			$scope.openAddParticipantsModal	= function() {
				$scope.$emit('PICK_CONTACT', {
					simple: true
				});
			};
			
			$scope.openMarketplacePost = function(postId){
				window.location.href = "#/listings/" + postId;
			}

			$scope.openPicture = function(c) {

				if($rootScope.isNative) {
					$scope.mess_pictures = new Array()
					$scope.mess_pictures.push(c.url)

					for(var i = 0; i < $scope.conversation.messages.length; i++) {
						var mess = $scope.conversation.messages[i];
						
						if(!mess.file)
							continue;
						
						if(mess.id === c.id_message)
							continue;

						if(mess.file.ext) {
							if(mess.file.ext.toLowerCase() !== 'png' 
								&& mess.file.ext.toLowerCase() !== 'gif' 
								&& mess.file.ext.toLowerCase() !== 'bmp' 
								&& mess.file.ext.toLowerCase() !== 'jpg' 
								&& mess.file.ext.toLowerCase() !== 'jpeg')
								continue;
						}

						$scope.mess_pictures.push(mess.file.url)
					}
					
					previewImages($scope.mess_pictures)
				}
				else {
					window.open(c.url + '=s0', '_blank')
				}
			}

			$scope.infoConversation = function() {
				location.href = '#/inbox/info/' + $rootScope.message_data.id;
			}

			$scope.beforeAddToConversation = function() {
				var anychange = $scope.body ? true : false;
				
				if(anychange) {
					var modalInstance = $uibModal.open({
						animation: true,
						scope: $scope,
						backdropClass: 'backdrop-zindexed',
						templateUrl: 'app/base/views/window-beforeleave-modal.html',
						size:'md',
						controller: function() {
							$scope.leave = function() {
								modalInstance.close();
								$scope.body = '';
								$scope.addToConversation()
							}
							$scope.stay = function() {
								modalInstance.close();
							};
						}
					})
				}
				else {
					$scope.addToConversation()
				}
			}

			$scope.addToConversation = function() {
				inboxService.get('parent/v1/conversation/' + $stateParams.id + '/participants',{'cache':false}).then(function (response) {
					if(!response.data)
						return;

					for(var i = 0; i < response.data.participants.length; i++) {
						if(response.data.participants[i].id !== $rootScope.active_user.id)
							$rootScope.temp_mess_contacts.push(response.data.participants[i])
					}

					if($rootScope.contacts_list) {
						for(var i = 0; i < $rootScope.contacts_list.parents.length; i++) {
							for(var j = 0; j < response.data.participants.length; j++) {
								if($rootScope.contacts_list.parents[i].id === response.data.participants[j].id) {
									$rootScope.contacts_list.parents[i].selected = true;
								}
							}
						}
					}

					$rootScope.resizeContactsList();
			
				}, function (error) {
					
				})

				$scope.createNewMessage(1)
			}

			$scope.goback = function() {
				if ($window.history.length > 2) {
					$window.history.back();
				} 
				else {
					$window.location.href = "/parent/#/inbox/list";
				}
			}

			$scope.back = function() { 
				if((!$scope.conversation.messages || $scope.conversation.messages.length === 0)
					&& ($scope.conversation.mine)) {
					inboxService.get('parent/v1/conversation/' + $stateParams.id + '/discard', { }).then(function(response) {
						$scope.goback()
					}, 
					function(error) {
						$scope.goback()
					})
				}
				else {
					$scope.goback()
				}
			}

			$scope.checkBodyLength = function(m) {
				var isMore = false;
				if(m.body){
					var isMore = m.body.length > 800;	
				}
				return isMore && !m.expanded;
			}

			$scope.expandBody = function(m) {
				m.expanded = true;
			}

			$scope.leaveConversation = function() {
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/inbox/views/leave.conversation.html',
					
					controller: function($scope){
						$scope.viewState = {
							isReady:true
						};

						$scope.close = function() {
							modalInstance.close();
						};

						$scope.leave = function() {
							//removeConversation($stateParams.id);
							modalInstance.close();

							inboxService.get('parent/v1/conversation/' + $stateParams.id + '/leave', { }).then(function(response) {
								location.href = '#/inbox/list';
							}, 
							function(error) {
								location.href = '#/inbox/list';
							})	
						}
					
					},
					size: 'sm'
				});
			}

			$scope.checkGoProfile = function(parent) {
				$scope.infoConversation()
			}

			$scope.quote = function(message) {
				$scope.replyTo = message;
				document.querySelector('#message-body').focus();
				$scope.setDraft();
			}

			$scope.discardQuote = function() {
				$scope.replyTo = null;
			}

            $scope.setDraft = function() {
                var draftMessage = {
                    body: $scope.body,
                    createdAt: new Date().getTime(),
                    messageId: $stateParams.id
                };
				if ($scope.replyTo) {
					draftMessage.replyTo = $scope.replyTo;
				}
                localStorage.setItem("draftMessage", JSON.stringify(draftMessage));
            }

            var draft = localStorage.getItem("draftMessage");
            if(draft) {
                var draftMessage = JSON.parse(draft);
                var time = new Date().getTime() - 24 * 60 * 60 * 1000; // now - 24 hours in miliseconds
                if(time > draftMessage.createdAt) {
                    localStorage.removeItem("draftMessage");
                    $scope.draftMessage.body = '';
                } else if($stateParams.id === draftMessage.messageId) {
                    $scope.body = draftMessage.body;
                    $scope.draftMessage = draftMessage;
					if (draftMessage.replyTo) {
						$scope.replyTo = draftMessage.replyTo;
					}
                }
            } else {
                $scope.draftMessage.body = '';
            }

			function virtualUpdate(_body, file) {
				var a = {
					senderId: $rootScope.active_user.id,
					senderFirstName: $rootScope.active_user.firstName,
					senderLastName: $rootScope.active_user.lastName,
					timestamp: new Date(),
					body:_body,
					senderAvatar: $rootScope.active_user.avatar,
					sending: true
				};

				if(file)
					a.file = file;

				$scope.conversation.messages.push(a);

				return a;
			}
			
			$scope.$on('UPLOAD_MESSAGE_READY', function(event, args) {
				if(args.files) {
					if(args.files.length > 0) {
						$scope.mediaList = args.files || new Array();
						$scope.body = args.caption;
						$scope.send();
					}
				}
			})
			
			$rootScope.$on('ON_SOCKET_READ_MESSAGE', function(evt, args) {
				for(var i = 0; i < $scope.conversation.messages.length; i++) {
					$scope.conversation.messages[i].read = true;
				}
				
				setTimeout(function() {
					$scope.$apply()
				}, 7);
			})
			
			$scope.send = function (id) {
				if(!$rootScope.message_data)
					return;
 
				if($rootScope.message_data && $rootScope.message_data.participantsSize === 1) {
					var modalInstance = $uibModal.open({
						animation: true,
						scope: $scope,
						backdropClass: 'backdrop-zindexed',
						templateUrl: 'app/inbox/views/no-participants-modal.html',
						size:'md',
						controller: function($scope) {
							$scope.close = function() {
								modalInstance.close();
							};
						}
					})

					$scope.body = '';
					return;
				}

				if($scope.sendingMessage)
					return;
					
				if(!$scope.body && !$scope.mediaList)
					return;

				var body = angular.copy($scope.body);

				var payload = {
					'body': body ? $rootScope.createEmailLinks(body) : '',
					'conversationId': $stateParams.id
				};

				if($scope.mediaList.length > 0) {
					payload.attachmentId = $scope.mediaList[0].file_id;
					payload.fileName = $scope.mediaList[0].name;
					payload.width = $scope.mediaList[0].width;
					payload.height = $scope.mediaList[0].height;
				}

				if(body)
					body = $rootScope.createEmailLinks(body);
					
				var a;
				if($scope.mediaList.length > 0) {
					a = virtualUpdate($rootScope.parseTagsToLinks(body), {
						url: $scope.mediaList[0].src,
						width: $scope.mediaList[0].width,
						height: $scope.mediaList[0].height,
						ext: $scope.mediaList[0].ext,
						name: $scope.mediaList[0].name
					});
				}
				else {
					a = virtualUpdate($rootScope.parseTagsToLinks(body))
				}

				if($scope.replyTo) {
					payload.replyTo = $scope.replyTo.id;
					a.replyTo = $scope.replyTo;
				}
				
				setTimeout(function() {
					var _a = document.getElementsByClassName('conversation-message-list')[0];

					if(_a && document.body) {
						if(_a.offsetHeight >= (document.body.offsetHeight - 100 - 70 - 50 - 80)) {
							animate(document.scrollingElement || document.documentElement, "scrollTop", "", window.pageYOffset, document.body.scrollHeight, 200, true);
						}
					}

					$scope.body = '';
				}, 100);

				$scope.sendingMessage = true;
				inboxService.post('parent/v1/conversation/' + $stateParams.id + '/reply', payload).then(function (response) {
					$scope.sendingMessage = false;
					$scope.mediaList = new Array()
					a.sending = false;
					$scope.replyTo = null;
					localStorage.removeItem("draftMessage");

					for(var i = 0; i < $scope.conversation.messages.length; i++) {
						if(!$scope.conversation.messages[i].id && !$scope.conversation.messages[i].body) {
							response.data.justsent = true;
							$scope.conversation.messages[i] = response.data;
						}
					}
				}, 
				function(error) {
					//toastr.info($translate.instant('ERROR_OFFLINE'));
					$scope.conversation.messages.splice($scope.conversation.messages.length - 1, 1);
					$scope.sendingMessage = false;
					console.error(error);
				
					setTimeout(function() {
						$scope.body = body;
					}, 200);
				});

				setTimeout(function() {
					document.getElementById("message-body").style.height = 'auto';
					
					if($scope.mediaList.length === 0)
						document.getElementById("message-body").focus();
				}, 10);
			}

			$scope.buildMedia = function(c) {
				if(!c.file)
					return;

				var url = c.file.url;
				var ext = c.file.ext;
				var name = c.file.name;
				//var portrait = c.file.width;
				var result = { }
				var new_url;

				result.id_message = c.id;

				if(url) {
					result.url = url;
					result.ext = ext;
					result.name = name;
					result.doctype = 1;
					new_url = url.split('_')

					if(new_url.length > 1) {
						new_url = new_url[1].split('x')

						if(new_url.length > 1) {
							if(parseInt(new_url[0]) > parseInt(new_url[1])) {
								result.isportrait = true;
							}
							else {
								result.isportrait = false;
							}
						}
					}
				}
				
				if(ext) {
					switch(ext.toLowerCase()) {
						default:
							break;
						case 'png':
						case 'gif': 
						case 'bmp': 
						case 'jpg': 
						case 'jpeg': 
							result.doctype = 2;
							break;
					}
				}
 
				return result;
			};

		}//END OF APP INIT
		
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}

		$scope.$on('$destroy', function () {
			if (listener)
			listener(); 
			if(mess_listener)
				mess_listener();
		});
	}
})();

(function() {
	'use strict';

	angular.module('modules.inbox.manageparticipants',[]).factory('inboxParticipantService', ['base', function (base) {
		return _.create(base, {

		});
	}]).directive('addParticipants', addParticipants);
	/** @ngInject */
	function addParticipants($uibModal, $translate, $rootScope, storage, inboxParticipantService, toastr) {

		var directive = {
			restrict: 'EA',
			replace: false,
			link: linkFunction
		};

		return directive;

		function linkFunction(scope) {

			scope.$on('ADD_PARTICIPANT', function(evt, args) {

				var modalInstance = $uibModal.open({
					animation: true,
					templateUrl: 'app/inbox/views/inbox.participant.module.html',
					backdropClass: 'backdrop-zindexed',
					controller: function ($scope) {
						$scope.schoolId = args.schoolId;
						$scope.participants = angular.copy(args.participants) || [];
						$scope.showTiers = args.eventContext ? true : false;
						$scope.eventContext = args.eventContext;

						$scope.close = function(){
							modalInstance.close();
						};

						$scope.save = function(){
							if(args.addBulk){
								args.callback($scope.participants)
								$rootScope.$broadcast('UPDATE_PARTICIPANTS', $scope.participants);
							} else {
								_.each($scope.participants, function(item){
									args.callback(item);
								})
								$rootScope.$broadcast('UPDATE_PARTICIPANTS', $scope.participants);
							}
							modalInstance.close();
						}

					},
					size: 'md'
				});
			})
		}

	}

})();

(function() {
	'use strict';

	angular.module('modules.inbox',[]).factory('inboxService', ['base', function (base) {
		return _.create(base, { });
	}]).controller('inboxController', inboxController);

	/** @ngInject */
	function inboxController($scope, baseService, $state, $rootScope, $timeout, $uibModal, storage, uploadService, classlistService, toastr, $translate, metadata) {
		$scope._participants;
		var relationships = { };

		_.each(metadata.data.metadata.relationships, function (obj, index) {
			relationships[obj.id] = obj.longName;
		});

		$rootScope.nameRelation = function (_id) {
			return relationships[_id]
		};
		
		// var leftpane = angular.element(document.getElementById('leftpane')),
		// 		rightpane = angular.element(document.getElementById('rightpane'));
		baseService.app_initialized = function(evt, args) {

		function toggle(visible) {
			// if(visible === 'left') {
			// 	leftpane.removeClass('hidden-sm').removeClass('hidden-xs');
			// 	rightpane.addClass('hidden-sm').addClass('hidden-xs');
			// } 
			// else {
			// 	rightpane.removeClass('hidden-sm').removeClass('hidden-xs');
			// 	leftpane.addClass('hidden-sm').addClass('hidden-xs');
			// }
			
			$timeout(function() {
				$rootScope.$broadcast('RERENDER_CONVERSATIONS_LIST', { });
			}, 0);
		}

		$scope.isThisYear = function(date) {
			var now = new Date();
			var curr = new Date(date);
			return now.getFullYear() === curr.getFullYear()
		}

		var fileUploader = document.getElementById('messageUploader');
		$scope.galleryUpload = function(participants, body) {
			
			if($rootScope.message_data && $rootScope.message_data.participantsSize === 1) {
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/inbox/views/no-participants-modal.html',
					size:'md',
					controller: function($scope) {
						$scope.close = function() {
							modalInstance.close();
						};
					}
				})

				$scope.body = '';
				return;
			}

			$scope._body = '';

			if(body)
				$scope._body = body;

			$scope._participants = participants;
			fileUploader.removeAttribute('capture')
			fileUploader.setAttribute('accept', 'image/*')
			fileUploader.click();
		}

		$scope.cameraUpload = function(participants, body) {

			if($rootScope.message_data && $rootScope.message_data.participantsSize === 1) {
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/inbox/views/no-participants-modal.html',
					size:'md',
					controller: function($scope) {
						$scope.close = function() {
							modalInstance.close();
						};
					}
				})

				$scope.body = '';
				return;
			}

			$scope._body = '';

			if(body)
				$scope._body = body;

			$scope._participants = participants;
			fileUploader.setAttribute('accept', 'image/*')
			fileUploader.setAttribute('capture', '')
			fileUploader.click();
		}

		$scope.attachmentUpload = function(participants, body) {

			if($rootScope.message_data && $rootScope.message_data.participantsSize === 1) {
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/inbox/views/no-participants-modal.html',
					size:'md',
					controller: function($scope) {
						$scope.close = function() {
							modalInstance.close();
						};
					}
				})

				$scope.body = '';
				return;
			}

			$scope._body = '';

			if(body)
				$scope._body = body;

			$scope._participants = participants;
			fileUploader.removeAttribute('accept')
			fileUploader.removeAttribute('capture')
			fileUploader.click();
		}
		
		$scope.isPortrait = function(c) {
			if(!c.file)
				return false;

			if(!c.file.width || !c.file.height)
				return false;
				
			return parseInt(c.file.height) > parseInt(c.file.width)
		}

		$scope.loadContacts = function() {
			if(!localStorage.getItem('__c5') || (localStorage.getItem('__c4') && localStorage.getItem('__c4').b64decode() !== $rootScope.active_school.id))  {
				// continue
			}
			else {
				return;
			}
				
			classlistService.get('parent/v1/'+$rootScope.active_school.id+'/listV2/classlist',{'cache':false})
			.then(function (response) {
				var data = response.data;

				$scope.noPupils = data.np;
				
				if($scope.noPupils) {
					if($scope.nopupilsshowed)
						return;

					$scope.nopupilsshowed = true;
					var modalInstance = $uibModal.open({
						animation: true,
						backdrop: 'static',
						backdropClass: 'backdrop-zindexed',
						templateUrl: 'app/classlist/views/no-pupil-modal.html',
						size:'sm',
						controller: function($scope) {
							
							$scope.close = function() {
								modalInstance.close();
							};
						}
					})
				}
				
				var contacts_map = [];
				if(data.parents) {
					for(var i = 0; i < data.parents.length; i++) {
						var p = data.parents[i];
						if(p.rM)
							contacts_map.push(p);
					}

					try {
						localStorage.setItem('__c5', JSON.stringify(data).b64encode());
						localStorage.setItem('__c6', JSON.stringify(contacts_map).b64encode());
					} 
					catch(ex) {
						//Skip for now.
					}

					if(!localStorage.getItem('__c4') || localStorage.getItem('__c4').b64decode() !== $rootScope.active_school.id) {
						localStorage.setItem('__c4', $rootScope.active_school.id.b64decode());
					}

					if(localStorage.getItem('__c5')) {
						$rootScope.contacts_list = JSON.parse(localStorage.getItem('__c5').b64decode());
					}
				}
				else {
					localStorage.setItem('__c5', '');
					localStorage.setItem('__c6', '');
				}

			}, function (error) {
				//$scope.loadingContacts = false;
			});
		}

		$scope.loadContacts()

		$scope.filesToSend = new Array()
		fileUploader.onchange = function() {
			var file = fileUploader.files[0],
				reader = new FileReader();

			if (file) {
				if(file.type.indexOf('image') > -1) {
					var _URL = window.URL || window.webkitURL;
					var img = new Image();
					
					img.onload = function () {
						window.EXIF.getData(img, function () {
							var orientation = EXIF.getTag(this, "Orientation");
							var canvas = document.createElement('canvas'),
								context;

							var aratio = calculateAspectRatioFit(
								img.width,
								img.height,
								1200,
								1200);

							context = canvas.getContext('2d');
							canvas.width = aratio.width;
							canvas.height = aratio.height;
							var x = 0;
							var y = 0;
							if (orientation !== 'undefined') {
								
								/*if (orientation > 4) {
									canvas.width = aratio.height;
									canvas.height = aratio.width;
								}

								switch (orientation) {
									case 2:
										context.translate(canvas.width, 0);
										context.scale(-1, 1);
										break;
									case 3:
										context.translate(canvas.width, canvas.height);
										context.rotate(Math.PI);
										break;
									case 4:
										context.translate(0, canvas.height);
										context.scale(1, -1);
										break;
									case 5:
										context.rotate(0.5 * Math.PI);
										context.scale(1, -1);
										break;
									case 6:
										context.rotate(0.5 * Math.PI);
										context.translate(0, -canvas.height);
										y = canvas.height - canvas.width;
										break;
									case 7:
										context.rotate(0.5 * Math.PI);
										context.translate(canvas.width, -canvas.height);
										context.scale(-1, 1);
										y = canvas.height - canvas.width;
										x = canvas.width - canvas.height;
										break;
									case 8:
										context.rotate(-0.5 * Math.PI);
										context.translate(-canvas.width, 0);
										x = canvas.width - canvas.height;
										break;
								}*/
								context.drawImage(img, x, y, aratio.width, aratio.height);
								context.restore();
								reader.readAsDataURL(file);
								reader.addEventListener('load', function (e) {
								$scope.filesToSend = new Array();

									$scope.filesToSend.push({
									width: canvas.width,
										height: canvas.height,
										name: file.name,
										ext: file.name.split('.').pop(),
										type: file.type,
										src: canvas.toDataURL('image/jpeg', 100),
										url: URL.createObjectURL(file),  
										blob: dataURItoBlob(canvas.toDataURL('image/jpeg', 100))
								})

								$scope.previewMedia($scope.filesToSend[0])
							}, false); 
							}
						});
					};
					img.src = _URL.createObjectURL(file);
				}
				else {
					reader.readAsDataURL(file);

					if(file.size > 8000000) {
						toastr.info($translate.instant('FILE_SIZE_TOO_BIG'));
						return;
					}

					reader.addEventListener('load', function (e) {
						$scope.filesToSend = new Array();
						$scope.filesToSend.push({
							name: file.name,
							ext: file.name.split('.').pop(),
							type: file.type,
							src: e.target.result,
							url: URL.createObjectURL(file), 
							blob: dataURItoBlob(reader.result)
						})

						$scope.previewMedia($scope.filesToSend[0])

					}, false);
				}
			}

			setTimeout(function() {
				fileUploader.value = '';
			}, 1000);
		}

		$scope.sendMedia = function(success, fail) {
			$scope.isUploading = true;

			uploadService.fileUpload($scope.filesToSend[0].blob, {
				headers: {
					'Content-Type': undefined,
					'ClasslistToken': storage.getToken() || '',
					'ClasslistCfg': angular.toJson({
						'type':'ATTACHMENT'
					})
				}
			}, $scope.filesToSend[0].name)
			.then(function(response) {
				$scope.isUploading = false;
				$scope.filesToSend[0].file_id = response.data;

				if(success)
					success()
			}, 
			function(error) {
				if (error.status === 403 || error.status === 409) {
					toastr.error($translate.instant(error.data));
				}
				else {
					console.error(error);
					// toastr.info($translate.instant('ERROR_OFFLINE'));
				}

				if(fail)
					fail()

				$scope.isUploading = false;
				
				setTimeout(function() {
					$scope.previewMedia($scope.filesToSend[0]);
				}, 200);
			});
		}

		$scope.previewMedia = function(data) {
			switch(data.type) {
				case 'image/gif':
				case 'image/jpeg':
				case 'image/png':
					data.isimage = true;
					break;
			} 
			
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				templateUrl: 'app/inbox/views/upload-preview-modal.html',
				backdropClass: 'backdrop-zindexed',
				size:'md',
				controller: function() {
					$scope.preview_object = data;
					$scope.preview_object.caption = '';
					
					if($scope._body)
						$scope.preview_object.caption = $scope._body;
					
					$scope.sendfile = function() {
						$scope.sendMedia(function() {
							$scope.$broadcast('UPLOAD_MESSAGE_READY', {
								files: $scope.filesToSend,
								caption: $scope.preview_object.caption
							});
						});
						modalInstance.close();
						
						setTimeout(function() {
							window.scrollTo(0, document.body.scrollHeight);
						}, 100);
					}

					$scope.close = function() {
						modalInstance.close();

						setTimeout(function() {
							window.scrollTo(0, document.body.scrollHeight);
						}, 100);
					}
				}
			})
		}

		$scope.$on('VIEW_CHANGED', function(evt,args) {
			if (matchMedia('only screen and (max-width: 992px)').matches) {
				if(args.to.name === 'inbox.view' && args.toParams.id !== null ) {
					toggle('right');
				}

				if(args.to.name === 'inbox') {
					toggle('left');
				}
			}
		});

		angular.element(window).bind('resize', function() {
			var st = $state;
			if (matchMedia('only screen and (max-width: 992px)').matches) {
				if(st.current.name === 'inbox.view' && st.params.id !== null ) {
					toggle('right');
				}
			
				if(st.current.name === 'inbox') {
					toggle('left');
				}
			}
		});

		if($state.current.name === 'inbox') {
			//if (matchMedia('only screen and (max-width: 992px)').matches) {
				toggle('left');
			//}
		}
		if($state.current.name === 'inbox.view') {
			//if (matchMedia('only screen and (max-width: 992px)').matches) {
				toggle('right');
			//}
		}

		$scope.beforeNewMessage = function() {
			$scope.iscreating = true;
		}

		$scope.cancelCreate = function() {
			$scope.iscreating = false;
		}

		$scope.createNewMessage = function(type) {
			var options = { reload: false };
			
			if(window.innerWidth < 991)
				options.reload = true;

			$rootScope.new_message_type = type;
			$rootScope.temp_mess_contacts = [];

			if($rootScope.contacts_list) {
				for(var i = 0; i < $rootScope.contacts_list.parents.length; i++) {
					$rootScope.contacts_list.parents[i].selected = false;
				}
			}

			$rootScope.selectedContactsFilter.load_search_contacts_index = 1;

			$scope.$emit('PICK_CONTACT', {
				simple: true
			});

			$rootScope.selectedContactsFilter.keyword = '';
			$rootScope.selectedContactsFilter.select = 0;
			
			//$rootScope.$broadcast('NEW_CONVERSATION', {delay: 0});
			//storage.del('newMessage', true);
			//storage.del('newParticipants', true);

			setTimeout(function() {
				var contacts_scroll = document.getElementsByClassName('search-contacts-container')[0];
				contacts_scroll.scrollTop = 0;
			}, 1);
		}
		
		function dataURItoBlob(dataURI) {
			var byteString = atob(dataURI.split(',')[1]);
			var ab = new ArrayBuffer(byteString.length);
			var ia = new Uint8Array(ab);
			for (var i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i);
			}
			return new Blob([ab], { type: 'image/jpeg' });
		}
	}//end of app init

		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}

	}
})();

(function() {
	'use strict';

	angular.module('modules.inbox.list',[]).controller('inboxListController', inboxListController);

	/** @ngInject */
	function inboxListController($scope, $timeout, $rootScope, $stateParams, $uibModal, inboxService, regexes, $state, toastr, $translate) {
		
	}
})();

(function() {
	'use strict';

	angular.module('modules.inbox.info',[]).controller('inboxInfoController', inboxInfoController);

	/** @ngInject */
	function inboxInfoController($scope, baseService, $rootScope, $timeout, inboxService, metadata, $state, $stateParams, toastr, regexes, storage, $sce, $uibModal, $window) {
		$scope.showSave = false;
		$scope.message_info = { };
		$scope.info = { };
		var relationships = { };
		
		_.each(metadata.data.metadata.relationships, function (obj, index) {
			relationships[obj.id] = obj.longName;
		});
		
		baseService.app_initialized = function(evt, args) {
			if(!$stateParams.id) {
				return;
			}

			inboxService.get('parent/v1/conversation/' + $stateParams.id + '/participants',{'cache':false}).then(function (response) {
				$scope.message_info = response.data;
				$scope.info.name = (' ' + $scope.message_info.subject).slice(1);

			}, function (error) {
				
			})
		}

		$scope.addToConversation = function() {
			inboxService.get('parent/v1/conversation/' + $stateParams.id + '/participants',{'cache':false}).then(function (response) {
				if(!response.data)
					return;

				for(var i = 0; i < response.data.participants.length; i++) {
					if(response.data.participants[i].id !== $rootScope.active_user.id)
						$rootScope.temp_mess_contacts.push(response.data.participants[i])
				}

				if($rootScope.contacts_list) {
					for(var i = 0; i < $rootScope.contacts_list.parents.length; i++) {
						for(var j = 0; j < response.data.participants.length; j++) {
							if($rootScope.contacts_list.parents[i].id === response.data.participants[j].id) {
								$rootScope.contacts_list.parents[i].selected = true;
							}
						}
					}
				}
				
				$rootScope.resizeContactsList();

			}, function (error) {
				
			})

			$scope.createNewMessage(1)
		}
		
		$scope.nameRelation = function (_id){
			return relationships[_id]
		};

		$scope.back = function() {
			if ($window.history.length > 2) {
				$window.history.back();
			}else{
				$window.location.href = "/parent";
			}
		}

		$scope.save = function() {
			var data = {
				payload: {
					subject: $scope.info.name
				}
			}

			inboxService.put('parent/v1/conversation/' + $stateParams.id + '/update/subject', data, {'cache':false}).then(function (response) {
				$scope.message_info.subject = $scope.info.name;
				$scope.back()
				
			}, function (error) {
				
			})
		}

		$scope.checkSave = function() {
			return $scope.info.name !== $scope.message_info.subject;
		}

		$scope.leaveConversation = function() {
			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/inbox/views/leave.conversation.html',
				
				controller: function($scope){
					$scope.viewState = {
						isReady:true
					};

					$scope.close = function() {
						modalInstance.close();
					};

					$scope.leave = function() {
						modalInstance.close();

						inboxService.get('parent/v1/conversation/' + $stateParams.id + '/leave', { }).then(function(response) {
							location.href = '#/inbox/list';
						}, 
						function(error) {
							location.href = '#/inbox/list';
						})	
					}
				
				},
				size: 'sm'
			});
		}
		
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.inbox.conversations',[]).factory('conversationsService', ['base', function (base) {
		return _.create(base, { });
	}])
	.directive('conversations', conversations);
	/** @ngInject */
	function conversations(baseService, conversationsService, $state, $stateParams, $timeout, $rootScope, $uibModal, storage, toastr, $translate) {
		var directive = {
			restrict: 'EA',
			replace: true,
			scope: true,
			templateUrl: 'app/inbox/views/inbox.conversations.module.html',
			link: linkFunction
		};
		return directive;

		function linkFunction(scope, elem, attrs) {
			$rootScope.notifsContainer.messages = 0;

			var schoolId;
			scope.conversations = [];
			scope.viewState = {
				isReady:false,
				hasConversations:true
			};

			scope.openProfile = function(user, e) {
				e.stopPropagation();
				location.href = '#/classlist/details/' + user.participantId;
			}

			$rootScope.$on('UPDATE_MESSAGES',function(evt,args) { 
				getConversations($rootScope.active_school.id);
			});

			baseService.app_initialized = function(evt, args) {
 			
				scope.$on('UPDATE_PARTICIPANTS', function(e, value) {
					getConversations($rootScope.active_school.id);
				});
			
				getConversations($rootScope.active_school.id);
			}
		
			if($rootScope.active_school && $rootScope.app_base_ready) { 
				baseService.app_initialized();
			}

			function getConversations(schoolId){
				conversationsService.get('parent/v1/conversationV2/list/'+ schoolId,{'cache':false}).then(function (response) {
					$timeout(function(){
						
						scope.conversations = response.data.items || [];
						
						if(response.data.items && response.data.items.length > 0){
							scope.viewState.items = true;

							if(matchMedia('only screen and (min-width: 991px)').matches && $state.current.name === 'inbox'){
								$state.go('inbox.view',{'id':scope.conversations[0].id});
								scope.viewState.activeConversation = scope.conversations[0].id;

							}else{
								scope.viewState.activeConversation = $stateParams.id;
							}
						} else {
							scope.viewState.hasConversations = false;
						}
					},0)

				}, function (error) {
					scope.viewState.isReady = true;
				})
			}
			
			function virtualUpdate(c) {
				$timeout(function() {
					if(scope.conversations.length > 0) {
						scope.viewState.hasConversations = true;
						scope.conversations.unshift(c)
					}
					else {
						scope.conversations.push(c);
						scope.viewState.hasConversations = true;
					}
					scope.viewState.activeConversation = scope.conversations[0].id;
				})
			}

			scope.openConversation = function (c) {
				var options = { reload: false };
				
				if(window.innerWidth < 991)
					options.reload = true;

				if(c)
					$state.go('inbox.view', c, options);
			};

			$rootScope.$on('ON_SOCKET_CONVERSATIONS', function(evt, args) {
				getConversations($rootScope.active_school.id);
			})
			
			scope.$on('GET_CONVERSATIONS', function(evt, args) {
				removeConversation('new');
				args.conversation ? virtualUpdate(args.conversation) : _.noop();
			});

			scope.$on('CONVERSATION_READ', function(evt, args){
				var conv = _.find(scope.conversations, { 'id': args.id });
				if(conv) {
					conv.read = true;
				}
			});

			scope.$on('NEW_CONVERSATION', function(evt, args) {
				var delay = 0;

				if(typeof args.delay !== 'undefined') {
					delay = args.delay;
				}

				$timeout(function() {
					if (!_.isUndefined(scope.conversations[0])) {
						if(scope.conversations[0].id !== 'new'){
							var newConversation = {id: 'new', participants: [], read: true}

							scope.conversations.unshift(newConversation);
							scope.viewState.activeConversation = 'new';
						}
					}
				}, delay);
			});

			scope.cancelNewConversation = function() {
				removeConversation('new');
				storage.del('newMessage', true);
				storage.del('newParticipants', true);
			}

			function removeConversation(id) {
				$timeout(function() {
					scope.conversations = _.without(scope.conversations, _.find(scope.conversations, {'id':id}));
					if(scope.conversations.length > 0){
						scope.viewState.hasConversations = true;
					} 
					else {
						scope.viewState.hasConversations = false;
					}
				});
			}

			scope.clearNewConversation = function() {

				if(scope.conversations[0].id === 'new') {
					delete scope.conversations[0]['participants'];
					delete scope.conversations[0]['participantFirstName'];
					delete scope.conversations[0]['participantLastName'];
				}
			}

			// scope.leaveConversation = function(id) {
			// 	var modalInstance = $uibModal.open({
			// 		animation: true,
			// 		backdropClass: 'backdrop-zindexed',
			// 		templateUrl: 'app/inbox/views/leave.conversation.html',
					
			// 		controller: function($scope){
			// 			$scope.viewState = {
			// 				isReady:true
			// 			};

			// 			$scope.close = function(){
			// 				modalInstance.close();
			// 			};

			// 			$scope.leave = function() {
			// 				removeConversation(id);
			// 				modalInstance.close();

			// 				conversationsService.get('parent/v1/conversation/'+id+'/leave',{}).then(function(response) {

			// 				}, 
			// 				function(error) {
								
			// 				})	
			// 			}
					
			// 		},
			// 		size: 'sm'
			// 	});
			// }
		}

	}

})();

(function() {
	'use strict';

	angular.module('modules.post.likes',[]).factory('pmService', ['base', function (base) {
		return _.create(base, { });
	}]).directive('postLikes', postLikes);

	/** @ngInject */
	function postLikes($uibModal, $rootScope, toastr, regexes, pmService) {
		var directive = {
			restrict: 'A',
			replace: true,
			link: linkFunction
		};
		return directive;

		function linkFunction(scope, elem, attrs) {

			scope.$on('POST_LIKES', function(event,	object) {
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/home/views/post-likes-modal.html',
					controller: function($scope) {
						$scope.object = object;
						
						setTimeout(function() {
							angular.element(document.querySelector('.likes-modal'))
							.parent().parent().addClass('modal-likes-size');
						}, 1);

						$scope.openLiker = function(liker) {
							modalInstance.close();

							if($rootScope.active_user.id === liker.userId)
								location.href = '#/profile';
							else
								location.href = '#/classlist/details/' + liker.userId + '/contact';
						}

						$scope.close = function() { 
							modalInstance.close();
						};
					}
				});

			});
		}
	}

})();

(function() {
	'use strict';

	angular.module('modules.home',[]).factory('groupsService', ['base', function (base) {
		return _.create(base, { });
	}]).controller('homeController', homeController);

	/** @ngInject */
	function homeController(baseService, $scope, $rootScope, $window, groupsService, $filter, $uibModal, toastr, $timeout, settings, $translate) {
		$scope.newgroup = { groupVisibility: 1, guests: new Array() }
		$scope.viewMore = false;
		var boardcastSocketListener;

		baseService.app_initialized = function(evt, args) {

			var appcueClicked = false;
			$scope.inlineAppcueDoLater = function(type) {
				switch(type) {
					case 'PARENT_PRODUCT_DISCOVERY_GROUPS':
						$scope.showAppcueGroupsInfo = false;
						$rootScope.userTag('PARENT_PRODUCT_DISCOVERY_GROUPS', 'LATER');
						break;
				}
			}

			$scope.inlineAppcueDontShowAgain = function(type) {
				if(appcueClicked)
					return;

				appcueClicked = true;
				$rootScope.dismissTodo(type).then(function(resp) { }, function(error) { });

				$rootScope.userTag('PARENT_PRODUCT_DISCOVERY_GROUPS', 'DONT_SHOW_AGAIN');

				switch(type) {
					case 'PARENT_PRODUCT_DISCOVERY_GROUPS':
						$scope.showAppcueGroupsInfo = false;
						localStorage.setItem('PARENT_PRODUCT_DISCOVERY_GROUPS', true);
						break;
				}
			}

			$rootScope.tempPosts = null;
			
			$rootScope.isOnWizard = false;
			$scope.members = [];

			$scope.viewState = {
				isReady:false
			}

			$scope.groups = [];

			$scope.groupFilter = function (group) {
				if(!$scope.keyword)
					return true;
					
				return group.title.toLowerCase().indexOf($scope.keyword.toString().toLowerCase()) > -1;
			}

			$scope.isSunsetModalVisible = false;
			$scope.isModalVisible = function() {
				var storedDate = $window.localStorage.getItem('sunsetModalShow');
				if(!storedDate){
					$scope.isSunsetModalVisible = true;
					return;
				}

				$scope.isSunsetModalVisible = storedDate !== (new Date().toDateString()); 
			};
		
			$scope.closeModal = function() {
				$scope.isSunsetModalVisible = false;
				$window.localStorage.setItem('sunsetModalShow', (new Date().toDateString()));
			};
			$scope.isModalVisible();

			function getGroups() {
				groupsService.get('group/v1/parent/'+$rootScope.active_school.id+'/list/v3', {'cache':false, 'xhr':true}).then(function(response) {

					if(!response.data.groups)
						response.data.groups = [];

					var latestGroup = null;

					var notificationCountAsInt = 0;
					var marketplaceIndex;

					for (var i = 0; i < response.data.groups.length; i++) {
						notificationCountAsInt = notificationCountAsInt + (response.data.groups[i].notificationCount ? parseInt(response.data.groups[i].notificationCount) : 0);
						
						//PWA-9063
						if(response.data.groups[i].type != 'MARKETPLACE'){
							if (latestGroup == null){
								latestGroup = response.data.groups[i];
							} else {
								if (response.data.groups[i].order > latestGroup.order){
									latestGroup = response.data.groups[i];
								}
							}
						}

						if(response.data.groups[i] && response.data.groups[i].lastPost && response.data.groups[i].lastPost.text){
							response.data.groups[i].lastPost.text = $rootScope.parseTagsToLinks(response.data.groups[i].lastPost.text);
							response.data.groups[i].lastPost.text = $rootScope.parseMentionTags(response.data.groups[i].lastPost.text);
						}
						
						if(response.data.groups[i] && response.data.groups[i].description){
							response.data.groups[i].description = $rootScope.parseTagsToLinks(response.data.groups[i].description);
						}

						if (response.data.groups[i].type === 'MARKETPLACE') {
							marketplaceIndex = i;
							notificationCountAsInt = notificationCountAsInt - (response.data.groups[i].notificationCount ? parseInt(response.data.groups[i].notificationCount) : 0);
						}
					}

					$scope.mainGroups = [response.data.groups[marketplaceIndex]];
					response.data.groups.splice(marketplaceIndex, 1);
					$scope.mainGroups.unshift({
						id: -1,
						notificationCount: notificationCountAsInt,
						lastPost: latestGroup != null ? latestGroup.lastPost: null,
						title: 'Newsfeed',
						type: 'ALL_ACTIVITY',
						avatar: $rootScope.active_school.logo
					});
					
					$scope.groups = $filter('groupBy')(response.data.groups , response.data.groups.length) || [];

					if (!_.isUndefined(response.data.discover)) {
						$scope.discovers = $filter('groupBy')(response.data.discover , response.data.discover.length)
					} else {
						$scope.discovers = [];	
					}
					
					$scope.viewState.isReady = true;
					
					$rootScope.sendToNative();
				}, 
				function(error) {
					$scope.viewState.isReady = true;
					console.log(error)
				});
			}

			boardcastSocketListener = $rootScope.$on('ON_GROUPS_LIST_BADGE_UPDATE', function(evt, args) {
				if ($scope.viewState.isReady && $scope.groups && $scope.groups[0] && $scope.groups[0].length > 0) {
					updateGroupsInBackground();
				}
			});

			getGroups();
		}

		function updateGroupsInBackground() {

			groupsService.get('group/v1/parent/'+$rootScope.active_school.id+'/list/v2', {'cache':false, 'xhr':true}).then(function(response) {

				if(!response.data.groups)response.data.groups = [];

				for(var i = 0; i < response.data.groups.length; i++) {
					var notificationCount = response.data.groups[i].notificationCount ? parseInt(response.data.groups[i].notificationCount) : 0;
					if (notificationCount < 1){
						continue;
					}
					var groupId = response.data.groups[i].id;
					
					if (!$scope.groups || !$scope.groups[0] || $scope.groups[0].length < 1){
						return;
					}
					
					for (var m = 0; m < $scope.groups[0].length; m++) {
						var group = $scope.groups[0][m];
						if (group.id === groupId){
							group.notificationCount = notificationCount;
						}
					}	
				}			
			}, 
			function(error) {})
		}

		$scope.viewMoreGroups = function() {
			groupsService.get('group/v1/parent/'+$rootScope.active_school.id+'/list/expandDiscover', {'cache':false, 'xhr':true}).then(function(response) {
				$scope.viewMore = true;
				if (!_.isUndefined(response.data.discover)) {
					$scope.discovers = $filter('groupBy')(response.data.discover , response.data.discover.length)
				} else {
					$scope.discovers = [];	
				}
			}, 
			function(error) {});
		}

		$scope.onBackArrowTap = function() {
			$rootScope.activityStreamTierId = -1;
			$window.location.href = "/parent/#/home";
		}
		
		$scope.selectGroupVisibility = function(index) {
			$scope.newgroup.groupVisibility = index;
		}
		
		$scope.uploadImage = function() {
			$rootScope.$broadcast('UPLOAD_PHOTO', {
				'callback_fn':function(response) {
					var url = groupsService.getPostImgBucketUrl() + '/' + response.data;
					$scope.newgroup.avatarURL = url;
					$scope.newgroup.avatarId = response.data || '';
				},
				'action': 'groupUpload',
				'config': 'groupCropper'
			});
		}

		$scope.goToGroup =function(group, isdiscover) {
			$rootScope.goToGroup(group, isdiscover, $scope.groups)
		}

		$scope.saveGroup = function() {
			var guests = new Array();
			if (!_.isUndefined($scope.newgroup.guests)) {
				for(var i = 0; i < $scope.newgroup.guests.length; i++) {
					guests.push($scope.newgroup.guests[i].id)
				}
			}

			var group = {
				"avatar": $scope.newgroup.avatarId,
				"description": $scope.newgroup.groupDescr,
				"members": guests,
				"school": $rootScope.active_school.id,
				"title": $scope.newgroup.groupName,
				"type": $scope.newgroup.groupVisibility === 1 ? 'PARENT_PUBLIC' : 'PARENT_PRIVATE'
			}
			
			$scope.saveingGroup = true;
			groupsService.post('group/v1/parent/create', group).then(function(response) {
				$scope.saveingGroup = false;
				$rootScope.refreshContext();
				$timeout(function(){
					$window.location.href = settings.conf.parentAppURL + '#/groups/view/' + response.data.id;
				}, 100)
			}, 
			function(error) {
				$scope.saveingGroup = false;
			})
		};

		$scope.splitDescription = function(descr) {
			if(!descr)
				return descr;

			if(descr.length > 180) {
				return descr.substring(0, 180) + '...';
			}
			else {
				return descr;
			}
		}
		
		$scope.createGroup = function() {
			$scope.newgroup = { groupVisibility: 1, guests: new Array() }
			
			var open = function() {
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					templateUrl: 'app/groups/views/create-group-modal.html',
					backdropClass: 'backdrop-zindexed',
					controller: function() {
						
						$scope.uploadImage = function() {
							modalInstance.close();

							$rootScope.$broadcast('UPLOAD_PHOTO', {
								'callback_fn':function(response) {
									var url = groupsService.getPostImgBucketUrl() + '/' + response.data;
									$scope.newgroup.avatarURL = url;
									$scope.newgroup.avatarId = response.data || '';
									open();
								},
								'action': 'groupUpload',
								'config': 'groupCropper',
								'on_close': function() {
									open();
								}
							});
						}

						$scope.saveGroup = function() {
							var guests = new Array();
							if (!_.isUndefined($scope.newgroup.guests)) {
								for(var i = 0; i < $scope.newgroup.guests.length; i++) {
									guests.push($scope.newgroup.guests[i].id)
								}
							}

							var group = {
								"avatar": $scope.newgroup.avatarId,
								"description": $scope.newgroup.groupDescr,
								"members": guests,
								"school": $rootScope.active_school.id,
								"title": $scope.newgroup.groupName,
								"type": $scope.newgroup.groupVisibility === 1 ? 'PARENT_PUBLIC' : 'PARENT_PRIVATE'
							}

							$scope.saveingGroup = true;
							groupsService.post('group/v1/parent/create', group).then(function(response) {
								modalInstance.close();
								$scope.saveingGroup = false;
								$rootScope.refreshContext();
								$timeout(function(){
									$window.location.href = settings.conf.parentAppURL + '#/groups/view/' + response.data.id;
								}, 100)
							}, 
							function(error) {
								$scope.saveingGroup = false;
							})
						};

						$scope.close = function() {
							modalInstance.close();
						};
					},
					size: 'md'
				});
			}

			open();
		}

		$scope.goToSearch = function() {
			window.location.href='#/search';
		}

		$scope.capDescription = function(text) {
			var array = text.split(' ');
			array.splice(50);
			return array.join(' ');
		}

		$scope.getWordCount = function(text) {
			return text.split(' ').length;
		}

		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}

		$scope.$on('$destroy', function() {
			if (boardcastSocketListener){
				boardcastSocketListener();
			}
		});
	}
})();

(function() {
	'use strict';

	angular.module('modules.post.likes',[]).factory('pmService', ['base', function (base)	{
		return _.create(base, { });
	}]).directive('postLikes', postLikes);

	/** @ngInject */
	function postLikes($uibModal, $rootScope, toastr, regexes, pmService)	{
		var directive = {
			restrict: 'A',
			replace: true,
			link: linkFunction
		};
		return directive;

		function linkFunction(scope, elem, attrs)	{

			scope.$on('POST_LIKES', function(event,	object) {
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/home/views/post-likes-modal.html',
					controller: function($scope) {
						$scope.object = object;
						
						setTimeout(function() {
							angular.element(document.querySelector('.likes-modal'))
							.parent().parent().addClass('modal-likes-size');
						}, 1);

						$scope.openLiker = function(liker) {
							modalInstance.close();

							if($rootScope.active_user.id === liker.userId)
								location.href = '#/profile';
							else
								location.href = '#/classlist/details/' + liker.userId + '/contact';
						}

						$scope.close = function() {
							modalInstance.close();
						};
					}
				});

			});
		}
	}

})();

(function() {
	'use strict';

	angular.module('modules.groups.view',[]).controller('groupsViewController', groupsViewController);

	/** @ngInject */
	function groupsViewController(baseService, $scope, $rootScope, $stateParams, $sce, groupsService, toastr, $location, $translate, $state, $window,$uibModal, regexes, storage) {
		var membersType = $stateParams.type;

		$scope.firsttime = true;
		$scope.newTag = {
			"tag": ''
		};

		var groupId = $stateParams.id;

		var screenParam = $rootScope.getQueryParam('screen');
		var openParam = $rootScope.getQueryParam('open');
		// if query has 'open' param, we don't redirect user to group feed
		if(screenParam === 'JOINED' && openParam !== 'approve'){
			$rootScope.activityStreamTierId = groupId;
			$rootScope.postingFrom = 'groups';
			location.href = '#/stream';
			return;
		}
		$scope.viewState = {
			isReady: false,
			isInitiated: false
		}
		$scope.school = $rootScope.active_school;

		$scope.$on('$destroy', function () {
			if (window.viewpostListener)
				window.viewpostListener();
		});

		baseService.app_initialized = function(evt, args) {

			$scope.regexes = regexes;
			var schoolId = $rootScope.active_school.id;
			var me = $rootScope.active_user;

			$scope.groupId = groupId;
			$scope.group = {};
			$scope.userName = me.firstName+' '+me.lastName;

			$scope.showPrivateInfo = function(){
				toastr.info($translate.instant('PRIVATE_GROUP_INFO_TEXT'))
			}

			$scope.showPublicInfo = function(){
				toastr.info($translate.instant('PUBLIC_GROUP_INFO_TEXT'))
			}

			$scope.onBackArrowTap = function() {
				location.href = '/parent/#/home';
			}

			$scope.openProfile = function () {
				location.href = '#/classlist/details/' + $rootScope.active_user.id + '/contact';
			}

			$scope.seeMore = function() {
				$rootScope.activityStreamTierId = $scope.group.id;
				$rootScope.postingFrom = 'groups';
				location.href = '#/stream';
			}

			$scope.getGroup = function() {
				groupsService.get('group/v1/parent/get/' + groupId, {' cache': false, 'xhr': true }).then(function(response) {
					$scope.group = response.data || [];

					if(!$scope.group.tags) {
						$scope.group.tags = [];
					}
					$scope.isGroupWithTags = !$scope.group.archived && ($scope.group.type === 'PARENT_PUBLIC' || $scope.group.type === 'PARENT_PRIVATE');
					$scope.group.schoolId = schoolId;//we need this
					$scope.type = membersType ? membersType : 1;
					$scope.viewState.isInitiated = true;

					if($scope.firsttime) {
						$scope.visibleDetails = !$scope.group.member;
						$scope.firsttime = false;
					}

					setTimeout(function() {
						$scope.viewState.isReady = true;

						if($scope.group.owner
							&& $scope.group.type !== 'PARENT_PUBLIC'
							&& $scope.group.waitingApproval
							&& location.href.indexOf('?open')) {
							$scope.openMembers(3);
						}

						$scope.$apply();
					}, 100);

					var found = false;
					for (var i = 0; i < $rootScope.active_user.groups.length; i++) {
						if($rootScope.active_user.groups[i].id === groupId){
							found =true;
							break;
						}
					}

					if (!found) {
						var tmpGroup = angular.copy($scope.group)
						tmpGroup.name = tmpGroup.title;
						tmpGroup.memberCount = tmpGroup.members.length;
						$rootScope.active_user.groups.push(tmpGroup)
					}

					for (var i = 0; i < $rootScope.active_user.groups.length; i++) {
						$scope.groups.push($rootScope.active_user.groups[i])
					}
				},
				function(error){
					console.log(error)
				})
			};
			$scope.getHtmlVersion = function(description) {
				if(description) {
					// convert classlist links to html
					return $sce.trustAsHtml($rootScope.parseTagsToLinks(description));
				}
				return '';
			}

			$scope.leaveGroup = function(type, groupType) {
				var modalInstance = $uibModal.open({
					animation: true,
					templateUrl: 'app/groups/views/leave-group-modal.html',
					backdropClass: 'backdrop-zindexed',
					size:'sm',
					controller: function($scope) {
						$scope.type = type;
						$scope.groupType = groupType;

						$scope.confirm = function() {

							if($scope.leavingGroup)
								return;

							$scope.leavingGroup = true;
							groupsService.get('group/v1/parent/' + groupId + '/leave',{},{}).then(function(response) {
								toastr.success($translate.instant('LEFT_GROUP'));
								$scope.leavingGroup = false;
								$state.go('home');
								modalInstance.close();

								//virtual update
								for (var i = 0; i < $rootScope.active_user.groups.length; i++) {
									if ($rootScope.active_user.groups[i].id === groupId){
										$rootScope.active_user.groups.splice(i, 1);
									}
								}

							}, function(error) {
								$scope.leavingGroup = false;

								if (error.data.error.message === 'LAST_MEMBER') {
									toastr.error($translate.instant('LAST_MEMBER'))
								}
							});
						}

						$scope.close = function() {
							modalInstance.close();
						}
					}
				})
			}

			$scope.deleteGroup = function() {
				var name = $scope.group.title
				var modalInstance = $uibModal.open({
					animation: true,
					templateUrl: 'app/groups/views/delete-group-modal.html',
					backdropClass: 'backdrop-zindexed',
					size:'sm',
					controller: function($scope) {
						$scope.currentGroupName = name;
						$scope.confirm = function() {

							$scope.deletingGroup = true;
							groupsService.get('group/v1/parent/remove/group/' + groupId).then(function(response) {
								modalInstance.close();
								$scope.deletingGroup = false;
								$window.location.href = "/parent/#/home";

							},
							function(error) {
								$scope.deletingGroup = false;
							});
						}

						$scope.close = function() {
							modalInstance.close();
						}
					}
				})
			}
			$scope.getGroup();
		}

		if($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}

		$scope.rejectRequest = function(type, request) {
			var membersType = type;
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				templateUrl: 'app/groups/views/reject-request-modal.html',
				backdropClass: 'backdrop-zindexed',
				controller: function() {
					$scope.rejectMessage = '';
					$scope.type = membersType;

					$scope.save = function() {
						$scope.rejecting = true;
						var message = $scope.rejectMessage ? $scope.rejectMessage : '';
						groupsService.get('group/v1/parent/'+$scope.group.id+'/member/decline/'+request.id+'/'+ message).then(function (response) {
							$scope.rejecting = false;
							$scope.members = $scope.spliceArrMembers($scope.type, [request])
							toastr.info($translate.instant('USERS_REJECTED_INFO'))
							modalInstance.close();
							if($scope.type){
								$scope.openMembers($scope.type, true);
							}
						},
						function (error) {
							$scope.rejecting = false;
						})
					};

					$scope.close = function() {
						modalInstance.close();

						if($scope.type)
							$scope.openMembers($scope.type, false);
					};
				},
				size: 'sm'
			});
		}

		$scope.onDialogCallback = function(){
			$scope.getGroup();
		}

		$scope.pushArrMembers = function(type, arr) {
			switch(type) {
				case 1:
					if (_.isUndefined($scope.group.owners)) {
						$scope.group.owners = [];
					}
					for(var i = 0; i < arr.length; i++)
						$scope.group.owners.unshift(arr[i]);

					$scope.group.members = $scope.group.owners;
					return $scope.group.members;

				case 2:
					if (_.isUndefined($scope.group.members)) {
						$scope.group.members = [];
					}
					for(var i = 0; i < arr.length; i++) {
						$scope.group.members.unshift(arr[i]);
					}

					$scope.group.members = $scope.group.members;
					return $scope.group.members;

				case 3:
					if (_.isUndefined($scope.group.waitingApproval)) {
						$scope.group.waitingApproval = [];
					}
					for(var i = 0; i < arr.length; i++)
						$scope.group.waitingApproval.unshift(arr[i]);

					$scope.group.members = $scope.group.waitingApproval;
					return $scope.group.members;
			}
		}

		$scope.spliceArrMembers = function(type, arr) {
			switch(type) {
				case 1:
					for(var i = 0; i < arr.length; i++)
						$scope.group.owners = _.without($scope.group.owners, arr[i]);

					return $scope.group.owners;

				case 2:
					for(var i = 0; i < arr.length; i++)
						$scope.group.members = _.without($scope.group.members, arr[i]);

					return $scope.group.members;

				case 3:
					for(var i = 0; i < arr.length; i++)
						$scope.group.waitingApproval = _.without($scope.group.waitingApproval, arr[i]);

					return $scope.group.waitingApproval;
			}
		}

		$scope.openMembers = function(type, executed) {
			var openreject = $scope.rejectRequest;

			var membersType = type;
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				templateUrl: 'app/groups/views/members-modal.html',
				backdropClass: 'backdrop-zindexed',
				controller: function() {
					$scope.type = membersType;

					setTimeout(function() {
						var max = document.getElementsByClassName('group-members-list-max')
						if(max && max[0]) {
							if(getIfNative()) {
								max[0].style.maxHeight = (window.innerHeight - 69) + 'px';
							}
							else {
								max[0].style.maxHeight = (window.innerHeight - 111) + 'px';
							}
						}
					}, 100);

					$scope.reject = function(member) {
						modalInstance.close();
						$scope.rejectRequest($scope.type, member);
					};

					$scope.accept = function(member) {
						groupsService.get('group/v1/parent/'+ $scope.group.id +'/member/accept/'+member.id).then(function (response) {
							toastr.info($translate.instant('USERS_APPROVED_INFO'))
							$scope.members = $scope.spliceArrMembers($scope.type, [member])

							$scope.group.members.push(member);
						},
						function (error) {

						})
					};

					$scope.close = function() {
						modalInstance.close();
					};
				},
				size: 'md'
			});
		}

		$scope.uploadImage = function() {
			$rootScope.$broadcast('UPLOAD_PHOTO', {'callback_fn':function(response) {
					var url = groupsService.getPostImgBucketUrl() + '/' + response.data;
					$scope.avatarURL = url;
					$scope.avatarId = response.data || '';
					$scope.group.avatar = $scope.avatarURL;

					//call the server now with the new image
					groupsService.get('group/v1/parent/update/'+$scope.group.id+'/avatar/'+$scope.avatarId,{}).then(function (response) {
						$scope.getGroup();
					}, function (error) {
						console.log(error);
					})

				},
				'action': 'groupUpload',
				'config': 'groupCropper'
			});
		}

		$scope.pickMember = function(participant) {

			if(participant.type === 'user') {
				push(participant, false)
				$scope.inviteMembers([participant.id]);
			}
			else if(participant.type === 'tier') {
				explode(participant.id, participant.field1)
			}

			$scope.participant = null;
			$scope.member = '';
		}

		$scope.removeMember = function(participant) {
			var toBeRemoved = _.filter($scope.group.members, function(obj) {return obj.id === participant.id;});
			for (var i = 0; i < toBeRemoved.length; i++) {
				$scope.spliceArrMembers($scope.membersType, [toBeRemoved[i]])

				groupsService.get('group/v1/parent/'+ $scope.group.id +'/remove/member/'+participant.id).then(function (response) {
					toastr.info($translate.instant('USERS_REMOVED_INFO'))
					$scope.getGroup();
				},
				function (error) {

				})
			}
		}

		function push(r, isBulk) {
			var includes = _.includes($scope.group.members, _.find($scope.group.members, {'id': r.id})),
				isMe = false;

			if(!includes && !isMe) {
				var toadd = {
					avatar: r.avatar || '',
					name: (r.firstName || r.field1) + ' ' + (r.lastName || r.field2),
					id: r.id,
					type: r.type || 'user',
					tierId: r.tierId || '',
					tierName: r.tierName || ''
				};

				$scope.pushArrMembers($scope.membersType, [toadd]);
				return;
			}
			if(includes && !isBulk) {
				toastr.info($translate.instant('ADD_RECIPIENT_ALREADY_EXIST'))
			}
		}

		function explode(tierId, tierName) {
			groupsService.get('group/v1/'+$rootScope.active_school.id+'/getTierParents/'+tierId,{'cache':true}).then(function (response) {
				var toadd = [];

				_.forEach(response.data.resultList, function(r) {
					r.type = 'tier';
					r.tierName = tierName;
					r.tierId = tierId;
					toadd.push(r.id)
					push(r, true)
				})

				$scope.inviteMembers(toadd);
			},
			function (error) {
				error.status === 403 ? toastr.error($translate.instant('CANT_SEE_PUPILS')) : _.noop()
			})
		}

		$scope.inviteMembers = function(arr) {
			if($scope.membersType === 2) {
				groupsService.post('group/v1/parent/invite', { invites : arr, id: groupId}, { }).then(function(response) {
					toastr.info($translate.instant('USERS_INVITED_INFO'))
				},
				function(error) {
					for(var i = 0; i < arr.length; i++) {
						$scope.group.members = $scope.group.members.splice(-1, 1)
						$scope.group.members = $scope.group.members;
					}
				})
			}
			else if($scope.membersType === 1) {
				groupsService.post('group/v1/parent/add/owners', { invites : arr , id: groupId}, { }).then(function(response) {
					toastr.info($translate.instant('OWNERS_INVITED_INFO'))
				},
				function(error) {

					for(var i = 0; i < arr.length; i++) {
						$scope.group.owners = $scope.group.owners.splice(-1, 1)
						$scope.group.members = $scope.group.owners;
					}
				})
			}
		}

		$scope.updateGroup = function(){
			toastr.info($translate.instant('OWNERS_INVITED_INFO'))
		}

		$scope.editTitle = function() {
			$scope.peditTitleInput = $scope.group.title;
			$scope.peditTitle = true;
		}

		$scope.updateOutsideTitle = function() {
			if(!isThisMobile())
				$scope.updateTitle()
		}

		$scope.updateTitle = function() {
			if($scope.group.title !== $scope.peditTitleInput) {
				if ($scope.peditTitleInput.length >= regexes.min.groupTitle) {

					$scope.group.title = $scope.peditTitleInput;

					groupsService.put('group/v1/parent/update/' + groupId + '/title',
					{ 'payload': {
						title: $scope.peditTitleInput
					}},
					{' cache': false, 'xhr': true }).then(function(response) {
						//virtual update
						for (var i = 0; i < $rootScope.active_user.groups.length; i++) {
							if ($rootScope.active_user.groups[i].id === groupId){
								$rootScope.active_user.groups[i].name = angular.copy($scope.peditTitleInput);
								break;
							}
						}

					},
					function(error) {
						console.log(error)
					})
				}else{
					toastr.info($translate.instant('ERR_GROUP_TITLE'))
				}
			}

			$scope.peditTitle = false;
		}

		$scope.cancelTitle = function() {
			$scope.peditTitleInput = $scope.group.title;
			$scope.peditTitle = false;
		}

		$scope.editDescr = function() {
			$rootScope.$broadcast('RESIZE_TO_LARGE');
			// convert classlist links to text
			$scope.peditDescrInput = $rootScope.removeLinks($scope.group.description);
			$scope.peditDescr = true;
		}

		$scope.updateOutsideDescr = function() {
			if(!isThisMobile())
				$scope.updateDescr()
		}

		$scope.updateDescr = function() {
			if($scope.group.description !== $scope.peditDescrInput) {
				// convert text to classlist links
				var description = $scope.peditDescrInput;
				if(description && description.length > 0) {
					description = $rootScope.createEmailLinks(description);
					var s = String(description);
					s = s.replace(/(&nbsp;)+<\/div>/g, '</div>');
					s = s.replace(/(&nbsp;)+\[URL/g, '[URL');
					description = s;
				}
				$scope.group.description = description;
				groupsService.put('group/v1/parent/update/'+groupId+'/description',
				{ 'payload': {
					'description': description
				}},
				{' cache': false, 'xhr': true }).then(function(response) {

				},
				function(error) {
					console.log(error)
				})
			}
			$scope.peditDescr = false;
		}

		$scope.cancelDescr = function() {
			$scope.peditDescrInput = $scope.group.description;
			$scope.peditDescr = false;
		}

		$scope.joinGroup = function() {

			if($scope.joiningGroup)
				return;

			$scope.joiningGroup = true;
			groupsService.get('group/v1/parent/' + groupId + '/join/', {' cache': false, 'xhr': true }).then(function(response) {
				$scope.joiningGroup = false;

				toastr.success($translate.instant('GROUP_JOIN_SUCCESS'));
				location.reload();
			},
			function(error) {
				$scope.joiningGroup = false;
				console.log(error)
			})
		}

		$scope.addMembersToGroup = function(type, callback) {
			var currentGroupName = $scope.group.title;
			var group = $scope.group;

			$scope.memberSearchPlaceholder = $translate.instant('ADD_GROUPMEMBER_SEARCH_PHOLDER');

			if(type === 1)
				$scope.memberSearchPlaceholder = $translate.instant('ADD_GROUPOWNER_SEARCH_PHOLDER');

			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/groups/views/add-members-group-modal.html',
				controller: function($scope){
					$scope.group = group;
					$scope.currentGroupName = currentGroupName;
					$scope.members = [];
					$scope.type = type;

					$scope.viewState = {
						isReady:true
					};

					$scope.close = function() {
						modalInstance.close();
					};

					$scope.add = function () {
						$scope.viewState.isReady = false;
						var memberArr = [];
						memberArr = _.map($scope.members,'id');
						inviteMembers(memberArr, type);
						modalInstance.close();
					}

					function inviteMembers(arr, type) {
						if(type === 2) {
							groupsService.post('group/v1/parent/invite', { invites : arr, id: group.id}, { }).then(function(response) {
								toastr.info($translate.instant('USERS_INVITED_INFO'));
								callback();
							},
							function(error) {

							})
						}
						else if(type === 1) {
							groupsService.post('group/v1/parent/add/owners', { invites : arr , id: group.id}, { }).then(function(response) {
								toastr.info($translate.instant('OWNERS_INVITED_INFO'))
								callback();

							},
							function(error) {

							})
						}
					}
				},
				size: 'md'
			});
		}

		$scope.removeMembersFromGroup = function(callback) {
			var group = angular.copy($scope.group);
			
			var ownerCount = group.owners.length;

			group.allMembers = group.members;

			if($scope.group.owners){
				for (var i = 0; i < group.owners.length; i++) {
					group.owners[i].isOwner = true;
					group.allMembers.push($scope.group.owners[i]);
				}
			}

			group.allMembers = removeCurrentUser(group.allMembers);

			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/groups/views/remove-members-group-modal.html',
				controller: function($scope){

					$scope.group = group;
					$scope.viewState = {
						isReady:true
					};

					$scope.close = function() {
						modalInstance.close();
					};

					$scope.remove = function () {
						$scope.viewState.isReady = false;
						var membersToBeRemoved = $scope.getSelectedMembers(group.allMembers);
						
						var ownerCountToBeRemoved = 0;

						for(var i=0; i < membersToBeRemoved.length; i++){
							if(membersToBeRemoved[i].isOwner){
								ownerCountToBeRemoved++;
							}
						}

						if(ownerCount == ownerCountToBeRemoved){
							toastr.info($translate.instant('MEMBERS_OWNER_CANT_DELETE'));
							modalInstance.close();
							callback();
							return;
						}

						groupsService.put('group/v1/parent/' + group.id +'/remove/members',{'members': membersToBeRemoved}).then(function(response){
							//clear members model
							_.forEach(group.allMembers, function(r){
								delete r.checked;
							});
							$scope.viewState.isReady = true;
							if (membersToBeRemoved.length > 1) {
								toastr.info($translate.instant('MEMBERS_REMOVED'));
							}else{
								toastr.info($translate.instant('MEMBER_REMOVED'));
							}
							modalInstance.close();

							callback();
						}, function(error){
							$scope.viewState.isReady = true;
						});

					}

					$scope.getSelectedMembers = function(members) {
						var selectedMembers = [];

						for (var member in members) {
							if(members[member].checked) {
								selectedMembers.push(members[member].id);
							}
						}
						return selectedMembers.length > 0 ? selectedMembers : false;
					}

					$scope.checkAllBoxes = function() {
						for(var member=0; member<$scope.group.members.length; member++){
							$scope.group.members[member].checked = true;
						}
					}

				},
				size: 'md'
			});
		}

		$scope.optInNotificaions = function(){
			groupsService.get('group/v1/parent/' + groupId +'/optin').then(function(response){
				if ($scope.group.optedIn ? toastr.info($translate.instant('GROUPS_OPT_OUT_INFO')) : toastr.info($translate.instant('GROUPS_OPT_IN_INFO')))
				$scope.getGroup();
			},
			function(error) {

			});
		}

		function removeCurrentUser(members){
			var temp = [];

			for (var i = 0; i < members.length; i++) {
				if (members[i].id !== $rootScope.active_user.id){
					temp.push(members[i]);
				}
			}
			return temp;
		}

		$scope.removeTag = function(tag, i) {
			groupsService.delete('group/v1/parent/' + groupId +'/remove/tag/' + tag).then(function(){
				$scope.group.tags.splice(i, 1);
			}, function(error){
				console.log(error);
			});
		}

		$scope.searchTag = function(tag) {
			$rootScope.searchTerm = tag;
			location.href = '#/search';

		}

		$scope.addTag = function() {
			groupsService.post('group/v1/parent/' + groupId +'/add/tags', $scope.newTag).then(function(){
				$scope.group.tags.push($scope.newTag.tag);
				$scope.newTag.tag = '';
			}, function(error){
				console.log(error);
			});
		}

		$scope.pickTag = function(tag) {
			$scope.newTag.tag = tag;
			$scope.addTag();
		}

		$scope.tagKeyUp = function(event) {
			if(event.which === 13) {
				if(!!$scope.newTag.tag && $scope.newTag.tag !== '') {
					$scope.addTag();
				}
			}
		}

		$scope.getTags = function (string) {
			return groupsService.get('group/v1/parent/' + $scope.school.id +
				'/tags/' + encodeURIComponent(string)).then(function (response) {
				return response.data.tags
			}, function (error) {
			})
		}

		$scope.selectGroupVisibility = function(type) {
			if(type === 1) {
				if($scope.changingType || $scope.group.type === 'PARENT_PUBLIC') {
					return
				};
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					templateUrl: 'app/groups/views/group-type-change-modal.html',
					backdropClass: 'backdrop-zindexed',
					size:'sm',
					controller: function($scope) {
						$scope.confirm = function() {
							$scope.changingType = true;

							groupsService.put('group/v1/parent/update/' + groupId + '/type',
							{ 'payload': {
								type: 'PARENT_PUBLIC'
							}},
							{' cache': false, 'xhr': true }).then(function(response) {
								$scope.group.type = 'PARENT_PUBLIC';
								$scope.changingType = false;
								modalInstance.close();
							},
							function(error) {
								console.log(error);
								$scope.changingType = false;
								modalInstance.close();
							});
						}

						$scope.close = function() {
							modalInstance.close();
						}
					}
				});
			} else {
				if($scope.changingType || $scope.group.type === 'PARENT_PRIVATE') {
					return
				};

				$scope.changingType = true;

				groupsService.put('group/v1/parent/update/' + groupId + '/type',
				{ 'payload': {
					type: 'PARENT_PRIVATE'
				}},
				{' cache': false, 'xhr': true }).then(function(response) {
					$scope.group.type = 'PARENT_PRIVATE';
					$scope.changingType = false;
				},
				function(error) {
					console.log(error);
					$scope.changingType = false;
				});
			}
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.groups',[]).factory('groupsService', ['base', function (base) {
		return _.create(base, { });
	}]).controller('groupsController', groupsController);

	/** @ngInject */
	function groupsController($scope, groupsService) {
		
	}
})();

(function() {
	'use strict';

	angular.module('modules.groups.list',[]).controller('groupsListController', groupsListController);

	/** @ngInject */
	function groupsListController(baseService, $scope, $rootScope, $window, groupsService, $filter, $uibModal, toastr, $timeout, settings, $translate) {
		$scope.newgroup = { groupVisibility: 1, guests: new Array() }

		baseService.app_initialized = function(evt, args) {

			var appcueClicked = false;
			$scope.inlineAppcueDoLater = function(type) {
				switch(type) {
					case 'PARENT_PRODUCT_DISCOVERY_GROUPS':
						$scope.showAppcueGroupsInfo = false;
						$rootScope.userTag('PARENT_PRODUCT_DISCOVERY_GROUPS', 'LATER');
						break;
				}
			}

			$scope.inlineAppcueDontShowAgain = function(type) {
				if(appcueClicked)
					return;

				appcueClicked = true;
				$rootScope.dismissTodo(type).then(function(resp) { }, function(error) { });

				$rootScope.userTag('PARENT_PRODUCT_DISCOVERY_GROUPS', 'DONT_SHOW_AGAIN');

				switch(type) {
					case 'PARENT_PRODUCT_DISCOVERY_GROUPS':
						$scope.showAppcueGroupsInfo = false;
						localStorage.setItem('PARENT_PRODUCT_DISCOVERY_GROUPS', true);
						break;
				}
			}

			$rootScope.tempPosts = null;
			
			$rootScope.isOnWizard = false;
			$scope.members = [];

			$scope.viewState = {
				isReady:false
			}

			$scope.groups = [];

			$scope.groupFilter = function (group) {
				if(!$scope.keyword)
					return true;
					
				return group.title.toLowerCase().indexOf($scope.keyword.toString().toLowerCase()) > -1;
			}

			function getGroups() {
				groupsService.get('group/v1/parent/'+$rootScope.active_school.id+'/list', {'cache':false, 'xhr':true}).then(function(response) {

					if(!response.data.groups)
						response.data.groups = [];

					response.data.groups.unshift({
						id: -1,
						title: 'Newsfeed',
						type: 'ALL_ACTIVITY',
						avatar: $rootScope.active_school.logo
					})
					
					$scope.groups = $filter('groupBy')(response.data.groups , response.data.groups.length) || [];
					if (!_.isUndefined(response.data.discover)) {
						$scope.discovers = $filter('groupBy')(response.data.discover , response.data.discover.length)
					}
					else {
						$scope.discovers = [];	
					}

					$scope.viewState.isReady = true;
				}, 
				function(error) {
					$scope.viewState.isReady = true;
					console.log(error)
				})
			}

			getGroups();
		}

		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}

		$scope.onBackArrowTap = function() {
			$rootScope.activityStreamTierId = -1;
			$window.location.href = "/parent/#/home";
		}
		
		$scope.selectGroupVisibility = function(index) {
			$scope.newgroup.groupVisibility = index;
		}
		
		$scope.uploadImage = function() {
			$rootScope.$broadcast('UPLOAD_PHOTO', {
				'callback_fn':function(response) {
					var url = groupsService.getPostImgBucketUrl() + '/' + response.data;
					$scope.newgroup.avatarURL = url;
					$scope.newgroup.avatarId = response.data || '';
				},
				'action': 'groupUpload',
				'config': 'groupCropper'
			});
		}

		$scope.goToGroup =function(group, isdiscover) {
			if (group.status !== 'APPROVAL_NEEDED' && group.status !== 'PENDING_APPROVAL') {
				if(isdiscover) {
					window.location.href = settings.conf.parentAppURL + '#/groups/view/' + group.id;
				}
				else {
					$rootScope.activityStreamTierId = group.id;
					$rootScope.postingFrom = 'groups';
					window.location.href = '#/stream';
				}
			}
			else {
				if (group.status === 'PENDING_APPROVAL') {
					toastr.info($translate.instant('REQUEST_SENT_INFO_LATER'))
				}
				else {
					var open = function() {
						var modalInstance = $uibModal.open({
							animation: true,
							scope: $scope,
							templateUrl: 'app/groups/views/request-modal.html',
							backdropClass: 'backdrop-zindexed',
							controller: function() {
								$scope.disableRequest = false;
								$scope.group = group;

								$scope.request = function() {
									$scope.disableRequest = true;
									groupsService.get('group/v1/parent/'+ group.id +'/join').then(function(response) {
										
										var realGroups = $scope.groups[0];//I dont know why
										if (!_.isUndefined(realGroups)) {
											for (var i = 0; i < realGroups.length; i++) {
												if (realGroups[i].id === group.id){
													realGroups[i].status = 'PENDING_APPROVAL';
												}
											}
										}
										$scope.groups[0] = realGroups;	
										
										toastr.info($translate.instant('REQUEST_SENT_INFO'))
										modalInstance.close();
									}, 
									function(error) {
										console.log(error)
									})
								}

								function getGroups() {
									groupsService.get('group/v1/parent/'+$rootScope.active_school.id+'/list', {'cache':false, 'xhr':true}).then(function(response) {
										$scope.groups = $filter('groupBy')(response.data.groups , response.data.groups.length) || [];
										$scope.viewState.isReady = true;
									}, 
									function(error) {
										$scope.viewState.isReady = true;
										console.log(error)
									})
								}

								$scope.close = function() {
									modalInstance.close();
								};
							},
							size: 'md'
						});
					}
					open();
				}
			}
		}

		$scope.saveGroup = function() {
			var guests = new Array();
			if (!_.isUndefined($scope.newgroup.guests)) {
				for(var i = 0; i < $scope.newgroup.guests.length; i++) {
					guests.push($scope.newgroup.guests[i].id)
				}
			}

			// convert link in description to classlist links
			var description = $scope.newgroup.groupDescr;
			if(description && description.length > 0) {
				description = $rootScope.createEmailLinks(description);
				var s = String(description);

				s = s.replace(/(&nbsp;)+<\/div>/g, '</div>');

				s = s.replace(/(&nbsp;)+\[URL/g, '[URL');

				description = s;
			}

			var group = {
				"avatar": $scope.newgroup.avatarId,
				"description": description,
				"members": guests,
				"school": $rootScope.active_school.id,
				"title": $scope.newgroup.groupName,
				"type": $scope.newgroup.groupVisibility === 1 ? 'PARENT_PUBLIC' : 'PARENT_PRIVATE',
				"tags": $scope.newgroup.tags
			}
			
			$scope.saveingGroup = true;
			groupsService.post('group/v1/parent/create', group).then(function(response) {
				$scope.saveingGroup = false;
				$rootScope.refreshContext();
				$timeout(function(){
					$window.location.href = settings.conf.parentAppURL + '#/groups/view/' + response.data.id;
				}, 100)
			}, 
			function(error) {
				$scope.saveingGroup = false;
			})
		};

		$scope.splitDescription = function(descr) {
			if(!descr)
				return descr;

			if(descr.length > 180) {
				return descr.substring(0, 180) + '...';
			}
			else {
				return descr;
			}
		}
		
		$scope.createGroup = function() {
			$scope.newgroup = { groupVisibility: 1, guests: new Array() }
			
			var open = function() {
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					templateUrl: 'app/groups/views/create-group-modal.html',
					backdropClass: 'backdrop-zindexed',
					controller: function() {
						
						$scope.uploadImage = function() {
							modalInstance.close();

							$rootScope.$broadcast('UPLOAD_PHOTO', {
								'callback_fn':function(response) {
									var url = groupsService.getPostImgBucketUrl() + '/' + response.data;
									$scope.newgroup.avatarURL = url;
									$scope.newgroup.avatarId = response.data || '';
									open();
								},
								'action': 'groupUpload',
								'config': 'groupCropper',
								'on_close': function() {
									open();
								}
							});
						}

						$scope.saveGroup = function() {
							var guests = new Array();
							if (!_.isUndefined($scope.newgroup.guests)) {
								for(var i = 0; i < $scope.newgroup.guests.length; i++) {
									guests.push($scope.newgroup.guests[i].id)
								}
							}

							var group = {
								"avatar": $scope.newgroup.avatarId,
								"description": $scope.newgroup.groupDescr,
								"members": guests,
								"school": $rootScope.active_school.id,
								"title": $scope.newgroup.groupName,
								"type": $scope.newgroup.groupVisibility === 1 ? 'PARENT_PUBLIC' : 'PARENT_PRIVATE',
								"tags": $scope.newgroup.tags
							}

							$scope.saveingGroup = true;
							groupsService.post('group/v1/parent/create', group).then(function(response) {
								modalInstance.close();
								$scope.saveingGroup = false;
								$rootScope.refreshContext();
								$timeout(function(){
									$window.location.href = settings.conf.parentAppURL + '#/groups/view/' + response.data.id;
								}, 100)
							}, 
							function(error) {
								$scope.saveingGroup = false;
							})
						};

						$scope.close = function() {
							modalInstance.close();
						};
					},
					size: 'md'
				});
			}

			open();
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.events.invite',[]).factory('eventInviteService', ['base', function (base) {
		return _.create(base, { });
	}])
	.controller('eventInviteController', eventInviteController);

	/** @ngInject */
	function eventInviteController(baseService, $scope, $rootScope, $state, regexes, $uibModal, settings, toastr, $translate, eventInviteService, $stateParams, storage) {
		$scope.id_event = $stateParams.id_event;
		$scope.members = [];
		$scope.sendGuestNotification = true;
		
		$scope.viewState = {
			isReady: false
		};
		
		// Init the beforeunlodpage on this page
		var onBeforeunload = $rootScope.$on('events.invite', function(evt, args) {
			var anychange = $scope.members.length > 0 ? true : false;

			if(anychange) {
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/base/views/window-beforeleave-modal.html',
					size:'md',
					controller: function($scope) {
						$scope.leave = function() {
							onBeforeunload();
							$state.go(args.toState.name, args.toParams);
						}
						$scope.stay = function() {
							modalInstance.close();
						};
					}
				})

				args.e.preventDefault();
			}
			else {
				onBeforeunload();
			}
		});

		$scope.getEvent = function() {
			angular.element(document).ready(function() {
				eventInviteService.get('event/v1/get/private/' + $scope.id_event, {'cache':false, 'xhr':true}).then(function(response) {
					$scope.event = response.data;
					$scope.viewState.isReady = true;
				},
				function(error) {

				})
			});
		}

		$scope.getMembers = function (string) {
			return eventInviteService.get('search/v1/event/private/'+$rootScope.active_school.id+'/'+encodeURIComponent(string),{}).then(function (response) {
				return response.data.resultList
			}, 
			function (error) {

			})
		}

		$scope.pickMember = function (participant) {
			if(participant.type === 'user') {
				push(participant, false)
			} 
			else if(participant.type === 'group') {
				explode(participant.id, participant.field1)
			}

			$scope.participant = null;
			setTimeout(function() {
				angular.element(document.querySelector('.input-event-invite-members'))[0].value = '';
			}, 1);
			$scope.member = '';
		}

		$scope.removeMember = function (participant) {
			var toBeRemoved = _.filter($scope.members, function(obj) {return obj.id === participant.id;});
			for (var i = 0; i < toBeRemoved.length; i++) {
				$scope.members = _.without($scope.members, toBeRemoved[i]);
			}
		}

		$scope.save = function() {
			$scope.invitingGuests = true;

			var gsts = [];
			for(var i = 0; i < $scope.members.length; i++) {
				gsts.push($scope.members[i].id);
			}
			
			eventInviteService.post('event/v1/create/guest/'+$scope.event.id, { 
				guests: gsts,
				sendNotifications: $scope.sendGuestNotification
			})
			.then(function(response) {
				$scope.invitingGuests = false;
				$scope.members = [];

				if($scope.event.answerCount.invited === 0) {
					var id_event = $scope.event.id;
					var modalInstanceLive = $uibModal.open({
						animation: true,
						backdropClass: 'backdrop-zindexed',
						templateUrl: 'app/events/views/live-confirm-modal.html',
						size:'md',
						controller: function($scope) {
							$scope.id = id_event;
							$scope.close = function() {
								modalInstanceLive.close();
								location.href = '#/events/create/' + $scope.event.id;
							};
						}
					})
				}
				else {
					$rootScope.back('#/events/create/' + $scope.event.id);
				}
			}, 
			function(error) {
				$scope.invitingGuests = false;

				if(error.data.error.code === 409) {
					toastr.error($translate.instant(error.data.error.message));
				}
			})
		};

		function push(r, isBulk) {
			var includes = _.includes($scope.members, _.find($scope.members, {'id': r.id})),
				isMe = false;
				
			if(!includes && !isMe) {
				var toadd = {
					avatar: r.avatar || '',
					name: (r.firstName || r.field1) + ' ' + (r.lastName || r.field2),
					id: r.id,
					type: r.type || 'user',
					tierId: r.tierId || '',
					tierName: r.tierName || '',
					pupils: r.pupils || [],
					field3: r.field3 || []
				};

				$scope.members.unshift(toadd)
				return;
			}
			if(includes && !isBulk) {
				toastr.info($translate.instant('ADD_RECIPIENT_ALREADY_EXIST'))
			}
		}
		
		function explode(tierId, tierName) {
			eventInviteService.get('group/v1/parent/private/group/members/'+tierId,{'cache':true}).then(function (response) {
				var toadd = [];

				_.forEach(response.data.resultList, function(r) {
					r.type = 'tier';
					r.tierName = tierName;
					r.tierId = tierId;
					toadd.push(r.id)
					push(r, true)
				})
			}, 
			function (error) {
				error.status === 403 ? toastr.error($translate.instant('CANT_SEE_PUPILS')) : _.noop()
			})
		}

		baseService.app_initialized = function(evt, args) {
			$scope.getEvent();
		}

		if($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}
	}
})();
(function () {
	'use strict';

	angular.module('modules.events.view', []).controller('eventsViewController', eventsViewController);

	/** @ngInject */
	function eventsViewController(baseService,
		$scope,
		$stateParams,
		$rootScope,
		$uibModal,
		eventsService,
		settings,
		$window) {
		var ticketsLink = '';
		$scope.event = {
			id: $stateParams.id
		};
		$scope.messageList = [];
		$scope.rotaList = [];
		$scope.isEventCreatedByNameUpdated = false;
		$scope.canJoinOnlineEvent = true; // will disable the button
		$scope.isAndroidNative = false;
		if ($rootScope.isNative) {
			if (window.AndroidBridge) {
				$scope.isAndroidNative = true;
			}
		} 
		$scope.toggleShow = function(index) {
			$scope.messageList[index].showFull = !$scope.messageList[index].showFull;
		};
		baseService.app_initialized = function (evt, args) {
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;

			$scope.redirectPages = $stateParams.redirectPages;
			$scope.viewState = {
				isReady: false
			}

			$scope.getEvent();

			if ($rootScope.getQueryParam('payPalReturn') === 'true') {
				$scope.succededPayment();
			}
			else if ($rootScope.getQueryParam('payPalReturn') === 'false') {
				$scope.failedPayment();
			}
			$scope.getEventMessages();

			setTimeout(function() {
				var screenParam = $rootScope.getQueryParam('screen');
				if(screenParam === 'EVENT_NOTES'){
					document.getElementById('messageSection').scrollIntoView(true, {behavior: 'smooth'});
					window.scrollBy(0, -130);
				}
			}, 1000);
	}
		// line control js
		var checkLineCount = function(text) {
			var tempElement = document.createElement("div");
			tempElement.innerHTML = text;
			document.body.appendChild(tempElement);
		
			var lineCount = tempElement.clientHeight / parseInt(window.getComputedStyle(tempElement).lineHeight);
		
			document.body.removeChild(tempElement);
		
			if (lineCount > 3) {
			return true;
			} else {
			return false;
			}
		};
		$scope.openRota = function (rota) {
			location.href = '#/events/' + $scope.event.id + '/signup/' + rota.id;
		}

		$scope.switchToEdit = function () {
			$rootScope.switchApps('#/community-events/dashboard/' + $scope.event.id);
		}

		$scope.hideMReplyDropdown = function () {
			$scope.event.showMReplyDropdown = false;
		}

		$scope.hideMReplyDropdownMobile = function () {
			$scope.event.showMReplyDropdownMobile = false;
		}

		$scope.hideDReplyDropdown = function () {
			$scope.event.showDReplyDropdown = false;
		}

		$scope.back = function () {
			if ($window.history && $window.history.length > 2) {
				if (document.referrer.indexOf('paypal') !== -1) {
					location.href = '/parent/#/events/list';
				}
				else {
					//window.history.back();
					if ($scope.event.status === 'DRAFT')
						location.href = '/parent/#/events/create/' + $scope.event.id;
					else
						location.href = '/parent/#/events/list';
				}
			}
			else {
				location.href = '/parent/#/events/list';
			}
		}

		$scope.showTickets = function () {
			location.href = '/parent/#/events/ticket/' + $scope.event.id + '/';
		}

		$scope.dismissSample = function () {
			$scope.event.sample = false;
		}

		$scope.downloadList = function (isticketed) {
			var filter = "ALL_INVITED";

			var _api = settings.conf.api;
			if ($rootScope.isNative) {
				if (_api.indexOf('https://') > -1)
					_api = _api.replace('https://', 'http://')
			}
			

			if (isticketed) {
				window.open(_api + '/generator/attachment?type=attendeeTicketed&id=' + $scope.event.id + "&listType=" + filter, '_self');
			}
			else {
				window.open(_api + '/generator/attachment?type=attendee&id=' + $scope.event.id + "&listType=" + filter, '_self');
			}
		}

		$scope.closeInfo = function () {
			$scope.showInfoPast = false;

		}
		$scope.goToEvents = function () {
			window.location.href = '/parent/#/events/list'
		}
		$scope.getEventMessages = function () {
			eventsService.get("event/v1/get/" + $scope.event.id+"/ownerMessages").then(
				function (response) {
					if (!response || !response.data || !response.data.items) return;

					$scope.messageList = response.data.items;
					$scope.messageList.forEach(function(item){
						item.hasReadMore = checkLineCount(item.message)
					})
			
				},
				function (error) {
				}
			);
		}
		$scope.getEvent = function () {
			eventsService.get('event/v1/get/private/' + $scope.event.id + '/v2', { 'cache': false, 'xhr': true }).then(function (response) {
				$scope.event = response.data;
				$scope.includesWholeSchool = false;
				if($scope.event.groups){
					for(var i=0; $scope.event.groups.length > i; i++){
						if($scope.event.groups[i].type == 'SCHOOL_GROUP'){
							$scope.includesWholeSchool = true;
							break;
						}
					}
				}
				
				$scope.event.description = $scope.event.description.replace(/\r?\n/g, '<br />');
				$scope.event.description = $rootScope.parseTagsToLinks($scope.event.description);

				$scope.viewState.isReady = true;
				$scope.post = response.data.post;

				if ($scope.event.rotas) {
					$scope.rotaList = $scope.event.rotas;
				}

				if ($scope.event.ended && ($rootScope.active_user.id === $scope.event.createdById))
					$scope.showInfoPast = true;
			
				ticketsLink = settings.conf.api + '/generator/pdfgenerator?id=' + $scope.event.id, '_blank';
				if($scope.event.eventOwners){
					var ownerUser = $scope.event.eventOwners.filter(function(x) {return x.id === $scope.event.createdById})[0]
					if(ownerUser){
						$scope.isEventCreatedByNameUpdated = (ownerUser.firstName + ' ' + ownerUser.lastName) !== $scope.event.createdByName;
					}
				}
			},
			function (error) {

			})
		}

		$scope.getTickets = function () {
			$scope.ticketList = {};

			eventsService.get('event/v1/list/' + $scope.event.id + '/tickets', { 'cache': false, 'xhr': true }).then(function (response) {

				if (response.data)
					$scope.ticketList = response.data;
			},
				function (error) {

				})
		}

		$scope.getTotalTickets = function (list) {
			var tot = 0;

			if (!list)
				return tot;

			for (var i = 0; i < list.length; i++) {

				if (list[i].quantity) {
					tot += (list[i].quantity * list[i].ticketPrice)
				}
			}

			return tot;
		}

		$scope.buyTickets = function () {
			location.href = '#/events/buy/' + $scope.event.id;
		}
		$scope.openOwnersModal = function(owners) {
			try {
				var modalInstance = $uibModal.open({
					animation: true,
					templateUrl: 'app/events/views/show-event-owners-dialog.html',
					backdropClass: 'backdrop-zindexed',
					size: 'sm',
					controller: function ($scope) {
						$scope.owners = owners;
						$scope.viewState = {
							isReady: true
						}
	
						$scope.close = function () {
							modalInstance.close();
						}
					}
				})	
			} catch (error) {
				alert(error)
			}
		
		}
		$scope.showGuests = function (type) {
			if ($scope.includesWholeSchool && type === 'ALL') {
				return;
			}
			
			function openModal(participants) {
				var isCommunityEvent = $scope.event.type === 'COMMUNITY'
				var modalInstance = $uibModal.open({
					animation: true,
					templateUrl: 'app/events/views/show-participants-dialog.html',
					backdropClass: 'backdrop-zindexed',
					size: 'sm',
					controller: function ($scope) {
						$scope.participants = participants;
						$scope.isCommunityEvent = isCommunityEvent;
						$scope.eventContext = true;
						$scope.addDisabled = true;
						$scope.viewState = {
							isReady: true
						}

						$scope.openAddParticipantsModal = function () {
							activateInviteGuests();
						}

						$scope.close = function () {
							modalInstance.close();
						}
					}
				})
			}

			eventsService.get('event/v1/get/' + $scope.event.id + '/attendees/' + type, { 'cache': false }).then(function (response) {
				if (response.data.items) {
					openModal(response.data.items)
				}
			},
				function (error) {

				})
		}

		$scope.failedPayment = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/events/views/payment-fail-modal.html',
				size: 'md',
				controller: function ($scope) {

					$scope.close = function () {
						modalInstance.close();
					};
				}
			})
		}

		$scope.succededPayment = function () {
			// location.href = '#/events/ticket/' + $scope.event.id + '/' + $rootScope.getQueryParam('lid');
		}

		$scope.getNumber = function (num) {
			return new Array(num);
		}

		if ($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
			
		}

		$scope.addToGoogleCalendar = function () {
			var eventLink = settings.conf.parentAppURL + '/#/events/view/' + $scope.event.id;
			var description = '<a href=' + eventLink + '>' + eventLink +'</a>' + '\n' + $scope.event.description;
			if($scope.isAndroidNative){
				window.AndroidBridge.addToCalendar(encodeURIComponent($scope.event.title), encodeURIComponent(description), $scope.event.date.startDate, $scope.event.date.endDate);
			} else {
				//prepare dates for the link
				var dates = "";
				var startDate = $scope.event.date.startDate.replace(/[-:.]/g, "").substring(0, 13);
				dates += startDate;
				if($scope.event.date.endDate){
					var endDate = $scope.event.date.endDate.replace(/[-:.]/g, "").substring(0, 13);
					dates +=  '/' + endDate;
				}

				var url = 'https://calendar.google.com/calendar/u/0/r/eventedit?text=' + encodeURIComponent($scope.event.title)
					+ '&dates=' + dates
					+ '&details=Get the event details by link, ' + encodeURIComponent(description);

				if($rootScope.isNative){
					window.location.href = url;
				} else {
					window.open(url,'_blank');
				}
			}
		}

		$scope.addToICal = function () {
			//date format should be like this for ios app => "yyyy-MM-dd'T'HH:mm:ss.SSS"			
			if ($rootScope.isNative) {
				var nativeStr = 'title=' + encodeURIComponent($scope.event.title) +
					'&startTime=' + $scope.event.date.startDate +
					'&rsvpTime=' + $scope.event.date.rsvpDate +
					'&endTime=' + $scope.event.date.endDate +
					'&description=' + encodeURIComponent("Get the event details by link, "+window.location.href);
					//Emese 18/01/18 - Please DO NOT CHANGE this again because the app wil crash
					window.location = 'classlistnativeparent://calendar?' + nativeStr;
			} else {
				window.open($scope.event.addToCalendarLink,'_blank');
			}
		}

		$scope.getTicketsCount = function (list) {
			var count = 0;

			if (!list)
				return count;

			for (var i = 0; i < list.length; i++)
				count += list[i].quantity;

			return count;
		}

		$scope.joinOnlineEvent = function () {
			if($scope.event.onlineEventType == 'EXTERNAL'){
				if($scope.event.onlineEventExternalLink && $scope.event.onlineEventExternalLink != ''){
					window.open($scope.event.onlineEventExternalLink, "_blank");
				}
				return;
			}
			$scope.canJoinOnlineEvent = false;
			eventsService.get('bench/v1/get/redirectionLink/' + $scope.event.id, { 'cache': false, 'xhr': true }).then(function (response) {
				if (response && response.data.payload && response.data.payload.redirectionLink) {
					var url = response.data.payload.redirectionLink;
					if (url.indexOf('https://') > -1) {
						url = url.replace('https://', 'http://')
					}
					$window.location.href = url;
				} else {
					$scope.canJoinOnlineEvent = true;
					// TODO handle this
				}
			},
			function (error) {
				$scope.canJoinOnlineEvent = true;
			})

		
		}

		window.addEventListener('online', function (net) {
			if (navigator.onLine) {
				//init websocket
				if($scope.canJoinOnlineEvent == false) {
					$scope.canJoinOnlineEvent = true;
				}
			}
		});
	}
})();
(function() {
	'use strict';

	angular.module('modules.events.tickets',[]).factory('eventTicketsService', ['base', function (base) {
		return _.create(base, { });
	}]).controller('eventTicketsController', eventTicketsController);

	/** @ngInject */
	function eventTicketsController(baseService, $scope, $state, regexes, $uibModal, settings, toastr, $translate, eventTicketsService, $location, $anchorScroll, $timeout, $rootScope, $window, $stateParams) {
		$scope.id_event = $stateParams.id_event;
		$scope.validateEmail = validateEmail;

		$scope.viewState = {
			isReady: false
		};

		$scope.changedTicketType = function(type) {
			$scope.invalidTicketInfo = false;
			$scope.ticket.is_free = type === 'FREE';
		};

		// Init the beforeunlodpage on this page
		var onBeforeunload = $rootScope.$on('events.tickets', function(evt, args) {
			var anychange = $scope.ticket.is_free ? $scope.ticket.hasAnyChangeFree() : $scope.ticket.hasAnyChangePaid()

			if(anychange) {
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/base/views/window-beforeleave-modal.html',
					size:'md',
					controller: function($scope) {
						$scope.leave = function() {
							onBeforeunload();
							$state.go(args.toState.name, args.toParams);
						}
						$scope.stay = function() {
							modalInstance.close();
						};
					}
				})

				args.e.preventDefault();
			}
			else {
				onBeforeunload();
			}
		});

		$scope.ticket = {
			free_list: [{ }],
			paid_list: [{ }],
			ticketCurrency: 'GBP',
			checkValidation: function(force) {
				if(this.is_free)
					return this.validateFree(force)
				else
					return this.validatePaid(force)
			},
			validateFree: function(force, e) {
				if(this.free_list) {
					for(var i = 0; i < this.free_list.length; i++) {
						var t = this.free_list[i];

						if(!force)
							if(!t.ticketName && (isNaN(t.availableTicket) || t.availableTicket === null) && this.free_list.length > 1)
								continue;

						if(!t.ticketName || (isNaN(t.availableTicket) || t.availableTicket === null)) {
							focusListValidator(e);
							return false;
						}
					}
				}

				return true;
			},
			validatePaid: function(force, e) {
				if(this.paid_list) {
					for(var i = 0; i < this.paid_list.length; i++) {
						var t = this.paid_list[i];

						if(!force)
							if(!t.ticketName && !t.ticketPrice && (isNaN(t.availableTicket) || t.availableTicket === null) && this.paid_list.length > 1)
								continue;

						if(!t.ticketName || !t.ticketPrice || (isNaN(t.availableTicket) || t.availableTicket === null)) {
							focusListValidator(e);
							return false;
						}
					}
				}

				return true;
			},
			hasAnyChangeFree: function() {
				if(this.free_list && $scope.ticket_clone.free_list) {
					if($scope.ticket_clone.free_list.length !== this.free_list.length)
						return true;

					for(var i = 0; i < this.free_list.length; i++) {
						var _old = $scope.ticket_clone.free_list[i];
						var _new = this.free_list[i];

						if(_old.ticketName !== _new.ticketName)
							return true;

						if(_old.availableTicket !== _new.availableTicket)
							return true;
					}
				}

				return false;
			},
			hasAnyChangePaid: function() {
				if($scope.ticket_clone.paid_list && this.paid_list) {
					if($scope.ticket_clone.paid_list.length !== this.paid_list.length)
						return true;

					if(this.paypalEmail !== $scope.ticket_clone.paypalEmail)
						return true;

					for(var i = 0; i < this.paid_list.length; i++) {
						var _old = $scope.ticket_clone.paid_list[i];
						var _new = this.paid_list[i];

						if(_old.ticketName !== _new.ticketName)
							return true;

						if(_old.ticketPrice !== _new.ticketPrice)
							return true;

						if(_old.availableTicket !== _new.availableTicket)
							return true;
					}
				}

				return false;
			}
		}

		
		$scope.decideGoBack = function() {
			
			if (document.referrer === "") {
				if ($scope.event && $scope.event.id > 0){
					window.location.href = "/parent/#/events/create/" + $scope.event.id;
				} else {
					window.location.href = "/parent/#/events/list";
				}
			} 
			else {
				history.back();
			}
		}

		$scope.getTickets = function() {
			eventTicketsService.get('event/v1/list/' + $scope.id_event + '/tickets', {'cache':false, 'xhr':true})
			.then(function(response) {
				$scope.ticket.paypalEmail = response.data.paypalEmail;
				$scope.event = response.data.event;

				if($scope.event.question) {
					$scope.event.question = $rootScope.removeLinks($scope.event.question)
				}

				if(response.data.ticketCurrency)
					$scope.ticket.ticketCurrency = response.data.ticketCurrency;

				$scope.disableTicketing = response.data.paidEventType;

				$scope.selectedTicketType = 'FREE';
				$scope.changedTicketType('FREE')

				if(response.data.tickets) {
					$scope.ticket.free_list = response.data.tickets;
					$scope.ticket.is_free = true;
				}

				$scope.checkTerms = $scope.disableTicketing ? true : false;
				$scope.ticket_clone = eval('(' + JSON.stringify($scope.ticket) + ')');

				if($scope.disableTicketing) {
					$scope.paypalRepeatEmail = response.data.paypalEmail;
				}

				$scope.viewState.isReady = true;
			},
			function(error) {

			})
		}

		baseService.app_initialized = function(evt, args) {
			$scope.getTickets();
		}

		$scope.addTicket = function(e) {
			$scope.invalidTicketInfo = false;

			if(!$scope.ticket.checkValidation(true, e)) {
				$scope.invalidTicketInfo = true;
				return;
			}

			if($scope.ticket.is_free)
				$scope.ticket.free_list.push({ new: true });
			else
				$scope.ticket.paid_list.push({ new: true });
		}

		$scope.removeTicket = function(index, item) {

			if($scope.disableTicketing && !item.new) {
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/events/views/remove-ticket-type-modal.html',
					size:'md',
					controller: function($scope) {
						$scope.cancel = function() {
							modalInstance.close();
						}
						$scope.confirm = function() {
							if($scope.ticket.is_free)
								$scope.ticket.free_list.splice(index, 1)
							else
								$scope.ticket.paid_list.splice(index, 1)

							modalInstance.close();
						};
					}
				})
			}
			else {
				if($scope.ticket.is_free)
					$scope.ticket.free_list.splice(index, 1)
				else
					$scope.ticket.paid_list.splice(index, 1)
			}
		}

		if($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}

		$scope.switchTicketType = function(single) {
			$scope.ticket.is_free = single;

			if($scope.ticket.is_free)
				$scope.ticket.free_list = [{ }];
			else
				$scope.ticket.paid_list = [{ }];
		}

		$scope.save = function() {
			var payload = { };
			var tickets = [];
			var list = [];

			if($scope.ticket.is_free)
				list = $scope.ticket.free_list;
			else
				list = $scope.ticket.paid_list;

			for(var i = 0; i < list.length; i++) {
				var t = list[i];
				var ticket = { };

				ticket.id = t.id ? t.id : 0;
				ticket.ticketName = t.ticketName;
				ticket.availableTicket = t.availableTicket;
				ticket.ticketType = 'FREE';

				if(!$scope.ticket.is_free) {
					if(ticket) {
						ticket.ticketPrice = t.ticketPrice;

						if(!ticket.ticketName && !ticket.ticketPrice && !ticket.availableTicket)
							continue;
					}
				}

				if(!ticket.ticketName && !ticket.availableTicket)
					continue;

				tickets.push(ticket);
			}

			payload.tickets = tickets;
			payload.question = $scope.event.question ? $rootScope.createEmailLinks($scope.event.question) : '';

			$scope.creatingTickets = true;
			eventTicketsService.post('event/v1/update/'+$scope.id_event+'/ticket', payload)
			.then(function(response) {
				$scope.ticket_clone = eval('(' + JSON.stringify($scope.ticket) + ')');
				$scope.creatingTickets = false;
				location.href = '#/events/create/' + $scope.id_event;
			},
			function(error) {
				$scope.creatingTickets = false;

				if(error.data.error.code === 400) {
					toastr.error($translate.instant(error.data.error.message));
				}
			})
		}

		function focusListValidator(e) {
			if(!e)
				return;

			var elem = angular.element(e.srcElement).parent().parent().parent()

			setTimeout(function() {
				var inputs = elem[0].getElementsByTagName('input');

				if(inputs) {
					for (var i = 0; i < inputs.length; i++) {
						if(!inputs[i].value) {
							inputs[i].focus();
							break;
						}
					}
				}
			}, 100);
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.events.rota',[]).controller('eventsRotaController', eventsRotaController);

	/** @ngInject */
	function eventsRotaController(baseService, $http, $scope, $document, $stateParams, $rootScope, $sce, $state, regexes, $uibModal, eventsService, toastr, $translate, settings, storage, $location, $window, $interpolate) {
		var ticketsLink = '';
		$scope.id_rota = $stateParams.id_rota;
		$scope.event = { 
			id: $stateParams.id
		};

		$scope.viewState = {
			isReady: false
		}

		$scope.rota = {};
		$scope.tasksList = [];
		$scope.currentUserId; 
		$scope.getTasks = function() {
			if(!$scope.id_rota)
				return;

			eventsService.get('rota/v1/' + $scope.id_rota + '/parent', { 'cache': false }).then(function(response) {
				if(!response || !response.data || !response.data)
					return;
					
				$scope.rota = response.data;
				$scope.tasksList = response.data.tasks;
				$scope.viewState.isReady = true;

			}, function() {
				$scope.viewState.isReady = true;
			});
		}

		$scope.loadSlots = function(task) {
			task.expanded = !task.expanded;

			if(task.expanded)
				$scope.getSlots(task);
		}

		$scope.getSlots = function(task) {
			eventsService.get('rota/v1/' + $scope.id_rota + '/parent/task/' + task.id +'/users', { 'cache': false }).then(function(response) {
				if(!response || !response.data || !response.data.items)
					return;
					
				task.slots = response.data.items;
			}, function() {
				
			});
		}

		$scope.customOrder = function(volunteer) {
			return volunteer.userId === $rootScope.currentUserId() ? -1 : 1;
		};

		$scope.saveSlotComment = function(rota, task, slot) {
			if(!slot.myComment)
				slot.myComment = '';

			eventsService.put('rota/v1/' + $scope.id_rota + '/parent/' + slot.id + '/comment', {
				comment: slot.myComment

			}, { 'cache': false }).then(function(response) {
				toastr.success('Your comment has been saved');
				
			}, function() {
				
			});
		}

		$scope.signUpSlot = function(rota, task, slot, isbooking) {
			if(slot.signinup)
				return;
				
			if(isbooking) {
				slot.signinup = true;
				eventsService.put('rota/v1/' + $scope.id_rota + '/parent/' + slot.id + '/book', { 'cache': false }).then(function(response) {
					slot.signinup = false;
					slot.bookedByMe = true;
					toastr.success('Successfully signed up to the slot');
					$scope.getSlots(task)
					if(!response || !response.data)
						return;

					slot.totalPlaces = response.data.totalPlaces;
					slot.bookedPlaces = response.data.bookedPlaces;
					
				}, function() {
					slot.signinup = false;
				});
			}
			else {
				var id_rota = $scope.id_rota;

				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/events/views/remove-volunteer-modal.html',
					size:'md',
					controller: function($scope) {
						$scope.save = function() {
							$scope.removingVolunteer = true;
							slot.signinup = true;

							eventsService.delete('rota/v1/' + id_rota + '/parent/' + slot.id + '/unbook', { 'cache': false }).then(function(response) {
								slot.signinup = false;
								slot.bookedByMe = false;
								toastr.success('Successfully removed from the slot');
								$scope.removingVolunteer = false;
								modalInstance.close();
								$scope.getSlots(task)
			
								if(!response || !response.data)
									return;
			
								slot.totalPlaces = response.data.totalPlaces;
								slot.bookedPlaces = response.data.bookedPlaces;
								
							}, function() {
								$scope.removingVolunteer = false;
								slot.signinup = false;
							});
						};
						
						$scope.close = function() {
							modalInstance.close();
						};
					}
				})
			}
		}

		baseService.app_initialized = function(evt, args) {
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
			$scope.currentUserId = $rootScope.currentUserId()
			$scope.getTasks();
		}

		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}

	}
})();
(function () {
	"use strict";

	angular
		.module("modules.events", [])
		.factory("eventsService", [
			"base",
			function (base) {
				return _.create(base, {});
			},
		])
		.controller("eventsController", eventsController);

	/** @ngInject */
	function eventsController(
		baseService,
		$scope,
		$rootScope,
		$state,
		$translate,
		$uibModal,
		toastr,
		eventsService,
		storage,
		settings
	) {
		baseService.app_initialized = function (evt, args) {};

		$scope.downloadTickets = function (id_event) {
			window.open(
				settings.conf.api +
					"/generator/pdfgenerator?id=" +
					id_event +
					"&timestamp=" +
					new Date().getTime(),
				"_self"
			);
		};

		//this function will check for rsvp second, because we need to check like this on the Edit page of th event
		$scope.isPastEvent = function (event) {
			// PWA-8125 rely on server event past calculation
			if (event) {
				return event.past || event.ended;
			} else {
				return true;
			}
		};

		$scope.deleteComment = function (
			id_post,
			id_comment,
			comments,
			commentCount
		) {
			_.each(comments, function (item, i) {
				if (item) {
					if (item.id === id_comment) {
						comments.splice(i, 1);
						commentCount--;
						return;
					}
				}
			});

			eventsService
				.delete("post/v1/comment/" + id_post + "/delete/" + id_comment, {})
				.then(
					function (response) {
						toastr.info($translate.instant("COMMENT_DELETED"));
					},
					function (error) {}
				);
		};

		function getText() {
			return document.getElementById("goingButtonText").innerHTML;
		}

		$scope.updateAttendance = function (event, answer) {
			switch (event.userAnswer.userAnswer) {
				case "GOING":
					if (parseInt(event.answerCount.going) > 0)
						event.answerCount.going = parseInt(event.answerCount.going) - 1;
					break;

				case "MAYBE":
					if (parseInt(event.answerCount.going) > 0)
						event.answerCount.maybe = parseInt(event.answerCount.maybe) - 1;
					break;

				case "NOT_GOING":
					if (parseInt(event.answerCount.going) > 0)
						event.answerCount.cantgo = parseInt(event.answerCount.cantgo) - 1;
					break;
			}

			var payload = {
				eventAnswerId: event.userAnswer.userAnswerId,
				answer: answer,
			};

			event.eventAnswer = payload.answer;
			event.userAnswer.userAnswer = answer;
			eventsService
				.post("event/v1/update/" + event.id + "/answer", payload, { xhr: true })
				.then(
					function (response) {
						switch (event.userAnswer.userAnswer) {
							case "GOING":
								if (parseInt(event.answerCount.going) > 0)
									event.answerCount.going =
										parseInt(event.answerCount.going) + 1;
								break;

							case "MAYBE":
								if (parseInt(event.answerCount.going) > 0)
									event.answerCount.maybe =
										parseInt(event.answerCount.maybe) + 1;
								break;

							case "NOT_GOING":
								if (parseInt(event.answerCount.going) > 0)
									event.answerCount.cantgo =
										parseInt(event.answerCount.cantgo) + 1;
								break;
						}
					},
					function (error) {
						event.userAnswer.userAnswer = null;
					}
				);
		};

		if ($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}
	}
})();

(function() {
    'use strict';

    angular.module('modules.events.list', []).controller('eventsListController', eventsListController);

    /** @ngInject */
    function eventsListController(baseService, $scope, $rootScope, eventsService, $translate, toastr, settings, $state, $uibModal) {
        $scope.pastItemsLimit = 3;

        $scope.event = {};
        $scope.viewState = {
            isReady: false,
            isEmpty: false
        }

        $scope.togglePastMore = function() {
            $scope.pastItemsLimit = null;
        }

        baseService.app_initialized = function(evt, args) {
            // Check the events appcues here
            if (!localStorage.getItem('PARENT_PRODUCT_DISCOVERY_EVENTS')) {
                if ($rootScope.active_school && $rootScope.active_school.id) {
                    $rootScope.checkTodo('PARENT_PRODUCT_DISCOVERY_EVENTS').then(function(resp) {
                        $scope.showAppcueEventsInfo = resp.data.payload.show;
                    });
                }
            }

            var appcueClicked = false;
            $scope.inlineAppcueDoLater = function(type) {
                switch (type) {
                    case 'PARENT_PRODUCT_DISCOVERY_EVENTS':
                        $scope.showAppcueEventsInfo = false;
                        $rootScope.userTag('PARENT_PRODUCT_DISCOVERY_EVENTS', 'LATER');
                        break;
                }
            }

            $scope.inlineAppcueDontShowAgain = function(type) {
                if (appcueClicked)
                    return;

                appcueClicked = true;
                $rootScope.dismissTodo(type).then(function(resp) {}, function(error) {});

                $rootScope.userTag('PARENT_PRODUCT_DISCOVERY_EVENTS', 'DONT_SHOW_AGAIN');

                switch (type) {
                    case 'PARENT_PRODUCT_DISCOVERY_EVENTS':
                        $scope.showAppcueEventsInfo = false;
                        localStorage.setItem('PARENT_PRODUCT_DISCOVERY_EVENTS', true);
                        break;
                }
            }

            $scope.checkCreateEvent = function() {
                var modalInstance = $uibModal.open({
                    animation: true,
                    scope: $scope,
                    templateUrl: 'app/events/views/before-create-modal.html',
                    backdropClass: 'backdrop-zindexed',
                    size: 'md',
                    controller: function($scope) {
                        $scope.switchRef = function() {
                            if ($rootScope.active_school.admin) {
                                $rootScope.switchApps('#/community-events/start?from=parent')
                            } else {
                                modalInstance.close();
                                $scope.openPrivateMessageDialog();
                                $scope.getReps();
                            }
                        }
                        $scope.close = function() {
                            modalInstance.close();
                            $scope.createEvent();
                        }
                    }
                });
            }

            $scope.openPrivateMessageDialog = function() {
                var modalInstance = $uibModal.open({
                    animation: true,
                    scope: $scope,
                    templateUrl: 'app/events/views/before-create-not-admin.html',
                    backdropClass: 'backdrop-zindexed',
                    size: 'md',
                    controller: function($scope) {
                        $scope.continue = function() {
                            $scope.sendMessage();
                        }
                        $scope.close = function() {
                            modalInstance.close();
                        }
                    }
                });
            }

            $scope.getReps = function() {
                eventsService.get('parent/v1/get/' + $rootScope.active_school.id + '/details', { 'xhr': true, cache: false }).then(function(response) {
                        $scope.reps_list = response.data.payload.ambassadors;
                    },
                    function(error) {});
            }

            $scope.sendMessage = function() {
                if (!$scope.reps_list || $scope.reps_list.length === 0) {
                    window.location.href = '#/school/details';
                    return;
                }

                var ambassador = $scope.reps_list[0];

                $scope.$emit('COMPOSE_TO', {
                    'firstName': ambassador.name || '',
                    'id': ambassador.id,
                    'avatar': ambassador.avatar,
                    'subject': $translate.instant('ADMIN_VOLUNTEER_SUBJECT', { name: "" })
                })
            }

            $scope.createEvent = function() {
                $scope.creatingEvent = true;
                eventsService.get('event/v1/create/' + $rootScope.active_school.id + '/new', { 'cache': false }).then(function(response) {
                        $scope.creatingEvent = false;
                        $scope.event = response.data;
                        location.href = '#/events/create/' + $scope.event.id;
                    },
                    function(error) {

                    })
            }

            $scope.openEvent = function(event, isdraft) {

                if (isdraft || ($scope.isPastEvent({
                        date: {
                            startDate: event.startDate,
                            rsvpDate: event.rsvpDate,
                            endDate: event.endDate
                        }
                    }) && $rootScope.active_user.id === event.createdById && event.type === 'PARENT')) {
                    location.href = '#/events/create/' + event.eventId;
                    return;
                }

                if (event.type === 'RAFFLE') {
                    $state.go('raffle.details', { raffle_id: event.eventId });
                } else if ((!event.sample && $rootScope.active_user.id === event.createdById) && event.type !== 'COMMUNITY' && !$scope.isPastEvent({
                        date: {
                            startDate: event.startDate,
                            rsvpDate: event.rsvpDate,
                            endDate: event.endDate
                        }
                    })) {
                    location.href = '#/events/create/' + event.eventId;
                } else {
                    location.href = '#/events/view/' + event.eventId;
                }
            }

            function getEvents() {
                $scope.draft_events = new Array();
                $scope.new_events = new Array();
                $scope.past_events = new Array();

                eventsService.get('event/v1/list/' + $rootScope.active_school.id + '/new', { 'cache': false, 'xhr': true }).then(function(response) {
                        $scope.draft_events = response.data.draftEvents;
                        $scope.new_events = response.data.futureEvents;
                        $scope.past_events = response.data.pastEvents;

                        $rootScope.notifsContainer.events = 0;

                        $scope.viewState.isReady = true;
                        if (!$scope.draft_events && !$scope.new_events && !$scope.past_events) {
                            $scope.viewState.isEmpty = true;
                        } else {
                            $scope.viewState.isEmpty = false;
                        }

                        //console.log($scope.draft_events);
                    },
                    function(error) {
                        $scope.viewState.isReady = true;
                    })
            }

            getEvents();
        }

        if ($rootScope.active_school && $rootScope.app_base_ready) {
            baseService.app_initialized();
        }
    }
})();
(function() {
	'use strict';

	angular.module('modules.events.guests',[]).factory('eventGuestsService', ['base', function (base) {
		return _.create(base, { });
	}])
	.filter('filterguests', function() {
	return function(list, filter) {
		var out = [];

		if (!filter.keyword && !filter.type) {
			return list;
		}

		if(list)
			for(var i = 0; i < list.length; i++) {
				var guest = list[i];

				if (filter.keyword) {
					if ((guest.userName.toLowerCase().indexOf(filter.keyword.toLowerCase()) > -1)
						|| (guest.pupilNames.toLowerCase().indexOf(filter.keyword.toLowerCase()) > -1)) {
						out.push(guest)
					}
				}
				else if(filter.type) {
					switch(filter.type) {
						case 'ALL_REPLIED':
							if(guest.status !== 'PENDING') {
								out.push(guest)
							}
							break;
						case 'HAVENT_REPLIED':
							if(guest.status === 'PENDING') {
								out.push(guest)
							}
							break;
						case 'GOING':
							if(guest.status === 'GOING') {
								out.push(guest)
							}
							break;
						case 'MAYBE':
							if(guest.status === 'MAYBE') {
								out.push(guest)
							}
							break;
						case 'CANT_GO':
							if(guest.status === 'NOT_GOING') {
								out.push(guest)
							}
							break;
						case 'ALL_PURCHASED':
							if(guest.tickets) {
								out.push(guest)
							}
							break;

						case 'HAVENT_PURCHASED':
							if(!guest.tickets) {
								out.push(guest)
							}
							break;

						default:
							if(guest.tickets) {
								for(var j = 0; j < guest.tickets.length; j++) {
									var ticket = guest.tickets[j];

									if(ticket.name.toLowerCase().indexOf(filter.type.toLowerCase()) > -1) {
										out.push(guest);
									}
								}
							}
							break;
					}
				}
			}

		return out;
	}
	})
	.controller('eventGuestsController', eventGuestsController);

	/** @ngInject */
	function eventGuestsController(baseService, $scope, $state, regexes, $uibModal, settings, toastr, $translate, eventGuestsService, $location, $anchorScroll, $timeout, $rootScope, $window, $stateParams, storage) {
		$scope.id_event = $stateParams.id_event;
		$scope.members = new Array();
		$scope.selectedSelectFilter = { };
		$scope.sendGuestNotification = true;

		$scope.viewState = {
			isReady: false
		};
		
		// Init the beforeunlodpage on this page
		var onBeforeunload = $rootScope.$on('events.ticketedguests', function(evt, args) {
			var anychange = $scope.event.addNote ? true : false;

			if(anychange) {
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/base/views/window-beforeleave-modal.html',
					size:'md',
					controller: function($scope) {
						$scope.leave = function() {
							onBeforeunload();
							$state.go(args.toState.name, args.toParams);
						}
						$scope.stay = function() {
							modalInstance.close();
						};
					}
				})

				args.e.preventDefault();
			}
			else {
				onBeforeunload();
			}
		});

		// Init the beforeunlodpage on this page
		var onBeforeunload1 = $rootScope.$on('events.nonticketedguests', function(evt, args) {
			var anychange = $scope.event.addNote ? true : false;

			if(anychange) {
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/base/views/window-beforeleave-modal.html',
					size:'md',
					controller: function($scope) {
						$scope.leave = function() {
							onBeforeunload1();
							$state.go(args.toState.name, args.toParams);
						}
						$scope.stay = function() {
							modalInstance.close();
						};
					}
				})

				args.e.preventDefault();
			}
			else {
				onBeforeunload1();
			}
		});

		$scope.getEvent = function() {
			angular.element(document).ready(function() {
				eventGuestsService.get('event/v1/get/private/' + $scope.id_event, {'cache':false, 'xhr':true}).then(function(response) {
					$scope.event = response.data;

					if($scope.event.ticketed)
						$scope.getTicketedGuests()
					else
						$scope.getNonTicketedGuests()
				},
				function(error) {

				})
			});
		}

		$scope.putQuestion = function(event) {
			
			eventGuestsService.put('event/v1/update/' + event.id + '/question', { question: event.question }, { }).then(function(response) {
				event.addNote = false;
				toastr.success('Your question has been saved');
			},
			function (error) {
				
			});
		}

		$scope.checkIn = function(guest) {
			eventGuestsService.get('event/v1/update/' + guest.eventAnswerId + '/eventAnswer/checkedIn', { })
			.then(function (response) {

			},
			function (error) {

			})
		}

		$scope.getTotalTickets = function(list) {
			var tot = 0;

			if(!list)
				return tot;

			for(var i = 0; i < list.length; i++)
				tot += (list[i].price * list[i].sold);

			return tot;
		}

		$scope.getTicketedGuests = function() {
			angular.element(document).ready(function() {
				eventGuestsService.get('event/v1/list/' + $scope.id_event + '/guests/ticketed/v2', { 'cache':false, 'xhr':true }).then(function(response) {
					$scope.guests = response.data;
					$scope.viewState.isReady = true;
				},
				function(error) {

				})
			});
		}

		$scope.getNonTicketedGuests = function() {
			angular.element(document).ready(function() {
				eventGuestsService.get('event/v1/list/' + $scope.id_event + '/guests/nonTicketed', { 'cache':false, 'xhr':true }).then(function(response) {
					$scope.guests = response.data;
					$scope.viewState.isReady = true;
				},
				function(error) {

				})
			});
		}

		$scope.sendMessage = function(guest) {
			var name = guest.userName.split(' ');
			$scope.$emit('COMPOSE_TO',{
				'firstName':name[0] || '',
				'lastName': name[1] || '',
				'id': guest.userId,
				'avatar': guest.userAvatar
			})
		}

		baseService.app_initialized = function(evt, args) {
			$scope.getEvent();
		}

		if($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}

		$scope.openMobileMember = function(guest) {
			for(var i = 0; i < $scope.guests.guestList.length; i++) {
				$scope.guests.guestList[i].opened = false;
			}

			guest.opened = true;
		}

		$scope.keywordKeyup = function() {
			$scope.selectedSelectFilter.type = null;
		}

		$scope.selectFilterChanged = function(value) {
			$scope.selectedSelectFilter.keyword = null;
		}

		$scope.sendNotification = function() {

			if(!$scope.filteredItems || $scope.filteredItems.length === 0)
				return;

			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/events/views/send-notification-modal.html',
				size:'md',
				controller: function($scope) {

					$scope.send = function() {
						$scope.sendingNotification = true;
						eventGuestsService.post('event/v1/create/'+$scope.event.id+'/guests/notification', {
							message: $scope.notif_note,
							messageGroupType: $scope.selectedSelectFilter.type ? $scope.selectedSelectFilter.type.toLowerCase(): "going",
							guests: $scope.getFilteredIds()
						})
						.then(function(response) {
							modalInstance.close();
							$scope.notif_note = null;
							$scope.sendingNotification = false;
							toastr.info($translate.instant('NOTIFICATION_SENT_TO_SELECTED_LIST'))
						},
						function(error) {
							$scope.sendingNotification = false;
						})
					};

					$scope.close = function() {
						modalInstance.close();
					};
				}
			})
		}

		$scope.getFilteredIds = function() {
			var ids = [];

			for(var i = 0; i < $scope.filteredItems.length; i++) {
				ids.push($scope.filteredItems[i].userId)
			}
			
			return ids;
		}

		$scope.downloadList = function(isticketed) {
			var filter = "ALL_INVITED";
			var stopdownload = false;

			if(!$scope.filteredItems || $scope.filteredItems.length === 0) {
				stopdownload = true;
			}

			if($scope.selectedSelectFilter.type === 'HAVENT_REPLIED'
				|| $scope.selectedSelectFilter.type === 'HAVENT_PURCHASED') {
					stopdownload = true;
			}
				
			if(!$scope.selectedSelectFilter.type || !$scope.filteredItems) {
				stopdownload = true;
			}

			if(stopdownload) {
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/events/views/stopdownload-modal.html',
					size:'sm',
					controller: function($scope) {
						$scope.close = function() {
							modalInstance.close();
						};
					}
				})
				return;
			}

			if ($scope.selectedSelectFilter && $scope.selectedSelectFilter.type){
				filter = $scope.selectedSelectFilter.type;
			}

			var _api = settings.conf.api;
			
			if(isticketed) {

				var ticketId = 0;
				for (var i=0;i<$scope.guests.inviteCounts.ticketTypes.length;i++){
					var ticket = $scope.guests.inviteCounts.ticketTypes[i];
					if (ticket.ticketName === filter){
						ticketId = ticket.id;
						break;
					}
				}
				if($rootScope.isNative) {
					if(_api.indexOf('https://') > -1)
						_api = _api.replace('https://', 'http://')
				}

				if (ticketId !== 0) {
					filter = "TICKET_TYPE";
					window.open(_api + '/generator/attachment?type=attendeeTicketed&id='+$scope.event.id + "&listType=" + filter + '&tid='+ticketId+'&ids=' + $scope.getFilteredIds().join(','), '_self');
				}
				else {
					window.open(_api + '/generator/attachment?type=attendeeTicketed&id='+$scope.event.id + "&listType=" + filter + '&ids=' + $scope.getFilteredIds().join(','), '_self');
				}
			}
			else {
				window.open(_api + '/generator/attachment?type=attendee&id='+$scope.event.id + "&listType=" + filter + '&ids=' + $scope.getFilteredIds().join(','), '_self');
			}
		}

		$scope.sendReminder = function() {

			if(!$scope.filteredItems || $scope.filteredItems.length === 0 || $scope.event.status === 'CANCELLED')
				return;

			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/events/views/send-reminder-modal.html',
				size:'sm',
				controller: function($scope) {
					$scope.send = function() {
						modalInstance.close();

						eventGuestsService.put('event/v1/remind/' + $scope.event.id, {
							guests: $scope.getFilteredIds()
						},
						{ 
							'cache': false, 
							'xhr': true 
						})
						.then(function(response) {
							toastr.info($translate.instant('EVENT_ACTION_REMINDER_SUCCESS'));
						},
						function(error) {
							
						})
					};
					$scope.close = function() {
						modalInstance.close();
					};
				}
			})
		}

		$scope.gotoTickets = function() {
			if($scope.event.answerCount.invited === 0 || $scope.event.ticketed) {
				setTimeout(function() {
					location.href = '#/events/tickets/' + $scope.event.id;
				}, 10);
			}
			else {
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/events/views/before-ticketing-modal.html',
					size:'md',
					controller: function($scope) {
						$scope.close = function() {
							modalInstance.close();
						};
						$scope.gotit = function() {
							location.href = '#/events/tickets/' + $scope.event.id;
						};
					}
				})
			}
		}

		$scope.inviteGuests = function() {
			$scope.members = new Array();

			if(!$scope.event.title || !$scope.event.date.startDate) {
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/events/views/before-invite-modal.html',
					size:'sm',
					controller: function($scope) {
						$scope.close = function() {
							modalInstance.close();
						};
					}
				})
			}
			else {
				location.href = '#/events/invite/' + $scope.event.id;
			}
		}

		$scope.getMembers = function (string) {
			return eventGuestsService.get('search/v1/event/private/'+$rootScope.active_school.id+'/'+encodeURIComponent(string),{}).then(function (response) {
				return response.data.resultList
			},
			function (error) {

			})
		}

		$scope.pickMember = function (participant) {
			if(participant.type === 'user') {
				push(participant, false)
			}
			else if(participant.type === 'group') {
				explode(participant.id, participant.field1)
			}

			$scope.participant = null;
			setTimeout(function() {
				angular.element(document.querySelector('.input-event-invite-members'))[0].value = '';
			}, 1);
			$scope.member = '';
		}

		$scope.removeMember = function (participant) {
			var toBeRemoved = _.filter($scope.members, function(obj) {return obj.id === participant.id;});
			for (var i = 0; i < toBeRemoved.length; i++) {
				$scope.members = _.without($scope.members, toBeRemoved[i]);

				eventGuestsService.get('group/v1/parent/remove/member/'+participant.id).then(function (response) {
					toastr.info($translate.instant('USERS_REMOVED_INFO'))
				},
				function (error) {

				})
			}
		}

		function push(r, isBulk) {
			var includes = _.includes($scope.members, _.find($scope.members, {'id': r.id})),
				isMe = false;

			if(!includes && !isMe) {
				var toadd = {
					avatar: r.avatar || '',
					name: (r.firstName || r.field1) + ' ' + (r.lastName || r.field2),
					id: r.id,
					type: r.type || 'user',
					tierId: r.tierId || '',
					tierName: r.tierName || '',
					pupils: r.pupils || [],
					field3: r.field3 || []
				};

				$scope.members.unshift(toadd)
				return;
			}
			if(includes && !isBulk) {
				toastr.info($translate.instant('ADD_RECIPIENT_ALREADY_EXIST'))
			}
		}

		function explode(tierId, tierName) {
			eventGuestsService.get('group/v1/parent/private/group/members/'+tierId,{'cache':true}).then(function (response) {
				var toadd = [];
				
				_.forEach(response.data.resultList, function(r) {
					r.type = 'tier';
					r.tierName = tierName;
					r.tierId = tierId;
					toadd.push(r.id)
					push(r, true)
				})
			},
			function (error) {
				error.status === 403 ? toastr.error($translate.instant('CANT_SEE_PUPILS')) : _.noop()
			})
		}
	}
})();

(function() {
    'use strict';

    angular.module('modules.events.create', []).factory('eventsCreateService', ['base', function(base) {
        return _.create(base, {});
    }]).controller('eventsCreateController', eventsCreateController);

    /** @ngInject */
    function eventsCreateController(baseService, $scope, $state, regexes, $uibModal, settings, toastr, $translate, eventsService, uploadService, storage, $location, $anchorScroll, $timeout, $rootScope, $window, $stateParams) {

        $scope.regexes = regexes;
        $scope.routerState = $state;
        var schoolId;
        $scope.validContinue = true;
        $scope.members = new Array();
        $scope.saveAddressCheck = true;
        $scope.sendGuestNotification = true;
        $scope.isOnlineEvent = true;
        $scope.isSchoolEvent = false;
        $scope.budiSelection = {
            isBudiEvent: true,
            isExternal: false
        };

        $scope.viewState = {
            isReady: false
        }

        $scope.event = {
            id: $stateParams.id
        }

        $scope.validateLink = validateLink;
        $scope.invalidOnlineLink = false;

        $scope.events = {
            commentCallback: function(comment) {
                if (!$scope.event.comments) {
                    $scope.event.comments = [];
                }

                comment.avatar = $rootScope.active_user.avatar;
                comment.postedBy = $rootScope.active_user.firstName + ' ' + $rootScope.active_user.lastName;
                comment.body = $rootScope.parseTagsToLinks(comment.body);
                comment.body = $rootScope.parseMentionTags(comment.body);

                $scope.event.comments.push(comment);
                $scope.event.commentCount++;
            }
        }

        $scope.back = function() {
            $scope.triggerAutosave('');
            $rootScope.goback();
            // setTimeout(function() {
            // 	location.href = '#/events/list';
            // }, 50);
        }

        $scope.goToEvents = function() {
            window.location.href = '/parent/#/events/list'
        }
        $scope.getEvent = function() {
            angular.element(document).ready(function() {
                eventsService.get('event/v1/get/private/' + $scope.event.id, { 'cache': false, 'xhr': true }).then(function(response) {
                        $scope.event = response.data;
                        $scope.event_clone = angular.copy($scope.event);
                        //$scope.event_clone = eval('('+JSON.stringify(response.data)+')');
                        $scope.event._description = $scope.event.description.replace(/\r?\n/g, '<br />');
                        $scope.event._description = $rootScope.parseTagsToLinks($scope.event._description);
                        $scope.isOnlineEvent = $scope.event.online;
                        $scope.isSchoolEvent = !$scope.isOnlineEvent;
                        if ($scope.event.onlineEventType == 'EXTERNAL') {
                            $scope.budiSelection.isBudiEvent = false;
                            $scope.budiSelection.isExternal = true;

                            $scope.event.onlineLink = $scope.event.onlineEventExternalLink;
                            $scope.event.onlineEventExternalUsername = $scope.event.onlineExternalEventUserName;
                            $scope.event.onlineEventExternalPassword = $scope.event.onlineExternalEventPassword;
                        } else {
                            $scope.budiSelection.isBudiEvent = true;
                            $scope.budiSelection.isExternal = false;
                        }

                        $scope.viewState.isReady = true;

                        if (!$scope.event.date.updated) {
                            $scope.event.date.updated = $scope.event.date.created;
                        }

                        if ($scope.event.status === 'DRAFT')
                            $scope.showInfo = true;

                        $scope.eventPost = response.data.postDTO.payload.post;
                    },
                    function(error) {

                    })
            });
        }

        baseService.app_initialized = function(evt, args) {
            schoolId = $rootScope.active_school.id;
            $scope.getEvent();

            setTimeout(function() {
                $window.scrollTo(0, 0);
            }, 200);
        }

        if ($rootScope.active_school && $rootScope.app_base_ready) {
            baseService.app_initialized();
        }

        $scope.anyChange = function() {

            if ($scope.event.location.location !== $scope.event_clone.location.location) {
                return true;
            }

            if ($scope.event.date.startDate) {
                if (new Date($scope.event.date.startDate) - new Date($scope.event_clone.date.startDate) !== 0)
                    return true;
            }

            if ($scope.event.date.endDate) {
                if (new Date($scope.event.date.endDate) - new Date($scope.event_clone.date.endDate) !== 0)
                    return true;
            }

            if ($scope.event.date.rsvpDate) {
                if (new Date($scope.event.date.rsvpDate) - new Date($scope.event_clone.date.rsvpDate) !== 0)
                    return true;
            }

            return false;
        }

        $scope.updateChangeGuests = function() {

            if ($scope.event.status === 'ACTIVE' && $scope.anyChange()) {
                var modalInstance = $uibModal.open({
                    animation: true,
                    scope: $scope,
                    backdropClass: 'backdrop-zindexed',
                    templateUrl: 'app/events/views/update-notification-modal.html',
                    size: 'md',
                    controller: function($scope) {
                        $scope.sendNotification = function() {
                            $scope.event_clone.date.startDate = $scope.event.date.startDate;
                            $scope.event_clone.date.endDate = $scope.event.date.endDate;
                            $scope.event_clone.date.rsvpDate = $scope.event.date.rsvpDate;
                            $scope.event_clone.location.location = $scope.event.location.location;

                            $scope.gotoGuests();
                        };
                        $scope.close = function() {
                            $scope.event_clone.date.startDate = $scope.event.date.startDate;
                            $scope.event_clone.date.endDate = $scope.event.date.endDate;
                            $scope.event_clone.date.rsvpDate = $scope.event.date.rsvpDate;
                            $scope.event_clone.location.location = $scope.event.location.location;
                            modalInstance.close();
                        };
                    }
                })
            }
        }

        $scope.eventStartDateOptions = {
            // options: {
            // 	defaultDate: new Date(),
            // 	minDate: new Date(),
            // 	maxDate: new Date()
            // },
            onDateSelect: function(date) {
                eventsService.put('event/v1/update/' + $scope.event.id + '/startdate', {
                        date: $rootScope.getWithoutTimeZone(date)
                    })
                    .then(function(response) {
                            $scope.event.date.startDate = $rootScope.getWithoutTimeZone(date);
                            $scope.event.date.updated = new Date();

                            $scope.updateChangeGuests();
                        },
                        function(error) {
                            if (error.data.error.code === 400) {
                                toastr.error($translate.instant(error.data.error.message));
                            } else {
                                //Skip for now.
                            }
                        })
            }
        }

        $scope.eventEndDateOptions = {
            options: {

            },
            onDateSelect: function(date) {
                eventsService.put('event/v1/update/' + $scope.event.id + '/enddate', {
                        date: $rootScope.getWithoutTimeZone(date)
                    })
                    .then(function(response) {
                            $scope.event.date.endDate = $rootScope.getWithoutTimeZone(date);
                            $scope.event.date.updated = new Date();
                            $scope.eventEndDateOptions.options.minDate = $scope.event.date.endDate;

                            $scope.updateChangeGuests();
                        },
                        function(error) {
                            if (error.data.error.code === 400) {
                                toastr.error($translate.instant(error.data.error.message));
                            } else {
                                //Skip for now.
                            }
                        })
            },
            clear: function() {
                $scope.event.date.endDate = null;
                $scope.event.date.updated = new Date();
                $scope.eventEndDateOptions.options.minDate = $scope.event.date.startDate;

                eventsService.put('event/v1/remove/' + $scope.event.id + '/enddate').then(function(response) {

                    },
                    function(error) {
                        if (error.data.error.code === 400) {
                            toastr.error($translate.instant(error.data.error.message));
                        } else {
                            //Skip for now.
                        }
                    })
            }
        }

        $scope.eventRSVPDateOptions = {
            options: {

            },
            onDateSelect: function(date) {
                eventsService.put('event/v1/update/' + $scope.event.id + '/rsvpdate', {
                        date: $rootScope.getWithoutTimeZone(date)
                    })
                    .then(function(response) {
                            $scope.event.date.rsvpDate = $rootScope.getWithoutTimeZone(date);
                            $scope.event.date.updated = new Date();
                            $scope.eventRSVPDateOptions.options.minDate = $scope.event.date.rsvpDate;

                            $scope.updateChangeGuests();
                        },
                        function(error) {
                            if (error.data.error.code === 400) {
                                toastr.error($translate.instant(error.data.error.message));
                            } else {
                                //Skip for now.
                            }
                        })
            },
            clear: function() {
                $scope.event.date.rsvpDate = null;
                $scope.event.date.updated = new Date();
                $scope.eventRSVPDateOptions.options.rsvpDate = null;
                $scope.eventRSVPDateOptions.options.minDate = $scope.event.date.startDate;

                eventsService.put('event/v1/remove/' + $scope.event.id + '/rsvpdate').then(function(response) {

                    },
                    function(error) {
                        if (error.data.error.code === 400) {
                            toastr.error(error.data.error.message);
                        } else {
                            //Skip for now.
                        }
                    })
            }
        }

        var fileUploader = document.getElementById('fileUploader');

        $scope.fileUploadDialog = function() {
            fileUploader.click();
        }

        $scope.closeInfo = function() {
            $scope.showInfo = false;
        }

        $scope.closeInfoRSVP = function() {
            $scope.showInfoRSVP = false;
        }

        $scope.openInfoRSVP = function() {
            $scope.showInfoRSVP = true;
        }

        $scope.uploadImage = function() {
            $rootScope.$broadcast('UPLOAD_PHOTO', {
                'callback_fn': function(response) {
                    var url = eventsService.getPostImgBucketUrl() + '/' + response.data;
                    $scope.event.fileLibrary.image = url;
                    $scope.event.photoId = response.data || '';

                    eventsService.post('event/v1/update/' + $scope.event.id + '/image', { image: $scope.event.photoId }).then(function(response) {

                        },
                        function(error) {

                        })
                },
                'action': 'eventUpload',
                'config': 'eventCropper',
                'on_close': function() {
                    $scope.pickGallery();
                }
            });
        }

        $scope.pickGallery = function() {
            $scope.$broadcast('GALLERY_PICKER', {
                'on_select': function(obj) {
                    $scope.event.fileLibrary.image = obj.url;
                    $scope.event.photoId = obj.id || '';

                    eventsService.post('event/v1/update/' + $scope.event.id + '/image', { image: obj.id }).then(function(response) {

                        },
                        function(error) {

                        })
                },
                'on_upload': function() {
                    $scope.uploadImage();
                }
            });
        }

        $scope.inviteGuests = function() {
            $scope.triggerAutosave('');
            $scope.members = new Array();

            if (!$scope.event.title || !$scope.event.date.startDate) {
                var modalInstance = $uibModal.open({
                    animation: true,
                    scope: $scope,
                    backdropClass: 'backdrop-zindexed',
                    templateUrl: 'app/events/views/before-invite-modal.html',
                    size: 'sm',
                    controller: function($scope) {
                        $scope.close = function() {
                            modalInstance.close();
                        };
                    }
                })
            } else {
                location.href = '#/events/invite/' + $scope.event.id;
            }
        }

        $scope.showGuests = function(type) {
            function openModal(participants) {
                var modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: 'app/inbox/views/show-participants-modal.html',
                    backdropClass: 'backdrop-zindexed',
                    size: 'sm',
                    controller: function($scope) {
                        $scope.participants = participants;
                        $scope.eventContext = true;
                        $scope.addDisabled = true;
                        $scope.viewState = {
                            isReady: true
                        }

                        $scope.openAddParticipantsModal = function() {
                            activateInviteGuests();
                        }

                        $scope.close = function() {
                            modalInstance.close();
                        }
                    }
                })
            }

            eventsService.get('event/v1/get/' + $scope.event.id + '/attendees/' + type, { 'cache': false }).then(function(response) {
                    if (response.data.items) {
                        openModal(response.data.items)
                    }
                },
                function(error) {

                })
        }

        $scope.switchAddress = function(saved) {
            $scope.selectedAddress = null;
            $scope.tabNewAddress = saved;
        }

        $scope.selectAddress = function(addr, index) {
            addr.index = index;
            $scope.selectedAddress = addr;
        }

        $scope.deleteAddress = function(addr, index) {
            $scope.savedAddresses.splice(index, 1);

            eventsService.delete('location/v1/delete/location/' + addr.id, {}).then(function(response) {
                    toastr.info($translate.instant('ADDRESS_DELETED'));
                },
                function(error) {

                })
        }

        $scope.$watch('event.g_location', function(newValue, oldValue) {
            $scope.selectedAddress = null;

            if (newValue) {
                if (newValue.fullAddress) {
                    $scope.selectedAddress = {
                        placeId: newValue.isRealAddress ? newValue.locationId : null,
                        location: newValue.fullAddress
                    }
                }
            }
        });

        $scope.getSavedLocations = function() {
            eventsService.get('location/v1/list/location/' + $rootScope.active_school.id, {}).then(function(response) {
                    $scope.savedAddresses = response.data.items;

                    if ($scope.savedAddresses.length === 0)
                        $scope.tabNewAddress = true;
                },
                function(error) {

                })
        }

        $scope.saveLocation = function(placeId, success) {
            eventsService.post('location/v1/create/location/' + $rootScope.active_school.id + '/place', { placeId: placeId }).then(function(response) {
                    if (success)
                        success();
                },
                function(error) {

                })
        }

        $scope.addLocation = function() {
            $scope.tabNewAddress = false;
            $scope.selectedAddress = null;

            $scope.getSavedLocations();

            var modalInstance = $uibModal.open({
                animation: true,
                scope: $scope,
                backdropClass: 'backdrop-zindexed',
                templateUrl: 'app/events/views/location-modal.html',
                size: 'md',
                controller: function($scope) {

                    $scope.save = function() {
                        if (!$scope.selectedAddress)
                            return;

                        var det = $scope.event.location.locationDetail;
                        $scope.event.location = $scope.selectedAddress;
                        $scope.event.location.locationDetail = det;

                        if (!$scope.tabNewAddress) {

                            if ($scope.selectedAddress.id === 0) {
                                $scope.addingLocation = true;
                                eventsService.put('event/v1/update/' + $scope.event.id + '/location/address', {
                                        plainAddress: $scope.selectedAddress.plainLocation
                                    })
                                    .then(function(response) {
                                            $scope.addingLocation = false;
                                            $scope.event.date.updated = new Date();

                                            if (!$scope.tabNewAddress)
                                                $scope.event.location.location = $scope.event.location.plainLocation;

                                            modalInstance.close();
                                            $scope.updateChangeGuests();
                                        },
                                        function(error) {
                                            $scope.addingLocation = false;
                                        })
                            } else {
                                $scope.addingLocation = true;
                                eventsService.put('event/v1/update/' + $scope.event.id + '/location/locationid', {
                                        locationId: $scope.selectedAddress.id
                                    })
                                    .then(function(response) {
                                            $scope.addingLocation = false;
                                            $scope.event.date.updated = new Date();

                                            if (!$scope.tabNewAddress)
                                                $scope.event.location.location = $scope.event.location.plainLocation;

                                            modalInstance.close();
                                            $scope.updateChangeGuests();
                                        },
                                        function(error) {
                                            $scope.addingLocation = false;
                                        })
                            }
                        } else {
                            $scope.addingLocation = true;
                            eventsService.put('event/v1/update/' + $scope.event.id + '/location/placeid', {
                                placeId: $scope.event.location.placeId,
                                plainAddress: $scope.event.location.location,
                                save: $scope.saveAddressCheck

                            }).then(function(response) {
                                    $scope.addingLocation = false;
                                    $scope.event.date.updated = new Date();

                                    if (!$scope.tabNewAddress)
                                        $scope.event.location.location = $scope.event.location.plainLocation;

                                    modalInstance.close();
                                    $scope.updateChangeGuests();
                                },
                                function(error) {
                                    $scope.addingLocation = false;
                                })
                        }

                        // if(!$scope.tabNewAddress)
                        // 	$scope.event.location.location = $scope.event.location.plainLocation;

                        // modalInstance.close();
                        // $scope.updateChangeGuests();
                    };
                    $scope.close = function() {
                        modalInstance.close();
                    };
                }
            })
        }

        $scope.deleteEvent = function() {
            var modalInstance = $uibModal.open({
                animation: true,
                scope: $scope,
                backdropClass: 'backdrop-zindexed',
                templateUrl: 'app/events/views/delete-modal.html',
                size: 'sm',
                controller: function($scope) {

                    $scope.save = function() {
                        $scope.deletingEvent = true;

                        eventsService.get('event/v1/update/' + $scope.event.id + '/delete').then(function(response) {
                                $scope.deletingEvent = false;
                                modalInstance.close();
                                location.href = '#/events/list';
                                toastr.info($translate.instant('EVENT_DELETED_INFO'));
                            },
                            function(error) {
                                $scope.deletingEvent = false;

                            })
                    };
                    $scope.close = function() {
                        modalInstance.close();
                    };
                }
            })
        }

        $scope.cancelEvent = function() {
            var modalInstance = $uibModal.open({
                animation: true,
                scope: $scope,
                backdropClass: 'backdrop-zindexed',
                templateUrl: 'app/events/views/cancel-modal.html',
                size: 'md',
                controller: function($scope) {
                    $scope.cancelMessage = $translate.instant('CANCEL_EVENT_DEFAULT_MESSAGE') + $rootScope.active_user.firstName;

                    $scope.save = function() {
                        $scope.cancellingEvent = true;

                        eventsService.post('event/v1/update/' + $scope.event.id + '/cancel', {
                                message: $scope.cancelMessage
                            })
                            .then(function(response) {
                                    $scope.cancellingEvent = false;
                                    modalInstance.close();
                                    location.href = '#/events/list';
                                    toastr.info($translate.instant('EVENT_CANCELLED_INFO'));
                                },
                                function(error) {
                                    $scope.cancellingEvent = false;

                                })
                    };
                    $scope.close = function() {
                        modalInstance.close();
                    };
                }
            })
        }

        // $scope.getMembers = function (string) {
        // 	return eventsService.get('search/v1/event/private/'+$rootScope.active_school.id+'/'+encodeURIComponent(string),{}).then(function (response) {
        // 		return response.data.resultList
        // 	}, 
        // 	function (error) {

        // 	})
        // }

        // $scope.pickMember = function (participant) {
        // 	if(participant.type === 'user') {
        // 		push(participant, false)
        // 	} 
        // 	else if(participant.type === 'group') {
        // 		explode(participant.id, participant.field1)
        // 	}

        // 	$scope.participant = null;
        // 	setTimeout(function() {
        // 		angular.element(document.querySelector('.input-event-invite-members'))[0].value = '';
        // 	}, 1);
        // 	$scope.member = '';
        // }

        // $scope.removeMember = function (participant) {
        // 	var toBeRemoved = _.filter($scope.members, function(obj) {return obj.id === participant.id;});
        // 	for (var i = 0; i < toBeRemoved.length; i++) {
        // 		$scope.members = _.without($scope.members, toBeRemoved[i]);
        // 	}
        // }

        // function push(r, isBulk) {
        // 	var includes = _.includes($scope.members, _.find($scope.members, {'id': r.id})),
        // 		isMe = false;

        // 	if(!includes && !isMe) {
        // 		var toadd = {
        // 			avatar: r.avatar || '',
        // 			name: (r.firstName || r.field1) + ' ' + (r.lastName || r.field2),
        // 			id: r.id,
        // 			type: r.type || 'user',
        // 			tierId: r.tierId || '',
        // 			tierName: r.tierName || '',
        // 			pupils: r.pupils || [],
        // 			field3: r.field3 || []
        // 		};

        // 		$scope.members.unshift(toadd)
        // 		return;
        // 	}
        // 	if(includes && !isBulk) {
        // 		toastr.info($translate.instant('ADD_RECIPIENT_ALREADY_EXIST'))
        // 	}
        // }

        // function explode(tierId, tierName) {
        // 	eventsService.get('group/v1/parent/private/group/members/'+tierId,{'cache':true}).then(function (response) {
        // 		var toadd = [];

        // 		_.forEach(response.data.resultList, function(r) {
        // 			r.type = 'tier';
        // 			r.tierName = tierName;
        // 			r.tierId = tierId;
        // 			toadd.push(r.id)
        // 			push(r, true)
        // 		})
        // 	}, 
        // 	function (error) {
        // 		error.status === 403 ? toastr.error($translate.instant('CANT_SEE_PUPILS')) : _.noop()
        // 	})
        // }

        $scope.triggerAutosave = function(type) {
            if (!isThisMobile())
                return;

            if (type !== 'title' && $scope.editingTitle)
                $scope.saveTitle();

            if (type !== 'descr' && $scope.editingDescr)
                $scope.saveDescr();

            if (type !== 'createdBy' && $scope.editingCreatedby)
                $scope.saveCreatedby();

            if (type !== 'locationDetail' && $scope.editingLocationDetail)
                $scope.saveLocationDetail();
        }

        $scope.editTitle = function(e) {
            $scope.triggerAutosave('title');

            $scope.editingTitle = true;
            $scope.valueTitle = $scope.event.title;

            var elem = angular.element(e.srcElement).parent()
            focusClickEditor(e);
        }

        $scope.cancelTitle = function() {
            $scope.editingTitle = false;
        }

        $scope.saveOutsideTitle = function() {
            if (!isThisMobile() && $scope.editingTitle)
                $scope.saveTitle()
        }

        $scope.stopPropagation = function(e) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }

        $scope.saveTitle = function() {
            $scope.event.title = $scope.valueTitle ? $scope.valueTitle : $scope.event.title;
            $scope.editingTitle = false;

            eventsService.put('event/v1/update/' + $scope.event.id + '/title', { title: $scope.event.title }).then(function(response) {
                    $scope.event.date.updated = new Date();
                },
                function(error) {

                })
        }

        $scope.editDescr = function(e) {
            $scope.triggerAutosave('descr');
            $rootScope.$broadcast('RESIZE_TO_LARGE');

            $scope.editingDescr = true;
            $scope.valueDescr = $rootScope.removeLinks($scope.event.description)
            focusClickEditor(e);
        }

        $scope.cancelDescr = function() {
            $scope.editingDescr = false;
        }

        $scope.saveOutsideDescr = function() {
            if (!isThisMobile() && $scope.editingDescr)
                $scope.saveDescr()
        }

        $scope.saveDescr = function() {
            $scope.event.description = $scope.valueDescr;
            $scope.event.description = $rootScope.createEmailLinks($scope.event.description);
            $scope.event._description = $scope.event.description.replace(/\r?\n/g, '<br />');
            $scope.event._description = $rootScope.parseTagsToLinks($scope.event._description)
            $scope.editingDescr = false;

            eventsService.put('event/v1/update/' + $scope.event.id + '/description', { description: $scope.event.description }).then(function(response) {
                    $scope.event.date.updated = new Date();
                },
                function(error) {

                })
        }

        $scope.editCreatedby = function(e) {
            $scope.triggerAutosave('createdBy');

            $scope.editingCreatedby = true;
            $scope.valueCreatedby = $scope.event.createdByName;
            focusClickEditor(e);
        }

        $scope.cancelCreatedby = function() {
            $scope.editingCreatedby = false;
        }

        $scope.saveOutsideCreatedby = function() {
            if (!isThisMobile() && $scope.editingCreatedby)
                $scope.saveCreatedby()
        }

        $scope.saveCreatedby = function() {
            $scope.event.createdByName = $scope.valueCreatedby ? $scope.valueCreatedby : $scope.event.createdByName;
            $scope.editingCreatedby = false;

            eventsService.put('event/v1/update/' + $scope.event.id + '/createdby', { createdByName: $scope.event.createdByName }).then(function(response) {
                    $scope.event.date.updated = new Date();
                },
                function(error) {

                })
        }

        $scope.editLocationDetail = function(e) {
            $scope.triggerAutosave('locationDetail');

            $scope.editingLocationDetail = true;
            $scope.valueLocationDetail = $scope.event.location.locationDetail;
            focusClickEditor(e);
            setTimeout(function() {
                $scope.$apply();
            }, 5);
        }

        $scope.cancelLocationDetail = function() {
            $scope.editingLocationDetail = false;
        }

        $scope.saveOutsideLocationDetail = function() {
            if (!isThisMobile() && $scope.editingLocationDetail)
                $scope.saveLocationDetail()
        }

        $scope.saveLocationDetail = function() {
            $scope.event.location.locationDetail = $scope.valueLocationDetail;
            $scope.editingLocationDetail = false;

            eventsService.put('event/v1/update/' + $scope.event.id + '/location/detail', { locationDetail: $scope.event.location.locationDetail }).then(function(response) {
                    $scope.event.date.updated = new Date();
                },
                function(error) {

                })
        }

        $scope.addAttachment = function(id, filename) {

            eventsService.post('attachment/v1/create/attachment/' + $rootScope.active_school.id, {
                id: id,
                name: filename,
                reference: $scope.event.id,
                type: 'EVENT'

            }).then(function(response) {
                    if (!$scope.event.fileLibrary.attachment)
                        $scope.event.fileLibrary.attachment = new Array();

                    $scope.event.date.updated = new Date();
                    $scope.event.fileLibrary.attachment.push(response.data)
                    toastr.info($translate.instant('ATTACHED_SUCCESSFULLY'));
                },
                function(error) {

                })
        }

        $scope.deleteAttachment = function(att, index) {
            $scope.event.fileLibrary.attachment.splice(index, 1);

            eventsService.delete('attachment/v1/delete/attachment/' + att.id, {}).then(function(response) {
                    toastr.info($translate.instant('ATTACHMENT_DELETED'));
                },
                function(error) {

                })
        }

        $scope.gotoPreview = function() {
            $scope.triggerAutosave('');

            setTimeout(function() {
                location.href = '#/events/view/' + $scope.event.id;
            }, 50);
        }

        $scope.gotoGuests = function() {
            $scope.triggerAutosave('');

            setTimeout(function() {
                if ($scope.event.ticketed)
                    location.href = '#/events/ticketedguests/' + $scope.event.id;
                else
                    location.href = '#/events/nonticketedguests/' + $scope.event.id;
            }, 50);
        }

        $scope.gotoTickets = function() {
            $scope.triggerAutosave('');

            if ($scope.event.answerCount.invited === 0 || $scope.event.ticketed) {
                setTimeout(function() {
                    location.href = '#/events/tickets/' + $scope.event.id;
                }, 10);
            } else {
                var modalInstance = $uibModal.open({
                    animation: true,
                    scope: $scope,
                    backdropClass: 'backdrop-zindexed',
                    templateUrl: 'app/events/views/before-ticketing-modal.html',
                    size: 'md',
                    controller: function($scope) {
                        $scope.close = function() {
                            modalInstance.close();
                        };
                        $scope.gotit = function() {
                            location.href = '#/events/tickets/' + $scope.event.id;
                        };
                    }
                })
            }
        }

        $scope.updateIsOnlineEvent = function(value) {
            var payload = {
                online: value
            };

            eventsService.put('event/v1/update/' + $scope.event.id + '/online', payload).then(function(response) {

            }, function(error) {
                if (error.data.error.code == 400) {
                    $scope.errorMessage = error.data.error.message;
                } else {
                    toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
                }
            });
            setTimeout(function() {
                if (value) {
                    // PWA-8263 do not set the event as budi. Timeout value slightly extended as well to avoid error
                    $scope.updateBudiEvent(false);
                }
            }, 250);
        }

        $scope.updateBudiEvent = function(isBudi) {
            var payload = {
                onlineEventType: 'EXTERNAL'
            }

            $scope.budiSelection.isExternal = true;

            // PWA-8214 focus on the link input immediately
            // PWA-8263 simply prevent the type being set as EXTERNAL
            if ($scope.budiSelection.isBudiEvent == 'EXTERNAL') {
                document.getElementById("event-ext-link").focus();
            }

            eventsService.put('event/v1/update/' + $scope.event.id + '/onlinetype', payload).then(function(response) {

                },
                function(error) {
                    toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
                })
        }

        $scope.validateExternalOnlineLink = function() {

            // PWA-8214 validate the link if external
            if ($scope.event.onlineLink === undefined || $scope.event.onlineLink.length == 0) {
                // the event is online but not budi, and the link is not defined
                toastr.error($translate.instant('NO_EXT_ONLINE_LINK_ERROR'));
                document.getElementById("event-ext-link").style.borderColor = 'red';
                document.getElementById("event-ext-link").style.borderStyle = 'solid';
                document.getElementById("event-ext-link").focus();
                return false;
            }

            if (!$scope.validateLink($scope.event.onlineLink)) {
                $scope.invalidOnlineLink = true;
                document.getElementById("event-ext-link").style.borderColor = 'red';
                document.getElementById("event-ext-link").style.borderStyle = 'solid';
                document.getElementById("event-ext-link").focus();
                return false;

            }
            $scope.invalidOnlineLink = false;
            document.getElementById("event-ext-link").style.borderColor = 'black';
            document.getElementById("event-ext-link").style.borderStyle = 'solid';
            return true;
        }

        $scope.saveOnlineLink = function() {
            if (!$scope.validateExternalOnlineLink()) return;

            var payload = {
                onlineEventExternalLink: $scope.event.onlineLink
            }
            eventsService.put('event/v1/update/' + $scope.event.id + '/onlinelink', payload).then(function(response) {},
                function(error) {
                    toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
                })
        }

        $scope.saveOnlineEventExternalUsername = function() {
            if (!$scope.event.onlineEventExternalUsername) return;

            var payload = {
                onlineEventExternalUsername: $scope.event.onlineEventExternalUsername
            }
            eventsService.put('event/v1/update/' + $scope.event.id + '/onlinelinkusername', payload).then(function(response) {},
                function(error) {
                    toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
                })
        }

        $scope.saveOnlineEventExternalPassword = function() {
            if (!$scope.event.onlineEventExternalPassword) return;

            var payload = {
                onlineEventExternalPassword: $scope.event.onlineEventExternalPassword
            }
            eventsService.put('event/v1/update/' + $scope.event.id + '/onlinelinkpassword', payload).then(function(response) {},
                function(error) {
                    toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
                })
        }


        $scope.checkValidLink = function() {
            if (!$scope.validateExternalOnlineLink()) return;
        }

        $scope.openBudiHelp = function() {
            window.open('https://help.classlist.com/hc/en-us/articles/360013553397', '_blank');
        }

        $scope.openBudiSignUp = function() {
            window.open('https://help.classlist.com/hc/en-us/articles/360013553397', '_blank');
        }

        $scope.openCommentImage = function(url) {
            if ($rootScope.isNative) {
                $rootScope.previewImage(url)
            } else {
                window.open(url + '=s0', '_blank')
            }
        }

        function focusClickEditor(e) {
            if (!e)
                return;

            var elem = angular.element(e.srcElement).parent()

            setTimeout(function() {
                if (elem.length > 0) {
                    if (elem[0].getElementsByTagName('input').length > 0) {
                        elem[0].getElementsByTagName('input')[0].focus();
                    } else if (elem[0].getElementsByTagName('textarea').length > 0) {
                        elem[0].getElementsByTagName('textarea')[0].focus();
                    }
                }
            }, 1);
        }

        function openSuccessModal(id) {
            var modalInstance = $uibModal.open({
                animation: true,
                backdropClass: 'backdrop-zindexed',
                backdrop: 'static',
                templateUrl: 'app/events/views/event-success-modal.html',
                size: 'sm',
                controller: function($scope) {
                    $rootScope.isDirty = false;
                    $scope.id = id;
                    $scope.close = function() {
                        modalInstance.close();
                    };
                }
            })
        }

        fileUploader.onchange = function() {

            var file = fileUploader.files[0],
                reader = new FileReader();

            if (file) {
                reader.readAsDataURL(file);
            }

            if (file.size > 8000000) {
                toastr.info($translate.instant('FILE_SIZE_TOO_BIG'));
                return;
            }

            reader.addEventListener('load', function() {
                $scope.isUploading = true;

                uploadService.fileUpload(dataURItoBlob(reader.result), {
                        headers: {
                            'Content-Type': undefined,
                            'ClasslistToken': storage.getToken() || '',
                            'ClasslistCfg': angular.toJson({
                                'type': 'ATTACHMENT'
                            })
                        }
                    }, file.name)
                    .then(function(response) {
                            $scope.addAttachment(response.data, file.name);
                            $scope.isUploading = false;
                        },
                        function(error) {
                            if (error.status === 403 || error.status === 409) {
                                toastr.error($translate.instant(error.data));
                            } else {
                                //Skip for now.
                            }

                            $scope.isUploading = false;
                        });
            }, false);

            setTimeout(function() {
                fileUploader.value = '';
            }, 1000);
        }

        function dataURItoBlob(dataURI) {
            var byteString = atob(dataURI.split(',')[1]);
            var ab = new ArrayBuffer(byteString.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ab], { type: 'image/jpeg' });
        }
    }
})();
(function() {
    'use strict';

    angular.module('modules.events.buytickets', []).factory('eventTicketsService', ['base', function(base) {
        return _.create(base, {});
    }]).controller('eventBuyticketsController', eventBuyticketsController);

    /** @ngInject */
    function eventBuyticketsController(baseService, $scope, $state, regexes, $uibModal, settings, toastr, $translate, eventTicketsService, $location, $anchorScroll, $timeout, $rootScope, $window, $stateParams, storage) {
        $scope.id_event = $stateParams.id_event;
        $scope.validateEmail = validateEmail;
        var stripe;
        var card;
        $scope.totalPayment = 0;

        $scope.viewState = {
            isReady: false
        };

        // Init the beforeunlodpage on this page
        var onBeforeunload = $rootScope.$on('events.buytickets', function(evt, args) {
            // var anychange = $scope.ticket.is_free ? $scope.ticket.hasAnyChangeFree() : $scope.ticket.hasAnyChangePaid()

            // if(anychange) {
            // 	var modalInstance = $uibModal.open({
            // 		animation: true,
            // 		scope: $scope,
            // 		backdropClass: 'backdrop-zindexed',
            // 		templateUrl: 'app/base/views/window-beforeleave-modal.html',
            // 		size:'md',
            // 		controller: function($scope) {
            // 			$scope.leave = function() {
            // 				onBeforeunload();
            // 				$state.go(args.toState.name, args.toParams);
            // 			}
            // 			$scope.stay = function() {
            // 				modalInstance.close();
            // 			};
            // 		}
            // 	})

            // 	args.e.preventDefault();
            // }
            // else {
            onBeforeunload();
            //}
        });

        $scope.loadStripe = function() {
            var node = document.createElement('script');
            node.src = 'https://js.stripe.com/v3/';
            node.type = 'text/javascript';
            node.async = false;
            document.getElementsByTagName('head')[0].appendChild(node);
            $rootScope.stripeLoaded = true;
        }

        $scope.getEvent = function() {
            angular.element(document).ready(function() {
                eventTicketsService.get('event/v1/get/private/' + $scope.id_event, { 'cache': false, 'xhr': true }).then(function(response) {
                        $scope.event = response.data;
                        $scope.viewState.isReady = true;

                        $scope.getTickets();
                    },
                    function(error) {

                    })
            });
        }

        $scope.getTickets = function() {
            $scope.ticketList = {};

            $rootScope.refreshNotifications()

            eventTicketsService.get('event/v1/list/' + $scope.event.id + '/remaining/tickets', { 'cache': false, 'xhr': true })
                .then(function(response) {
                        if (response.data) $scope.ticketList = response.data;
                        // console.log($scope.ticketList);

                        $scope.initStripe(response.data.paymentProvider.accountId);
                    },
                    function(error) {

                    })
        }

        baseService.app_initialized = function(evt, args) {
            if(!$rootScope.stripeLoaded) {
                $scope.loadStripe();
            }
            $scope.getEvent();
        }

        if ($rootScope.active_school && $rootScope.app_base_ready) {
            baseService.app_initialized();
        }

        $scope.getNumber = function(num) {
            // To display only 20 item as options
            if(num > 20) {
                return new Array(21);
            }
            return new Array(num);
        }

        $scope.getTotalTickets = function(list) {
            var tot = 0;

            if (!list)
                return tot;

            for (var i = 0; i < list.length; i++) {

                if (list[i].quantity) {
                    tot += (list[i].quantity * list[i].ticketPrice);
                } else if (list[i].donationAmount && list[i].donationAmount >= 1.00) {
                    tot += parseFloat(list[i].donationAmount);
                }
            }
            
            $scope.totalPayment = tot;
            return tot;
        }

        $scope.getTicketsCount = function(list) {
            var count = 0;

            if (!list)
                return count;

            for (var i = 0; i < list.length; i++)
                count += list[i].quantity;

            return count;
        }

        $scope.initStripe = function(accountId) {
            stripe = Stripe(settings.conf.stripeKey, {
                stripeAccount: accountId
            });
            var elements = stripe.elements();

            var style = {
                base: {
                    color: '#32325d',
                    lineHeight: '18px',
                    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                    fontSmoothing: 'antialiased',
                    fontSize: '16px',
                    '::placeholder': {
                        color: '#aab7c4'
                    }
                },
                invalid: {
                    color: '#fa755a',
                    iconColor: '#fa755a'
                }
            };

            // Create an instance of the card Element.
            card = elements.create('card', { style: style });

            // Add an instance of the card Element into the `card-element` <div>.
            card.mount('#card-element');

            // Handle real-time validation errors from the card Element.
            card.addEventListener('change', function(event) {
                var displayError = document.getElementById('card-errors');

                if (event.error) {
                    displayError.textContent = event.error.message;
                } else {
                    displayError.textContent = '';
                }
            });
        }

        $scope.stripeSubmit = function() {
            $scope.buingTickets = true;

            var payload = {
                eventId: $scope.event.id,
                token: '',
                tickets: []
            };

            for (var i = 0; i < $scope.ticketList.tickets.length; i++) {

                if ($scope.ticketList.tickets[i].quantity && $scope.ticketList.tickets[i].quantity > 0) {
                    payload.tickets.push({
                        ticketTypeId: $scope.ticketList.tickets[i].id,
                        quantity: $scope.ticketList.tickets[i].quantity
                    })
                } else if ($scope.ticketList.tickets[i].donationAmount && $scope.ticketList.tickets[i].donationAmount >= 1.00) {
                    payload.tickets.push({
                        ticketTypeId: $scope.ticketList.tickets[i].id,
                        donationAmount: $scope.ticketList.tickets[i].donationAmount
                    })
                }
            }

            if (payload.tickets.length === 0) {
                $scope.buingTickets = false;

                setTimeout(function() {
                    $scope.$apply()
                }, 2);

                toastr.info($translate.instant('EVENT_SELECT_TICKETS'));
                return false;
            }

            stripe.createPaymentMethod('card', card).then(function(result) {
                if (result.error) {
                    $scope.buingTickets = false;
                    var errorElement = document.getElementById('card-errors');
                    if (errorElement)
                        errorElement.textContent = result.error.message;

                    setTimeout(function() {
                        $scope.$apply()
                    }, 3);
                } else {
                    payload.token = result.paymentMethod.id;
                    eventTicketsService.post('payment/v1/event/payment/stripe', payload, {
                            'cache': false,
                            'xhr': true
                        })
                        .then(function(response) {

                                setTimeout(function() {
                                    $scope.$apply()
                                }, 4);

                                if (response && response.data) {
                                    if (response.data.requiresAction) {
                                        handleAction(response.data)
                                        return;
                                    }
                                }

                                $scope.buingTickets = false;
                                // console.log(response);
                                window.location.href = '/parent/#/events/ticket/' + payload.eventId + '/' + response.data.logId;
                            },
                            function(error) {
                                $scope.buingTickets = false;

                                if (error.data.error.message) {
                                    toastr.info(error.data.error.message);
                                } else {
                                    toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
                                }

                                setTimeout(function() {
                                    $scope.$apply()
                                }, 5);
                            });
                }
            });
        }

        function handleAction(response) {
            stripe.handleCardAction(response.clientSecret).then(function(result) {
                if (result.error) {
                    $scope.buingTickets = false;
                    toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
                } else {
                    eventTicketsService.post('payment/v1/event/paymentIntent/confirm', {
                            logId: response.logId
                        }, {
                            'Content-Type': 'application/json',
                            'cache': false,
                            'xhr': true
                        })
                        .then(function(resp) {
                                $scope.buingTickets = false;
                                window.location.href = '/parent/#/events/ticket/' + $scope.event.id + '/' + response.logId;
                            },
                            function(error) {
                                $scope.buingTickets = false;

                                if (error.data.error.message) {
                                    toastr.info(error.data.error.message);
                                } else {
                                    toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
                                }
                            });
                }
            });
        }

        $scope.save = function() {
            var payload = {
                eventId: $scope.event.id,
                tickets: [],
                oneDomain: true
            };

            for (var i = 0; i < $scope.ticketList.tickets.length; i++) {

                if ($scope.ticketList.tickets[i].quantity && $scope.ticketList.tickets[i].quantity > 0) {
                    payload.tickets.push({
                        ticketTypeId: $scope.ticketList.tickets[i].id,
                        quantity: $scope.ticketList.tickets[i].quantity
                    })
                } else if ($scope.ticketList.tickets[i].donationAmount) {
                    payload.tickets.push({
                        ticketTypeId: $scope.ticketList.tickets[i].id,
                        donationAmount: $scope.ticketList.tickets[i].donationAmount
                    })
                }
            }

            if (payload.tickets.length === 0) {
                // TODO: show an error
                return false;
            }

            if ($scope.totalPayment === 0 || $scope.ticketList.paidEventType === 'FREE') {
                $scope.buingTickets = true;

                eventTicketsService.post('event/v1/buy/freeTicket', payload, { 'cache': false, 'xhr': true }).then(function(response) {
                    location.href = '#/events/ticket/' + $scope.event.id + '/' + response.data.payload.lid;
                }, function(error) {
                    $scope.buingTickets = false;
                    $scope.getTickets();

                    if (error.data.error.message) {
                        toastr.info(error.data.error.message);
                    } else {
                        toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
                    }

                });
            } else {
                if (!storage.hasStorageEnabled || !storage.hasCookiesEnabled) {
                    toastr.warning($translate.instant('PAYPAL_COOKIE_WARNING'));
                    return;
                }

                $scope.buingTickets = true;

                var modalInstance = $uibModal.open({
                    animation: true,
                    scope: $scope,
                    backdrop: 'static',
                    closeByEscape: false,
                    closeByDocument: false,
                    backdropClass: 'backdrop-zindexed',
                    templateUrl: 'app/base/views/window-redirecting-to-paypal.html',
                    size: 'md',
                    controller: function($scope) {

                        $scope.isButtonDisabled = false;
                        $scope.redirectTimer = false;

                        $scope.onRefreshTap = function() {
                            window.location.href = "/parent/#/events/view/" + $scope.event.id;
                        }

                        $scope.onContinueTap = function() {
                            $scope.isButtonDisabled = true;

                            if (isThisMobile()) {
                                setTimeout(function() {
                                    $scope.$apply(function() {
                                        $scope.redirectTimer = true;
                                    });
                                }, 3000);
                            }

                            if (getMobileOperatingSystem() === 'iOS' && $rootScope.isNative) {
                                location.href = settings.conf.apiNoSecure + '/payment/pay?t=' + encodeURIComponent(JSON.stringify(payload));
                            } else {
                                if (window.AndroidBridge) {
                                    window.AndroidBridge.openBrowser(settings.conf.api + '/payment/pay?t=' + encodeURIComponent(JSON.stringify(payload))) ;
                                } else {
                                    location.href = settings.conf.api + '/payment/pay?t=' + encodeURIComponent(JSON.stringify(payload));
                                }
                            }
                        }
                    }
                })
            }
        };
    }
})();
(function() {
	'use strict';

	angular.module('modules.marketplace.mobile',['rzSlider'])
	.factory('postService', ['base', function (base) {
		return _.create(base, { });
	}])
	.controller('composerMkpMobileController', composerMkpMobileController);

	/** @ngInject */
	function composerMkpMobileController(baseService, $scope, $rootScope, $state, regexes, $translate, postService, $window, $stateParams, $uibModal, uploadService, storage, metadata, toastr) {
		$scope.ignoreedit = false;

		$scope.viewState = {
			isReady: true
		}

		$scope.category = "";

		$scope.priceSlider = {
			options: {
				ticksArray: [ 
					{ value: 0, legend: '0%' },
					{ value: 50, legend: '50%' },
					{ value: 100, legend: '100%' }
				],
				legend: '%',
				step: 5,
				floor: 0,
				ceil: 100
			}
		}
		$scope.availableCurrencies = [];
		$scope.marketplaceCategories = metadata.data.metadata.marketplaceCategories || [];
		$scope.marketplaceCategories.unshift({"name": "", "value": "Select category"});
		
		$scope.$on('slideEnded', function() {
			//$scope.savePost();
		})

		$scope.redirectToStripe = function(type) {
			$scope.savePost();
			$rootScope.userTag('MARKETPLACE_INITIATED_STRIPE', 'MARKETPLACE')
				
			$scope.ignoreedit = true;
			location.href = '#/payment/setup';
		};

		$scope.redirectToOffline = function() {
			// TODO:
		};

		$scope.getDonationPrice = function() {
			if(!$scope.post.price)
				return 0;

			if($scope.post.ptaPercentage === 0)
				return 0;

			return (($scope.post.ptaPercentage / 100) * $scope.post.price).toFixed(2);
		}

		$scope.getNetPrice = function() {
			if(!$scope.post.price)
				return 0;

			if((100 - $scope.post.ptaPercentage) === 0)
				return 0;

			return (((100 - $scope.post.ptaPercentage) / 100) * $scope.post.price).toFixed(2);
		}

		$scope.getPost = function(id) {
			$scope.viewState.isReady = false;

			postService.get('marketplace/v1/get/' + id, { 'xhr': true, 'cache': false }).then(function(response) {
				
				if(!response || !response.data) {
					$scope.viewState.isReady = false;
					return;
				}

				$scope.post = eval('(' + JSON.stringify(response.data) + ')')

				if($scope.post.photos) {
					$scope.post.attachments = [];
					for(var i = 0; i < $scope.post.photos.length; i++) {
						$scope.post.attachments[i] = {
							imageUrl: $scope.post.photos[i].url,
							imageId: $scope.post.photos[i].id
						}
					}
				}

				$scope.post.body = $rootScope.removeLinks($scope.post.description);
				$scope.viewState.isReady = true;
				$scope.post.type = $scope.post.type ? $scope.post.type : 'FOR_SALE';
				$scope.category = $scope.post.category ? $scope.post.category : "";
				$scope.selectType($scope.post.type);
				
				if($scope.post.type === 'FOR_SALE') {
					$scope.hasPrice = true;
					$scope.isFree = false;
					$scope.post.price = $scope.post.priceAsDouble;
					$scope.post.enabledOffer = true;

					setTimeout(function() {
						$scope.post.currency = response.data.currency;
					}, 1);
				}

				if($scope.post.type === 'FREE') {
					$scope.post.enabledOffer = true;
					$scope.hasPrice = true;
					$scope.isFree = true;
				}

				setTimeout(function() {
					$scope.$apply()
				}, 4);

				$rootScope.$broadcast('RESIZE_TO_LARGE', function(someVar) {			

				});
			}, 
			function(error) {
				$scope.viewState.isReady = true;
			});
		}

		baseService.app_initialized = function(evt, args) {
			$scope.regexes = regexes;
			var fileUploader = document.getElementById('postUploader');
			getAndSetAvailableCurrencies();

			var clean = angular.copy({ });

			/*
			$scope.getAmbassador = function(complete) {
				postService.get('parent/v1/get/' + $rootScope.active_school.id + '/details', { 'xhr': true, cache: false }).then(function (response) {
					if(complete)
						complete(DTOS.Map(response.data.payload || { }, 'school'))
				},
				function(error){
					console.log(error);
				}) 
			}*/

			if(postService._temp) {
				$scope.post = postService._temp.post;
				$scope.hasPrice = postService._temp.hasPrice;
				$scope.post.type = postService._temp.post.type;
				$scope.imageUrl = postService._temp.imageUrl;

				if(!$scope.post.ptaPercentage) {
					$scope.post.ptaPercentage = 10;
				}

				if(!$scope.post.currency) {
					$scope.post.currency = 'GBP';
				}
			}
			else {
				$scope.post = { 
					ptaPercentage: 10, 
					currency: 'GBP' 
				};
				postService._temp = { };
				postService._temp.post = $scope.post;
			}

			if(localStorage.getItem('_draftMarketplace')) {
				$scope.post = JSON.parse(localStorage.getItem('_draftMarketplace'));

				if($scope.post.type === 'FOR_SALE') {
					$scope.hasPrice = true;
				}
			}

			/*
			if(location.href.indexOf('marketplace/post') > -1 
				&& !$stateParams.id 
				&& !$scope.post.type) {
				location.href = '#/listings/list';
				return;
			}*/

			$scope.editing = false;

			if($stateParams.id) {
				$scope.getPost($stateParams.id)
				$scope.editing = true;
			}

			$scope.onSell = function() {
				if($scope.editing) return;
				$scope.post.type = 'FOR_SALE';
				$scope.post.enabledOffer = true;
			}

			$scope.onOffer = function() {
				if($scope.editing) return;
				$scope.post.price = '';
				$scope.post.ptaPercentage = 10;
				$scope.post.type = 'FREE';
				$scope.post.enabledOffer = true;
			}

			$scope.selectType = function(value) {
				if($scope.editing) return;
				$scope.enabledOffer = false;
				$scope.post.type = value;
				$scope.post.price = '';
				
				if (value === 'FREE' || value === 'FOR_SALE') {
					$scope.hasPrice = true;
					postService._temp.hasPrice = true;
				} 
				else {
					$scope.hasPrice = false;
					postService._temp.hasPrice = false;
				}

				postService._temp.post = $scope.post;
			}


			$scope.viewState = {
				isReady: true
			}

			$scope.gotoPost = function() {
				$state.go('composer_mkp.post');
			}
			
			$scope.getGroupById = function(id) {
				for(var i = 0; i < $scope.groups.length; i++) {
					if($scope.groups[i].id === id)
						return $scope.groups[i];
				}
			}
			
			$scope.attachUpload = function(blob, success, fail) {
				uploadService.fileUpload($scope.filesToSend[0].blob, {
					headers: {
						'Content-Type': undefined,
						'ClasslistToken': storage.getToken() || '',
						'ClasslistCfg': angular.toJson({
							'type': 'ATTACHMENT'
						})
					}
				}, $scope.filesToSend[0].name)
				.then(function(response) {
					$scope.isUploading = false;
					$scope.filesToSend[0].file_id = response.data;

					var url = postService.getPostImgBucketUrl() + '/' + response.data
					$scope.post.attachments.push({ imageUrl: url, blob: blob, imageId: response.data || '' });

					$scope.savePost();

					if(success)
						success()
				}, 
				function(error) {
					if (error.status === 403 || error.status === 409) {
						toastr.error($translate.instant(error.data));
					}
					else {
						//Skip for now.
					}

					if(fail)
						fail()

					$scope.isUploading = false;
				});
			}

			$scope.filesToSend = new Array()
			fileUploader.onchange = function() {
				var length = 0;

				function recursiveLoad(files, success) {
					var reader = new FileReader();
					var file = files[length];

					if (file) {
						if(file.type.indexOf('image') > -1) {
							var _URL = window.URL || window.webkitURL;
							var img = new Image();
							
							img.onload = function () {
								window.EXIF.getData(img, function () {
									var orientation = EXIF.getTag(this, "Orientation");
									var canvas = document.createElement('canvas'),
										context;
	
									var aratio = calculateAspectRatioFit(
										img.width,
										img.height,
										1200,
										1200);
	
									context = canvas.getContext('2d');
									canvas.width = aratio.width;
									canvas.height = aratio.height;
				
									var x = 0;
									var y = 0;
									if (orientation !== 'undefined') {
										
										if (orientation > 4) {
											canvas.width = aratio.height;
											canvas.height = aratio.width;
										}
				
										switch (orientation) {
											case 2:
												context.translate(canvas.width, 0);
												context.scale(-1, 1);
												break;
											case 3:
												context.translate(canvas.width, canvas.height);
												context.rotate(Math.PI);
												break;
											case 4:
												context.translate(0, canvas.height);
												context.scale(1, -1);
												break;
											case 5:
												context.rotate(0.5 * Math.PI);
												context.scale(1, -1);
												break;
											case 6:
												context.rotate(0.5 * Math.PI);
												context.translate(0, -canvas.height);
												y = canvas.height - canvas.width;
												break;
											case 7:
												context.rotate(0.5 * Math.PI);
												context.translate(canvas.width, -canvas.height);
												context.scale(-1, 1);
												y = canvas.height - canvas.width;
												x = canvas.width - canvas.height;
												break;
											case 8:
												context.rotate(-0.5 * Math.PI);
												context.translate(-canvas.width, 0);
												x = canvas.width - canvas.height;
												break;
										}
				
									context.drawImage(img, x, y, aratio.width, aratio.height);
									context.restore();
									
									reader.readAsDataURL(file);
									reader.addEventListener('load', function (e) {
										$scope.filesToSend = new Array();
	
										$scope.filesToSend.push({
											width: canvas.width,
											height: canvas.height,
											name: file.name,
											ext: file.name.split('.').pop(),
											type: file.type,
											src: canvas.toDataURL('image/jpeg', 100),
											url: URL.createObjectURL(file),
											blob: dataURItoBlob(canvas.toDataURL('image/jpeg', 100))
										})
	
										if(!$scope.post.attachments)
											$scope.post.attachments = new Array()
	
										$scope.attachUpload(URL.createObjectURL(file), function() {
											length += 1;

											$scope.viewState.isReady = false;
											recursiveLoad(files, success)
										})
	
									}, false);
									
									}
								});
							};
							img.src = _URL.createObjectURL(file);
						}
						else {
							// 	// TODO: do something for files
							// reader.readAsDataURL(file);
	
							// if(file.size > 8000000) {
							// 	toastr.info($translate.instant('FILE_SIZE_TOO_BIG'));
							// 	return;
							// }
	
							// reader.addEventListener('load', function (e) {
							// 	$scope.filesToSend = new Array();
							// 	$scope.filesToSend.push({
							// 		name: file.name,
							// 		ext: file.name.split('.').pop(),
							// 		type: file.type,
							// 		src: e.target.result,
							// 		url: URL.createObjectURL(file), 
							// 		blob: dataURItoBlob(reader.result)
							// 	})
	
							// 	//$scope.previewMedia($scope.filesToSend[0])
	
							// }, false);
						}
					}
					else {
						$scope.viewState.isReady = true;

						if(success)
							success();
					}
				}

				if(fileUploader.files.length > 20) {
					var modalInstance = $uibModal.open({
						animation: true,
						scope: $scope,
						templateUrl: 'app/marketplace/views/max-upload-files-modal.html',
						backdropClass: 'backdrop-zindexed',
						size:'md',
						controller: function($scope) {
							
							$scope.close = function() {
								modalInstance.close();
							}
						}
					})
					
					return;
				}

				recursiveLoad(fileUploader.files, function() {
					fileUploader.value = '';
				})
			}

			$scope.uploadImage = function () {
				fileUploader.setAttribute('accept', 'image/x-png,image/png,image/gif,image/jpeg,image/jpg')
				fileUploader.click();
				$scope.$root.nativeCamPerm();
			}
								
			$scope.back = function() {
				$window.history.back();
			}

			$scope.postPost = function(iscash) {
				$rootScope.checkIfPostIsLegal(true, $scope.post, 
					function(post) {
					//on cancel
				}, function(post) {
					//on continue
					$scope.callCreateAPI(iscash);
				});
			}

			$scope.callCreateAPI = function(iscash){
				if($scope.post.showOfflinePayment === true) {
					iscash = true;
				}
				
				if(!$scope.viewState.isReady) 
					return;
					
				var attachs = new Array()

				if(!$scope.post.title) {
					toastr.info('The title is mandatory');
					return;
				}

				if(!$scope.post.title || $scope.post.title.length < 3) {
					toastr.info('The title must be at least 3 characters');
					return;
				}

				if(!$scope.post.body) {
					toastr.info('The description is mandatory');
					return;
				}

				if(!$scope.post.body || $scope.post.body.length < 4) {
					toastr.info('The description must be at least 4 characters');
					return;
				}

				if($scope.category === "") {
					toastr.info('The category is mandatory');
					return;
				}

				if($scope.post.attachments) {
					for(var i = 0; i < $scope.post.attachments.length; i++) {
						attachs.push($scope.post.attachments[i].imageId)
					}
				}

				var payload = {
					description: $scope.post.body,
					photos: attachs,
					title: $scope.post.title,
					type: $scope.post.type,
					category: $scope.category,
					charitable: $scope.post.charitable
				}

				if($scope.post.price >= 100000) {
					toastr.info('The price should be up to ' + $translate.instant($scope.post.currency + '_SHORT') + '99999.99');
					return;
				}

				if($scope.post.type.toUpperCase() === 'FOR_SALE') {
					payload.price = $scope.post.price ? $scope.post.price : 0;

					if(payload.price) {
						payload.currency = $scope.post.currency;
					}
					
					if(!$scope.post.price || $scope.post.price < 1.00) {
						toastr.info('The price should be at least ' + $translate.instant($scope.post.currency + '_SHORT') + '1.00');
						return;
					}
				}

				$scope.viewState.isReady = false;

				if(!$stateParams.id) {
					postService.post('marketplace/v1/' + $rootScope.active_school.id + '/create', payload, { 'xhr':true }).then(function(response) {
						$scope.viewState.isReady = true;
						var posted = response.data;
						$scope.cancel();

						var mi = $uibModal.open({
							animation: true,
							scope: $scope,
							backdropClass: 'backdrop-zindexed',
							backdrop: 'static',
							templateUrl: 'app/composer_mkp/views/posted-modal.html',
							size:'sm',
							controller: function($scope) {
								
								$scope.close = function() {
									$state.go('listings.view', { id: posted.id });
								}
							}
						})
					}, 
					function(error) {
						$scope.viewState.isReady = true;
						toastr.error(error.data.error.message);
					})
				}
				else {
					postService.post('marketplace/v1/update/' + $stateParams.id, payload, { 'xhr': true, 'cache': false }).then(function(response) {
						$scope.viewState.isReady = true;
						var posted = response.data;

						var mi = $uibModal.open({
							animation: true,
							scope: $scope,
							backdropClass: 'backdrop-zindexed',
							backdrop: 'static',
							templateUrl: 'app/composer_mkp/views/posted-modal.html',
							size:'sm',
							controller: function($scope) {
								
								$scope.close = function() {
									$state.go('listings.view', { id: posted.id });
								}
							}
						})
					}, 
					function(error) {
						$scope.viewState.isReady = true;
						toastr.error(error.data.error.message);
					})
				}
			}

			// Init the beforeunlodpage on this page
			//FIXME 
			//Adrian 11 APR 19, added this
			var onBeforeunload = $rootScope.$on('composer_mkp.post', function(evt, args) {
				var anychange = $scope.post.body && !$stateParams.id && !$scope.ignoreedit ? true : false;
				
				if(anychange) {
					var modalInstance = $uibModal.open({
						animation: true,
						scope: $scope,
						backdropClass: 'backdrop-zindexed',
						templateUrl: 'app/base/views/window-beforeleave-modal.html',
						size:'md',
						controller: function($scope) {
							$scope.leave = function() {
								onBeforeunload();
								$scope.cleanPost();
								$state.go(args.toState.name, args.toParams);
							}
							$scope.stay = function() {
								modalInstance.close();
							};
						}
					})

					args.e.preventDefault();
				}
				else {
					onBeforeunload();
				}
			});

			//FIXME 
			//Adrian 11 APR 19, changed this
			//this is the old discardPost function
			$scope.cleanPost = function() {
				$scope.post = angular.copy(clean);
				postService._temp.post = $scope.post;
				localStorage.removeItem('_draftMarketplace');
			}
			
			$scope.cancel = function() {
				$scope.cleanPost();
				$rootScope.postingFromGroupId = null;

				if($rootScope.postingFrom === 'home') {
					$state.go('home');
				}
				else if($rootScope.postingFrom === 'listings') {
					//$state.go('listings.list');
				}
				else if($rootScope.postingFrom === 'groups') {
					//location.href = '#/groups/view/' + $rootScope.postingFromGroupId;
				}
			}
			
			$scope.removePhoto = function(index) {
				$scope.post.attachments.splice(index, 1);
				postService._temp.post = $scope.post;
				$scope.savePost();
			}

			$scope.savePost = function() {
				try{
					localStorage.setItem('_draftMarketplace', JSON.stringify($scope.post));
				} catch(error){
					//skip for now...
				}		
			}

			$scope.editPhoto = function(index) {
				$rootScope.$broadcast('UPLOAD_PHOTO', {
					'file_blob': $scope.post.attachments[index].blob,
					'callback_fn': function(response) {
						var url = postService.getPostImgBucketUrl() + '/' + response.data;

						if(!$scope.post.attachments)
							$scope.post.attachments = new Array()

						$scope.post.attachments[index] = { imageUrl: url, blob: response.file_blob, imageId: response.data || '' };
					},
					'action':'postUpload',
					'config':'postCropper'
				});
			}

			$scope.charitableInfo = function() {
				var modalInstance = $uibModal.open({
					animation: true,
					templateUrl: 'app/composer_mkp/views/charitable-info-modal.html',
					backdropClass: 'backdrop-zindexed',
					size:'md',
					controller: function($scope) {
						
						$scope.close = function() {
							modalInstance.close();
						}
					}
				});
			}
		}
		function getAndSetAvailableCurrencies(){
			$scope.viewState.isReady = false;
			try {
				postService.get('shared/v1/list/currencies/' + $rootScope.active_school.id + '/marketplace', {'cache':false, 'xhr':true})
				.then(function(response) {
				$scope.viewState.isReady = true;
				$scope.availableCurrencies = response.data.items;
				getSchool();
			});
			} catch (ex) {
				$scope.viewState.isReady = true;
				toastr.error(error.data.error.message);
			}
		}
		function getSchool() {
			$scope.viewState.isReady = false;

			postService.get('parent/v1/get/' + $rootScope.active_school.id + '/details', { 'xhr': true, cache: false }).then(function (response) {
				$scope.viewState.isReady = true;
				$scope.school = DTOS.Map(response.data.payload || { }, 'school');
				$scope.school.cover = $scope.school.cover + '?v=' + new Date().getTime();
				$scope.school.logo = $scope.school.logo + '?v=' + new Date().getTime(); 
			},
			function(error){
				console.log(error);
			})
		}
		
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}

})();

(function() {
    'use strict';

    angular.module('modules.composer.mobile', [])
        .factory('postService', ['base', function(base) {
            return _.create(base, {});
        }])
        .controller('composerMobileController', composerMobileController);

    /** @ngInject */
    function composerMobileController(baseService, $scope, $rootScope, $state, regexes, $translate, postService, $window, $stateParams, $uibModal, uploadService, storage, toastr) {

        baseService.app_initialized = function(evt, args) {
            $scope.regexes = regexes;
            var fileUploader = document.getElementById('postUploader');
            $scope.draftPost = {};

            $scope.isNativeAndroid = function() {


                // PWA-7806 Hide the attachment link for posts on Android nativeg
                if ($rootScope.isNative && $rootScope.os === 'Android') {
                    console.log('Detected that user is using Android native');

                    return true;

                } else {

                    return false;
                }
            }

            $scope.categories = [
                "general",
                "lost_found",
                "offer",
                "wanted"
            ];

            $scope.viewState = {
                isReady: false
            }
            $scope.isBodyAllSpace = true;

            var clean = angular.copy({});

            if (!$rootScope.postingFrom) {
                $state.go('home');
            }

            //we need to query the groups
            if ($state.current.name === 'composer.post') {
                $scope.groups = [];

                baseService.get('parent/v1/get/context/v2/groups/' + $rootScope.active_school.id, { 'cache': false }).then(function(resp) {
                    $scope.groups = resp.data.items;

                    if($scope.groups){
                        for(var i=0; $scope.groups.length > i; i++){
                            if($scope.groups[i].type === 'MARKETPLACE'){
                                $scope.groups.splice(i, 1);
                                break;
                            }
                        }
                        for(var i=0; $scope.groups.length > i; i++){
                            // class rep cannot create whole school posts FMA-1362
                            if($scope.groups[i].type === 'SCHOOL_GROUP' && !$scope.groups[i].postEnabled && (!$rootScope.active_school.admin ||  ($rootScope.active_school.roles && $rootScope.active_school.roles.length === 1 && $rootScope.active_school.roles[0] === "CLASS_REP"))){
                                $scope.groups.splice(i, 1);
                                break;
                            }
                        }
                    }
                    var gid;

                    $scope.viewState.isReady = true;

                    if ($rootScope._gid) {

                        $scope.post.groupId = $rootScope._gid.id;

                        if ($rootScope._gid.name === 'Whole school' &&
                            $rootScope.postingFrom !== 'listings') {
                            $scope.post.groupId = $scope.groups[0].id;
                            $scope.selectedGroup = $scope.groups[0];
                        }

                        $scope.selectGroup()

                        gid = $scope.selectedGroup;
                    } else {
                        if ($rootScope.gid) {

                            gid = $scope.getGroupById($rootScope.gid)
                            if (gid) {
                                if (gid.name === 'Whole school' &&
                                    $rootScope.postingFrom !== 'listings') {
                                    $scope.post.groupId = $scope.groups[0].id;
                                    $scope.selectedGroup = $scope.groups[0];
                                }

                                $scope.selectGroup(gid);
                                $rootScope.gid = null;
                            } else {
                                $scope.selectGroup($scope.groups[0]);
                            }
                        } else {

                            $scope.selectGroup($scope.groups[0]);
                        }
                        if ($rootScope.postingFromGroupId) {

                            $scope.post.groupId = $rootScope.postingFromGroupId;

                            // if(_gr.name == 'Whole school' 
                            // 	&& $rootScope.postingFrom != 'listings') {

                            // 	$scope.post.groupId = $scope.groups[0].id;
                            // 	$scope.selectedGroup = $scope.groups[0];
                            // }

                            $scope.selectGroup()

                            if ($scope.post) {
                                $scope.post.groupId = $scope.selectedGroup.id;
                            }

                            postService._temp.post = $scope.post;
                        }
                    }
                });
            }

            $scope.getAmbassador = function(complete) {
                postService.get('parent/v1/get/' + $rootScope.active_school.id + '/details', { 'xhr': true, cache: false }).then(function(response) {
                        if (complete)
                            complete(DTOS.Map(response.data.payload || {}, 'school'))
                    },
                    function(error) {
                        console.log(error);
                    })
            }

            $scope.selectGroup = function() {

                var group = $scope.post.groupId ?
                    $scope.getGroupById($scope.post.groupId) :
                    $scope.groups[0];

                // just in case getGroupById returns null. This can happen if user is in Whole School
                // and Whole School posts are turned off
                if(group === null ) {
                    group = $scope.groups[0];
                }

                $scope.canPostWholeSchool = group.postEnabled;

                if (group.name === 'Whole school' &&
                    $rootScope.postingFrom !== 'listings') {
                    $scope.post.groupId = $scope.selectedGroup ?
                        $scope.selectedGroup.id :
                        $scope.groups[0].id;

                    setTimeout(function() {
                        if ($scope.canPostWholeSchool || $rootScope.active_school.admin) {
                            var modalInstance1 = $uibModal.open({
                                animation: true,
                                scope: $scope,
                                templateUrl: 'app/composer/views/marketplace-admin-modal.html',
                                backdropClass: 'backdrop-zindexed',
                                size: 'md',
                                controller: function($translate) {

                                    $scope.confirm = function() {
                                        $scope.post.groupId = group.id;
                                        postService._temp.post = $scope.post;
                                        $rootScope._gid = group;

                                        //save a temp post
                                        //Adrian 11 APR 19, changed this
                                        var defaultPost = {
                                            "ptaPercentage": 10,
                                            "currency": "GBP",
                                            "body": $scope.post.body,
                                            "attachments": $scope.post.attachments
                                        };

                                        try {
                                            localStorage.setItem("_draftMarketplace", JSON.stringify(defaultPost));
                                        } catch (error) {
                                            //skip for now...
                                        }


                                        $rootScope.userTag('POST_WHOLE_SCHOOL_GOTO_MARKETPLACE')
                                        location.href = '#/listings/list/';
                                    }

                                    $scope.close = function() {
                                        $scope.selectedGroup = group;
                                        $scope.post.groupId = group.id;
                                        postService._temp.post = $scope.post;
                                        $rootScope._gid = group;

                                        $rootScope.userTag('POST_WHOLE_SCHOOL_DONTGOTO_MARKETPLACE')
                                        modalInstance1.close();
                                    }
                                }
                            })
                        }
                    }, 1);
                } else {
                    $scope.selectedGroup = group;
                    $scope.post.groupId = group.id;
                    postService._temp.post = $scope.post;
                    //$rootScope._gid = group;
                }
            }

            if (postService._temp) {
                // $scope.post = postService._temp.post;
                $scope.post = {};
                $scope.hasPrice = postService._temp.hasPrice;
                $scope.showPrice = postService._temp.showPrice;
                $scope.url = postService._temp.url;
            } else {
                $scope.post = {};
                postService._temp = {};
                postService._temp.post = $scope.post;
            }

            if ($rootScope.activityStreamTierId !== -1)
                $scope.post.groupId = $rootScope.activityStreamTierId;

            $scope.selectCategory = function(value) {
                $scope.showPrice = false;
                $scope.post.category = value;
                $scope.post.price = '';

                if (value === 'free' || value === 'jobs' || value === 'for_sale' || value === 'offer') {
                    $scope.hasPrice = true;
                    postService._temp.hasPrice = true;

                    if (value === 'free') {
                        $scope.post.price = "FREE";
                    }
                } else {
                    $scope.hasPrice = false;
                    postService._temp.hasPrice = false;
                }

                postService._temp.showPrice = false;
                postService._temp.post = $scope.post;
            }

            if ($rootScope.postingFrom === 'home') {
                $scope.textPlaceholder = $translate.instant('WRITE_A_POST');
                $scope.hasPrice = false;
            } else if ($rootScope.postingFrom === 'listings') {
                if (!$scope.post.category)
                    $scope.selectCategory($scope.categories[0])

                $scope.textPlaceholder = $translate.instant('WRITE_A_POST');

                switch ($scope.post.category) {
                    case "general":
                        $scope.textPlaceholder = $translate.instant('WRITE_A_POST_GENERAL');
                        break;
                    case "lost_found":
                        $scope.textPlaceholder = $translate.instant('WRITE_A_POST_LOST');
                        break;
                    case "offer":
                        $scope.textPlaceholder = $translate.instant('WRITE_A_POST_OFFER');
                        break;
                    case "wanted":
                        $scope.textPlaceholder = $translate.instant('WRITE_A_POST_WANTED');
                        break;
                }

            } else if ($rootScope.postingFrom === 'groups') {
                $scope.hasPrice = false;
                $scope.textPlaceholder = $translate.instant('WRITE_A_POST');
            }

            $scope.gotoPost = function() {
                $state.go('composer.post');
            }

            $scope.getGroupById = function(id) {
                for (var i = 0; i < $scope.groups.length; i++) {
                    
                    if ($scope.groups[i].id === id) {
                        return $scope.groups[i];
                    }
                }
                return null;
            }


            $scope.removePrice = function() {
                $scope.post.price = '';
                $scope.showPrice = false;
                postService._temp.showPrice = false;
            }

            $scope.addPrice = function() {
                $scope.showPrice = true;
                postService._temp.showPrice = true;
            }

            $scope.freePrice = function() {
                $scope.showPrice = true;
                postService._temp.showPrice = true;
                $scope.post.price = 'FREE!'
            }

            var decodeEntities = (function() {
                // this prevents any overhead from creating the object each time
                var element = document.createElement('div');
                function decodeHTMLEntities (str) {
                  if(str && typeof str === 'string') {
                    // strip script/html tags
                    str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
                    str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
                    element.innerHTML = str;
                    str = element.textContent;
                    element.textContent = '';
                  }
              
                  return str;
                }
                return decodeHTMLEntities;
              })();

            $scope.getPostBody = function(bodyWithTags) {
                $scope.bodyWithoutEntities = decodeEntities(bodyWithTags);
                // string only contains whitespace
                if (!$scope.bodyWithoutEntities.replace(/\s/g, '').length) {
                    $scope.isBodyAllSpace = true;
                } else $scope.isBodyAllSpace = false;
                $scope.post.body = bodyWithTags;
                $scope.checkForLinkPreviews(bodyWithTags);
                $scope.setDraft(bodyWithTags);
            }

            //This function will check if post body matches with Link regex.
            $scope.checkForLinkPreviews = function(textToCheck) {
                //first check if we need to check

                if (!textToCheck || textToCheck.length < 3 ||
                    ($scope.post.attachments && $scope.post.attachments.length > 0) ||
                    ($scope.post.files && $scope.post.files > 0)) {
                    return;
                }

                //check if there is already a link
                if ($scope.post.previewLink && $scope.post.previewLink !== '') {
                    return;
                }
                var expression = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
                var matches = textToCheck.match(expression);
                if (matches !== null) {
                    for (var i = 0; i < matches.length; i++) {
                        if (matches[i].indexOf("@") > -1) {
                            continue;
                        }
                        $scope.firstLinkInPostBody = matches[i];
                        break;
                    }
                }
            }

            //This function will invoke when user clicks on x button to remove link preview.
            //If user clicks on x button, no more link preview will be possible.
            $scope.deleteLinkPreview = function() {
                $scope.post.previewLink = "";
            }

            //This callback invoked from linkpreview directive when API returns a response with title.
            //If so, make linkpreview container visible. 
            $scope.onPreviewSuccess = function(url) {
                $scope.post.previewLink = url;
            }

            $scope.attachUpload = function(blob, success, fail) {
                uploadService.fileUpload($scope.filesToSend[0].blob, {
                        headers: {
                            'Content-Type': undefined,
                            'ClasslistToken': storage.getToken() || '',
                            'ClasslistCfg': angular.toJson({
                                'type': 'ATTACHMENT'
                            })
                        }
                    }, $scope.filesToSend[0].name)
                    .then(function(response) {
                            $scope.isUploading = false;
                            $scope.filesToSend[0].file_id = response.data;

                            if (success)
                                success(response)
                        },
                        function(error) {
                            if (error.status === 403 || error.status === 409) {
                                toastr.error($translate.instant(error.data));
                            } else {
                                //Skip for now.
                            }

                            if (fail)
                                fail()

                            $scope.isUploading = false;
                        });
            }

            $scope.filesToSend = new Array()
            fileUploader.onchange = function() {
                var length = 0;

                function recursiveLoad(files, success) {
                    var reader = new FileReader();
                    var file = files[length];

                    if (file) {
                        if (file.type.indexOf('image') > -1) {
                            var _URL = window.URL || window.webkitURL;
                            var img = new Image();

                            img.onload = function() {
                                window.EXIF.getData(img, function() {
                                    var orientation = EXIF.getTag(this, "Orientation");
                                    var canvas = document.createElement('canvas'),
                                        context;

                                    var aratio = calculateAspectRatioFit(
                                        img.width,
                                        img.height,
                                        1200,
                                        1200);

                                    context = canvas.getContext('2d');
                                    canvas.width = aratio.width;
                                    canvas.height = aratio.height;

                                    var x = 0;
                                    var y = 0;
                                    if (orientation !== 'undefined') {

                                        /*
                                        if (orientation > 4) {
                                            canvas.width = aratio.height;
                                            canvas.height = aratio.width;
                                        }

                                        switch (orientation) {
                                            case 2:
                                                context.translate(canvas.width, 0);
                                                context.scale(-1, 1);
                                                break;
                                            case 3:
                                                context.translate(canvas.width, canvas.height);
                                                context.rotate(Math.PI);
                                                break;
                                            case 4:
                                                context.translate(0, canvas.height);
                                                context.scale(1, -1);
                                                break;
                                            case 5:
                                                context.rotate(0.5 * Math.PI);
                                                context.scale(1, -1);
                                                break;
                                            case 6:
                                                context.rotate(0.5 * Math.PI);
                                                context.translate(0, -canvas.height);
                                                y = canvas.height - canvas.width;
                                                break;
                                            case 7:
                                                context.rotate(0.5 * Math.PI);
                                                context.translate(canvas.width, -canvas.height);
                                                context.scale(-1, 1);
                                                y = canvas.height - canvas.width;
                                                x = canvas.width - canvas.height;
                                                break;
                                            case 8:
                                                context.rotate(-0.5 * Math.PI);
                                                context.translate(-canvas.width, 0);
                                                x = canvas.width - canvas.height;
                                                break;
                                        }*/

                                        context.drawImage(img, x, y, aratio.width, aratio.height);
                                        context.restore();

                                        reader.readAsDataURL(file);
                                        reader.addEventListener('load', function(e) {
                                            $scope.filesToSend = new Array();

                                            $scope.filesToSend.push({
                                                width: canvas.width,
                                                height: canvas.height,
                                                name: file.name,
                                                ext: file.name.split('.').pop(),
                                                type: file.type,
                                                src: canvas.toDataURL('image/jpeg', 100),
                                                url: URL.createObjectURL(file),
                                                blob: dataURItoBlob(canvas.toDataURL('image/jpeg', 100))
                                            })

                                            if (!$scope.post.attachments)
                                                $scope.post.attachments = new Array()

                                            $scope.attachUpload(URL.createObjectURL(file), function(resp) {
                                                var url = postService.getPostImgBucketUrl() + '/' + resp.data
                                                $scope.post.attachments.unshift({ url: url, blob: URL.createObjectURL(file), id: resp.data || '' });
                                                $scope.setDraft();

                                                length += 1;

                                                $scope.viewState.isReady = false;
                                                /*
                                                 * If the uploaded image is portrait (orientation == 6),
                                                 * we rotate left.
                                                if (orientation == 6) {
                                                    setTimeout(function() {
                                                        rotateLeft();
                                                    }, 100);
                                                }
                                                 */
                                                recursiveLoad(files, success)
                                            })

                                        }, false);

                                    }
                                });
                            };
                            img.src = _URL.createObjectURL(file);
                        } else {
                            // Files
                            reader.readAsDataURL(file);

                            if (file.size > 8000000) {
                                toastr.info($translate.instant('FILE_SIZE_TOO_BIG'));
                                return;
                            }

                            reader.addEventListener('load', function(e) {
                                $scope.filesToSend = new Array();
                                $scope.filesToSend.push({
                                    name: file.name,
                                    ext: file.name.split('.').pop(),
                                    type: file.type,
                                    src: e.target.result,
                                    url: URL.createObjectURL(file),
                                    blob: dataURItoBlob(reader.result)
                                })

                                if (!$scope.post.files)
                                    $scope.post.files = new Array()

                                $scope.attachUpload(URL.createObjectURL(file), function(resp) {
                                    var url = postService.getPostImgBucketUrl() + '/' + resp.data
                                    $scope.post.files.unshift({ name: file.name, url: url, blob: URL.createObjectURL(file), id: resp.data || '' });

                                    length += 1;

                                    $scope.viewState.isReady = false;
                                    recursiveLoad(files, success)
                                })

                            }, false);
                        }
                    } else {
                        $scope.viewState.isReady = true;

                        if (success)
                            success();
                    }
                }

                if (fileUploader.files.length > 20) {
                    var modalInstance = $uibModal.open({
                        animation: true,
                        scope: $scope,
                        templateUrl: 'app/composer/views/max-upload-files-modal.html',
                        backdropClass: 'backdrop-zindexed',
                        size: 'md',
                        controller: function($scope) {

                            $scope.close = function() {
                                modalInstance.close();
                            }
                        }
                    })

                    return;
                }

                recursiveLoad(fileUploader.files, function() {
                    fileUploader.value = '';
                })
            }

            $scope.uploadImage = function() {
                if (!$rootScope.active_user.emailVerified) {
                    toastr.error($translate.instant('PLEASE_VERIFY_EMAIL'));
			        $rootScope.verifyEmailDismissed = false;
                    return; 
                }
                fileUploader.setAttribute('accept', 'image/x-png,image/png,image/gif,image/jpeg,image/jpg')
                fileUploader.click();
                $scope.$root.nativeCamPerm();
            }

            function rotateLeft() {
                var imagePreview = document.getElementById('post-previewer');
                var rotateAngle = -90;
                imagePreview.setAttribute("style", "transform: rotate(" + rotateAngle + "deg)");
                rotateAngle = rotateAngle + 90;
            }

            $scope.uploadAttachment = function() {
                if (!$rootScope.active_user.emailVerified) {
                    toastr.error($translate.instant('PLEASE_VERIFY_EMAIL'));
			        $rootScope.verifyEmailDismissed = false;
                    return; 
                }
                fileUploader.setAttribute('accept', '*')
                fileUploader.click();
                $scope.$root.nativeCamPerm();
            }

            $scope.back = function() {
                if (location.href.indexOf('composer/post') > -1)
                    $scope.discardPost();

                $window.history.back();
            }

            $scope.changePostCategory = function(group_name) {
                if ($scope.post.selectedGroup.name.toLowerCase() === 'whole school') {
                    //Skip for now.
                }
            }

            $scope.postPost = function() {
                if (!$scope.post.groupId)
                    return;

                if (!$rootScope.active_user.emailVerified) {
                    toastr.error($translate.instant('PLEASE_VERIFY_EMAIL'));
			        $rootScope.verifyEmailDismissed = false;
                    return; 
                }

                /*
                *   Default message for blank post bodies*
                *   Link preview : <user first name> shared a link
                *   Photo : <user first name> posted a photo
                */

                if($scope.post && $scope.post.body==''){
                    if($scope.post.previewLink !== '' ){
                        // Empty post with link preview
                        $scope.post.body = $rootScope.active_user.firstName + ' ' + 'shared a link';
                    }
                    if($scope.post.attachments){
                        // Empty post with attachment
                        $scope.post.body = $rootScope.active_user.firstName + ' ' + 'posted a photo';
                    }
                }
                

                $rootScope.checkIfPostIsLegal(false, $scope.post,
                    function(post) {
                        //on cancel
                    },
                    function(post) {
                        //on continue
                        $scope.callCreateAPI();
                    });
            }

            $scope.callCreateAPI = function() {
                var attachs = new Array()
                if ($scope.post.attachments) {
                    for (var i = 0; i < $scope.post.attachments.length; i++) {
                        attachs.push({
                            id: $scope.post.attachments[i].id,
                            name: $scope.post.attachments[i].name
                        })
                    }
                }

                var file_attachs = new Array()
                if ($scope.post.files) {
                    for (var i = 0; i < $scope.post.files.length; i++) {
                        file_attachs.push({
                            id: $scope.post.files[i].id,
                            name: $scope.post.files[i].name
                        })
                    }
                }

                var payload = {
                    currentUserId: $rootScope.active_user.id,
                    body: $scope.post.body ? $rootScope.createEmailLinks($scope.post.body) : " ",
                    postCategory: $scope.post.category ? $scope.post.category.toUpperCase() : 'GENERAL',
                    price: $scope.post.price,
                    groupId: $scope.post.groupId,
                    attachments: attachs,
                    files: file_attachs,
                    linkPreview: $scope.post.previewLink
                }

                if ($rootScope.postingFrom === 'listings')
                    payload.forceListing = true;

                var newGroupId = $scope.post.groupId;

                // nbsp broke the post body so we need to remove it
                if(payload.body && payload.body.length > 0) {
					var s = String(payload.body);

                    s = s.replace(/(&nbsp;)+<\/div>/g, '</div>');

                    s = s.replace(/(&nbsp;)+\[URL/g, '[URL');

					payload.body = s;
				}
                
                $scope.viewState.isReady = false;

                postService.post('post/v1/create/v4', { 'payload': DTOS.Map(payload, 'composer') }, { 'xhr': true }).then(function(response) {
                        localStorage.removeItem("draftPost");
                        $scope.viewState.isReady = true;
                        var posted = response.data.payload.post;
                        $scope.cancel();

                        if ($rootScope.postingFrom === 'groups') {
                            $state.go('groups.view', { id: newGroupId })
                        }
                    },
                    function(error) {
                        $scope.viewState.isReady = true;
                        console.log(error);
                    })

                if ($rootScope.introduceDismissable) {
                    localStorage.setItem('PARENT_PRODUCT_DISCOVERY_INTRODUCE', true);
                    $rootScope.dismissTodo('PARENT_PRODUCT_DISCOVERY_INTRODUCE').then(function(resp) {}, function(error) {});
                }
            }

            $scope.discardPost = function() {
                $scope.post = angular.copy(clean);
                postService._temp.post = $scope.post;
                //$scope.removePhoto();
            }

            $scope.cancel = function() {
                var g_id = $scope.post.groupId;
                $scope.discardPost();
                $rootScope.postingFromGroupId = null;
                $rootScope._gid = null;

                if ($scope.groups)
                    if ($scope.groups.length > 0)
                        $scope.selectGroup($scope.groups[0])

                if ($rootScope.postingFrom === 'home') {
                    $rootScope.activityStreamTierId = g_id;
                    $rootScope.postingFrom = 'groups';
                    window.location.href = '#/stream';
                } else if ($rootScope.postingFrom === 'listings') {
                    $state.go('listings.list');
                } else if ($rootScope.postingFrom === 'groups') {
                    //location.href = '#/groups/view/' + $rootScope.postingFromGroupId;
                }
            }

            $scope.removePhoto = function(index) {
                $scope.post.attachments.splice(index, 1);
                postService._temp.post = $scope.post;
            }

            $scope.removeFile = function(index) {
                $scope.post.files.splice(index, 1);
                postService._temp.post = $scope.post;
            }

            $scope.editPhoto = function(index) {
                $rootScope.$broadcast('UPLOAD_PHOTO', {
                    'file_blob': $scope.post.attachments[index].blob,
                    'callback_fn': function(response) {
                        var url = postService.getPostImgBucketUrl() + '/' + response.data;

                        if (!$scope.post.attachments)
                            $scope.post.attachments = new Array()

                        $scope.post.attachments[index] = { url: url, blob: response.file_blob, id: response.data || '' };
                    },
                    'action': 'postUpload',
                    'config': 'postCropper'
                });
            }

            $scope.changeGroup = function(draftPost) {
                $scope.draftPost.body = draftPost.body;
                $scope.post = draftPost;
                $scope.selectGroup();
            }

            $scope.discardDraft = function() {
                localStorage.removeItem("draftPost");
                $scope.draftPost.body = '';
                $scope.post = {
                    groupId: $scope.selectedGroup.id
                };
            }

            $scope.setDraft = function(text) {
                if(!$scope.selectedGroup && !$scope.selectedGroup.name) return;
                var draftPost = {
                    body: text ? text : $scope.post.body,
                    createdAt: new Date().getTime(),
                    groupId: $scope.post.groupId,
                    groupName: $scope.selectedGroup.name,
                    attachments: $scope.post.attachments
                };
                localStorage.setItem("draftPost", JSON.stringify(draftPost));
            }

            var draft = localStorage.getItem("draftPost");
            if(draft) {
                var draftPost = JSON.parse(draft);
                var time = new Date().getTime() - 24 * 60 * 60 * 1000; // now - 24 hours in miliseconds
                if(time > draftPost.createdAt) {
                    localStorage.removeItem("draftPost");
                    $scope.draftPost.body = '';
                } else if($scope.post.groupId === draftPost.groupId) {
                    $scope.post = draftPost;
                    $scope.draftPost.body = draftPost.body;
                } else {
                    var modalInstance = $uibModal.open({
                        animation: true,
                        scope: $scope,
                        templateUrl: 'app/composer/views/draft-will-be-discarded-modal.html',
                        backdropClass: 'backdrop-zindexed',
                        size: 'md',
                        controller: function($scope) {
                            $scope.draftGroupName = draftPost.groupName;
                            $scope.discard = function() {
                                $scope.discardDraft();
                                modalInstance.close();
                            }
                            $scope.continue = function() {
                                $scope.changeGroup(draftPost);
                                modalInstance.close();
                            }
                        }
                    });
                }
            } else {
                $scope.draftPost.body = '';
            }
        }

        if ($rootScope.active_school && $rootScope.app_base_ready) {
            baseService.app_initialized();
        }
    }

})();
(function() {
	'use strict';

	angular.module('modules.classlist.map',[]).factory('classlistService', ['base', function (base) {
		return _.create(base, { });
	}]).controller('classlistMapController', classlistMapController);

	/** @ngInject */
	function classlistMapController(baseService, regexes, storage, runmapService, $scope, $rootScope, metadata, classlistService, $translate, $timeout, $location, $state, $uibModal, $stateParams, profileService, toastr, settings, gaService) {
		$scope.gPlace;
		$scope.mapConfig = {};
		$scope.parentDetails = {};
		$scope.regexes = regexes;
		$scope.myUser = {};
		$scope.selectedSearch = false;
		$scope.viewState = {
			isReady:false,
			isParentVisible:false
		};

		var relationships = {};

		_.each(metadata.data.metadata.relationships, function (obj, index) {
			relationships[obj.id] = obj.longName;
		});

		if(localStorage.getItem('__c5')) {
			var _c = JSON.parse(localStorage.getItem('__c5').b64decode());
			if(_c) {
				$rootScope.isEnabled = _c.me.rM;
				$scope.mapConfig = _c;
			}
		}
		
		if(localStorage.getItem('__c6')) {
			var _cm = JSON.parse(localStorage.getItem('__c6').b64decode());
			$scope.mapConfig.parents = _cm

			if($rootScope.isEnabled) {
				var runmap = document.querySelector('.contacts-runmap')
				if(runmap)
					runmap.style.height = (window.innerHeight - 229) + 'px'; //296
			}
		}

		$scope.nameRelation = function (_id){
			return relationships[_id]
		};

		$rootScope.nameRelation = $scope.nameRelation;

		$scope.getContactById = function(id) {
			if(localStorage.getItem('__c5')) {
				var contacts = eval('('+localStorage.getItem('__c5').b64decode()+')');

				for(var i = 0; i < contacts.parents.length; i++) {
					if(contacts.parents[i].id === id)
						return contacts.parents[i];
				}
			}

			return null;
		}
			
		$scope.setFindUser = function(u) {
			$scope.selectedSearch = false;
			if($scope.mapConfig.onSearchSelected) {
				$scope.mapConfig.onSearchSelected(u)
			}
		}
		
		$scope.filter = { class: -1 }

		$scope.gotoContactsList = function() {
			if($scope.filter.class && $scope.filter.class !== -1)
				location.href = '#/classlist/all/' + $scope.filter.class;
			else
				location.href = '#/classlist/all';
		}

		$scope.openSearchContacts = function() {
			if($rootScope.selectedContactsFilter)
				$rootScope.selectedContactsFilter.keyword = '';
				
			$rootScope.search_page = { active: true };
			
			$rootScope.resizeContactsList();

			setTimeout(function() {
				var s_input = document.querySelector('.search-contacts-input')
				$rootScope.selectedContactsFilter.keyword = '';
				s_input.focus();
			});

			$rootScope.userTag('PARENT_OPEN_CONTACT_SEARCH')
		}
		
		if(localStorage.getItem('__c5')) {
			$scope.mapConfig = JSON.parse(localStorage.getItem('__c5').b64decode())

			if ($scope.mapConfig.filters) {
				$scope.mapConfig.filters.unshift({id: -1, name: 'Whole school'})
			}
		}

		$scope.gotoInvite = function() {
			$rootScope.userTag('PARENT_CLICK_INVITE_FROM_CONTACTS')
			location.href = '#/invite';
		}

		baseService.app_initialized = function(evt, args) {
			$scope.myname = $rootScope.active_user.firstName + ' '+$rootScope.active_user.lastName;

			if(storage.get('sClassFilter', true, true))
				$scope.filter.class = storage.get('sClassFilter', true, true);
			
			if(storage.get('sParentFilter', true, true) && storage.get('sParentFilter', true, true).name) {
				$scope.filter.search = storage.get('sParentFilter', true, true).name;
				setTimeout(function() {
					$scope.selectedSearch = false;
				}, 1000);
			}

			$scope.isOptInClicked = false;
			var showOptInError = false;

			$scope.$watch('filter.search', function (newValue, oldValue) {
				$scope.selectedSearch = false;

				setTimeout(function() {
					$scope.selectedSearch = newValue && newValue.length > 1;
					$scope.filterByClass(true);

					$scope.$apply();
				}, 500);
			});

			$scope.search = function(item) {
				var f = $scope.filter.class !== -1 ? $scope.filter.class : '';

				if ((item.name.toLowerCase().indexOf($scope.filter.search ? $scope.filter.search.toLowerCase() : '') !== -1)) {
					if(f) {
						var found = false;
						for(var i = 0; i < item.pupils.length; i++) {
							if(item.pupils[i].tiers.indexOf(f) > -1){
								return true;
							}
						}
					}
					else {
						return true;
					}

				}
				else {
					//if not check its pupils
					var found = false;
					for(var i = 0; i < item.pupils.length; i++) {
						//if there is a filter check by filter and name
						if(f) {
							if(item.pupils[i].tiers.indexOf(f) > -1 && (item.pupils[i].name.toLowerCase().indexOf($scope.filter.search ? $scope.filter.search.toLowerCase() : '') !== -1)) {
								return true;
							}
						}
						else {
							//if not just by name
							if (item.pupils[i].name.toLowerCase().indexOf($scope.filter.search) !== -1) {
								return true;
							}
						}
					}
				}
				return false;
			}

			$scope.filterByClass = function(fromAutocomplete) {
				if($scope.mapConfig.onClassFilter){
					$scope.mapConfig.onClassFilter($scope.filter.class !== -1 ? $scope.filter.class : '')
				}
				if (!fromAutocomplete){
					$scope.filter.search = '';
				}
			}

			$scope.beforeFilterByClass = function(fromAutocomplete) {
				$scope.filterByClass(fromAutocomplete)

				if($scope.filter.class && $scope.filter.class !== -1) {
					$rootScope.userTag('PARENT_FILTERED_BY_TIER');
					location.href = '#/classlist/map/0/' + $scope.filter.class;
				}
				else {
					location.href = '#/classlist/map/0/';
				}
			}

			setTimeout(function() {
				$scope.filter.class = $stateParams.tierId ? $stateParams.tierId : -1;
			}, 10);

			$scope.toggleParentOverlay = function(){
				$scope.viewState.isParentVisible = !$scope.viewState.isParentVisible
			}

			function checkRunMap(address, city, postCode, checkbox ) {
				var streetAddressLength, cityLength, postCodeLength;
				_.isUndefined(address) ? streetAddressLength = 0 : streetAddressLength = address.length;
				_.isUndefined(city) ? cityLength = 0 : cityLength =  city.length;
				_.isUndefined(postCode) ? postCodeLength = 0 : postCodeLength = postCode.length;

				if ( streetAddressLength > 0 && cityLength > 0 && postCodeLength > 0 
					&& checkbox === true ) {
					
					return showOptInError = false;
				} 
				else {
					return showOptInError = true;
				}
			}

			$scope.update = function () {
				$scope.isOptInClicked = true;

				checkRunMap($scope.myUser.address.streetAddress, $scope.myUser.address.city, 
					$scope.myUser.address.postCode, $scope.myUser.runSchoolShare)

				if (!showOptInError) {
					$scope.viewState.updating = true;
					$scope.myUser.address.runMap = true;

					profileService.put('parent/v1/parent/address', $scope.myUser.address , { }).then(function(response) {
						if (response && response.data.locationFound === false){
							toastr.info($translate.instant('ADDRESS_NOT_GEODECODED'));
							getMapConfig();
							$scope.viewState.updating = false;
						} else {
							toastr.success($translate.instant('UPDATE_SUCCESSFUL'));

							getClasslist(function(){
								$rootScope.isEnabled = true;
								var obj = JSON.parse(localStorage.getItem('__c5').b64decode());
								obj.me.rM = $rootScope.isEnabled;
								localStorage.setItem('__c5',JSON.stringify(obj).b64encode());

								getMapConfig();
								$scope.viewState.updating = false;
							});
						}

						$rootScope.$broadcast('UPDATE_PROFILE', $scope.myUser);
				
					}, 
					function (error) {
						$scope.myUser.address.runMap = false;
						$scope.viewState.updating = false;
						(error.status !== -1 ) ? toastr.error(error.data.error.message || $translate.instant('UPDATE_FAIL')) : _.noop();
						$scope.viewState.isReady = true;
						$rootScope.isEnabled = false;
					});
				}else{
					//Skip for now.
				}
			}
			
			function getMapConfig() {
				$scope.viewState.isReady = true;
				$scope.mapConfig._timestamp = new Date().getDate();
				$scope.mapready = true;

				setTimeout(function() {
					if($stateParams.id_parent && $stateParams.id_parent !== 0) {
						var p = $scope.getContactById($stateParams.id_parent)
	
						if(p && p.rM) {
							p = {
								firstName: p.fN,
								name: p.fN + ' ' + p.lN,
								lastName: p.lN,
								id: p.id,
								avatar: p.a,
								lat: p.lt,
								lng: p.lg
							}
	
							$scope.setFindUser(p)
						}
					}
	
					$scope.$apply();
				}, 510);

				var response = { }
				if(localStorage.getItem('__c5')) {
					response = JSON.parse(localStorage.getItem('__c5').b64decode())

					for(var i = 0; i < response.parents.length; i ++) {
						var p = response.parents[i]
						response.parents[i] = {
							firstName: p.fN,
							name: p.fN + ' ' + p.lN,
							lastName: p.lN,
							id: p.id,
							avatar: p.a,
							lat: p.lt,
							lng: p.lg,
							pupils: p.ps
						}
					}
				}

				$scope.mapConfig = response;

				if(response && response.me) {
					response.me.rM ? $rootScope.isEnabled = true : $rootScope.isEnabled = false;
				}

				if (!$rootScope.isEnabled) {
					fillInfo();
					
					setTimeout(function() {
						gaService.send('/classlist/map/notopted');
					}, 1000);
				} 
				else {
					$scope.viewState.isReady = true;
				}

				if ($scope.mapConfig.filters){
					$scope.mapConfig.filters.unshift({id: -1, name: 'Whole school'})
				}

				setTimeout(function() {
					$scope.mapready = true;

					if($stateParams.id_parent) {
						var p = $scope.getContactById($stateParams.id_parent)
						
						if(p && p.rM) {
							p = {
								firstName: p.fN,
								name: p.fN + ' ' + p.lN,
								lastName: p.lN,
								id: p.id,
								avatar: p.a,
								lat: p.lt,
								lng: p.lg,
								pupils: p.ps
							}

							$scope.setFindUser(p)
						}
					}

					$scope.$apply();
				}, 100);

				var runmap = document.querySelector('.contacts-runmap')
				if(runmap)
					runmap.style.height = (window.innerHeight - 229) + 'px'; //296
			}

			function fillInfo(){
				runmapService.get('parent/v1/' + $rootScope.active_school.id + '/get/myprofile', { 'cache': false }).then(function (response) {
					$scope.myUser = response.data;
					$scope.viewState.isReady = true;
				}, 
				function (error) {
					$scope.viewState.isReady = true;
				})
			}

			function getClasslist(callback) {		
				classlistService.get('parent/v1/'+$rootScope.active_school.id+'/listV2/classlist',{'cache':false}).then(function (response) {
					var data = response.data;
					var contacts_map = [];
					if(data.parents) {
						for(var i = 0; i < data.parents.length; i++) {
							var p = data.parents[i];
							if(p.rM)
								contacts_map.push(p);
						}

						try {
							localStorage.setItem('__c5', JSON.stringify(data).b64encode());
							localStorage.setItem('__c6', JSON.stringify(contacts_map).b64encode());
						} 
						catch(ex) {
							//Skip for now.
						}

						callback();
					}
				}, function (error) {
					callback();
				});
			}

			angular.element(document).ready(function(){
				getMapConfig();
			});
		}
	
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.classlist.details',[]).controller('classlistDetailController', classlistDetailController);
	/** @ngInject */

	function classlistDetailController(baseService, $scope, metadata, $state, $stateParams, classlistService, $rootScope, $uibModal, toastr, $translate, $window, $cacheFactory, regexes) {
		$scope.mapConfig = {};

		document.body.scrollTop = 0;
		document.documentElement.scrollTop = 0;

		$scope.user = {};
		$scope.viewState = {
			isReady: false
		};

		$scope.displayInputText = false;

		var metadata = metadata.data.metadata;
		var relationships = {};
		var genders = {};

		if(localStorage.getItem('__c5')) {
			var _c = JSON.parse(localStorage.getItem('__c5').b64decode());
			if(_c) {
				$rootScope.isEnabled = _c.me ? _c.me.rM : false;
				$scope.mapConfig = _c;
			}
		}

		function nameRelation(_id, _gender) {
			return relationships[_id, _gender]
		}

		if(localStorage.getItem('__c6')) {
			var _cm = JSON.parse(localStorage.getItem('__c6').b64decode());
			$scope.mapConfig.parents = _cm;

			if($rootScope.isEnabled) {
				var runmap = document.querySelector('.contacts-runmap')
				if(runmap)
					runmap.style.height = (window.innerHeight - 229) + 'px'; //296
			}
		}

		if(localStorage.getItem('__c5')) {
			$scope.mapConfig = JSON.parse(localStorage.getItem('__c5').b64decode())

			if ($scope.mapConfig.filters) {
				$scope.mapConfig.filters.unshift({id: -1, name: 'Whole school'})
			}
		}

		$scope.removeFmilyMember = function (id) {
			var _id = id;
			
			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'app/profile/views/delete-family-modal.html',
				backdropClass: 'backdrop-zindexed',
				size:'sm',
				controller: function($scope) {
					$scope.isMember = true;
					
					$scope.confirm = function() {
						$scope.deleting = true;
						modalInstance.close();

						classlistService.delete('parent/v1/delete/familyMember/' + _id, { 'cache': false }).then(function (response) {
							$scope.deleting = false;
							getUser();
							toastr.success('Family member removed successfully');
							
						},function (error) {
							$scope.deleting = false;
						})
					}

					$scope.close = function() {
						modalInstance.close();
					}
				}
			})
		};

		$scope.openEditAddress = function() {
			var myaddress = angular.copy($scope.user.address);

			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'app/classlist/views/address-modal.html',
				backdropClass: 'backdrop-zindexed',
				controller: function($scope) {
					$scope.myUser = { address: myaddress };
					
					$scope.save = function() {
						classlistService.put('parent/v1/parent/address', $scope.myUser.address, { 'cache': false }).then(function (response) {
							modalInstance.close();
							getMe();
							toastr.success('Successfully updated your address');
							
						},function (error) {
							
						})
					};

					$scope.close = function() {
						modalInstance.close();
					};
				},
				size: 'sm'
			});
		}
		$scope.getParentRelationship = function(p) {
			if(!p.parents){
				if(!$scope.isCurrentUser()){
					//this is other user...
					return relationships[p.relationshipId] + ' of'; 
				} else {
					return '';
				}	
			}
			
			for(var i = 0; i < p.parents.length; i++) {
				if($scope.user.id === p.parents[i].user) {
					return relationships[p.parents[i].relationshipId] + ' of'; 
				}
			}
		}

		$scope.openAddPupil = function (pupil) {
			if(pupil && pupil.id) {
				location.href = '#/pupil/edit/' + pupil.id;
			}
			else {
				location.href = '#/pupil/add';
			}
		};

		$scope.onAboutMePencin = function () {
			$scope.displayInputText = true;
		};

		$scope.deleteLink = function (link, index) {
			var payload = {
				"payload": {
					"href": link.href
				}
			}
			classlistService.post('parent/v1/remove/social/link', payload).then(function(response) {
				for (var i = 0; i < $scope.user.details.links.length; i++){
					if (index == i) {
						delete $scope.user.details.links[i];
						break;
					}
				}
			}, 
			function(error) {
				toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
			});
		};

		$scope.openAddLink = function () {
			if (!$scope.user.details.links) {
				$scope.user.details.links = [];
			}

			var links = $scope.user.details.links;
			
			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/classlist/views/link-modal.html',
				controller: function($scope) {

					$scope.viewState = {
						isReady: true
					};

					$scope.link = { };

					$scope.close = function() {
						modalInstance.close();
					};

					$scope.confirm = function () {
						$scope.viewState.isReady = false;
						var payload = {
							"payload": {
								"href": $scope.link.href,
								'text': $scope.link.text
							}
						}			
						classlistService.post('parent/v1/add/social/link', payload).then(function(response) {
							links.push({
								text: $scope.link.text,
								href: $scope.link.href
							});
							modalInstance.close();
						}, 
						function(error) {
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
							$scope.viewState.isReady = true;
						});
					}
				},
				size: 'sm'
			});
		};

		$scope.updateAboutMe = function () {
				var payload = {
					"payload":{
						"text": $scope.user.details.aboutMe && $scope.user.details.aboutMe != '' ? $scope.user.details.aboutMe : ""
					}
				}
				classlistService.post('parent/v1/update/aboutme',payload).then(function (response) {
					$scope.displayInputText = false;
				}, function (error) {
					$scope.displayInputText = false;
				});
		};

		$scope.openAddFamily = function (member) {

			if(member && (member.user || member.id)) {
				location.href = '#/family/edit/' + (member.user ? member.user : member.id);
			}
			else {
				location.href = '#/family/add';
			}
		};

		$scope.preLongPressCall = function(phone) {
			if(!$scope.isCurrentUser() && $scope.user.phoneNumber && $scope.user.phoneNumber.length > 2 && $rootScope.isNumeric($scope.user.phoneNumber)) {
				$rootScope.longPressCall(phone);
			}
		}

		$scope.preComposeTo = function(user) {
			if(!$scope.isCurrentUser()) {
				$rootScope.composeTo(user);
			}
		}

		$scope.setFindUser = function(u) {
			$scope.selectedSearch = false;
			if($scope.mapConfig.onSearchSelected) {
				$scope.mapConfig.onSearchSelected(u)
			}
		}

		$scope.getNearestHundred = getNearestHundred;

		function getMapConfig() {
			$scope.mapConfig._timestamp = new Date().getDate();
			$scope.mapready = true;

			var response = { }
			if(localStorage.getItem('__c5')) {
				response = JSON.parse(localStorage.getItem('__c5').b64decode())

				for(var i = 0; i < response.parents.length; i ++) {
					var p = response.parents[i]
					response.parents[i] = {
						firstName: p.fN,
						name: p.fN + ' ' + p.lN,
						lastName: p.lN,
						id: p.id,
						avatar: response.baseUrl + p.id,
						lat: p.lt,
						lng: p.lg,
						pupils: p.ps
					}
				}
			}

			$scope.mapConfig = response;

			if(response && response.me) {
				response.me.rM ? $rootScope.isEnabled = true : $rootScope.isEnabled = false;
			}

			if ($scope.mapConfig.filters){
				$scope.mapConfig.filters.unshift({id: -1, name: 'Whole school'})
			}

			if($rootScope.isEnabled) {
				var runmap = document.querySelector('.contacts-runmap')
				if(runmap)
					runmap.style.height = '300px';
			}
		}

		function getPerson() { 
			classlistService.get('parent/v1/'+$rootScope.active_school.id+'/get/'+$stateParams.id+'/parent',{'cache':false}).then(function (response) {
				$scope.viewState.isReady = true;
				$scope.user = response.data;
				$scope.user.relation  = nameRelation(response.data.relationshipId);
				$scope.user.me = $scope.user.id === $rootScope.active_user.id;
				$scope.user.lat = $scope.user.location.lat;
				$scope.user.lng = $scope.user.location.lng;
				
				if (!$scope.user.details) {
					$scope.user.details = {};
				}

				$scope.user.details.links ? $scope.user.details.links : [];
				
				if($scope.user.avatar)
					$scope.user.avatar = $scope.user.avatar + '?v=' + new Date().getTime();
				
				_.forEach(response.data.pupils, function(pupil){
					pupil.gender = nameGender(pupil.genderId);
				})
				if(response.data.address.countryId > 0){
					$scope.user.address.country = _.find(metadata.countries, {'id':response.data.address.countryId}).longName || '';
				}
				
				$scope.user.address.postCode = formatUKPostCode($scope.user.address.countryId, $scope.user.address.postCode);

				if($scope.user.phoneNumber) {
					//if there is no plus sign
					if ($scope.user.phoneNumber.indexOf("+") === -1) { 
						
						//if it has no leading zero
						if ($scope.user.phoneNumber.indexOf("0") !== 0 && $rootScope.isNumeric($scope.user.phoneNumber)){
							$scope.user.phoneNumber = '0'+	$scope.user.phoneNumber;
						}
					}
				}
				
				$scope.user.name = $scope.user.firstName + ' ' + $scope.user.lastName;
				setTimeout(function() {
					$scope.setFindUser($scope.user)
					$scope.$apply()
				}, 1);

				setTimeout(function() {
					$scope.viewState.isReady = true;
					$scope.$apply();
				}, 100);

			}, function (error) {
				$scope.viewState.isReady = true;
			});
		}

		function getMe() {
			classlistService.get('parent/v1/'+$rootScope.active_school.id+'/get/myprofile',{'cache':false}).then(function (response) {
				$scope.viewState.isReady = true;
				$scope.user = response.data;
				
				$scope.user.me = $scope.user.id === $rootScope.active_user.id;
				$scope.user.lat = $scope.user.location.lat;
				$scope.user.lng = $scope.user.location.lng;
				$scope.user.details = scope.user.details ? scope.user.details : {};

				if($scope.user.avatar)
					$scope.user.avatar = $scope.user.avatar + '?v=' + new Date().getTime();
				
				_.forEach(response.data.pupils, function(pupil){
					pupil.gender = nameGender(pupil.genderId);
				})
	
				if(response.data.address.countryId > 0){
					$scope.user.address.country = _.find(metadata.countries, { 'id': response.data.address.countryId }).longName || '';
				}
						
				$scope.user.address.postCode = formatUKPostCode($scope.user.address.countryId, $scope.user.address.postCode);

				if($scope.user.phoneNumber) {
					//if there is no plus sign
					if ($scope.user.phoneNumber.indexOf("+") === -1) { 
						
						//if it has no leading zero
						if ($scope.user.phoneNumber.indexOf("0") !== 0 && $rootScope.isNumeric($scope.user.phoneNumber)){
							$scope.user.phoneNumber = '0'+	$scope.user.phoneNumber;
						}
					}
				}
				
				$scope.user.name = $scope.user.firstName + ' ' + $scope.user.lastName;
				setTimeout(function() {
					$scope.setFindUser($scope.user)
					$scope.$apply()
				}, 2);

				setTimeout(function() {
					$scope.viewState.isReady = true;
					$scope.$apply();
				}, 100);

			}, function (error) {
				$scope.viewState.isReady = true;
			});
		}

		function getUser() {
			if($rootScope.active_user.id === $stateParams.id) {
				getMe();
			}
			else {
				getPerson();
			}
		}

		function nameGender(_id) {
			return genders[_id] || '';
		}
	
		var nameMonth = function (_id){
			return months[_id];
		}

		function formatUKPostCode(countryId, postCode){
			if (!(_.isUndefined(countryId) || _.isUndefined(postCode))) {
				if (countryId === 826 && postCode.length >= 6) {
					return addSpaceToIndexFromEnd(postCode, 3);
				}else {
					return postCode;
				}
			}	
		}

		function addSpaceToIndexFromEnd(string, index){
			var endStr, startStr;
			if (!(_.isUndefined(string) || _.isUndefined(index))) {
				if (!(string.charAt(index).includes(' '))) {
					endStr = string.substr(string.length-index, index);
					startStr = string.replace(endStr, " ");
					return startStr.concat(endStr); 
				} else {
					return string;
				}
			}
		}

		baseService.app_initialized = function(evt, args) {

			if($stateParams.id === '' || $stateParams.id === null) {
				$state.go('classlist.all')
			}
			else if($stateParams.id !== '') {
				getUser()
			}
			$scope.integration = $rootScope.active_school.integration;
			_.each(metadata.relationships, function (obj, index) {
				relationships[obj.id] = obj.longName;
			});

			_.each(metadata.genders, function (obj, index) {
				genders[obj.id] = obj.longName;
			});

			var months = { };
			_.each(metadata.months, function (obj, index) {
				months[obj.id] = obj.longName;
			});
			
			var parent_relationships = { };
			_.each(metadata.parent_relationships, function (obj, index) {
				parent_relationships[obj.id] = obj.longName;
			});
			
			$scope.relationToPupils = function (_id, _gender) {
				return namePupilRelation(relationships, parent_relationships, _id, _gender)
			};

			$scope.openEditName = function(me) {
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/classlist/views/edit-name-modal.html',
					controller: function($scope) {
						$scope.isClicked = 0;
						$scope.firstName = me.firstName;
						$scope.lastName = me.lastName;
						$scope.genderId = me.genderId;

						$scope.regexes = regexes;

						$scope.close = function() {
							modalInstance.close();
						};

						$scope.save = function() {
							$scope.isClicked += 1;

							var firstNameLength, lastNameLength;
							if ($scope.firstName === null) {
								firstNameLength = 0;
							} else {
								firstNameLength = $scope.firstName ? $scope.firstName.length : 0;
							}

							if ($scope.lastName === null) {
								lastNameLength = 0;
							} else {
								lastNameLength = $scope.lastName ? $scope.lastName.length : 0;
							}

							if (!($scope.firstName === null || firstNameLength < regexes.min.name 
								|| $scope.lastName === null || lastNameLength < regexes.min.name)) { 
							
								$scope.saving = true;
								classlistService.put('parent/v1/basicInfo', { 
									personalInfo: {
										firstName: $scope.firstName,
										lastName: $scope.lastName,
										genderId: $scope.genderId
									}
								})
								.then(function(response) {
									$scope.saving = false;
									modalInstance.close();
									getUser();
									$rootScope.refreshContext();
									localStorage.removeItem('__c5');
									$rootScope.loadContactsStorage();
								}, 
								function (err) {
									$scope.saving = false;
									if(error)
										error();
								});
							}
							else {
								toastr.info('Please fill the mandatory fields')
							}
						}
					},
					size: 'md'
				});
			}

			$scope.isCurrentUser = function() {
				return $scope.user.id === $rootScope.active_user.id;
			}
			
			$scope.back = function() {
				$rootScope.backFromPost = true;
				$window.history.back();
				
				if($rootScope.search_page)
					if($rootScope.search_page.keep_active)
						$rootScope.search_page = { active: true };
			}

			$scope.backContacts = function() {
				window.location.href = '/parent/#/classlist/all';
			}
			
			$scope.reportParent = function() {
				var userId = $scope.user.id, 
					schoolId = $rootScope.active_school.id,
					parentName = $scope.user.firstName +'  ' + $scope.user.lastName; 

				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/classlist/views/report-parent-modal.html',
					controller: function($scope){
						$scope.viewState = {
							isReady:true
						};

						$scope.close = function() {
							modalInstance.close();
						};

						$scope.parentName = parentName;

						$scope.report = function(){

							classlistService.post('parent/v1/reportParent',{
								'schoolId': schoolId,
								'reportedUser': userId
							}, { })
							.then(function(response) {
								toastr.success($translate.instant('REPORTING_SUCCESS'));
								modalInstance.close();
							}, 
							function(error) {
								
							})
						}
					},
					size: 'sm'
				});
			}

			$scope.muteParent = function() {
				var user = $scope.user;

				var modalInstance = $uibModal.open({
					animation: true,
					templateUrl: 'app/classlist/views/mute-parent-modal.html',
					backdropClass: 'backdrop-zindexed',
					size:'sm',
					controller: function($scope) {
						$scope.fullName = user.firstName + ' ' + user.lastName;
						$scope.parentName = user.firstName;

						$scope.confirm = function() {
							$scope.mutingAccount = true;

							toggleMuteParent(function() {
								user.muted = true;
								$scope.mutingAccount = false;
								modalInstance.close();
							}, 
							function() {
								$scope.mutingAccount = false;
							});
						}

						$scope.close = function() {
							modalInstance.close();
						}
					}
				})
			}

			$scope.unmuteParent = function() {
				$scope.unmutingAccount = true;

				toggleMuteParent(function() {
					$scope.user.muted = false;
					$scope.unmutingAccount = false;
				}, 
				function() {
					$scope.unmutingAccount = false;
				});
			}

			function toggleMuteParent(callback, error) {

				classlistService.put('parent/v1/mute/'+$rootScope.active_school.id+'/'+$scope.user.id, { })
				.then(function(response) {

					if(callback)
						callback();
				}, 
				function (err) {
					if(error)
						error();
				});
			}

			$scope.$on("$destroy", function() {
				if($rootScope.search_page)
					$rootScope.search_page.keep_active = false;
			});

			if ($rootScope.scrollToChildren) {
				$rootScope.scrollToChildren = false;
				setTimeout(function() {
					var scroll_to_children = document.getElementById('scroll_to_children');
					if (scroll_to_children) {
						scroll_to_children.scrollIntoView(true);
						window.scrollBy(0, -130);
					}
				}, 500);
			}
		}
		
		angular.element(document).ready(function(){
			getMapConfig();
		});

		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}
 
})();

(function () {
	'use strict';

	angular.module('modules.classlist.all', []).factory('classlistService', ['base', function (base) {
		return _.create(base, {});
	}]).controller('classlistAllController', classlistAllController);

	/** @ngInject */
	function classlistAllController(baseService, $scope, $rootScope, metadata, storage, classlistService, $translate, $timeout, $location, $state, $uibModal, $window, $stateParams) {
		$scope.nopupilsshowed = false;
		$scope.classlist = {};
		$scope.filters = [];
		$scope.tierId = 0;
		$scope.keyword = '';

		var cursor = 'none';
		var local_list;

		$scope.viewState = {
			isReady: true,
			isInitiated: false
		}

		var relationships = {};
		_.each(metadata.data.metadata.relationships, function (obj, index) {
			relationships[obj.id] = obj.longName;
		});

		$scope.beforeComposeTo = function (data, subject, baseURL) {
			$rootScope.userTag('PARENT_OPENED_MESSAGES_FROM_CONTACTS')
			$rootScope.composeTo(data, subject, baseURL)
		}

		$scope.gotoContactsMap = function () {
			$rootScope.userTag('PARENT_OPENED_MAP_FROM_CONTACTS')

			if ($scope.tierId)
				location.href = '#/classlist/map/0/' + $scope.tierId;
			else
				location.href = '#/classlist/map/0/';
		}

		$scope._parents = [];
		$scope._parents_placeholders = [];
		var moreloading = false;

		$scope.pushMoreUsers = function (value) {
			if ($scope._parents.length >= $scope.classlist.parents.length)
				return;

			var cur_length = $scope._parents.length;
			if ($scope.classlist.parents.length > ($scope._parents.length + value)) {
				for (var i = cur_length; i < (cur_length + value); i++) {
					$scope._parents.push($scope.classlist.parents[i])
				}
			}
			else {
				for (var i = cur_length; i < $scope.classlist.parents.length; i++) {
					$scope._parents.push($scope.classlist.parents[i])
				}
			}

			setTimeout(function () {
				$scope.$apply();
			}, 2);

			moreloading = false;

			if (!localStorage.getItem('PARENT_PRODUCT_DISCOVERY_FIRST_ONE_CLASSLIST')) {

				localStorage.setItem('PARENT_PRODUCT_DISCOVERY_FIRST_ONE_CLASSLIST', true);

				if ($rootScope.active_school && $rootScope.active_school.id) {
					$rootScope.checkTodo('PARENT_PRODUCT_DISCOVERY_FIRST_ONE_CLASSLIST').then(function (resp) {
						if (resp.data.payload.show) {
							var modalInstance = $uibModal.open({
								animation: true,
								backdrop: 'static',
								backdropClass: 'backdrop-zindexed',
								windowTemplateUrl: 'app/base/appcues/baseAppcueModal.html',
								templateUrl: 'app/base/appcues/thisis-classlist-modal.html',
								size: 'sm',
								controller: function ($scope) {
									$scope.isNewSchool = local_list && local_list.parents && local_list.parents.length == 1;

									$scope.close = function () {
										modalInstance.close();
										$rootScope.dismissTodo('PARENT_PRODUCT_DISCOVERY_FIRST_ONE_CLASSLIST').then(function (resp) {

										},
											function (error) { })
									};
								}
							})
						}
					},
						function (error) { })
				}
			}

			if (local_list && local_list.parents && local_list.parents.length === 1) {
				for (var i = 0; i < 4; i++) {
					$scope._parents_placeholders.push({});
				}
			}
		};

		$scope.getNearestHundred = getNearestHundred;

		$scope.openProfile = function (user) {
			location.href = '#/classlist/details/' + user.id + '/contact';
		}


		$scope.isProfileCompleted = function () {
			if (!localStorage.getItem('completed_profile')) {
				localStorage.setItem('completed_profile', true);
				return false;
			}
			return true;
		}

		$scope.openSearchContacts = function () {
			if ($rootScope.selectedContactsFilter)
				$rootScope.selectedContactsFilter.keyword = '';

			$rootScope.search_page = { active: true };

			$rootScope.resizeContactsList();

			setTimeout(function () {
				var s_input = document.querySelector('.search-contacts-input')
				$rootScope.selectedContactsFilter.keyword = '';
				s_input.focus();
			});

			$rootScope.userTag('PARENT_OPEN_CONTACT_SEARCH')
		}

		$scope.invite = function () {
			//$state.go('invite');
		}

		/**
		 * Function used in contacts dropdown filter
		 */
		function compareArray(a, b, array) {
			return array.includes(a.id) ? -1 : 1;
		}
		
		/**
		 *  Will create filters and sort by pupils classes first
		 */
		function fillFilters(data) {
			var myPupils = data.me.ps;
			if (!myPupils) {
				return;
			}
			
			var myPupilsClasses = myPupils.map(function (i) { return i.fTI })
			var myPupilsYears = myPupils.map(function (i) { return i.sTI })

			var localFilter = data.filters || [];

			localFilter.sort(function(a, b) {
				return compareArray(a, b, myPupilsClasses)
			});

			localFilter.sort(function(a, b) {
				return compareArray(a, b, myPupilsYears)
			});

			localFilter.unshift({
				'name': $translate.instant('ALL_CONTACTS_TXT'),
				'id': 0
			});

			$scope.filters = localFilter;
			$rootScope.storedFilters = $scope.filters;
		}

		$scope.nameRelation = function (_id) {
			return relationships[_id]
		};

		$rootScope.nameRelation = $scope.nameRelation;

		$scope.gotoInvite = function () {
			$rootScope.userTag('PARENT_CLICK_INVITE_FROM_CONTACTS')
			location.href = '#/invite';
		}

		$scope.gotoInviteSkeleton = function () {
			$rootScope.userTag('PARENT_CLICK_INVITE_FROM_CONTACTS_PLACEHOLDER')
			location.href = '#/invite';
		}

		$scope.gotoInviteCard = function () {
			$rootScope.userTag('PARENT_CLICK_INVITE_FROM_CONTACTS_CARD')
			location.href = '#/invite';
		}

		$rootScope.nameRelation = $scope.nameRelation;

		baseService.app_initialized = function (evt, args) {
			var schoolId = $rootScope.active_school.id;

			$scope.hasMoreParents = function () {
				return cursor !== 0 && $scope.keyword.length === 0 && $scope.classlist.length > 9;
			}

			function getClasslistSearch(tierId) {
				classlistService.get('parent/v1/' + schoolId + '/search/classlist/' + tierId + '/' + $scope.keyword, { 'cache': false }).then(function (response) {
					var data = response.data; // FIXME ?? Adrian 16 july 2020
					$scope.pushMoreUsers(20)
				}, function (error) {

				});
			}

			$scope.searchContacts = function () {
				if ($scope.keyword.length > 1) {
					$rootScope.keywordEnteredClPage = $scope.keyword;
					getClasslistSearch($scope.tierId);
				}
				else {
					if ($scope.keyword.length === 0) {
						cursor = 'none';
						$rootScope.keywordEnteredClPage = '';
					}
				}
			}

			$scope.getClasslist = function (tierId, render_only) {
				moreloading = false;
				local_list = new Array()

				if (tierId == 0 && cursor == 0)
					return;

				// Load contacts from storage first
				if (localStorage.getItem('__c5') && localStorage.getItem('__c4') && localStorage.getItem('__c4').b64decode() == $rootScope.active_school.id) {
					local_list = JSON.parse(localStorage.getItem('__c5').b64decode());
					fillFilters(local_list);
				}

				$scope.classlist.parents = [];
				$scope._parents = [];
				$scope._parents_placeholders = [];

				if (tierId || $scope.classlist.parents.length == 0) {
					if (localStorage.getItem('__c5') && localStorage.getItem('__c4') && localStorage.getItem('__c4').b64decode() == $rootScope.active_school.id) {
						var list = local_list.parents;

						if (tierId) {
							for (var i = 0; i < list.length; i++) {
								var item = list[i];
								item.l = null;

								if (item.ps) {
									for (var j = 0; j < item.ps.length; j++) {
										if (item.ps[j].fTI == tierId || item.ps[j].sTI == tierId) {
											$scope.classlist.parents.push(item)
											break;
										}
									}
								}
							}
						}
						else {
							$scope.classlist.parents = list;

						}

						$scope.pushMoreUsers(20);
					}
				}
				else {
					$scope.pushMoreUsers(20);
				}

				setTimeout(function () {
					$scope.$apply();
				}, 3);

				if (render_only)
					return;

				if (!localStorage.getItem('__c5') || (localStorage.getItem('__c4') && localStorage.getItem('__c4').b64decode() != $rootScope.active_school.id))
					$scope.loadingContacts = true;

				classlistService.get('parent/v1/' + schoolId + '/listV2/classlist', { 'cache': false })
					.then(function (response) {
						$scope.loadingContacts = false;

						var data = response.data;
						cursor = data.cursor || 0;

						$scope.noPupils = data.np;

						if ($scope.noPupils) {
							if ($scope.nopupilsshowed)
								return;

							$scope.nopupilsshowed = true;
							var modalInstance = $uibModal.open({
								animation: true,
								backdrop: 'static',
								backdropClass: 'backdrop-zindexed',
								templateUrl: 'app/classlist/views/no-pupil-modal.html',
								size: 'sm',
								controller: function ($scope) {

									$scope.close = function () {
										modalInstance.close();
									};
								}
							})
						}

						var contacts_map = [];
						if (data.parents) {
							for (var i = 0; i < data.parents.length; i++) {
								var p = data.parents[i];
								if (p.rM)
									contacts_map.push(p);
							}

							try {
								localStorage.setItem('__c5', JSON.stringify(data).b64encode());
								localStorage.setItem('__c6', JSON.stringify(contacts_map).b64encode());
							}
							catch (ex) {
							}

							fillFilters(data.filters);

							if (!localStorage.getItem('__c4') || localStorage.getItem('__c4').b64decode() != $rootScope.active_school.id) {
								localStorage.setItem('__c4', $rootScope.active_school.id.b64decode());

								if ($stateParams.tierId == -3) {
									if ($rootScope.storedFilters && $rootScope.storedFilters.length > 0) {
										$stateParams.tierId = $rootScope.storedFilters[1].id;
										$scope.tierId = $rootScope.storedFilters[1].id;
										$scope.getClasslist($stateParams.tierId, true)
									}
									else {
										$scope.getClasslist(null, true)
									}
								}
								else {
									$scope.getClasslist(null, true)
								}
							}

							if (localStorage.getItem('__c5')) {
								$rootScope.contacts_list = JSON.parse(localStorage.getItem('__c5').b64decode());
								if ($rootScope._parents) {

									if ($stateParams.tierId == -3) {
										if ($rootScope.storedFilters && $rootScope.storedFilters.length > 0) {
											$stateParams.tierId = $rootScope.storedFilters[1].id;
											$scope.tierId = $rootScope.storedFilters[1].id;
											$scope.getClasslist($stateParams.tierId, true)
										}
										else {
											$scope.getClasslist(null, true)
										}
									}
									else {
										$scope.getClasslist(null, true)
									}
								}
							}
						}
						else {
							localStorage.setItem('__c5', '');
							localStorage.setItem('__c6', '');
						}

						$scope.viewState.isInitiated = true;

					}, function (error) {
						$scope.loadingContacts = false;
					});
			}

			$scope.tierChanged = function (tierId) {
				cursor = 'none';
				$scope.keyword = '';
				$rootScope.keywordEnteredClPage = '';
				$rootScope.tierSelectedClPage = tierId ? tierId : '';
				$scope.getClasslist(tierId ? tierId : '', tierId ? true : false);
			}

			if (localStorage.getItem('__c5') && localStorage.getItem('__c4') && localStorage.getItem('__c4').b64decode() == $rootScope.active_school.id) {

			}
			else {
				$scope.tierChanged(null)
			}

			$scope.beforeTierChanged = function (tierId) {
				if (tierId && tierId != -1) {
					$rootScope.userTag('PARENT_FILTERED_BY_TIER')
					location.href = '#/classlist/all/' + tierId;
				} else {
					location.href = '#/classlist/all/';
				}

				setTimeout(function () {
					$scope.$apply()
				}, 100);
			}

			if (localStorage.getItem('__c5') && localStorage.getItem('__c4') && localStorage.getItem('__c4').b64decode() == $rootScope.active_school.id) {
				local_list = JSON.parse(localStorage.getItem('__c5').b64decode());
				fillFilters(local_list);
			}

			if ($rootScope.storedFilters) {
				if ($rootScope.storedFilters.length > 1) {
					if ($stateParams.tierId == -3) {
						$stateParams.tierId = $rootScope.storedFilters[1].id;
					}
				}
			}
			else {
				if ($stateParams.tierId == -3)
					$stateParams.tierId = ''
			}

			$scope.tierChanged($stateParams.tierId);

			$scope.isCurrentUser = function (parentId) {
				return $rootScope.active_user.id == parentId;
			}

			$rootScope.isCurrentUser = $scope.isCurrentUser;

			if ($rootScope.tierSelectedClPage) {
				$scope.tierId = $rootScope.tierSelectedClPage;
				if ($rootScope.keywordEnteredClPage !== '' && typeof $rootScope.keywordEnteredClPage !== 'undefined') {
					$scope.keyword = $rootScope.keywordEnteredClPage;
					$scope.viewState.isInitiated = true;
				}
			}
			else {
				$rootScope.tierSelectedClPage = 0;
				$scope.tierId = 0;
				if ($rootScope.keywordEnteredClPage !== '' && typeof $rootScope.keywordEnteredClPage !== 'undefined') {
					$scope.keyword = $rootScope.keywordEnteredClPage;
					$scope.viewState.isInitiated = true;
				}
				else {
					if ($location.search().fromParent && $rootScope.storedClasslist) {
						cursor = $rootScope.storedCursor;
						$scope.filters = $rootScope.storedFilters;
						$scope.viewState.isInitiated = true;
					}
					else {
						$rootScope.storedCursor = cursor;
					}
				}
			}

			var doc = document.documentElement;
			$window.onscroll = function () {
				if ($location.path().indexOf('/classlist/all') > -1) {
					var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
					var here = doc.scrollHeight - window.innerHeight;

					// if((window.pageYOffset >= doc.scrollHeight - window.innerHeight)
					// || (window.pageYOffset >= doc.scrollHeight - window.innerHeight - 300)
					// || (window.pageYOffset >= doc.scrollHeight - window.innerHeight - 100)) {

					if ((window.pageYOffset >= here) || (window.pageYOffset >= here - 250)) {

						if (moreloading)
							return;

						moreloading = true;
						$scope.pushMoreUsers(10);
					}
				}
			}
		}

		if ($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}
	}
})();
(function() {
	'use strict';

	angular.module('modules.announcements.view',[]).controller('announcementsViewController', announcementsViewController);

	/** @ngInject */
	function announcementsViewController(baseService, $scope, settings, $stateParams, announcementsService, toastr, $translate, $state, regexes, $sce, $rootScope) {

		baseService.app_initialized = function(evt, args) {
			var announcementId = $stateParams.id;
			var schoolId = $rootScope.active_school.id;
			$scope.redirectPages = $stateParams.redirectPages;
			$scope.posts = new Array();

			$scope.userName = $rootScope.active_user.firstName+' '+$rootScope.active_user.lastName;

			$scope.viewState = {
				isReady:true,
				isInitiated:true
			}
			
			$scope.dismissSample = function() {
				$scope.announcement.sample = false;
			}

			$scope.actionButtonText = $translate.instant('DOWNLOAD_BTN');

			$scope.back = function(redirectPages){
				$rootScope.evaluateBack(redirectPages);
			}
			
			function getAnnouncement(){
				$scope.viewState.isReady = false;
				
				announcementsService.get('announcement/v1/parent/' + schoolId + '/get/' + announcementId,{'xhr':true, 'cache':false})
				.then(function(response){
					$scope.announcement = response.data;
					//Emese 29/08/17 - We stick to the download only version for now.
					$scope.announcement.body = $rootScope.parseTagsToLinks($scope.announcement.body);
					$scope.announcement.sentTo = textToArray($scope.announcement.sentTo);

					setTimeout(function() {
						$scope.viewState.isReady = true;
						$scope.$apply();
					}, 100);

					if($scope.announcement.post)
						$scope.posts.push($scope.announcement.post.payload.post)
				}, 
				function(error) {
					$scope.viewState.isReady = true;
				});
			}

			getAnnouncement();
			
			function textToArray(arr){
				if (arr instanceof Array){
					return arr;
				}
				return arr.split(",")
			}
		}
		
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.announcements',[]).factory('announcementsService', ['base', function (base) {
		return _.create(base, { });
	}]).controller('announcementsController', announcementsController);

	/** @ngInject */
	function announcementsController($scope, $uibModal, announcementsService, toastr, $translate) {

	}

})();

(function() {
	'use strict';

	angular.module('modules.announcements.list',[]).controller('announcementsListController', announcementsListController);

	/** @ngInject */
	function announcementsListController(baseService, $scope, $rootScope, $uibModal, announcementsService, toastr, $translate) {

		$scope.viewState = {
			isReady:true
		};

		baseService.app_initialized = function(evt, args) {
			$rootScope.tempPosts = null;
			
			var schoolId = $rootScope.active_school.id;

			$scope.announcements = [];

			function getAnnouncements() {
				$scope.viewState.isReady = false;
				announcementsService.get('announcement/v1/parent/' + schoolId + '/list',{'xhr':true, 'cache':false}).then(function(response){
					if(response.data.items)
						$scope.announcements = response.data.items;
					$scope.viewState.isReady = true;
				}, 
				function(error){
					$scope.viewState.isReady = true;
				})
			}
			
			getAnnouncements();
		}
		
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}

})();

angular.module("CLParent").run(["$templateCache", function($templateCache) {$templateCache.put("app/composer/before-invite-modal.html","<div style=\"padding: 15px\"><div class=modal-header><h3 translate=LET_GUESTS_KNOW_MORE_HEADER></h3></div><div class=modal-body><p translate=LET_GUESTS_KNOW_MORE_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-default pull-right\" translate=GOTIT_BTN ng-click=close()></button></div></div>");
$templateCache.put("app/composer_mkp/before-invite-modal.html","<div style=\"padding: 15px\"><div class=modal-header><h3 translate=LET_GUESTS_KNOW_MORE_HEADER></h3></div><div class=modal-body><p translate=LET_GUESTS_KNOW_MORE_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-default pull-right\" translate=GOTIT_BTN ng-click=close()></button></div></div>");
$templateCache.put("app/schoolpage/wrapper.html","<div class=content-logged><div ui-view></div></div>");
$templateCache.put("app/schoolrequest/wrapper.html","<div class=\"content-logged schoolrequest\"><div class=header-content-separator></div><div ui-view></div></div>");
$templateCache.put("app/announcements/views/announcement-list.html","<section class=announcements><div class=\"page-view-header clearfix {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div><div premium-ad></div><div><div class=page-subheader-title><svg ng-click=goback() id=header-back-button class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <strong class=page-view-header__title translate=ANNOUNCEMENTS_TITLE></strong></div></div></div></div><div class=page-container-header-from-top><div class=col-md-12><div class=empty-state ng-if=\"announcements.length == 0 && viewState.isReady == true\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><line data-color=color-2 x1=20 y1=44 x2=44 y2=44 fill=none stroke=#4aa0f0 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></line><circle data-color=color-2 cx=19.5 cy=29.5 r=2.5 fill=none stroke=#4aa0f0 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></circle><circle data-color=color-2 cx=44.5 cy=29.5 r=2.5 fill=none stroke=#4aa0f0 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></circle><circle cx=32 cy=32 r=28 fill=none stroke=#4aa0f0 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></circle><circle data-color=color-2 data-stroke=none cx=19.5 cy=29.5 r=2.5 fill=#4aa0f0></circle><circle data-color=color-2 data-stroke=none cx=44.5 cy=29.5 r=2.5 fill=#4aa0f0></circle></g></svg><h4 translate=EMPTY_TITLE_ANNOUNCEMENTS></h4><p translate=EMPTY_DESCR_ANNOUNCEMENTS></p></div><div id=announcements-row-id class=\"row announcements__row\" ng-repeat=\"a in announcements | orderBy: \'-sendOn\'\" ui-sref=\"view({ \'id\': a.id })\"><div class=\"col-sm-4 announcements__cell\"><strong class=\"announcements__subject ann_list_subject\">{{ a.subject }}</strong> <a class=\"visible-sm visible-md visible-lg\"></a></div><div class=\"col-sm-4 announcements__cell send-to-cell-div\"><span class=send-to-cell>{{ a.sentByFirstName }} {{ a.sentByLastName }}</span></div><div class=\"col-sm-4 announcements__cell send-to-cell-div\"><span class=announcements__date>{{a.sentOn | date:\'MMM dd, yyyy\'}} {{a.sentOn | date:\' h:mm a\' }}</span></div></div></div></div></section>");
$templateCache.put("app/announcements/views/announcement-view-pdf.html","<section class=announcement-view add-participants ng-class=\"{\'is-visible\':viewState.isReady}\"><div class=\"page-view-header clearfix\"><div><div class=row><div class=col-xs-12 style=\"position: relative\"><svg id=header-back-button ng-click=back(redirectPages) class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg><div class=page-view-header__text><strong class=page-view-header__title>PDF VIEW</strong></div></div></div></div></div><div class=\"visible-md visible-lg\"><div class=row><div class=col-xs-7><canvas class=pdf-canvas></canvas></div></div></div></section>");
$templateCache.put("app/announcements/views/announcement-view.html","<section class=\"announcement-view hidden-content {{ viewState.isReady ? \'visible-content\' : \'\' }}\" post-likes><div class=\"page-view-header clearfix post-header\"><div style=\"position: relative\"><svg id=header-back-button ui-sref=announcements.list class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg><div class=page-view-header__text><strong class=page-view-header__title>{{::announcement.subject}}</strong></div></div></div><div class=page-container-header-from-top><div class=post-header><div><p ng-bind-html=::announcement.body></p></div><div style=\"margin-top: 10px\"><aside ng-if=announcement.post class=group-posts><post-asset ng-repeat=\"p in posts\" post-content=p readonly-post=1 post-context=HOME_VIEW class=enter user-avatar=active_user.avatar user-id=active_user.id user-name=userName post-events=events></post-asset></aside></div></div></div><div class=sample-popup ng-if=announcement.sample style=\"top: 30%; left: 25%\"><span class=dripicons-cross ng-click=dismissSample()></span><div class=sample-padding><div class=sample-container><span translate=SAMPLE_ANN_DESCR_1></span></div><br><div class=sample-container-big><span translate=SAMPLE_ANN_DESCR_2></span></div><br><div class=sample-container><span translate=SAMPLE_ANN_DESCR_3></span></div><br><div class=sample-container><span translate=SAMPLE_ANN_DESCR_4></span></div></div><div class=arrow></div></div></section>");
$templateCache.put("app/announcements/views/wrapper.html","<div class=\"content-logged announcements-wrapper\"><div ui-view autoscroll=false></div></div>");
$templateCache.put("app/base/appcues/baseAppcueModal.html","<div class=base-appcue-modal uib-modal-transclude native-appcue-template></div>");
$templateCache.put("app/base/appcues/events-modal.html","<div class=inline-appcue style=\"margin-top: 20px!important\"><div class=modal-header><h3><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><circle cx=16 cy=16 r=15 fill=none stroke=#005cb8 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></circle><circle data-color=color-2 data-stroke=none cx=10 cy=14 r=2 fill=#005cb8></circle><circle data-color=color-2 data-stroke=none cx=22 cy=14 r=2 fill=#005cb8></circle><path data-color=color-2 data-stroke=none d=M16,26a6,6,0,0,0,6-6H10A6,6,0,0,0,16,26Z fill=#005cb8></path></g></svg><div style=\"color: #005cb8\" translate=APPCUE_EVENTS_TEXT_1></div></h3></div><div class=modal-body><p translate=APPCUE_EVENTS_TEXT_2></p></div><div class=modal-footer style=\"text-align: center\"><div><button type=button class=\"btn btn-primary btn-primary-pink\" translate=APPCUE_EVENTS_TEXT_3 ng-click=\"inlineAppcueDoLater(\'PARENT_PRODUCT_DISCOVERY_EVENTS\')\"></div><div class=checkbox-label><label ng-click=\"inlineAppcueDontShowAgain(\'PARENT_PRODUCT_DISCOVERY_EVENTS\')\"><input type=checkbox> <span translate=DONT_SHOW_AGAIN></span></label></div></div></div><div class=empty-state ng-if=\"new_events.length == 0 && viewState.isReady == true\"><h4 translate=EMPTY_TITLE_ANNOUNCEMENTS></h4><p translate=EMPTY_DESCR_ANNOUNCEMENTS></p></div>");
$templateCache.put("app/base/appcues/getapp.html","<div class=\"custom-appcues getapp-appcue\"><div><div class=on-fullscreen-content><div><br><br><div class=use-app-logo><img style=width:180px alt=\"\" src=https://www.classlist.com/hubfs/_images/logos/classlist/Classlist%20-%20Brand%20blue@1x.svg></div><br><div class=use-app-text><span style=\"display: inline\">To use Classlist on your mobile,<br>download the app.</span><p style=\"margin-top: 10px\">Find out the latest and customise your notifications easily.</p></div><div style=\"margin-bottom: 15px\" class=btn-primary><div ng-click=downloadApp() translate=GET_THE_APP class=text></div></div><br><p style=\"margin-top: 10px\" class=use-app-text>Installed it already?</p><div class=btn-get-app style=\"margin-bottom: 15px\"><div class=text-2 ng-click=\"openApp() \">Open in the app</div></div><div class=store-btn><div ng-if=\"os==\'iOS\' \" ng-click=\"downloadApp() \" class=btn-appstore><img src=https://storage.googleapis.com/classlist-branding/email-template/ios-store-link.png></div><div ng-if=\"os==\'Android\' \" ng-click=\"downloadApp() \" class=btn-googleplay><img src=https://storage.googleapis.com/classlist-branding/email-template/android-store-link.png></div></div></div></div></div></div>");
$templateCache.put("app/base/appcues/groups-modal.html","<div class=inline-appcue style=\"margin-top: 20px!important\"><div class=modal-header><h3><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><circle cx=16 cy=16 r=15 fill=none stroke=#4AA0F0 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></circle><circle data-color=color-2 data-stroke=none cx=10 cy=14 r=2 fill=#4AA0F0></circle><circle data-color=color-2 data-stroke=none cx=22 cy=14 r=2 fill=#4AA0F0></circle><path data-color=color-2 data-stroke=none d=M16,26a6,6,0,0,0,6-6H10A6,6,0,0,0,16,26Z fill=#4AA0F0></path></g></svg><div translate=APPCUE_GROUPS_TEXT_1></div></h3></div><div class=modal-body><p translate=APPCUE_GROUPS_TEXT_2></p></div><div class=modal-footer style=\"text-align: center\"><div><button type=button class=\"btn btn-primary btn-primary-pink\" translate=APPCUE_GROUPS_TEXT_3 ng-click=\"inlineAppcueDoLater(\'PARENT_PRODUCT_DISCOVERY_GROUPS\')\"></div><div class=checkbox-label><label ng-click=\"inlineAppcueDontShowAgain(\'PARENT_PRODUCT_DISCOVERY_GROUPS\')\"><input type=checkbox> <span translate=DONT_SHOW_AGAIN></span></label></div></div></div>");
$templateCache.put("app/base/appcues/introduce-yourself-modal.html","<div class=inline-appcue><div class=modal-header><h3><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><circle cx=16 cy=16 r=15 fill=none stroke=#4AA0F0 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></circle><circle data-color=color-2 data-stroke=none cx=10 cy=14 r=2 fill=#4AA0F0></circle><circle data-color=color-2 data-stroke=none cx=22 cy=14 r=2 fill=#4AA0F0></circle><path data-color=color-2 data-stroke=none d=M16,26a6,6,0,0,0,6-6H10A6,6,0,0,0,16,26Z fill=#4AA0F0></path></g></svg><div translate=INTRO_YOURSELF_TEXT_1></div></h3></div><div class=modal-body><p translate=INTRO_YOURSELF_TEXT_2></p></div><div class=modal-footer style=\"text-align: center\"><div><button type=button class=\"btn btn-primary btn-primary-pink\" translate=INTRO_YOURSELF_TEXT_3 ng-click=\"inlineAppcueStart(\'PARENT_PRODUCT_DISCOVERY_INTRODUCE\')\"></div><div><a ng-click=\"inlineAppcueDoLater(\'PARENT_PRODUCT_DISCOVERY_INTRODUCE\')\"><span translate=DOT_THIS_LATER></span></a></div><div class=checkbox-label><label ng-click=\"inlineAppcueDontShowAgain(\'PARENT_PRODUCT_DISCOVERY_INTRODUCE\')\"><input type=checkbox> <span translate=DONT_SHOW_AGAIN></span></label></div></div></div>");
$templateCache.put("app/base/appcues/marketplace-modal.html","<div class=inline-appcue style=\"margin-top: 20px!important\"><div class=modal-header><h3><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><circle cx=16 cy=16 r=15 fill=none stroke=#005cb8 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></circle><circle data-color=color-2 data-stroke=none cx=10 cy=14 r=2 fill=#005cb8></circle><circle data-color=color-2 data-stroke=none cx=22 cy=14 r=2 fill=#005cb8></circle><path data-color=color-2 data-stroke=none d=M16,26a6,6,0,0,0,6-6H10A6,6,0,0,0,16,26Z fill=#005cb8></path></g></svg><div style=\"color: #005cb8\" translate=APPCUE_MARKETPLACE_TEXT_1></div></h3></div><div class=modal-body><p translate=APPCUE_MARKETPLACE_TEXT_2></p></div><div class=modal-footer style=\"text-align: center\"><div><button type=button class=\"btn btn-primary btn-primary-pink\" translate=APPCUE_MARKETPLACE_TEXT_3 ng-click=\"inlineAppcueDoLater(\'PARENT_PRODUCT_DISCOVERY_MARKETPLACE\')\"></div><div class=checkbox-label><label ng-click=\"inlineAppcueDontShowAgain(\'PARENT_PRODUCT_DISCOVERY_MARKETPLACE\')\"><input type=checkbox> <span translate=DONT_SHOW_AGAIN></span></label></div></div></div>");
$templateCache.put("app/base/appcues/qr-code-download.html","<div class=\"custom-appcues welcome-appcue qr-code-appcue\" style=\"width: 100%;overflow-y: auto\"><div><div class=on-fullscreen-content><div><div class=welcome-logo><img alt=\"\" src=https://storage.googleapis.com/classlist-branding/app-assets/classlist-new-logo.svg style=\"width: 100px\"></div><h2 style=\"font-weight: 900; color: #001031; font-size:22px; margin-top:15px; margin-bottom:25px\">{{ active_school.name }}</h2><div style=\"font-weight: 900; color: #001031; font-size:18px\" class=welcome-name><span translate=GET_THE_APP2></span></div><div style=\"font-size:16px;margin-top:5px;font-weight: 500; color:#001031\"><span translate=SCAN_WITH_PHONE></span></div><div class=box-wrapper style=margin-top:5px><figure class=box style=\"height: auto; padding-bottom: 20px\"><img width=100px height=100px style=\"cursor: pointer\" alt=\"\" ng-src=\"{{\'https://storage.googleapis.com/classlist-branding/app-assets/ParentQRRedirection.png\'}}\" onerror=\"this.src=\'assets/icons/default-avatar.png\'\"></figure></div><div style=\"padding-left: 20%; padding-right: 20%; text-align: left\"><p translate=QR_CODE_APPCUES_LIST_TITLE style=\"font-weight: 900; color: #001031; font-size:18px; margin-bottom:0px\"></p><table class=qr-code-list><tr><td style=display:flex><img style=width:30px;padding-right:16px src=https://storage.googleapis.com/classlist-branding/email-template/check.png></td><td translate=QR_CODE_APPCUES_LIST_1 style=\"font-weight: 500; color: #001031; font-size:16px\"></td></tr><tr><td style=display:flex><img style=width:30px;padding-right:16px src=https://storage.googleapis.com/classlist-branding/email-template/check.png></td><td translate=QR_CODE_APPCUES_LIST_2 style=\"font-weight: 500; color: #001031; font-size:16px\"></td></tr><tr><td style=display:flex><img style=width:30px;padding-right:16px src=https://storage.googleapis.com/classlist-branding/email-template/check.png></td><td translate=QR_CODE_APPCUES_LIST_3 style=\"font-weight: 500; color: #001031; font-size:16px\"></td></tr><tr><td style=display:flex><img style=width:30px;padding-right:16px src=https://storage.googleapis.com/classlist-branding/email-template/check.png></td><td translate=QR_CODE_APPCUES_LIST_4 style=\"font-weight: 500; color: #001031; font-size:16px\"></td></tr><tr><td style=display:flex><img style=width:30px;padding-right:16px src=https://storage.googleapis.com/classlist-branding/email-template/check.png></td><td translate=QR_CODE_APPCUES_LIST_5 style=\"font-weight: 500; color: #001031; font-size:16px\"></td></tr></table></div><br><div style=\"padding-left: 20%; padding-right: 20%; text-align: left\"><div style=\"font-weight: 700;padding-bottom:5px\" translate=LOG_IN_TO_APP></div><div style=\"display: flex\"><div style=\"margin-right: 5px\"><a title=\"apple store\" ng-click=gotoAppStore() target=_blank><img height=auto style=\"max-width: 200px\" src=https://storage.googleapis.com/classlist-branding/email-template/ios-store-link.png width=90 alt=AppleStore></a></div><div style=\"margin-right: auto\"><a title=\"play store\" ng-click=gotoGooglePlay() target=_blank style=text-decoration:none><img src=https://storage.googleapis.com/classlist-branding/email-template/android-store-link.png width=90 alt=GooglePlay></a></div><div style=\"text-align: right\"><a ng-click=continueBrowser() class=show-btn style=\"text-decoration: none\"><span style=\"font-size:16px;text-decoration: underline; font-weight: 600;color:#005cb8\" class=use-app-link translate=GOT_THE_APP></span> <span class=dripicons-chevron-right style=\"font-size:16px;vertical-align: middle; color:#005cb8\"></span></a></div></div></div></div></div></div></div>");
$templateCache.put("app/base/appcues/thisis-classlist-modal.html","<div class=thisis-classlist-modal-body><div class=modal-header><h3><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><circle cx=16 cy=16 r=15 fill=none stroke=#4AA0F0 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></circle><circle data-color=color-2 data-stroke=none cx=10 cy=14 r=2 fill=#4AA0F0></circle><circle data-color=color-2 data-stroke=none cx=22 cy=14 r=2 fill=#4AA0F0></circle><path data-color=color-2 data-stroke=none d=M16,26a6,6,0,0,0,6-6H10A6,6,0,0,0,16,26Z fill=#4AA0F0></path></g></svg><div translate=THISISYOURCLASSLIST_TEXT_1></div></h3></div><div class=modal-body><div ng-show=!isNewSchool><ul class=THISISYOURCLASSLIST-LI><li><span translate=THISISYOURCLASSLIST_TEXT_2></span></li><li><span translate=THISISYOURCLASSLIST_TEXT_3></span></li><li><span translate=THISISYOURCLASSLIST_TEXT_4></span></li></ul></div><div ng-show=isNewSchool><p translate=THISISYOURCLASSLIST_TEXT_6></p></div></div><div class=modal-footer style=\"text-align: center\"><button type=button class=\"btn btn-primary btn-primary-pink\" ng-click=close() style=\"width: 100%; margin: auto; max-width: 270px\"><span translate=THISISYOURCLASSLIST_TEXT_7></span></button></div></div>");
$templateCache.put("app/base/appcues/welcome.html","<div class=\"custom-appcues welcome-appcue\" style=width:100%><div><div class=on-fullscreen-content><div><div class=welcome-logo><img alt=\"\" src=https://start.classlist.com/classlist-logo-icon-blue.2c417856d821c2c735fd.svg style=\"width: 64px\"></div><h2 class=school-name>{{ active_school.name }}</h2><div class=welcome-name><div><span translate=APPCUE_WELCOME_TEXT_1></span> {{ active_user.firstName }}</div><div translate=APPCUE_WELCOME_TEXT_2></div></div><div class=box-wrapper><figure class=box><img class=image-box alt=\"\" id=welcomeappcueimg src=assets/icons/default-avatar.png></figure><!-- <figure class=\"box\">\n                        <img class=\"image-box\" alt=\"\" ng-src=\"{{\'https://storage.googleapis.com/classlist-branding/app-assets/events.png\'}}\" onerror=\"this.src=\'assets/icons/default-avatar.png\'\">\n                    </figure>\n                    <figure class=\"box\">\n                        <img class=\"image-box\" alt=\"\" ng-src=\"{{\'https://storage.googleapis.com/classlist-branding/app-assets/chat.png\'}}\" onerror=\"this.src=\'assets/icons/default-avatar.png\'\">\n                    </figure> --></div><div style=\"text-align:center; margin-top: 30px\"><a ng-click=onDownloadButtonClicked() class=btn-continue>Continue to Classlist!</a></div></div></div></div></div>");
$templateCache.put("app/base/appcues/what-about-coffee-modal.html","<div class=inline-appcue><div class=modal-header><h3><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\"><g transform=\"translate(0, 0)\"><path fill=#4AA0F0 d=\"M45,18h-7v-2c0-0.553-0.447-1-1-1H9c-0.553,0-1,0.447-1,1v18c0,3.859,3.141,7,7,7h16c3.859,0,7-3.141,7-7v-1 h3c2.757,0,5-2.243,5-5v-9C46,18.447,45.553,18,45,18z M44,28c0,1.654-1.346,3-3,3h-3V20h6V28z\"></path><path data-color=color-2 fill=#4AA0F0 d=M23,9c0.553,0,1-0.447,1-1V2c0-0.553-0.447-1-1-1s-1,0.447-1,1v6C22,8.553,22.447,9,23,9z></path><path data-color=color-2 fill=#4AA0F0 d=\"M14,11c0.553,0,1-0.447,1-1V4c0-0.553-0.447-1-1-1s-1,0.447-1,1v6C13,10.553,13.447,11,14,11 z\"></path><path data-color=color-2 fill=#4AA0F0 d=\"M32,11c0.553,0,1-0.447,1-1V4c0-0.553-0.447-1-1-1s-1,0.447-1,1v6C31,10.553,31.447,11,32,11 z\"></path><path fill=#4AA0F0 d=M8,47h30c2.209,0,4-1.791,4-4H4C4,45.209,5.791,47,8,47z></path></g></svg> <span translate=HOW_ABOUT_CLASS_COFFEE_TEXT_1></span></h3></div><div class=modal-body><p translate=HOW_ABOUT_CLASS_COFFEE_TEXT_2></p></div><div class=modal-footer style=\"text-align: center\"><div><button type=button class=\"btn btn-primary btn-primary-pink\" translate=HOW_ABOUT_CLASS_COFFEE_TEXT_3 ng-click=\"inlineAppcueStart(\'PARENT_PRODUCT_DISCOVERY_MEETUP\')\"></div><div><a ng-click=\"inlineAppcueDoLater(\'PARENT_PRODUCT_DISCOVERY_MEETUP\')\"><span translate=DOT_THIS_LATER></span></a></div><div class=checkbox-label><label ng-click=\"inlineAppcueDontShowAgain(\'PARENT_PRODUCT_DISCOVERY_MEETUP\')\"><input type=checkbox> <span translate=DONT_SHOW_AGAIN></span></label></div></div></div>");
$templateCache.put("app/base/views/before-posting-marketplace-modal.html","<div style=\"padding: 15px\"><div class=modal-body><p translate=BEFORE_POSTING_MARKETPLACE></p></div><div class=modal-footer><button type=button class=\"btn btn-default pull-right\" translate=CREATE_AD ng-click=createAd()><button type=button class=\"btn btn-default pull-right\" translate=CONTINUE_POSTING ng-click=keepPostingHere()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/base/views/before-posting-modal.html","<div style=\"padding: 15px\"><div class=modal-body><p translate=BEFORE_POSTING></p></div><div class=modal-footer><button type=button class=\"btn btn-default pull-right\" translate=CREATE_AD ng-click=createAd()><button type=button class=\"btn btn-default pull-right\" translate=CONTINUE_POSTING ng-click=keepPostingHere()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/base/views/disabled-modal.html","<div class=disabled-modal role=document id=pending-approval-id><div class=modal-content><div class=modal-header><a href=#/ ><span ng-click=close() class=\"dripicons-cross close-btn pull-right\"></span></a><h4 class=modal-title-disabled translate=MULTIPLE_SCHOOL_TITLE></h4></div><div class=modal-body><div><p translate=MULTIPLE_SCHOOL_DEACTIVATED_ACCOUNT_TEXT translate-values=\"{\'schoolName\': school}\"></p><p translate=MULTIPLE_SCHOOL_REACTIVATED_ACCOUNT_TEXT></p></div></div><div class=grey-line></div><div class=modal-header><h4 class=modal-title-disabled translate=MULTIPLE_SCHOOL_REGISTER_NEW_TEXT></h4></div><div class=modal-body style=\"padding-top: 0px!important; padding-bottom: 0px!important\"><div><p translate=MULTIPLE_SCHOOL_REGISTER_ANOTHER_TEXT></p></div><div class=disabled-footer><button class=\"btn btn-ghost delete-btn\" translate=NEW_SCHOOL_BTN ng-click=goToApply()></button></div></div><div class=modal-header style=\"padding-top: 0px!important\"><h4 class=modal-title-disabled translate=MULTIPLE_SCHOOL_DELETE_ACCOUNT translate-values=\"{\'schoolName\': school}\" style=\"padding-top: 0px!important\"></h4></div><div class=modal-body style=\"padding-top: 0px!important\"><div><p translate=MULTIPLE_SCHOOL_REGISTER_ANOTHER_TEXT></p></div><p class=delete-text translate=MULTIPLE_SCHOOL_DELETE_PERSONAL_DETAILS translate-values=\"{\'schoolName\': school}\"></p><input class=password type=password ng-model=password placeholder=Password><div translate=\"{{ deletingAccountError }}\" class=\"alert alert-error\" ng-show=deletingAccountError></div><div class=disabled-footer><a class=pull-left ng-click=gotoForgotPwd() translate=FORGOT_MY_PWD></a> <button class=\"btn btn-ghost delete-btn\" ng-disabled=\"!password || deletingAccount \" translate=DELETE_ACCOUNT_BTN ng-click=delete()></button></div></div></div></div>");
$templateCache.put("app/base/views/download-app-modal.html","<div><div class=modal-body style=\"padding: 22px 22px\"><p translate=CLASSLIST_BETTER_APP style=\"margin: 20px 0\"></p><div><div style=text-align:right><button type=button class=\"btn btn-ghost\" translate=GET_APP ng-click=openApp()></button></div><div style=\"margin-top: 20px; text-align:right\"><a translate=GET_APP_SKIP ng-click=skip()></a></div></div></div></div>");
$templateCache.put("app/base/views/footer.html","<footer class=\"footer center-text\"><img alt=\"\" src=assets/images/classlist-footer-logo.svg width=150 height=32> <small translate=REG_FOOTER></small></footer>");
$templateCache.put("app/base/views/header.html","<header class=header-logged><div class=container><div class=wrapper><figure id=school-selector-id ng-if=active_school class=\"school-selector clearfix\" ng-click=showSchoolSelector() click-outside=leaveSchoolSelector()><div class=\"school-logo school-logo-header pull-left hidden-xs\"><img alt=\"\" ng-src=\"{{ getServingURL(active_school.logo, 42, true) }}\" width=40 height=40 onerror=\"this.src=\'assets/icons/default-school-logo.png\'\"></div><figcaption class=\"school-name pull-left\"><div>{{active_school.name}}</div><span class=\"dripicons-multiple-school multischool-arrow\"></span></figcaption><div class=dropdown-menu ng-show=ifShowSchoolSelector click-outside=closeSchoolSelector()><div ng-repeat=\"school in schools\" ng-if=\"school.id != active_school.id\" ng-click=switchSchool(school) class=multi-school-item><img alt=\"\" ng-src=\"{{ getServingURL(school.logo, 24, true) }}\" class=logo onerror=\"this.src=\'assets/icons/default-school-logo.png\'\"><div class=dropdown-school-name>{{ school.name }}</div><div tooltip ng-if=\"school.status == \'WAITING APPROVAL\'\"><span class=tltp translate=PENDING_APPROVAL></span> <span class=\"dripicons-loading icon-loading icon\"></span></div><div tooltip ng-if=\"school.status == \'DISABLED\'\"><span class=tltp translate=DISABLED></span> <span class=\"dripicons-wrong icon-disabled icon\"></span></div></div><div id=request-school-id class=request-school ui-sref=schoolrequest.start><span class=dripicons-plus></span> <span>Apply for a new school</span></div></div></figure><div class=\"top-nav top-nav--right\"><ul><li ng-if=\"active_school.admin == true\" class=\"{{ switchingApps ? \'switching-apps-disabled\' : \'\' }}\"><a id=desktop-switch-id ng-click=switchApps() class=small-switch><div class=switch-admin-circle><div ng-if=\"schoolSideNotifications > 0\">{{schoolSideNotifications}}</div><svg class=switch-admin-svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><polygon fill=none stroke=#627293 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 points=\"22,7 15,2 15,5 3,5 3,9 15,9 15,12 \" stroke-linejoin=miter></polygon><polygon data-color=color-2 fill=none stroke=#627293 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 points=\" 2,17 9,22 9,19 21,19 21,15 9,15 9,12 \" stroke-linejoin=miter></polygon></g></svg></div><span translate=TOPNAV_MANAGECOMMUNITY class=manage-community-label></span></a></li><li ng-if=active_school class=\"{{ switchingApps ? \'switching-apps-disabled\' : \'\' }} small-messages-container\"><a id=desktop-switch-id ui-sref=inbox.list class=small-messages><div><div ng-if=\"notifsContainer.messages > 0\">{{notifsContainer.messages}}</div><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><polyline data-color=color-2 points=\"23 5 23 18 19 18 19 22 13 18 12 18\" fill=none stroke=#627293 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></polyline><polygon points=\"19 2 1 2 1 14 5 14 5 19 12 14 19 14 19 2\" fill=none stroke=#627293 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></polygon></g></svg></div></a></li></ul></div></div></div><loader></loader></header><ng-include src=\"\'app/base/views/white-screen.html\'\"></ng-include>");
$templateCache.put("app/base/views/leave-page-modal.html","<div><div class=modal-header><h3 translate=LEAVE_HEADER></h3></div><div class=modal-body><p translate=LEAVE_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=OK_BTN ng-click=confirm()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/base/views/not-found-modal.html","<div><div class=modal-body style=\"padding: 40px\"><img alt=\"\" src=assets/images/whoops.svg><p ng-if=!notFoundPost translate=NOT_FOUND_TEXT style=\"margin: 20px 0\"></p><p ng-if=notFoundPost translate=NOT_FOUND_TEXT_POST style=\"margin: 20px 0\"></p><div style=\"height: 40px\"><button type=button class=\"btn btn-ghost pull-right\" translate=HOMEPAGE_BUTTON ng-click=confirm()></div></div></div>");
$templateCache.put("app/base/views/old-version-modal.html","<div><div class=modal-body style=\"padding: 22px 22px\"><p style=\"margin: 20px 0\">We\'ve been busy updating and improving Classlist! Press OK to get the latest version.<br>Thanks for using Classlist.</p><div><div style=text-align:right><button type=button class=\"btn btn-ghost\" ng-click=confirm()>OK</button></div></div></div></div>");
$templateCache.put("app/base/views/pending-approval-modal.html","<div class=pending-modal><div class=\"modal-header pending-modal-header\"><a><span ng-click=close() class=\"dripicons-cross pending-modal-cross pull-right\"></span></a><h3 class=text translate=PENDING_APPROVAL_MODAL_TEXT_1></h3></div><div class=\"modal-body pending-modal-body\"><p translate=PENDING_APPROVAL_MODAL_TEXT_2></p><p translate=PENDING_APPROVAL_MODAL_TEXT_3></p><p translate=PENDING_APPROVAL_MODAL_TEXT_4></p><br><div><p style=\"font-weight: 600\" translate=DELETE_ACCOUNT translate-values=\"{\'school\': school_name }\"></p><p translate=DELETE_ACCOUNT_TEXT_1></p><br><p translate=INSERT_PASSWORD></p><div style=\"max-width: 200px\"><input id=delete-pwd-id type=password class=form-control placeholder=Password ng-model=vm.password ng-minlength=2 ng-maxlength=250 maxlength=250 required></div><br><div translate=\"{{ deletingAccountError }}\" class=\"alert alert-error\" ng-show=deletingAccountError></div><div><button id=delete-account-btn-id type=button class=\"btn btn-primary\" ng-disabled=\"!vm.password || deletingAccount\" translate=DELETE_BTN_MODAL ng-click=confirm()></div></div></div></div>");
$templateCache.put("app/base/views/plus-menu.html","<div ng-click=closePlusMenu() tab-menu-container class=\"{{ showPlus ? \'absolute-top\' : \'\' }}\"><div plus-menu class=\"{{ showPlus ? \'active\' : \'\' }}\" ng-class=\"{\'desktop-plus-menu\': !isMobile}\"><div><div class=title translate=CREATE_NEW></div><ul><li ng-click=menuPlus()><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><polyline points=\"9 5 2 5 2 22 19 22 19 15\" fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></polyline><polygon data-color=color-2 points=\"11 16 7 17 8 13 19 2 22 5 11 16\" fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></polygon></g></svg><div><span translate=POST_LABEL></span><p translate=PLUS_DESCR_1></p></div></li><li ng-click=createNewMessage(2)><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><polyline data-color=color-2 points=\"23 5 23 18 19 18 19 22 13 18 12 18\" fill=none stroke=#627293 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></polyline><polygon points=\"19 2 1 2 1 14 5 14 5 19 12 14 19 14 19 2\" fill=none stroke=#627293 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></polygon></g></svg><div><span translate=PLUS_PRIVATE_MESSAGE></span><p translate=PLUS_DESCR_3></p></div></li><li ng-click=checkCreateEvent()><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><line data-color=color-2 x1=1 y1=8 x2=23 y2=8 fill=none stroke=#444444 stroke-miterlimit=10 stroke-width=2></line><rect x=1 y=3 width=22 height=19 rx=2 ry=2 fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></rect><line data-color=color-2 x1=6 y1=1 x2=6 y2=4 fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></line><line data-color=color-2 x1=18 y1=1 x2=18 y2=4 fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></line></g></svg><div><span translate=PLUS_EVENT></span><p translate=PLUS_DESCR_4></p></div></li><li ui-sref=groups.create><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><path data-color=color-2 fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M4,7L4,7 C2.895,7,2,6.105,2,5v0c0-1.105,0.895-2,2-2h0c1.105,0,2,0.895,2,2v0C6,6.105,5.105,7,4,7z\" stroke-linejoin=miter></path><path data-color=color-2 fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M6,21H3v-4 l-2,0v-5c0-1.105,0.895-2,2-2h1\" stroke-linejoin=miter></path><path data-color=color-2 fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M20,7L20,7 c1.105,0,2-0.895,2-2v0c0-1.105-0.895-2-2-2h0c-1.105,0-2,0.895-2,2v0C18,6.105,18.895,7,20,7z\" stroke-linejoin=miter></path><path data-color=color-2 fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M18,21h3v-4 l2,0v-5c0-1.105-0.895-2-2-2h-1\" stroke-linejoin=miter></path><path fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M12,7L12,7 c-1.657,0-3-1.343-3-3v0c0-1.657,1.343-3,3-3h0c1.657,0,3,1.343,3,3v0C15,5.657,13.657,7,12,7z\" stroke-linejoin=miter></path><path fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M15,23H9v-6H7v-5 c0-1.105,0.895-2,2-2h6c1.105,0,2,0.895,2,2v6h-2V23z\" stroke-linejoin=miter></path></g></svg><div><span translate=TOPNAV_GROUP></span><p translate=PLUS_DESCR_5></p></div></li><li ng-click=postMarketplace()><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><polyline points=\"4 13 4 22 20 22 20 13\" fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></polyline><path data-color=color-2 d=M4,2,1,7A2.992,2.992,0,0,0,6.667,8.347a2.977,2.977,0,0,0,5.333,0,2.977,2.977,0,0,0,5.333,0A2.992,2.992,0,0,0,23,7L20,2Z fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></path><polyline data-cap=butt points=\"10 22 10 16 14 16 14 22\" fill=none stroke=#444444 stroke-miterlimit=10 stroke-width=2 stroke-linecap=butt stroke-linejoin=miter></polyline></g></svg><div><span translate=PLUS_MARKETPLACE></span><p translate=PLUS_DESCR_2></p></div></li><li ng-if=\"active_school.admin && active_school.approved\" ng-click=switchCommunityEvents() class=schoolside-icon><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><line data-color=color-2 x1=1 y1=8 x2=23 y2=8 fill=none stroke=#00796B stroke-miterlimit=10 stroke-width=2></line><rect x=1 y=3 width=22 height=19 rx=2 ry=2 fill=none stroke=#00796B stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></rect><line data-color=color-2 x1=6 y1=1 x2=6 y2=4 fill=none stroke=#00796B stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></line><line data-color=color-2 x1=18 y1=1 x2=18 y2=4 fill=none stroke=#00796B stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></line></g></svg><div><span translate=COMMUNITY_EVENT style=\"color: #00796B!important\"></span><p translate=PLUS_DESCR_6></p></div></li><li ng-if=\"active_school.admin && active_school.approved\" ng-click=switchAnnouncementCreate() class=schoolside-icon><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><path data-cap=butt data-color=color-2 d=M9.336,14l2.519,6.252a2,2,0,0,1-1.108,2.6h0a2,2,0,0,1-2.6-1.108L5,14 fill=none stroke=#00796B stroke-miterlimit=10 stroke-width=2 stroke-linecap=butt stroke-linejoin=miter></path><path d=M11,6H5a4,4,0,0,0,0,8h6l8,4V2Z fill=none stroke=#00796B stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></path><path data-stroke=none d=M21,7v6a3,3,0,0,0,0-6Z fill=#00796B></path></g></svg><div><span translate=ANNOUNCEMENT style=\"color: #00796B!important\"></span><p translate=PLUS_DESCR_7></p></div></li></ul><div><div class=cancel-button translate=CANCEL_BTN></div></div></div></div></div><div ng-if=\"showPlus || showMenu\" class=mobile-menu-background></div>");
$templateCache.put("app/base/views/search-contacts.html","<div ng-show=search_page.active class=\"search-page-container {{ search_page.simple ? \'search-page-simple\' : \'\' }}\"><div class=search-page-opacity ng-click=closeContactsSearch()></div><div class=search-page-popup><div class=search-header><div class=recipient-search-input><svg ng-click=closeContactsSearch() class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <input ng-model=selectedContactsFilter.keyword autocomplete=off ng-keyup=beforeSearchKeyup() class=search-contacts-input type=text placeholder=\"Search for parents by parent or child name\"> <span ng-click=clearContactsSearch() ng-if=selectedContactsFilter.keyword class=\"icon icon-cross dripicons-cross\"></span></div><div ng-show=search_page.simple class=recipient-search-select><span class=pull-left style=\"width: 40%; max-width: 125px; line-height: 34px; font-size: 12px\" translate=FILTER_CONTACTS></span><div class=pull-left style=\"width: 60%; max-width: 300px\"><div class=is-relative><select class=form-control ng-model=selectedContactsFilter.select ng-change=beforeTierChanged(selectedContactsFilter.select) ng-options=\"f.id as f.name for f in storedFilters\"></select><span class=\"dripicons-chevron-down select-arrow\"></span></div></div></div><div ng-if=\"temp_mess_contacts.length > 0 && search_page.simple\" class=mess-selected-contacts><div class=mess-selected-contacts-scroll><div ng-repeat=\"contact in temp_mess_contacts\" style=\"display: inline-block; margin: 8px 10px; margin-right: 0; text-align: center\"><div><figure class=classlist-item-avatar ng-click=removeTempSelected(contact) style=\"height: 40px; position: relative; display: inline-block\"><avatar source=\"{{ ::(contacts_list.baseUrl + contact.id) }}\" width=40 height=40 name=\"{{ ::(contact.fN + \' \' + contact.lN) }}\" my=false></avatar><div ng-if=\"contact.id != active_user.id\" class=contact-selected-remove><span class=dripicons-cross></span></div></figure></div><div style=\"width: 55px; overflow: hidden; text-overflow: ellipsis; font-size: 12px\"><span ng-if=\"contact.id != active_user.id\">{{ ::contact.fN }}</span><span ng-if=\"contact.id == active_user.id\">You</span></div></div></div></div></div><div class=search-contacts-container style=\"{{ search_page.simple && temp_mess_contacts.length > 0 ? \'margin-top: 183px!important;\' : \'\' }}\"><div ng-if=\"new_message_type == 1 && search_page.simple\" style=\"padding-right: 10px; background: #f1f2f5; padding: 6px 10px; font-size: 13px; font-weight: 600; color: #91969d\"><span>You can add {{ 8 - temp_mess_contacts.length }} <span ng-if=\"temp_mess_contacts.length > 0\">more</span> <span>participant<span ng-if=\"8 - temp_mess_contacts.length > 1\">s</span></span></span></div><div ng-if=\"new_message_type != 1 && search_page.simple\" style=\"border-bottom: 1px solid #e1e1e1\"><figure class=classlist-item-avatar ng-click=newGroupMessage() style=\"float: left; height: 40px; margin-right: 10px; position: relative; border-radius: 50%; background: #ddd; width: 40px; text-align: center\"><svg style=\"width: 24px; height: 40px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><path data-color=color-2 fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M38,19 c0,4.971,4.029,11,9,11s9-6.029,9-11s-4.029-9-9-9S38,14.029,38,19z\" stroke-linejoin=miter></path><path data-cap=butt data-color=color-2 fill=none stroke=#444444 stroke-width=2 stroke-miterlimit=10 d=\"M48,50h14v-4.324 c0-2.446-1.47-4.657-3.742-5.562C55.657,39.077,51.8,38,47,38s-8.657,1.077-11.258,2.113c-1.072,0.427-1.961,1.14-2.605,2.036\" stroke-linejoin=miter stroke-linecap=butt></path><path fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M40,56H2v-5.63 c0-3.052,1.722-5.845,4.466-7.182C9.668,41.628,14.554,40,21,40s11.332,1.628,14.534,3.188C38.278,44.525,40,47.318,40,50.37V56z\" stroke-linejoin=miter></path><path fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M32,19 c0,6.075-4.925,13-11,13s-11-6.925-11-13S14.925,8,21,8S32,12.925,32,19z\" stroke-linejoin=miter></path></g></svg></figure><div style=\"overflow: auto; cursor: pointer\" ng-click=newGroupMessage()><div class=contact-name style=\"line-height: 38px; font-weight: 600\" translate=NEW_MULTIPLE_CONVERSATION></div></div><span class=icon-location ng-click=mapTo(c) ng-if=c.rM><svg style=\"width: 26px; height: 26px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><path fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M54,24.095 C54,39,32,61,32,61S10,39,10,24.095C10,10.113,21.369,2,32,2S54,10.113,54,24.095z\" stroke-linejoin=miter></path><circle data-color=color-2 fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 cx=32 cy=24 r=8 stroke-linejoin=miter></circle></g></svg> </span><span class=icon-message ng-click=composeTo(c) ng-if=!isCurrentUser(c.id)><svg style=\"width: 26px; height: 26px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><path d=M10,26V59L26,46H58a4,4,0,0,0,4-4V14a4,4,0,0,0-4-4H26 fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></path><line x1=10 y1=2 x2=10 y2=18 fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 data-color=color-2 stroke-linejoin=miter></line><line x1=2 y1=10 x2=18 y2=10 fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 data-color=color-2 stroke-linejoin=miter></line></g></svg> </span><span class=icon-pencil ng-click=gotoMyProfile() ng-if=isCurrentUser(c.id)><svg style=\"width: 26px; height: 26px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><line data-cap=butt data-color=color-2 fill=none stroke=#444444 stroke-width=2 stroke-miterlimit=10 x1=6 y1=32 x2=16 y2=42 stroke-linejoin=miter stroke-linecap=butt></line><line data-cap=butt data-color=color-2 fill=none stroke=#444444 stroke-width=2 stroke-miterlimit=10 x1=11 y1=37 x2=31 y2=17 stroke-linejoin=miter stroke-linecap=butt></line><line data-color=color-2 fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 x1=30 y1=8 x2=40 y2=18 stroke-linejoin=miter></line><line data-color=color-2 fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 x1=26 y1=12 x2=36 y2=22 stroke-linejoin=miter></line><path fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M16,42L4,44l2-12L33.2,4.8 c1.6-1.6,4.1-1.6,5.7,0l4.3,4.3c1.6,1.6,1.6,4.1,0,5.7L16,42z\" stroke-linejoin=miter></path></g></svg></span></div><div ng-repeat=\"c in (filteredItems = (contacts_list.parents | filtercontacts:selectedContactsFilter))\" ng-show=\"c.fN != \'na\'\"><figure class=classlist-item-avatar ng-click=\"gotoProfile(c.id, c)\" style=\"float: left; height: 40px; margin-right: 10px; position: relative\"><avatar source=\"{{ ::(contacts_list.baseUrl + c.id) }}\" width=40 height=40 name=\"{{ ::(c.fN + \' \' + c.lN) }}\" my=false></avatar><div ng-if=c.selected class=contact-selected-checkmark><span class=dripicons-checkmark></span></div></figure><div style=\"{{ !search_page.simple ? \'margin-right: 75px;\' : \'\' }} overflow: auto; cursor: pointer\" ng-click=\"gotoProfile(c.id, c)\"><div class=contact-name style=\"font-weight: 600\"><span ng-if=\"c.id != active_user.id\">{{ ::c.fN }} {{ ::c.lN }}</span><span ng-if=\"c.id == active_user.id\">You</span></div><div><span ng-repeat=\"p in c.ps\" style=\"color: #777\">{{ ::p.fN }} {{ ::p.lN }}<span ng-hide=\"$index == c.ps.length-1\">, &nbsp;</span></span></div></div><span class=icon-location ng-click=mapTo(c) ng-if=c.rM><svg style=\"width: 26px; height: 26px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><path fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M54,24.095 C54,39,32,61,32,61S10,39,10,24.095C10,10.113,21.369,2,32,2S54,10.113,54,24.095z\" stroke-linejoin=miter></path><circle data-color=color-2 fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 cx=32 cy=24 r=8 stroke-linejoin=miter></circle></g></svg> </span><span class=icon-message ng-click=composeTo(c) ng-if=!isCurrentUser(c.id)><svg style=\"width: 26px; height: 26px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><polyline data-color=color-2 fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 points=\" 50,18 62,18 62,48 54,48 54,58 40,48 28,48 \" stroke-linejoin=miter></polyline><polygon fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 points=\"50,4 2,4 2,38 12,38 12,52 28,38 50,38 \" stroke-linejoin=miter></polygon></g></svg> </span><span class=icon-pencil ng-click=gotoMyProfile() ng-if=isCurrentUser(c.id)><svg style=\"width: 26px; height: 26px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><line data-cap=butt data-color=color-2 fill=none stroke=#444444 stroke-width=2 stroke-miterlimit=10 x1=6 y1=32 x2=16 y2=42 stroke-linejoin=miter stroke-linecap=butt></line><line data-cap=butt data-color=color-2 fill=none stroke=#444444 stroke-width=2 stroke-miterlimit=10 x1=11 y1=37 x2=31 y2=17 stroke-linejoin=miter stroke-linecap=butt></line><line data-color=color-2 fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 x1=30 y1=8 x2=40 y2=18 stroke-linejoin=miter></line><line data-color=color-2 fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 x1=26 y1=12 x2=36 y2=22 stroke-linejoin=miter></line><path fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M16,42L4,44l2-12L33.2,4.8 c1.6-1.6,4.1-1.6,5.7,0l4.3,4.3c1.6,1.6,1.6,4.1,0,5.7L16,42z\" stroke-linejoin=miter></path></g></svg></span></div><div style=\"height: 80px\"></div></div><div ng-if=\"temp_mess_contacts.length > 0\"><a class=\"fab-button fab-create-message fab-next-compose nav-webview-fixed\" ng-click=nextCompose() style=\"background-color: #eb004e!important\"><svg style=\"width: 26px; height: 50px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><line fill=none stroke=#ffffff stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 x1=0.5 y1=8.5 x2=15.5 y2=8.5 data-color=color-2></line><polyline fill=none stroke=#ffffff stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"10.5,3.5 15.5,8.5 10.5,13.5 \"></polyline></g></svg></a></div></div></div>");
$templateCache.put("app/base/views/tab-menu.html","<div ng-click=closePlusMenu() tab-menu-container class=\"visible-sm visible-xs hidden-md hidden-lg {{ showMenu ? \'absolute-top\' : \'\' }}\"><div list-menu class=\"{{ showMenu ? \'active\' : \'\' }}\"><div><div style=\"height: 20px\"></div><ul><li ui-sref=profile><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><path fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M12,12L12,12 c-2.761,0-5-2.239-5-5V6c0-2.761,2.239-5,5-5h0c2.761,0,5,2.239,5,5v1C17,9.761,14.761,12,12,12z\" stroke-linejoin=miter></path><path data-color=color-2 fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M22,20.908 c0-1.8-1.197-3.383-2.934-3.856C17.172,16.535,14.586,16,12,16s-5.172,0.535-7.066,1.052C3.197,17.525,2,19.108,2,20.908V23h20 V20.908z\" stroke-linejoin=miter></path></g></svg><div><span translate=PROFILE_BTN></span></div></li><li ui-sref=invite><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><path fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M12,13L12,13 c-2.761,0-5-2.239-5-5V6c0-2.761,2.239-5,5-5h0c2.761,0,5,2.239,5,5v2C17,10.761,14.761,13,12,13z\" stroke-linejoin=miter></path><path fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M12,17H7 c-3.314,0-6,2.686-6,6c0,0,21.958,0,22,0v0\" stroke-linejoin=miter></path><line data-color=color-2 fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 x1=20 y1=13 x2=20 y2=19 stroke-linejoin=miter></line><line data-color=color-2 fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 x1=17 y1=16 x2=23 y2=16 stroke-linejoin=miter></line></g></svg><div style=\"padding: 1px 0\"><span translate=INVITE_PARENTS></span></div></li><li ui-sref=announcements.list><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><path data-cap=butt data-color=color-2 d=M9.336,14l2.519,6.252a2,2,0,0,1-1.108,2.6h0a2,2,0,0,1-2.6-1.108L5,14 fill=none stroke=#444444 stroke-miterlimit=10 stroke-width=2 stroke-linecap=butt stroke-linejoin=miter></path><path d=M11,6H5a4,4,0,0,0,0,8h6l8,4V2Z fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></path><path data-stroke=none d=M21,7v6a3,3,0,0,0,0-6Z fill=#444444></path></g></svg><div><span translate=TOPNAV_ANNOUNCEMENTS></span></div></li><li ui-sref=school.details><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><line data-color=color-2 fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 x1=23 y1=11 x2=23 y2=16 stroke-linejoin=miter></line><polygon fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 points=\"12,13 2,8 12,3 22,8 \" stroke-linejoin=miter></polygon><path data-cap=butt fill=none stroke=#444444 stroke-width=2 stroke-miterlimit=10 d=\"M5,9.5V18c0,1.657,3.134,3,7,3 s7-1.343,7-3V9.5\" stroke-linecap=butt stroke-linejoin=miter></path></g></svg><div><span translate=TOPNAV_SCHOOL></span></div></li><li ng-click=adsManager()><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\"><g stroke-width=2 transform=\"translate(0, 0)\"><rect x=10 y=14 fill=none stroke=#636568 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 width=4 height=9 stroke-linejoin=miter></rect><rect x=1 y=18 fill=none stroke=#636568 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 width=4 height=5 stroke-linejoin=miter></rect><rect x=19 y=10 fill=none stroke=#636568 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 width=4 height=13 stroke-linejoin=miter></rect><polyline data-cap=butt data-color=color-2 fill=none stroke=#636568 stroke-width=2 stroke-miterlimit=10 points=\"3,10 8,5 12,9 20,1 \n                            \" stroke-linejoin=miter stroke-linecap=butt></polyline><polyline data-color=color-2 fill=none stroke=#636568 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 points=\"\n                            15,1 20,1 20,6 \" stroke-linejoin=miter></polyline></g></svg><div><span translate=TOPNAV_ADS_MANAGER></span></div><div class=badge style=\"left: 4%; top: 3px\" ng-if=notifsContainer.adsManager>{{ notifsContainer.adsManager}}</div></li><li ng-click=help()><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><circle cx=12 cy=12 r=11 fill=none stroke=#627293 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></circle><circle data-color=color-2 data-stroke=none cx=12 cy=18 r=1 fill=#627293></circle><path data-color=color-2 d=M9.853,6.56c1.98-.875,4.542-.771,5.417.645s.271,3.063-1.229,4.334S12,13.5,12,14.5 fill=none stroke=#627293 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></path></g></svg><div style=\"display: inline-block\"><span translate=TOPNAV_TRAININGHELP></span></div></li></ul><div style=\"height: 20px\"></div></div></div><div tab-menu ng-if=\"!isOnWizard && active_school\"><ul><li ui-sref=home ui-sref-active=active id=tab-home class=\"{{ showMenu ? \'force-inactive\' : \'\' }}\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><polyline data-cap=butt data-color=color-2 points=\"1 11 12 2 23 11\" fill=none stroke=#3677d9 stroke-miterlimit=10 stroke-width=2 stroke-linecap=butt stroke-linejoin=miter></polyline><polyline data-cap=butt points=\"10 23 10 17 14 17 14 23\" fill=none stroke=#3677d9 stroke-miterlimit=10 stroke-width=2 stroke-linecap=butt stroke-linejoin=miter></polyline><polyline points=\"4 13 4 23 20 23 20 13\" fill=none stroke=#3677d9 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></polyline></g></svg> <img class=hightlighted src=./assets/icons/Fill@3x.png><div class=badge ng-if=\"notifsContainer.home && notifsContainer.home != \'0\'\">{{ notifsContainer.home }}</div></li><li ui-sref=events.list ui-sref-active=active id=tab-messages class=\"{{ showMenu ? \'force-inactive\' : \'\' }}\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><line data-color=color-2 x1=1 y1=8 x2=23 y2=8 fill=none stroke=#627293 stroke-miterlimit=10 stroke-width=2></line><rect x=1 y=3 width=22 height=19 rx=2 ry=2 fill=none stroke=#627293 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></rect><line data-color=color-2 x1=6 y1=1 x2=6 y2=4 fill=none stroke=#627293 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></line><line data-color=color-2 x1=18 y1=1 x2=18 y2=4 fill=none stroke=#627293 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></line></g></svg><div class=badge ng-if=\"notifsContainer.events && notifsContainer.events != \'0\'\">{{ notifsContainer.events }}</div></li><li ui-sref=listings.list ui-sref-active=active id=tab-notifications class=\"{{ showMenu ? \'force-inactive\' : \'\' }}\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><polyline points=\"4 13 4 22 20 22 20 13\" fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></polyline><path data-color=color-2 d=M4,2,1,7A2.992,2.992,0,0,0,6.667,8.347a2.977,2.977,0,0,0,5.333,0,2.977,2.977,0,0,0,5.333,0A2.992,2.992,0,0,0,23,7L20,2Z fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></path><polyline data-cap=butt points=\"10 22 10 16 14 16 14 22\" fill=none stroke=#444444 stroke-miterlimit=10 stroke-width=2 stroke-linecap=butt stroke-linejoin=miter></polyline></g></svg></li><li ui-sref=\"classlist.all1({ \'tierId\': -3 })\" ui-sref-active=active id=tab-classlist class=\"{{ showMenu ? \'force-inactive\' : \'\' }}\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><path data-cap=butt data-color=color-2 fill=none stroke=#444444 stroke-width=2 stroke-miterlimit=10 d=\"M13,23h10v-8.8 c0-0.739-0.407-1.417-1.059-1.765l-4.007-2.15\" stroke-linejoin=miter stroke-linecap=butt></path><line data-cap=butt data-color=color-2 fill=none stroke=#444444 stroke-width=2 stroke-miterlimit=10 x1=13.077 y1=10.292 x2=10.727 y2=11.545 stroke-linejoin=miter stroke-linecap=butt></line><path data-color=color-2 fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M15.5,11 L15.5,11C13.015,11,11,8.985,11,6.5v-1C11,3.015,13.015,1,15.5,1h0C17.985,1,20,3.015,20,5.5v1C20,8.985,17.985,11,15.5,11z\" stroke-linejoin=miter></path><path data-cap=butt fill=none stroke=#444444 stroke-width=2 stroke-miterlimit=10 d=\"M4.592,17.195l-2.487,1.253 C1.428,18.786,1,19.479,1,20.236V23h12v-2.764c0-0.758-0.428-1.45-1.106-1.789l-2.487-1.253\" stroke-linejoin=miter stroke-linecap=butt></path><path fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M7,18L7,18 c-2.209,0-4-1.791-4-4v-1c0-2.209,1.791-4,4-4h0c2.209,0,4,1.791,4,4v1C11,16.209,9.209,18,7,18z\" stroke-linejoin=miter></path></g></svg></li><li ui-sref=notifications ui-sref-active=active id=tab-notifications class=\"{{ showMenu ? \'force-inactive\' : \'\' }}\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><path d=M19,13V8A7,7,0,0,0,5,8v5a13.834,13.834,0,0,1-2,7H21A13.834,13.834,0,0,1,19,13Z fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></path><path data-color=color-2 data-stroke=none d=M9.174,22a3,3,0,0,0,5.652,0Z fill=#444444></path></g></svg><div class=badge ng-if=\"notifsContainer.notifications > 0\">{{ notifsContainer.notifications }}</div></li><li ng-click=menuMenu($event) id=tab-menu class=\"{{ showMenu ? \'active\' : \'\' }}\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><line data-color=color-2 fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 x1=1 y1=12 x2=23 y2=12 stroke-linejoin=miter></line><line fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 x1=1 y1=5 x2=23 y2=5 stroke-linejoin=miter></line><line fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 x1=1 y1=19 x2=23 y2=19 stroke-linejoin=miter></line></g></svg></li></ul></div></div>");
$templateCache.put("app/base/views/white-screen.html","<div id=white-screen></div>");
$templateCache.put("app/base/views/window-beforeleave-modal.html","<div style=\"padding: 15px\"><div class=modal-body><p translate=BEFORE_LEAVEPAGE_TITLE></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=STAY_PAGE_BTN ng-click=stay() style=\"margin-left: 10px\"><button type=button class=\"btn btn-default pull-right\" translate=LEAVE_PAGE_BTN ng-click=leave()></div></div>");
$templateCache.put("app/base/views/window-redirecting-to-paypal.html","<div style=\"padding: 15px\"><div class=modal-body><p translate=BEFORE_REDIRECTING_PAYPAL></p></div><div class=modal-footer><div ng-if=\"redirectTimer === true\"><div>If this page doesn\'t refresh when you come back from Paypal use the button bellow:</div><button type=button class=\"btn btn-link\" translate=REFRESH ng-click=onRefreshTap()></button></div><button ng-if=!redirectTimer ng-disabled=isButtonDisabled type=button class=\"btn btn-primary pull-right\" translate=CONTINUE_BTN ng-click=onContinueTap()></button></div></div>");
$templateCache.put("app/base/directives/avatar.directive.html","<div style=\"width: 100%; height: 100%; min-width: 40px; min-height: 40px; border-radius: 50%\"><div class=\"letter-avatar letter-color-{{ getInitial() }}\"><div style=\"position: relative\"><div>{{ getInitials() }}</div><div class=avatar-picture style=\"background-image: url(\'{{ src }}\')\"></div></div></div></div>");
$templateCache.put("app/base/directives/carousel.directive.html","<div class=card-container id=ad-carousel><!-- Advertisement Arrow Function --><div class=card-container-box ng-if=\"!rightside && images.length > 1\" ng-click=scrollLeft()><div class=arrow><div class=\"icons dripicons-chevron-right\"></div></div></div><!-- Advertisement Arrow Function --> <a href={{link}} target=_blank ng-repeat=\"item in images track by $index\"><img alt=sponsor-image class=card-container-img ng-class=\"{\'small-height\': small}\" ng-src={{item}}></a></div>");
$templateCache.put("app/base/directives/classPicker.directive.html","<div class=is-relative><div class=is-relative><select class=\"form-control class-list\" ng-model=selectedTierId ng-change=selectTier() id=select-tier-directive></select><span id=pupil_class_placeholder translate=PUPIL_CLASS_PHOLDER class=select-placeholder></span> <span class=\"dripicons-chevron-down select-arrow\"></span></div></div>");
$templateCache.put("app/base/directives/commentComposer.directive.html","<div class=comment-composer-inner><form name=cmm novalidate><div class=vi-row style=\"margin: 8px 0 12px 0\"><div class=vi-col-left style=\"width: 50px; margin-top: 4px\"><figure style=\"position: inherit\" class=comment-item-avatar><avatar source=\"{{ activeUser.avatar }}\" name=\"{{ activeUser.firstName + \' \' + activeUser.lastName }}\" width=32 height=32></avatar></figure></div><div class=vi-col-middle><div><mentionsuggestor draftbody={{draftComment.body}} postid={{postId}} commentbody=\"getCommentBody(bodyWithTags, draft)\" replyto={{replyToAnchor}} id=comment-body-id class=\"comment-body form-control\" style=\"border:1px solid #b6c2db; background: #f5f8ff\" placeholder=\"{{ commentPlaceHolderText }}\" autoresize-textarea-comment required ng-minlength=regexes.min.commentBody></mentionsuggestor><div ng-if=\"comment.body != null && (comment.body.length > regexes.max.commentBody)\" class=error-text-stripe><span class=error-text-stripe_text translate=ERR_COMMENT_CHAR_LIMIT translate-values=\"{actual:comment.body.length, max: regexes.max.commentBody}\"></span></div><div style=\"overflow: hidden; position: absolute; top: 3px; right: 8px\"><div ng-if=\"!cmm.$invalid && !sendingComment\" class=\"mobile-send-but {{ cmm.$invalid ? \'mobile-send-diabled\' : \'\' }}\" style=\"cursor: pointer; padding-top: 7px; padding-right: 8px\"><div class=post-links style=\"cursor: pointer\"><span id={{postId}}icons class=\"icon-link photo-icon\" style=\"margin-left: 5px\"><span ng-click=uploadImage(postId) style=\"float: left\"><svg style=\"width: 22px; height: 36px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><path fill=#005cb8 d=\"M58,13h-8.546l-6.701-7.659C42.562,5.125,42.288,5,42,5H28c-0.288,0-0.562,0.125-0.753,0.341L20.546,13H6 c-2.757,0-5,2.243-5,5v36c0,2.757,2.243,5,5,5h52c2.757,0,5-2.243,5-5V18C63,15.243,60.757,13,58,13z M13,26c-1.103,0-2-0.897-2-2 s0.897-2,2-2s2,0.897,2,2S14.103,26,13,26z M35,50c-7.732,0-14-6.268-14-14s6.268-14,14-14s14,6.268,14,14S42.732,50,35,50z\"></path></g></svg> </span><span ng-click=uploadAttachment(postId) style=\"float: left; margin-left: 15px\"><svg style=\"width: 22px; height: 36px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><path fill=none stroke=#005cb8 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M27.8,16.5l-9.9,9.9 c-3.1,3.1-8.2,3.1-11.3,0l0,0c-3.1-3.1-3.1-8.2,0-11.3L16.8,4.9c2.1-2.1,5.6-2.1,7.8,0l0,0c2.1,2.1,2.1,5.6,0,7.8l-9.5,9.5 c-1.2,1.2-3.1,1.2-4.2,0l0,0c-1.2-1.2-1.2-3.1,0-4.2L20,8.7\" stroke-linejoin=miter></path></g></svg> </span></span><span ng-if=\"comment.body != null && (comment.body.length < regexes.max.commentBody)\" ng-click=postComment(postId) style=\"float: left; margin-left: 15px; padding-top: 10px\"><svg xmlns=http://www.w3.org/2000/svg xmlns:sketch=http://www.bohemiancoding.com/sketch/ns xmlns:xlink=http://www.w3.org/1999/xlink height=18px version=1.1 viewBox=\"0 0 23 18\" width=23px><g fill=none fill-rule=evenodd id=Page-1 stroke=none stroke-width=1><g fill=#eb004e id=Core transform=\"translate(-421.000000, -381.000000)\"><g id=send transform=\"translate(421.500000, 381.000000)\"><path d=\"M0,18 L21,9 L0,0 L0,7 L15,9 L0,11 L0,18 Z\" id=Shape /></g></g></g></svg></span></div></div></div></div><div style=\"display: none; overflow: auto; min-height: 100px; min-width: 100px; max-height: 250px; max-width: 250px\" id={{postId}}><div id=img-preview-wrapper class=post-img-preview style=\"margin-bottom: 3px;text-align: center; min-height: 35px\"><img id=test-id src=\"\"><span id=att-name style=\"color: #4a9fef; float: left;border-bottom: 1px solid #ddd; line-height: 26px\"></span> <span class=delete-button-wrap ng-click=removeAttachment(postId)><span class=delete-pic-button><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><polygon fill=#ffffff points=\"44,17.171 32,29.171 20,17.171 17.171,20 29.171,32 17.171,44 20,46.829 32,34.829 44,46.829 46.829,44 34.829,32 46.829,20\"></polygon></g></svg></span></span></div><!-- <div id=\"att-preview-wrapper \">\n						<span id=\"att-name \" style=\"color: #4a9fef; \"></span>\n                        <span ng-click=\"removeFile(postId) \" class=\"delete-pic-button \">\n							<svg xmlns=\"http://www.w3.org/2000/svg \" xmlns:xlink=\"http://www.w3.org/1999/xlink \" x=\"0px \" y=\"0px \" width=\"64px \" height=\"64px \" viewBox=\"0 0 64 64 \"><g transform=\"translate(0, 0) \"><polygon fill=\"#ffffff \" points=\"44,17.171 32,29.171 20,17.171\n                                    17.171,20 29.171,32 17.171,44 20,46.829 32,34.829 44,46.829 46.829,44 34.829,32 46.829,20 \"></polygon></g></svg>\n						</span>\n					</div> --></div></div></div></form></div>");
$templateCache.put("app/base/directives/cropper.directive.html","<div class=cropper ng-class=\"{\'not-ready\':!viewState.isReady}\"><img alt=\"\" id=imgPreviewer><div class=cropper-pholder id=imgPholder><input type=file id=imgUploader accept=image/*><div class=cz-message><span class=\"hidden-sm hidden-xs icon dripicons-upload\"></span><p class=\"hidden-sm hidden-xs\" translate=DRAG_A_PHOTO_HERE></p><p class=\"hidden-sm hidden-xs\" translate=_OR_></p><button type=button class=\"btn btn-ghost\" translate=CHOOSE_PHOTO></button><div translate=MAX_FILE_SIZE></div><div translate=UPLOAD_A_EVENT_PHOTO_HELP></div></div></div><div ng-hide=viewState.isReady style=\"position: absolute; z-index: 99999; width: 100%;height: 40px;top: 50%;margin-top: -20px\"><svg class=circular viewBox=\"25 25 50 50\"><circle class=path cx=50 cy=50 r=20 fill=none stroke-width=4 stroke-miterlimit=10></circle></svg></div></div>");
$templateCache.put("app/base/directives/datepicker.directive.html","<div class=winkel-calendar><input type=hidden class=wc-input value=\"{{myDate | date: format}}\"><div ng-show=popover><div class=popover-background></div><div class=wc-date-popover ng-class=\"{\'banner-true\': bigBanner == true}\"><div class=wc-banner ng-if=bigBanner ng-class=\"{\'timepicker-true\': timePicker == true}\"><div class=\"wc-day-row calendar-header\"><span>{{ header }}</span></div></div><div class=\"wc-details wc-hover-opacity\" ng-click=toggleMonthView()><div class=month-year ng-show=bigBanner>{{myDate | date: \'MMMM\'}}</div><div class=month-year ng-show=!bigBanner>{{myDate | date: \'MMMM\'}} &nbsp;</div></div><div class=\"year-title wc-hover-opacity\" ng-click=generateYearList()><div class=year-dropdown>{{myDate | date: \'yyyy\'}} <i ng-show=!yearView class=\"fa fa-angle-down\"></i> <i ng-show=yearView class=\"fa fa-angle-up\"></i></div></div><table class=calendar-header><tr><td class=calendar-header-day>Su</td><td class=calendar-header-day>Mo</td><td class=calendar-header-day>Tu</td><td class=calendar-header-day>We</td><td class=calendar-header-day>Th</td><td class=calendar-header-day>Fr</td><td class=calendar-header-day>Sa</td></tr></table><div class=months-view ng-show=monthsView ng-click=setMonth($event)><span ng-repeat=\"month in cal_months_labels_short\" value={{month}} ng-class=\"{\'current-month\': month == cal_months_labels_short[myDate.getMonth()]}\">{{month}}</span></div><div class=years-view ng-show=yearView><div class=\"fa fa-angle-left prev\" ng-click=\"generateYearList(\'prev\')\"></div><div class=\"fa fa-angle-right next\" ng-click=\"generateYearList(\'next\')\"></div><div class=years-list-view ng-click=setYear($event)><span ng-repeat=\"year in yearsList\" value={{year}} ng-class=\"{\'current-year\': year == myDate.getFullYear()}\">{{year}}</span></div></div><div class=time-view ng-show=timeView><div class=time style=\"width: 160px; margin-right: -32px\"><div class=hour style=\"width: 60px\"><input type=text value=\"{{hourValue | numberFixedLen:2}}\" autofocus disabled style=\"padding: 5px 0!important; opacity: 1!important\"></div><div class=time-divider style=\"width: 10px\">:</div><div class=minutes style=\"width: 60px\"><input type=text value=\"{{minValue  | numberFixedLen:2}}\" disabled style=\"padding: 5px 0!important; opacity: 1!important\"></div><div style=\"font-size: 19px; margin-top: 21px; float: right; width: 29px\"><span ng-if=\"timeViewMeridian == \'AM\'\">AM</span> <span ng-if=\"timeViewMeridian == \'PM\'\">PM</span></div></div><div><div class=cuppa-btn-group><button ng-class=\"{\'active\': timeViewMeridian == \'AM\'}\" class=button ng-model=timeViewMeridian ng-click=\"toggleMeridian(\'AM\')\">AM</button> <button ng-class=\"{\'active\': timeViewMeridian == \'PM\'}\" class=button id=timepicker-pm-select ng-model=timeViewMeridian ng-click=\"toggleMeridian(\'PM\')\">PM</button></div></div><h5>Hours</h5><div range-slider floor=1 ceiling=12 step=1 precision=5 highlight=left ng-model=hourValue on-change=onHourUpdate(val)></div><h5>Minutes</h5><div range-slider floor=0 ceiling=55 step=5 precision=5 highlight=left ng-model=minValue on-change=onMinUpdate(val)></div><div class=time-view-btn><button class=\"button button-sm\" ng-click=setTimeView()>Set Time</button></div></div><table class=calendar-days ng-click=setDay($event);><tr ng-repeat=\"week in monthDays\"><td class=calendar-day ng-class=\"{\'today\': day == today.getDate() && myDate.getMonth() == today.getMonth() && myDate.getFullYear() == today.getFullYear(),\'selected-day\': day == myDate.getDate()}\" ng-repeat=\"day in week track by $index\"><span ng-if=\"day != 0\" value={{day}} class=disabled>{{day}}</span></td></tr></table><div class=wc-banner ng-if=bigBanner ng-class=\"{\'timepicker-true\': timePicker == true}\"><div class=wc-date-row>{{myDate | date: \'dd\'}}</div><div class=wc-my-sec><div class=wc-month-row><div>{{myDate | date: \'MMM\'}}</div></div><div class=wc-year-row><div>{{myDate | date: \'yyyy\'}}</div></div></div><div class=wc-time-sec ng-if=timePicker ng-click=toggleTimeView()><div class=time><div class=hour><div class=datepicker-input>{{myDate | date: \'hh\'}}</div></div><div class=time-divider>:</div><div class=minutes><div class=datepicker-input>{{myDate | date: \'mm\'}}</div></div></div><div class=timestate><span>{{myDate | date: \'a\'}}</span></div></div></div><div ng-if=!bigBanner><i class=\"fa fa-clock-o\" aria-hidden=true ng-click=toggleTimeView()></i></div><div class=cal-util><div class=cancel ng-click=cancel()><i class=\"fa fa-check\"></i>Cancel</div><div class=ok ng-click=confirmDate()><i class=\"fa fa-check\"></i>Done</div></div></div></div></div>");
$templateCache.put("app/base/directives/galleryPicker.directive.html","<div class=gallery-picker><div class=modal-header><h3 class=modal-title><div class=pull-left ng-click=close()><svg id=header-back-button ng-click=close() style=\"top: 8px\" class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg></div><span translate=UPLOAD_A_EVENT_PHOTO_TITLE style=\"font-size: 20px; margin-left: 25px\"></span></h3></div><div class=modal-body><div class=gallery-picker><div class=dev-pick ng-click=uploadImage()><div><div style=\"position: absolute; top: 0; left: 50%; margin-left: -45px\"><div class=\"dripicons-monitor icon\"></div><br><div translate=CHOOSE_FROM_DEVICE></div></div></div><span></span></div><div ng-repeat=\"def in def_gallery\" ng-click=select(def) class=\"{{ selectedPic.id == def.id ? \'selected\' : \'\' }}\"><div style=\"background-image: url(\'{{def.url}}\')\"></div><span translate=\"{{ def.title }}\"></span></div></div></div></div>");
$templateCache.put("app/base/directives/googleMapsAutocomplete.directive.html","<div class=\"autocomplete col-md-12 col-sm-12 col-xs-12\"><script type=text/ng-template id=autocompleteTemplate.html><div class=\"autocomplete-address-item\">\n			<p class=\"autocomplete-address-name\" ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"></p>\n		</div></script><div class=address-autocomplete><input type=text ng-model=address click-outside=onFocusOut() ng-change=onChanged() placeholder=\"{{ \'START_TYPING_PLACEHOLDER\' | translate }}\" uib-typeahead=\"address.description for address in getResults($viewValue)\" typeahead-wait-ms=100 typeahead-min-length=3 typeahead-on-select=pickAddress($item) typeahead-loading=isGettingaddresses typeahead-template-url=autocompleteTemplate.html class=autocomplete-map-address id=typeaheader autocomplete=off></div></div>");
$templateCache.put("app/base/directives/grouptags.module.html","<script type=text/ng-template id=grouptagsTemplate.html><div class=\"match-container\">\n		<span ng-bind-html=\"match.model | uibTypeaheadHighlight:query\" ng-if=\"match.model\"></span>\n	</div></script><div class=group-tags><div><input type=text ng-model=tag placeholder=\"{{ inputPlaceholder }}\" uib-typeahead=\"r for r in getTags($viewValue)\" typeahead-focus-first=false typeahead-wait-ms=300 typeahead-min-length=2 typeahead-on-select=pickTag($item) ng-keyup=keyUp($event) typeahead-template-url=grouptagsTemplate.html class=tags-input style=\"color: #627293 !important\"></div><div class=tags-area><div class=tags><ul><li ng-repeat=\"tag in tags track by $index\">{{tag}} <span ng-click=removeTags($index) class=\"icon dripicons-cross\"></span></li></ul></div></div></div>");
$templateCache.put("app/base/directives/linkpreview.directive.html","<div class=link-prev-card ng-click=openLink(preview.link) ng-show=\"preview.title !== \'\'\"><div class=link-padding ng-show=\"preview.title !== \'\' && (!preview.youtube || preview.youtube == \'\')\"><img class=link-prev-image src={{preview.image}} alt={{preview.title}}><div class=link-prev-title>{{preview.title}}</div><div>{{preview.description}}</div><a href=javascript:void(0)>{{preview.domain}}</a></div><div ng-show=\"preview.youtube && preview.youtube !== \'\'\"><iframe width=100% height=300px ng-src={{trustSrc(preview.youtube)}} frameborder=0 allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe></div></div>");
$templateCache.put("app/base/directives/mentionsuggestor.directive.html","<div id=baseOfMention><div><div class=mentionsuggestor-placeholder style=\"border: none; padding: 0px; margin: 0px; position: absolute; pointer-events: none;\n        touch-action: none; color: #627293\">{{hint}}</div><div id=\"{{ itemId }}\" my-right-click=onFocus($event); style=\"border: none; padding: 0px; margin: 0px; {{ type && type === \'post\' ? \'min-height:77px\' : \'height:100%\' }}\" class=\"editor form-control\" contenteditable ng-keydown=keydown($event) ng-keyup=keyup($event) ng-blur=onBlur() ng-click=onFocus($event)></div></div></div>");
$templateCache.put("app/base/directives/participants.module.html","<script type=text/ng-template id=participantTemplate.html><div class=\"match-container\">	\n		<div class=\"match-container-parentname\">\n			<span ng-bind-html=\"match.model.field1 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field1\"></span>\n			<span ng-bind-html=\"match.model.field2 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field2\"></span>\n		</div>\n		<div>\n			<span translate=\"PARENTHESES_OPEN\" ng-if=\"match.model.field3\"></span><span ng-bind-html=\"(m | uibTypeaheadHighlight:query) + ($last ? \'\' : \', \')\" ng-repeat=\"m in match.model.field3 track by $index\"></span><span translate=\"PARENTHESES_CLOSE\" ng-if=\"match.model.field3\"></span>\n		</div>\n	</div></script><div class=manage-participants><div class=search><input type=text ng-model=participant placeholder=\"{{ inputPlaceholder }}\" uib-typeahead=\"r.field1 for r in getParticipants($viewValue)\" typeahead-wait-ms=300 typeahead-min-length=2 typeahead-on-select=pickParticipant($item) typeahead-template-url=participantTemplate.html class=form-control></div><ul class=basket><li ng-repeat=\"(key, item) in participants track by $index\"><header class=tier-header ng-if=\"item.type !== \'user\' && item.groupId !== participants[key-1].groupId\"><figure class=avatar><span class=dripicons-user-group></span></figure>{{ item.groupName }} <a ng-click=toggleGroup(item.groupId)><span class=dripicons-chevron-down></span></a></header><div ng-class=\"{\'group\':item.type !== \'user\'}\" class=\"{{ item.groupId }}\"><div class=participant><figure class=avatar><avatar source={{item.avatar}} name=\"{{ item.firstName + \' \' + item.lastName }}\" width=40 height=40></avatar></figure>{{item.firstName}} {{item.lastName}} <span translate=PARENTHESES_OPEN ng-if=item.pupils></span><span ng-bind-html=\"(p.firstName | uibTypeaheadHighlight:query) + ($last ? \'\' : \', \')\" ng-repeat=\"p in item.pupils track by $index\"></span><span translate=PARENTHESES_CLOSE ng-if=item.pupils></span> <a ng-click=removeParticipant(item)><span class=dripicons-cross></span></a></div></div></li></ul></div>");
$templateCache.put("app/base/directives/photoUpload.directive.html","<div class=\"photo-uploader user-select-none\"><div class=modal-header><h3 ng-show=showChoose class=modal-title translate={{translations.title}}></h3><h3 ng-show=!showChoose class=modal-title translate=EDIT_PICTURE></h3></div><div class=modal-body><cropper events=events></cropper><a class=rotate-button ng-class=\"{\'visible\':saveDisabled === false && events.editingPicture === true}\" ng-click=rotate() style=\"float: right;\n		background-color: #fff;\n		border-radius: 50%;\n		border-radius: 50%;\n		cursor: pointer\"><svg style=\"width: 25px; height: 25px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><path data-cap=butt fill=none stroke=#444444 stroke-width=2 stroke-miterlimit=10 d=M33,12H19c-5.523,0-10,4.477-10,10v6 stroke-linejoin=miter stroke-linecap=butt></path><polyline fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 points=\"24,21 33,12 24,3 \" stroke-linejoin=miter></polyline><rect data-color=color-2 x=23 y=30 fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 width=16 height=16 stroke-linejoin=miter></rect></g></svg></a></div><div class=modal-helper><p translate={{translations.tips}}></p><a ng-show=showChoose ng-class=\"{\'visible\':saveDisabled === false}\" translate=CHOOSE_DIFFERENT_PHOTO ng-click=chooseAgain()></a><div ng-show=\"error.length > 0\" class=\"alert alert-error\"><p>{{ error }}</p></div><div ng-if=!events.editingPicture style=\"margin-top: 10px; display: none\"><span ng-class=\"{\'visible\':saveDisabled === false}\"><a translate=CROP_PICTURE ng-click=events.cropPicture()></a></span></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=save() ng-disabled=saveDisabled><span translate=SAVE_BTN></span></button></div></div>");
$templateCache.put("app/base/directives/postAdv.directive.html","<div class=post-item><div class=\"post-container {{ context === \'NOTIFICATION_VIEW\' ? \'notification-advert\' : \'\' }} {{ context === \'HOME_VIEW\' ? \'home-advert\' : \'\' }}\"><div class=post-item-details><div><div class=padding-post style=\"overflow: auto; padding: 0; padding-top: 17px\"><div class=\"col-xs-2 col-sm-2\"><figure class=post-item-avatar><avatar class=\"visible-xs visible-sm\" source={{logo}} onerror=\"this.src=\'assets/icons/default-avatar.png\'\" width=40 height=40 my=false></avatar><avatar class=\"visible-md visible-lg\" onerror=\"this.src=\'assets/icons/default-avatar.png\'\" source={{logo}} width=60 height=60 my=false></avatar></figure></div><div class=\"col-xs-10 col-sm-10 remove-comm-padding\"><div class=post-item-head><h4 style=\"width: 100%\"><a class=HEADER2 href={{link}} target=_blank style=\"color: #000\">{{ title }}</a></h4><time translate=SPONSORED></time></div></div></div><div class=padding-post style=\"padding-top: 0; padding-bottom: 0\"><div><div class=remove-comm-padding><div class=text><p ng-bind-html=body class=multiple-line-text style=\"margin-top: 10px; margin-bottom: 0\"></p></div></div></div></div><figure class=\"post-item-photo padding-post photo-padding\" ng-if=\"artwork && artwork.length > 1\"><carousel images=artwork link={{link}} small=false></carousel></figure><figure class=\"post-item-photo padding-post photo-padding\" ng-if=\"artwork && artwork.length == 1\"><a href={{link}} target=_blank><img alt=sponsor-image ng-src={{artwork[0]}}></a></figure><div style=\"text-align: center; margin-top: 8px\"><a class=\"btn btn-primary sponsor-but\" href={{link}} target=_blank>{{ linkName }}</a></div><br></div></div></div></div>");
$templateCache.put("app/base/directives/postAsset.confirmReportCommentModal.directive.html","<div class=assign-parent-admin ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=REPORT_COMMENT_DIALOG_TITLE translate-values={name:user.name}></h3></div><div class=modal-body><p translate=REPORT_COMMENT_DIALOG_TEXT></p></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=report()><span translate=REPORT_BTN></span></button></div></div>");
$templateCache.put("app/base/directives/postAsset.confirmReportModal.directive.html","<div class=assign-parent-admin ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=REPORT_POST_DIALOG_TITLE translate-values={name:user.name}></h3></div><div class=modal-body><p translate=REPORT_POST_DIALOG_TEXT></p></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=report()><span translate=REPORT_BTN></span></button></div></div>");
$templateCache.put("app/base/directives/postAsset.directive.html","<div class=post-item mw=\"{{ userId == postUserId ? true : false }}\"><div class=post-container style=\"{{ isPostView() ? \'border: solid 1px #b6c2db;\' : \'\' }}{{ commentOnly ? \'max-width:100%; border: none !important;\' : \'\' }}\"><div class=post-item-details ng-show=\"post.isOwn && post.type == \'event\'\"><!-- Need to add section header for comments here --><nav class=\"has-dropdown-click is-relative more-dots\" style=\"margin-top: 0; position: absolute; height: 20px; top: -10px; right: 0px; z-index: 11; height: 34px; float: right\"><ul ng-if=post.menuOpened class=dropdown-menu style=\"right: 15px!important; background: #fff!important\"><li ng-if=\"post.isOwn && post.type != \'welcome\'\"><a translate=\"{{ post.commentLocked ? \'UNLOCK_COMMENTS\' : \'LOCK_COMMENTS\'}}\" ng-click=lockComments()></a></li></ul><svg ng-click=togglePostMenu(post) style=\"transform: rotate(90deg); height: 55px; margin-top: 0; margin-right: 10px; position: relative; padding: 1px 1px; width: 18px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\"><g transform=\"translate(0, 0)\"><circle fill=#627293 cx=4 cy=16 r=3></circle><circle data-color=color-2 fill=#627293 cx=16 cy=16 r=3></circle><circle fill=#627293 cx=28 cy=16 r=3></circle></g></svg></nav></div><div class=post-item-details ng-hide=commentOnly><div class=padding-post style=\"padding-bottom: 0\"><nav ng-show=\"post.type !== \'NEW_GROUP\' && post.type !== \'welcome\' && !post.event\" class=\"has-dropdown-click is-relative more-dots\" style=\"margin-top: 0; position: absolute; top: 1px; right: 2px; z-index: 11; height: 50px\"><ul ng-if=post.menuOpened class=dropdown-menu style=\"right: 1px!important; background: #fff!important\"><li ng-if=post.canMessage><a ng-click=sendMessage()><span translate=SEND_MESS_TO></span> <span>{{ post.postedByFirstName }}</span></a></li><li ng-if=\"post.isOwn && post.type != \'welcome\' && !readonly && post.type != \'announcement\' && !post.event && !post.raffle\"><a translate=EDIT_POST ng-click=edit()></a></li><li ng-if=\"post.isOwn && !readonly && post.type === \'announcement\'\"><a translate=EDIT_ANNOUNCEMENT_BTN ng-click=edit()></a></li><li ng-if=\"post.canMessage || post.type == \'classlist\'\"><a ng-click=followPost(true)><span ng-if=!post.isFollowed translate=ON_NOTIFICATIONS></span> <span ng-if=post.isFollowed translate=OFF_NOTIFICATIONS></span></a></li><li ng-if=\"post.isOwn && post.type != \'welcome\' && post.type != \'announcement\'\"><a translate=DELETE_POST ng-click=deletePost()></a></li><li ng-if=\"post.isOwn && post.type != \'welcome\' && post.type === \'announcement\'\"><a translate=DELETE_ANNOUNCEMENT_BTN ng-click=deletePost()></a></li><li ng-if=\"post.isOwn && post.type != \'welcome\' && post.type != \'announcement\'\"><a translate=\"{{ post.commentLocked ? \'UNLOCK_COMMENTS\' : \'LOCK_COMMENTS\'}}\" ng-click=lockComments()></a></li><li ng-if=\"post.isOwn && post.type != \'welcome\' && post.type === \'announcement\'\"><a translate=\"{{ post.commentLocked ? \'TURN_ON_COMMENTING_ANNOUNCEMENT_BTN\' : \'TURN_OFF_COMMENTING_ANNOUNCEMENT_BTN\'}}\" ng-click=lockComments()></a></li><li ng-if=\"post.isOwn && post.type==\'listing\' && !post.sold\"><a ng-if=\"post.listingCategory ==\'OFFER\'\" translate=LISTING_SOLD ng-click=markSold()></a> <a ng-if=\"post.listingCategory ==\'WANTED\'\" translate=LISTING_CLAIMED ng-click=markSold()></a> <a ng-if=\"post.listingCategory ==\'LOST_FOUND\'\" translate=LISTING_FOUND ng-click=markSold()></a></li><li ng-if=\"post.isOwn && post.type==\'listing\' && post.sold\"><a ng-if=\"post.listingCategory ==\'OFFER\'\" translate=LISTING_UNSOLD ng-click=markUnsold()></a> <a ng-if=\"post.listingCategory ==\'WANTED\'\" translate=LISTING_UNCLAIMED ng-click=markUnsold()></a> <a ng-if=\"post.listingCategory ==\'LOST_FOUND\'\" translate=LISTING_NOTFOUND ng-click=markUnsold()></a></li><li ng-if=\"userId !== post.userId\"><a translate=REPORT_POST ng-click=reportPost()></a></li><li><a translate=\"{{ post.type === \'announcement\' && post.isOwn ? \'WHO_CAN_SEE_ANNOUNCEMENT_BTN\' : \'WHO_CAN_SEE_POST\'}}\" target=_blank href=https://help.classlist.com/hc/en-us/articles/213258969-Who-will-see-what-I-ve-posted-and-how-will-they-know-it-s-there-></a></li></ul><svg ng-click=togglePostMenu(post) style=\"transform: rotate(90deg); height: 45px; margin-top: 0; position: relative; padding: 1px 15px; width: 48px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\"><g transform=\"translate(0, 0)\"><circle fill=#627293 cx=4 cy=16 r=3></circle><circle data-color=color-2 fill=#627293 cx=16 cy=16 r=3></circle><circle fill=#627293 cx=28 cy=16 r=3></circle></g></svg></nav><div class=vi-row><div class=vi-col-left><figure ng-show=\"!post.sample && !post.raffle\" class=post-item-avatar ng-click=\"openUserHome(post.userId, post)\"><avatar class=\"visible-xs visible-sm\" source=\"{{ ::post.avatar }}\" name=\"{{ ::post.postedBy }}\" width=40 height=40 my=false></avatar><avatar class=\"visible-md visible-lg\" source=\"{{ ::post.avatar }}\" name=\"{{ ::post.postedBy }}\" width=60 height=60 my=false></avatar></figure><figure ng-show=\"post.sample || post.raffle\" class=post-item-avatar><avatar class=\"visible-xs visible-sm\" source=\"{{ ::post.avatar }}\" name=\"{{ ::post.postedBy }}\" width=40 height=40 my=false></avatar><avatar class=\"visible-md visible-lg\" source=\"{{ ::post.avatar }}\" name=\"{{ ::post.postedBy }}\" width=60 height=60 my=false></avatar></figure></div><div class=vi-col-middle><div><h4 style=\"margin-right: 30px; display: block; {{ (post.type == \'announcement\' || post.event || post.raffle) ? \'margin-top: 0;\' : \'\' }}\"><a ng-show=\"!post.sample && !post.raffle\" ng-click=\"openUserHome(post.userId, post)\" style=\"line-height: 20px\" class=\"HEADER2 post-username {{ post.sample ? \'disabled\' : \'\' }}\">{{ ::post.postedBy }}</a> <span ng-show=\"post.sample || post.raffle\"><a class=\"disabled HEADER2\">{{ ::post.postedBy }}</a></span><div style=\"line-height: 24px\"><span ng-show=\"::post.type == \'welcome\'\" class=posted-in>{{ ::post.body }}</span> <span ng-show=\"::post.type == \'NEW_GROUP\'\" translate=CREATED_GROUP class=posted-in></span> <span ng-show=\"::post.type == \'welcome\'\" translate=JOINED_IN class=posted-in></span> <span ng-show=\"::post.type == \'announcement\'\" translate=ANNOUNCEMENT_IN_GROUPS class=posted-in></span> <span ng-show=\"::post.event && post.event.type != \'PARENT\'\" translate=CREATED_COMMUNITY_EVENT class=posted-in></span> <span ng-show=\"::post.event && post.event.type == \'PARENT\'\" translate=CREATED_PRIVATE_EVENT class=posted-in></span> <a ng-if=\"post.type != \'group\' && post.type != \'announcement\' && !post.event\"><strong ng-show=\"post.type === \'announcement\' || post.type === \'group\'\">{{ post.groupName }}</strong> </a><span ng-show=\"post.type == \'welcome\'\"><a ng-click=onGroupTap(post.groupId)><strong style=\"color: #005cb8\">{{ post.groupName }}</strong></a></span></div></h4><div ng-show=\"!(post.type != \'classlist\' && post.type != \'NEW_GROUP\' && post.type != \'announcement\' && post.type != \'listing\' && !post.event && !post.raffle)\" style=\"display: inline-block\"><time style=\"color: #009e6c\"><span translate=AT ng-show=!post.raffle></span>{{post.postedOn | date:\'h:mm a\' }}, {{post.postedOn | date:\'MMM dd\'}}</time></div><div ng-show=\"post.type != \'classlist\' && post.type != \'NEW_GROUP\' && post.type != \'announcement\' && post.type != \'listing\' && !post.event && !post.raffle\" style=\"display: inline-block\"><time ng-if=\"post.type != \'announcement\'\">{{ post.postedOn | timeago }}: </time><span><a ng-click=onGroupTap(post.groupId) class=drip-group><span style=\"line-height: 22px\"><span ng-if=isArchivedGroup>Archived - </span>{{post.groupName}} </span><svg style=\"position: relative; top: 4px; left: -3px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polygon fill=#4a9fef points=\"6,13.4 4.6,12 8.6,8 4.6,4 6,2.6 11.4,8\"></polygon></g></svg></a></span></div></div></div></div><div ng-if=\"post.type == \'announcement\' || post.event || post.raffle\" style=\"height: 10px\"></div><p count-chars ng-bind-html=post.body class=\"multiple-line-text post-text\" ng-show=\"post.type == \'group\'\" style=\"margin-bottom: 8px\"></p><div ng-if=post.linkPreview><linkpreview url={{post.linkPreview}}></linkpreview></div></div><div class=mkp-spacer></div><div ng-show=\"post.type == \'listing\'\" class=listing-labels-container style=\"{{ post.attachments.length > 0 ? \'height: 0\' : \'\' }}\" ng-click=openPost(post)><div class=\"listing-post listing-labels {{ post.attachments.length > 0 ? \'active\' : \'\' }} {{ post.photo !== undefined && post.type === \'listing\' && hasPrice() ? \'listing-margin-picture\' : \'\' }}\"><div style=\"z-index: 1; position: relative\"><div><div ng-repeat=\"c in categories\"><div style=\"{{ post.sold ? \'background: #ff5a5a;\' : \'\' }} margin-left: 10px\" ng-show=\"post.listingCategory == c.toUpperCase()\" is-selected=\"{{post.category === c}}\" id={{c}} ng-class=\"{\'category-item-post category-item-post_{{c}}\': post.category === c || post.category !== c}\"><span class=category-name style=\"color: #fff\" ng-if=\"post.sold && post.listingCategory == \'OFFER\'\" translate=LABEL_SOLD></span> <span class=category-name style=\"color: #fff\" ng-if=\"post.sold && post.listingCategory == \'WANTED\'\" translate=LABEL_CLAIMED></span> <span class=category-name style=\"color: #fff\" ng-if=\"post.sold && post.listingCategory == \'LOST_FOUND\'\" translate=LABEL_FOUND></span><div ng-show=\"!post.sold && post.listingCategory == c.toUpperCase()\" is-selected=\"{{post.category === c}}\" id={{c}} ng-class=\"{\'category-item-post category-item-post_{{c}}\': post.category === c || post.category !== c}\"><span class=category-name translate=\"POST_CAT_{{c | uppercase}}\"></span></div></div></div><div ng-if=\"post.type == \'listing\' && hasPrice()\" style=\"float: left; margin-left: 6px\"><div class=\"price-without-photo listing-type-{{post.listingCategory.toLowerCase()}}\" style=\"height: auto\"><span class=price-without-photo_text><span style=\"float: left\" translate=\"{{ post.currency }}_SHORT\"></span> {{ hasPrice() }}</span></div></div><div ng-if=\"post.type === \'listing\' && hasPrice() && post.ptaPercentage\"><div class=\"price-without-photo donation-offer listing-type-{{post.listingCategory.toLowerCase()}}\" style=\"height: auto\"><span class=price-without-photo_text>{{ doInt(post.ptaPercentage*100) }}% {{post.sold ? \"raised\" : \"donation\"}}</span></div></div></div></div></div></div><div ng-show=\"post.type != \'classlist\'\" class=\"padding-post photo-padding\"><div ng-if=\"post.type === \'raffle\'\"><div class=raffle-post>{{post.body}}</div><div class=raffle-img style=\"background-image: url({{post.raffle.imagePath}})\"><span ng-if=\"post.raffle.status === \'ACTIVE\'\" class=live-tag><svg xmlns=http://www.w3.org/2000/svg width=14 height=14 viewBox=\"0 0 24 24\" fill=#ffffff><path d=\"M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z\"></path></svg> LIVE</span> <span ng-if=\"post.raffle.status !== \'ACTIVE\' && post.raffle.status !== \'CANCELLED\'\" class=live-tag>ENDED</span> <span ng-if=\"post.raffle.status == \'CANCELLED\'\" class=live-tag>CANCELLED</span></div><div class=raffle-info><div><div ng-if=\"post.raffle.status == \'ACTIVE\' && post.raffle.status !== \'CANCELLED\'\" class=draw-bg><span class=\"icon dripicons-hourglass\"></span></div><div><div class=held-on-text><span ng-if=\"post.raffle.status === \'ACTIVE\'\">Draw will be held on</span> <span ng-if=\"post.raffle.status !== \'ACTIVE\' && post.raffle.status !== \'CANCELLED\'\">The raffle has ended on</span></div><div class=held-on-date ng-if=\"post.raffle.status !== \'CANCELLED\'\">{{post.raffle.drawDate | date:\'EEEE, LLLL d, y hh:mm a\' : \'GMT\'}}</div></div></div><div class=held-on-text><span ng-if=\"post.raffle.status == \'CANCELLED\'\">The raffle has been cancelled</span></div><div style=\"margin: 20px 12px 10px; text-align: center\"><button ng-if=\"post.raffle.status === \'ACTIVE\'\" type=button class=\"btn btn-primary btn-raffle\" translate=GET_TICKETS ui-sref=\"raffle.details({raffle_id: post.raffle.id})\"></button> <button ng-if=\"post.raffle.status !== \'ACTIVE\' && post.raffle.parentPurchasedTickets\" type=button class=\"btn btn-primary btn-raffle\" translate=VIEW_TICKETS ui-sref=\"raffle.view({raffle_id: post.raffle.id})\"></button></div></div></div><div ng-if=\"post.type !== \'raffle\' && post.type !== \'announcement\' && !isPostView()\" class=\"multiple-pictures-template {{ getPostPictures(post.attachments).pictures.length == 1 || (post.type == \'listing\' || post.event) ? \'single-forced\' : \'\' }} {{ ::getPostPictures(post.attachments).cssclass }}\" ng-click=openPost(post)><div ng-if=\"(post.type == \'listing\' || post.event) && getPostPictures(post.attachments).pictures.length > 0\" class=\"picture-box single-picture-box\"><div style=\"background-size: cover; background-position: center; position: relative; padding-bottom: 50%; background-image: url(\'{{ ::getPostPicture() }}\')\"></div></div><div ng-if=\"post.type != \'listing\' && !post.event && !post.raffle && getPostPictures(post.attachments).pictures.length == 1\" class=\"picture-box single-picture-box\"><img alt=\"\" ng-src=\"{{ ::(getPostPictures(post.attachments).pictures[0].url + (!post.event ? \'=s584-c\' : \'\')) }}\"></div><div ng-if=\"post.type != \'listing\' && !post.event && getPostPictures(post.attachments).pictures.length > 1\" ng-repeat=\"att in getPostPictures(post.attachments).pictures | limitTo: 3\" class=picture-box style=\"background-image: url(\'{{ att.url }}=s290-c\')\"><div class=more-items-circle ng-if=\"getPostPictures(post.attachments).pictures.length > 3 && $last\"><div><div>+{{ (getPostPictures(post.attachments).pictures.length - 3) }}</div></div></div></div></div><div ng-if=isPostView() class=view-post-pictures-separator><div ng-repeat=\"att in getPostPictures(post.attachments).pictures\" style=\"text-align: center\"><img alt=\"\" ng-click=\"openPicture(post.attachments, att)\" ng-src=\"{{ att.url }}=s584-c\" style=\"max-width: 100%; cursor: pointer; width: 100%\"></div></div></div><div ng-show=\"post.type == \'classlist\'\" class=\"padding-post photo-padding\" style=\"margin-top: 10px\"><div ng-if=!isPostView() class=\"multiple-pictures-template {{ getPostPictures(post.attachments).pictures.length == 1 ? \'single-forced\' : \'\' }} {{ ::getPostPictures(post.attachments).cssclass }}\" ng-click=openClasslistPost(post)><div ng-if=\"getPostPictures(post.attachments).pictures.length == 1\" class=\"picture-box single-picture-box\"><img alt=\"\" ng-src=\"{{ ::(getPostPictures(post.attachments).pictures[0].url + \'=s584-c\') }}\"></div><div ng-if=\"getPostPictures(post.attachments).pictures.length > 1\" ng-repeat=\"att in getPostPictures(post.attachments).pictures | limitTo: 3\" class=picture-box style=\"background-image: url(\'{{ att.url }}=s290-c\')\"><div class=more-items-circle ng-if=\"::getPostPictures(post.attachments).pictures.length > 3 && $last\"><div><div>+{{ ::(getPostPictures(post.attachments).pictures.length - 3) }}</div></div></div></div></div></div><div ng-click=openPost(post) ng-if=\"!isPostView() && post.type == \'listing\'\" class=\"padding-post post-text {{ getPostPictures(post.attachments).pictures.length > 0 ? \'mkp-body-picture1\' : \'\' }}\" style=\"padding-bottom: 6px; padding-top: 5px\"><div><div style=\"overflow: auto\" class=\"text mkp-body\"><div class=mkp-title>{{ post.title }}</div><div ng-if=post.body class=mkp-descr ng-bind-html=post.body></div></div></div></div><div ng-click=openPost(post) ng-if=\"!isPostView() && post.event\" class=\"padding-post post-text {{ getPostPictures(post.attachments).pictures.length > 0 ? \'mkp-body-picture1\' : \'\' }}\" style=\"padding-bottom: 6px; padding-top: 5px\"><div><div style=\"overflow: auto\" class=\"text mkp-body\"><div class=mkp-title>{{ post.event.title }}</div><div ng-if=post.event.description class=mkp-descr ng-bind-html=getEventDescription(post.event.description)></div></div></div><div ng-if=post.event class=details-attachment-list><ul class=details-attachment-list style=\"font-size: 14px; font-weight: normal\"><li style=\"color: #eb004e; text-transform: uppercase; line-height: 25px; font-size: 16px\"><span>{{ post.event.date.startDate | date:\'EEE,\' : \'GMT\' }} <span>{{ post.event.date.startDate | date:\'MMM dd\' : \'GMT\' }}</span> <span><span translate=AT></span> <span>{{ post.event.date.startDate | date:\'h:mm a\' : \'GMT\' }}</span></span></span></li><!-- IF EVENT IS TICKETED --><li ng-if=\"post.event.status == \'ACTIVE\' && post.event.ticketed && post.event.answerCount.going > 0\"><time style=\"margin-right: 7px\"><span style=\"color: #009e6c\">{{ post.event.answerCount.sold }} going</span></time></li><!-- IF EVENT IS NOT TICKETED --><li ng-if=\"post.event.status == \'ACTIVE\' && !post.event.ticketed && post.event.answerCount.going > 0\"><time style=\"margin-right: 7px\"><span>{{ post.event.answerCount.going }} going</span></time></li></ul><div style=\"margin-top: 10px\"><div ng-if=post.event.ticketed><button ng-if=\"!post.event.past && post.event.status != \'CANCELLED\'\" ng-click=openPost(post) type=button class=\"btn btn-primary btn-primary-pink\" style=\"margin-top: 3px\"><span translate=GET_TICKETS></span></button></div><div ng-if=!post.event.ticketed><button ng-if=\"!post.event.past && post.event.status != \'CANCELLED\'\" ng-click=openPost(post) type=button class=\"btn btn-primary btn-primary-pink\" style=\"margin-top: 3px;display: block;\n                            margin: auto\"><span translate=RSVP_LABEL></span></button></div></div></div></div><div class=home-files-list ng-if=\"post.files && post.files.length > 0\"><div><div ng-repeat=\"att in post.files track by $index\" style=\"border-bottom: none\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><path fill=none stroke=#8a94a2 stroke-width=4 stroke-linecap=round stroke-miterlimit=10 d=\"M36,8v25 c0,7.2-5.8,13-13,13h0c-7.2,0-13-5.8-13-13V11c0-5,4-9,9-9h0c5,0,9,4,9,9v20c0,2.8-2.2,5-5,5h0c-2.8,0-5-2.2-5-5V14\" stroke-linejoin=round></path></g></svg> <a href=\"{{ att.url }}\" target=_blank style=\"word-break: break-word\">{{ att.name }}</a></div></div></div><div ng-if=\"isPostView() && post.type == \'listing\' && (post.body || post.title)\" class=padding-post><div style=\"overflow: auto\" class=text><div style=\"font-size: 16px; color: #6d7279; font-weight: 600; margin-bottom: 5px; word-break: break-word\">{{ post.title }}</div><span count-chars ng-bind-html=post.body class=multiple-line-text style=\"word-break: break-word\"></span></div></div><div class=\"padding-post padding-top-zero\" style=\"padding-bottom: 0\"><div ng-show=\"post.type === \'announcement\'\" class=\"announcement-stream {{ !isPostView() ? \'announcement-stream-cut\' : \'\' }}\"><div class=text><div post-id=\"{{ post.id }}\" count-chars data-ng-bind-html=trustAsHtml(post.body) style=\"margin: 0; color: #333\"></div><div ng-if=showReadMore><div ui-sref=\"view({ \'id\': post.id })\" ng-if=!isPostView() class=announcement-bottom-shadow><a class=btn-default translate=READ_MORE_BTN></a></div></div></div><div class=home-files-list style=\"padding: 0\"><div ng-if=\"post.attachments && post.attachments.length > 0\"><div ng-repeat=\"att in post.attachments\" style=\"border-bottom: none\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><path fill=none stroke=#8a94a2 stroke-width=4 stroke-linecap=round stroke-miterlimit=10 d=\"M36,8v25 c0,7.2-5.8,13-13,13h0c-7.2,0-13-5.8-13-13V11c0-5,4-9,9-9h0c5,0,9,4,9,9v20c0,2.8-2.2,5-5,5h0c-2.8,0-5-2.2-5-5V14\" stroke-linejoin=round></path></g></svg> <a href=\"{{ att.path }}\" target=_blank style=\"word-break: break-word\">{{ att.name }}</a></div></div></div></div><div ng-if=\"post.type == \'announcement\' && !isPostView() && post.attachmentCount > 0\" style=\"margin-top: 15px; font-size: 14px\"><a ui-sref=\"view({ \'id\': post.id })\">This announcement has {{ post.attachmentCount }} attachment(s)</a></div><div ng-show=\"post.type == \'classlist\'\"><div class=vi-row><div class=vi-col-middle><div class=text><div ng-bind-html=\"post.body | to_trusted\" class=\"multiple-line-text multiple-line-article\" style=\"margin-right: 0\"></div></div></div></div></div><!--\n				<div ng-show=\"!post.sold && !paymentConfirmed\">\n\n					<div ng-show=\"post.buyItem && post.onlinePayment && isPostView()\">\n						<div class=\"mkp_pay_text\">\n							<h1 translate=\"DONT_LET_AWAY\"></h1>\n							<br>\n						</div>\n						<form id=\"payment-form\">\n							<div class=\"form-row\"\n								style=\"border-radius: 10px; box-shadow: 0 2px 6px #ccc; padding: 10px;\">\n								<label for=\"card-element-1\">\n									Credit or debit card\n								</label>\n								<div id=\"card-element-1\"></div>\n								<div id=\"card-errors-1\" role=\"alert\"></div>\n							</div>\n						</form>\n						<div class=\"gray-but\" style=\"text-align: center; margin-top: 20px; margin-bottom: 15px;\">\n							<a id=\"post-button-id\" class=\"btn btn-primary btn-primary-pink mobile-post-button ng-scope\"\n								ng-click=\"buyNow()\" ng-disabled=\"buingTickets\"\n								style=\"position: relative; min-width: 130px; max-width: 200px; margin-top: 0;\"\n								translate=\"PAY_NOW\">\n\n							</a>\n							<a id=\"post-button-id\" class=\"btn btn-default btn-default-gray mobile-post-button ng-scope\"\n								ng-click=\"composeTo({ id: post.userId })\" ng-disabled=\"buingTickets\"\n								style=\"position: relative; max-width: 200px; margin-top: 0;color: #768F9B!important; min-width: 130px;\">\n								<span translate=\"CONTACT_SELLER\"></span> {{ post.postedByFirstName }}\n							</a>\n						</div>\n						<div>\n							<p>Please read</p>\n							<div class=\"mkp-small-text\">\n								<p>By selecting “Pay now” you acknowledge that this payment is final and irreversible.\n									Classlist cannot accept any financial or other liability related to this purchase.\n									<a target=\'_blank\'\n										href=\'https://help.classlist.com/hc/en-us/articles/360026405312\'>Find out\n										more</a></p>\n								<br>\n							</div>\n						</div>\n					</div>\n				</div>\n				<div ng-show=\"paymentConfirmed\" class=\"mkp-payment-confirmed\">\n					<h4 translate=\"MKP_CONGRATS\"></h4>\n					<p translate=\"MKP_CONGRATS_TEXT\" style=\"margin-bottom: 20px;\"></p>\n					<h4 translate=\"MKP_NOW_WHAT\"></h4>\n					<p translate=\"MKP_NOW_WHAT_TEXT\"></p>\n					<a id=\"post-button-id\" class=\"btn btn-default btn-default-gray mobile-post-button ng-scope\"\n						ng-click=\"composeTo({ id: post.userId })\" ng-disabled=\"buingTickets\"\n						style=\"position: relative; max-width: 200px; margin-top: 0;color: #768F9B!important; min-width: 130px; margin-bottom: 15px;\">\n						<span translate=\"CONTACT_SELLER\"></span> {{ post.postedByFirstName }}\n					</a>\n				</div>--><div ng-show=\"isPostView() && post.type == \'listing\' && !post.onlinePayment\" style=\"text-align: center\"><a id=post-button-id class=\"btn btn-default btn-default-gray mobile-post-button ng-scope\" ng-click=\"composeTo({ id: post.userId })\" ng-disabled=buingTickets style=\"position: relative; max-width: 200px; margin-top: 0;color: #768F9B!important; min-width: 130px; margin-bottom: 15px\"><span translate=CONTACT_SELLER></span> {{ post.postedByFirstName }}</a></div><div ng-show=\"post.type != \'listing\'\"><div class=likes-container style=\"margin-bottom: -12px; overflow: auto\"><div class=who-likes ng-if=\"post.likeCount > 0\"><div ng-click=showLikers(post) style=\"cursor: pointer\"><div ng-if=\"post.type != \'welcome\'\"><span ng-if=!post.isLiked class=likes-text><span>{{ post.lastLike[0] }}</span> <span ng-if=\"post.likeCount > 1\" translate=\"{{ (post.likeCount-1 > 1)? \'NUM_LIKES\' : \'NUM_LIKE\' }}\" translate-values=\"{\'num\':post.likeCount-1}\"></span> <span ng-if=\"post.likeCount == 1\" translate=LIKES_THIS></span> </span><span ng-if=\"post.isLiked && post.likeCount > 1\" class=likes-text translate=\"{{ (post.likeCount-1 > 1)? \'NUM_OTHER_LIKES\' : \'NUM_OTHER_LIKE\' }}\" translate-values=\"{\'num\':post.likeCount-1}\"></span> <span ng-if=\"post.isLiked && post.likeCount <= 1\" translate=NUM_MY_LIKE class=likes-text></span></div><div ng-if=\"post.type == \'welcome\'\"><span ng-if=!post.isLiked class=likes-text><span ng-if=\"post.likeCount > 1\" translate=OTHERS_WELCOMED translate-values=\"{\'name\':post.lastLike[0], \'num\':post.likeCount-1}\"></span> <span ng-if=\"post.likeCount == 1\" translate=SOMEONE_WELCOMED translate-values=\"{\'name\':post.lastLike[0]}\"></span> </span><span ng-if=\"post.isLiked && post.likeCount > 1\" class=likes-text translate=ME_OTHERS_WELCOMED translate-values=\"{\'num\':post.likeCount-1}\"></span> <span ng-if=\"post.isLiked && post.likeCount <= 1\" translate=ME_WELCOMED class=likes-text></span></div></div></div></div></div></div></div><div ng-show=\"post.type != \'listing\' || isPostView()\"><div class=\"post-item-likes clearfix\" ng-hide=commentOnly><div class=like-container style=\"cursor: pointer; min-width: 65px\"><a id=like-post-id ng-click=likePost(post) style=\"line-height: initial\"><svg ng-if=!post.isLiked style=\"width: 24px; height: 27px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=3><g stroke-width=3 transform=\"translate(0.5, 0.5)\"><path data-cap=butt fill=none stroke=#eb004e stroke-width=3 stroke-miterlimit=10 d=\"M14,56l6.7,3.4 C24.2,61.1,28.1,62,32,62h20c3.3,0,6.4-2.4,7-6l3-24c0-3.3-2.7-6-6-6H40V16c0-5.7-3.5-11.9-9.4-13.6C29.3,2.1,28,3,28,4.3V16L14,34\" stroke-linejoin=miter stroke-linecap=butt></path><rect data-color=color-2 x=2 y=28 fill=none stroke=#eb004e stroke-width=3 stroke-linecap=square stroke-miterlimit=10 width=12 height=34 stroke-linejoin=miter></rect></g></svg> <svg ng-if=post.isLiked style=\"width: 24px; height: 27px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><path data-color=color-2 fill=#3677d9 d=\"M12,27H2c-0.6,0-1,0.4-1,1v34c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1V28C13,27.4,12.6,27,12,27z \"></path><path fill=#3677d9 d=\"M56,25H41v-9c0-5.8-3.5-12.6-10.1-14.5c-0.3-0.1-0.6-0.1-0.9-0.1c-1.7,0-3,1.3-3,3v11.3L15,31.1v26.5 l5.3,2.6C23.9,62,28,63,32,63h20c3.9,0,7.3-2.9,8-6.9l3-24c0,0,0-0.1,0-0.1C63,28.1,59.9,25,56,25z\"></path></g></svg> </a><span ng-click=showLikers(post) class=text style=\"font-size: 14px; float: left; line-height: 31px; padding: 0px 10px; font-weight: bold; {{ post.isLiked ? \'color: #3677d9;\' : \'\' }}\" ng-if=\"post.likeCount > 0\">{{ post.likeCount }} </span><span class=text ng-click=likePost() ng-if=!post.likeCount style=\"font-size: 13px; float: left; line-height: 31px; padding: 0px 10px\"></span></div><div ng-if=\"!post.isOwn && post.type != \'welcome\' && !readonly\" class=\"like-container follow-container\" style=\"cursor: pointer\"><a id=follow-post-id ng-click=followPost(true) style=\"line-height: initial; float: left\"><svg ng-if=post.isFollowed style=\"width: 23px; height: 29px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\"><g transform=\"translate(0, 0)\"><path data-color=color-2 d=M24,47a6.006,6.006,0,0,0,5.91-5H18.09A6.006,6.006,0,0,0,24,47Z fill=#3677d9></path><path d=M43.814,38.419C43.766,38.352,39,31.6,39,26V16A15,15,0,1,0,9,16V26c0,5.6-4.766,12.352-4.814,12.419A1,1,0,0,0,5,40H43a1,1,0,0,0,.814-1.581Z fill=#3677d9></path></g></svg> <svg ng-if=!post.isFollowed style=\"width: 23px; height: 29px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><path d=M38,55a6,6,0,0,1-12,0 fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></path><path d=M52.262,42A22.711,22.711,0,0,1,50,33V21A18,18,0,0,0,32,3h0A17.95,17.95,0,0,0,18.584,9 fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></path><path data-cap=butt d=M15.018,15.019A17.97,17.97,0,0,0,14,21V33c0,8-7,17-7,17H50 fill=none stroke=#444444 stroke-miterlimit=10 stroke-width=2 stroke-linecap=butt stroke-linejoin=miter></path><line data-color=color-2 x1=4 y1=4 x2=60 y2=60 fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></line></g></svg></a></div></div><div class=post-item-comment ng-if=\"post.commentCount > 0\" style=\"background:#fff; padding-left: 12px\"><div class=vi-row ng-if=\"post.comments.length < post.commentCount\"><div class=vi-col-right><span class=comment-num style=\"margin-top: 0; margin-bottom: 10px; font-size: 14px\"><span>{{ post.comments.length }} <span translate=OF></span></span> {{ post.commentCount }}</span></div><div class=vi-col-middle style=\"padding-left: 5px\"><div ng-hide=post.hideMoreComm><a class=view-previous-comments ng-click=getMoreComments(post) style=\"margin-top: 0; margin-bottom: 10px; font-size: 14px; padding-left: 2px\" translate=VIEW_PREV_COMMENTS></a></div></div></div><div class=comment-item id=\"comment_{{ cmm.id }}\" ng-repeat=\"cmm in post.comments\" style=\"margin-bottom: 0\"><div class=vi-row id=\"cmt_{{ cmm.id }}\"><div class=vi-col-left style=\"width: 46px; padding-right: 10px\"><figure ng-if=!cmm.sample class=comment-item-avatar ng-click=openUserHome(cmm.userId)><avatar source={{cmm.avatar}} name=\"{{ cmm.postedBy }}\" width=60 height=60 my=false></avatar></figure><figure ng-show=cmm.sample class=comment-item-avatar><avatar source={{cmm.avatar}} name=\"{{ cmm.postedBy }}\" width=60 height=60 my=false></avatar></figure></div><div class=vi-col-middle style=\"overflow: auto\"><div style=\"margin-right: 10px; border-radius: 10px; position: relative; width: 97%\"><div style=\"overflow: auto; background: #f5f8ff; border-radius: 10px\"><div class=comment-text-section style=\"overflow: auto; padding: 6px 8px; float: left; max-width: 100%\"><div class=\"multiple-line-text comment-text\" style=\"margin: 0\"><a ng-if=!cmm.sample ng-click=openUserHome(cmm.userId) style=\"margin-right: 36px\" class=HEADER2>{{cmm.postedBy}}</a><a ng-if=cmm.sample class=\"disabled HEADER2\" style=\"margin-right: 36px\">{{cmm.postedBy}}</a><br><span ng-bind-html=cmm.body ng-if=\"cmm.body && cmm.body.length > 0 && cmm.body.length < 799\" style=\"color: #627293; margin-right: 10px; word-break: break-word\"></span> <span ng-bind-html=\"cmm.body.substring(0, 799) + \'...\'\" ng-if=\"cmm.body && cmm.body.length > 0 && cmm.body.length > 799 && !cmm.showFullComment\" style=\"color: #627293; margin-right: 10px; word-break: break-word\"></span> <span ng-bind-html=cmm.body ng-if=\"cmm.body && cmm.body.length > 0 && cmm.showFullComment\" style=\"color: #627293; margin-right: 10px; word-break: break-word\"></span> <a style=\"font-weight: bold; color:#eb004e\" ng-if=\" cmm.body && cmm.body.length> 799 && !cmm.showFullComment\" ng-click=\"cmm.showFullComment = true\">Read more</a></div></div><div ng-if=\"cmm.attachment && cmm.attachment.url != \'\'\" style=\"clear: both\"></div><div ng-if=\"cmm.attachment && cmm.attachment.url != \'\' && !cmm.attachment.fileView\" style=\"overflow: auto; width: 100%; height: 100%; padding: 10px;max-width: 100%; max-height: 250px; cursor: pointer\" id=image-preview-wrapper><div ng-click=openCommentImage(cmm.attachment.url) style=\"margin-bottom: 3px;text-align: center\"><img ng-src={{cmm.attachment.url}} style=\"height: 100%; width: 100%\"></div></div><div class=home-files-list ng-if=\"cmm.attachment && cmm.attachment.url != \'\' && cmm.attachment.fileView\" style=\"float: left; padding-left: 2px; margin-top: 0px !important\"><div><div style=\"border-bottom: none\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><path fill=none stroke=#8a94a2 stroke-width=4 stroke-linecap=round stroke-miterlimit=10 d=\"M36,8v25 c0,7.2-5.8,13-13,13h0c-7.2,0-13-5.8-13-13V11c0-5,4-9,9-9h0c5,0,9,4,9,9v20c0,2.8-2.2,5-5,5h0c-2.8,0-5-2.2-5-5V14\" stroke-linejoin=round></path></g></svg> <a href=\"{{ cmm.attachment.url }}\" target=_blank style=\"word-break: break-word\">{{ cmm.attachment.fileName }}</a></div></div></div></div><nav ng-show=\"post.type !== \'NEW_GROUP\'\" class=\"has-dropdown is-relative more-dots\" style=\"margin-top: 0; position: absolute; top: 2px; right: 0; width: 26px; padding-top: 5px; z-index: 9; padding-bottom: 7px\"><svg style=\"transform: rotate(90deg); height: 16px; margin-top:5px\" ng-if=\"post.type !== \'welcome\'\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\"><g transform=\"translate(0, 0)\"><circle fill=#8a94a2 cx=4 cy=16 r=3></circle><circle data-color=color-2 fill=#8a94a2 cx=16 cy=16 r=3></circle><circle fill=#8a94a2 cx=28 cy=16 r=3></circle></g></svg><ul class=dropdown-menu style=\"right: 1px!important; top:100%!important\"><li ng-if=cmm.own><a ng-click=deleteComment(cmm.id)>Delete</a></li><li ng-if=!cmm.own><a ng-click=reportComment(cmm.id)>{{\'REPORT_COMMENT\' | translate}}</a></li></ul></nav><div class=comment-box style=\"padding-left:0px !important\" ng-if=\"cmm.userId > 10\"><div style=\"float:left; width:100%\"><ng-container><time style=\"float: left; margin: 0px 10px 0px 5px; line-height: 23px; color: #009e6c\">{{ cmm.created | timeago }}</time><div style=\"width: 50px; float:left; margin: 2px 0 0 15px\"><!--like comment--> <a ng-click=likeComment(cmm) style=\"{{ cmm.liked ? \'color: #005cb8; font-weight: bold;\' : \'color:#eb004e;\' }}\">Like</a></div><div style=\"width: 50px; float:left; margin-top:2px\" ng-if=!post.commentLocked><!--reply comment -- we used input instead of link for ios keyboard action--> <input ng-click=replyComment(cmm) style=\"color:#eb004e; cursor: pointer; margin: 0px; padding: 0px; border:none; width:40px\" value=Reply></div><div ng-if=\"cmm.likeCount > 0\" ng-click=showCommLikers(cmm) style=\"float:right; color: #627293; margin: 2px 0 0 15px\"><!--reply comment--> <svg style=\"width: 16px; height: 20px; vertical-align: bottom\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=3><g stroke-width=3 transform=\"translate(0.5, 0.5)\"><path data-cap=butt fill=none stroke=#eb004e stroke-width=3 stroke-miterlimit=10 d=\"M14,56l6.7,3.4 C24.2,61.1,28.1,62,32,62h20c3.3,0,6.4-2.4,7-6l3-24c0-3.3-2.7-6-6-6H40V16c0-5.7-3.5-11.9-9.4-13.6C29.3,2.1,28,3,28,4.3V16L14,34\" stroke-linejoin=miter stroke-linecap=butt></path><rect data-color=color-2 x=2 y=28 fill=#eb004e stroke=#eb004e stroke-width=3 stroke-linecap=square stroke-miterlimit=10 width=12 height=34 stroke-linejoin=miter></rect></g></svg> {{ cmm.likeCount }}</div></ng-container></div></div></div></div><!--REPLIES START--><div ng-if=\"cmm.totalReplyCount > 0\" id=replies_{{cmm.id}} class=vi-col-middle style=\"width:93%; float: right\"><div class=vi-col-middle style=\"padding-left: 5px\"><div ng-show=\"cmm.replies.length != cmm.totalReplyCount\"><a class=view-previous-comments ng-click=getMoreReplies(cmm) ] style=\"margin: 10px 0px 20px; padding-left: 2px; font-size: 14px\" translate=VIEW_PREV_REPLIES translate-values=\"{ \'moreReplyCount\': cmm.totalReplyCount - cmm.replies.length}\"></a></div></div><div class=comment-item id=\"comment_{{ reply.id }}\" ng-repeat=\"reply in cmm.replies\" style=\"margin-bottom: 0\"><div class=vi-row id=\"cmt_{{ reply.id }}\"><div class=vi-col-left style=\"width: 46px; padding-right: 10px\"><figure ng-if=!reply.sample class=comment-item-avatar ng-click=openUserHome(reply.userId)><avatar source={{reply.avatar}} name=\"{{ reply.postedBy }}\" width=60 height=60 my=false></avatar></figure><figure ng-show=reply.sample class=comment-item-avatar><avatar source={{reply.avatar}} name=\"{{ reply.postedBy }}\" width=60 height=60 my=false></avatar></figure></div><div class=vi-col-middle style=\"overflow: auto\"><div style=\"margin-right: 10px; border-radius: 10px; position: relative; width: 97%\"><div style=\"overflow: auto; background: #f5f8ff; border-radius: 10px\"><div class=comment-text-section style=\"overflow: auto; padding: 6px 8px; float: left; max-width: 100%\"><div class=\"multiple-line-text comment-text\" style=\"margin: 0\"><a ng-if=!reply.sample ng-click=openUserHome(reply.userId) style=\"margin-right: 36px\" class=HEADER2>{{reply.postedBy}}</a><a ng-if=reply.sample class=\"disabled HEADER2\" style=\"margin-right: 36px\">{{reply.postedBy}}</a><br><span ng-bind-html=reply.body ng-if=\"reply.body && reply.body.length > 0 && reply.body.length < 799\" style=\"color: #627293; margin-right: 10px; word-break: break-word\"></span> <span ng-bind-html=\"reply.body.substring(0, 799) + \'...\'\" ng-if=\"reply.body && reply.body.length > 0 && reply.body.length > 799 && !reply.showFullComment\" style=\"color: #627293; margin-right: 10px; word-break: break-word\"></span> <span ng-bind-html=reply.body ng-if=\"reply.body && reply.body.length > 0 && reply.showFullComment\" style=\"color: #627293; margin-right: 10px; word-break: break-word\"></span> <a style=\"font-weight: bold; color:#eb004e\" ng-if=\" reply.body && reply.body.length> 799 && !reply.showFullComment\" ng-click=\"reply.showFullComment = true\">Read more</a></div></div><div ng-if=\"reply.attachment && reply.attachment.url != \'\'\" style=\"clear: both\"></div><div ng-if=\"reply.attachment && reply.attachment.url != \'\' && !reply.attachment.fileView\" style=\"overflow: auto; width: 100%; height: 100%; padding: 10px;max-width: 100%; max-height: 250px; cursor: pointer\" id=image-preview-wrapper><div ng-click=openCommentImage(reply.attachment.url) style=\"margin-bottom: 3px;text-align: center\"><img ng-src={{reply.attachment.url}} style=\"height: 100%; width: 100%\"></div></div><div class=home-files-list ng-if=\"reply.attachment && reply.attachment.url != \'\' && reply.attachment.fileView\" style=\"float: left; padding-left: 2px; margin-top: 0px !important\"><div><div style=\"border-bottom: none\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><path fill=none stroke=#8a94a2 stroke-width=4 stroke-linecap=round stroke-miterlimit=10 d=\"M36,8v25 c0,7.2-5.8,13-13,13h0c-7.2,0-13-5.8-13-13V11c0-5,4-9,9-9h0c5,0,9,4,9,9v20c0,2.8-2.2,5-5,5h0c-2.8,0-5-2.2-5-5V14\" stroke-linejoin=round></path></g></svg> <a href=\"{{ reply.attachment.url }}\" target=_blank style=\"word-break: break-word\">{{ reply.attachment.fileName }}</a></div></div></div></div><nav ng-show=\"post.type !== \'NEW_GROUP\'\" class=\"has-dropdown is-relative more-dots\" style=\"margin-top: 0; position: absolute; top: 2px; right: 0; width: 26px; padding-top: 0px; z-index: 99; padding-bottom: 7px\"><svg style=\"transform: rotate(90deg); height: 16px; margin-top: 10px\" ng-if=\"post.type !== \'welcome\'\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\"><g transform=\"translate(0, 0)\"><circle fill=#8a94a2 cx=4 cy=16 r=3></circle><circle data-color=color-2 fill=#8a94a2 cx=16 cy=16 r=3></circle><circle fill=#8a94a2 cx=28 cy=16 r=3></circle></g></svg><ul class=dropdown-menu style=\"right: 1px!important; top:100%!important\"><li ng-if=reply.own><a ng-click=\"deleteReplyComment(cmm.id, reply.id)\">Delete</a></li><li ng-if=!reply.own><a ng-click=reportComment(reply.id)>{{\'REPORT_COMMENT\' | translate}}</a></li></ul></nav><div class=comment-box style=\"padding-left:0px !important\"><div style=\"float:left; width: 100%\"><ng-container><time style=\"float: left; margin: 0px 10px 0px 5px; line-height: 23px; color: #009e6c\">{{ reply.created | timeago }}</time><div style=\"width: 50px; float:left; margin: 2px 0 0 15px\"><!--like comment--> <a ng-click=likeComment(reply) style=\"{{ reply.liked ? \'color: #005cb8; font-weight: bold;\' : \'color:#eb004e;\' }}\">Like</a></div><div style=\"width: 50px; float:left; margin-top: 2px\" ng-if=!post.commentLocked><!--reply comment--> <input ng-click=replyComment(cmm,reply.userId,reply.postedBy,null,reply.id) style=\"color:#eb004e; cursor: pointer; margin: 0px; padding: 0px; border:none; width:40px\" value=Reply></div><div ng-if=\"reply.likeCount > 0\" ng-click=showCommLikers(cmm) style=\"float:right; color:#969696; margin: 2px 0 0 15px\"><!--reply comment--> <svg style=\"width: 18px; height: 22px; vertical-align: bottom; color:#627293\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=3><g stroke-width=3 transform=\"translate(0.5, 0.5)\"><path data-cap=butt fill=none stroke=#eb004e stroke-width=3 stroke-miterlimit=10 d=\"M14,56l6.7,3.4 C24.2,61.1,28.1,62,32,62h20c3.3,0,6.4-2.4,7-6l3-24c0-3.3-2.7-6-6-6H40V16c0-5.7-3.5-11.9-9.4-13.6C29.3,2.1,28,3,28,4.3V16L14,34\" stroke-linejoin=miter stroke-linecap=butt></path><rect data-color=color-2 x=2 y=28 fill=#eb004e stroke=#eb004e stroke-width=3 stroke-linecap=square stroke-miterlimit=10 width=12 height=34 stroke-linejoin=miter></rect></g></svg> {{ reply.likeCount }}</div></ng-container></div></div></div></div></div></div></div><!--REPLIES END--></div></div></div><div class=post-item-add-comment ng-hide=post.commentLocked ng-show=\"postContext !== null && postContext !== \'GROUP_LIST_VIEW\'\" style=\"background: #fff; padding-left: 12px\"><div class=comment-composer><comment-composer draft-comment=draftComment post-id={{post.id}} user-avatar=userAvatar events=events></comment-composer></div></div></div></div><div ng-if=\"readonlyPost && post.type === \'announcement\'\" class=post-container style=\"background: transparent; border: none\"><div style=\"padding: 0 10px\"><strong class=page-view-header__title style=\"padding: 6px 0\"><span translate=ANNOUNCEMENTS_TO></span>:</strong><div class=announcement-sent-to ng-repeat=\"a in post.sentTo track by $index\"><p></p><figure class=avatar><span class=dripicons-user-group></span></figure>{{a}}<p></p></div></div></div></div>");
$templateCache.put("app/base/directives/premiumAd.directive.html","<div ng-if=premium_ad><div class=premium-ban><div><a href=\"{{ premium_ad.link }}\" target=_blank><img alt=\"\" class=ad-image ng-src=\"{{ premium_ad.photo }}\"></a></div></div></div>");
$templateCache.put("app/classlist/views/address-modal.html","<div><div class=modal-header><h3 translate=ADDRESS_CONTACT></h3></div><div class=modal-body><div><div><div class=form-group><div><input type=text class=\"form-control address-form\" name=houseName autocomplete=off ng-model=myUser.address.houseName placeholder=\"{{\'HOUSENAME_PHOLDER\' | translate }}\" ng-maxlength=regexes.max.address maxlength={{regexes.max.address}}></div></div><div class=form-group><div><input type=text class=\"form-control address-form\" autocomplete=off name=streetName ng-model=myUser.address.streetAddress placeholder=\"{{\'STREETNAME_PHOLDER\' | translate }}\" ng-maxlength=regexes.max.address maxlength={{regexes.max.address}}><div class=error-text-red ng-show=\"(!myUser.address.streetAddress || myUser.address.streetAddress.length === 0) && isOptInClicked\"><p translate=ERR_RUNMAP_STREET></p></div></div></div><div class=\"row form-group\"><div class=\"col-md-6 col-sm-6 col-xs-6\"><input type=text class=\"form-control address-form\" autocomplete=off name=city ng-model=myUser.address.city placeholder=\"{{\'CITY_PHOLDER\' | translate }}\" ng-maxlength=regexes.max.address maxlength={{regexes.max.address}}><div class=error-text-red ng-show=\"(!myUser.address.city || myUser.address.city.length === 0) && isOptInClicked\"><p translate=ERR_RUNMAP_CITY></p></div></div><div class=\"col-md-6 col-sm-6 col-xs-6\"><input type=text class=\"form-control address-form\" autocomplete=off name=state ng-model=myUser.address.stateCounty placeholder=\"{{\'STATE_PHOLDER\' | translate }}\" ng-maxlength=regexes.max.address maxlength={{regexes.max.address}}></div></div><div class=\"row form-group\"><div class=\"col-md-6 col-sm-6 col-xs-6\"><input type=text class=\"form-control address-form\" autocomplete=off name=postCode ng-model=myUser.address.postCode placeholder=\"{{\'POSTCODE_PHOLDER\' | translate }}\" remove-chars=address ng-maxlength=regexes.max.postcode maxlength={{regexes.max.postcode}}><div class=error-text-red ng-show=\"(!myUser.address.postCode || myUser.address.postCode.length === 0)  && isOptInClicked\"><p translate=ERR_RUNMAP_POSTCODE></p></div></div><div class=\"col-md-6 col-sm-6 col-xs-6\"><div class=\"is-relative address-form\"><countries class=address-label ng-model=myUser.address.countryId is-required=true></countries><label class=select-placeholder translate=COUNTRY_PHOLDER ng-hide=\"myUser.address.countryId.length > 0\"></label><span class=\"dripicons-chevron-down select-arrow\"></span></div></div></div></div></div></div><div class=modal-footer><a ng-click=close() type=button class=\"btn btn-default\" translate=CANCEL_BTN></a> <a ng-click=save() type=button class=\"btn btn-primary\" translate=SAVE_BTN></a></div></div>");
$templateCache.put("app/classlist/views/all.html","<article><section class=page-view-header><div style=\"padding-left: 0\"><div><div class=classlist-page-header><div><div class=switch-tabs><div class=sw-tabs-back><div class=is-relative><svg ng-click=back() id=header-back-button class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg></div></div><div class=sw-tabs-select><div class=is-relative><select class=form-control ng-model=tierId ng-change=beforeTierChanged(tierId) ng-options=\"f.id as f.name for f in filters\"></select><span class=\"dripicons-chevron-down select-arrow\"></span></div></div><div class=sw-tabs-switch><button ng-click=gotoInvite() class=\"btn btn-primary pull-right btn-primary-pink plus-button btn-primary-subheader\"><svg style=\"float: left; margin-top: 3px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=25px height=25px viewBox=\"0 0 48 48\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><line fill=none stroke=#ffffff stroke-width=4 stroke-linecap=round stroke-miterlimit=10 x1=24 y1=14 x2=24 y2=34 stroke-linejoin=round></line><line fill=none stroke=#ffffff stroke-width=4 stroke-linecap=round stroke-miterlimit=10 x1=34 y1=24 x2=14 y2=24 stroke-linejoin=round></line></g></svg> <span style=\"margin-top: 0px; float: left\">Invite</span></button></div></div></div></div></div></div></section><section style=\"margin-top: 0!important\"><div class=page-view-subheader style=\"margin-bottom: 0; padding: 0 15px\"><div class=search-tabs><div><span ng-click=openSearchContacts() class=contacts-search-label><div class=search-label><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 64 64\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><line data-cap=butt data-color=color-2 fill=none stroke=#627293 stroke-width=4 stroke-miterlimit=10 x1=60 y1=60 x2=43 y2=43 stroke-linejoin=miter stroke-linecap=butt></line><circle fill=none stroke=#627293 stroke-width=4 stroke-linecap=square stroke-miterlimit=10 cx=26 cy=26 r=24 stroke-linejoin=miter></circle></g></svg> <span>Search for parent or child</span></div></span></div><div><div><div class=contacts-tabs><div ng-click=gotoContactsMap()><svg class=location-svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\"><g transform=\"translate(0, 0)\"><path fill=#444444 d=\"M24,1C15.644,1,7,7.359,7,18c0,11.285,15.627,27.042,16.293,27.707C23.48,45.895,23.735,46,24,46 s0.52-0.105,0.707-0.293C25.373,45.042,41,29.285,41,18C41,7.359,32.356,1,24,1z M24,24c-3.309,0-6-2.691-6-6s2.691-6,6-6 s6,2.691,6,6S27.309,24,24,24z\"></path></g></svg></div><div class=active ng-click=gotoContactsList()><svg class=contacts-svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><path fill=#444444 d=M6,0H1C0.4,0,0,0.4,0,1v5c0,0.6,0.4,1,1,1h5c0.6,0,1-0.4,1-1V1C7,0.4,6.6,0,6,0z></path><path fill=#444444 d=M15,0h-5C9.4,0,9,0.4,9,1v5c0,0.6,0.4,1,1,1h5c0.6,0,1-0.4,1-1V1C16,0.4,15.6,0,15,0z></path><path fill=#444444 d=M6,9H1c-0.6,0-1,0.4-1,1v5c0,0.6,0.4,1,1,1h5c0.6,0,1-0.4,1-1v-5C7,9.4,6.6,9,6,9z></path><path fill=#444444 d=M15,9h-5c-0.6,0-1,0.4-1,1v5c0,0.6,0.4,1,1,1h5c0.6,0,1-0.4,1-1v-5C16,9.4,15.6,9,15,9z></path></g></svg></div></div></div></div></div></div><div ng-if=loadingContacts style=\"text-align: center; font-size: 15px; color: #444; padding: 30px\"><span>We are retrieving the contacts list. It will take just a moment...</span></div><div class=classlist-list><div ng-if=\"tierId > 0\" ng-repeat=\"c in _parents track by $index\" style=\"cursor: pointer\"><div ng-click=openProfile(c) class=\"{{ _parents_placeholders.length > 0 ? \'hlighted\' : \'\' }}\"><div><div class=classlist-item ng-show=\"(c.fN !== \'na\')\" ng-class=\"{\'hidden\': c.invisible}\"><div class=user-icon><figure class=classlist-item-avatar><avatar source=\"{{ c.id == active_user.id ? active_user.avatar : (c.a) }}\" width=40 height=40 name=\"{{ c.fN + \' \' + c.lN }}\" my=false></avatar></figure></div><div class=classlist-item-info><h5>{{ c.fN }} {{ c.lN }}</h5><div class=comma-fix><span ng-repeat=\"p in c.ps\" ng-if=\"!tierId || p.fTI == tierId || p.sTI == tierId\"><span>{{ p.fN }}<span>,&nbsp;</span></span></span></div></div></div></div><div class=footer-bar><div ng-if=\"viewState.isReady && c.me && !isProfileCompleted()\" class=complete-profile-footer-pink><span translate=COMPLETE_YOUR_PROFILE></span></div><div ng-if=\"viewState.isReady && c.me && isProfileCompleted()\" class=complete-profile-footer><span translate=EDIT_YOUR_PROFILE></span></div><div ng-if=!c.me class=distance-footer>{{ getNearestHundred(c.dist) }}</div></div></div></div><div ng-if=!loadingContacts style=\"cursor: pointer\"><div class=\"classlist-item-placeholder classlist-item-invite\"><div ng-click=gotoInviteCard()><div class=classlist-item><div class=classlist-item-info><h5><span translate=KNOW_ANYONE_ELSE></span></h5></div><div translate=INVITE_THEM></div></div></div></div></div><div ng-repeat=\"cp in _parents_placeholders\" style=\"cursor: pointer\"><div class=classlist-item-placeholder><div ng-click=gotoInviteSkeleton()><div class=classlist-item><div class=user-icon-placeholder><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=12px height=12px viewBox=\"0 0 12 12\"><g transform=\"translate(0, 0)\"><circle cx=6 cy=3 r=3 fill=#005cb8 data-color=color-2></circle><path d=M6,7C2.625,7,1,9.106,1,10.333V11a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1v-.667C11,9.106,9.375,7,6,7Z fill=#005cb8></path></g></svg></div><div class=classlist-item-info><h5 style=\"font-size: 14px; font-weight:bold\"><div class=placeholder-name></div></h5><div class=comma-fix><div class=placeholder-pupils></div></div></div></div></div><div class=footer-bar><div class=placeholder-location></div></div></div></div><div ng-if=\"tierId > 0 && _parents.length != classlist.parents.length\" style=\"text-align: center; color: #444; font-size: 15px; padding: 30px\"><span>Loading...</span></div></div></section></article>");
$templateCache.put("app/classlist/views/details.html","<article class=\"classlist-details hidden-content {{ viewState.isReady ? \'visible-content\' : \'\' }}\"><section class=\"page-view-header classlist-header {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div style=\"padding: 0\"><div class=premium-ad-clear style=\"padding: 0 15px\"><div premium-ad></div></div><div style=\"position: relative\"><svg id=header-back-button ng-click=back() class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <strong class=page-view-header__title translate=PROFILE></strong><nav ng-if=!isCurrentUser() class=\"has-dropdown is-relative more-dots\" style=\"margin-top: 0; position: absolute; top: 1px; right: 2px; width: 40px; z-index: 11; height: 50px; float: right\"><ul class=dropdown-menu style=\"right: 1px!important; background: #fff!important\"><li ng-if=!user.muted ng-click=muteParent()><a translate=MUTE_PARENT_LABEL></a></li><li ng-if=user.muted ng-click=unmuteParent()><a translate=UNMUTE_PARENT_LABEL></a></li><li ng-click=reportParent()><a translate=CLIST_REPORTUSER></a></li></ul><svg class=profile-dots xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\"><g transform=\"translate(0, 0)\"><circle fill=#91969d cx=4 cy=16 r=3></circle><circle data-color=color-2 fill=#91969d cx=16 cy=16 r=3></circle><circle fill=#91969d cx=28 cy=16 r=3></circle></g></svg></nav><a href=#/profile class=account-settings-icon ng-if=isCurrentUser()><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><path d=M60.354,41.139,53.706,36.1a22.285,22.285,0,0,0,.385-4.1v0a22.267,22.267,0,0,0-.393-4.1l6.652-5.037a1,1,0,0,0,.262-1.3L55.34,12.434a1,1,0,0,0-1.255-.421l-7.7,3.254A22.241,22.241,0,0,0,39.3,11.153L38.265,2.876A1,1,0,0,0,37.273,2H26.727a1,1,0,0,0-.992.876L24.7,11.153a22.225,22.225,0,0,0-7.086,4.112l-7.7-3.254a1,1,0,0,0-1.255.421L3.384,21.566a1,1,0,0,0,.262,1.3L10.3,27.9a22,22,0,0,0,0,8.2L3.646,41.137a1,1,0,0,0-.262,1.3l5.272,9.132a1,1,0,0,0,1.255.421l7.7-3.254A22.212,22.212,0,0,0,24.7,52.847l1.034,8.277a1,1,0,0,0,.992.876H37.273a1,1,0,0,0,.992-.876L39.3,52.847a22.225,22.225,0,0,0,7.086-4.112l7.7,3.254a1,1,0,0,0,1.255-.421l5.272-9.132A1,1,0,0,0,60.354,41.139ZM32,43A11,11,0,1,1,43,32,11,11,0,0,1,32,43Z fill=#627293></path></g></svg></a></div></div></section><section><div style=\"margin: 30px 0\"><div class=centering><div class=profile-heading><div><a ng-show=\"os == \'Android\'\" ng-click=preLongPressCall(user.phoneNumber) class=\"profile-phone-icon {{ !isCurrentUser() && user.phoneNumber.length > 2 && isNumeric(user.phoneNumber) ? \'\' : \'disabled-icon\' }}\"><svg ng-if=!isCurrentUser() xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><path fill=#444444 d=\"M15.285,12.305l-2.578-2.594c-0.39-0.393-1.025-0.393-1.416-0.002L9,12L4,7l2.294-2.294 c0.39-0.39,0.391-1.023,0.001-1.414l-2.58-2.584C3.324,0.317,2.691,0.317,2.3,0.708L0.004,3.003L0,3c0,7.18,5.82,13,13,13 l2.283-2.283C15.673,13.327,15.674,12.696,15.285,12.305z\"></path></g></svg> </a><a ng-show=\"os != \'Android\'\" ng-click=preLongPressCall(user.phoneNumber) class=\"profile-phone-icon {{ !isCurrentUser() && user.phoneNumber.length > 2 && isNumeric(user.phoneNumber) ? \'\' : \'disabled-icon\' }}\"><svg ng-if=!isCurrentUser() xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><path fill=#444444 d=\"M15.285,12.305l-2.578-2.594c-0.39-0.393-1.025-0.393-1.416-0.002L9,12L4,7l2.294-2.294 c0.39-0.39,0.391-1.023,0.001-1.414l-2.58-2.584C3.324,0.317,2.691,0.317,2.3,0.708L0.004,3.003L0,3c0,7.18,5.82,13,13,13 l2.283-2.283C15.673,13.327,15.674,12.696,15.285,12.305z\"></path></g></svg></a></div><div><figure class=\"classlist-item-avatar parent-profile-avatar centering\" style=\"overflow: initial\"><avatar source=\"{{ !isCurrentUser() ? user.avatar : active_user.avatar }}\" my=false name=\"{{ user.firstName + \' \' + user.lastName }}\" style=\"border-radius: 50%\"></avatar><div ng-if=isCurrentUser() class=photo-icon ng-click=uploadAvatar()><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><path fill=#ffffff d=\"M58,13h-8.546l-6.701-7.659C42.562,5.125,42.288,5,42,5H28c-0.288,0-0.562,0.125-0.753,0.341L20.546,13H6 c-2.757,0-5,2.243-5,5v36c0,2.757,2.243,5,5,5h52c2.757,0,5-2.243,5-5V18C63,15.243,60.757,13,58,13z M13,26c-1.103,0-2-0.897-2-2 s0.897-2,2-2s2,0.897,2,2S14.103,26,13,26z M35,50c-7.732,0-14-6.268-14-14s6.268-14,14-14s14,6.268,14,14S42.732,50,35,50z\"></path></g></svg></div></figure></div><div><div ng-if=!isCurrentUser() ng-click=preComposeTo(user) class=\"profile-message-icon {{ !isCurrentUser() ? \'\' : \'disabled-icon\' }}\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><path d=M57,4H7a6,6,0,0,0-6,6V40a6,6,0,0,0,6,6h8V59a1,1,0,0,0,.561.9A.984.984,0,0,0,16,60a1,1,0,0,0,.614-.211L34.343,46H57a6,6,0,0,0,6-6V10A6,6,0,0,0,57,4Z fill=#444444></path></g></svg></div></div></div><div class=classlist-detail-info><h5 class=name><span>{{ user.firstName }} {{ user.lastName }}</span> <span ng-if=\"isCurrentUser() && !integration\" ng-click=openEditName(user) class=profile-edit-pencil style=\"float: none; margin-right: -31px\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><path fill=#eb004e d=M8.1,3.5l-7.8,7.8C0.1,11.5,0,11.7,0,12v3c0,0.6,0.4,1,1,1h3c0.3,0,0.5-0.1,0.7-0.3l7.8-7.8L8.1,3.5z></path><path data-color=color-2 fill=#eb004e d=M15.7,3.3l-3-3c-0.4-0.4-1-0.4-1.4,0L9.5,2.1l4.4,4.4l1.8-1.8C16.1,4.3,16.1,3.7,15.7,3.3z></path></g></svg></span></h5><p ng-if=user.about class=invited-by-label><span ng-if=user.about.invitedByName>Invited by</span> <a ng-if=\"user.about.invitedById && user.about.invitedById != \'0\'\" href=\"#/classlist/details/{{ user.about.invitedById }}/contact\">{{ user.about.invitedByName }} </a><span ng-if=\"!user.about.invitedById || user.about.invitedById == \'0\'\">{{ user.about.invitedByName }}</span></p></div></div></div><div><div ng-if=user.groupList class=profile-section><div class=profile-section-separator></div><h2><span translate=SCHOOL_GROUPS></span></h2><div class=pupils-list><div class=\"vi-row pupil\" ng-repeat=\"p in user.groupList\"><div class=vi-col-left style=\"padding: 0; width: 50px\"><div class=\"group-school-logo group-comm\" style=\"width: 40px; height: 40px; background-image: url(\'{{p.avatar}}\'); background-color: white\"></div></div><div class=\"vi-col-middle identity identity-middle\"><strong>{{ p.title }}</strong></div></div></div></div></div><div><div class=profile-section><h2><span translate=ABOUT_ME_CONTACT></span> <span ng-if=isCurrentUser() ng-click=onAboutMePencin() class=profile-edit-pencil><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><path fill=#eb004e d=M8.1,3.5l-7.8,7.8C0.1,11.5,0,11.7,0,12v3c0,0.6,0.4,1,1,1h3c0.3,0,0.5-0.1,0.7-0.3l7.8-7.8L8.1,3.5z></path><path data-color=color-2 fill=#eb004e d=M15.7,3.3l-3-3c-0.4-0.4-1-0.4-1.4,0L9.5,2.1l4.4,4.4l1.8-1.8C16.1,4.3,16.1,3.7,15.7,3.3z></path></g></svg></span></h2><div style=\"margin-bottom: 10px\"><div class=address ng-if=\"displayInputText == false\"><span style=\"white-space: pre-wrap\" ng-if=\"user.details.aboutMe && user.details.aboutMe != \'\'\" ng-bind-html=user.details.aboutMe></span> <span ng-if=\"!user.details.aboutMe || user.details.aboutMe == \'\'\" translate=ABOUT_ME_DEFAULT></span></div><div class=\"row form-group\" ng-if=\"displayInputText == true\"><div class=col-md-12><div style=\"border: none\"><textarea ng-model=user.details.aboutMe class=form-control placeholder=\"{{ \'ABOUT_ME_PHOLDER\' | translate }}\" name=aboutMe ng-maxlength=499 maxlength=499 required></textarea></div><br><div style=\"overflow: auto\"><button type=button class=\"btn btn-primary btn-primary-pink\" ng-click=updateAboutMe()><span translate=SAVE_BTN></span></button></div></div></div></div></div><div class=profile-section><div class=profile-section-separator></div><h2><span translate=MY_LINKS></span></h2><div style=\"margin-bottom: 10px\"><div class=address><div ng-if=user.details.links style=\"width: 100%\" ng-repeat=\"linkItem in user.details.links track by $index\"><div ng-if=linkItem><a target=_blank class=profile-link href={{linkItem.href}}>{{linkItem.text}}</a> <svg ng-click=\"deleteLink(linkItem, $index)\" ng-if=isCurrentUser() class=profile-link xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><line fill=none stroke=#ff2828 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 x1=16 y1=8 x2=8 y2=16 stroke-linejoin=miter></line><line fill=none stroke=#ff2828 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 x1=16 y1=16 x2=8 y2=8 stroke-linejoin=miter></line></g></svg></div></div><span ng-if=\"!user.details.links || user.details.links.length == 0\" translate=ABOUT_ME_DEFAULT></span></div><br><a ng-if=isCurrentUser() class=add-another-link ng-click=openAddLink()><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=12px height=12px viewBox=\"0 0 12 12\" stroke-width=1><g stroke-width=1 transform=\"translate(0, 0)\"><circle cx=6 cy=6 r=5.5 fill=none stroke=#eb004e stroke-linecap=round stroke-linejoin=round stroke-width=1></circle><line x1=6 y1=3 x2=6 y2=9 fill=none stroke=#eb004e stroke-linecap=round stroke-linejoin=round data-color=color-2 stroke-width=1></line><line x1=3 y1=6 x2=9 y2=6 fill=none stroke=#eb004e stroke-linecap=round stroke-linejoin=round data-color=color-2 stroke-width=1></line></g></svg> <span translate=ADD_LINK>Add link</span></a></div></div></div><!-- Follow us on social media--><div class=profile-section><div class=profile-section-separator></div><h2><span translate=FOLLOW_US></span></h2><div style=\"margin-bottom: 10px\"><br><a href=https://www.fb.com/schoolclasslist/ target=_blank class=\"icon-button facebook\"><i class=icon-facebook><svg width=36px viewBox=\"0 0 512 512\"><path d=\"M211.9 197.4h-36.7v59.9h36.7V433.1h70.5V256.5h49.2l5.2-59.1h-54.4c0 0 0-22.1 0-33.7 0-13.9 2.8-19.5 16.3-19.5 10.9 0 38.2 0 38.2 0V82.9c0 0-40.2 0-48.8 0 -52.5 0-76.1 23.1-76.1 67.3C211.9 188.8 211.9 197.4 211.9 197.4z\"/></svg> </i><span></span></a> <a href=https://www.linkedin.com/company/schoolclasslist/ target=_blank class=\"icon-button linkedin\"><i class=icon-linkedin><svg width=36px viewBox=\"0 0 512 512\"><path d=\"M186.4 142.4c0 19-15.3 34.5-34.2 34.5 -18.9 0-34.2-15.4-34.2-34.5 0-19 15.3-34.5 34.2-34.5C171.1 107.9 186.4 123.4 186.4 142.4zM181.4 201.3h-57.8V388.1h57.8V201.3zM273.8 201.3h-55.4V388.1h55.4c0 0 0-69.3 0-98 0-26.3 12.1-41.9 35.2-41.9 21.3 0 31.5 15 31.5 41.9 0 26.9 0 98 0 98h57.5c0 0 0-68.2 0-118.3 0-50-28.3-74.2-68-74.2 -39.6 0-56.3 30.9-56.3 30.9v-25.2H273.8z\"/></svg> </i><span></span></a> <a href=https://www.instagram.com/classlist/ target=_blank class=\"icon-button instagram\"><i class=icon-instagram><svg width=36px viewBox=\"0 0 512 512\"><g><path d=\"M256 109.3c47.8 0 53.4 0.2 72.3 1 17.4 0.8 26.9 3.7 33.2 6.2 8.4 3.2 14.3 7.1 20.6 13.4 6.3 6.3 10.1 12.2 13.4 20.6 2.5 6.3 5.4 15.8 6.2 33.2 0.9 18.9 1 24.5 1 72.3s-0.2 53.4-1 72.3c-0.8 17.4-3.7 26.9-6.2 33.2 -3.2 8.4-7.1 14.3-13.4 20.6 -6.3 6.3-12.2 10.1-20.6 13.4 -6.3 2.5-15.8 5.4-33.2 6.2 -18.9 0.9-24.5 1-72.3 1s-53.4-0.2-72.3-1c-17.4-0.8-26.9-3.7-33.2-6.2 -8.4-3.2-14.3-7.1-20.6-13.4 -6.3-6.3-10.1-12.2-13.4-20.6 -2.5-6.3-5.4-15.8-6.2-33.2 -0.9-18.9-1-24.5-1-72.3s0.2-53.4 1-72.3c0.8-17.4 3.7-26.9 6.2-33.2 3.2-8.4 7.1-14.3 13.4-20.6 6.3-6.3 12.2-10.1 20.6-13.4 6.3-2.5 15.8-5.4 33.2-6.2C202.6 109.5 208.2 109.3 256 109.3M256 77.1c-48.6 0-54.7 0.2-73.8 1.1 -19 0.9-32.1 3.9-43.4 8.3 -11.8 4.6-21.7 10.7-31.7 20.6 -9.9 9.9-16.1 19.9-20.6 31.7 -4.4 11.4-7.4 24.4-8.3 43.4 -0.9 19.1-1.1 25.2-1.1 73.8 0 48.6 0.2 54.7 1.1 73.8 0.9 19 3.9 32.1 8.3 43.4 4.6 11.8 10.7 21.7 20.6 31.7 9.9 9.9 19.9 16.1 31.7 20.6 11.4 4.4 24.4 7.4 43.4 8.3 19.1 0.9 25.2 1.1 73.8 1.1s54.7-0.2 73.8-1.1c19-0.9 32.1-3.9 43.4-8.3 11.8-4.6 21.7-10.7 31.7-20.6 9.9-9.9 16.1-19.9 20.6-31.7 4.4-11.4 7.4-24.4 8.3-43.4 0.9-19.1 1.1-25.2 1.1-73.8s-0.2-54.7-1.1-73.8c-0.9-19-3.9-32.1-8.3-43.4 -4.6-11.8-10.7-21.7-20.6-31.7 -9.9-9.9-19.9-16.1-31.7-20.6 -11.4-4.4-24.4-7.4-43.4-8.3C310.7 77.3 304.6 77.1 256 77.1L256 77.1z\"/><path d=\"M256 164.1c-50.7 0-91.9 41.1-91.9 91.9s41.1 91.9 91.9 91.9 91.9-41.1 91.9-91.9S306.7 164.1 256 164.1zM256 315.6c-32.9 0-59.6-26.7-59.6-59.6s26.7-59.6 59.6-59.6 59.6 26.7 59.6 59.6S288.9 315.6 256 315.6z\"/><circle cx=351.5 cy=160.5 r=21.5 /></g></svg> </i><span></span></a></div></div><div ng-if=\"user.pupils || isCurrentUser()\" class=profile-section><div class=profile-section-separator></div><h2 ng-if=!isCurrentUser()><span translate=S_CHILDREN></span></h2><h2 ng-if=isCurrentUser() id=scroll_to_children><span translate=YOUR_CHILDREN></span></h2><div class=pupils><div class=pupils-list><div class=\"vi-row pupil\" ng-repeat=\"p in user.pupils\"><div class=vi-col-right style=\"width: 92px\"><span ng-if=\"isCurrentUser() && !integration\" ng-click=openAddPupil(p) class=profile-edit-pencil><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><path fill=#eb004e d=M8.1,3.5l-7.8,7.8C0.1,11.5,0,11.7,0,12v3c0,0.6,0.4,1,1,1h3c0.3,0,0.5-0.1,0.7-0.3l7.8-7.8L8.1,3.5z></path><path data-color=color-2 fill=#eb004e d=M15.7,3.3l-3-3c-0.4-0.4-1-0.4-1.4,0L9.5,2.1l4.4,4.4l1.8-1.8C16.1,4.3,16.1,3.7,15.7,3.3z></path></g></svg></span><div class=profile-pupil-birthmonth ng-if=\"p.monthId !== \'0\'\" ng-class=\"{\'female\':p.gender === \'Girl\',\'male\':p.gender === \'Boy\', \'notdefined\':p.gender === \'Prefer not to say\', \'nodata\':p.gender === \'No data\'}\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=3><g stroke-width=3 transform=\"translate(0.5, 0.5)\"><path d=M56,30V54a5,5,0,0,1-5,5H13a5,5,0,0,1-5-5V30 fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=3 stroke-linejoin=miter></path><rect x=2 y=14 width=60 height=10 fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=3 stroke-linejoin=miter></rect><path data-color=color-2 d=M14,8a6,6,0,0,1,6-6c8.875,0,12,12,12,12H20A6,6,0,0,1,14,8Z fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=3 stroke-linejoin=miter></path><path data-color=color-2 d=M50,8a6,6,0,0,0-6-6C35.125,2,32,14,32,14H44A6,6,0,0,0,50,8Z fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=3 stroke-linejoin=miter></path><polyline data-color=color-2 points=\"38 14 38 59 26 59 26 14\" fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=3 stroke-linejoin=miter></polyline></g></svg><div><span class=birth-month ng-if=\"p.monthId === \'2001\'\" translate=PUPIL_JAN_SHORT></span> <span class=birth-month ng-if=\"p.monthId === \'2002\'\" translate=PUPIL_FEB_SHORT></span> <span class=birth-month ng-if=\"p.monthId === \'2003\'\" translate=PUPIL_MAR_SHORT></span> <span class=birth-month ng-if=\"p.monthId === \'2004\'\" translate=PUPIL_APR_SHORT></span> <span class=birth-month ng-if=\"p.monthId === \'2005\'\" translate=PUPIL_MAY_SHORT></span> <span class=birth-month ng-if=\"p.monthId === \'2006\'\" translate=PUPIL_JUN_SHORT></span> <span class=birth-month ng-if=\"p.monthId === \'2007\'\" translate=PUPIL_JUL_SHORT></span> <span class=birth-month ng-if=\"p.monthId === \'2008\'\" translate=PUPIL_AUG_SHORT></span> <span class=birth-month ng-if=\"p.monthId === \'2009\'\" translate=PUPIL_SEP_SHORT></span> <span class=birth-month ng-if=\"p.monthId === \'2010\'\" translate=PUPIL_OCT_SHORT></span> <span class=birth-month ng-if=\"p.monthId === \'2011\'\" translate=PUPIL_NOV_SHORT></span> <span class=birth-month ng-if=\"p.monthId === \'2012\'\" translate=PUPIL_DEC_SHORT></span></div></div></div><div class=vi-col-left style=\"padding: 0; width: 50px\"><figure class=avatar ng-class=\"{\'female\':p.genderId == 3002,\'male\':p.genderId == 3001, \'notdefined\':p.genderId == 3004, \'nodata\':!p.genderId || p.genderId == 0}\"><img alt=\"\" ng-src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg width=28 ng-if=\"p.genderId == 3002\"> <img alt=\"\" ng-src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg width=28 ng-if=\"p.genderId == 3001\"> <img alt=\"\" ng-src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg width=28 ng-if=\"p.genderId == 3003\"> <img alt=\"\" ng-src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg width=28 ng-if=\"p.genderId == 3004\"> <img alt=\"\" ng-src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg width=28 ng-if=\"!p.genderId || p.genderId == 0\"></figure></div><div class=\"vi-col-middle identity\"><em class=em-relationship ng-class=\"{\'female\':p.gender === \'Girl\',\'male\':p.gender === \'Boy\', \'notdefined\':p.gender === \'Prefer not to say\',  \'nodata\':p.gender === \'No data\'}\">{{ getParentRelationship(p) }} </em><strong>{{ p.firstName }} {{ p.lastName }}</strong><br ng-if=!p.genderId><em>{{ p.secondTierName }} <span ng-if=p.secondTierName>-</span> {{p.firstTierName}}</em></div></div></div><a ng-if=\"isCurrentUser() && !integration\" class=add-another-link ng-click=openAddPupil()><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=12px height=12px viewBox=\"0 0 12 12\" stroke-width=1><g stroke-width=1 transform=\"translate(0, 0)\"><circle cx=6 cy=6 r=5.5 fill=none stroke=#eb004e stroke-linecap=round stroke-linejoin=round stroke-width=1></circle><line x1=6 y1=3 x2=6 y2=9 fill=none stroke=#eb004e stroke-linecap=round stroke-linejoin=round data-color=color-2 stroke-width=1></line><line x1=3 y1=6 x2=9 y2=6 fill=none stroke=#eb004e stroke-linecap=round stroke-linejoin=round data-color=color-2 stroke-width=1></line></g></svg> <span>Add another child</span></a></div></div><div class=profile-section-separator></div><div class=profile-section><h2 translate=FAMILY_CONTACT></h2><div ng-show=\"!user.familyMembers.invites && !user.familyMembers.parents\" class=family-member><h4 ng-if=!isCurrentUser()>{{user.firstName}} {{user.lastName}} {{\'CLIST_DETAILS_NO_FAMILYMEMBER\' | translate }}</h4><h4 ng-if=isCurrentUser() translate=ME_DETAILS_NO_FAMILYMEMBER></h4></div><div class=\"vi-row family-member\" ng-repeat=\"member in user.familyMembers.parents\" ng-show=\"user.familyMembers.parents.length > 0\"><div class=vi-col-right style=\"{{ !isCurrentUser() ? \'width: 88px;\' : \'width: 116px;\' }}\"><span ng-if=\"isCurrentUser() && !integration\" ng-click=removeFmilyMember(member.user) class=profile-remove-member><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=12px height=12px viewBox=\"0 0 12 12\"><g transform=\"translate(0, 0)\"><path d=M10.707,1.293a1,1,0,0,0-1.414,0L6,4.586,2.707,1.293A1,1,0,0,0,1.293,2.707L4.586,6,1.293,9.293a1,1,0,1,0,1.414,1.414L6,7.414l3.293,3.293a1,1,0,0,0,1.414-1.414L7.414,6l3.293-3.293A1,1,0,0,0,10.707,1.293Z fill=#444444></path></g></svg></span></div><div class=\"vi-col-left identity\" style=\"width: 50px\"><a href=\"#/classlist/details/{{ member.user }}/contact\"><figure><avatar source=\"{{ member.avatar }}\" name=\"{{ (member.firstName + \' \' + member.lastName) }}\" width=40 height=40 my=false></avatar></figure></a></div><div class=\"vi-col-middle identity identity-middle\" style=\"padding: 0\"><a href=\"#/classlist/details/{{ member.user }}/contact\">{{member.firstName }} {{member.lastName }}</a></div></div><div class=\"vi-row family-member\" ng-repeat=\"member in user.familyMembers.invites\" ng-show=\"user.familyMembers.invites.length > 0\"><div class=vi-col-right style=\"{{ !isCurrentUser() ? \'width: 88px;\' : \'width: 116px;\' }}\"><span ng-if=isCurrentUser() ng-click=openAddFamily(member) class=profile-edit-pencil><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><path fill=#eb004e d=M8.1,3.5l-7.8,7.8C0.1,11.5,0,11.7,0,12v3c0,0.6,0.4,1,1,1h3c0.3,0,0.5-0.1,0.7-0.3l7.8-7.8L8.1,3.5z></path><path data-color=color-2 fill=#eb004e d=M15.7,3.3l-3-3c-0.4-0.4-1-0.4-1.4,0L9.5,2.1l4.4,4.4l1.8-1.8C16.1,4.3,16.1,3.7,15.7,3.3z></path></g></svg></span><div class=family-member-buttons><div><a ng-show=\"os == \'Android\'\" ng-click=preLongPressCall(user.phoneNumber) class=\"profile-phone-icon {{ member.phoneNumber.length > 2 && isNumeric(member.phoneNumber) ? \'\' : \'disabled-icon\' }}\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><path fill=#444444 d=\"M15.285,12.305l-2.578-2.594c-0.39-0.393-1.025-0.393-1.416-0.002L9,12L4,7l2.294-2.294 c0.39-0.39,0.391-1.023,0.001-1.414l-2.58-2.584C3.324,0.317,2.691,0.317,2.3,0.708L0.004,3.003L0,3c0,7.18,5.82,13,13,13 l2.283-2.283C15.673,13.327,15.674,12.696,15.285,12.305z\"></path></g></svg> </a><a ng-show=\"os != \'Android\'\" ng-click=preLongPressCall(user.phoneNumber) class=\"profile-phone-icon {{ member.phoneNumber.length > 2 && isNumeric(member.phoneNumber) ? \'\' : \'disabled-icon\' }}\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><path fill=#444444 d=\"M15.285,12.305l-2.578-2.594c-0.39-0.393-1.025-0.393-1.416-0.002L9,12L4,7l2.294-2.294 c0.39-0.39,0.391-1.023,0.001-1.414l-2.58-2.584C3.324,0.317,2.691,0.317,2.3,0.708L0.004,3.003L0,3c0,7.18,5.82,13,13,13 l2.283-2.283C15.673,13.327,15.674,12.696,15.285,12.305z\"></path></g></svg></a></div><div><div class=\"profile-email-icon {{ user.relationshipId != \'0\' ? \'\' : \'disabled-icon\' }}\" style=\"margin-left: 8px\"><a href=\"mailto:{{ member.email }}\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\"><g transform=\"translate(0, 0)\"><path d=M42,5H6a5,5,0,0,0-5,5V38a5,5,0,0,0,5,5H42a5,5,0,0,0,5-5V10A5,5,0,0,0,42,5Zm-.338,6.75-17,15a1,1,0,0,1-1.324,0l-17-15a1,1,0,0,1,1.324-1.5L24,24.666,40.338,10.25a1,1,0,0,1,1.324,1.5Z fill=#444444></path></g></svg></a></div></div></div></div><div class=\"vi-col-left identity\" style=\"width: 50px\"><figure><avatar source=\"{{ member.avatar }}\" name=\"{{ (member.firstName + \' \' + member.lastName) }}\" width=40 height=40 my=false></avatar></figure></div><div class=\"vi-col-middle identity identity-middle\" style=\"padding: 0\"><strong>{{member.firstName }} {{member.lastName }}</strong></div></div><br><a ng-if=\"isCurrentUser() && !integration\" class=add-another-link ng-click=openAddFamily()><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=12px height=12px viewBox=\"0 0 12 12\" stroke-width=1><g stroke-width=1 transform=\"translate(0, 0)\"><circle cx=6 cy=6 r=5.5 fill=none stroke=#eb004e stroke-linecap=round stroke-linejoin=round stroke-width=1></circle><line x1=6 y1=3 x2=6 y2=9 fill=none stroke=#eb004e stroke-linecap=round stroke-linejoin=round data-color=color-2 stroke-width=1></line><line x1=3 y1=6 x2=9 y2=6 fill=none stroke=#eb004e stroke-linecap=round stroke-linejoin=round data-color=color-2 stroke-width=1></line></g></svg> <span ng-if=\"!user.familyMembers.invites && !user.familyMembers.parents\">Add a family contact</span> <span ng-if=\"user.familyMembers.invites || user.familyMembers.parents\">Add another contact</span></a></div><div ng-if=user.about class=profile-section><div class=profile-section-separator></div><h2><span translate=ABOUT_CONTACT></span> <span>{{ user.firstName }}</span></h2><div class=about-contact><p>Member since {{ user.about.memberSince | date:\'MMM yyyy\' }}</p><p ng-if=user.about.invitedParentCount>Invited {{ user.about.invitedParentCount }} <span ng-if=\"user.about && user.about.invitedParentCount == 1\">parent</span><span ng-if=\"user.about && (user.about.invitedParentCount > 1 || user.about.invitedParentCount == 0)\">parents</span></p></div></div><div class=profile-section><div class=profile-section-separator></div><h2><span translate=ADDRESS_CONTACT></span> <span ng-if=isCurrentUser() ng-click=openEditAddress(user) class=profile-edit-pencil><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><path fill=#eb004e d=M8.1,3.5l-7.8,7.8C0.1,11.5,0,11.7,0,12v3c0,0.6,0.4,1,1,1h3c0.3,0,0.5-0.1,0.7-0.3l7.8-7.8L8.1,3.5z></path><path data-color=color-2 fill=#eb004e d=M15.7,3.3l-3-3c-0.4-0.4-1-0.4-1.4,0L9.5,2.1l4.4,4.4l1.8-1.8C16.1,4.3,16.1,3.7,15.7,3.3z></path></g></svg></span></h2><div style=\"margin-bottom: 10px\"><div ng-if=user.address.postCode><p><span class=address-line ng-if=user.address.houseName>{{user.address.houseName}}</span> <span class=address-line ng-if=user.address.streetAddress>{{user.address.streetAddress}}<span>,</span> </span><span class=address-line ng-if=user.address.city>{{user.address.city}}<span>,</span> </span><span class=address-line ng-if=user.address.stateCounty>{{user.address.stateCounty}}<span>,</span> </span><span class=address-line ng-if=user.address.postCode>{{user.address.postCode}}<span>,</span> </span><span class=address-line ng-if=user.address.country>{{user.address.country}}</span></p><p ng-if=\"user.id === active_user.id\n							&& user.address.city.length > 0\n							&& user.address.city.indexOf(\'Update settings to share with your\') !== -1\"><span class=\"icon dripicons-location\"></span> <a href=/#/profile/privacy>{{user.address.city}}</a></p></div><div ng-if=!user.address.postCode class=address><span>Address not provided</span></div></div></div><div ng-show=\"user.lat \n					&& user.lng \n					&& user.lat != 0.0 \n					&& user.lng != 0.0\n					&& user.runSchoolShare\"><div class=\"map-mobile-border contacts-map\"><runmap config=mapConfig myname=myname class=contacts-runmap></runmap></div><div ng-if=\"!isCurrentUser() && getNearestHundred(user.location.distance)\" class=parent-distance-label><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\"><g transform=\"translate(0, 0)\"><path d=M20,46a1,1,0,0,1-.707-.293C18.627,45.042,3,29.285,3,18A16.836,16.836,0,0,1,20,1,16.836,16.836,0,0,1,37,18c0,11.285-15.627,27.042-16.293,27.707A1,1,0,0,1,20,46Z fill=#eb004e></path><circle cx=20 cy=18 r=6 fill=#fff></circle></g></svg> <span>{{ user.firstName }} lives about {{ getNearestHundred(user.location.distance) }} away</span></div></div><!-- <div ng-if=\"isEnabled && user.runSchoolShare\" style=\"padding-left: 12px; padding-top: 20px;\">\n				<a href=\"#/profile/privacy\">Opt out for the Parent Map</a>\n			</div> --><div><div ng-show=\"isCurrentUser() && !user.runSchoolShare\" class=profile-section><div class=profile-section-separator></div><h2><span translate=OPTIN_CONTACT></span></h2></div><div ng-show=\"isCurrentUser() && !user.runSchoolShare\"><span class=runmap-notoped-label><span translate=RUNMAP_ME_NOTOPTEDIN_1></span> <a ng-click=openEditAddress(user)>add your address</a> <span translate=RUNMAP_ME_NOTOPTEDIN_2></span></span></div><div ng-show=\"!isCurrentUser() && !user.runSchoolShare\"><span class=runmap-notoped-label translate=RUNMAP_YOU_NOTOPTEDIN translate-values=\"{ parentName: user.firstName }\"></span></div></div></section></article>");
$templateCache.put("app/classlist/views/edit-name-modal.html","<div><div class=modal-header><h3 translate=EDIT_NAME_HEADER></h3></div><div class=modal-body><div class=\"row form-group\"><div class=\"col-md-6 col-sm-6 col-xs-6\"><div class=form-group><input class=form-control type=text name=firstName placeholder=\"{{\'FIRSTNAME_PHOLDER\' | translate }}\" ng-model=firstName ng-maxlength=regexes.max.name maxlength={{::regexes.max.name}} remove-chars=nameField required><div class=error-text-red ng-show=\"(!firstName || firstName.length == 0) && isClicked >= 1\"><p translate=ERR_PUPIL_FIRSTNAME></p></div><div class=error-text-red ng-show=\"(firstName.length > 0 && firstName.length < regexes.min.name) && isClicked >= 1\"><p translate=ERR_PUPIL_FIRSTNAME_SHORT></p></div></div></div><div class=\"col-md-6 col-sm-6 col-xs-6\"><div class=form-group><input class=form-control type=text name=lastName placeholder=\"{{\'LASTNAME_PHOLDER\' | translate }}\" ng-model=lastName ng-maxlength=regexes.max.name maxlength={{::regexes.max.name}} remove-chars=nameField required><div class=error-text-red ng-show=\"(!lastName || lastName.length == 0) && isClicked >= 1\"><p translate=ERR_PUPIL_LASTNAME></p></div><div class=error-text-red ng-show=\"(lastName.length > 0 && lastName.length < regexes.min.name) && isClicked >= 1\"><p translate=ERR_PUPIL_LASTNAME_SHORT></p></div></div></div></div></div><div class=modal-footer><a ng-click=close() type=button class=\"btn btn-default\" translate=CANCEL_BTN></a> <a ng-click=save(); ng-disabled=saving type=button class=\"btn btn-primary\" translate=SAVE_BTN></a></div></div>");
$templateCache.put("app/classlist/views/link-modal.html","<div class=assign-parent-admin ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 ng-if=!link.title translate=NEW_LINK_TITLE></h3><h3 ng-if=link.title translate=EDIT_LINK_TITLE></h3></div><div class=modal-body><form novalidate name=aa><div class=form-group><div class=row><div class=col-md-12><input type=text placeholder=\"{{\'LINK_NAME_PHOLDER\' | translate}}\" class=form-control ng-model=link.text required></div></div></div><div class=form-group><div class=row><div class=col-md-12><input type=text placeholder=\"{{\'LINK_URL_PHOLDER\' | translate}}\" class=form-control ng-model=link.href required></div></div></div></form></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=confirm() ng-disabled=\"!link.text || !link.href\"><span translate=SAVE_BTN></span></button></div></div>");
$templateCache.put("app/classlist/views/map.html","<article><section class=page-view-header><div style=\"padding-left: 0\"><div><div class=classlist-page-header><div><div class=switch-tabs><div class=sw-tabs-back><div class=is-relative><svg ng-click=back() id=header-back-button class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg></div></div><div class=sw-tabs-select><div class=is-relative><select class=form-control ng-model=filter.class ng-change=beforeFilterByClass(false) ng-options=\"f.id as f.name for f in mapConfig.filters\"></select><span class=\"dripicons-chevron-down select-arrow\"></span></div></div><div class=sw-tabs-switch><button ng-click=gotoInvite() class=\"btn btn-primary pull-right btn-primary-pink plus-button btn-primary-subheader\"><svg style=\"float: left; margin-top: 3px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=25px height=25px viewBox=\"0 0 48 48\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><line fill=none stroke=#ffffff stroke-width=4 stroke-linecap=round stroke-miterlimit=10 x1=24 y1=14 x2=24 y2=34 stroke-linejoin=round></line><line fill=none stroke=#ffffff stroke-width=4 stroke-linecap=round stroke-miterlimit=10 x1=34 y1=24 x2=14 y2=24 stroke-linejoin=round></line></g></svg> <span style=\"margin-top: 0px; float: left\">Invite</span></button></div></div></div></div></div></div></section><section class=page-container-header-from-top style=\"margin-top: 0!important\"><div ng-if=isEnabled class=page-view-subheader style=\"margin-bottom: 0; padding: 0 15px\"><div class=search-tabs><div><span ng-click=openSearchContacts() class=contacts-search-label><div class=search-label><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 64 64\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><line data-cap=butt data-color=color-2 fill=none stroke=#627293 stroke-width=4 stroke-miterlimit=10 x1=60 y1=60 x2=43 y2=43 stroke-linejoin=miter stroke-linecap=butt></line><circle fill=none stroke=#627293 stroke-width=4 stroke-linecap=square stroke-miterlimit=10 cx=26 cy=26 r=24 stroke-linejoin=miter></circle></g></svg> <span>Search for parent or child</span></div></span></div><div><div><div class=contacts-tabs><div class=active ng-click=gotoContactsMap()><svg class=location-svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\"><g transform=\"translate(0, 0)\"><path fill=#444444 d=\"M24,1C15.644,1,7,7.359,7,18c0,11.285,15.627,27.042,16.293,27.707C23.48,45.895,23.735,46,24,46 s0.52-0.105,0.707-0.293C25.373,45.042,41,29.285,41,18C41,7.359,32.356,1,24,1z M24,24c-3.309,0-6-2.691-6-6s2.691-6,6-6 s6,2.691,6,6S27.309,24,24,24z\"></path></g></svg></div><div ng-click=gotoContactsList()><svg class=contacts-svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><path fill=#444444 d=M6,0H1C0.4,0,0,0.4,0,1v5c0,0.6,0.4,1,1,1h5c0.6,0,1-0.4,1-1V1C7,0.4,6.6,0,6,0z></path><path fill=#444444 d=M15,0h-5C9.4,0,9,0.4,9,1v5c0,0.6,0.4,1,1,1h5c0.6,0,1-0.4,1-1V1C16,0.4,15.6,0,15,0z></path><path fill=#444444 d=M6,9H1c-0.6,0-1,0.4-1,1v5c0,0.6,0.4,1,1,1h5c0.6,0,1-0.4,1-1v-5C7,9.4,6.6,9,6,9z></path><path fill=#444444 d=M15,9h-5c-0.6,0-1,0.4-1,1v5c0,0.6,0.4,1,1,1h5c0.6,0,1-0.4,1-1v-5C16,9.4,15.6,9,15,9z></path></g></svg></div></div></div></div></div></div><div class=contacts-map-container><div ng-show=\"mapready && isEnabled\" class=\"map-mobile-border contacts-map\"><runmap config=mapConfig myname=myname class=contacts-runmap></runmap></div><form ng-if=!isEnabled name=bd><div class=page-container-header-from-top><div style=\"padding: 0 20px; padding-top: 20px\"><div><div translate=PRIVACY_OPTIN_HEADER></div><legend translate=PRIVACY_OPTIN_SUBHEADER class=\"col-md-12 address-title\"></legend><div><legend translate=PRIVACY_OPTIN_SUBHEADER1 class=\"col-md-12 address-title\"></legend><div class=form-group><div><input type=text class=\"form-control address-form\" name=houseName autocomplete=off ng-model=myUser.address.houseName placeholder=\"{{\'HOUSENAME_PHOLDER\' | translate }}\" ng-maxlength=regexes.max.address maxlength={{regexes.max.address}}></div></div><div class=form-group><div><input type=text class=\"form-control address-form\" autocomplete=off name=streetName ng-model=myUser.address.streetAddress placeholder=\"{{\'STREETNAME_PHOLDER\' | translate }}\" ng-maxlength=regexes.max.address maxlength={{regexes.max.address}}><div class=error-text-red ng-show=\"(!myUser.address.streetAddress || myUser.address.streetAddress.length === 0) && isOptInClicked\"><p translate=ERR_RUNMAP_STREET></p></div></div></div><div class=\"row form-group\"><div class=\"col-md-6 col-sm-6 col-xs-6\"><input type=text class=\"form-control address-form\" autocomplete=off name=city ng-model=myUser.address.city placeholder=\"{{\'CITY_PHOLDER\' | translate }}\" ng-maxlength=regexes.max.address maxlength={{regexes.max.address}}><div class=error-text-red ng-show=\"(!myUser.address.city || myUser.address.city.length === 0) && isOptInClicked\"><p translate=ERR_RUNMAP_CITY></p></div></div><div class=\"col-md-6 col-sm-6 col-xs-6\"><input type=text class=\"form-control address-form\" autocomplete=off name=state ng-model=myUser.address.stateCounty placeholder=\"{{\'STATE_PHOLDER\' | translate }}\" ng-maxlength=regexes.max.address maxlength={{regexes.max.address}}></div></div><div class=\"row form-group\"><div class=\"col-md-6 col-sm-6 col-xs-6\"><input type=text class=\"form-control address-form\" autocomplete=off name=postCode ng-model=myUser.address.postCode placeholder=\"{{\'POSTCODE_PHOLDER\' | translate }}\" remove-chars=address ng-maxlength=regexes.max.postcode maxlength={{regexes.max.postcode}}><div class=error-text-red ng-show=\"(!myUser.address.postCode || myUser.address.postCode.length === 0)  && isOptInClicked\"><p translate=ERR_RUNMAP_POSTCODE></p></div></div><div class=\"col-md-6 col-sm-6 col-xs-6\"><div class=\"is-relative address-form\"><countries class=address-label ng-model=myUser.address.countryId is-required=true></countries><label class=select-placeholder translate=COUNTRY_PHOLDER ng-hide=\"myUser.address.countryId.length > 0\"></label><span class=\"dripicons-chevron-down select-arrow\"></span></div></div></div></div><div class=form-group><div class=address-checkbox-div><p><span class=address-checkbox><input type=checkbox class=checkbox ng-model=myUser.runSchoolShare></span><span class=address-text translate=PRIVACY_OPTIN_CHECK></span></p><p><span class=address-text translate=PRIVACY_OPTIN_CHECK_1></span></p><div class=error-text-red ng-show=\"!myUser.runSchoolShare  && isOptInClicked\"><p translate=ERR_RUNMAP_TERMS></p></div></div></div><div class=buttons><div style=\"height: 130px\"><button type=button ng-disabled=viewState.updating class=\"btn btn-primary pull-left btn-primary-pink\" ng-click=update()><span translate=SAVE_BTN></span></button></div></div></div></div></div></form></div><div ng-if=isEnabled><div class=\"row hidden-sm hidden-xs jumbotron\"><div class=col-md-4><h3 translate=SCHOOLRUNMAP_GOGREEN></h3></div><div class=col-md-2></div><div class=col-md-6><h4 translate=SCHOOLRUNMAP_SAVESTIME_H></h4><p translate=SCHOOLRUNMAP_SAVESTIME_P></p><h4 translate=SCHOOLRUNMAP_SAFE_H></h4><p translate=SCHOOLRUNMAP_SAFE_P></p></div></div></div></section></article>");
$templateCache.put("app/classlist/views/mute-parent-modal.html","<div ng-class=\"{\'not-ready\':mutingAccount}\"><div class=modal-header><h3 translate=MUTE_PARENT_HEADER translate-values=\"{ name: fullName }\"></h3></div><div class=modal-body><p><span translate=MUTE_PARENT_TEXT_1 translate-values=\"{ name: parentName }\"></span> <a target=_blank href=https://help.classlist.com/hc/en-us/articles/115001911085 translate=MUTE_PARENT_TEXT_2></a> <span translate=MUTE_PARENT_TEXT_3></span></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=MUTE_BTN_MODAL ng-click=confirm()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/classlist/views/no-pupil-modal.html","<div class=no-pupils-modal><div class=modal-header><h3 translate=EMPTY_CLASSLIST_TEXT_1></h3></div><div class=modal-body><p translate=EMPTY_CLASSLIST_TEXT_2></p></div><div class=modal-footer><a ng-click=close() type=button class=\"btn btn-default\" translate=LATER_BTN></a> <a href=#/profile type=button class=\"btn btn-primary\" translate=EMPTY_CLASSLIST_TEXT_3></a></div></div>");
$templateCache.put("app/classlist/views/opt-in-modal.html","<div><div class=modal-header><h3 translate=PRIVACY_OPTIN_HEADER></h3></div><div class=modal-body><div><legend translate=PRIVACY_OPTIN_SUBHEADER class=\"col-md-12 address-title\"></legend><div class=form-group><div class=address-checkbox-div><p><span class=address-checkbox><input type=checkbox class=checkbox ng-model=runSchoolShare></span><span class=address-text translate=PRIVACY_OPTIN_CHECK></span></p><p><span class=address-text translate=PRIVACY_OPTIN_CHECK_1></span></p><div class=error-text-red ng-show=\"runSchoolShare  && isOptInClicked\"><p translate=ERR_RUNMAP_TERMS></p></div></div></div></div></div><div class=modal-footer><a ng-click=close() type=button class=\"btn btn-default\" translate=CANCEL_BTN></a> <a ng-click=save() type=button class=\"btn btn-primary\" translate=SAVE_BTN></a></div></div>");
$templateCache.put("app/classlist/views/partial.contact.html","<div class=address><h4 translate=CLIST_DETAILS_CONTACT class=\"hidden-xs hidden-sm\" ng-if=\"user.email || user.phoneNumber || user.address.country \"></h4><p ng-if=\"user.email && user.email.indexOf(\'@\') > -1\"><span class=\"icon dripicons-mail\"></span> {{::user.email}}</p><p ng-if=\"user.id === active_user.id && user.email && user.email.indexOf(\'@\') === -1\"><span class=\"icon dripicons-mail\"></span> <a href=/#/profile/privacy>{{::user.email}}</a></p><p ng-if=\"user.phoneNumber.length > 2 && isNumeric(user.phoneNumber)\"><span class=\"icon dripicons-phone\"></span> <a ng-show=\"os == \'Android\'\" ng-click=longPressCall(user.phoneNumber) style=\"line-height: 26px\" class=long-press-call-mobile><span>Press to call</span> </a><a ng-show=\"os != \'Android\'\" ng-click=longPressCall(user.phoneNumber) style=\"line-height: 26px\" class=long-press-call-mobile><span>Long press to call</span> </a><span style=\"line-height: 26px\" class=long-press-call-desktop>{{ user.phoneNumber }}</span></p><p ng-if=\"user.phoneNumber.length > 2 && user.id === active_user.id && !isNumeric(user.phoneNumber)\"><span class=\"icon dripicons-phone\"></span> <a href=/#/profile/privacy>{{::user.phoneNumber}}</a></p><p ng-if=\"user.address.houseName.length > 0\n	&& user.address.streetAddress.length > 0\n	&& user.address.city.length > 0\n	&& user.address.postCode.length > 0\n	|| user.address.country.length > 0\"><span class=\"icon dripicons-location\"></span> <span class=address-line ng-if=user.address.houseName>{{::user.address.houseName}}</span> <span class=address-line ng-if=user.address.streetAddress>{{::user.address.streetAddress}}<br></span><span class=address-line ng-if=user.address.city>{{::user.address.city}}<br></span><span class=address-line ng-if=user.address.stateCounty>{{::user.address.stateCounty}}<br></span><span class=address-line ng-if=user.address.postCode>{{::user.address.postCode}}<br></span><span class=address-line ng-if=user.address.country>{{::user.address.country}}</span></p><p ng-if=\"user.id === active_user.id\n		&& user.address.city.length > 0\n		&& user.address.city.indexOf(\'Update settings to share with your\') !== -1\"><span class=\"icon dripicons-location\"></span> <a href=/#/profile/privacy>{{::user.address.city}}<a></a></p><a ng-if=\"user.address.streetAddress && user.address.postCode\" translate=GET_DIRECTIONS href=\"http://maps.google.com/?q={{ user.address.houseName + \' \' + user.address.streetAddress + \' \' + user.address.city + \' \' + user.address.postCode + \' \' + user.address.country}}\" target=_blank style=\"white-space: nowrap\"></a><p></p></div>");
$templateCache.put("app/classlist/views/partial.family.html","<div><div ng-show=!user.familyMembers.length class=family-member><h4 translate=CLIST_DETAILS_FAMILY><h4>{{user.firstName}} {{user.lastName}} {{\'CLIST_DETAILS_NO_FAMILYMEMBER\' | translate }}</h4></div><h4 translate=CLIST_DETAILS_FAMILY class=\"hidden-xs hidden-sm\" ng-show=\"user.familyMembers.length > 0\">{{user.familyMembers.length}}</h4><div class=family-member ng-repeat=\"member in user.familyMembers\" ng-show=\"user.familyMembers.length > 0\"><div class=identity><figure class=avatar ng-class=\"{\'female\':p.gender === \'Girl\',\'male\':p.gender === \'Boy\'}\"><span class=dripicons-heart></span></figure><strong>{{::member.firstName }} {{::member.lastName }}</strong> <em>{{ relationToPupils(member.relationshipId) }} of <span class=pupil ng-repeat=\"p in user.pupils\">{{ p.firstName }}</span></em></div><p ng-show=\"member.email.length > 0\"><span class=\"icon dripicons-mail\"></span> {{::member.email}}</p><p ng-show=\"member.phoneNumber.length > 0\"><span class=\"icon dripicons-phone\"></span> <a class=long-press-call-mobile ng-click=longPressCall(member.phoneNumber)>+{{ ::member.phoneNumber }}</a><span class=long-press-call-desktop>+{{ ::member.phoneNumber }}</span></p></div></div>");
$templateCache.put("app/classlist/views/partial.pupils.html","<div class=pupils><h4 translate=CLIST_DETAILS_PUPILS class=\"hidden-xs hidden-sm\" ng-show=\"user.pupils.length > 0\"></h4><div class=pupils-list><div class=pupil ng-repeat=\"p in user.pupils\"><figure class=avatar ng-class=\"{\'female\':p.genderId == 3002,\'male\':p.genderId == 3001, \'nonbinary\':p.genderId == 3003, \'notdefined\':p.genderId == 3004, \'nodata\':!p.genderId || p.genderId == 0}\"><img alt=\"\" src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg width=28 ng-if=\"p.gender == 3002\"> <img alt=\"\" src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg width=28 ng-if=\"p.gender == 3001\"> <img alt=\"\" ng-src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg width=28 ng-if=\"p.genderId == 3003\"> <img alt=\"\" ng-src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg width=28 ng-if=\"p.genderId == 3004\"> <img alt=\"\" ng-src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg width=28 ng-if=\"!p.genderId || p.genderId == 0\"></figure><div class=identity><strong>{{ p.firstName }} {{ p.lastName }}</strong><br ng-if=!p.genderId><em ng-if=\"p.genderId !== \'0\'\"><span>{{ relationToPupils(user.relationshipId, p.genderId) }}</span> </em><em>{{ p.secondTierName }} <span ng-if=p.secondTierName>-</span> {{p.firstTierName}}</em> <em ng-if=\"p.monthId !== \'0\'\"><figure class=\"emblem icon-birthday-cake\" ui-sref=classlist.all href=#/classlist/all><span class=\"dripicons-birthday-cake icon-birthday-cake\" width=18 height=20></span></figure><div><span class=birth-month ng-if=\"p.monthId === \'2001\'\" translate=PUPIL_JAN></span> <span class=birth-month ng-if=\"p.monthId === \'2002\'\" translate=PUPIL_FEB></span> <span class=birth-month ng-if=\"p.monthId === \'2003\'\" translate=PUPIL_MAR></span> <span class=birth-month ng-if=\"p.monthId === \'2004\'\" translate=PUPIL_APR></span> <span class=birth-month ng-if=\"p.monthId === \'2005\'\" translate=PUPIL_MAY></span> <span class=birth-month ng-if=\"p.monthId === \'2006\'\" translate=PUPIL_JUN></span> <span class=birth-month ng-if=\"p.monthId === \'2007\'\" translate=PUPIL_JUL></span> <span class=birth-month ng-if=\"p.monthId === \'2008\'\" translate=PUPIL_AUG></span> <span class=birth-month ng-if=\"p.monthId === \'2009\'\" translate=PUPIL_SEP></span> <span class=birth-month ng-if=\"p.monthId === \'2010\'\" translate=PUPIL_OCT></span> <span class=birth-month ng-if=\"p.monthId === \'2011\'\" translate=PUPIL_NOV></span> <span class=birth-month ng-if=\"p.monthId === \'2012\'\" translate=PUPIL_DEC></span></div></em></div></div></div></div>");
$templateCache.put("app/classlist/views/report-parent-modal.html","<div class=assign-parent-admin ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=REPORT_PARENT_DIALOG_TITLE translate-values={name:parentName}></h3></div><div class=modal-body><p translate=REPORT_PARENT_DIALOG_TEXT></p></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=report()><span translate=REPORT_BTN></span></button></div></div>");
$templateCache.put("app/classlist/views/wrapper.html","<div class=content-logged><div ui-view autoscroll=false style=\"padding: 0!important\"></div></div>");
$templateCache.put("app/composer/views/composer-mobile-categories.html","<div class=composer-post-mobile><div class=\"page-view-header clearfix composer-post-mobile_header {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div style=\"padding: 0\"><div class=premium-ad-clear style=\"padding: 0 15px\"><div premium-ad></div></div><div style=\"padding-right: 15px\"><div style=\"position: relative\"><svg id=header-back-button ng-click=cancel() class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg><div class=page-view-header__text style=\"padding-left: 35px\"><strong class=page-view-header__title translate=PICK_A_CATEGORY></strong> <button id=post-button-id class=\"btn btn-primary btn-primary-pink pull-right mobile-post-button\" translate=NEXT_BTN ng-disabled=!post.category ng-click=gotoPost()></button></div></div></div></div></div><div class=mobile-post-holder><button is-selected=\"{{post.category === c}}\" id={{c}} ng-repeat=\"c in categories\" ng-click=selectCategory(c) ng-class=\"{\'category-item category-item_{{c}} {{c}}-selected\': post.category === c, \'category-item category-item_{{c}}\':post.category !== c}\"><div class=\"circle-icon category-color_{{c}}\"><span ng-class=\"{\'dripicons-web\': c === \'general\', \'dripicons-preview\': c === \'wanted\', \'dripicons-star\': c === \'recommend\', \'dripicons-trophy\': c === \'free\', \'dripicons-suitcase\': c === \'jobs\', \'dripicons-flashlight\': c === \'lost_found\', \'dripicons-tag\': c === \'for_sale\', \'dripicons-tag\': c === \'offer\'}\"></div><span class=category-name translate=\"POST_CAT_{{c | uppercase}}\"></span></button></div><div style=\"padding: 0 17px; font-size: 14px; color: #888\"><span ng-if=\"post.category == \'general\'\" translate=POST_CAT_DESCR_1></span> <span ng-if=\"post.category == \'lost_found\'\" translate=POST_CAT_DESCR_2></span> <span ng-if=\"post.category == \'offer\'\" translate=POST_CAT_DESCR_3></span> <span ng-if=\"post.category == \'wanted\'\" translate=POST_CAT_DESCR_4></span></div><div style=\"padding: 0 17px; font-size: 13px\"><a target=_blank style=\"line-height: 40px\" href=https://help.classlist.com/hc/en-us/articles/213259029-The-Marketplace-Rules-and-Guidelines>Community guidelines</a></div></div>");
$templateCache.put("app/composer/views/composer-mobile-post.html","<div class=composer-post-mobile><div class=\"page-view-header clearfix composer-post-mobile_header\" style=\"margin-bottom: 0\"><div style=\"padding: 0\"><div><div style=\"position: relative\"><div class=\"vi-row page-view-header__text\" style=\"padding-left: 0\"><div class=vi-col-left><svg id=header-back-button ng-click=back() class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg></div><div class=vi-col-right style=\"width: 90px\"><div class=\"action-button pull-right\" style=\"margin-top: 7px; margin-right: 7px\"><!-- FIXME 30-jul-19 We have to make this better using classes and use same classes or design on every page --> <button class=\"btn btn-primary pull-right btn-primary-pink plus-button btn-primary-subheader\" ng-disabled=\"(isBodyAllSpace && (!post.previewLink || post.previewLink == \'\') && (!post.attachments || post.attachments.length == 0)) || !viewState.isReady\" ng-click=postPost()><span style=\"margin-top: 0px; float: left; margin: 0; padding: 0 10px\" translate=POST_BTN></span></button><!-- END --></div></div><div class=vi-col-middle><strong class=page-view-header__title style=\"padding: 0px 65px; padding-right: 0; padding-top: 4px\"><div class=\"is-relative post-group-select\"><div class=composer-group-title>{{selectedGroup.name}}</div><select class=\"form-control group-select-form\" ng-model=post.groupId ng-change=selectGroup() ng-options=\"f.id as (f.name + \' (\' + f.memberCount + \')\') for f in groups\"></select><div ng-if=\"selectedGroup.name && selectedGroup.name != \'\'\" style=\"margin-top: 2px\" class=change-group-header>Change group</div></div></strong></div></div></div></div></div></div><div><div><div class=post-padding style=\"padding: 0\"><div style=\"background: #fff\"><div class=text-container><mentionsuggestor draftbody={{draftPost.body}} postid=0 commentbody=getPostBody(bodyWithTags) autoresize-textarea class=\"form-control post-title-text post-title-text_share post-mobile-area mention-container\" style=\"margin-bottom: 0; color: #000; border-bottom: none!important; position: relative\" placeholder=\"Write something to this group here\" type=post></mentionsuggestor><div class=title-input style=\"border-top: none!important; font-size: 13px; font-weight: 500; text-align: right; color: #91969d; padding-bottom: 10px; padding-top: 0\">{{ (bodyWithoutEntities ? ((1500-bodyWithoutEntities.length) > 0 ? (1500-bodyWithoutEntities.length) : 0) : 1500) }}/1500</div><div ng-show=\"post && bodyWithoutEntities.length > regexes.max.postBody\" class=error-text-stripe><span class=error-text-stripe_text translate=ERR_POST_CHAR_LIMIT translate-values=\"{actual:bodyWithoutEntities.length, max: regexes.max.postBody}\"></span></div></div></div><div ng-if=hasPrice class=post-mobile-price-area><div class=price-container><div><div ng-if=showPrice class=pull-left><a class=\"pull-left icon-link price-link\" ng-click=removePrice()><span class=\"dripicons-minus icon\" style=\"float: left\"></span> <span class=link translate=POST_REMOVE_PRICE style=\"line-height: 28px\"></span></a></div><div ng-if=!showPrice class=pull-left><a class=\"pull-left icon-link price-link\" ng-click=addPrice()><span class=\"dripicons-plus icon\" style=\"float: left\"></span> <span class=link translate=POST_ADD_PRICE style=\"line-height: 28px\"></span></a></div><div class=pull-left style=\"margin-left: 30px\"><a class=\"pull-left icon-link price-link\" ng-click=freePrice()><span class=\"dripicons-plus icon\" style=\"float: left\"></span> <span class=link translate=POST_CAT_FREE style=\"line-height: 28px; margin-left: 7px!important\"></span></a></div></div><div ng-if=showPrice><input focus=true type=text class=\"price form-control\" ng-model=post.price ng-maxlength={{regexes.max.postPrice}} maxlength=15 placeholder=\"{{ \'POST_ENTER_PRICE\' | translate}}\"></div></div></div><div class=post-links style=\"padding: 0 16px; margin-bottom: 10px; margin-top: 5px; cursor: pointer\"><span class=\"icon-link photo-icon\" ng-if=\"!post.attachments || (post.attachments && post.attachments.length < 1000)\" style=\"margin-left: 5px\"><span ng-class=\"{\'disable\': post.previewLink && post.previewLink.length > 2}\" ng-click=uploadImage() style=\"float: left\"><svg style=\"width: 22px; height: 36px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><path fill=#005cb8 d=\"M58,13h-8.546l-6.701-7.659C42.562,5.125,42.288,5,42,5H28c-0.288,0-0.562,0.125-0.753,0.341L20.546,13H6 c-2.757,0-5,2.243-5,5v36c0,2.757,2.243,5,5,5h52c2.757,0,5-2.243,5-5V18C63,15.243,60.757,13,58,13z M13,26c-1.103,0-2-0.897-2-2 s0.897-2,2-2s2,0.897,2,2S14.103,26,13,26z M35,50c-7.732,0-14-6.268-14-14s6.268-14,14-14s14,6.268,14,14S42.732,50,35,50z\"></path></g></svg> </span><span ng-click=uploadAttachment() ng-class=\"{\'disable\': post.previewLink && post.previewLink.length > 2}\" style=\"float: left; margin-left: 20px\"><svg style=\"width: 22px; height: 36px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><path fill=none stroke=#005cb8 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M27.8,16.5l-9.9,9.9 c-3.1,3.1-8.2,3.1-11.3,0l0,0c-3.1-3.1-3.1-8.2,0-11.3L16.8,4.9c2.1-2.1,5.6-2.1,7.8,0l0,0c2.1,2.1,2.1,5.6,0,7.8l-9.5,9.5 c-1.2,1.2-3.1,1.2-4.2,0l0,0c-1.2-1.2-1.2-3.1,0-4.2L20,8.7\" stroke-linejoin=miter></path></g></svg> </span><a style=\"float: right; font-size: 13px; line-height: 38px\" href=https://help.classlist.com/hc/en-us/articles/211584605-Community-Guidelines-rules-for-users target=_blank>Community guidelines</a></span></div></div><div class=post-files-list><div ng-if=\"post.files && post.files.length > 0\"><div ng-repeat=\"att in post.files track by $index\"><span style=\"color: #4a9fef\">{{ att.name }}</span> <span ng-click=removeFile($index) class=delete-pic-button><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><polygon fill=#ffffff points=\"44,17.171 32,29.171 20,17.171 17.171,20 29.171,32 17.171,44 20,46.829 32,34.829 44,46.829 46.829,44 34.829,32 46.829,20 \"></polygon></g></svg></span></div></div></div><div ng-show=\"post && !post.attachments && post.previewLink && post.previewLink !== \'\'\"><span ng-click=deleteLinkPreview() class=\"dripicons-cross icon remove-link-preview-buttom\"></span><linkpreview url={{firstLinkInPostBody}} on-success=onPreviewSuccess(url)></linkpreview></div><div style=\"overflow: auto\"><div ng-repeat=\"att in post.attachments track by $index\" class=post-img-preview ng-if=att.url style=\"margin-bottom: 3px;text-align: center\"><img alt=\"\" id=post-previewer ng-src=\"{{ att.url }}\"> <span class=delete-button-wrap ng-click=removePhoto($index)><span class=delete-pic-button><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><polygon fill=#ffffff points=\"44,17.171 32,29.171 20,17.171 17.171,20 29.171,32 17.171,44 20,46.829 32,34.829 44,46.829 46.829,44 34.829,32 46.829,20 \"></polygon></g></svg> </span></span><span class=edit-button-wrap><span class=edit-button ng-click=editPhoto($index)><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><path fill=#ffffff d=M21,18V3c0-0.552-0.448-1-1-1h-4c-0.552,0-1,0.448-1,1v15H21z></path><path fill=#ffffff d=M43,46h6V16c0-0.552-0.448-1-1-1H3c-0.552,0-1,0.448-1,1v4c0,0.552,0.448,1,1,1h40V46z></path><path fill=#ffffff d=M43,51v10c0,0.552,0.448,1,1,1h4c0.552,0,1-0.448,1-1V51H43z></path><path fill=#ffffff d=M61,43H21V23h-6v25c0,0.552,0.448,1,1,1h45c0.552,0,1-0.448,1-1v-4C62,43.448,61.552,43,61,43z></path><path data-color=color-2 fill=#ffffff d=\"M51,14c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l10-10 c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-10,10C51.512,13.902,51.256,14,51,14z\"></path><path data-color=color-2 fill=#ffffff d=\"M24,41c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l16-16 c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-16,16C24.512,40.902,24.256,41,24,41z\"></path></g></svg> <span>Edit</span></span></span></div></div></div></div></div>");
$templateCache.put("app/composer/views/draft-will-be-discarded-modal.html","<div style=\"padding: 15px\"><div class=modal-body><p>Previous draft will be discarded for group {{draftGroupName}}</p></div><div class=modal-footer style=\"text-align: right\"><button type=button class=\"btn btn-default\" ng-click=discard() style=\"margin-bottom: 10px\">Discard</button><br><button type=button class=\"btn btn-default\" ng-click=continue() style=\"margin-bottom: 10px\">Change group</button></div></div>");
$templateCache.put("app/composer/views/marketplace-admin-modal.html","<div style=\"padding: 15px\"><div class=modal-header><h3 translate=ADMIN_POST_WHOLE_SCHOOL_TITLE></h3></div><div class=modal-body><p translate=ADMIN_POST_WHOLE_SCHOOL_DESCR></p></div><div class=modal-footer style=\"text-align: right\"><button type=button class=\"btn btn-default\" translate=ADMIN_POST_WHOLE_SCHOOL_BUTTON_2 ng-click=confirm() style=\"margin-bottom: 10px\"></button><br><button type=button class=\"btn btn-default\" translate=ADMIN_POST_WHOLE_SCHOOL_BUTTON_1 ng-click=close() style=\"margin-bottom: 10px\"></button></div></div>");
$templateCache.put("app/composer/views/max-upload-files-modal.html","<div style=\"padding: 15px\"><div class=modal-body><p>You can upload up to 20 pictures</p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=GOTIT_BTN ng-click=close()></div></div>");
$templateCache.put("app/composer/views/wrapper.html","<div class=content-logged><div autoscroll=false></div>");
$templateCache.put("app/composer/views/wrappermobile.html","<div class=content-logged><div><div ui-view></div></div></div>");
$templateCache.put("app/composer_mkp/views/charitable-info-modal.html","<div style=\"padding: 15px\"><div class=modal-header><h3 translate=LISTING_CHARITABLE></h3></div><div class=modal-body><p translate=LISTING_CHARITABLE_INFO_1></p><p translate=LISTING_CHARITABLE_INFO_2></p><p translate=LISTING_CHARITABLE_INFO_3></p><p translate=LISTING_CHARITABLE_INFO_4></p><p translate=LISTING_CHARITABLE_INFO_5></p></div><div class=modal-footer style=\"text-align: right\"><button type=button class=\"btn btn-primary\" translate=OK_BTN ng-click=close() style=\"margin-bottom: 10px\"></button></div></div>");
$templateCache.put("app/composer_mkp/views/composer-mobile-categories.html","<div class=composer-post-mobile><div class=\"page-view-header clearfix composer-post-mobile_header {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div style=\"padding: 0\"><div class=premium-ad-clear style=\"padding: 0 15px\"><div premium-ad></div></div><div style=\"padding-right: 15px\"><div style=\"position: relative\"><svg id=header-back-button ng-click=cancel() class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg><div class=page-view-header__text style=\"padding-left: 35px\"><strong class=page-view-header__title translate=PICK_A_CATEGORY></strong> <button id=post-button-id class=\"btn btn-primary btn-primary-pink pull-right mobile-post-button\" translate=NEXT_BTN ng-disabled=!post.category ng-click=gotoPost()></button></div></div></div></div></div><div class=mobile-post-holder><button is-selected=\"{{post.category === c}}\" id={{c}} ng-repeat=\"c in categories\" ng-click=selectCategory(c) ng-class=\"{\'category-item category-item_{{c}} {{c}}-selected\': post.category === c, \'category-item category-item_{{c}}\':post.category !== c}\"><div class=\"circle-icon category-color_{{c}}\"><span ng-class=\"{\'dripicons-web\': c === \'general\', \'dripicons-preview\': c === \'wanted\', \'dripicons-star\': c === \'recommend\', \'dripicons-trophy\': c === \'free\', \'dripicons-suitcase\': c === \'jobs\', \'dripicons-flashlight\': c === \'lost_found\', \'dripicons-tag\': c === \'for_sale\', \'dripicons-tag\': c === \'offer\'}\"></div><span class=category-name translate=\"POST_CAT_{{c | uppercase}}\"></span></button></div><div style=\"padding: 0 17px; font-size: 14px; color: #888\"><span ng-if=\"post.category == \'general\'\" translate=POST_CAT_DESCR_1></span> <span ng-if=\"post.category == \'lost_found\'\" translate=POST_CAT_DESCR_2></span> <span ng-if=\"post.category == \'offer\'\" translate=POST_CAT_DESCR_3></span> <span ng-if=\"post.category == \'wanted\'\" translate=POST_CAT_DESCR_4></span></div><div style=\"padding: 0 17px; font-size: 13px\"><a target=_blank style=\"line-height: 40px\" href=https://help.classlist.com/hc/en-us/articles/213259029-The-Marketplace-Rules-and-Guidelines>Community guidelines</a></div></div>");
$templateCache.put("app/composer_mkp/views/composer-mobile-post.html","<div class=\"composer-post-mobile marketplace-post-mobile\"><div class=\"page-view-header clearfix composer-post-mobile_header {{ premium_ad ? \'premium-ad-header\' : \'\' }}\" style=\"margin-bottom: 0\"><div style=\"padding: 0\"><div class=premium-ad-clear style=\"padding: 0 15px\"><div premium-ad></div></div><div><div style=\"position: relative\"><svg id=header-back-button ng-click=back() class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg><div class=page-view-header__text style=\"padding-left: 0\"><strong ng-show=\"post.type == \'FOR_SALE\' || post.type == \'FREE\'\" class=page-view-header__title translate=HEADER_SELL_OFFER></strong> <strong ng-show=\"post.type != \'FOR_SALE\' && post.type != \'FREE\'\" class=page-view-header__title translate=LIST_SOMETHING></strong></div></div></div></div></div><div><div class=post-padding style=\"padding: 0\"><div ng-if=\"post.type == \'WANTED\' || post.type == \'LOST\'\" class=\"post-mobile-price-area post-mobile-sell-free\"><div translate=SELECT_TYPE style=\"color: #6d7279; font-size: 16px; padding: 15px 15px; padding-bottom: 0\"></div><div class=price-container style=\"padding-bottom: 0\"><div class=butt-sell-free><div><a ng-disabled=editing ng-click=\"selectType(\'WANTED\')\" class=\"btn {{ post.type == \'WANTED\' ? \'btn-primary\' : \'btn-ghost\' }}\" translate=POST_CAT_WANTED></a></div><div><a ng-disabled=editing ng-click=\"selectType(\'LOST\')\" class=\"btn {{ post.type == \'LOST\' ? \'btn-primary\' : \'btn-ghost\' }}\" translate=LOST></a></div><!--\n						<div>\n							<a ng-click=\"selectType(\'free\')\" class=\"btn {{ post.type == \'free\' ? \'btn-primary\' : \'btn-ghost\' }}\" translate=\"OFFER\">\n								\n							</a>\n						</div>\n						<div>\n							<a ng-click=\"selectType(\'general\')\" class=\"btn {{ post.type == \'general\' ? \'btn-primary\' : \'btn-ghost\' }}\" translate=\"POST_CAT_GENERAL\">\n								\n							</a>\n						</div>\n						--></div></div></div><div><div ng-if=\"post.attachments && post.attachments.length > 0\" style=\"overflow: auto; padding-bottom: 4px\" class=post-mobile-price-area><div ng-repeat=\"att in post.attachments track by $index\" class=\"post-img-preview marketplace-img-preview\" ng-if=att.imageUrl style=\"text-align: center;  \n					background-image: url({{ att.imageUrl }})\"><span class=delete-button-wrap ng-click=removePhoto($index)><span class=delete-pic-button><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><polygon fill=#ffffff points=\"44,17.171 32,29.171 20,17.171 17.171,20 29.171,32 17.171,44 20,46.829 32,34.829 44,46.829 46.829,44 34.829,32 46.829,20 \"></polygon></g></svg> </span></span><!--\n						<span class=\"edit-button-wrap\">\n							<span class=\"edit-button\" ng-click=\"editPhoto($index)\">\n								<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"64px\" height=\"64px\" viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><path fill=\"#ffffff\" d=\"M21,18V3c0-0.552-0.448-1-1-1h-4c-0.552,0-1,0.448-1,1v15H21z\"></path> <path fill=\"#ffffff\" d=\"M43,46h6V16c0-0.552-0.448-1-1-1H3c-0.552,0-1,0.448-1,1v4c0,0.552,0.448,1,1,1h40V46z\"></path> <path fill=\"#ffffff\" d=\"M43,51v10c0,0.552,0.448,1,1,1h4c0.552,0,1-0.448,1-1V51H43z\"></path> <path fill=\"#ffffff\" d=\"M61,43H21V23h-6v25c0,0.552,0.448,1,1,1h45c0.552,0,1-0.448,1-1v-4C62,43.448,61.552,43,61,43z\"></path> <path data-color=\"color-2\" fill=\"#ffffff\" d=\"M51,14c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l10-10 c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-10,10C51.512,13.902,51.256,14,51,14z\"></path> <path data-color=\"color-2\" fill=\"#ffffff\" d=\"M24,41c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l16-16 c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-16,16C24.512,40.902,24.256,41,24,41z\"></path></g></svg>\n								<span>\n									Edit\n								</span>\n							</span>\n						</span>\n						--></div></div></div><div style=\"background: #fff; margin-top: -4px\"><div ng-if=\"(!post.attachments || post.attachments.length == 0) && (post.type == \'FOR_SALE\' || post.type == \'FREE\')\" class=post-mobile-price-area style=\"text-align: center; border-bottom: none!important\"><div class=add-first-picture ng-click=uploadImage()><div><svg style=\"width: 40px; height: 40px; margin-top: 20px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=100px height=100px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><path fill=#eb004e d=\"M58,13h-8.546l-6.701-7.659C42.562,5.125,42.288,5,42,5H28c-0.288,0-0.562,0.125-0.753,0.341L20.546,13H6 c-2.757,0-5,2.243-5,5v36c0,2.757,2.243,5,5,5h52c2.757,0,5-2.243,5-5V18C63,15.243,60.757,13,58,13z M13,26c-1.103,0-2-0.897-2-2 s0.897-2,2-2s2,0.897,2,2S14.103,26,13,26z M35,50c-7.732,0-14-6.268-14-14s6.268-14,14-14s14,6.268,14,14S42.732,50,35,50z\"></path></g></svg></div><div translate=POST_PHOTO style=\"color: #eb004e; font-size: 14px; margin-top: 5px\"></div></div></div><div class=post-mobile-price-area><div ng-if=\"((!post.attachments || (post.attachments && post.attachments.length < 1000)) && post.attachments && post.attachments.length > 0) || post.type != \'FOR_SALE\' && post.type != \'FREE\'\" class=post-links style=\"padding: 0 16px; margin-top: 0; cursor: pointer; border-top: 1px solid #D8D8D8 !important; padding-top: 5px\"><span class=\"icon-link photo-icon\" style=\"margin-left: 5px\"><span style=\"float: left\"><span ng-click=uploadImage() style=\"float: left\"><svg style=\"width: 22px; height: 36px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><path fill=#eb004e d=\"M58,13h-8.546l-6.701-7.659C42.562,5.125,42.288,5,42,5H28c-0.288,0-0.562,0.125-0.753,0.341L20.546,13H6 c-2.757,0-5,2.243-5,5v36c0,2.757,2.243,5,5,5h52c2.757,0,5-2.243,5-5V18C63,15.243,60.757,13,58,13z M13,26c-1.103,0-2-0.897-2-2 s0.897-2,2-2s2,0.897,2,2S14.103,26,13,26z M35,50c-7.732,0-14-6.268-14-14s6.268-14,14-14s14,6.268,14,14S42.732,50,35,50z\"></path></g></svg> </span><span ng-click=uploadImage() class=link translate=POST_PHOTO style=\"color: #eb004e; line-height: 36px; font-size: 13px; margin-left: 4px\"></span></span></span></div></div><div class=\"text-container title-input\" style=\"border-top: none!important; padding-bottom: 10px\"><input focus=true ng-model=post.title class=\"form-control post-title-text\" maxlength=65 placeholder=\"Add a title here\" style=\"margin-bottom: 0; color: #000; border-top: none!important; height: auto\"><div style=\"border-top: none!important; font-size: 13px; font-weight: 500; text-align: right; color: #91969d\">{{ (post.title ? (65-post.title.length) : 65) }}/65</div></div><div class=text-container><textarea ng-model=post.body maxlength=800 autoresize-textarea class=\"form-control post-title-text post-title-text_share post-mobile-area\" placeholder=\"Describe your listing here\" style=\"margin-bottom: 0; color: #000; border-bottom: none!important\"></textarea><div class=title-input style=\"border-top: none!important; font-size: 13px; font-weight: 500; text-align: right; color: #91969d; padding-bottom: 10px; padding-top: 0\">{{ (post.body ? ((800-post.body.length) > 0 ? (800-post.body.length) : 0) : 800) }}/800</div><div ng-show=\"post && post.body.length > regexes.max.postBody\" class=error-text-stripe><span class=error-text-stripe_text translate=ERR_POST_CHAR_LIMIT translate-values=\"{actual:post.body.length, max: regexes.max.postBody}\"></span></div></div><div class=\"text-container title-input\" style=\"border-top: none!important; padding-bottom: 10px\"><select class=form-control style=\"border: none; appearance: auto\" ng-model=category ng-options=\"c.name as c.value for c in marketplaceCategories\"></select></div></div><div ng-if=\"post.type != \'WANTED\' && post.type != \'LOST\'\" class=\"post-mobile-price-area post-mobile-sell-free\"><div class=price-container style=\"padding-bottom: 0\"><div class=butt-sell-free><div><a ng-disabled=editing ng-click=onSell() class=\"btn {{ post.type == \'FOR_SALE\' && post.enabledOffer ? \'btn-primary\' : \'btn-ghost\' }}\" translate=SELL_THIS_ITEM></a></div><div><a ng-disabled=editing ng-click=onOffer() class=\"btn {{ post.type == \'FREE\' && post.enabledOffer ? \'btn-default\' : \'btn-ghost\' }}\" translate=OFFER_THIS_ITEM></a></div></div></div></div><div ng-if=\"post.type == \'FOR_SALE\' && post.enabledOffer\" class=post-mobile-price-area><div class=price-container><div style=\"overflow: auto\"><div class=\"is-relative currency-select\" style=\"margin-top: 1px\"><select ng-model=post.currency class=form-control required ng-init=\"post.currency = school.defaultCurrency\"><option ng-repeat=\"option in availableCurrencies\" value={{option.id}}>{{option.id}} ({{option.asciiSymbol}})</option></select><span class=\"dripicons-chevron-down select-arrow\"></span></div><div style=\"float: left; margin-left: 20px\"><div class=price-block><div><input type=text formatprice=number class=\"price form-control\" ng-model=post.price ng-maxlength={{regexes.max.postPrice}} maxlength=8 placeholder=\"{{ \'POST_ENTER_PRICE\' | translate}}\"></div></div></div></div></div><div class=\"text-container title-input\" style=\"border: none !important; border-top: 1px solid #b6c2db !important; padding-bottom: 10px !important\"><span class=address-checkbox><input name=charitable id=charitable type=checkbox class=checkbox ng-model=post.charitable></span><label for=charitable class=address-text translate=LISTING_CHARITABLE></label><span ng-click=charitableInfo() class=\"icon dripicons-information\"></span></div></div><div ng-if=\"editing && !post.onlinePayment\"><div class=post-mobile-price-area><div style=\"text-align: center\"><button id=post-button-id class=\"btn btn-primary btn-primary-pink mobile-post-button\" ng-disabled=\"!viewState.isReady || post.body.length > regexes.max.postBody || !post.type\" ng-click=postPost() style=\"position: relative; width: 100%; max-width: 200px; margin-top: 0; margin-bottom: 15px; margin-top: 15px\"><span ng-show=\"post.type == \'FOR_SALE\' || post.type == \'FREE\'\" translate=LIST_THIS_ITEM></span> <span ng-show=\"post.type != \'FOR_SALE\' && post.type != \'FREE\'\" translate=CREATE_THIS_LISTING></span></button></div><div ng-show=\"post.type == \'FOR_SALE\'\" class=price-container style=\"padding-top: 0\"><div translate=MKP_STRIPE_TERMS></div></div></div></div><div ng-if=\"(editing && post.onlinePayment) || !editing\"><div ng-if=\"(post.type == \'FOR_SALE\' && post.enabledOffer) \n					|| (post.type == \'FREE\' && post.enabledOffer) \n					|| (post.type != \'FOR_SALE\')\"><div class=post-mobile-price-area><br><div class=price-container><div translate=MKP_STRIPE_TERMS></div></div><div style=\"text-align: center\"><button id=post-button-id class=\"btn btn-primary btn-primary-pink mobile-post-button\" ng-disabled=\"!viewState.isReady || post.body.length > regexes.max.postBody || !post.type\" ng-click=postPost(true) style=\"position: relative; width: 100%; max-width: 200px; margin-top: 0; margin-bottom: 15px; margin-top: 15px\"><span ng-show=\"post.type == \'FOR_SALE\' || post.type == \'FREE\'\" translate=LIST_THIS_ITEM></span> <span ng-show=\"post.type != \'FOR_SALE\' && post.type != \'FREE\'\" translate=CREATE_THIS_LISTING></span></button></div></div></div></div></div></div></div>");
$templateCache.put("app/composer_mkp/views/marketplace-admin-modal.html","<div style=\"padding: 15px\"><div class=modal-header><h3 translate=ADMIN_POST_WHOLE_SCHOOL_TITLE></h3></div><div class=modal-body><p translate=ADMIN_POST_WHOLE_SCHOOL_DESCR></p></div><div class=modal-footer style=\"text-align: right\"><button type=button class=\"btn btn-default\" translate=ADMIN_POST_WHOLE_SCHOOL_BUTTON_2 ng-click=confirm() style=\"margin-bottom: 10px\"></button><br><button type=button class=\"btn btn-default\" translate=ADMIN_POST_WHOLE_SCHOOL_BUTTON_1 ng-click=close() style=\"margin-bottom: 10px\"></button></div></div>");
$templateCache.put("app/composer_mkp/views/marketplace-modal.html","<div style=\"padding: 15px\"><div class=modal-header><h3 translate=POST_WHOLE_SCHOOL_TITLE></h3></div><div class=modal-body><p translate=POST_WHOLE_SCHOOL_DESCR></p></div><div class=modal-footer style=\"text-align: right\"><button type=button class=\"btn btn-default\" translate=POST_WHOLE_SCHOOL_BUTTON_2 ng-click=confirm() style=\"margin-bottom: 10px\"></button><br><button type=button class=\"btn btn-default\" translate=POST_WHOLE_SCHOOL_BUTTON_1 ng-click=ask() style=\"margin-bottom: 10px\"></button><br><button type=button class=\"btn btn-default\" translate=CANCEL_BTN ng-click=close() style=\"margin-bottom: 10px\"></button></div></div>");
$templateCache.put("app/composer_mkp/views/max-upload-files-modal.html","<div style=\"padding: 15px\"><div class=modal-body><p>You can upload up to 20 pictures</p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=GOTIT_BTN ng-click=close()></div></div>");
$templateCache.put("app/composer_mkp/views/posted-modal.html","<div style=\"padding: 15px\"><div class=\"modal-body congrats-modal\"><div><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><path data-cap=butt d=M13,33,24,2s7-.182,7,8V25H55a5.618,5.618,0,0,1,5.727,5.364,5.4,5.4,0,0,1-1.312,3.511,5.418,5.418,0,0,1-.986,9.8,5.432,5.432,0,0,1-3.06,8.285A4.084,4.084,0,0,1,52.545,59H31a39.551,39.551,0,0,1-18-4 fill=none stroke=#005cb8 stroke-miterlimit=10 stroke-width=2 stroke-linecap=butt stroke-linejoin=miter></path><rect data-color=color-2 x=2 y=28 width=11 height=30 rx=3 ry=3 fill=none stroke=#005cb8 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></rect></g></svg></div><h4 translate=CONGRATULATIONS></h4><p translate=ITEM_LISTED></p></div><div class=modal-footer style=\"text-align: center\"><button type=button class=\"btn btn-primary classlist-item-message btn-primary-pink\" ng-click=close()><span translate=OK_GOTIT></span></button></div></div>");
$templateCache.put("app/composer_mkp/views/wrapper.html","<div class=content-logged><div autoscroll=false></div>");
$templateCache.put("app/composer_mkp/views/wrappermobile.html","<div class=content-logged><div><div ui-view></div></div></div>");
$templateCache.put("app/events/views/before-create-modal.html","<div style=\"padding: 15px\"><div class=modal-header><h3 translate=BEFORE_CREATE_TITLE></h3></div><div class=modal-body style=\"padding-top: 0px\"><ul class=event-desc-list><li ng-if=\"active_school.admin && active_school.approved\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><line data-color=color-2 fill=none stroke=#8a94a2 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 x1=10 y1=1 x2=10 y2=3 stroke-linejoin=miter></line><line data-color=color-2 fill=none stroke=#8a94a2 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 x1=5 y1=2 x2=5 y2=4 stroke-linejoin=miter></line><line data-color=color-2 fill=none stroke=#8a94a2 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 x1=15 y1=2 x2=15 y2=4 stroke-linejoin=miter></line><path data-cap=butt fill=none stroke=#8a94a2 stroke-width=2 stroke-miterlimit=10 d=M19,8h4v4c0,1.1-0.9,2-2,2h-2.5 stroke-linejoin=miter stroke-linecap=butt></path><path fill=none stroke=#8a94a2 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M10,20L10,20c-5,0-9-4-9-9 V8h18v3C19,16,15,20,10,20z\" stroke-linejoin=miter></path><line fill=none stroke=#8a94a2 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 x1=1 y1=23 x2=19 y2=23 stroke-linejoin=miter></line></g></svg> <a id=switch-option ng-click=switchRef()>Community event</a><p>Class, year, school wide event, volunteer sign up, guest checkout</p></li><li><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><path data-color=color-2 fill=none stroke=#8a94a2 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M12,8 c1.104,0,2-0.896,2-2s-2-4-2-4s-2,2.896-2,4S10.896,8,12,8z\" stroke-linejoin=miter></path><rect x=1 y=15 fill=none stroke=#8a94a2 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 width=22 height=8 stroke-linejoin=miter></rect><path fill=none stroke=#8a94a2 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M23,15c0,2.209-1.791,4-4,4 c-1.518,0-2.822-0.855-3.5-2.101C14.822,18.145,13.518,19,12,19s-2.822-0.855-3.5-2.101C7.822,18.145,6.518,19,5,19 c-2.209,0-4-1.791-4-4\" stroke-linejoin=miter></path><polyline fill=none stroke=#8a94a2 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 points=\"20,15 20,11 4,11 4,15 \" stroke-linejoin=miter></polyline></g></svg> <a id=second-option ng-click=close()>Birthday parties</a><p>Invite whole class or any child at school. Private to guests</p></li><li><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><line data-cap=butt data-color=color-2 fill=none stroke=#8a94a2 stroke-width=2 stroke-miterlimit=10 x1=4 y1=7 x2=20 y2=7 stroke-linejoin=miter stroke-linecap=butt></line><path fill=none stroke=#8a94a2 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M12,15L12,15 c-4.4,0-8-3.6-8-8V1h16v6C20,11.4,16.4,15,12,15z\" stroke-linejoin=miter></path><line fill=none stroke=#8a94a2 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 x1=12 y1=15 x2=12 y2=23 stroke-linejoin=miter></line><line fill=none stroke=#8a94a2 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 x1=7 y1=23 x2=17 y2=23 stroke-linejoin=miter></line></g></svg> <a id=third-option ng-click=close()>Private Gathering</a><p>Playdates, individual invitations</p></li><li><svg style=\"margin-top: 3px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><polyline data-color=color-2 points=\"9 15 11 17 16 12\" fill=none stroke=#8a94a2 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></polyline><rect x=1 y=3 width=22 height=19 rx=2 ry=2 fill=none stroke=#8a94a2 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></rect><line x1=6 y1=1 x2=6 y2=4 fill=none stroke=#8a94a2 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></line><line x1=18 y1=1 x2=18 y2=4 fill=none stroke=#8a94a2 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></line><line x1=1 y1=8 x2=23 y2=8 fill=none stroke=#8a94a2 stroke-miterlimit=10 stroke-width=2></line></g></svg> <a id=forth-option ng-click=close()>Any other type of event</a></li></ul></div></div>");
$templateCache.put("app/events/views/before-create-not-admin.html","<div><div class=modal-header><h3>Community event</h3></div><div class=modal-body>To set up a community event you need admin status.</div><div class=modal-footer><button type=button class=\"btn btn-primary btn-primary-pink pull-right\" translate=REQUEST_ADMIN_ACCESS ng-click=continue()></button> <button type=button class=\"btn btn-default pull-right\" translate=NOT_NOW ng-click=close()></div></div>");
$templateCache.put("app/events/views/before-invite-modal.html","<div style=\"padding: 15px\"><div class=modal-header><h3 translate=LET_GUESTS_KNOW_MORE_HEADER></h3></div><div class=modal-body><p translate=LET_GUESTS_KNOW_MORE_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-default pull-right\" translate=GOTIT_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/before-ticketing-modal.html","<div style=\"padding: 15px\"><div class=modal-header><h3 translate=BEFORE_TICKETING_HEADER></h3></div><div class=modal-body><p translate=BEFORE_TICKETING_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-ghost pull-right\" translate=GOTIT_BTN ng-click=gotit()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/buy-tickets-modal.html","<div class=event-buytickets-modal style=\"padding: 15px\"><div class=modal-header><h3 ng-show=\"ticketList.paidEventType && ticketList.paidEventType != \'FREE\'\" translate=BUY_TICKETS_HEADER translate-values=\"{ \'eventName\': event.title }\"></h3><h3 ng-show=\"ticketList.paidEventType && ticketList.paidEventType == \'FREE\'\" translate=GET_TICKETS_HEADER translate-values=\"{ \'eventName\': event.title }\"></h3></div><div class=modal-body><div class=tickets-list-modal ng-show=ticketList><div class=\"row header\"><div class=\"col-md-6 col-xs-12 col-sm-12\"><span translate=TYPE></span></div><div class=\"col-md-2 col-xs-4 col-sm-4\"><span translate=PRICE></span></div><div class=\"col-md-2 col-xs-4 col-sm-4\"><span translate=QUANTITY></span></div><div class=\"col-md-2 col-xs-4 col-sm-4 align-right\"><span translate=TOTAL></span></div></div><div class=row ng-repeat=\"ticket in ticketList.tickets\"><div class=\"col-md-6 col-xs-12 col-sm-12\"><span>{{ ticket.ticketName }}</span></div><div class=\"col-md-2 col-xs-4 col-sm-4\"><span ng-show=ticketList.ticketCurrency translate=\"{{ ticketList.ticketCurrency }}_SHORT\"></span><span>{{ ticket.ticketPrice | currency: \"\" }}</span></div><div class=\"col-md-2 col-xs-4 col-sm-4\"><div class=is-relative><select ng-model=ticket.quantity class=form-control ng-disabled=\"ticket.availableTicket == 0\"><option ng-if=\"ticket.availableTicket == 0\" translate=SOLD_OUT></option><option ng-repeat=\"i in getNumber(ticket.availableTicket + 1) track by $index\" value=\"{{ $index }}\">{{ $index }}</option></select><span class=\"dripicons-chevron-down select-arrow\" style=\"right: -2px\"></span></div></div><div class=\"col-md-2 col-xs-4 col-sm-4 align-right\"><span ng-if=\"(ticket.quantity * ticket.ticketPrice) && ticketList.ticketCurrency\" translate=\"{{ ticketList.ticketCurrency }}_SHORT\"></span><span>{{ (ticket.quantity * ticket.ticketPrice) | currency: \"\" }}</span></div></div><div class=\"row total-label\"><div class=align-right><span ng-show=ticketList.ticketCurrency translate=\"{{ ticketList.ticketCurrency }}_SHORT\"></span><span>{{ getTotalTickets(ticketList.tickets) | currency: \"\" }}</span></div></div></div></div><div ng-show=\"ticketList.paidEventType && ticketList.paidEventType != \'FREE\'\" class=align-right style=\"padding-right: 15px; font-size: 13px\"><span translate=PAYPAL_CREDIT_CARD></span></div><div class=modal-footer><span ng-show=\"ticketList.paidEventType && ticketList.paidEventType != \'FREE\'\" class=pull-right><button type=button class=\"btn btn-primary btn-paypal\" ng-click=save() ng-disabled=buingTickets></button> </span><span ng-show=\"ticketList.paidEventType && ticketList.paidEventType == \'FREE\'\" class=pull-right><button type=button class=\"btn btn-primary btn-primary-pink\" ng-click=save() ng-disabled=buingTickets translate=GET_TICKETS></button> </span><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></button></div></div>");
$templateCache.put("app/events/views/buy-tickets.html","<section class=event-tickets ng-class=\"{\'is-visible\': viewState.isReady }\"><div class=\"page-view-header clearfix {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div><div premium-ad></div><div><div class=row><div class=col-md-12 style=\"position: relative\"><svg id=header-back-button ui-sref=\"events.view({\'id\': id_event})\" class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg></div></div></div></div></div><div class=\"body-container page-container-header-from-top\"><div><div class=tickets-header-circles><div class=step-circle style=\"float: left\"><svg style=\"transform: rotate(90deg)\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=26px height=26px viewBox=\"0 0 48 48\" stroke-width=3><g stroke-width=3 transform=\"translate(0.5, 0.5)\"><path d=M40,24a6.018,6.018,0,0,1,6-6V8H2V18A6,6,0,0,1,2,30V40H46V30A6.018,6.018,0,0,1,40,24Z fill=none stroke=#3677d9 stroke-linecap=square stroke-miterlimit=10 stroke-width=3 stroke-linejoin=miter></path><rect data-color=color-2 x=15 y=18 width=18 height=12 fill=none stroke=#3677d9 stroke-linecap=square stroke-miterlimit=10 stroke-width=3 stroke-linejoin=miter></rect></g></svg></div><div class=step-circle style=\"float: right\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=26px height=26px viewBox=\"0 0 64 64\" stroke-width=3><g stroke-width=3 transform=\"translate(0.5, 0.5)\"><polyline data-color=color-2 fill=none stroke=#8a94a2 stroke-width=3 stroke-linecap=square stroke-miterlimit=10 points=\" 25,35 30,40 40,30 \" stroke-linejoin=miter></polyline><polyline fill=none stroke=#8a94a2 stroke-width=3 stroke-linecap=square stroke-miterlimit=10 points=\"49,11 57,11 57,62 7,62 7,11 15,11 \" stroke-linejoin=miter></polyline><path fill=none stroke=#8a94a2 stroke-width=3 stroke-linecap=square stroke-miterlimit=10 d=\"M39,9c0-3.866-3.134-7-7-7 s-7,3.134-7,7h-5v8h24V9H39z\" stroke-linejoin=miter></path><circle data-stroke=none fill=#8a94a2 cx=32 cy=9 r=2 stroke-linejoin=miter stroke-linecap=square></circle><polyline data-color=color-2 fill=none stroke=#8a94a2 stroke-width=3 stroke-linecap=square stroke-miterlimit=10 points=\" 51,17 51,56 13,56 13,17 \" stroke-linejoin=miter></polyline></g></svg></div><div class=dash-separator></div><div style=\"margin-top: 32px; font-size: 10px; font-weight: 600; color: #8a94a2\"><span style=\"float: left; margin-left: -18px; color: #3677d9\">Select tickets</span> <span style=\"float: right; margin-right: -38px\">Confirmation & Notes</span></div></div></div><h1 ng-show=\"ticketList.paidEventType && ticketList.paidEventType != \'FREE\'\" translate=BUY_TICKETS_HEADER translate-values=\"{ \'eventName\': event.title }\" style=\"margin-bottom: 10px; font-size: 18px; color: #3677d9; font-weight: 600\"></h1><h1 ng-show=\"ticketList.paidEventType && ticketList.paidEventType == \'FREE\'\" translate=GET_TICKETS_HEADER translate-values=\"{ \'eventName\': event.title }\" style=\"margin-bottom: 10px; font-size: 18px; color: #3677d9; font-weight: 600\"></h1><div class=pick-tickets-section ng-show=ticketList><div ng-repeat=\"ticket in ticketList.tickets\"><!-- Free ticket type START --><div class=pick-tickets-item ng-if=\"ticket.ticketType === \'FREE\'\"><div style=\"font-weight: 600; padding-bottom: 2px; margin-bottom: 10px; border-bottom: 1px solid #8a94a2\">{{ ticket.ticketName }}</div><div class=pick-tickets-cols><div style=\"width: 37%\"><div style=\"color: #8a94a2; font-weight: 600; font-size: 13px; margin-bottom: 4px\"><span translate=PRICE></span></div><div><strong style=\"font-size: 15px; line-height: 38px\"><span>FREE</span></strong></div></div><div style=\"width: 26%\"><div style=\"color: #8a94a2; font-weight: 600; font-size: 13px; margin-bottom: 8px\"><span translate=QUANTITY></span></div><div ng-if=\"ticket.availableTicket > 0\" style=\"border: 1px solid #8a94a2; padding: 0; border-radius: 8px; margin-bottom: 10px\"><div class=is-relative style=\"padding-left: 12px\"><select ng-model=ticket.quantity class=form-control ng-disabled=\"ticket.availableTicket == 0\" style=\"font-weight: 600; border: none; height: 28px\"><option ng-repeat=\"i in getNumber(ticket.availableTicket + 1) track by $index\" value=\"{{ $index }}\" style=\"text-align: center; font-weight: 600\">{{ $index }}</option></select><span class=\"dripicons-chevron-down select-arrow\" style=\"right: 4px; top: 5px\"></span></div></div><div ng-if=\"ticket.availableTicket == 0\" style=\"line-height: 32px; font-weight: 600; color: #555; font-size: 14px\"><span translate=SOLD_OUT></span></div></div><div style=\"width: 37%; text-align: right\"><div style=\"color: #8a94a2; font-weight: 600; font-size: 13px; margin-bottom: 4px\"><span translate=TOTAL></span></div><div><strong style=\"font-size: 15px; line-height: 38px\"><span>FREE</span></strong></div></div></div></div><!-- Free ticket type END --><!-- Paid ticket type START --><div class=pick-tickets-item ng-if=\"ticket.ticketType === \'PAID\'\"><div style=\"font-weight: 600; padding-bottom: 2px; margin-bottom: 10px; border-bottom: 1px solid #8a94a2\">{{ ticket.ticketName }}</div><div class=pick-tickets-cols><div style=\"width: 37%\"><div style=\"color: #8a94a2; font-weight: 600; font-size: 13px; margin-bottom: 4px\"><span translate=PRICE></span></div><div><strong style=\"font-size: 15px; line-height: 38px\"><span ng-show=ticketList.ticketCurrency translate=\"{{ ticketList.ticketCurrency }}_SHORT\"></span><span>{{ ticket.ticketPrice | currency: \'\' }}</span></strong></div></div><div style=\"width: 26%\"><div style=\"color: #8a94a2; font-weight: 600; font-size: 13px; margin-bottom: 8px\"><span translate=QUANTITY></span></div><div ng-if=\"ticket.availableTicket > 0\" style=\"border: 1px solid #8a94a2; padding: 0; border-radius: 8px; margin-bottom: 10px\"><div class=is-relative style=\"padding-left: 12px\"><select ng-model=ticket.quantity class=form-control ng-disabled=\"ticket.availableTicket == 0\" style=\"font-weight: 600; border: none; height: 28px\"><option ng-repeat=\"i in getNumber(ticket.availableTicket + 1) track by $index\" value=\"{{ $index }}\" style=\"text-align: center; font-weight: 600\">{{ $index }}</option></select><span class=\"dripicons-chevron-down select-arrow\" style=\"right: 4px; top: 5px\"></span></div></div><div ng-if=\"ticket.availableTicket == 0\" style=\"line-height: 32px; font-weight: 600; color: #555; font-size: 14px\"><span translate=SOLD_OUT></span></div></div><div style=\"width: 37%; text-align: right\"><div style=\"color: #8a94a2; font-weight: 600; font-size: 13px; margin-bottom: 4px\"><span translate=TOTAL></span></div><div><strong style=\"font-size: 15px; line-height: 38px\"><span ng-if=ticketList.ticketCurrency translate=\"{{ ticketList.ticketCurrency }}_SHORT\"></span><span>{{ (ticket.quantity ? ticket.quantity * ticket.ticketPrice : 0.00) | currency: \'\' }}</span></strong></div></div></div></div><!-- Paid ticket type END --><!-- Donation ticket type START --><div class=pick-tickets-item ng-if=\"ticket.ticketType === \'DONATION\'\"><div style=\"font-weight: 600; padding-bottom: 2px; margin-bottom: 10px; border-bottom: 1px solid #8a94a2\">{{ ticket.ticketName }}</div><div class=pick-tickets-cols><div style=\"width: 37%\"><div style=\"color: #8a94a2; font-weight: 600; font-size: 13px; margin-bottom: 4px\"><span translate=EVENT_DONATION></span></div><div><strong style=\"font-size: 15px; line-height: 38px\" ng-if=\"ticket.ticketPrice !== 0\"><span ng-show=ticketList.ticketCurrency translate=\"{{ ticketList.ticketCurrency }}_SHORT\"></span><span>{{ ticket.ticketPrice | currency: \'\' }}</span> </strong><strong style=\"font-size: 15px; line-height: 38px\" ng-if=\"ticket.ticketPrice === 0\"><span translate=DONATION_NOT_SPECIFIED></span></strong></div></div><div style=\"width: 26%; padding-bottom: 10px\"><div style=\"color: #8a94a2; font-weight: 600; font-size: 13px; margin-bottom: 8px\"><span translate=DONATION_AMOUNT></span></div><div class=is-relative><input type=text ng-model=ticket.donationAmount remove-chars=number formatprice=number maxlength=7 autocomplete=off style=\"width: 100%; border: 1px solid #8a94a2; padding: 8px; border-radius: 10px; height: 36px\" placeholder=\"e.g. 10.00\"> <span style=\"color: #FF5A5A; font-size: 12px\" ng-if=\"!!ticket.donationAmount && ticket.donationAmount < 1.00\">Minimum donation is 1.00</span></div></div><div style=\"width: 37%; text-align: right\"><div style=\"color: #8a94a2; font-weight: 600; font-size: 13px; margin-bottom: 4px\"><span translate=TOTAL></span></div><div><strong style=\"font-size: 15px; line-height: 38px\"><span ng-if=ticketList.ticketCurrency translate=\"{{ ticketList.ticketCurrency }}_SHORT\"></span><span>{{ ((!!ticket.donationAmount && ticket.donationAmount >= 1.00) ? ticket.donationAmount : 0.00) | currency: \'\' }}</span></strong></div></div></div></div><!-- Donation ticket type END --></div><div class=total-label><div style=\"float: left\"><div translate=TOTAL_TO_PAY></div></div><div class=align-right><span ng-show=\"ticketList.ticketCurrency && ticketList.paidEventType != \'FREE\'\" translate=\"{{ ticketList.ticketCurrency }}_SHORT\"></span> <span ng-show=\"ticketList.paidEventType && ticketList.paidEventType != \'FREE\'\">{{ getTotalTickets(ticketList.tickets) | currency: \"\" }}</span> <span ng-show=\"ticketList.paidEventType && ticketList.paidEventType == \'FREE\'\">FREE</span></div></div></div><div ng-show=\"totalPayment !== 0 && ticketList.paymentProvider && ticketList.paymentProvider.provider == \'stripe\'\" class=pick-tickets-section><div><div translate=PAY_SECURELY_BY_CARD></div></div><div class=pick-tickets-item style=\"padding: 10px 12px; margin-bottom: 25px\"><form id=payment-form><div class=form-row><label for=card-element>Credit or debit card</label><div id=card-element></div><div id=card-errors role=alert></div></div></form></div></div><div ng-show=\"totalPayment !== 0\" class=align-right style=\"padding-right: 15px; font-size: 13px; margin-bottom: 10px; margin-top: 10px\"><span ng-if=\"ticketList.paymentProvider.provider == \'paypal\'\" translate=PAYPAL_CREDIT_CARD></span></div><div><div ng-show=\"totalPayment !== 0\"><div ng-if=\"ticketList.paymentProvider.provider != \'stripe\'\"><button type=button class=\"btn btn-primary btn-paypal\" ng-click=save() ng-disabled=buingTickets style=\"width: 100%; max-width: 400px; margin: auto; display: table; border-radius: 0!important; height: 35px!important\"></button></div><div ng-if=\"ticketList.paymentProvider.provider == \'stripe\' && stripeLoaded\"><button type=button class=\"btn btn-primary pay-now-but\" ng-click=stripeSubmit() ng-disabled=buingTickets>Pay now</button></div></div><div ng-show=\"totalPayment === 0\" style=\"margin-top: 15px\"><button type=button class=\"btn btn-primary btn-primary-pink\" ng-click=save() ng-disabled=buingTickets translate=CONFIRM_TICKETS style=\"width: 100%; max-width: 300px; margin: auto; display: table\"></button></div></div></div></section>");
$templateCache.put("app/events/views/cancel-modal.html","<div><div class=modal-header><h3 translate=CANCEL_EVENT_HEADER></h3></div><div class=modal-body><p translate=CANCEL_EVENT_TEXT></p><textarea ng-model=cancelMessage class=\"form-control bordered\" maxlength=500 autoresize-textarea style=\"min-height: 150px\"></textarea></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=YES_CANCEL_BTN ng-click=save() ng-disabled=\"cancellingEvent || !cancelMessage\"><button type=button class=\"btn btn-default pull-right\" translate=NO_THANKS_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/create.html","<section class=\"event-view event-create\" add-guests gallery-picker ng-class=\"{\'is-visible\': viewState.isReady }\"><div class=\"page-view-header clearfix {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div style=\"padding: 0\"><div class=premium-ad-clear style=\"padding: 0 15px\"><div premium-ad></div></div><div style=\"position: relative\"><div class=pull-left><svg id=header-back-button ng-click=goToEvents() class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg></div><div class=\"last-updated-label pull-right visible-md visible-lg\" style=\"padding-right: 15px\"><span><span translate=EVENT_LAST_UPDATED_LABEL></span> <span>{{ event.date.updated | date:\' h:mm a\' }}, {{ event.date.updated | date:\'MMM dd\' }}</span></span></div></div></div></div><div class=page-container-header-from-top><div class=\"last-updated-label hidden-md hidden-lg\" style=\"margin: 10px; text-align: right\"><span><span translate=EVENT_LAST_UPDATED_LABEL></span> <span>{{ event.date.updated | date:\' h:mm a\' }}, {{ event.date.updated | date:\'MMM dd\' }}</span></span></div><div ng-if=showInfo style=\"padding: 0!important\"><section class=event-details><a ng-click=\"showMoreInfo = !showMoreInfo;\">How does creating an event work? </a><span ng-if=showMoreInfo ng-click=closeInfo() class=dripicons-cross style=\"float: right;\n				color: red;\n				font-size: 23px;\n				margin-top: -12px;\n				margin-right: -5px\"></span><div ng-if=showMoreInfo class=yellow-tooltip style=\"margin-bottom: 0; background: transparent\"><div style=\"padding: 0!important\"><br><span translate=CREATE_EVENT_INFO></span></div></div></section></div><div style=\"margin: 0!important\"><div style=\"padding: 0!important\"><div class=event-picture-container><div class=event-picture><span class=change-image-link ng-click=pickGallery()><span class=\"icon dripicons-camera\"><span style=\"font-size: 14px; margin-left: 10px\" translate=CHANGE_IMAGE></span></span></span><div class=img style=\"background-image: url(\'{{ event.fileLibrary.image }}\')\"></div></div></div></div><div style=\"padding: 0!important\"><section class=event-details><div class=row><div class=col-md-12><h1><span ng-if=!editingTitle><span ng-if=event.title style=\"color: #3677d9; font-size: 18px; font-weight: 600\">{{ event.title }}</span> <span ng-if=!event.title translate=EVENT_NAME></span> </span><span ng-if=!editingTitle class=\"icon dripicons-pencil\" ng-click=editTitle($event) id=auto-mob-edit-title></span><div class=click-editor ng-show=editingTitle click-outside=saveOutsideTitle() ng-click=stopPropagation($event)><input ng-model=valueTitle maxlength={{regexes.max.eventTitle}} type=text placeholder=\"{{\'EVENT_NAME\' | translate }}\"><div><span class=\"icon dripicons-checkmark\" ng-click=saveTitle()></span> <span class=\"icon dripicons-cross\" ng-click=cancelTitle()></span></div></div></h1><div style=\"min-height: 40px\"><span ng-if=!editingDescr><span ng-show=event._description ng-bind-html=event._description style=\"word-break: break-word\"></span> <span ng-if=!event._description translate=EVENT_DESCRIPTION></span> </span><span ng-if=!editingDescr class=\"icon dripicons-pencil\" ng-click=editDescr($event) id=auto-mob-edit-descr></span><div class=click-editor ng-show=editingDescr click-outside=saveOutsideDescr() ng-click=stopPropagation($event)><textarea ng-model=valueDescr maxlength={{regexes.max.eventDescription}} autoresize-textarea placeholder=\"{{\'EVENT_DESCRIPTION\' | translate }}\"></textarea><div><span class=\"icon dripicons-checkmark\" ng-click=saveDescr()></span> <span class=\"icon dripicons-cross\" ng-click=cancelDescr()></span></div></div></div><br><div><span translate=PRIVATE_EVENT_CREATED_BY></span> <a ui-sref=\"classlist.details.contact({\'id\': event.createdById })\">{{event.createdByName}}</a> <span ng-if=!editingCreatedby class=\"icon dripicons-pencil\" ng-click=editCreatedby($event) id=auto-mob-edit-createdby></span><div class=click-editor ng-show=editingCreatedby click-outside=saveOutsideCreatedby() ng-click=stopPropagation($event)><input ng-model=valueCreatedby type=text placeholder=\"{{\'EVENT_CREATED_BY\' | translate }}\"><div><span class=\"icon dripicons-checkmark\" ng-click=saveCreatedby()></span> <span class=\"icon dripicons-cross\" ng-click=cancelCreatedby()></span></div></div></div></div></div></section></div></div><div ng-if=showInfoRSVP class=yellow-tooltip><span ng-click=closeInfoRSVP() class=dripicons-cross></span><div><span translate=CREATE_EVENT_INFO_RSVP></span></div></div><section><div class=row><div class=col-md-6><ul class=details-attachment-list><li ng-show=event.date.startDate><svg style=\"margin-right: 10px; margin-bottom: 4px; float: left\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=18px height=18px viewBox=\"0 0 48 48\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><line x1=45 y1=16 x2=3 y2=16 fill=none stroke=#eb004e stroke-miterlimit=10 stroke-width=4 data-cap=butt stroke-linecap=butt stroke-linejoin=miter></line><polyline points=\"20 42 3 42 3 6 45 6 45 25\" fill=none stroke=#eb004e stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></polyline><line x1=13 y1=2 x2=13 y2=10 fill=none stroke=#eb004e stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></line><line x1=35 y1=2 x2=35 y2=10 fill=none stroke=#eb004e stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></line><polyline points=\"32 37 34 39 38 35\" fill=none stroke=#eb004e stroke-linecap=square stroke-miterlimit=10 stroke-width=4 data-color=color-2 stroke-linejoin=miter></polyline><circle cx=35 cy=37 r=9 fill=none stroke=#eb004e stroke-linecap=square stroke-miterlimit=10 stroke-width=4 data-color=color-2 stroke-linejoin=miter></circle></g></svg> <span>{{ event.date.startDate | date:\'EEEE, MMM dd\' : \'GMT\' }}<br>{{ event.date.startDate | date:\'h:mm a\' : \'GMT\' }} </span><span class=\"icon dripicons-pencil\" ng-click=\"triggerAutosave(\'\'); eventStartDateOptions.open(eventStartDateOptions.options)\"></span></li><li ng-show=!event.date.startDate><span class=\"icon dripicons-calendar\"></span> <a translate=ADD_DATE_TIME ng-click=\"triggerAutosave(\'\'); eventStartDateOptions.open(eventStartDateOptions.options)\"></a><datepicker ng-model=event.date.startDate big-banner=true action=eventStartDateOptions header-title=START_DATE_PHOLDER format=\"dd/MM/yyyy hh:mm a\" time-picker=true on-date-select=eventStartDateOptions.onDateSelect(selectedDate)></datepicker></li><li class=indented ng-show=event.date.endDate><span>{{ event.date.endDate | date:\'EEEE, MMM dd\' : \'GMT\' }}<br>{{ event.date.endDate | date:\'h:mm a\' : \'GMT\' }} </span><span class=\"icon dripicons-pencil\" ng-click=\"triggerAutosave(\'\'); eventEndDateOptions.open(eventEndDateOptions.options)\"></span> <span class=\"icon dripicons-cross\" ng-click=\"triggerAutosave(\'\'); eventEndDateOptions.clear()\"></span></li><li class=\"{{ !event.date.startDate ? \'disabled\' : \'\' }} indented\" ng-show=!event.date.endDate><span class=\"icon dripicons-plus pull-left\"></span> <span ng-if=event.date.startDate><a translate=ADD_END_DATE_TIME ng-click=\"triggerAutosave(\'\'); eventEndDateOptions.open(eventEndDateOptions.options)\"></a> </span><span ng-if=!event.date.startDate><a translate=ADD_END_DATE_TIME></a></span><datepicker ng-model=event.date.endDate min-date=\"event.date.endDate ? event.date.endDate : event.date.startDate\" big-banner=true action=eventEndDateOptions header-title=END_DATE_PHOLDER format=\"dd/MM/yyyy hh:mm a\" time-picker=true on-date-select=eventEndDateOptions.onDateSelect(selectedDate)></datepicker></li><li class=indented ng-show=event.date.rsvpDate><span>{{ event.date.rsvpDate | date:\'EEEE, MMM dd\' : \'GMT\' }}<br>{{ event.date.rsvpDate | date:\'h:mm a\' : \'GMT\' }} </span><span class=\"icon dripicons-pencil\" ng-click=\"triggerAutosave(\'\'); eventRSVPDateOptions.open(eventRSVPDateOptions.options)\"></span> <span class=\"icon dripicons-cross\" ng-click=\"triggerAutosave(\'\'); eventRSVPDateOptions.clear()\"></span></li><li class=\"{{ !event.date.startDate ? \'disabled\' : \'\' }} indented\" ng-show=!event.date.rsvpDate><span class=\"icon dripicons-plus pull-left\"></span> <span ng-if=event.date.startDate><a translate=ADD_RSVP_DATE ng-click=\"triggerAutosave(\'\'); eventRSVPDateOptions.open(eventRSVPDateOptions.options)\"></a> <span ng-click=openInfoRSVP() class=\"dripicons-information icon-rsvp-info\"></span> </span><span ng-if=!event.date.startDate><a translate=ADD_RSVP_DATE></a></span><datepicker ng-model=event.date.rsvpDate min-date=\"event.date.rsvpDate ? event.date.rsvpDate : event.date.startDate\" big-banner=true action=eventRSVPDateOptions header-title=RSVP_DATE_PHOLDER format=\"dd/MM/yyyy hh:mm a\" time-picker=true on-date-select=eventRSVPDateOptions.onDateSelect(selectedDate)></datepicker></li></ul></div><div class=col-md-6><ul class=details-attachment-list click-outside=saveOutsideLocationDetail() ng-click=stopPropagation($event)><li ng-if=\"event.location.location && !isOnlineEvent\"><svg style=\"float: left; margin-right: 10px; margin-bottom: 4px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=18px height=18px viewBox=\"0 0 64 64\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><path fill=none stroke=#eb004e stroke-width=4 stroke-linecap=square stroke-miterlimit=10 d=\"M54,24.095 C54,39,32,61,32,61S10,39,10,24.095C10,10.113,21.369,2,32,2S54,10.113,54,24.095z\" stroke-linejoin=miter></path><circle data-color=color-2 fill=none stroke=#eb004e stroke-width=4 stroke-linecap=square stroke-miterlimit=10 cx=32 cy=24 r=8 stroke-linejoin=miter></circle></g></svg> <span>{{ event.location.location }}</span> <a translate=CHANGE_BTN ng-click=addLocation()></a></li><li ng-if=\"!event.location.location && !isOnlineEvent\"><svg style=\"float: left; margin-right: 10px;margin-bottom: 4px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=18px height=18px viewBox=\"0 0 64 64\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><path fill=none stroke=#eb004e stroke-width=4 stroke-linecap=square stroke-miterlimit=10 d=\"M54,24.095 C54,39,32,61,32,61S10,39,10,24.095C10,10.113,21.369,2,32,2S54,10.113,54,24.095z\" stroke-linejoin=miter></path><circle data-color=color-2 fill=none stroke=#eb004e stroke-width=4 stroke-linecap=square stroke-miterlimit=10 cx=32 cy=24 r=8 stroke-linejoin=miter></circle></g></svg> <a id=auto-mob-edit-addlocation translate=ADD_LOCATION ng-click=addLocation()></a></li><li class=indented ng-if=\"event.location.locationDetail && !editingLocationDetail && !isOnlineEvent\"><span>{{ event.location.locationDetail }}</span> <a translate=CHANGE_BTN ng-click=editLocationDetail($event)></a></li><li ng-show=\"!isOnlineEvent && !event.location.locationDetail && !editingLocationDetail && event.location.location\" class=\"{{ !event.location ? \'disabled\' : \'\' }} indented\"><span class=\"icon dripicons-plus\"></span> <span ng-if=event.location.location><a id=auto-mob-edit-addlocationdetail translate=ADD_LOCATION_DETAILS ng-click=editLocationDetail($event)></a> </span><span ng-if=!event.location.location><a ng-click=editLocationDetail($event) translate=ADD_LOCATION_DETAILS></a></span></li><li ng-show=\"editingLocationDetail && event.location.location\" ng-click=stopPropagation($event)><div class=click-editor ng-show=editingLocationDetail style=\"line-height: 24px\"><input ng-model=valueLocationDetail type=text placeholder=\"{{\'ADD_LOCATION_DETAILS\' | translate }}\" maxlength={{regexes.max.eventLocDet}}><div><span class=\"icon dripicons-checkmark\" ng-click=saveLocationDetail()></span> <span class=\"icon dripicons-cross\" ng-click=cancelLocationDetail()></span></div></div></li></ul></div></div><div class=row><div class=col-md-12><ul class=details-attachment-list><li><svg style=\"float: left; margin-right: 10px; margin-top: 2px; margin-bottom: 4px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=18px height=22px viewBox=\"0 0 48 48\"><g transform=\"translate(0, 0)\"><path fill=#eb004e d=\"M23.245,46.981C15.187,46.584,9,39.633,9,31.565V12.322C9,6.598,13.24,1.587,18.94,1.05 C25.48,0.434,31,5.585,31,12l0,17.755c0,3.557-2.55,6.732-6.078,7.185C20.654,37.489,17,34.163,17,30V13c0-0.552,0.448-1,1-1h2 c0.552,0,1,0.448,1,1l0,16.882c0,1.451,0.978,2.784,2.402,3.06C25.317,33.314,27,31.85,27,30l0-17.755 c0-3.557-2.55-6.732-6.078-7.185C16.654,4.511,13,7.837,13,12l0,19.678c0,5.725,4.24,10.736,9.94,11.272 C29.48,43.566,35,38.415,35,32V7c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v25C39,40.522,31.858,47.406,23.245,46.981z\"></path></g></svg><div style=\"float: left; max-width: 80%\"><span ng-repeat=\"att in event.fileLibrary.attachment\"><a href=\"{{ att.path }}\" target=_self>{{ att.name }}</a> <span class=\"icon dripicons-cross\" ng-click=\"deleteAttachment(att, $index)\" style=\"cursor: pointer\"></span><br></span><div ng-hide=\"event.fileLibrary.attachment.length > 5\"><a translate=ADD_ATTACHMENT ng-click=fileUploadDialog() style=\"line-height: 26px\"></a></div></div></li></ul></div></div></section><section class=event-section><h2 translate=EVENT_ONLINE style=\"margin: 0px 0 10px 0\"></h2><p><span translate=EVENT_ONLINE_DESC></span>&nbsp; <span ng-if=!isFriendshipBetaSchool() ng-click=openBudiSignUp() class=\"icon dripicons-information\"></span> <span ng-if=isFriendshipBetaSchool() class=\"dripicons-question icon\" ng-click=openBudiHelp() style=\"color: #777; cursor: pointer\"></span></p><br><div class=location-checkboxes><p translate=IS_EVENT_ONLINE></p><label style=\"margin-right: 25px\"><span translate=YES></span> <input ng-model=isOnlineEvent ng-click=\"isOnlineEvent = true; isSchoolEvent = false; updateIsOnlineEvent(true)\" type=checkbox checked style=\"float: right\"></label><label><span translate=NO></span> <input ng-model=isSchoolEvent ng-click=\"isOnlineEvent = false; isSchoolEvent = true; updateIsOnlineEvent(false)\" type=checkbox style=\"float: right\"></label><br><div ng-if=isOnlineEvent><div ng-if=isFriendshipBetaSchool() style=\"margin-bottom: 12px\"><label style=\"margin-right: 25px\"><input ng-model=budiSelection.isBudiEvent ng-click=\"budiSelection.isBudiEvent = true; budiSelection.isExternal = false; updateBudiEvent(true)\" type=checkbox> <span style=\"font-weight: normal\" translate=BUDI_DESCRIPTION></span> <span ng-if=isFriendshipBetaSchool() class=\"dripicons-question icon\" ng-click=openBudiHelp() style=\"color: #777; cursor: pointer\"></span></label></div><div style=\"margin-bottom: 12px\"><label style=\"margin-right: 25px\"><!-- <input ng-model=\"budiSelection.isExternal\" ng-click=\"budiSelection.isBudiEvent = false; budiSelection.isExternal = true;  updateBudiEvent(false)\" style=\"margin-right: 10px;\" type=\"checkbox\" /> --> <span style=\"font-weight: normal\" translate=ADD_YOUR_VIDEO_LINK></span></label><input id=event-ext-link ng-model=event.onlineLink ng-if=budiSelection.isExternal ng-keyup=checkValidLink() ng-blur=saveOnlineLink() style=\"width: 95%; padding: 10px\" type=text placeholder=\"{{ \'ADD_YOUR_VIDEO_LINK\' | translate }}\"><div class=event-wrong-online-link ng-if=invalidOnlineLink class=invalid-label translate=NOT_VALID_ONLINE_LINK></div></div><div style=\"margin-bottom: 12px\"><label style=\"margin-right: 25px\"><!-- <input ng-model=\"budiSelection.isExternal\" ng-click=\"budiSelection.isBudiEvent = false; budiSelection.isExternal = true;  updateBudiEvent(false)\" style=\"margin-right: 10px;\" type=\"checkbox\" /> --> <span style=\"font-weight: normal\" translate=ADD_ID_PASSWORD></span></label><div style=\"clear: both\"></div><input id=event-ext-link ng-model=event.onlineEventExternalUsername ng-if=budiSelection.isExternal ng-blur=saveOnlineEventExternalUsername() style=\"width: 40%; padding: 10px\" type=text placeholder=\"{{ \'ADD_ID\' | translate }}\"> <input id=event-ext-link ng-model=event.onlineEventExternalPassword ng-if=budiSelection.isExternal ng-blur=saveOnlineEventExternalPassword() style=\"width: 40%; padding: 10px; margin-left: 10px\" type=text placeholder=\"{{ \'ADD_PASSWORD\' | translate }}\"></div></div></div></section><section ng-if=\"event.status != \'CANCELLED\' && !isPastEvent(event)\" style=\"overflow: auto\"><a ng-show=event.ticketed class=\"pull-left events-manage\" ng-click=gotoGuests()><svg style=\"float: left; margin-right: 10px; margin-top: 3px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=18px height=18px viewBox=\"0 0 32 32\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><rect data-color=color-2 x=10 y=12 fill=none stroke=#4a9fef stroke-width=2 stroke-linecap=square stroke-miterlimit=10 width=12 height=8 stroke-linejoin=miter></rect><path fill=none stroke=#4a9fef stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M27,16c0-2.209,1.791-4,4-4 V5H1v7c2.209,0,4,1.791,4,4c0,2.209-1.791,4-4,4v7h30v-7C28.791,20,27,18.209,27,16z\" stroke-linejoin=miter></path></g></svg> <span translate=VIEW_TICKETS></span> </a><!-- <a ng-click=\"showMoreTickets = !showMoreTickets;\" style=\"line-height: 40px;\">\n				Info about tickets\n			</a> --><p ng-if=showMoreTickets>Lorem Impsum dolor sit amet Lorem Impsum dolor sit amet Lorem Impsum dolor sit amet Lorem Impsum dolor sit amet Lorem Impsum dolor sit amet</p><button type=button class=\"btn btn-ghost pull-right\" ng-click=gotoTickets()><span ng-show=!event.ticketed translate=ADD_TICKET_BTN></span> <span ng-show=event.ticketed translate=EDIT_TICKET_BTN></span></button></section><section style=\"overflow: auto; text-align: right\"><span ng-show=\"event.answerCount.invited > 0\" style=\"margin-left: 10px\"><button type=button class=\"btn btn-ghost\" ng-click=gotoPreview()><span translate=PREVIEW_BTN></span></button> </span><span ng-if=\"event.status == \'ACTIVE\' && !isPastEvent(event)\" style=\"margin-left: 10px\"><button type=button class=\"btn btn-ghost\" ng-click=cancelEvent()><span translate=CANCEL_EVENT_BTN></span></button> </span><span ng-if=\"event.status == \'DRAFT\' || isPastEvent(event)\" style=\"margin-left: 10px\"><button type=button class=\"btn btn-ghost\" ng-click=deleteEvent()><span translate=DELETE_EVENT_BTN></span></button></span></section><section><div ng-if=\"active_user.id == event.createdById && event.answerCount.inviting\" style=\"margin-bottom: 20px; color: #000\"><span translate=INVITATIONS_ARE_BEING_SENT></span> <a ng-click=getEvent() translate=REFRESH_EVENT></a></div><div class=\"small-invitation-resume {{ event.ticketed ? \'ticketed\' : \'\' }}\"><div ng-click=\"showGuests(\'ALL\')\"><h1>{{event.answerCount.invited}}</h1><span translate=EVENT_TXT_SOLD></span></div><div ng-if=!event.ticketed ng-click=\"showGuests(\'GOING\')\"><h1>{{event.answerCount.going}}</h1><span translate=EVENT_TXT_GOING></span></div><div ng-if=!event.ticketed ng-click=\"showGuests(\'MAYBE\')\"><h1>{{event.answerCount.maybe}}</h1><span translate=EVENT_TXT_MAYBE></span></div><div ng-if=!event.ticketed ng-click=\"showGuests(\'NOT_GOING\')\"><h1>{{event.answerCount.cantgo}}</h1><span translate=EVENT_TXT_CANTGO></span></div><div ng-if=event.ticketed ng-click=\"showGuests(\'GOING\')\" style=\"float: right\"><h1>{{event.answerCount.sold}}</h1><span translate=EVENT_TXT_GOING></span></div></div><br><div><div><div class=invited-group-list><div ng-repeat=\"group in event.groups\"><span class=\"icon dripicons-user-group groups-icon\"></span> <span>{{ group.name }}</span></div></div></div></div><br><div class=row ng-if=!event.answerCount.inviting><div class=\"col-md-8 col-xs-7\"><b ng-if=\"event.status != \'ACTIVE\'\" translate=EVENT_ACTIVE_BY_INVITE_TEXT></b> <b ng-if=\"event.status == \'ACTIVE\'\" translate=EVENT_ACTIVE_BY_MANAGE_TEXT></b></div><div class=\"col-md-4 col-xs-5\" style=\"text-align: right\"><div ng-if=\"event.status != \'CANCELLED\'\"><button ng-disabled=\"event.answerCount && event.answerCount.invited == \'0\'\" type=button class=\"btn btn-ghost\" ng-click=gotoGuests() style=\"margin-bottom: 10px\"><span translate=MANAGE_BTN></span></button> <button type=button class=\"btn btn-ghost\" ng-click=inviteGuests() style=\"margin-bottom: 10px\"><span translate=INVITE_BTN></span></button></div></div></div></section><section><aside ng-if=eventPost><post-asset comment-only=true post-content=eventPost readonly-post=1 post-context=HOME_VIEW class=enter user-avatar=active_user.userAvatar user-id=active_user.userId user-name=\"active_user.firstName+\' \'+active_user.lastName\" post-events=postEvents></post-asset></aside></section></div><input type=file id=fileUploader></section>");
$templateCache.put("app/events/views/delete-modal.html","<div><div class=modal-header><p translate=DELETE_EVENT_HEADER></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=OK_BTN ng-click=save()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/guests-nonticketed.html","<section class=event-guests ng-class=\"{\'is-visible\': viewState.isReady }\"><div class=\"page-view-header clearfix {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div style=\"padding: 0\"><div class=premium-ad-clear style=\"padding: 0 15px\"><div premium-ad></div></div><div style=\"position: relative; padding-right: 15px\"><svg id=header-back-button ui-sref=\"events.create({\'id\': id_event})\" class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg><div class=\"hosted-by-label pull-right visible-md visible-lg\" style=\"margin-top: 15px\"><span class=event-tag ng-if=\"event.type == \'COMMUNITY\'\"><span class=\"circle-tag community-tag\"></span> <span class=event-tag-txt translate=TAG_COMMUNITY_EVENT></span> </span><span class=event-tag ng-if=\"event.type == \'PARENT\'\"><span class=\"circle-tag private-tag\"></span> <span class=event-tag-txt translate=TAG_PRIVATE_EVENT></span> </span><span ng-if=event.createdByName translate=CREATED_BY style=\"margin-left: 6px\"></span> <a ui-sref=\"classlist.details.contact({\'id\': event.createdById })\">{{ event.createdByName }}</a></div></div></div></div><div class=page-container-header-from-top><div ng-if=isPastEvent(event) style=\"margin-top: 20px\"><div class=yellow-tooltip style=\"margin-bottom: 0\"><div><span translate=PAST_EVENT_INFO></span></div></div><br></div><div><div><section><div class=guests-resume-nonticketed><div style=\"overflow: auto\"><div class=\"col-md-2 pull-left\"><div>{{ guests.answerCount.invited }}</div><div translate=EVENT_TXT_INVITED style=\"font-size: 16px\"></div></div><div class=pull-right ng-if=\"event.status != \'CANCELLED\' && !isPastEvent(event)\"><button type=button class=\"btn btn-ghost pull-right\" ng-click=inviteGuests()><span translate=INVITE_MORE></span></button></div></div><br><div class=row style=\"margin: 0\"><div class=\"col-md-4 col-xs-4\"><span style=\"font-size: 20px\">{{ guests.answerCount.going }}</span> <span translate=EVENT_GOING_BTN></span></div><div class=\"col-md-4 col-xs-4\"><span style=\"font-size: 20px\">{{ guests.answerCount.maybe }}</span> <span translate=EVENT_MAYBE_BTN></span></div><div class=\"col-md-4 col-xs-4\"><span style=\"font-size: 20px\">{{ guests.answerCount.cantgo }}</span> <span translate=EVENT_NOT_GOING_BTN></span></div></div></div></section></div><div><section><div class=\"is-relative search-input\"><input type=search class=form-control placeholder=\"{{ \'SEARCH_TXT\' | translate }}\" ng-model=selectedSelectFilter.keyword ng-keyup=keywordKeyup()> <span class=dripicons-search></span></div><div class=\"is-relative select-filter\"><select ng-model=selectedSelectFilter.type class=form-control ng-change=selectFilterChanged(selectedSelectFilter.type)><option translate=ALL_INVITED value=\"\"></option><option translate=ALL_REPLIED value=ALL_REPLIED></option><option translate=HAVENT_REPLIED value=HAVENT_REPLIED></option><option translate=GOING value=GOING></option><option translate=MAYBE value=MAYBE></option><option translate=CANT_GO value=CANT_GO></option></select><span class=\"dripicons-chevron-down select-arrow\"></span></div><div class=\"filter-links {{ !filteredItems || filteredItems.length == 0 ? \'f-links-disabled\' : \'\' }}\"><span class=\"icon dripicons-bell\" style=\"color: #4A9FF2\"></span> <a translate=SEND_NOTIFICATION_TO_SELECTED ng-click=sendNotification()></a></div><div ng-if=!isPastEvent(event) class=\"filter-links {{ !filteredItems || filteredItems.length == 0 || event.status == \'CANCELLED\' ? \'f-links-disabled\' : \'\' }}\"><span class=\"icon dripicons-skip\" style=\"color: #4A9FF2\"></span> <a translate=RESEND_INVITATION_TO_SELECTED ng-click=sendReminder()></a></div><div class=filter-links><span class=\"icon dripicons-download\" style=\"color: #4A9FF2\"></span> <a translate=DOWNLOAD_SELECTED_LIST ng-click=downloadList(false) style=\"line-height: 25px\"></a></div></section></div></div></div><div><section class=guests-list-mobile style=\"padding: 0\"><div class=\"row {{ guest.opened ? \'opened\' : \'\' }}\" ng-repeat=\"guest in (filteredItems = (guests.guestList | filterguests:selectedSelectFilter)) track by $index\"><div class=col-md-12 style=\"cursor: pointer\"><figure ui-sref=\"classlist.details.contact({ \'id\': guest.userId })\" style=\"float: left; height: 40px; margin-right: 10px\"><avatar source=\"{{ guest.userAvatar }}\" width=40 height=40 name=\"{{ guest.userName }}\" my=false></avatar></figure><div><a class=name ui-sref=\"classlist.details.contact({ \'id\': guest.userId })\">{{ guest.userName }}</a></div><div style=\"overflow: auto\"><div style=\"float: left; max-width: 80%\">{{ guest.pupilNames }}</div></div></div><div class=collapsible-container><div class=vi-row><div class=vi-col-left></div></div></div></div></section></div></section>");
$templateCache.put("app/events/views/guests-ticketed.html","<section class=event-guests ng-class=\"{\'is-visible\': viewState.isReady }\"><div class=\"page-view-header clearfix {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div style=\"padding: 0\"><div class=premium-ad-clear style=\"padding: 0 15px\"><div premium-ad></div></div><div style=\"position: relative; padding-right: 15px\"><svg id=header-back-button ui-sref=\"events.create({\'id\': id_event})\" class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg><div class=\"hosted-by-label pull-right visible-md visible-lg\" style=\"margin-top: 15px\"><span class=event-tag ng-if=\"event.type == \'COMMUNITY\'\"><span class=\"circle-tag community-tag\"></span> <span class=event-tag-txt translate=TAG_COMMUNITY_EVENT></span> </span><span class=event-tag ng-if=\"event.type == \'PARENT\'\"><span class=\"circle-tag private-tag\"></span> <span class=event-tag-txt translate=TAG_PRIVATE_EVENT></span> </span><span ng-if=event.createdByName translate=CREATED_BY style=\"margin-left: 6px\"></span> <a ui-sref=\"classlist.details.contact({\'id\': event.createdById })\">{{ event.createdByName }}</a></div></div></div></div><div class=page-container-header-from-top><div ng-if=isPastEvent(event) style=\"margin-top: 20px\"><div class=yellow-tooltip style=\"margin-bottom: 0\"><div><span translate=PAST_EVENT_INFO></span></div></div><br></div><div><div><section><div class=guests-resume-ticketed><div class=row><div class=\"col-xs-6 col-md-6\"><div style=\"margin-bottom: 6px\"><span style=\"letter-spacing: 1px; font-size: 16px\"><span class=bolded style=\"font-size: 30px\">{{ guests.inviteCounts.totalSold.sold }}</span>/{{ guests.inviteCounts.totalSold.available }} </span><span translate=TICKETS_SOLD></span></div><div ng-repeat=\"tick in guests.inviteCounts.ticketTypes\"><span style=\"letter-spacing: 1px\"><span class=bolded>{{ tick.sold }}</span>/{{ tick.available }} </span><span>{{ tick.ticketName }}</span> <span translate=TICKETS_SOLD></span></div><div ng-if=\"guests.inviteCounts.totalSold.pending > 0\"><span style=\"letter-spacing: 1px\"><span class=bolded>{{ guests.inviteCounts.totalSold.pending }}</span> </span><span translate=PENDING_PAYMENT></span></div><div ng-if=\"guests.inviteCounts.totalSold.inprogress > 0\"><span style=\"letter-spacing: 1px\"><span class=bolded>{{ guests.inviteCounts.totalSold.inprogress }}</span> </span><span translate=IN_BASKET></span></div><br><button ng-if=\"event.status != \'CANCELLED\' && !isPastEvent(event)\" type=button class=\"btn btn-ghost auto-inviteguests-mobile\" ng-click=gotoTickets()><span translate=EDIT_TICKET_BTN></span></button></div><div class=\"col-xs-6 col-md-6 align-right\"><div class=align-center style=\"display: inline-block\"><div><div style=\"font-size: 34px; line-height: 37px\">{{ guests.inviteCounts.inviteCount }}</div><div translate=EVENT_TXT_INVITED style=\"margin-bottom: 10px\"></div></div><button ng-if=\"event.status != \'CANCELLED\' && !isPastEvent(event)\" type=button class=\"btn btn-ghost auto-inviteguests-mobile\" ng-click=inviteGuests()><span translate=INVITE_MORE></span></button></div></div></div></div></section></div><div><section><div><div class=tickets-list-modal style=\"margin-top: 2px\"><div><div class=pick-tickets-item><div style=\"overflow: auto\"><div><strong style=\"padding-left: 1px\"><span>Add an optional question or request</span></strong></div><div style=\"font-size: 13px; color: #555\">Guests with tickets will see your question and be able to respond with a note per ticket.</div></div><div style=\"overflow: auto; margin-top: 10px\"><span ng-if=\"event.question && !event.addNote\" class=note-elipsis ng-bind-html=parseTagsToLinks(event.question)></span><div ng-if=!event.addNote style=\"float: right; color: #3677d9\" ng-click=\"event._question = removeLinks(event.question); event.addNote = true;\"><span ng-if=!event.question style=\"font-size: 12px; font-weight: 600; cursor: pointer\">Add question </span><span ng-if=event.question style=\"font-size: 12px; font-weight: 600; cursor: pointer\">Edit question </span><span style=\"margin-left: 5px; float: right; background: #e0e3e7; border-radius: 50%; text-align: center; width: 20px\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=10px height=10px viewBox=\"0 0 12 12\"><g transform=\"translate(0, 0)\"><path d=M11,5H7V1A1,1,0,0,0,5,1V5H1A1,1,0,0,0,1,7H5v4a1,1,0,0,0,2,0V7h4a1,1,0,0,0,0-2Z fill=#3677d9></path></g></svg></span></div></div><div ng-if=event.addNote class=ticket-note><textarea focus=true autoresize-textarea ng-model=event._question placeholder=\"Type a question or request\" style=\"width: 100%; border: 1px solid #ddd; padding: 8px; border-radius: 10px\" maxlength=250></textarea><div style=\"overflow: auto; margin-top: 3px\"><div style=\"float: left\" ng-click=\"event._question = \'\'; event.addNote = false; event.viewNote = false;\"><span style=\"font-size: 12px; font-weight: 600; color: #666; cursor: pointer\">Cancel</span></div><div style=\"float: right\" ng-click=\"event.question = createEmailLinks(event._question); event.viewNote = false; putQuestion(event);\"><span style=\"font-size: 12px; font-weight: 600; color: #eb004e; cursor: pointer\">Save question</span> <span style=\"margin-left: 5px; float: right; background: #eb004e; border-radius: 50%; text-align: center; width: 20px\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=10px height=10px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><path fill=#ffffff d=\"M14.3,2.3L5,11.6L1.7,8.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l4,4C4.5,13.9,4.7,14,5,14s0.5-0.1,0.7-0.3 l10-10c0.4-0.4,0.4-1,0-1.4S14.7,1.9,14.3,2.3z\"></path></g></svg></span></div></div></div></div></div></div></div></section></div><div><section><div class=\"is-relative search-input\"><input type=search class=\"form-control auto-searchguests-mobile\" placeholder=\"{{ \'SEARCH_TXT_MANAGE_GUESTS\' | translate }}\" ng-model=selectedSelectFilter.keyword ng-keyup=keywordKeyup() style=\"border: 1px solid #91969d!important\"> <span class=dripicons-search></span></div><div class=\"is-relative select-filter\"><select ng-model=selectedSelectFilter.type class=form-control ng-change=selectFilterChanged(selectedSelectFilter.type)><option translate=ALL_INVITED value=\"\"></option><option translate=ALL_PURCHASED value=ALL_PURCHASED></option><option translate=HAVENT_PURCHASED value=HAVENT_PURCHASED></option><option ng-repeat=\"type in guests.inviteCounts.ticketTypes\" value=\"{{ type.ticketName }}\">{{ type.ticketName }}</option></select><span class=\"dripicons-chevron-down select-arrow\"></span></div><div class=\"filter-links {{ !filteredItems || filteredItems.length == 0 ? \'f-links-disabled\' : \'\' }}\"><span class=\"icon dripicons-bell\" style=\"color: #4A9FF2\"></span> <a translate=SEND_NOTIFICATION_TO_SELECTED ng-click=sendNotification() class=auto-sendguestnotif-mobile></a></div><div ng-if=!isPastEvent(event) class=\"filter-links {{ !filteredItems || filteredItems.length == 0 || event.status == \'CANCELLED\' ? \'f-links-disabled\' : \'\' }}\"><span class=\"icon dripicons-skip\" style=\"color: #4A9FF2\"></span> <a translate=RESEND_INVITATION_TO_SELECTED ng-click=sendReminder()></a></div><div class=filter-links><span class=\"icon dripicons-download\" style=\"color: #4A9FF2\"></span> <a translate=DOWNLOAD_SELECTED_LIST ng-click=downloadList(true) style=\"line-height: 25px\"></a></div></section></div></div></div><div><section class=guests-list-mobile style=\"padding: 0\"><div class=\"row {{ guest.opened ? \'opened\' : \'\' }}\" ng-repeat=\"guest in (filteredItems = (guests.guestList | filterguests:selectedSelectFilter)) track by $index\"><div class=col-md-12 style=\"cursor: pointer; margin-bottom: 5px; float: none\"><figure ui-sref=\"classlist.details.contact({ \'id\': guest.userId })\" style=\"float: left; height: 40px; margin-right: 10px\"><avatar source=\"{{ guest.userAvatar }}\" width=40 height=40 name=\"{{ guest.userName }}\" my=false></avatar></figure><div><a class=name ui-sref=\"classlist.details.contact({ \'id\': guest.userId })\">{{ guest.userName }}</a></div><div style=\"overflow: auto\"><div style=\"float: left; max-width: 80%\">{{ guest.pupilNames }}</div></div></div><div style=\"margin-left: 14px; margin-right: 14px; margin-top: 10px\"><div class=tickets-resume><div ng-repeat=\"tick in guest.tickets\" style=\"border-bottom: 2px dashed #e5e5e5; padding-bottom: 10px\"><div><strong style=\"display: inline-block; max-width: 70%\">{{ tick.name }}</strong><div style=\"float: right; max-width: 30%\"><span>{{ tick.quantity }} x </span><span ng-show=tick.currency translate=\"{{ tick.currency }}_SHORT\"></span> <span>{{ tick.price > 0 ? (tick.price | currency: \"\") : (\'Free\') }}</span></div></div><div style=\"overflow: auto\"><div style=\"display: inline-block; width: 55%\"><div ng-if=\"tick.answers[0] && tick.answers[0].answer && tick.answers[0].answer.title\" style=\"min-height: 20px\"><div style=\"overflow: auto\"><span class=manage-guests-note>{{ tick.answers[0].answer.title }}</span></div><!-- <div ng-if=\"!tick.showNote\">\n                                            <a ng-click=\"tick.showNote = true;\" style=\"font-size: 12px; font-weight: 600;\">View note</a>\n                                        </div>\n                                        <div ng-if=\"tick.showNote\">\n                                            <a ng-click=\"tick.showNote = false;\" style=\"font-size: 12px; font-weight: 600;\">Hide note</a>\n                                        </div> --></div></div><span style=\"float: right; max-width: 45%; font-size: 13px; color: #666; text-align: right\"><div><span translate=PURCHASED_ON></span> <span>{{ tick.purchaseDate | date:\'MMM dd\' }}</span></div></span></div></div><div ng-if=\"guest.tickets && guest.total  > 0\" style=\"color: #000; font-weight: 600; text-align: right\"><div><span translate=TOTAL></span></div><div><span ng-show=guest.tickets[0].currency translate=\"{{ guest.tickets[0].currency }}_SHORT\"></span> <span>{{ guest.total | currency: \"\" }}</span></div><div><span></span></div></div></div></div></div></section></div></section>");
$templateCache.put("app/events/views/invite-guests.html","<script type=text/ng-template id=memberTemplate.html><div class=\"match-container\" style=\"padding: 0 5px;\">\n        <figure class=\"avatar\" style=\"float: left; height: 40px; margin-right: 13px;\">\n            <avatar source=\"{{match.model.avatar}}\" name=\"{{ match.model.field1 + \' \' + match.model.field2 }}\" width=\"40\" height=\"40\"></avatar>\n        </figure>\n        <div>\n            <div class=\"match-container-parentname\" style=\"float: none;\">\n                <span ng-bind-html=\"match.model.field1 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field1\"></span>\n                <span ng-bind-html=\"match.model.field2 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field2\"></span>\n            </div>\n            <div style=\"font-size: 13px; color: #777;\">\n                <span ng-bind-html=\"(m | uibTypeaheadHighlight:query) + ($last ? \'\' : \', \')\" ng-repeat=\"m in match.model.field3 track by $index\"></span>\n            </div>\n        </div>\n	</div></script><section class=\"invite-modal event-guests event-invite-guests\" ng-class=\"{\'is-visible\': viewState.isReady }\"><div class=\"page-view-header clearfix {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div style=\"padding: 0\"><div class=premium-ad-clear style=\"padding: 0 15px\"><div premium-ad></div></div><div style=\"position: relative; padding-right: 15px\" ng-click=back()><svg id=header-back-button class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg><div class=page-view-header__text><strong class=page-view-header__title>Invite guests</strong></div></div></div></div><div class=page-container-header-from-top><section><div><div translate=EVENT_INVITE_TEXT_3></div></div><div class=search><input style=\"height: 0px;border: 0;background: transparent\" type=text> <input type=text autocomplete=off autocorrect=off autocapitalize=off spellcheck=false ng-model=member placeholder=\"{{ \'INVITE_GUESTS_PLACEHOLDER\' | translate }}\" uib-typeahead=\"r.field1 for r in getMembers($viewValue)\" typeahead-wait-ms=300 typeahead-min-length=2 typeahead-on-select=pickMember($item) typeahead-template-url=memberTemplate.html class=\"form-control input-event-invite-members\"></div><br><div class=events-members-list style=\"padding: 0\"><div><div class=member ng-repeat=\"m in members track by $index\"><div><span ng-click=removeMember(m) class=\"dripicons-cross icon\"></span><figure class=avatar title=\"{{::m.name }}\" style=\"width: 40px !important; height: 40px !important\"><avatar style=\"min-width: 0 !important; min-height: 0 !important\" source={{m.avatar}} name=\"{{ m.name }}\" width=35 height=35 my=false title=\"{{ m.name }}\"></avatar></figure><span class=name style=\"float: none; margin: 0\">{{ m.name }}</span><div ng-if=m.pupils><label ng-repeat=\"p in m.pupils\" style=\"font-weight: normal; font-size: 12px\">{{ p.firstName }}<label ng-if=!$last style=\"font-weight: normal; font-size: 12px\">,&nbsp;</label></label></div><div ng-if=\"m.field3.length > 0\" style=\"max-width: 70%; float: left\"><label style=\"font-weight: normal; font-size: 12px\">{{ m.field3.join(\', \') }}</label></div></div></div></div></div><div><div><label style=\"margin-bottom: 10px\"><input ng-model=sendGuestNotification type=checkbox checked style=\"float: left\"> <span style=\"margin-left: 10px; line-height: 28px\" translate=SEND_NOTIF_TO_INVITEES></span></label></div><div translate=EVENT_INVITE_TEXT_1></div><br><div translate=EVENT_INVITE_TEXT_2></div></div><br><div><button type=button class=\"btn btn-primary\" translate=INVITE_BTN ng-disabled=\"members.length == 0 || invitingGuests\" ng-click=save()></div></section></div></section>");
$templateCache.put("app/events/views/invite-modal.html","<script type=text/ng-template id=memberTemplate.html><div class=\"match-container\" style=\"padding: 0 5px;\">\n        <figure class=\"avatar\" style=\"float: left; height: 40px; margin-right: 13px;\">\n            <avatar source=\"{{match.model.avatar}}\" name=\"{{ match.model.field1 + \' \' + match.model.field2 }}\" width=\"40\" height=\"40\"></avatar>\n        </figure>\n        <div>\n            <div class=\"match-container-parentname\" style=\"float: none;\">\n                <span ng-bind-html=\"match.model.field1 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field1\"></span>\n                <span ng-bind-html=\"match.model.field2 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field2\"></span>\n            </div>\n            <div style=\"font-size: 13px; color: #777;\">\n                <span ng-bind-html=\"(m | uibTypeaheadHighlight:query) + ($last ? \'\' : \', \')\" ng-repeat=\"m in match.model.field3 track by $index\"></span>\n            </div>\n        </div>\n	</div></script><div class=invite-modal style=\"padding: 10px; padding-right: 0\"><div class=modal-header><h3 translate=INVITE_GUESTS></h3><div translate=EVENT_INVITE_TEXT_3 style=\"margin-top: 10px\"></div></div><div class=modal-body><div class=search><input style=\"height: 0px;border: 0;background: transparent\" type=text> <input type=text autocomplete=off autocorrect=off autocapitalize=off spellcheck=false ng-model=member placeholder=\"{{ \'INVITE_GUESTS_PLACEHOLDER\' | translate }}\" uib-typeahead=\"r.field1 for r in getMembers($viewValue)\" typeahead-wait-ms=300 typeahead-min-length=2 typeahead-on-select=pickMember($item) typeahead-template-url=memberTemplate.html class=\"form-control input-event-invite-members\"></div></div><div class=events-members-list><div><div class=member ng-repeat=\"m in members track by $index\"><div><span ng-click=removeMember(m) class=\"dripicons-cross icon\"></span><figure class=avatar title=\"{{::m.name }}\" style=\"width: 40px !important; height: 40px !important\"><avatar style=\"min-width: 0 !important; min-height: 0 !important\" source={{m.avatar}} name=\"{{ m.name }}\" width=35 height=35 my=false title=\"{{ m.name }}\"></avatar></figure><span class=name style=\"float: none; margin: 0\">{{ m.name }}</span><div ng-if=m.pupils><label ng-repeat=\"p in m.pupils\" style=\"font-weight: normal; font-size: 12px\">{{ p.firstName }}<label ng-if=!$last style=\"font-weight: normal; font-size: 12px\">,&nbsp;</label></label></div><div ng-if=\"m.field3.length > 0\" style=\"max-width: 70%; float: left\"><label style=\"font-weight: normal; font-size: 12px\">{{ m.field3.join(\', \') }}</label></div></div></div></div></div><div class=modal-body><div><label style=\"margin-bottom: 10px\"><input ng-model=sendGuestNotification type=checkbox checked style=\"float: left\"> <span style=\"margin-left: 10px; line-height: 28px\" translate=SEND_NOTIF_TO_INVITEES></span></label></div><div translate=EVENT_INVITE_TEXT_1></div><br><div translate=EVENT_INVITE_TEXT_2></div></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=INVITE_BTN ng-disabled=\"members.length == 0 || invitingGuests\" ng-click=save()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/list.html","<div class=event-list-container><div class=\"page-view-header clearfix {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div><div premium-ad></div><div><div class=page-subheader-title><svg ng-click=goback() id=header-back-button class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <strong class=page-view-header__title translate=EVENTS_HEADER></strong><div class=pull-right style=\"margin-top: 7px\"><button ng-click=checkCreateEvent() class=\"btn btn-primary pull-right btn-primary-pink plus-button btn-primary-subheader\"><svg style=\"float: left; margin-top: 3px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=25px height=25px viewBox=\"0 0 48 48\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><line fill=none stroke=#ffffff stroke-width=4 stroke-linecap=round stroke-miterlimit=10 x1=24 y1=14 x2=24 y2=34 stroke-linejoin=round></line><line fill=none stroke=#ffffff stroke-width=4 stroke-linecap=round stroke-miterlimit=10 x1=34 y1=24 x2=14 y2=24 stroke-linejoin=round></line></g></svg> <span translate=CREATE_BTN style=\"margin-top: 0px; float: left\"></span></button></div></div></div></div></div><div class=page-container-header-from-top><div class=event-list style=\"margin-top: -10px\"><ng-include ng-if=showAppcueEventsInfo src=\"\'app/base/appcues/events-modal.html\'\"></ng-include><div class=event-empty-state-parent ng-if=viewState.isEmpty><!--Start emoji--> <svg class=emoji xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><line data-color=color-2 x1=20 y1=44 x2=44 y2=44 fill=none stroke=#4aa0f0 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></line><circle data-color=color-2 cx=19.5 cy=29.5 r=2.5 fill=none stroke=#4aa0f0 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></circle><circle data-color=color-2 cx=44.5 cy=29.5 r=2.5 fill=none stroke=#4aa0f0 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></circle><circle cx=32 cy=32 r=28 fill=none stroke=#4aa0f0 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></circle><circle data-color=color-2 data-stroke=none cx=19.5 cy=29.5 r=2.5 fill=#4aa0f0></circle><circle data-color=color-2 data-stroke=none cx=44.5 cy=29.5 r=2.5 fill=#4aa0f0></circle></g></svg><!--End emoji--><h4 class=empty-events translate=EMPTY_TITLE_EVENTS></h4><p class=empty-event-descr translate=EMPTY_DESCR_EVENTS></p></div><!--Draft events--><div><div ng-show=\"draft_events.length > 0\" translate=DRAFT_EVENTS></div><div class=event-items><section id={{e.title}} class=groups-list ng-repeat=\"e in draft_events\" ng-click=\"openEvent(e, true)\"><div class=group-box><div style=\"overflow: auto\"><div class=vi-row><div class=vi-col-left style=\"width: 75px; position: relative\"><div class=group-school-logo style=\"background-image: url(\'{{ e.imageURL }}\')\"></div></div><div class=vi-col-right><div style=\"padding-right: 10px; text-align: right\"><span class=number style=\"font-size: 12px; color: #8a94a2\">{{ ::e.startDate | date:\'MMM dd\' : \'GMT\' }}</span></div></div><div class=vi-col-middle><div><div class=group-names><div class=group-names-child><div class=group-name style=\"margin-bottom: 5px; word-break: break-word; text-overflow: initial; overflow: initial; white-space: initial\">{{ ::(e.title ? e.title : \'No title\') }}</div></div></div></div></div></div></div></div></section></div></div><!--Upcoming events--><div><div ng-show=\"new_events.length > 0\" translate=COMING_UP_EVENTS></div><div class=event-items><section id={{e.title}} class=groups-list ng-if=\"new_events.length > 0\" ng-repeat=\"e in new_events\" ng-click=openEvent(e)><div class=group-box><div style=\"overflow: auto\"><div class=vi-row><div class=vi-col-left style=\"width: 75px; position: relative\"><div class=group-school-logo style=\"background-image: url(\'{{ e.imageURL }}\')\"></div><div ng-if=e.soldOut><div class=group-school-logo-soldout-shadow></div><div class=group-school-logo-soldout style=\"background-image: url(\'assets/icons/sold_out_small.png\')\"></div></div></div><div class=vi-col-right><div style=\"padding-right: 10px; text-align: right\"><span class=number style=\"font-size: 12px; color: #8a94a2\">{{ ::e.startDate | date:\'MMM dd\' : \'GMT\' }}</span></div><div ng-if=\"e.notification && e.notification > 0\" class=circle-notif></div></div><div class=vi-col-middle><div><div class=group-names><div class=group-names-child><div class=group-name style=\"margin-bottom: 5px; word-break: break-word; text-overflow: initial; overflow: initial; white-space: initial\">{{ ::e.title }}</div></div></div></div></div></div></div></div></section></div></div><!--Past events--><div><div ng-if=\"past_events.length > 0\"><span ng-if=\"past_events.length > pastItemsLimit\" style=\"float: right; font-size: 12px;\n							padding: 6px 10px\">{{ pastItemsLimit ? pastItemsLimit : past_events.length }} <span translate=of></span> {{ past_events.length }} <span ng-show=pastItemsLimit style=\"margin-left: 10px\"><a ng-click=togglePastMore() translate=SHOW_ALL></a></span></span><div translate=PAST_EVENTS></div></div><section id={{e.title}} class=groups-list ng-if=\"past_events.length > 0\" ng-repeat=\"e in past_events | limitTo: pastItemsLimit\" ng-click=openEvent(e)><div class=group-box><div style=\"overflow: auto\"><div class=vi-row><div class=vi-col-left style=\"width: 75px; position: relative\"><div class=group-school-logo style=\"background-image: url(\'{{ e.imageURL }}\')\"></div><div ng-if=e.soldOut><div class=group-school-logo-soldout-shadow></div><div class=group-school-logo-soldout style=\"background-image: url(\'assets/icons/sold_out_small.png\')\"></div></div></div><div class=vi-col-right><div style=\"padding-right: 10px; text-align: right\"><span class=number style=\"font-size: 12px; color: #8a94a2\">{{ ::e.startDate | date:\'MMM dd\' : \'GMT\' }}</span></div></div><div class=vi-col-middle><div><div class=group-names><div class=group-names-child><div class=group-name style=\"margin-bottom: 5px; word-break: break-word; text-overflow: initial; overflow: initial; white-space: initial\">{{ ::e.title }}</div></div></div></div></div></div></div></div></section></div><aside ng-if=\"new_events.length === 0 && past_events.length === 0 && viewState.isReady\"><div class=col-sm-2></div><div class=\"col-sm-4 no-events-image\"><img alt=\"\" src=assets/images/no-events.svg></div><div class=\"col-sm-4 no-events-text\"><p translate=NO_EVENTS_TEXT></p></div><div class=col-sm-2></div></aside></div></div></div>");
$templateCache.put("app/events/views/live-confirm-modal.html","<div style=\"padding: 25px\"><div class=modal-body><img alt=\"\" src=assets/images/events-invites-sent.svg style=\"max-width: 100%\"><h3 translate=EVENT_SUCCESS_TITLE></h3><p translate=EVENT_SUCCESS_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=PREVIEW_EVENT_BTN ui-sref=\"events.view({\'id\': id})\"><button type=button class=\"btn btn-default pull-right\" translate=CONTINUE_EDITING_BTN ui-sref=\"events.create({\'id\': id})\"></div></div>");
$templateCache.put("app/events/views/location-modal.html","<div class=event-addlocation-modal style=\"padding: 10px; padding-right: 0\"><div class=modal-header><h3 translate=ADD_LOCATION></h3></div><div class=modal-body><div class=location-tabs><div translate=USE_SAVED_ADDRESS ng-click=switchAddress(false) class=\"{{ !tabNewAddress ? \'selected\' : \'\' }}\" ng-show=!tabNewAddress></div><div translate=ENTER_NEW_ADDRESS ng-click=switchAddress(true) class=\"{{ tabNewAddress ? \'selected\' : \'\' }}\"></div><div translate=USE_SAVED_ADDRESS ng-click=switchAddress(false) class=\"{{ !tabNewAddress ? \'selected\' : \'\' }}\" ng-show=tabNewAddress></div></div><div ng-show=!tabNewAddress><br><div class=saved-addresses><div ng-repeat=\"addr in savedAddresses\"><div class=vi-row ng-click=\"selectAddress(addr, $index)\"><div class=vi-col-left style=\"width: 40px\"><label><input type=checkbox ng-checked=\"$index == selectedAddress.index\" style=\"float: left\"></label></div><div class=vi-col-right><span ng-if=\"addr.id != 0\" ng-click=\"deleteAddress(addr, $index)\" class=\"icon dripicons-cross\"></span></div><div class=vi-col-middle><div>{{ addr.plainLocation }}</div></div></div></div></div></div><div ng-show=tabNewAddress><div><google-maps-autocomplete ng-model=event.g_location></div><br><div><label><input ng-model=saveAddressCheck type=checkbox checked style=\"float: left\"> <span style=\"margin-left: 10px; line-height: 28px\" translate=SAVE_FOR_LATER></span></label></div><div translate=EVENT_LOCATION_TEXT_1></div></div></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=CREATE_FOOTER_BTN ng-click=save() ng-disabled=\"!selectedAddress || addingLocation\"><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/payment-fail-modal.html","<div style=\"padding: 20px\"><div class=modal-header><h3 translate=PAYMENT_FAIL_HEADER></h3></div><div class=modal-body><p translate=PAYMENT_FAIL_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=TRY_AGAIN_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/payment-success-modal.html","<div style=\"padding: 20px\"><div class=modal-header><h3 translate=PAYMENT_SUCCESS_HEADER></h3></div><div class=modal-body><p translate=YOU_PURCHASED_TICKETS_FOR translate-values=\"{ \'eventName\': event.title, \'ticketsCount\': getTicketsCount(cofirmed_tickets.tickets) }\"></p><div class=tickets-list-modal ng-show=cofirmed_tickets.tickets><div class=\"row header\"><div class=\"col-md-6 col-xs-12 col-sm-12\"><span translate=TYPE></span></div><div class=\"col-md-2 col-xs-4 col-sm-4\"><span translate=PRICE></span></div><div class=\"col-md-2 col-xs-4 col-sm-4\"><span translate=QUANTITY></span></div><div class=\"col-md-2 col-xs-4 col-sm-4 align-right\"><span translate=TOTAL></span></div></div><div class=row ng-repeat=\"ticket in cofirmed_tickets.tickets\"><div class=\"col-md-6 col-xs-12 col-sm-12\"><span>{{ ticket.ticketTypeName }}</span></div><div class=\"col-md-2 col-xs-4 col-sm-4\"><span ng-show=cofirmed_tickets.currency translate={{cofirmed_tickets.currency}}_SHORT></span><span>{{ ticket.price | currency: \"\" }}</span></div><div class=\"col-md-2 col-xs-4 col-sm-4\"><span>{{ ticket.quantity }}</span></div><div class=\"col-md-2 col-xs-4 col-sm-4 align-right\"><span ng-show=cofirmed_tickets.currency translate={{cofirmed_tickets.currency}}_SHORT></span><span>{{ ticket.total | currency: \"\" }}</span></div></div><div class=total-label><div class=align-right><span ng-show=cofirmed_tickets.currency translate={{cofirmed_tickets.currency}}_SHORT></span><span>{{ cofirmed_tickets.total | currency: \"\" }}</span></div></div></div><br><div><a class=downtickets-link ng-click=downloadTickets(event.id) style=\"margin-top: 3px; background: #ddd!important; border-color: #ddd!important; color: #4a9fef!important\"><span class=\"icon dripicons-download\"></span> <span translate=DOWNLOAD_TICKETS></span></a></div><br><br></div><div class=modal-footer><button type=button class=\"btn btn-default pull-right\" translate=OK_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/payment-success.html","<section class=event-tickets ng-class=\"{\'is-visible\': viewState.isReady }\"><div class=\"page-view-header clearfix {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div><div premium-ad></div><div><div class=row><div class=col-md-12 style=\"position: relative\"><svg id=header-back-button ui-sref=\"events.view({\'id\': id_event})\" class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg></div></div></div></div></div><div class=\"body-container page-container-header-from-top\"><div ng-if=!isview><div class=tickets-header-circles><div class=step-circle style=\"float: left\"><svg style=\"transform: rotate(90deg)\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=26px height=26px viewBox=\"0 0 48 48\" stroke-width=3><g stroke-width=3 transform=\"translate(0.5, 0.5)\"><path d=M40,24a6.018,6.018,0,0,1,6-6V8H2V18A6,6,0,0,1,2,30V40H46V30A6.018,6.018,0,0,1,40,24Z fill=none stroke=#8a94a2 stroke-linecap=square stroke-miterlimit=10 stroke-width=3 stroke-linejoin=miter></path><rect data-color=color-2 x=15 y=18 width=18 height=12 fill=none stroke=#8a94a2 stroke-linecap=square stroke-miterlimit=10 stroke-width=3 stroke-linejoin=miter></rect></g></svg></div><div class=step-circle style=\"float: right\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=26px height=26px viewBox=\"0 0 64 64\" stroke-width=3><g stroke-width=3 transform=\"translate(0.5, 0.5)\"><polyline data-color=color-2 fill=none stroke=#3677d9 stroke-width=3 stroke-linecap=square stroke-miterlimit=10 points=\" 25,35 30,40 40,30 \" stroke-linejoin=miter></polyline><polyline fill=none stroke=#3677d9 stroke-width=3 stroke-linecap=square stroke-miterlimit=10 points=\"49,11 57,11 57,62 7,62 7,11 15,11 \" stroke-linejoin=miter></polyline><path fill=none stroke=#3677d9 stroke-width=3 stroke-linecap=square stroke-miterlimit=10 d=\"M39,9c0-3.866-3.134-7-7-7 s-7,3.134-7,7h-5v8h24V9H39z\" stroke-linejoin=miter></path><circle data-stroke=none fill=#3677d9 cx=32 cy=9 r=2 stroke-linejoin=miter stroke-linecap=square></circle><polyline data-color=color-2 fill=none stroke=#3677d9 stroke-width=3 stroke-linecap=square stroke-miterlimit=10 points=\" 51,17 51,56 13,56 13,17 \" stroke-linejoin=miter></polyline></g></svg></div><div class=dash-separator></div><div style=\"margin-top: 32px;\n						font-size: 10px;\n						font-weight: 600;\n						color: #666\"><span style=\"float: left; margin-left: -18px\">Select tickets</span> <span style=\"float: right; margin-right: -38px; color: #3677d9\">Confirmation & Notes</span></div></div></div><!-- <div ng-if=\"!isview\">\n			<h1 ng-if=\"event.tickets[0].ticketPrice == 0\" translate=\"PAYMENT_SUCCESS_HEADER\"\n				style=\"margin-bottom: 5px; line-height: 26px;\"></h1>\n			<h1 ng-if=\"event.tickets[0].ticketPrice > 0 && event.paymentProvider != \'stripe\'\"\n				translate=\"PAYMENT_SUCCESS_HEADER_PAID\" style=\"margin-bottom: 5px; line-height: 26px;\"></h1>\n\n			<h1 ng-if=\"event.tickets[0].ticketPrice > 0 && event.paymentProvider == \'stripe\'\"\n				translate=\"PAYMENT_SUCCESS_STRIPE_HEADER_PAID\" style=\"margin-bottom: 5px; line-height: 26px;\"></h1>\n		</div> --><div ng-if=!isview style=\"font-weight: normal\"><p ng-if=\"event.tickets.length === 0 || event.tickets[0].ticketPrice == 0\" translate=YOU_PURCHASED_TICKETS_FOR translate-values=\"{ \'eventName\': event.title, \'ticketsCount\': event.tickets.length }\" style=\"font-size: 13px\"></p><p ng-if=\"event.tickets[0].ticketPrice  > 0 && event.paymentProvider != \'stripe\'\" translate=YOU_PURCHASED_TICKETS_FOR_PAID translate-values=\"{ \'eventName\': event.title, \'ticketsCount\': event.tickets.length }\" style=\"font-size: 13px\"></p><p ng-if=\"event.tickets[0].ticketPrice  > 0 && event.paymentProvider == \'stripe\'\" translate=YOU_PURCHASED_TICKETS_FOR_PAID_STRIPE translate-values=\"{ \'eventName\': event.title, \'ticketsCount\': event.tickets.length }\" style=\"font-size: 13px\"></p><h2 ng-if=hasQuestions style=\"font-weight: bold !important; font-size: 20px\" translate=YOU_PURCHASED_TICKETS_COMPLETE_ORDER></h2><div style=\"height: 1px;\n					background: #e5e5e5;\n					margin-top: 10px;\n					margin-bottom: 10px\"></div></div><div class=\"tickets-list-modal pick-tickets-section\" ng-show=event.tickets style=\"margin-top: 2px\"><div ng-repeat=\"ticket in event.tickets track by $index\"><!-- Return the free ticket START --><div ng-click=\"returnTicket(ticket.id, $index)\" ng-if=\"ticket.ticketPrice == 0\" style=\"color: #3677d9; margin-bottom: 7px; text-align: right\"><span class=\"icon dripicons-return\"></span><span translate=RETURN_TICKET style=\"font-size: 12px;\n							margin-left: 5px;\n							font-weight: bold;\n							cursor: pointer\"></span></div><!-- Return the free ticket END --><div class=pick-tickets-item><div style=\"overflow: auto\"><strong style=\"float: left; padding-left: 1px\"><svg style=\"float: left; margin-right: 10px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=20px height=20px viewBox=\"0 0 32 32\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><rect data-color=color-2 x=10 y=12 fill=none stroke=#8a94a2 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 width=12 height=8 stroke-linejoin=miter></rect><path fill=none stroke=#8a94a2 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M27,16c0-2.209,1.791-4,4-4 V5H1v7c2.209,0,4,1.791,4,4c0,2.209-1.791,4-4,4v7h30v-7C28.791,20,27,18.209,27,16z\" stroke-linejoin=miter></path></g></svg> <span>{{ ticket.ticketName }} </span></strong><strong style=\"font-size: 15px; float: right\" ng-if=\"ticket.ticketPrice === 0\"><span>FREE</span> </strong><strong style=\"font-size: 15px; float: right\" ng-if=\"ticket.ticketPrice !== 0\"><span ng-show=ticket.ticketCurrency translate=\"{{ ticket.ticketCurrency }}_SHORT\"></span><span>{{ ticket.ticketPrice | currency: \"\" }}</span></strong></div><div style=\"overflow: auto; margin-top: 10px\"><!-- FOR LOOP FOR NOTES --><div style=\"overflow: auto\" ng-repeat=\"singleNote in ticket.questions\"><div style=\"border-top: 1px solid #e9e9e9\"></div><div style=\"margin-top: 7px\"><div style=\"font-weight: bold; font-size: 16px\">{{singleNote.questionTitle}}</div><span ng-if=\"singleNote.answerTitle && !singleNote.addAnswer\">{{ singleNote.answerTitle }}</span><div ng-if=!singleNote.addAnswer style=\"color: #3677d9; margin-bottom: 7px\" ng-click=\"singleNote._answer = singleNote.answerTitle; singleNote.addAnswer = true;\"><span translate=ADD_NOTE ng-if=!singleNote.answerTitle style=\"font-size: 12px; font-weight: 600; cursor: pointer\"></span> <span translate=EDIT_NOTE ng-if=singleNote.answerTitle style=\"font-size: 12px; font-weight: 600; cursor: pointer\"></span></div></div><!-- EXPANDED PANEL --><div style=\"margin-top: 5px; margin-bottom: 5px\" ng-if=singleNote.addAnswer class=ticket-note><textarea focus=true autoresize-textarea ng-model=singleNote._answer ng-trim=false placeholder=\"Answer question\" style=\"width: 100%;\n										border: 1px solid #ddd;\n										padding: 8px;\n										border-radius: 10px\" maxlength=250></textarea><div class=counter style=\"font-size: 14px; color: #627293; text-align: right\">{{ singleNote._answer ? singleNote._answer.length : 0 }} / 250</div><div style=\"overflow: auto; margin-top: 3px\"><div style=\"float: left\" ng-click=\"singleNote._answer= \'\'; singleNote.addAnswer = false; singleNote.addAnswer = false;\"><span style=\"font-size: 12px;\n												font-weight: 600;\n												color: #666;\n												cursor: pointer\">Cancel</span></div><div style=\"float: right\" ng-click=\"singleNote.answerTitle = singleNote._answer; putNote(ticket.id, singleNote);\"><span style=\"font-size: 12px;\n												font-weight: 600;\n												color: #eb004e;\n												cursor: pointer\">Save answer</span></div></div></div><!-- EXPANDED PANEL END --></div></div></div></div></div><br><p class=inbox translate=THANK_YOU></p><p class=inbox translate=YOU_PURCHASED_TICKETS_COMPLETE_ORDER_CHECK_YOUR_EMAIL></p><br><div style=\"text-align: center\" ng-if=\"event.tickets.length !== 0\"><button class=\"btn btn-primary btn-primary-pink\" type=button ng-click=downloadTickets(id_event) style=\"margin-top: 3px;\n					background: #ddd !important;\n					border-color: #ddd !important;\n					color: #4a9fef !important\"><span translate=DOWNLOAD_TICKETS></span></button></div><div style=\"height: 1px;\n				background: #e5e5e5;\n				margin-top: 10px;\n				margin-bottom: 10px\"></div><div style=\"text-align: center\"><a class=downtickets-link href=#/events/view/{{id_event}}><span translate=BACK_TO_EVENTS></span></a></div></div></section>");
$templateCache.put("app/events/views/remove-ticket-type-modal.html","<div style=\"padding: 15px\"><div class=modal-header><h3 translate=CONFIRM_REMOVE_TICKET_TYPE_HEADER></h3></div><div class=modal-body><p translate=CONFIRM_REMOVE_TICKET_TYPE_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-ghost pull-right\" translate=REMOVE_BTN ng-click=confirm()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=cancel()></div></div>");
$templateCache.put("app/events/views/remove-volunteer-modal.html","<div><div class=modal-header><h3 translate=REMOVE_VOLUNTEER_HEADER></h3></div><div class=modal-body><p translate=REMOVE_VOLUNTEER_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=YES_REMOVE_BTN ng-click=save() ng-disabled=removingVolunteer><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/return-ticket-modal.html","<div style=padding:20px><div class=modal-header><h3 translate=RETURN_TICKET_HEADER></h3></div><div class=modal-body><p translate=RETURN_TICKET_CONTENT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=YES_CANCEL_BTN ng-click=continue()><button type=button class=\"btn btn-default pull-right\" translate=NO_THANKS_BTN ng-click=close()></button></button></div></div>");
$templateCache.put("app/events/views/rota.html","<section class=event-view add-guests ng-class=\"{ \'is-visible\': viewState.isReady }\" post-likes><div class=\"page-view-header clearfix {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div style=\"padding: 0\"><div class=premium-ad-clear style=\"padding: 0 15px\"><div premium-ad></div></div><div><div style=\"position: relative\"><svg id=header-back-button ng-click=goback() class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg></div><strong class=\"page-view-header__title elipsis-text\" style=\"max-width: 95%; overflow: hidden\" translate=SIGNUP></strong></div></div></div><div><section class=rota-section><div class=section-header><h4 style=\"margin-bottom: 4px\">{{ rota.title }}</h4><p ng-if=rota.timeBased style=\"font-weight: 600; color: #6d7279\">{{ rota.startDate | date: \'h:mm a\' : \'GMT\' }} - {{ rota.endDate | date: \'h:mm a\' : \'GMT\' }}</p><p ng-if=rota.timeBased style=\"font-weight: 600; color: #6d7279\">{{ rota.startDate | date: \'MMM dd, yyyy\'}}</p><br><p ng-if=rota.description style=\"margin-bottom: 10px\">{{ rota.description }}</p></div><br><div class=section-header><h5 translate=TASKS_AND_SLOTS></h5></div><div ng-if=\"!tasksList || tasksList.length == 0\"><span style=\"font-size: 16px; opacity: .6; padding: 10px 0\" translate=NO_TASKS_AVAILABLE></span></div><div class=rota-tasks-list><div ng-repeat=\"task in tasksList\"><div ng-click=loadSlots(task) class=vi-row><div class=\"vi-col-right task-expand-icon\"><svg class=\"{{ task.expanded ? \'expanded\' : \'\' }}\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=12px height=12px viewBox=\"0 0 12 12\"><g transform=\"translate(0, 0)\"><path d=M10.293,3.293,6,7.586,1.707,3.293A1,1,0,0,0,.293,4.707l5,5a1,1,0,0,0,1.414,0l5-5a1,1,0,1,0-1.414-1.414Z fill=#8A94A2></path></g></svg></div><div class=vi-col-middle><div style=\"padding-left: 4px\"><strong>{{ task.title }}</strong><p ng-if=task.description>{{ task.description }}</p><p style=\"color: #6d7279\">{{ task.totalVolunteerNeeded }} <span translate=SPACES></span></p></div></div></div><div class=\"rota-slots-list {{ task.expanded ? \'expanded\' : \'\' }}\"><div ng-repeat=\"slot in task.slots\" class=\"{{ slot.bookedByMe ? \'booked-slot\' : \'\' }}\"><div class=\"slot-item {{ slot.totalPlaces == slot.bookedPlaces ? \'full\' : \'available\' }}\"><div class=vi-row><div class=\"vi-col-left rota-slot-timer\"><div><p><span ng-if=task.timeBased>{{ ::slot.startDate | date: \'HH:mm\' : \'GMT\' }}</span> <span ng-if=!task.timeBased>-- : --</span></p><p><span ng-if=task.timeBased>{{ ::slot.endDate | date: \'HH:mm\' : \'GMT\' }}</span> <span ng-if=!task.timeBased>-- : --</span></p></div></div><div class=vi-col-middle><div style=\"padding-left: 3px\"><div style=\"display: inline-block\"><div class=available-slots-count><p>{{ (slot.totalPlaces - slot.bookedPlaces) }} / {{ ::slot.totalPlaces }}</p><label translate=SPACES></label></div><div class=full-slots-count><p translate=FULL></p></div></div><div style=\"float: right; width: 100px; height: 38px\"><div ng-if=\"!slot.bookedByMe && (slot.bookedPlaces < slot.totalPlaces)\" ng-click=\"signUpSlot(rota, task, slot, true)\" class=\"rota-button rota-signup-button {{ slot.signinup ? \'disabled\' : \'\' }}\" translate=SIGN_UP></div><div ng-if=slot.bookedByMe style=\"text-align: center\"><div class=you-booked>Booked!</div><div ng-if=slot.bookedByMe ng-click=\"signUpSlot(rota, task, slot, false)\" class=\"rota-button rota-signout-button {{ slot.signinup ? \'disabled\' : \'\' }}\" translate=REMOVE_BTN></div></div></div></div></div></div></div><div class=slot-volunteer><div ng-repeat=\"volunteer in slot.volunteers | orderBy:customOrder\" class=vi-row><div class=vi-col-left style=\"width: 40px; padding-right: 0\"><figure style=\"float: left; width: 30px; height: 30px; margin-right: 10px\"><avatar source={{volunteer.avatar}} name=\"{{ volunteer.firstName }} {{ volunteer.lastName }}\" width=30 height=30 my=false></avatar></figure></div><div class=vi-col-middle><div style=\"padding-left: 3px; {{ volunteer.comment ? \'line-height: 20px;\' : \'\' }}\"><b><a href=\"#/classlist/details/{{ volunteer.userId }}/contact\">{{ currentUserId === volunteer.userId ? \'You\' : (volunteer.firstName + \' \' +volunteer.lastName) }}</a></b></div><div style=\"line-height: 20px\"><i>{{ ::volunteer.comment }}</i></div></div></div></div><br><div ng-if=slot.bookedByMe class=slot-comment><div class=event-input><!-- <label>Add a comment</label> --><textarea id=event-description ng-model=slot.myComment maxlength=200 autoresize-textarea placeholder=\"Add a comment\"></textarea></div><div style=\"text-align: left\"><div ng-click=\"saveSlotComment(rota, task, slot)\" class=\"rota-button rota-signup-button\" style=\"display: inline-block; margin-left: 0\" translate=SAVE_COMMENT></div></div></div></div></div></div></div></section></div></section>");
$templateCache.put("app/events/views/send-notification-modal.html","<div><div class=modal-header><h3 translate=SEND_NOTIFICATION_HEADER></h3></div><div class=modal-body><div><textarea ng-model=notif_note autoresize-textarea placeholder=\"{{\'WRITE_NOTE\' | translate }}\" style=\"border: 1px solid #91969d; padding: 10px; width: 100%\" maxlength=500></textarea></div><p translate=SEND_GUEST_NOTIFICATION_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=SEND_BTN ng-click=send() ng-disabled=\"!notif_note || sendingNotification\"><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/send-reminder-modal.html","<div style=\"padding: 15px\"><div class=modal-header><h3 translate=SEND_REMINDER_TITLE></h3></div><div class=modal-body><p translate=SEND_REMINDER_DESCR></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=SEND_BTN ng-click=send()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/show-event-owners-dialog.html","<div class=\"messages show-participants scrollbar-enabled\" ng-class=\"{\'is-visible\':viewState.isReady}\"><ul class=basket><li ng-repeat=\"p in owners track by $index\"><div class=vi-row><div class=vi-col-left style=\"width: 55px\"><figure ng-if=!p.staff ui-sref=\"classlist.details.contact({ \'id\': p.id })\" style=\"float: left; height: 40px; margin-right: 10px\"><avatar source={{p.avatar}} name=\"{{ p.firstName + \' \' + p.lastName }}\" width=40 height=40 my=false></avatar></figure><figure ng-if=p.staff style=\"float: left; height: 40px; margin-right: 10px; cursor: auto\"><avatar source={{p.avatar}} name=\"{{ p.firstName + \' \' + p.lastName }}\" width=40 height=40 my=false></avatar></figure></div><div class=vi-col-middle><h4 ng-if=!p.staff ui-sref=\"classlist.details.contact({ \'id\': p.id })\" class=event-owner-popup-profile>{{ p.firstName + \' \' + p.lastName }}</h4><h4 ng-if=p.staff>{{ p.firstName + \' \' + p.lastName }}</h4></div></div></li></ul></div>");
$templateCache.put("app/events/views/show-participants-dialog.html","<div class=\"messages show-participants scrollbar-enabled\" add-participants ng-class=\"{\'is-visible\':viewState.isReady}\"><ul class=basket><li ng-repeat=\"p in participants track by $index\"><div class=participant style=\"height: auto; min-height: 50px\"><figure class=avatar><avatar source={{p.avatar}} name=\"{{ p.firstName + \' \' + p.lastName }}\" width=40 height=40></avatar></figure><div class=\"{{ p.tickets ? \'two-lines-height\' : \'\' }}\"><div style=\"{{ p.pupilNames ? \'line-height: 20px;\' : \'line-height: 37px;\' }}\">{{ p.firstName }} {{ p.lastName }}</div><div ng-if=p.pupilNames style=\"line-height: 17px; font-size: 12px; color: #777\">{{ p.pupilNames }}</div><span ng-if=\"p.tickets && !isCommunityEvent\"><span class=dripicons-ticket></span> {{ p.tickets }} <span translate=TICKETS_LABEL></span></span></div></div></li></ul><a class=add-participant ng-click=\"close(); openAddParticipantsModal()\" ng-if=!addDisabled><span class=dripicons-plus></span> <span translate=ADD_RECIPIENT_BTN ng-if=!eventContext></span> <span translate=ADD_GUESTS_BTN ng-if=eventContext></span></a></div>");
$templateCache.put("app/events/views/stopdownload-modal.html","<div><div class=modal-body><p translate=STOPDOWNLOAD_GUESTS_TEXT_1></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=OK_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/tickets.html","<section class=event-tickets ng-class=\"{\'is-visible\': viewState.isReady }\"><div class=\"page-view-header clearfix {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div><div premium-ad></div><div><div class=row><div class=col-md-12 style=\"position: relative\"><svg id=header-back-button ng-click=decideGoBack() class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg><div class=\"page-view-header__text pull-left\"><strong ng-if=\"event.title && viewState.isReady\" class=page-view-header__title>{{ event.title }}</strong> <strong ng-if=\"!event.title && viewState.isReady\" class=page-view-header__title translate=NO_TITLE></strong></div></div></div></div></div></div><div class=\"body-container page-container-header-from-top\"><h1 style=\"margin-bottom: 10px !important\" ng-if=!disableTicketing translate=CREATE_TICKET_FOR_EVENT_TEXT></h1><h1 ng-if=disableTicketing translate=EDIT_TICKET_FOR_EVENT></h1><div ng-show=\"ticket.is_free && selectedTicketType\"><div class=\"row tickets-header visible-md visible-lg\"><div class=\"col-md-4 col-xs-12\"><span translate=TICKET_NAME></span></div><div class=\"col-md-4 col-xs-6\"><span translate=CAPACITY></span></div></div><div class=\"row tickets-list\" ng-repeat=\"free_item in ticket.free_list\"><div class=\"col-md-4 col-xs-6\"><div class=\"tickets-header hidden-md hidden-lg\"><span translate=TICKET_NAME></span></div><input type=text ng-model=free_item.ticketName autocomplete=off class=form-control placeholder=\"{{ \'EG_ADULT_FAMILY\' | translate }}\" style=\"margin-bottom: 8px; {{ invalidTicketInfo && !free_item.ticketName ? \'border-bottom: 2px solid red;\' : \'\' }}\"></div><div class=\"col-md-4 col-xs-6\"><div class=\"tickets-header hidden-md hidden-lg\"><span translate=CAPACITY></span></div><input type=number ng-model=free_item.availableTicket remove-chars=number min=0 autocomplete=off class=form-control placeholder=\"{{ \'EG_QUANTITY_OF_TICKETS\' | translate }}\" style=\"{{ invalidTicketInfo && !free_item.availableTicket ? \'border-bottom: 2px solid red;\' : \'\' }}\"></div><div class=\"col-md-2 col-xs-12\" style=\"width: 100%; font-size: 12px; color: gray\"><div ng-if=\"free_item.sold > 0\">Sold: {{free_item.sold}}</div><div ng-if=\"free_item.pending > 0\">Payment transfer pending: {{free_item.pending}}</div><div ng-if=\"free_item.inProgress > 0\">Tickets in basket: {{free_item.inProgress}}</div></div><div class=\"col-md-4 col-xs-12\"><div ng-if=\"ticket.free_list.length>1\" style=\"padding-top: 4px\"><div ng-click=\"removeTicket($index, free_item)\" style=\"display: inline-block; cursor: pointer; background: #e0e3e7; padding: 5px 15px; border-radius: 20px\"><span style=\"color: #3677d9; font-size: 13px; font-weight: 600\">Delete</span></div></div></div></div><div style=\"margin-top: 20px; text-align: center\"><button type=button class=\"btn btn-ghost\" ng-click=addTicket($event)><span translate=ADD_NEW_TICKET></span></button></div></div><div ng-show=\"!ticket.is_free && selectedTicketType\"><div class=\"row tickets-header visible-md visible-lg\"><div class=\"col-md-4 col-xs-12\"><span translate=TICKET_NAME></span></div><div class=\"col-md-3 col-xs-6\"><span translate=EVENT_PRICE_PER_TICKET></span></div><div class=\"col-md-4 col-xs-6\"><span translate=CAPACITY></span></div></div><div class=\"row tickets-list\" ng-repeat=\"paid_item in ticket.paid_list\"><div class=\"col-md-4 col-xs-12\"><div class=\"tickets-header hidden-md hidden-lg\"><span translate=TICKET_NAME></span></div><input autocomplete=off ng-model=paid_item.ticketName type=text class=form-control placeholder=\"{{ \'EG_ADULT_FAMILY\' | translate }}\" style=\"{{ invalidTicketInfo && !paid_item.ticketName ? \'border-bottom: 2px solid red;\' : \'\' }}\"></div><div class=\"col-md-3 col-xs-6\"><div class=\"tickets-header hidden-md hidden-lg\"><span translate=EVENT_PRICE_PER_TICKET></span></div><input type=number ng-model=paid_item.ticketPrice remove-chars=money min=1 autocomplete=off class=form-control placeholder=\"{{ \'EG_PRICE_PER_TICKET\' | translate }}\" style=\"margin-bottom: 8px; {{ invalidTicketInfo && !paid_item.ticketPrice ? \'border-bottom: 2px solid red;\' : \'\' }}\"></div><div class=\"col-md-4 col-xs-6\"><div class=\"tickets-header hidden-md hidden-lg\"><span translate=CAPACITY></span></div><input type=number ng-model=paid_item.availableTicket remove-chars=number min=0 autocomplete=off class=form-control placeholder=\"{{ \'EG_QUANTITY_OF_TICKETS\' | translate }}\" style=\"{{ invalidTicketInfo && !paid_item.availableTicket ? \'border-bottom: 2px solid red;\' : \'\' }}\"></div><div class=\"col-md-2 col-xs-12\" style=\"width: 100%; font-size: 12px; color: gray\"><div ng-if=\"paid_item.sold > 0\">Sold: {{paid_item.sold}}</div><div ng-if=\"paid_item.pending > 0\">Payment transfer pending: {{paid_item.pending}}</div><div ng-if=\"paid_item.inProgress > 0\">Tickets in basket: {{paid_item.inProgress}}</div></div><br class=\"hidden-md hidden-lg\"><div class=\"col-md-2 col-xs-12\" style=\"width: 100%\"><div ng-if=\"ticket.paid_list.length>1\" style=\"padding-top: 4px\"><div ng-click=\"removeTicket($index, paid_item)\" style=\"display: inline-block; cursor: pointer; background: #e0e3e7; padding: 5px 15px; border-radius: 20px\"><span style=\"color: #3677d9; font-size: 13px; font-weight: 600\">Delete</span></div></div><br></div></div><div style=\"margin-top: 20px; text-align: center\"><button type=button class=\"btn btn-ghost\" ng-click=addTicket($event)><span translate=ADD_NEW_TICKET></span></button></div></div></div><br><div class=body-container ng-if=selectedTicketType><div class=\"tickets-list-modal pick-tickets-section\" style=\"margin-top: 2px\"><div><div class=pick-tickets-item><div style=\"overflow: auto\"><div><strong style=\"padding-left: 1px\"><span>Add an optional question or request</span></strong></div><div style=\"font-size: 13px; color: #9B9B9B\">Guests with tickets will see your question and be able to respond with a note per ticket.</div></div><div class=ticket-note style=\"margin-top: 10px\"><textarea autoresize-textarea ng-model=event.question placeholder=\"Type a question or request\" style=\"width: 100%; border: 1px solid #ddd; padding: 8px; border-radius: 10px\" maxlength=500></textarea></div></div></div></div></div><br><div class=body-container ng-if=selectedTicketType><div ng-show=!ticket.is_free class=row><div class=col-md-6><label><input ng-model=checkTerms type=checkbox checked style=\"float: left\"> <span style=\"margin-left: 10px; line-height: 28px\" translate=SELLING_TICKETS></span></label></div><div class=col-md-6><div><input ng-model=ticket.paypalEmail autocomplete=off type=text class=form-control placeholder=\"{{ \'EVENT_PAYPAL_EMAIL_PHOLDER\' | translate }}\"></div><br><div><input ng-model=paypalRepeatEmail autocomplete=off type=text class=form-control placeholder=\"{{ \'EVENT_PAYPAL_EMAIL_REPEAT_PHOLDER\' | translate }}\"><div translate=EVENT_UPDATE_MESSAGE></div></div><div ng-if=\"ticket.paypalEmail && paypalRepeatEmail && (!validateEmail(ticket.paypalEmail) || (ticket.paypalEmail != paypalRepeatEmail))\" style=\"margin-top: 10px; color: red; font-size: 13px\"><span translate=ERROR_INVALID_NOTMACHING_EMAIL></span></div><p translate=EVENT_TICKET_TC></p></div></div><div ng-show=ticket.is_free style=\"text-align: center\"><div style=\"margin-bottom: 10px\"><button type=button class=\"btn btn-primary btn-primary-pink auto-create-free\" ng-disabled=\"!ticket.checkValidation(false) || creatingTickets\" ng-click=save() style=\"width: 100%; max-width: 300px; margin: auto\"><span ng-if=!disableTicketing translate=CREATE_BTN></span> <span ng-if=disableTicketing translate=UPDATE_BTN></span></button></div><div><button type=button class=\"btn btn-default\" ui-sref=\"events.create({\'id\': id_event})\" style=\"width: 100%; max-width: 300px; margin: auto\"><span translate=CANCEL_BTN></span></button></div></div><div ng-show=!ticket.is_free style=\"text-align: center\"><div style=\"margin-bottom: 10px\"><button id=create_paid_tickets_button ng-show=!ticket.is_free type=button class=\"btn btn-primary btn-primary-pink auto-create-paid\" ng-disabled=\"!ticket.checkValidation(false) || !validateEmail(ticket.paypalEmail) || creatingTickets || !checkTerms || (ticket.paypalEmail != paypalRepeatEmail)\" ng-click=save() style=\"width: 100%; max-width: 300px; margin: auto\"><span ng-if=!disableTicketing translate=CREATE_BTN></span> <span ng-if=disableTicketing translate=UPDATE_BTN></span></button></div><div><button id=cancel_paid_tickets_button type=button class=\"btn btn-default\" ui-sref=\"events.create({\'id\': id_event})\" style=\"width: 100%; max-width: 300px; margin: auto\"><span translate=CANCEL_BTN></span></button></div></div></div></section>");
$templateCache.put("app/events/views/update-notification-modal.html","<div style=\"padding: 25px\"><div class=modal-header><h3 translate=EVENT_UPDATE_TITLE></h3></div><div class=modal-body><p translate=EVENT_UPDATE_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=YES_PLEASE ng-click=sendNotification()><button type=button class=\"btn btn-default pull-right\" translate=NO_THANKS ng-click=close()></div></div>");
$templateCache.put("app/events/views/view.html","<section class=event-view add-guests ng-class=\"{ \'is-visible\': viewState.isReady }\" post-likes><div class=\"page-view-header clearfix {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div style=\"padding: 0\"><div class=premium-ad-clear style=\"padding: 0 15px\"><div premium-ad></div></div><div><div style=\"position: relative\"><svg id=header-back-button ng-click=goToEvents() class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg></div><strong class=\"page-view-header__title elipsis-text\" style=\"max-width: 95%; overflow: hidden\">{{event.title}}</strong></div></div></div><div style=\"margin-top: -3px\"><div ng-if=showInfoPast style=\"margin-top: 20px\"><div class=yellow-tooltip style=\"margin-bottom: 0\"><span ng-click=closeInfo() class=dripicons-cross></span><div><span translate=PAST_EVENT_INFO></span></div></div><br></div><div><div style=\"padding: 0!important\"><div class=event-picture-container><div style=\"padding: 16px; text-align: center\"><h1 style=\"font-size: 22px; font-weight: normal; margin: 0; color: #404040; margin-bottom: 7px; color: #005cb8; font-size: 20px; font-weight: 600\">{{ event.title }}</h1><ul class=details-attachment-list style=\"font-size: 15px; color: #6d7279\"><li style=\"padding: 3px\"><span style=\"line-height: 22px\">{{ event.date.startDate | date:\'EEEE,\' : \'GMT\' }} <span style=\"font-weight: 600\">{{ event.date.startDate | date:\'MMM dd\' : \'GMT\' }}</span> <span translate=AT></span> <span style=\"font-weight: 600\">{{ event.date.startDate | date:\'h:mm a\' : \'GMT\' }}</span> <span ng-show=\"event.date.endDate && event.date.startDate !== event.date.endDate && event.date.sameDay\"><span>-</span> {{ event.date.endDate | date:\'h:mm a\' : \'GMT\' }}</span></span></li></ul></div><div class=event-picture><div class=img ng-if=event.fileLibrary.image style=\"background-image: url(\'{{ event.fileLibrary.image }}\')\"></div><div ng-if=!event.fileLibrary.image class=img style=\"background-image: url(\'https://storage.googleapis.com/classlist-branding/app-assets/no-events.svg\')\"></div><div ng-if=event.soldOut><div class=sold-out-label></div><img alt=\"\" class=sold-out-picture src=assets/icons/sold_out.png></div></div><div style=\"padding: 16px; text-align: center\"><p ng-show=event.description style=\"word-break: break-word; padding: 0; text-align: center; margin-top: 0; font-size: 16px;\n						color: #627293\" ng-bind-html=event.description></p><div><div class=section-tickets ng-if=event.ticketed><div><span ng-if=!event.tickets translate=NO_TICKETS_YET></span> <a ng-if=event.tickets class=downtickets-link ng-click=showTickets() style=\"display: inline-block; margin-bottom: 15px\"><svg style=\"float: left; margin-right: 10px; margin-top: 4px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=18px height=18px viewBox=\"0 0 32 32\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><rect data-color=color-2 x=10 y=12 fill=none stroke=#4a9fef stroke-width=2 stroke-linecap=square stroke-miterlimit=10 width=12 height=8 stroke-linejoin=miter></rect><path fill=none stroke=#4a9fef stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M27,16c0-2.209,1.791-4,4-4 V5H1v7c2.209,0,4,1.791,4,4c0,2.209-1.791,4-4,4v7h30v-7C28.791,20,27,18.209,27,16z\" stroke-linejoin=miter></path></g></svg> <span style=\"font-weight: 600\" translate=VIEW_PURCHASED_TICKETS></span></a></div><div><button ng-if=\"!event.tickets && !event.past && event.status != \'CANCELLED\'\" ng-click=buyTickets() type=button class=\"btn btn-primary btn-primary-pink\" style=\"margin-top: 3px\"><span translate=GET_TICKETS></span></button> <button ng-if=\"event.tickets && !event.past && event.status != \'CANCELLED\'\" ng-click=buyTickets() type=button class=\"btn btn-ghost\" style=\"margin-top: 3px\"><span translate=MORE_TICKETS></span></button><div ng-if=\"event.userAnswer.userAnswer == \'GOING\' && event.online\"><br><button ng-disabled=!canJoinOnlineEvent ng-click=joinOnlineEvent() class=\"btn btn-primary btn-primary-pink plus-button btn-primary-subheader\"><span style=\"margin-top: 0px; float: left\">Join online event</span></button><br><br><div><div><span class=event-tag-txt style=\"font-weight: 600;color: #627293\">Link:</span> <a href=\"{{ event.onlineEventExternalLink }}\" target=_blank style=\"word-break: break-word\">{{ event.onlineEventExternalLink }}</a></div><div ng-if=event.onlineExternalEventUserName><span class=event-tag-txt style=\"font-weight: 600;color: #627293\">ID:</span> <span style=\"word-break: break-word\">{{ event.onlineExternalEventUserName }}</span></div><div ng-if=event.onlineExternalEventPassword><span class=event-tag-txt style=\"font-weight: 600;color: #8a94a2\">Password:</span> <span style=\"word-break: break-word\">{{ event.onlineExternalEventPassword }}</span></div></div></div></div></div><div ng-if=!event.ticketed><div ng-if=\"event.online && event.onlineEventType === \'EXTERNAL\'\"><span>Use the button below to join your external online event easily. If a password is shown above please copy it first</span></div><div><span ng-if=\"event.userAnswer.userAnswer == \'PENDING\'\"><span translate=YOU_HAVENT_REPLIED_YET></span> </span><span ng-if=\"event.userAnswer.userAnswer != \'PENDING\'\"><span translate=YOU_REPLIED_AS></span> <span translate=\"{{ event.userAnswer.userAnswer }}\"></span></span></div><div><nav class=\"view-event-attend-buttons is-relative\" click-outside=hideMReplyDropdown()><span ng-if=\"event.userAnswer.userAnswer == \'PENDING\' && !event.past && event.status != \'CANCELLED\'\"><button type=button class=\"btn btn-primary btn-primary-pink\" ng-init=\"event.showMReplyDropdown = false\" ng-click=\"event.showMReplyDropdown = !event.showMReplyDropdown\"><span translate=REPLY_BTN></span> <span class=dripicons-chevron-down></span></button> </span><span ng-if=\"event.userAnswer.userAnswer != \'PENDING\' && !event.past && event.status != \'CANCELLED\'\"><button type=button class=\"btn btn-ghost\" ng-init=\"event.showMReplyDropdown = false\" ng-click=\"event.showMReplyDropdown = !event.showMReplyDropdown\"><span translate=CHANGE_BTN></span> <span class=dripicons-chevron-down></span></button></span><div ng-if=event.online><br><button ng-disabled=!canJoinOnlineEvent ng-click=joinOnlineEvent() class=\"btn btn-primary btn-primary-pink plus-button btn-primary-subheader\"><span style=\"margin-top: 0px; float: left\">Join online event</span></button><br><br><div><div><span class=event-tag-txt style=\"font-weight: 600;color: #627293\">Link:</span> <a href=\"{{ event.onlineEventExternalLink }}\" target=_blank style=\"word-break: break-word\">{{ event.onlineEventExternalLink }}</a></div><div ng-if=event.onlineExternalEventUserName><span class=event-tag-txt style=\"font-weight: 600;color: #627293\">ID:</span> <span style=\"word-break: break-word\">{{ event.onlineExternalEventUserName }}</span></div><div ng-if=event.onlineExternalEventPassword><span class=event-tag-txt style=\"font-weight: 600;color: #627293\">Password:</span> <span style=\"word-break: break-word\">{{ event.onlineExternalEventPassword }}</span></div></div></div><ul class=dropdown-menu ng-class=\"{\'show\':event.showMReplyDropdown}\" style=\"top: 35px; right: auto; left: 50%; margin-left: -84px\"><li><a translate=EVENT_GOING_BTN ng-click=\"updateAttendance(event, \'GOING\'); event.showMReplyDropdown = false\" class=uppercase></a></li><li><a translate=EVENT_MAYBE_BTN ng-click=\"updateAttendance(event, \'MAYBE\'); event.showMReplyDropdown = false\" class=uppercase></a></li><li><a translate=EVENT_NOT_GOING_BTN ng-click=\"updateAttendance(event, \'NOT_GOING\'); event.showMReplyDropdown = false\" class=uppercase></a></li></ul><br></nav></div></div></div></div></div></div></div><section ng-if=\"rotaList && rotaList.length > 0\" class=mobile-fix-dates><div><strong style=\"color: #627293\">SignUp</strong></div><div class=volunteer-rota-list><div ng-repeat=\"rota in rotaList\"><div class=vi-row><div class=vi-col-right style=\"width: 94px\"><div ng-click=openRota(rota) class=rota-button style=\"float: right\">Sign up</div></div><div class=vi-col-middle><h2 style=\"{{ rota.volunteered ? \'\' : \'margin-top: 8px;\' }}\"><span ng-click=openRota(rota)>{{ rota.title }}</span></h2><div class=you-booked ng-if=rota.volunteered style=\"color: #778F9B\">Booked!</div></div></div></div></div></section><section class=mobile-fix-dates><div class=hosted-by-label style=\"overflow: auto; margin-top: 10px\"><div ng-if=\"event.type == \'COMMUNITY\'\"><span class=event-tag><span class=\"circle-tag community-tag\"></span> <span class=event-tag-txt translate=TAG_COMMUNITY_EVENT></span></span><div ng-if=\"event.eventOwners && event.eventOwners.length > 1\"><span translate=CREATED_BY style=\"margin-left: 6px\"></span> <a ng-if=!isEventCreatedByNameUpdated ng-click=openOwnersModal(event.eventOwners) translate=EVENT_CREATED_BY_ORGANISER_COUNT translate-values=\"{\'count\': event.eventOwners.length}\" style=\"font-weight: 600\"></a> <a ng-if=isEventCreatedByNameUpdated ng-click=openOwnersModal(event.eventOwners) style=\"font-weight: 600\">{{ ::event.createdByName }}</a></div><div ng-if=\"!event.eventOwners || event.eventOwners.length <= 1\"><span ng-if=event.createdByName translate=CREATED_BY style=\"margin-left: 6px\"></span> <a ui-sref=\"classlist.details.contact({\'id\': event.createdById })\" style=\"font-weight: 600\">{{ ::event.createdByName }}</a></div></div><div ng-if=\"event.type == \'PARENT\'\"><span class=event-tag><span class=\"circle-tag private-tag\"></span> <span class=event-tag-txt translate=TAG_PRIVATE_EVENT></span> </span><span ng-if=event.createdByName translate=CREATED_BY style=\"margin-left: 6px\"></span> <a ui-sref=\"classlist.details.contact({\'id\': event.createdById })\" style=\"font-weight: 600\">{{ ::event.createdByName }}</a></div></div><div><div><ul class=details-attachment-list><li><svg style=\"float: left; margin-right: 10px; margin-top: 2px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=18px height=18px viewBox=\"0 0 48 48\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><circle fill=none stroke=#eb004e stroke-width=4 stroke-linecap=square stroke-miterlimit=10 cx=24 cy=24 r=22 stroke-linejoin=miter></circle><polyline data-color=color-2 fill=none stroke=#eb004e stroke-width=4 stroke-linecap=square stroke-miterlimit=10 points=\" 24,12 24,24 36,24 \" stroke-linejoin=miter></polyline></g></svg> <span style=\"line-height: 22px\">{{ event.date.startDate | date:\'EEEE,\' : \'GMT\' }} <span style=\"font-weight: 600\">{{ event.date.startDate | date:\'MMM dd\' : \'GMT\' }}</span> <span translate=AT></span> <span style=\"font-weight: 600\">{{ event.date.startDate | date:\'h:mm a\' : \'GMT\' }}</span> <span ng-show=\"event.date.endDate && event.date.startDate !== event.date.endDate && event.date.sameDay\"><span>-</span> {{ event.date.endDate | date:\'h:mm a\' : \'GMT\' }}</span></span></li><li class=indented ng-show=\"event.date.endDate && event.date.startDate !== event.date.endDate && !event.date.sameDay\"><span translate=UNTIL></span> {{ event.date.endDate | date:\'EEEE,\' : \'GMT\' }} <span style=\"font-weight: 600\">{{ event.date.endDate | date:\'MMM dd\' : \'GMT\' }}</span> <span translate=AT></span> <span style=\"font-weight: 600\">{{ event.date.endDate | date:\'h:mm a\' : \'GMT\' }}</span></li><li ng-show=\"event.date.rsvpDate && !event.past\"><div style=\"overflow: auto\"><svg style=\"float: left; margin-right: 10px; margin-top: 2px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=18px height=18px viewBox=\"0 0 48 48\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><line data-color=color-2 x1=18 y1=2 x2=30 y2=2 fill=none stroke=#eb004e stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></line><line data-color=color-2 x1=24 y1=2 x2=24 y2=5 fill=none stroke=#eb004e stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></line><polyline data-color=color-2 points=\"24 18 24 28 34 28\" fill=none stroke=#eb004e stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></polyline><circle cx=24 cy=28 r=18 fill=none stroke=#eb004e stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></circle><line data-color=color-2 x1=38 y1=9 x2=44 y2=15 fill=none stroke=#eb004e stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></line></g></svg> <span style=\"line-height: 22px; float: left\"><span translate=RSVP_BY></span><br>{{ event.date.rsvpDate | date:\'EEEE,\' : \'GMT\' }} <span style=\"font-weight: 600\">{{ event.date.rsvpDate | date:\'MMM dd\' : \'GMT\' }}</span> <span style=\"font-weight: 600\">{{ event.date.rsvpDate | date:\'h:mm a\' : \'GMT\' }}</span></span></div></li><li ng-show=\"event.date.rsvpDate && event.past\"><svg style=\"float: left; margin-right: 10px; margin-top: 2px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=18px height=18px viewBox=\"0 0 48 48\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><line data-color=color-2 x1=18 y1=2 x2=30 y2=2 fill=none stroke=#eb004e stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></line><line data-color=color-2 x1=24 y1=2 x2=24 y2=5 fill=none stroke=#eb004e stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></line><polyline data-color=color-2 points=\"24 18 24 28 34 28\" fill=none stroke=#eb004e stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></polyline><circle cx=24 cy=28 r=18 fill=none stroke=#eb004e stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></circle><line data-color=color-2 x1=38 y1=9 x2=44 y2=15 fill=none stroke=#eb004e stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></line></g></svg> <span style=\"line-height: 22px\"><span translate=RSVP_BY_PAST></span></span></li><li ng-if=!isAndroidNative><svg style=\"float: left; margin-right: 10px; margin-top: 2px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=18px height=18px viewBox=\"0 0 48 48\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><line x1=45 y1=16 x2=3 y2=16 fill=none stroke=#eb004e stroke-miterlimit=10 stroke-width=4 data-cap=butt stroke-linecap=butt stroke-linejoin=miter></line><polyline points=\"20 42 3 42 3 6 45 6 45 25\" fill=none stroke=#eb004e stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></polyline><line x1=13 y1=2 x2=13 y2=10 fill=none stroke=#eb004e stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></line><line x1=35 y1=2 x2=35 y2=10 fill=none stroke=#eb004e stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></line><polyline points=\"32 37 34 39 38 35\" fill=none stroke=#eb004e stroke-linecap=square stroke-miterlimit=10 stroke-width=4 data-color=color-2 stroke-linejoin=miter></polyline><circle cx=35 cy=37 r=9 fill=none stroke=#eb004e stroke-linecap=square stroke-miterlimit=10 stroke-width=4 data-color=color-2 stroke-linejoin=miter></circle></g></svg> <a ng-click=addToICal() translate=ADD_EVENT_TO_CALENDAR_1 style=\"font-weight: 600\"></a></li><li><svg style=\"float: left; margin-right: 10px; margin-top: 2px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=18px height=18px viewBox=\"0 0 48 48\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><line x1=45 y1=16 x2=3 y2=16 fill=none stroke=#eb004e stroke-miterlimit=10 stroke-width=4 data-cap=butt stroke-linecap=butt stroke-linejoin=miter></line><polyline points=\"20 42 3 42 3 6 45 6 45 25\" fill=none stroke=#eb004e stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></polyline><line x1=13 y1=2 x2=13 y2=10 fill=none stroke=#eb004e stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></line><line x1=35 y1=2 x2=35 y2=10 fill=none stroke=#eb004e stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></line><polyline points=\"32 37 34 39 38 35\" fill=none stroke=#eb004e stroke-linecap=square stroke-miterlimit=10 stroke-width=4 data-color=color-2 stroke-linejoin=miter></polyline><circle cx=35 cy=37 r=9 fill=none stroke=#eb004e stroke-linecap=square stroke-miterlimit=10 stroke-width=4 data-color=color-2 stroke-linejoin=miter></circle></g></svg> <a ng-click=addToGoogleCalendar() translate=ADD_EVENT_TO_CALENDAR_2 style=\"font-weight: 600\"></a></li><li ng-if=\"event.location.location && !event.online\"><span class=\"icon dripicons-location\" style=\"float: left; color: #627293\"></span> <span style=\"margin-right: 7px\">{{ event.location.location }} <span ng-if=event.location.locationDetail>({{ event.location.locationDetail }})</span></span> <a ng-if=\"event.location.locationLat != 0.0 && event.location.locationLong != 0.0\" translate=MAP_VIEW href=\"http://maps.google.com/?q={{ event.location.location }}\" target=_blank style=\"white-space: nowrap\"></a></li><li ng-if=event.online><span class=\"icon dripicons-location\" style=\"float: left; color: #627293\"></span> <span style=\"margin-right: 7px\">This is an online event</span></li></ul><div><ul class=details-attachment-list><li ng-if=event.fileLibrary.attachment><span class=\"icon dripicons-paperclip\"></span> <span ng-repeat=\"att in event.fileLibrary.attachment\"><a href=\"{{ att.path }}\" target=_self style=\"word-wrap: break-word\">{{ att.name }}</a><br></span></li></ul></div></div></div></section><section class=mobile-fix-dates ng-if=\"active_user.id == event.createdById && event.type == \'COMMUNITY\' && !isPastEvent(event)\"><div class=swap><div class=iconcircle><span class=\"icon dripicons-swap\"></span></div><a class=switch-app-button ng-click=switchToEdit()><span translate=SWITCH_TO_EDIT></span></a></div></section><section class=mobile-fix-dates style=\"padding: 16px 0\"><div ng-if=\"active_user.id == event.createdById && event.answerCount.inviting\" style=\"padding-left: 15px; margin-bottom: 20px; color: #000\"><span translate=INVITATIONS_ARE_BEING_SENT></span> <a ng-click=getEvent() translate=REFRESH_EVENT></a></div><!-- If it\'s a whole school, do not display the guest list --><div class=\"small-invitation-resume {{ event.ticketed ? \'ticketed\' : \'\' }}\"><div ng-click=\"showGuests(\'ALL\')\"><h1>{{event.answerCount.invited}}</h1><span translate=EVENT_TXT_INVITED></span></div><div ng-if=!event.ticketed ng-click=\"showGuests(\'GOING\')\"><h1>{{event.answerCount.going}}</h1><span translate=EVENT_TXT_GOING></span></div><div ng-if=!event.ticketed ng-click=\"showGuests(\'MAYBE\')\"><h1>{{event.answerCount.maybe}}</h1><span translate=EVENT_TXT_MAYBE></span></div><div ng-if=!event.ticketed ng-click=\"showGuests(\'NOT_GOING\')\"><h1>{{event.answerCount.cantgo}}</h1><span translate=EVENT_TXT_CANTGO></span></div><div ng-if=event.ticketed ng-click=\"showGuests(\'GOING\')\"><h1>{{event.answerCount.sold}}</h1><span translate=EVENT_TXT_GOING></span></div></div><br><div><div><div class=invited-group-list style=\"margin-top: 8px\"><div ng-repeat=\"group in event.groups\" style=\"padding-left: 15px\"><svg style=\"float: left; margin-right: 10px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=20px height=20px viewBox=\"0 0 64 64\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><path data-color=color-2 fill=none stroke=#627293 stroke-width=4 stroke-linecap=square stroke-miterlimit=10 d=\"M38,19 c0,4.971,4.029,11,9,11s9-6.029,9-11s-4.029-9-9-9S38,14.029,38,19z\" stroke-linejoin=miter></path><path data-cap=butt data-color=color-2 fill=none stroke=#627293 stroke-width=4 stroke-miterlimit=10 d=\"M48,50h14v-4.324 c0-2.446-1.47-4.657-3.742-5.562C55.657,39.077,51.8,38,47,38s-8.657,1.077-11.258,2.113c-1.072,0.427-1.961,1.14-2.605,2.036\" stroke-linejoin=miter stroke-linecap=butt></path><path fill=none stroke=#627293 stroke-width=4 stroke-linecap=square stroke-miterlimit=10 d=\"M40,56H2v-5.63 c0-3.052,1.722-5.845,4.466-7.182C9.668,41.628,14.554,40,21,40s11.332,1.628,14.534,3.188C38.278,44.525,40,47.318,40,50.37V56z\" stroke-linejoin=miter></path><path fill=none stroke=#627293 stroke-width=4 stroke-linecap=square stroke-miterlimit=10 d=\"M32,19 c0,6.075-4.925,13-11,13s-11-6.925-11-13S14.925,8,21,8S32,12.925,32,19z\" stroke-linejoin=miter></path></g></svg> <span style=\"font-weight: 600\">{{ group.name }}</span></div></div></div></div></section><section class=mobile-fix-dates ng-if=\"event.type == \'PARENT\' && event.past && (active_user.id == event.createdById)\"><a translate=DOWNLOAD_SELECTED_GUESTS_LIST ng-click=downloadList(event.ticketed) style=\"font-weight: 600\"></a></section><!--  Event Notes Section--><section id=messageSection class=\"event-section event-message-section\" ng-if=\"messageList && messageList.length > 0\"><h5 translate=EVENT_MESSAGES_TITLE translate-values=\"{\'multiple\':event.hasMultipleOwners ? \'s\' : \'\'}\" style=\"padding-left: 20px;margin-bottom:0px\"></h5><div ng-repeat=\"message in messageList\" class=dash-message-list><div><div class=message><!--  Ambassador & Rep profile card --><div class=user-profile ng-if=!message.staff><a href=\"#/classlist/details/{{ message.userId }}/contact\"><figure class=avatar style=\"margin-top: 0\"><avatar source=\"{{ message.avatar }}\" name={{message.postedBy}} width=50 height=50 my=true></avatar></figure></a><div style=padding-left:10px><a href=\"#/classlist/details/{{ message.userId }}/contact\"><h4 class=user-name>{{message.postedBy}}</h4></a><span class=normal-text>{{ message.createdAt | date:\'dd MMM yyyy \\\'at\\\' h:mm a\' }}</span></div></div><!--  Staff profile card --><div class=user-profile ng-if=message.staff><figure class=avatar style=\"margin-top: 0\"><avatar source=\"{{ message.avatar }}\" name={{message.postedBy}} width=50 height=50 my=true></avatar></figure><div style=padding-left:10px><a style=\"text-decoration: none; cursor: default\"><h4 class=user-name>{{message.postedBy}}</h4></a><span class=normal-text>{{ message.createdAt | date:\'dd MMM yyyy \\\'at\\\' h:mm a\' }}</span></div></div><br><div ng-if=message.hasReadMore><div ng-if=!message.showFull><span class=\"clamped normal-text\" ng-bind-html=message.message style=\"-webkit-box-orient: vertical\"></span> <a ng-click=toggleShow($index) class=show-btn><span style=\"text-decoration: underline\">Show More</span> <span class=dripicons-chevron-down style=\"font-size:18px;vertical-align: middle\"></span></a></div><div ng-if=message.showFull><span ng-bind-html=message.message class=normal-text></span><br><a ng-click=toggleShow($index) class=show-btn><span style=\"text-decoration: underline\">Hide</span> <span class=dripicons-chevron-up style=\"font-size:18px;vertical-align: middle\"></span></a></div></div><div ng-if=!message.hasReadMore ng-bind-html=message.message class=normal-text></div><div class=sent-to>Sent to: {{message.sentTo}}</div></div></div></div></section><!--  Event Notes Section--><!-- <section ng-if=\"event.rotaLink\" class=\"mobile-fix-dates\">\n			<div>\n				<strong style=\"color: #8a94a2;\">\n					Volunteer rota link\n				</strong>\n			</div>\n			<div>\n				<a href=\"{{ event.rotaLink }}\" target=\"_blank\" style=\"font-weight: 600;\">{{ event.rotaLink }}</a>\n			</div>\n		</section> --><section><aside ng-if=post><post-asset comment-only=true post-content=post archived-group=event.archived readonly-post=1 post-context=HOME_VIEW class=enter user-avatar=userAvatar user-id=userId user-name=userName post-events=postEvents></post-asset></aside></section></div><div class=sample-popup ng-if=\"event.sample && event.type == \'COMMUNITY\'\" style=\"top: 35%; left: 40%\"><span class=dripicons-cross ng-click=dismissSample()></span><div class=sample-padding><div class=sample-header><span translate=SAMPLE_EVENT_TITLE></span></div><div class=sample-container><span translate=SAMPLE_EVENT_DESCR></span></div></div><div class=arrow></div></div><div class=sample-popup ng-if=\"event.sample && event.type != \'COMMUNITY\'\" style=\"top: 35%; left: 40%\"><span class=dripicons-cross ng-click=dismissSample()></span><div class=sample-padding><div class=sample-container style=\"font-size: 16px\"><span translate=SAMPLE_EVENT_DESCR_1></span></div><br><div class=sample-container-big><span translate=SAMPLE_EVENT_DESCR_2></span></div><br><div class=sample-container><span translate=SAMPLE_EVENT_DESCR_3></span></div><div style=\"text-align: right\"><a href=#/events/list class=\"btn btn-ghost\"><span translate=SAMPLE_EVENT_BUTTON_1></span></a></div><br><div class=sample-container><span translate=SAMPLE_EVENT_DESCR_4></span></div><div style=\"text-align: right\"><a href=#/home class=\"btn btn-ghost\"><span translate=SAMPLE_EVENT_BUTTON_2></span></a></div></div><div class=arrow></div></div></section>");
$templateCache.put("app/events/views/wrapper.html","<div class=\"content-logged events\"><div ui-view autoscroll=false></div></div>");
$templateCache.put("app/groups/views/add-members-group-modal.html","<script type=text/ng-template id=memberTemplate.html><div class=\"match-container\">\n		<div class=\"match-container-parentname\">\n			<span ng-bind-html=\"match.model.field1 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field1\"></span>\n			<span ng-bind-html=\"match.model.field2 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field2\"></span>\n		</div>\n		<div>\n			<span translate=\"PARENTHESES_OPEN\" ng-if=\"match.model.field3\"></span><span ng-bind-html=\"(m | uibTypeaheadHighlight:query) + ($last ? \'\' : \', \')\" ng-repeat=\"m in match.model.field3 track by $index\"></span><span translate=\"PARENTHESES_CLOSE\" ng-if=\"match.model.field3\"></span>\n		</div>\n	</div></script><div class=create-group><form name=amg novalidate ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 ng-if=\"type == 1\" translate=GROUPS_ADD_OWNERS></h3><h3 ng-if=\"type == 2\" translate=ADD_MEMBERS></h3></div><div class=modal-body><div ng-if=\"type == 1\"><span translate=GROUPS_ADD_OWNERS_TEXT_1></span><br><span translate=GROUPS_ADD_OWNERS_TEXT_2></span></div><div ng-if=\"type == 2\"><p class=add-members-text translate=ADD_MEMBERS_TEXT translate-values=\"{\'groupName\':currentGroupName}\"></p></div><p class=create-groups-text translate=ADD_MEMBERS></p><participants ng-model=members event-context=true show-tiers=true school-id={{active_school.id}} allow-host-invite=true></participants></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=add() ng-disabled=\"members.length === 0\"><span translate=CREATE_FOOTER_BTN></span></button></div></form></div>");
$templateCache.put("app/groups/views/create-group-modal.html","<div><div class=modal-header><h3 class=modal-title translate=CREATE_PARENT_GROUP></h3></div><div class=modal-body><input type=text required maxlength=100 ng-model=newgroup.groupName class=form-control placeholder=\"{{ \'GROUPNAME_PHOLDER\' | translate }}\"><div style=\"margin-top: 20px; margin-bottom: 20px\"><textarea autoresize-textarea ng-model=newgroup.groupDescr class=\"form-control form-control-border\" maxlength=4000 placeholder=\"{{ \'GROUPDESCR_PHOLDER\' | translate }}\" style=\"border: 1px solid #91969d;\n            padding: 8px\"></textarea></div><div class=group-add-photo><span ng-click=uploadImage() style=\"cursor: pointer\"><span class=dripicons-camera></span><span translate=POST_PHOTO></span></span></div><div><img alt=\"\" src=\"{{ newgroup.avatarURL }}\" style=\"max-width: 100%\"></div><div class=group-radio-container style=\"margin-top: 10px\"><div class=\"{{ newgroup.groupVisibility == \'1\' ? \'active\' : \'\' }}\" ng-click=selectGroupVisibility(1)><div class=checkbox></div><span translate=PUBLIC_GROUP></span></div><div class=\"{{ newgroup.groupVisibility == \'2\' ? \'active\' : \'\' }}\" ng-click=selectGroupVisibility(2) v><div class=checkbox></div><span translate=PRIVATE_GROUP></span></div></div><p translate=CREATE_GROUP_VISIBILITY_LABEL></p><br><br><p class=create-groups-text translate=ADD_MEMBERS></p><participants ng-model=newgroup.guests event-context=true show-tiers=true school-id={{active_school.id}} allow-host-invite=true></participants></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" ng-disabled=\"saveingGroup || !newgroup.groupName\" type=button ng-click=saveGroup()><span translate=CREATE_BTN></span></button></div></div>");
$templateCache.put("app/groups/views/create-group.html","<div class=\"content-logged page-create-group\"><div class=\"page-view-header clearfix\"><div style=\"padding: 0\"><div><div style=\"position: relative\"><div><svg id=header-back-button ng-click=back() class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg></div><div class=page-view-header__text style=\"padding: 0\"><strong translate=CREATE_PARENT_GROUP class=page-view-header__title></strong></div></div></div></div></div><div style=\"padding: 0 20px\"><br><input type=text required maxlength=100 ng-model=newgroup.groupName class=form-control placeholder=\"{{ \'GROUPNAME_PHOLDER\' | translate }}\" style=\"border: 1px solid #b6c2db; background-color: #fff; padding: 10px; border-radius: 12px\"><div style=\"margin-top: 20px; margin-bottom: 20px\"><textarea autoresize-textarea ng-model=newgroup.groupDescr class=\"form-control form-control-border\" maxlength=4000 placeholder=\"{{ \'GROUPDESCR_PHOLDER\' | translate }}\" style=\"border: 1px solid #b6c2db; background-color: #fff; padding: 10px; border-radius: 12px\"></textarea></div><div class=group-add-photo ng-click=uploadImage()><img alt=\"\" src={{newgroup.avatarURL}} style=\"max-width: 100%\"><div ng-if=!newgroup.avatarURL><span style=\"cursor: pointer\"><div><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><path fill=#eb004e d=\"M58,13h-8.546l-6.701-7.659C42.562,5.125,42.288,5,42,5H28c-0.288,0-0.562,0.125-0.753,0.341L20.546,13H6 c-2.757,0-5,2.243-5,5v36c0,2.757,2.243,5,5,5h52c2.757,0,5-2.243,5-5V18C63,15.243,60.757,13,58,13z M13,26c-1.103,0-2-0.897-2-2 s0.897-2,2-2s2,0.897,2,2S14.103,26,13,26z M35,50c-7.732,0-14-6.268-14-14s6.268-14,14-14s14,6.268,14,14S42.732,50,35,50z\"></path></g></svg></div><span translate=GROUP_PHOTO style=\"line-height: 36px\"></span></span></div></div><div ng-if=newgroup.avatarURL ng-click=uploadImage()><svg style=\"width: 20px; height: 20px; float: left; margin-top: 7px; margin-right: 10px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><path fill=#4a9fef d=\"M58,13h-8.546l-6.701-7.659C42.562,5.125,42.288,5,42,5H28c-0.288,0-0.562,0.125-0.753,0.341L20.546,13H6 c-2.757,0-5,2.243-5,5v36c0,2.757,2.243,5,5,5h52c2.757,0,5-2.243,5-5V18C63,15.243,60.757,13,58,13z M13,26c-1.103,0-2-0.897-2-2 s0.897-2,2-2s2,0.897,2,2S14.103,26,13,26z M35,50c-7.732,0-14-6.268-14-14s6.268-14,14-14s14,6.268,14,14S42.732,50,35,50z\"></path></g></svg> <a translate=CHANGE_PHOTO style=\"line-height: 36px\"></a></div><br><div class=group-radio-container style=\"margin-top: 10px\"><div class=\"{{ newgroup.groupVisibility == \'1\' ? \'active\' : \'\' }}\" ng-click=selectGroupVisibility(1)><div class=checkbox></div><span translate=PUBLIC_GROUP></span></div><div class=\"{{ newgroup.groupVisibility == \'2\' ? \'active\' : \'\' }}\" ng-click=selectGroupVisibility(2) v><div class=checkbox></div><span translate=PRIVATE_GROUP></span></div></div><br><div><strong style=\"font-size: medium\" translate=WHO_CAN_SEE_GROUP></strong></div><p translate=CREATE_GROUP_VISIBILITY_LABEL></p><br><div><strong style=\"font-size: medium\" translate=DO_I_NEED_GROUP></strong></div><p style=\"padding-top: 10px\" translate=CREATE_GROUP_NEEDS_LABEL></p><br><p class=create-groups-text translate=ADD_MEMBERS></p><participants ng-model=newgroup.guests event-context=true show-tiers=true school-id={{active_school.id}} allow-host-invite=true></participants><p class=create-groups-text translate=ADD_TAGS></p><grouptags ng-model=newgroup.tags school-id={{active_school.id}}></grouptags></div><div class=modal-footer><button class=\"btn btn-default\" type=button ui-sref=home><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary btn-primary-pink\" ng-disabled=\"saveingGroup || !newgroup.groupName\" type=button ng-click=\"saveGroup() \"><span translate=CREATE_BTN></span></button></div></div>");
$templateCache.put("app/groups/views/delete-group-modal.html","<div><div class=modal-header><h3 translate=DELETE_GROUPS_HEADER translate-values=\"{\'groupName\':currentGroupName}\"></h3></div><div class=modal-body><p class=add-members-text translate=DELETE_GROUPS_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=DELETE_BTN ng-click=confirm() ng-disabled=deletingGroup><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/groups/views/group-type-change-modal.html","<div><div class=modal-body><p class=add-members-text translate=CHANGE_GROUP_TYPE_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=I_AM_OK_WITH_THAT ng-click=confirm() ng-disabled=deletingGroup><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></button></button></div></div>");
$templateCache.put("app/groups/views/group-view.html","<section class=group-view add-participants post-likes ng-show=viewState.isReady><div class=\"page-view-header post-header {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div style=\"padding: 0\"><div class=premium-ad-clear style=\"padding: 0 15px\"><div premium-ad></div></div><div style=\"position: relative\"><div class=pull-left style=\"width: 80%\"><a ng-click=onBackArrowTap() id=header-back-button style=\"float: left\"><svg class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> </a><strong class=\"page-view-header__title elipsis-text\" style=\"max-width: 100%; overflow: hidden\"><span ng-if=group.archived>Archived -</span> {{group.title}}</strong></div><div class=pull-right><nav class=\"has-dropdown is-relative\" style=\"line-height: 25px\"><svg ng-if=\"!group.archived && (group.type == \'PARENT_PRIVATE\' || group.type == \'PARENT_PUBLIC\')\" style=\"height: 43px; width: 44px; padding: 14px 10px; padding-bottom: 3px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\"><g transform=\"translate(0, 0)\"><circle fill=#51a8f9 cx=4 cy=16 r=3></circle><circle data-color=color-2 fill=#51a8f9 cx=16 cy=16 r=3></circle><circle fill=#51a8f9 cx=28 cy=16 r=3></circle></g></svg><ul class=dropdown-menu style=\"right: 41px; top: 22px; left: auto\"><li ng-if=group.owner><a ng-click=\"addMembersToGroup(2, onDialogCallback)\" translate=GROUP_VIEW_MEMBERS></a></li><li ng-if=\"group.owner && group.members && group.members.length > 0\"><a ng-click=removeMembersFromGroup(onDialogCallback)><span translate=GROUPS_REMOVE_MEMBERS></span></a></li><li ng-if=\"group.owner && group.type != \'PARENT_PUBLIC\' && group.waitingApproval\"><a ng-click=openMembers(3)><span translate=GROUPS_APPROVE_REQUESTS></span></a></li><li ng-if=group.owner><a ng-click=\"addMembersToGroup(1, onDialogCallback)\"><span translate=GROUPS_OWNERS></span></a></li><li ng-if=group.owner ng-click=deleteGroup()><a><span translate=GROUPS_DELETE></span></a></li><li ng-if=\"!group.member && !group.member\"><a ng-click=joinGroup() class=\"{{ joiningGroup ? \'link-disabled\' : \'\' }}\"><span translate=GROUPS_JOIN></span></a></li><li ng-if=\"!group.archived && (group.type == \'PARENT_PRIVATE\' || group.type == \'PARENT_PUBLIC\') && !group.owner && group.member\"><a ng-click=\"leaveGroup(2, group.type)\"><span translate=GROUPS_LEAVE></span></a></li><li ng-if=\"!group.archived && (group.type == \'PARENT_PRIVATE\' || group.type == \'PARENT_PUBLIC\') && group.owner\"><a ng-click=\"leaveGroup(1, group.type)\"><span translate=GROUPS_LEAVE></span></a></li></ul></nav></div></div></div></div><div class=page-container-header-from-top style=\"min-height: 400px; margin-top: 0!important\"><div><div class=\"main-right-col active\" ng-show=viewState.isInitiated><div class=\"right-section picture-section\"><div><div ng-if=\"group.owner && !group.archived\" ng-class=\"{\'show-for-owner\': group.owner}\" class=\"edit-button ng-scope\" ng-click=uploadImage()><span class=\"icon dripicons-camera\"></span></div><div class=img style=\"background-image: url(\'{{ group.avatarURL }}\')\"></div></div></div><div class=group-title-blue><h4><div ng-if=\"!group.archived && group.owner && (group.type === \'PARENT_PRIVATE\' || group.type === \'PARENT_PUBLIC\')\" ng-class=\"{\'show-for-owner\': group.owner}\" ng-show=!peditTitle class=\"edit-button title-holder ng-scope\" ng-mouseup=editTitle() style=border:none;margin:0><span ng-class=\"{\'show-for-owner\': group.owner}\" class=\"icon dripicons-pencil\" style=\"font-size: 18px\"></span></div><span ng-show=!peditTitle style=\"word-break: break-word\"><span ng-if=group.archived>Archived -</span>	{{group.title}}</span><div class=click-editor ng-show=peditTitle click-outside=updateOutsideTitle()><input ng-model=peditTitleInput type=text maxlength=100><div><span class=\"icon dripicons-checkmark\" ng-click=updateTitle()></span> <span class=\"icon dripicons-cross\" ng-click=cancelTitle()></span></div></div></h4></div><div class=\"group-view-members right-section\" style=\"margin-bottom: 0; border-top: none\"><div class=group-radio-container ng-if=\"!group.archived && (group.type == \'PARENT_PUBLIC\' || group.type == \'PARENT_PRIVATE\') && group.owner\"><div class=\"{{ group.type == \'PARENT_PUBLIC\' ? \'active\' : \'\' }}\" ng-click=selectGroupVisibility(1)><div class=checkbox></div><span translate=PUBLIC_GROUP></span></div><div class=\"{{ group.type == \'PARENT_PRIVATE\' ? \'active\' : \'\' }}\" ng-click=selectGroupVisibility(2) v><div class=checkbox></div><span translate=PRIVATE_GROUP></span></div></div><!-- Group Info for Ambassadors & Reps --><div ng-if=\"group.type == \'ADMIN_GROUP\'\" style=\"margin: 10px 0 15px\"><span class=\"icons dripicons-information\"></span> You’re in this group because you’re an ambassador or rep. <a href=#/school/details>See school profile</a></div><!-- Group Info for Ambassadors & Reps End --><!-- Group Info Year Groups --><div ng-if=\"group.type == \'TIER_GROUP\'\" style=\"margin: 10px 0 15px\"><div><span class=\"icons dripicons-information\"></span> This is your child’s year group. If you think you should be in a different group,</div><div style=\"cursor: pointer; color: #eb004e; font-weight: 600; text-decoration: none\" ng-click=openProfile()>update your profile</div></div><!-- Group Info Year Groups End --><div class=users-list><span class=visibility-info><span ng-if=\"group.type == \'PARENT_PRIVATE\'\" translate=PRIVATE_GROUP></span> <span ng-if=\"group.type == \'PARENT_PUBLIC\'\" translate=PUBLIC_GROUP></span> </span><span ng-if=\"group.type == \'PARENT_PRIVATE\' || group.type == \'PARENT_PUBLIC\'\">-</span> <span ng-if=group.processingMembers>Processing new members... </span><span ng-if=!group.processingMembers>{{ group.owners.length + group.members.length }} member(s) </span><a ng-if=\"group.type != \'SCHOOL_GROUP\'\" translate=GROUPS_VIEW_ALL ng-click=openMembers(2) style=\"margin-left: 5px\"></a></div><div ng-if=\"group.type != \'SCHOOL_GROUP\'\" style=\"overflow: auto\"><div ng-click=openMembers(2) ng-if=\"group.owners || group.members || group.waitingApproval\" class=\"group-view-member-avatars clearfix\"><div ng-repeat=\"m in group.owners | limitTo: 3\"><figure class=group-member-avatar title=\"{{m.name }}\"><avatar source={{m.avatar}} name=\"{{ m.name }}\" width=40 height=40 my=false title={{m.name}}></avatar></figure></div><div ng-repeat=\"m in group.members | limitTo: 3\"><figure class=group-member-avatar title=\"{{m.name }}\"><avatar source={{m.avatar}} name=\"{{ m.name }}\" width=40 height=40 my=false title={{m.name}}></avatar></figure></div></div><span ng-if=\"!group.archived && group.type !== \'SCHOOL_GROUP\' && group.type !== \'TIER_GROUP\'\"><span ng-if=\"!group.owner && !group.member\"><button ng-click=joinGroup() type=button class=\"btn btn-primary btn-primary-pink add-join-button\">+ Join</button> </span><span ng-if=group.owner><button ng-click=\"addMembersToGroup(2, onDialogCallback)\" type=button class=\"btn btn-primary add-join-button\">+ Add</button></span></span></div><div class=users-list-separator></div><div><!------------ Group Tags Start -----------><div class=group-tags ng-if=isGroupWithTags><div class=group-view-member-nums>Group tags</div><div class=tags-area><div class=tags><ul><li ng-repeat=\"tag in group.tags track by $index\" ng-click=searchTag(tag)>{{tag}} <span ng-if=group.owner ng-click=\"removeTag(tag, $index)\" class=\"icon dripicons-cross\"></span></li></ul></div></div><div><span ng-if=group.owner><input type=text ng-model=newTag.tag placeholder=\"{{ \'ADD_TAGS_PLACEHOLDER\' | translate }}\" uib-typeahead=\"r for r in getTags($viewValue)\" typeahead-focus-first=false typeahead-wait-ms=300 typeahead-min-length=2 typeahead-on-select=pickTag($item) ng-keyup=tagKeyUp($event) typeahead-template-url=grouptagsTemplate.html class=tags-input></span></div><div class=clear></div></div><!------------ Group Tags End -----------><div class=users-list-separator ng-if=isGroupWithTags></div><div><div class=group-view-member-nums>About this group</div><time><span translate=CREATED_AT></span> {{group.created | date:\'h:mm a, MMM dd\'}}</time><div style=\"margin-top: 4px\"><span ng-if=\"!group.description && !peditDescr\" translate=GROUP_DESCRIPTION></span><div ng-if=group.owner ng-class=\"{\'show-for-owner\': group.owner}\" ng-show=!peditDescr class=\"edit-button description-holder ng-scope\" ng-mouseup=editDescr() style=border:none;margin:0><span class=\"icon dripicons-pencil\" style=\"font-size: 18px\"></span></div><p ng-show=!peditDescr class=multiple-line-text style=\"font-size: 15px\" ng-bind-html=getHtmlVersion(group.description)></p></div><div class=click-editor ng-show=peditDescr click-outside=updateOutsideDescr()><textarea ng-show=peditDescr ng-model=peditDescrInput autoresize-textarea placeholder=\"Write a description...\" maxlength=1500 ng-trim=false></textarea><div><span class=\"icon dripicons-checkmark\" ng-click=updateDescr()></span> <span class=\"icon dripicons-cross\" ng-click=cancelDescr()></span></div></div><div ng-show=peditDescr class=counter style=\"font-size: 14px; color: #627293; text-align: right; padding-top:5px\">{{ peditDescrInput ? peditDescrInput.length : 0 }} / 1500</div><div><time ng-if=group.archived><span translate=GROUP_ARCHIVED></span> <span style=color:black>{{group.archivedAt | date:\'dd MMM yyyy h:mm a\'}}</span></time></div><div ng-if=\"group.owner || group.member\" style=\"text-align: center; margin-top: 20px; margin-bottom: 10px\"><button type=button class=\"btn btn-primary btn-primary-pink\" ng-click=seeMore()>See all posts in this feed</button></div></div></div></div></div></div></div></section><script type=text/ng-template id=grouptagsTemplate.html><div class=\"match-container\">\n		<span ng-bind-html=\"match.model | uibTypeaheadHighlight:query\" ng-if=\"match.model\"></span>\n	</div></script>");
$templateCache.put("app/groups/views/groups-list.html","");
$templateCache.put("app/groups/views/leave-group-modal.html","<div><div class=modal-header><h3 translate=LEAVE_GROUP_HEADER></h3></div><div class=modal-body><p ng-if=\"groupType == \'PARENT_PUBLIC\'\" translate=LEAVE_GROUP_TEXT_PUBLIC></p><p ng-if=\"groupType == \'PARENT_PRIVATE\'\" translate=LEAVE_GROUP_TEXT_PRIVATE></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=OK_BTN ng-disabled=leavingGroup ng-click=confirm()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/groups/views/members-modal.html","<script type=text/ng-template id=memberTemplate.html><div class=\"match-container\">	\n		<div class=\"match-container-parentname\">\n			<span ng-bind-html=\"match.model.field1 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field1\"></span>\n			<span ng-bind-html=\"match.model.field2 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field2\"></span>\n		</div>\n		<div>\n            <span translate=\"PARENTHESES_OPEN\" ng-if=\"match.model.field3\"></span><span ng-bind-html=\"(m | uibTypeaheadHighlight:query) + ($last ? \'\' : \', \')\" ng-repeat=\"m in match.model.field3 track by $index\"></span><span translate=\"PARENTHESES_CLOSE\" ng-if=\"match.model.field3\"></span>\n		</div>\n	</div></script><div class=members-container><div class=modal-header><h3 ng-if=\"type == 1\" class=modal-title><svg style=\"top: 4px\" ng-click=close() class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <span translate=MEMBERS_OWNERS style=\"float: left; margin-left: 30px; font-size: 20px\"></span></h3><h3 ng-if=\"type == 2\" class=modal-title><svg style=\"top: 4px\" ng-click=close() class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <span translate=MEMBERS_GROUP style=\"float: left; margin-left: 30px; font-size: 20px\"></span></h3><h3 ng-if=\"type == 3\" class=modal-title><svg style=\"top: 4px\" ng-click=close() class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <span translate=MEMBERS_WAITING_APPROVAL style=\"float: left; margin-left: 30px; font-size: 20px\"></span></h3></div><div ng-if=\"type == 3\" class=modal-body><p translate=MEMBERS_WAITING_APPROVAL_TEXT_1></p></div><div class=group-members-list><div class=group-members-list-max style=\"padding: 0\"><div ng-if=group.waitingApproval class=members-list-header ng-if=\"group.owners && group.owners.length > 0\"><span>Waiting approval</span></div><div class=member ng-repeat=\"m in group.waitingApproval\" style=\"padding: 0 15px\"><div ui-sref=\"classlist.details.contact({\'id\':m.id })\"><figure class=avatar title=\"{{::m.name }}\" style=\"margin-right: 5px\"><avatar source={{m.avatar}} name=\"{{ m.name }}\" width=40 height=40 my=false title=\"{{ m.name }}\"></avatar></figure><span class=name style=\"margin-top: 0\"><div>{{m.name}}</div><div ng-if=m.pupils style=\"font-size: 12px; line-height: 18px\">{{ m.pupils }}</div></span></div><span ng-click=reject(m) class=\"dripicons-cross icon\" style=\"padding-top: 6px\"></span> <span ng-click=accept(m) class=\"dripicons-checkmark icon\" style=\"padding-top: 6px\"></span></div><div class=members-list-header ng-if=\"group.owners && group.owners.length > 0\">Owners</div><div class=member ng-repeat=\"m in group.owners\" style=\"padding: 0 15px\"><div ui-sref=\"classlist.details.contact({\'id\':m.id })\"><figure class=avatar title=\"{{::m.name }}\" style=\"margin-right: 5px\"><avatar source={{m.avatar}} name=\"{{ m.name }}\" width=40 height=40 my=false title=\"{{ m.name }}\"></avatar></figure><span class=name style=\"margin-top: 0\"><div>{{m.name}}</div><div ng-if=m.pupils style=\"font-size: 12px; line-height: 18px\">{{ m.pupils }}</div></span></div></div><div class=members-list-header>Members</div><div class=member ng-repeat=\"m in group.members\" style=\"padding: 0 15px\"><div ui-sref=\"classlist.details.contact({\'id\':m.id })\"><figure class=avatar title=\"{{::m.name }}\" style=\"margin-right: 5px\"><avatar source={{m.avatar}} name=\"{{ m.name }}\" width=40 height=40 my=false title=\"{{ m.name }}\"></avatar></figure><span class=name style=\"margin-top: 0\"><div>{{m.name}}</div><div ng-if=m.pupils style=\"font-size: 12px; line-height: 18px\">{{ m.pupils }}</div></span></div></div></div></div></div>");
$templateCache.put("app/groups/views/members.html","<script type=text/ng-template id=memberTemplate.html><div class=\"match-container\">	\n		<div class=\"match-container-parentname\">\n			<span ng-bind-html=\"match.model.field1 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field1\"></span>\n			<span ng-bind-html=\"match.model.field2 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field2\"></span>\n		</div>\n		<div>\n            <span translate=\"PARENTHESES_OPEN\" ng-if=\"match.model.field3\"></span><span ng-bind-html=\"(m | uibTypeaheadHighlight:query) + ($last ? \'\' : \', \')\" ng-repeat=\"m in match.model.field3 track by $index\"></span><span translate=\"PARENTHESES_CLOSE\" ng-if=\"match.model.field3\"></span>\n		</div>\n	</div></script><div class=members-container><div class=\"page-view-header clearfix\"><div><div class=row><div class=col-md-12 style=\"position: relative\"><div><svg id=header-back-button ng-click=back() class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg></div><div class=page-view-header__text><strong class=page-view-header__title>{{::group.groupName}}</strong></div></div></div></div></div><div style=\"padding: 15px; padding-top: 0\"><p ng-if=\"type == 3\" translate=MEMBERS_WAITING_APPROVAL_TEXT_1></p><p ng-if=\"type == 1\" translate=ADD_OWNERS></p><p ng-if=\"type == 2\" translate=ADD_MEMBERS></p><div ng-if=\"type == 1 || type == 2\" class=search><input type=text ng-model=member placeholder=\"{{ \'ADD_GROUPMEMBER_SEARCH_PHOLDER\' | translate }}\" uib-typeahead=\"r.field1 for r in getMembers($viewValue)\" typeahead-wait-ms=300 typeahead-min-length=2 typeahead-on-select=pickMember($item) typeahead-template-url=memberTemplate.html class=form-control><br></div></div><div ng-if=\"type == 1\" class=\"group-members-list scrollbar-enabled\"><div style=\"max-height: 100%\"><div class=member ng-repeat=\"m in group.owners track by $index\"><div ui-sref=\"classlist.details.contact({\'id\':m.id })\"><figure class=avatar title={{::m.name}}><avatar source={{m.avatar}} name=\"{{ m.name }}\" width=40 height=40 my=false title={{::m.name}}></avatar></figure><span class=name style=\"max-width: 50%\">{{::m.name}}</span></div></div></div></div><div ng-if=\"type == 2\" class=\"group-members-list scrollbar-enabled\"><div style=\"max-height: 100%\"><div class=member ng-repeat=\"m in group.members track by $index\"><div ui-sref=\"classlist.details.contact({\'id\':m.id })\"><figure class=avatar title={{::m.name}}><avatar source={{m.avatar}} name=\"{{ m.name }}\" width=40 height=40 my=false title={{::m.name}}></avatar></figure><span class=name style=\"max-width: 50%\">{{::m.name}}</span></div><span ng-if=\"type == 1 || type == 2\" ng-click=removeMember(m) class=\"dripicons-cross icon\"></span> <span ng-if=\"type == 3\" ng-click=rejectRequest() class=\"dripicons-cross icon\"></span> <span ng-if=\"type == 3\" class=\"dripicons-checkmark icon\"></span></div></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button ui-sref=\"groups.view({\'id\':groupId})\"><span translate=CLOSE_BTN></span></button></div></div>");
$templateCache.put("app/groups/views/mobile-details.html","<div><div class=\"page-view-header clearfix\"><div><div class=row><div class=col-md-12 style=\"position: relative\"><div ng-show=viewState.isInitiated ng-click=back()><svg id=header-back-button class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg></div><div class=page-view-header__text><strong class=page-view-header__title>{{group.title}}</strong></div></div></div></div></div><div style=\"padding: 0 20px\" class=mobile-details><div class=title-holder ng-show=!peditTitle><div ng-if=group.owner ng-class=\"{\'show-for-owner\': group.owner}\" ng-click=editTitle() style=border:none;margin:0><span ng-class=\"{show-for-owner: group.owner}\" class=\"icon dripicons-pencil edit-button\"></span></div><span ng-show=!peditTitle class=editing style=\"word-break: break-word\">{{group.title}}</span></div><div class=click-editor ng-show=peditTitle style=\"margin-bottom: 30px\"><input ng-model=peditTitleInput type=text class=mobile-title-desc><div><span class=\"icon dripicons-checkmark\" ng-click=updateTitle()></span> <span class=\"icon dripicons-cross\" ng-click=cancelTitle()></span></div></div><div class=description-holder ng-if=!peditDescr style=\"min-height: 40px; padding: 8px\"><span><span class=mobile-textarea ng-if=group.description>{{ group.description }}</span> </span><span ng-if=!peditDescr class=\"icon dripicons-pencil edit-button\" ng-click=editDescr() style=\"margin: 4px\"></span></div><div class=click-editor ng-show=peditDescr style=\"min-height: 40px; margin-bottom: 30px\"><textarea class=mobile-textarea focus=true maxlength=4000 ng-model=peditDescrInput autoresize-textarea placeholder=\"{{\'EVENT_DESCRIPTION\' | translate }}\"></textarea><div><span class=\"icon dripicons-checkmark\" ng-click=updateDescr()></span> <span class=\"icon dripicons-cross\" ng-click=cancelDescr()></span></div></div><div class=pic><div style=\"text-align: center\"><img alt=\"\" ng-src=\"{{ group.avatar }}\" onerror=\"this.src=\'assets/images/no-events.svg\'\" class=photo-holder><div ng-if=group.owner ng-class=\"{\'show-for-owner\': group.owner}\" class=\"edit-button ng-scope\" ng-click=uploadImage()><span class=\"icon dripicons-camera\"></span></div></div></div></div></div>");
$templateCache.put("app/groups/views/post-likes-modal.html","<div class=likes-modal><div class=modal-header><div style=\"font-weight: 600; font-size: 15px\"><span>{{ object.likes.length }}</span> <span ng-if=\"object.type != \'welcome\'\" translate=LIKES></span> <span ng-if=\"object.type == \'welcome\'\" translate=WELCOMES></span></div></div><div class=show-participants><ul class=basket><li ng-click=openLiker(item) ng-repeat=\"item in object.likes track by $index\"><div class=participant><figure class=avatar><avatar source={{item.avatar}} name=\"{{ item.firstName + \' \' + item.lastName }}\" width=40 height=40></avatar></figure>{{item.firstName}} {{item.lastName}}</div></li></ul></div><div class=modal-footer><button class=\"btn btn-ghost\" type=button ng-click=\"close(); isClicked = isClicked + 1\" ng-init=\"isClicked = 0\"><span translate=DONE_BTN></span></button></div></div>");
$templateCache.put("app/groups/views/reject-request-modal.html","<div><div class=modal-header><h3 class=modal-title translate=GROUP_REJECT_TEXT_1></h3></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=save(); ng-disabled=rejecting><span translate=REJECT_BTN></span></button></div></div>");
$templateCache.put("app/groups/views/remove-members-group-modal.html","<div class=remove-members-groups ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=REMOVE_MEMBERS_TITLE translate-values={name:user.name}></h3></div><div class=modal-body><p translate=REMOVE_MEMBERS_TEXT translate-values={name:user.name}></p><input ng-show=\"{{group.members && group.members.length>0}}\" type=search class=\"form-control input-lg\" placeholder=\"{{ \'START_TYPING_NAME_PHOLDER\' | translate }}\" ng-model=keyword> <button id=checkallBoxesForTest class=testing-only ng-click=checkAllBoxes()>check all</button><ul class=basket><li ng-repeat=\"member in group.members |filter: keyword track by $index\"><div ng-click=\"member.checked=!member.checked\" ng-class=\"{selected: member.checked}\"><figure class=avatar><avatar source={{member.avatar}} name=\"{{ member.name }}\" width=40 height=40></avatar></figure><strong>{{member.name}}</strong> <input type=checkbox class=pull-right ng-checked=member.checked></div></li></ul></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=remove() ng-disabled=!getSelectedMembers(group.allMembers)><span translate=REMOVE_BTN></span></button></div></div>");
$templateCache.put("app/groups/views/request-modal.html","<div class=request-modal><div class=modal-header><h3 class=modal-title translate=GROUPS_REQUEST_MODAL_TEXT_1></h3></div><div class=request-line></div><div class=modal-body><div class=request-text-holder><span class=request-title>{{group.title}}</span></div><div class=\"request-text-holder request-date\"><span translate=REQUEST_CREATED_AT></span> {{::group.created | date:\'h:mm a,\' }} {{::group.created | date:\'MMM dd\' }}</div><div class=request-text-holder><span class=request-description>{{ splitDescription(group.description) }}</span></div></div><div class=request-line></div><div class=modal-footer><div class=request-notification><span class=request-notification-text translate=GROUPS_REQUEST_MODAL_TEXT_2></span></div><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=request() ng-disabled=disableRequest><span translate=REQUEST_BTN></span></button></div></div>");
$templateCache.put("app/groups/views/wrapper.html","<div class=groups><div ui-view autoscroll=false></div></div>");
$templateCache.put("app/home/views/delete-post-modal.html","<div><div class=modal-header><h3 translate=DELETE_POST_HEADER></h3></div><div class=modal-body><p translate=DELETE_POST_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=OK_BTN ng-click=confirm()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/home/views/lock-comment-modal.html","<div><div class=modal-header><h3 translate=\"{{isLocked ? \'UNLOCK_COMMENT_HEADER\' : \'LOCK_COMMENT_HEADER\'}}\"></h3></div><div class=modal-body><p translate=\"{{isLocked ? \'UNLOCK_COMMENT_TEXT\' : \'LOCK_COMMENT_TEXT\'}}\"></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=OK_BTN ng-click=confirm()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/home/views/mark-sold-modal.html","<div><div class=modal-header><h3 translate=MARK_SOLD_HEADER></h3></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=OK_BTN ng-click=confirm()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/home/views/no-pupil-modal.html","<div class=no-pupils-modal><div class=modal-header><h3 translate=EMPTY_HOME_TEXT_1></h3></div><div class=modal-body><p translate=EMPTY_CLASSLIST_TEXT_2></p></div><div class=modal-footer><a type=button class=\"btn btn-default\" translate=LATER_BTN ng-click=close()></a> <a href=#/profile type=button class=\"btn btn-default\" translate=EMPTY_CLASSLIST_TEXT_3></a></div></div>");
$templateCache.put("app/home/views/post-groups-modal.html","<div class=likes-modal><div class=modal-header><div style=\"font-weight: 600; font-size: 15px\"><span>{{ _groups.length }}</span> <span translate=GROUPS_TEXT></span></div></div><div class=show-participants><ul class=basket><li ng-click=openGroup(group) ng-repeat=\"group in _groups track by $index\" style=\"cursor: pointer\"><div class=participant><figure class=avatar><avatar source=\"{{ group.avatar }}\" name=\"{{ group.title }}\" width=40 height=40></avatar></figure>{{ group.title }}</div></li></ul></div><div class=modal-footer><button class=\"btn btn-ghost\" type=button ng-click=\"close(); isClicked = isClicked + 1\" ng-init=\"isClicked = 0\" style=\"margin-right: 14px\"><span translate=DONE_BTN></span></button></div></div>");
$templateCache.put("app/home/views/post-likes-modal.html","<div class=likes-modal><div class=modal-header><div style=\"font-weight: 600; font-size: 15px\"><span>{{ object.likes.length }}</span> <span ng-if=\"object.type != \'welcome\' && object.type != \'thanks\'\" translate=LIKES></span> <span ng-if=\"object.type == \'welcome\'\" translate=WELCOMES></span> <span ng-if=\"object.type != \'welcome\' && object.type == \'thanks\'\" translate=THANK_YOUS></span></div></div><div class=show-participants><ul class=basket><li ng-click=openLiker(item) ng-repeat=\"item in object.likes track by $index\"><div class=participant><figure class=avatar><avatar source={{item.avatar}} name=\"{{ item.firstName + \' \' + item.lastName }}\" width=40 height=40></avatar></figure>{{item.firstName}} {{item.lastName}}</div></li></ul></div><div class=modal-footer><button class=\"btn btn-ghost\" type=button ng-click=\"close(); isClicked = isClicked + 1\" ng-init=\"isClicked = 0\"><span translate=DONE_BTN></span></button></div></div>");
$templateCache.put("app/home/views/posts.html","<section class=home-view add-participants ng-class=\"{\'is-visible\':viewState.isInitiated}\" post-likes><div ng-if=premium_ad class=\"page-view-header premium-ad-header premium-ad-short\"><div class=no-border style=\"z-index: 10000\"><div premium-ad></div></div></div><div class=page-container-header-from-top><div><ng-include ng-if=showAppcueGroupsInfo src=\"\'app/base/appcues/groups-modal.html\'\"></ng-include><div ng-if=viewState.isReady><div class=announcement-container ng-if=isSunsetModalVisible><div class=content-wrapper><div class=announcement-image-container><img src=https://storage.googleapis.com/classlist-branding/app-assets/pwa-sunset-phone-3.png alt=\"QR and Phone\"></div><div class=announcement-text-container style=margin-top:-15px><p class=announcement-title translate=PWA_SUNSET_TITLE></p><p class=announcement-description translate=PWA_SUNSET_TITLE_DESC></p><!-- <a href=\"https://help.classlist.com/hc/en-us/articles/24780845259933-Classlist-for-Parents-Embracing-Mobile-for-Better-Community-Engagement\" target=\"_blank\" class=\"announcement-learn-more\" translate=\"PWA_SUNSET_TITLE_DESC_2\"></a> --><p class=announcement-description translate=PWA_SUNSET_TITLE_DESC_3 style=padding-bottom:5px;padding-top:8px></p><div class=announcement-download-buttons><div class=announcement-button><a title=\"apple store\" ng-click=gotoAppStore() target=_blank><img src=https://storage.googleapis.com/classlist-branding/email-template/ios-store-link.png alt=\"Apple Store\"></a></div><div class=announcement-button><a title=\"play store\" ng-click=gotoGooglePlay() target=_blank><img src=https://storage.googleapis.com/classlist-branding/email-template/android-store-link.png alt=\"Google Play\"></a></div></div></div></div><button class=announcement-close-button ng-click=closeModal()><svg width=24 height=24 viewBox=\"0 0 24 24\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M20 4 4 20M20 20 4 4\" stroke=#627293 stroke-width=1.5 stroke-linecap=round stroke-linejoin=round /></svg></button></div><div class=search-box ng-click=goToSearch()><div class=search-label><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 64 64\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><line data-cap=butt data-color=color-2 fill=none stroke=#627293 stroke-width=4 stroke-miterlimit=10 x1=60 y1=60 x2=43 y2=43 stroke-linejoin=miter stroke-linecap=butt></line><circle fill=none stroke=#627293 stroke-width=4 stroke-linecap=square stroke-miterlimit=10 cx=26 cy=26 r=24 stroke-linejoin=miter></circle></g></svg> <span translate=SEARCH_POST_TXT style=\"padding-top: 3px; float: left\">Search for parent or child</span></div></div><!-- MAIN GROUPS SECTION --><section class=groups-list><div class=group-box ng-repeat=\"g in mainGroups\"><div ng-click=goToGroup(g) style=\"padding-right: 0\"><div class=vi-row><div class=vi-col-left style=\"width: 75px\"><div ng-if=\"g.type === \'ALL_ACTIVITY\'\" class=group-school-logo ng-class=\"{ \'group-info group-school clearfix\': g.type === \'SCHOOL_GROUP\', \'group-info group-admin clearfix\': g.type === \'ADMIN_GROUP\' }\"><img width=100% height=100% style=\"width: 100%; height: 100%\" src=https://storage.googleapis.com/classlist-branding/app-assets/home-icon-newsfeed-v2.png></div><div ng-if=\"g.type !== \'ALL_ACTIVITY\'\" class=group-school-logo ng-class=\"{ \'group-info group-school clearfix\': g.type === \'SCHOOL_GROUP\', \'group-info group-admin clearfix\': g.type === \'ADMIN_GROUP\' }\"><img alt=\"\" ng-src=\"{{ getServingURL(g.avatar, 60, true) }}\" style=\"object-fit: cover\" width=60 height=60 onerror=\"this.src=\'assets/icons/default-school-logo.png\'\"></div></div><div class=vi-col-right style=\"width: auto\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=45px height=45px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><path fill=#b6c2db d=M26,17.172L23.172,20l12,12l-12,12L26,46.828l13.414-13.414c0.781-0.781,0.781-2.047,0-2.828L26,17.172z></path></g></svg></div><div class=vi-col-right style=\"width: auto; margin-right: 10px\"><div class=time-ago-text><time ng-if=\"g.lastPost && g.lastPost.updated!=\'\' \">{{ g.lastPost.updated | timeago }}</time></div><div ng-if=\"g.notificationCount > 0\"><figure class=\"group-member-count clearfix\"><span class=number>{{g.notificationCount }}</span></figure></div></div><div class=vi-col-middle><div class=group-names><div class=\"group-names-child {{ g.type == \'ALL_ACTIVITY\' ? \'all-activity-group-type\' : \'\' }}\"><div class=group-name>{{g.title}}</div><div class=group-type-container ng-if=\"g.type === \'PARENT_PUBLIC\' || g.type === \'PARENT_PRIVATE\'\"><span ng-if=\"g.type === \'PARENT_PUBLIC\'\" translate=OPEN_TO_JOIN></span> <span ng-if=\"g.type === \'PARENT_PRIVATE\'\" translate=APPROVAL_NEEDED></span></div><div ng-if=\"g.lastPost.createdBy && g.lastPost.createdBy !=\'\'\" class=\"group-type-container group-description\"><span ng-bind-html=g.lastPost.text ng-if=\"g.lastPost.text && g.lastPost.text !== \'\'\"></span></div><div ng-if=\"(!g.lastPost.createdBy || g.lastPost.createdBy == \'\') && g.description && g.description !=\'\'\" class=\"group-type-container group-description\"><span ng-bind-html=g.description></span></div><div translate=\"{{g.status == \'PENDING_APPROVAL\' ? \'SNIPPET_WAITING_APPROVAL\' : \'SNIPPET_NO_POST\'}}\" ng-if=\"(!g.lastPost.createdBy || g.lastPost.createdBy == \'\') && (!g.description || g.description == \'\')\" class=group-type-container></div></div></div></div></div></div></div></section><!-- GROUPS SECTION --><div class=discover style=\"margin-top: 6px\"><span translate=MY_GROUPS_HEADER></span> <a class=link ui-sref=groups.create translate=CREATE_GROUP style=\"float: right; font-weight: normal; font-size: 15px\"></a></div><!-- MEMBERSHIPS SECTION --><section class=groups-list ng-repeat=\"groupCluster in groups track by $index\"><div class=group-box ng-repeat=\"g in groupCluster\"><div ng-click=goToGroup(g) style=\"padding-right: 0\"><div class=vi-row><div class=vi-col-left style=\"width: 75px\"><div class=group-school-logo ng-class=\"{ \'group-info group-school clearfix\': g.type === \'SCHOOL_GROUP\', \'group-info group-admin clearfix\': g.type === \'ADMIN_GROUP\' }\"><img alt=\"\" ng-src=\"{{ getServingURL(g.avatar, 60, true) }}\" style=\"object-fit: cover\" width=60 height=60 onerror=\"this.src=\'assets/icons/default-school-logo.png\'\"></div></div><div class=vi-col-right style=\"width: auto\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=45px height=45px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><path fill=#b6c2db d=M26,17.172L23.172,20l12,12l-12,12L26,46.828l13.414-13.414c0.781-0.781,0.781-2.047,0-2.828L26,17.172z></path></g></svg></div><div class=vi-col-right style=\"width: auto; margin-right: 10px\"><div class=time-ago-text><time ng-if=!g.archived ng-if=\"g.lastPost && g.lastPost.updated!=\'\' \">{{ g.lastPost.updated | timeago }} </time><time ng-if=g.archived>Last active {{ g.archivedAt | date:\'dd MMM yyyy\' }}</time></div><div ng-if=\"g.notificationCount > 0\"><figure class=\"group-member-count clearfix\"><span class=number>{{g.notificationCount }}</span></figure></div></div><div class=vi-col-middle><div class=group-names><div class=\"group-names-child {{ g.type == \'ALL_ACTIVITY\' ? \'all-activity-group-type\' : \'\' }}\"><div class=group-name ng-class=\"{\'group-tier-archived\': g.archived}\"><span ng-if=g.archived>Archived - </span>{{g.title}}</div><div class=group-type-container ng-if=\"g.type === \'PARENT_PUBLIC\' || g.type === \'PARENT_PRIVATE\'\"><span ng-if=\"g.type === \'PARENT_PUBLIC\'\" translate=OPEN_TO_JOIN></span> <span ng-if=\"g.type === \'PARENT_PRIVATE\'\" translate=APPROVAL_NEEDED></span></div><div ng-if=\"g.lastPost.createdBy && g.lastPost.createdBy !=\'\'\" class=\"group-type-container group-description\"><span ng-bind-html=g.lastPost.text ng-if=\"g.lastPost.text && g.lastPost.text !== \'\'\"></span></div><div ng-if=\"(!g.lastPost.createdBy || g.lastPost.createdBy == \'\') && g.description && g.description !=\'\'\" class=\"group-type-container group-description\"><span ng-bind-html=g.description></span></div><div translate=\"{{g.status == \'PENDING_APPROVAL\' ? \'SNIPPET_WAITING_APPROVAL\' : \'SNIPPET_NO_POST\'}}\" ng-if=\"(!g.lastPost.createdBy || g.lastPost.createdBy == \'\') && (!g.description || g.description == \'\')\" class=group-type-container></div></div></div></div></div></div></div></section><!-- DISCOVER SECTION --><div class=discover><span translate=GROUPS_DISCOVER_TEXT></span> <a class=link ui-sref=groups.create translate=CREATE_GROUP style=\"float: right; font-weight: normal; font-size: 15px\"></a></div><div class=empty-state ng-if=\"discovers.length == 0 && viewState.isReady == true\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><line data-color=color-2 x1=20 y1=44 x2=44 y2=44 fill=none stroke=#005cb8 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></line><circle data-color=color-2 cx=19.5 cy=29.5 r=2.5 fill=none stroke=#005cb8 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></circle><circle data-color=color-2 cx=44.5 cy=29.5 r=2.5 fill=none stroke=#005cb8 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></circle><circle cx=32 cy=32 r=28 fill=none stroke=#005cb8 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></circle><circle data-color=color-2 data-stroke=none cx=19.5 cy=29.5 r=2.5 fill=#005cb8></circle><circle data-color=color-2 data-stroke=none cx=44.5 cy=29.5 r=2.5 fill=#005cb8></circle></g></svg><h4 translate=EMPTY_TITLE_GROUPS></h4><p translate=EMPTY_DESCR_GROUPS></p></div><section class=groups-list ng-repeat=\"groupCluster in discovers\"><div class=group-box ng-if=\"g.type === \'PARENT_PRIVATE\' || g.type === \'PARENT_PUBLIC\'\" ng-repeat=\"g in groupCluster\"><div style=\"overflow: auto\" ng-click=\"goToGroup(g, true)\"><div class=vi-row><div class=vi-col-left style=\"width: 75px\"><div class=\"group-school-logo group-comm\" style=\"background-image: url(\'{{g.avatar}}\'); background-color: white\"></div></div><div class=vi-col-middle><div class=group-names><div class=group-names-child><div class=group-name>{{g.title}}</div><div class=group-type-container><span translate={{g.status}}>{{g.status}}</span></div><div class=group-type-container ng-if=!!g.description><span>{{capDescription(g.description)}}</span><div class=group-description-bottom-shadow ng-if=\"getWordCount(g.description) > 50\"><a class=btn-default translate=READ_MORE_BTN></a></div></div></div></div></div></div></div></div></section><div class=discover style=\"margin-top: 6px; text-align: center\" ng-if=!viewMore><a ng-click=viewMoreGroups() class=link translate=VIEW_MORE style=\"font-weight: normal; font-size: 15px\"></a></div><div ng-if=\"viewState.isReady && discovers && discovers.length > 0\" class=group-create-bottom><h2 style=\"color: #005cb8\" translate=SHARE_YOUR_PASSIONS></h2><p translate=SHARE_YOUR_PASSIONS_CONTENT></p><div><button type=button class=\"btn btn-primary btn-primary-pink\" ui-sref=groups.create><span translate=CREATE_NEW_GROUP></span></button></div></div></div></div></div><div class=fab-plus ng-click=menuPlusMenu($event)><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=25px height=25px viewBox=\"0 0 48 48\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><line fill=none stroke=#ffffff stroke-width=4 stroke-linecap=round stroke-miterlimit=10 x1=24 y1=14 x2=24 y2=34 stroke-linejoin=round></line><line fill=none stroke=#ffffff stroke-width=4 stroke-linecap=round stroke-miterlimit=10 x1=34 y1=24 x2=14 y2=24 stroke-linejoin=round></line></g></svg></div></section>");
$templateCache.put("app/home/views/update-app-modal.html","<div><div class=modal-body><p translate=UPDATE_APP_TEXT_1></p></div><div class=modal-footer style=\"padding-top: 0\"><div><div><a type=button class=\"btn btn-primary pull-right\" translate=UPDATE href=https://itunes.apple.com/us/app/classlist/id1058636226 target=_blank></a></div></div></div></div>");
$templateCache.put("app/home/views/wrapper.html","<div class=home-background><div class=\"content-logged home\"><div autoscroll=false><ng-include src=\"\'app/home/views/posts.html\'\"></ng-include></div></div></div>");
$templateCache.put("app/inbox/views/inbox.conversations.module.html","<div class=conversation-list id=conversationList ng-touchstart=\"hovered = true\" ng-touchend=\"hovered = false\" ng-class=\"{\'active\': hovered }\" style=\"margin-top: 0; padding-bottom: 80px\"><div class=empty-state ng-if=\"conversations.length == 0 && viewState.isReady == true\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><line data-color=color-2 x1=20 y1=44 x2=44 y2=44 fill=none stroke=#4aa0f0 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></line><circle data-color=color-2 cx=19.5 cy=29.5 r=2.5 fill=none stroke=#4aa0f0 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></circle><circle data-color=color-2 cx=44.5 cy=29.5 r=2.5 fill=none stroke=#4aa0f0 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></circle><circle cx=32 cy=32 r=28 fill=none stroke=#4aa0f0 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></circle><circle data-color=color-2 data-stroke=none cx=19.5 cy=29.5 r=2.5 fill=#4aa0f0></circle><circle data-color=color-2 data-stroke=none cx=44.5 cy=29.5 r=2.5 fill=#4aa0f0></circle></g></svg><h4 translate=EMPTY_TITLE_MESSAGES></h4><p translate=EMPTY_DESCR_MESSAGES></p></div><aside ng-repeat=\"c in conversations\" class=\"conversation-item {{c.read}}\" ng-class=\"{\'active\': c.id === viewState.activeConversation, \'unread\': !c.read}\" ng-click=\"viewState.activeConversation = c.id\"><div ng-if=\"c.id !== \'new\'\"><div ng-click=openConversation({id:c.id}) ui-sref-active=active class=\"messages-avatar-wrapper {{ c.unreadMessageCount > 0 ? \'unread-item\' : \'\' }}\"><figure class=avatar style=\"margin-top: 0\"><avatar source={{c.avatar}} width=35 height=35 name=\"{{ c.subject }}\" ng-hide=\"c.participants.length > 2\"></avatar><svg ng-show=\"c.participants.length > 2\" style=\"width: 24px; height: 40px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><path data-color=color-2 fill=none stroke=#ffffff stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M38,19 c0,4.971,4.029,11,9,11s9-6.029,9-11s-4.029-9-9-9S38,14.029,38,19z\" stroke-linejoin=miter></path><path data-cap=butt data-color=color-2 fill=none stroke=#ffffff stroke-width=2 stroke-miterlimit=10 d=\"M48,50h14v-4.324 c0-2.446-1.47-4.657-3.742-5.562C55.657,39.077,51.8,38,47,38s-8.657,1.077-11.258,2.113c-1.072,0.427-1.961,1.14-2.605,2.036\" stroke-linejoin=miter stroke-linecap=butt></path><path fill=none stroke=#ffffff stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M40,56H2v-5.63 c0-3.052,1.722-5.845,4.466-7.182C9.668,41.628,14.554,40,21,40s11.332,1.628,14.534,3.188C38.278,44.525,40,47.318,40,50.37V56z\" stroke-linejoin=miter></path><path fill=none stroke=#ffffff stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M32,19 c0,6.075-4.925,13-11,13s-11-6.925-11-13S14.925,8,21,8S32,12.925,32,19z\" stroke-linejoin=miter></path></g></svg></figure><div class=avatar-companion style=\"display: block; max-width: 100%; padding-left: 50px\"><div style=\"overflow: auto\"><strong class=conversation-list__subject style=\"max-width: 60%; float: left; width: 100%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; line-height: 20px\">{{ c.subject }}</strong><div ng-if=isThisYear(c.timestamp) class=mess-timestamp>{{ c.timestamp | date: \'h:mm a MMM dd\' }}</div><div ng-if=!isThisYear(c.timestamp) class=mess-timestamp>{{ c.timestamp | date: \'MMM dd yyyy\' }}</div></div><div style=\"font-size: 13px; overflow: auto\"><div class=mess-body-preview ng-bind-html=c.lastMessage></div><div class=new-mess-badge>{{ c.unreadMessageCount }}</div></div></div></div></div></aside><div ng-hide=viewState.hasConversations style=\"text-align: center; padding: 0 40px\"><img alt=\"\" src=assets/images/no-messages-V2.svg width=196 height=auto style=\"display:block; margin: 20px auto\"> <span translate=INBOX_NO_MESSAGES></span></div></div>");
$templateCache.put("app/inbox/views/inbox.participant.module.html","<script type=text/ng-template id=participantTemplate.html><a>\n		<span ng-bind-html=\"match.model.field1 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field1\"></span>\n		<span ng-bind-html=\"match.model.field2 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field2\"></span>\n	</a></script><div class=manage-participants><div class=modal-header><h3 class=modal-title translate=ADD_RECIPIENT_TITLE ng-if=\"!eventContext && !showTiers\"></h3><h3 class=modal-title translate=INVITE_GUESTS_TITLE ng-if=\"eventContext || showTiers\"></h3></div><div class=modal-body><p translate=ADD_RECIPIENT_INTRO ng-if=\"!eventContext && !showTiers\"></p><p translate=INVITE_GUESTS_HELP ng-if=\"eventContext || showTiers\"></p><div><participants ng-model=participants event-context=\"{{ eventContext }}\" show-tiers=\"{{ showTiers }}\" school-id=\"{{ schoolId }}\" allow-host-invite=true></participants><div class=error-text-red ng-show=\"event.guests.length === 0 && isClicked >= 1\"><p translate=ERR_EVENT_GUESTS></p></div></div></div><div class=modal-footer style=\"border-top:1px solid #d8d8d8\"><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=save() ng-disabled=\"participants.length < 1\"><span translate=CREATE_FOOTER_BTN></span></button></div></div>");
$templateCache.put("app/inbox/views/info.html","<section class=\"message-info full-height is-visible\" add-participants><form novalidate name=sm style=\"position: relative\"><div class=\"page-view-header clearfix {{ premium_ad ? \'premium-ad-header premium-ad-short\' : \'\' }}\"><div style=\"padding: 0\"><div premium-ad></div><div class=message-participants style=\"padding: 0\"><div class=messages-avatar-wrapper style=\"padding: 0 15px; padding-bottom: 10px; height: 50px; position: relative\"><div class=pull-left style=\"max-width: 87%\"><svg id=header-back-button ng-click=back() class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg></div><span class=pull-right style=\"padding: 0; margin-right: -15px\"><nav class=\"has-dropdown is-relative more-dots\"><div style=\"overflow: auto\"><svg style=\"transform: rotate(90deg); padding: 0 15px; float: right; height: 50px; width: 50px; cursor: pointer\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\"><g transform=\"translate(0, 0)\"><circle fill=#444444 cx=4 cy=16 r=3></circle><circle data-color=color-2 fill=#444444 cx=16 cy=16 r=3></circle><circle fill=#444444 cx=28 cy=16 r=3></circle></g></svg></div><ul class=dropdown-menu style=\"right: -1px!important; top: 50px\"><li><a translate=ADD_PARTICIPANTS ng-click=addToConversation()></a></li><li><a translate=LEAVE_CONVERSATION ng-click=leaveConversation()></a></li></ul></nav></span></div></div></div></div><div ng-if=checkSave()><a class=\"fab-button fab-create-message\" ng-click=save() style=\"bottom: auto; position: absolute; top: 117px\"><svg style=\"width: 50px; height: 50px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><polyline fill=none stroke=#ffffff stroke-width=2 stroke-linecap=square stroke-miterlimit=10 points=\"18,34 26,42 46,22 \" stroke-linejoin=miter></polyline></g></svg></a></div><div class=info-page style=\"{{ premium_ad ? \'margin-top: 50px;\' : \'\' }}\"><div ng-if=message_info.group class=info-name><div><input type=text class=form-control placeholder=\"Add a conversation name\" ng-model=info.name style=\"font-size: 16px\"></div></div><div class=info-header>{{ message_info.participants.length }} participants</div><div style=\"padding: 5px 10px\"><div ng-repeat=\"c in message_info.participants\" style=\"overflow: auto; margin: 16px 0\"><figure class=classlist-item-avatar ng-click=\"gotoProfile(c.id, c)\" style=\"float: left; height: 40px; margin-right: 10px; position: relative\"><avatar source=\"{{ (contacts_list.baseUrl + c.id) }}\" width=40 height=40 name=\"{{ c.fN + \' \' + c.lN }}\" my=false></avatar><div ng-if=c.selected class=contact-selected-checkmark><span class=dripicons-checkmark></span></div></figure><div style=\"margin-right: 75px; overflow: auto; cursor: pointer\" ng-click=\"gotoProfile(c.id, c)\"><div class=contact-name><span ng-if=\"c.id != active_user.id\">{{ c.fN }} {{ c.lN }}</span><span ng-if=\"c.id == active_user.id\">You</span></div><div><span ng-repeat=\"p in c.ps\" style=\"color: #777\">{{ p.fN }} {{ p.lN }}<span ng-hide=\"$index == c.ps.length-1\">,&nbsp;</span></span></div></div></div></div></div></form></section>");
$templateCache.put("app/inbox/views/leave.conversation.html","<div class=assign-parent-admin ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=LEAVE_CONVERSATION_TITLE translate-values={name:parentName}></h3></div><div class=modal-body><p translate=LEAVE_CONVERSATION_TEXT></p></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=leave()><span translate=LEAVE_BTN></span></button></div></div>");
$templateCache.put("app/inbox/views/list.html","<section class=is-relative><div class=\"page-view-header clearfix {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div><div premium-ad></div><div><div class=page-subheader-title><svg ng-click=goback() id=header-back-button class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <strong class=page-view-header__title translate=MESSAGES_TITLE></strong> <button ng-click=createNewMessage(2) class=\"btn btn-primary pull-right btn-primary-pink plus-button btn-primary-subheader\" style=\"margin-top: 7px\"><svg style=\"float: left; margin-top: 3px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=25px height=25px viewBox=\"0 0 48 48\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><line fill=none stroke=#ffffff stroke-width=4 stroke-linecap=round stroke-miterlimit=10 x1=24 y1=14 x2=24 y2=34 stroke-linejoin=round></line><line fill=none stroke=#ffffff stroke-width=4 stroke-linecap=round stroke-miterlimit=10 x1=34 y1=24 x2=14 y2=24 stroke-linejoin=round></line></g></svg> <span translate=CREATE_BTN style=\"margin-top: 0px; float: left\"></span></button></div></div></div></div><conversations></conversations></section>");
$templateCache.put("app/inbox/views/max-participants-modal.html","<div add-participants class=is-visible><div class=modal-body><p translate=MAX_PARTICIPANTS_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=GOTO_GROUP_BTN ng-click=confirm()><button type=button class=\"btn btn-default pull-right\" translate=NOT_NOW_BTN ng-click=close()></div></div>");
$templateCache.put("app/inbox/views/no-participants-modal.html","<div add-participants class=is-visible><div class=modal-body><p translate=NO_PARTICIPANTS_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=OK_BTN ng-click=close()></div></div>");
$templateCache.put("app/inbox/views/show-participants-modal.html","<div class=\"messages show-participants scrollbar-enabled\" add-participants ng-class=\"{\'is-visible\':viewState.isReady}\"><ul class=basket><li ng-repeat=\"p in participants track by $index\"><div class=participant style=\"background: transparent\"><figure class=avatar><avatar source={{p.avatar}} name=\"{{ p.firstName + \' \' + p.lastName }}\" width=40 height=40></avatar></figure><div class=\"{{ p.tickets ? \'two-lines-height\' : \'\' }}\"><div><div style=\"{{ p.pupilNames ? \'line-height: 20px;\' : \'line-height: 39px;\' }}\">{{ p.firstName }} {{ p.lastName }}</div><div ng-if=p.pupilNames style=\"line-height: 17px; font-size: 12px; color: #777\">{{ p.pupilNames }}</div></div><span ng-if=p.tickets><span class=dripicons-ticket></span> {{ p.tickets }} <span translate=TICKETS_LABEL></span></span></div></div></li></ul><a class=add-participant ng-click=\"close(); openAddParticipantsModal()\" ng-if=!addDisabled><span class=dripicons-plus></span> <span translate=ADD_RECIPIENT_BTN ng-if=!eventContext></span> <span translate=ADD_GUESTS_BTN ng-if=eventContext></span></a></div>");
$templateCache.put("app/inbox/views/upload-preview-modal.html","<div class=\"messages show-participants\" add-participants ng-class=\"{\'is-visible\':viewState.isReady}\"><div style=\"overflow: auto; padding-bottom: 8px; position: relative\"><svg id=header-back-button ng-click=close() class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg><div class=page-view-header__text style=\"padding-left: 40px\"><div style=\"font-size: 16px; cursor: pointer\"><div><figure ng-click=checkGoProfile(message_data) class=avatar style=\"margin-top: 5px; margin-right: 10px\"><avatar source=\"{{ message_data.avatar }}\" name=\"{{ message_data.subject }}\" width=40 height=40></avatar></figure><div class=mobile-elipsis-title style=\"margin-top: 7px\"><strong ng-click=checkGoProfile(message_data) style=\"line-height: 35px; font-size: 15px\" class=mess-name class=conversation-list__subject>{{ message_data.subject }}</strong></div></div></div></div></div><div ng-if=preview_object.isimage style=\"text-align: center\"><img alt=\"\" src=\"{{ preview_object.src }}\" style=\"max-width: 100%; padding-bottom: 35px; max-height: 350px\"></div><div ng-if=!preview_object.isimage><br><div style=\"margin: auto; max-width: 90%; border: 1px solid #ccc; padding: 10px 15px; border-radius: 10px\"><a style=\"word-break: break-word; cursor: default!important; text-decoration: none!important\" target=_blank>{{ preview_object.name }}</a></div><br></div><div style=\"position: relative\"><a class=\"fab-button fab-send-file\" ng-click=sendfile() style=\"position: absolute; bottom: 8px; right: 15px\"><svg style=\"margin-top: 16px; margin-left: 5px\" xmlns=http://www.w3.org/2000/svg xmlns:sketch=http://www.bohemiancoding.com/sketch/ns xmlns:xlink=http://www.w3.org/1999/xlink height=18px version=1.1 viewBox=\"0 0 23 18\" width=23px><g fill=none fill-rule=evenodd id=Page-1 stroke=none stroke-width=1><g fill=#ffffff id=Core transform=\"translate(-421.000000, -381.000000)\"><g id=send transform=\"translate(421.500000, 381.000000)\"><path d=\"M0,18 L21,9 L0,0 L0,7 L15,9 L0,11 L0,18 Z\" id=Shape /></g></g></g></svg></a></div><div style=\"padding: 0 15px\"><div style=\"border-radius: 20px; border: 1px solid #ccc; overflow: auto\"><textarea ng-model=preview_object.caption autoresize-textarea rows=1 placeholder=\"{{ \'ADD_CAPTION_PHOLDER\' | translate}}\" style=\"max-height: 17vh; border-radius: 20px; padding: 10px 20px; float: left; width: 100%\"></textarea></div><br></div></div>");
$templateCache.put("app/inbox/views/view.html","<section class=\"message-compose is-relative\" add-participants><div class=\"page-view-header clearfix {{ premium_ad ? \'premium-ad-header premium-ad-short\' : \'\' }}\" style=\"padding: 0; min-height: 70px\"><div style=\"padding: 0\"><div class=premium-ad-clear style=\"padding: 0 15px\"><div premium-ad></div></div><div class=message-participants style=\"padding: 0; border-top: 1px solid #d8d8d8\"><div class=messages-avatar-wrapper style=\"padding: 0 15px;\n						padding-bottom: 10px;\n						height: 50px;\n						position: relative\"><div ng-if=messagesloaded class=pull-left style=\"max-width: 87%\"><svg id=header-back-button ng-click=back() class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg><div class=page-view-header__text style=\"padding-left: 25px\"><div style=\"font-size: 16px; cursor: pointer\"><div><figure ng-click=checkGoProfile(message_data) class=avatar style=\"margin-top: 5px; margin-right: 10px\"><avatar source=\"{{ message_data.avatar }}\" name=\"{{ message_data.subject }}\" width=40 height=40></avatar></figure><div class=mobile-elipsis-title style=\"margin-top: 7px\"><strong ng-click=checkGoProfile(message_data) style=\"line-height: 35px; font-size: 15px\" class=mess-name class=conversation-list__subject>{{ message_data.subject }}</strong></div></div></div></div></div><span ng-if=\"messagesloaded && !sample\" class=pull-right style=\"padding: 0; margin-right: -15px\"><nav class=\"has-dropdown is-relative more-dots\"><div style=\"overflow: auto\"><svg style=\"transform: rotate(90deg);\n										padding: 0 15px;\n										float: right;\n										height: 50px;\n										width: 50px;\n										cursor: pointer\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\"><g transform=\"translate(0, 0)\"><circle fill=#444444 cx=4 cy=16 r=3></circle><circle data-color=color-2 fill=#444444 cx=16 cy=16 r=3></circle><circle fill=#444444 cx=28 cy=16 r=3></circle></g></svg></div><ul class=dropdown-menu style=\"right: -1px !important; top: 50px\"><li><a translate=MESSAGE_GROUP_INFO ng-click=infoConversation()></a></li><li ng-if=\"!message_data.reference || !message_data.referenceType\"><a translate=ADD_PARTICIPANTS ng-click=beforeAddToConversation()></a></li><li><a translate=LEAVE_CONVERSATION ng-click=leaveConversation()></a></li></ul></nav></span></div></div></div></div><div class=conversation-message-list id=autoscroll ng-touchstart=\"dHovered = true\" ng-touchend=\"dHovered = false\" ng-class=\"{\'active\': dHovered}\" style=\"{{ premium_ad ? \'margin-top: 60px;\' : \'\' }}\"><div class=empty-state ng-if=\"(!conversation.messages || conversation.messages.length == 0) && viewState.isReady\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><path d=M57,6H7a5,5,0,0,0-5,5V41a5,5,0,0,0,5,5H22L32,58,42,46H57a5,5,0,0,0,5-5V11A5,5,0,0,0,57,6Z fill=none stroke=#005cb8 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></path><line data-color=color-2 x1=16 y1=20 x2=48 y2=20 fill=none stroke=#005cb8 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></line><line data-color=color-2 x1=16 y1=32 x2=34 y2=32 fill=none stroke=#005cb8 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></line></g></svg><p translate=EMPTY_DESCR_CONVERSATIONS></p></div><div ng-repeat=\"c in conversation.messages track by $index\" class=\"conversation-message-item {{ c.event ? \'event-conv-message-item\' : \'\' }} {{ c.sending ? \'sending-mess\' : \'\' }}\"><div ng-if=\"c.senderId != active_user.id && c.event != \'joined\' && c.event != \'left\' && c.event != \'marketplace\'\" class=\"her-message {{ (buildMedia(c).doctype) ? \'body-image\' : \'\' }}\"><figure class=avatar style=\"margin-top: 20px; margin-right: 10px\"><avatar source={{c.senderAvatar}} name=\"{{ c.senderFirstName + \' \' + c.senderLastName }}\" width=40 height=40 ui-sref=\"classlist.details({\'id\':c.senderId })\"></avatar></figure><div style=\"margin-left: 50px; margin-top: 15px\"><div><div class=message-content><strong ui-sref=\"classlist.details({\'id\':c.senderId })\">{{::c.senderFirstName }} {{::c.senderLastName }}</strong></div></div><div><div class=message-content><div class=\"mess-body {{ checkBodyLength(c) ? \'split-body\' : \'\' }}\"><div class=quotation-other-user ng-if=c.replyTo><div class=user-name>{{ c.replyTo.senderId == active_user.id ? \'You\' : (c.replyTo.senderFirstName + \' \' + c.replyTo.senderLastName)}}</div><span linebreaks-to-html=c.replyTo.body class=multiple-line-text></span></div><div class=mess-picture ng-if=\"buildMedia(c).doctype == 2\"><div ng-click=openPicture(buildMedia(c)) class=\"media-picture-second {{ isPortrait(c) ? \'media-portrait\' : \'\' }}\" style=\"background-image: url(\'{{ buildMedia(c).url }}\')\"></div></div><div class=mess-doc ng-if=\"buildMedia(c).doctype == 1\"><a class=mess-doc-button href=\"{{ buildMedia(c).url }}\" target=_blank><span style=\"color: #888\" class=dripicons-document-new></span> <span class=mess-doc-title>{{ buildMedia(c).name }}</span></a><div class=mess-ext-label>{{ buildMedia(c).ext }}</div></div><div style=\"overflow: auto\"><p linebreaks-to-html=c.body class=multiple-line-text></p></div><div ng-click=expandBody(c) class=body-read-more><span>Read more...</span></div><!-- Reply text link which is display when users tap on message box --><div class=quoting-reply><a ng-click=quote(c)><span class=\"icon dripicons-reply\"></span>Reply</a></div><!-- Reply text link END --></div><time>{{c.timestamp | date:\'h:mm a\'}}, {{c.timestamp | date:\'MMM dd\' }}</time></div></div></div></div><div ng-if=\"c.senderId == active_user.id && c.event != \'marketplace\'\" class=\"mine-message {{ (buildMedia(c).doctype) ? \'body-image\' : \'\' }}\"><div class=message-content><div class=\"mess-body {{ checkBodyLength(c) ? \'split-body\' : \'\' }}\"><div class=quotation ng-if=c.replyTo><div class=user-name>{{ c.replyTo.senderId == active_user.id ? \'You\' : (c.replyTo.senderFirstName + \' \' + c.replyTo.senderLastName)}}</div><span linebreaks-to-html=c.replyTo.body class=multiple-line-text></span></div><div class=mess-picture ng-if=\"buildMedia(c).doctype == 2\"><div ng-click=openPicture(buildMedia(c)) class=\"media-picture {{ isPortrait(c) ? \'media-portrait\' : \'\' }}\" style=\"background-image: url(\'{{ buildMedia(c).url }}\')\"></div></div><div class=mess-doc ng-if=\"buildMedia(c).doctype == 1\"><a class=mess-doc-button href=\"{{ buildMedia(c).url }}\" target=_blank><span style=\"color: #888\" class=dripicons-document-new></span> <span class=mess-doc-title>{{ buildMedia(c).name }}</span></a><div class=mess-ext-label>{{ buildMedia(c).ext }}</div></div><p linebreaks-to-html=c.body class=multiple-line-text></p><div ng-click=expandBody(c) class=body-read-more><span>Read more...</span></div><!-- Reply text link which is display when users tap on message box --><div class=quoting-reply><a ng-click=quote(c)><span class=\"icon dripicons-reply\"></span>Reply</a></div><!-- Reply text link END --></div><time>{{c.timestamp | date:\'h:mm a\'}}, {{c.timestamp | date:\'MMM dd\' }}</time> <span class=\"message-checkmark {{ c.read ? \'read-check\' : \'\' }}\" ng-if=\"!c.sending && showOnlyNewDateTicks(c.timestamp)\"><span class=dripicons-checkmark></span> <span class=dripicons-checkmark></span> </span><time ng-if=\"c.sending && !c.justsent\" translate=SENDING_LABEL></time></div></div><!-- marketplace conversation card design --><div ng-if=\"c.event == \'marketplace\'\"><div class=\"conversation-message-event body-image\" style=\"text-align: center;;cursor:pointer\"><div class=message-content><div class=mess-body ng-click=openMarketplacePost(conversation.reference)><div class=mess-picture><div class=media-marketplace-picture style=\"background-image: url(\'{{ c.linkPreview.image }}\')\"></div><br><h4 style=\"font-weight: bold\">{{ c.linkPreview.title}}</h4></div></div></div></div><br></div><!-- marketplace conversation card design --><div ng-if=\"c.event == \'left\' || c.event == \'joined\'\" class=conversation-message-event style=\"height: 20px; margin: 20px 0\"><p><span ng-if=\"c.event == \'left\'\" translate=MSG_EVENT_LEFT translate-values=\"{\'firstName\':c.senderFirstName, \'lastName\':c.senderLastName}\"></span> <span ng-if=\"c.event == \'joined\'\" translate=MSG_EVENT_JOIN translate-values=\"{\'firstName\':c.senderFirstName, \'lastName\':c.senderLastName}\"></span></p></div>{{ $last ? scrollToBottom() : \'\' }}</div><div ng-if=\"conversation.messages.length == 0 && message_data.group && messagesloaded\" class=conversation-message-event style=\"height: 20px; margin: 20px 0\"><p><span>A new conversation has been started with these contacts</span></p></div><div style=\"min-height: 18vh; margin-top: 25px\"><div class=replying-message ng-if=replyTo><div class=cross-icon-area ng-click=discardQuote()><div class=\"icon dripicons-cross\"></div></div><div class=quotation-mine-message><div class=user-name>{{ replyTo.senderId == active_user.id ? \'You\' : (replyTo.senderFirstName + \' \' + replyTo.senderLastName)}}</div><span linebreaks-to-html=replyTo.body class=multiple-line-text></span></div></div><aside class=composer style=\"border-radius: 20px; border: 1px solid #ccc\"><form novalidate name=sm><div class=\"clearfix is-relative\"><div style=\"margin: 0\"><div style=\"position: relative\"><textarea autoresize-textarea id=message-body class=\"form-control message-body\" ng-model=body placeholder=\"{{ \'MESSAGE_BODY_PHOLDER\' | translate}}\" ng-change=setDraft() ng-minlength=regexes.min.msgBody maxlength=5000 rows=1 required noresize style=\"max-height: 17vh;\n										border-radius: 20px;\n										padding: 10px 20px;\n										background: transparent !important;\n										margin-left: 1px;\n										padding-right: 50px\"></textarea></div><div class=\"composer__action clearfix\" style=\"padding: 0; position: inherit; margin-right: 1px\"><div style=\"overflow: auto;\n										position: absolute;\n										bottom: 0;\n										right: 0\"><div ng-if=!sm.$invalid class=\"mobile-send-but {{ sm.$invalid ? \'mobile-send-diabled\' : \'\' }}\" ng-click=send() style=\"cursor: pointer\"><svg xmlns=http://www.w3.org/2000/svg xmlns:sketch=http://www.bohemiancoding.com/sketch/ns xmlns:xlink=http://www.w3.org/1999/xlink height=18px version=1.1 viewBox=\"0 0 23 18\" width=23px><g fill=none fill-rule=evenodd id=Page-1 stroke=none stroke-width=1><g fill=#eb004e id=Core transform=\"translate(-421.000000, -381.000000)\"><g id=send transform=\"translate(421.500000, 381.000000)\"><path d=\"M0,18 L21,9 L0,0 L0,7 L15,9 L0,11 L0,18 Z\" id=Shape /></g></g></g></svg></div></div></div><div ng-if=sample class=conv-placeholder><span translate=NO_MESSAGE_PLACEHOLDER></span></div></div></div></form></aside><div ng-hide=sample class=composer-media-picker><div ng-if=isNative ng-click=\"cameraUpload(participants, body)\"><span><svg style=\"width: 22px; height: 22px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><path fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M6,58h52 c2.209,0,4-1.791,4-4V18c0-2.209-1.791-4-4-4h-9l-7-8H28l-7,8H6c-2.209,0-4,1.791-4,4v36C2,56.209,3.791,58,6,58z\" stroke-linejoin=miter></path><circle data-color=color-2 fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 cx=35 cy=36 r=14 stroke-linejoin=miter></circle><circle fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 cx=13 cy=24 r=1 stroke-linejoin=miter></circle><circle data-stroke=none fill=#444444 cx=13 cy=24 r=1 stroke-linejoin=miter stroke-linecap=square></circle></g></svg></span></div><div ng-click=\"galleryUpload(participants, body)\"><span><svg style=\"width: 22px; height: 22px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><path data-color=color-2 fill=#005cb8 d=\"M62,5H2C1.448,5,1,5.447,1,6v52c0,0.553,0.448,1,1,1h60c0.552,0,1-0.447,1-1V6 C63,5.447,62.552,5,62,5z M61,57H3V7h58V57z\"></path><circle fill=#005cb8 cx=27 cy=21 r=5></circle><path fill=#005cb8 d=\"M58.832,53.445l-16-24c-0.174-0.261-0.459-0.425-0.772-0.443c-0.313-0.019-0.616,0.109-0.819,0.348 l-9.606,11.206l4.449,6.986L20.625,35.219c-0.209-0.168-0.479-0.245-0.742-0.212c-0.266,0.031-0.508,0.168-0.672,0.379l-14,18 c-0.234,0.302-0.276,0.711-0.109,1.054C5.27,54.782,5.618,55,6,55h52c0.369,0,0.708-0.203,0.882-0.528 C59.056,54.146,59.037,53.752,58.832,53.445z\"></path></g></svg></span></div><div ng-click=\"attachmentUpload(participants, body)\"><span><svg style=\"width: 22px; height: 22px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><path fill=none stroke=#005cb8 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M27.8,16.5l-9.9,9.9 c-3.1,3.1-8.2,3.1-11.3,0l0,0c-3.1-3.1-3.1-8.2,0-11.3L16.8,4.9c2.1-2.1,5.6-2.1,7.8,0l0,0c2.1,2.1,2.1,5.6,0,7.8l-9.5,9.5 c-1.2,1.2-3.1,1.2-4.2,0l0,0c-1.2-1.2-1.2-3.1,0-4.2L20,8.7\" stroke-linejoin=miter></path></g></svg></span></div></div></div></div></section>");
$templateCache.put("app/inbox/views/wrapper.html","<div autoscroll=true class=\"ng-view content-logged messages full-height\" ng-class=\"{\'is-visible\':viewState.isReady}\"><div ui-view autoscroll=false class=full-height></div></div><input type=file id=messageUploader>");
$templateCache.put("app/invite/views/admin-invite-parents.html","<div style=\"padding: 15px\"><div class=modal-header><h3 translate=ADMIN_INVITE_PARENT_HEADER></h3></div><div class=modal-body><p translate=ADMIN_INVITE_PARENT_BODY></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=SWITCH_TO_ADMIN ng-click=close()><button type=button class=\"btn btn-default pull-right\" translate=STAY_PAGE_BTN ng-click=stay() style=\"margin-left: 10px\"></div></div>");
$templateCache.put("app/invite/views/invite-email-message.html","<section><div class=\"content-logged off invite\" ng-class=\"{\'is-visible\':viewState.isReady}\"><div class=\"page-view-header clearfix {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div><div premium-ad></div><div><div class=page-subheader-title><svg ng-click=back() id=header-back-button class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <strong translate=INVITE_PARENTS_BYEMAIL_HEADLINE class=page-view-header__title></strong></div></div></div></div><div class=page-container-header-from-top style=\"padding: 20px 15px\"><div class=invite-content><div><p class=big translate=INVITE_PARENTS_BYEMAIL_MESSAGE_HEADLINE></p><form novalidate name=ip><div><textarea class=\"form-control message-body\" ng-model=message ng-init=\"message = defaultText\" maxlength=499 required noresize></textarea><small ng-if=\"message!= defaultText\" class=\"pull-right text-counter\">{{ message.length }}/499</small></div><div class=error-text-red ng-show=\"(message.length === 0 || message.length === undefined) && isClicked >= 1\"><span translate=ERR_INVITE_PARENTS_TEXTAREA></span></div><div class=emails-count></div><div class=checkbox-label><label ng-click=\"inlineAppcueDontShowAgain(\'PARENT_PRODUCT_DISCOVERY_MEETUP\')\"><input type=checkbox ng-model=checkConfirmSend> <span translate=INVITE_CHECK_CONFIRM_KNOW_PEOPLE></span></label></div><div class=button-content><button type=button ng-disabled=\"sending || !checkConfirmSend || _emails.length === 0 || !message\" class=\"btn btn-primary btn-primary-pink\" ng-click=\"invite(); isClicked = isClicked +1\" ng-init=\"isClicked = 0\"><span translate=SEND_BTN></span></button></div></form></div></div></div></div></section>");
$templateCache.put("app/invite/views/invite-email.html","<section><div class=\"content-logged off invite\" ng-class=\"{\'is-visible\':viewState.isReady}\"><div class=\"page-view-header clearfix {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div><div premium-ad></div><div><div class=page-subheader-title><svg ng-click=back() id=header-back-button class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <strong translate=INVITE_PARENTS_BYEMAIL_HEADLINE class=page-view-header__title></strong></div></div></div></div><div class=page-container-header-from-top style=\"padding: 20px 15px\"><div class=invite-content><div><p class=big translate=OR_INVITE_PARENTS_HELP style=\"margin-bottom: 15px\"></p><form novalidate name=ip><div><textarea ng-model=emails class=\"form-control message-body\" placeholder=\"{{ inviteParentsPlaceholder }}\" required maxlength=1000 name=emails>\n						</textarea></div><div class=emails-count><span ng-if=\"emailsCount > 1\">{{ emailsCount }} <span>invitees</span> </span><span ng-if=\"emailsCount == 1\">{{ emailsCount }} <span>invitee</span></span></div><div class=button-content><button type=button ng-disabled=!emails class=\"btn btn-primary btn-primary-pink\" ng-click=nextInvite()><span translate=INVITE_THESE_PEOPLE></span></button></div></form></div></div></div></div></section>");
$templateCache.put("app/invite/views/invite-native.html","<div class=invite-native><div class=\"page-view-header clearfix no-margin\"><div class=container><div class=row><div class=col-md-12><div ng-click=back() style=\"position: relative\"><svg id=header-back-button class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg></div><strong class=\"page-view-header__title page-view-header__text\" translate=INVITE_PARENTS_HEADLINE></strong></div></div></div></div><div class=invite-section><div class=\"col-md-8 col-sm-8 col-xs-8\"><p class=invite-text translate=INVITE_PARENTS_M></p></div><div class=\"col-md-4 col-sm-4 col-xs-4\"><div class=fb-btn-holder><button type=button id=btnFBShare class=\"btn btn-primary btn-facebook pull-left\" ng-click=shareMobile();><span translate=INVITE_BTN></span></button></div></div></div><div class=border></div><div class=invite-section><span translate=INVITE_PARENTS_P_1></span></div></div>");
$templateCache.put("app/invite/views/success-invite-modal.html","<div style=\"padding: 20px\"><div class=modal-header style=\"padding-bottom: 0\"><h3 ng-if=\"invited_count > 1\" translate=INVITE_SUCCESS_TEXT_1 translate-values=\"{ count: invited_count }\"></h3><h3 ng-if=\"invited_count == 1\" translate=INVITE_SUCCESS_TEXT_1_1 translate-values=\"{ count: invited_count }\"></h3></div><div class=modal-body><p translate=INVITE_SUCCESS_TEXT_2></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=INVITE_SUCCESS_TEXT_3 ng-click=close()></div></div>");
$templateCache.put("app/invite/views/wrapper.html","<section><div class=\"content-logged off invite\" ng-class=\"{\'is-visible\':viewState.isReady}\"><div class=\"page-view-header clearfix {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div><div premium-ad></div><div><div class=page-subheader-title><svg ng-click=back() id=header-back-button class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <strong translate=INVITE_PARENTS_HEADLINE class=page-view-header__title></strong></div></div></div></div><div class=page-container-header-from-top style=\"padding: 20px 15px\"><div><p class=big translate=INVITE_PARENTS_HELP_1></p><p translate=INVITE_PARENTS_HELP_2></p><div class=invite-options><div class=whatsapp-section ng-click=shareWhatsapp()><div class=icon><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 48 48\"><g transform=\"translate(0, 0)\"><path fill=#ffffff d=\"M0.10739,48l3.37542-12.32542c-2.08204-3.60688-3.17763-7.69894-3.17592-11.89098 C0.31215,10.66928,10.98554,0,24.09976,0c6.36475,0.00253,12.33865,2.47971,16.83067,6.97547 c4.49214,4.49575,6.96465,10.47174,6.96218,16.82712c-0.00531,13.11432-10.67966,23.785-23.79253,23.785h-0.00006h-0.00974 c-3.98213-0.00164-7.89481-1.00024-11.36995-2.89505L0.10739,48z M13.30466,40.38635l0.72215,0.42849 c3.03621,1.80129,6.51666,2.7542,10.06511,2.75559h0.0081c10.89973,0,19.77101-8.8685,19.77545-19.76937 c0.00202-5.28238-2.053-10.2494-5.78667-13.98611c-3.73368-3.73672-8.69893-5.79578-13.98092-5.79781 c-10.90811,0-19.77946,8.86787-19.78382,19.76797c-0.00152,3.73532,1.04402,7.37333,3.02355,10.52097l0.47026,0.7479 l-1.99782,7.29512L13.30466,40.38635z\"></path><path data-color=color-2 fill-rule=evenodd clip-rule=evenodd fill=#ffffff d=\"M18.15336,13.84087 c-0.48253-1.1589-0.97266-1.0021-1.33759-1.02027c-0.34636-0.01724-0.74309-0.02088-1.13941-0.02088 s-1.04036,0.14873-1.5853,0.74366c-0.54492,0.59496-2.08067,2.03281-2.08067,4.958c0,2.92519,2.13022,5.7512,2.42748,6.14787 c0.29723,0.39667,4.19204,6.39961,10.15569,8.97392c1.41836,0.6123,2.52578,0.9779,3.38909,1.25194 c1.42423,0.45222,2.72022,0.38844,3.74456,0.23544c1.14216-0.17059,3.51729-1.43777,4.01272-2.82601 c0.49537-1.38824,0.49537-2.57817,0.34674-2.82608c-0.14856-0.24784-0.54491-0.3966-1.13937-0.69412 c-0.59452-0.29745-3.51734-1.73529-4.06233-1.93359c-0.54491-0.19831-0.9412-0.29746-1.33755,0.29751 c-0.39628,0.59491-1.5356,1.9336-1.88241,2.3302c-0.34674,0.39667-0.69355,0.44627-1.28801,0.14876 c-0.59453-0.29745-2.51008-0.92506-4.7808-2.94978c-1.76725-1.57578-2.96047-3.52215-3.30725-4.11712 c-0.34677-0.59496-0.03689-0.91665,0.26073-1.2129c0.26739-0.26626,0.59446-0.69412,0.89172-1.04118 c0.29723-0.34706,0.39632-0.59497,0.59446-0.99157c0.19818-0.39667,0.09909-0.74372-0.04955-1.04121 C19.83772,17.956,18.64879,15.03077,18.15336,13.84087z\"></path></g></svg></div><div class=right-text><h3 translate=INVITE_OPTIONS_TEXT_1></h3><p translate=INVITE_OPTIONS_TEXT_1_1></p></div></div><div class=facebook-section ng-click=shareFacebook()><div class=icon><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\"><g transform=\"translate(0, 0)\"><path fill=#ffffff d=\"M19.32924,46V25.92955h-6.75413v-7.82187h6.75413v-5.76839C19.32924,5.64511,23.41782,2,29.38949,2 c2.86049,0,5.31894,0.21297,6.03539,0.30816v6.99581l-4.14167,0.00188c-3.24773,0-3.87657,1.54327-3.87657,3.80792v4.99391h7.74553 l-1.0085,7.82187h-6.73704V46H19.32924z\"></path></g></svg></div><div class=right-text><h3 translate=INVITE_OPTIONS_TEXT_2></h3><p translate=INVITE_OPTIONS_TEXT_2_1></p></div></div><div ng-click=\"showInviteLink = true\" class=link-section><div class=icon><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\"><g transform=\"translate(0, 0)\"><path d=M19,37H14a13,13,0,0,1,0-26h5a2,2,0,0,1,0,4H14a9,9,0,0,0,0,18h5a2,2,0,0,1,0,4Z fill=#ffffff></path><path d=M34,37H29a2,2,0,0,1,0-4h5a9,9,0,0,0,0-18H29a2,2,0,0,1,0-4h5a13,13,0,0,1,0,26Z fill=#ffffff></path><path data-color=color-2 d=M34,26H14a2,2,0,0,1,0-4H34a2,2,0,0,1,0,4Z fill=#ffffff></path></g></svg></div><div class=right-text><h3 translate=INVITE_OPTIONS_TEXT_3></h3><p translate=INVITE_OPTIONS_TEXT_3_1></p></div></div><div ng-if=showInviteLink class=link-input-section><div class=select-link style=\"position: relative\"><input id=select-link-url-input type=text value=\"{{ link }}\" disabled> <a ng-click=copyLink() translate=COPY></a></div></div><div ng-click=gotoInviteMail() class=email-section><div class=icon><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=5><g stroke-width=5 transform=\"translate(0.5, 0.5)\"><polyline data-cap=butt data-color=color-2 points=\"4.467 9.467 33 35 59.508 9.439\" fill=none stroke=#444444 stroke-miterlimit=10 stroke-width=5 stroke-linecap=butt stroke-linejoin=miter></polyline><path d=M3,13V51a5,5,0,0,0,5,5H56a5,5,0,0,0,5-5V13a5,5,0,0,0-5-5H8A5,5,0,0,0,3,13Z fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=5 stroke-linejoin=miter></path></g></svg></div><div class=right-text><h3 translate=INVITE_OPTIONS_TEXT_4></h3><p translate=INVITE_OPTIONS_TEXT_4_1></p></div></div></div></div></div></div></section>");
$templateCache.put("app/listings/views/available-modal.html","<div><div class=modal-header><h3 ng-show=\"listing.type === \'WANTED\' || listing.type === \'LOST\'\" translate=LISTING_UNCLAIMED></h3><h3 ng-show=\"listing.type !== \'WANTED\' && listing.type !== \'LOST\'\" translate=LISTING_UNSOLD></h3></div><div class=modal-body><p ng-show=\"listing.type === \'WANTED\' || listing.type === \'LOST\'\" translate=LISTING_MARK_UNCLAIMED_TEXT></p><p ng-show=\"listing.type !== \'WANTED\' && listing.type !== \'LOST\'\" translate=LISTING_MARK_UNSOLD_TEXT></p></div><div class=modal-footer><button ng-show=\"listing.type === \'WANTED\' || listing.type === \'LOST\'\" type=button class=\"btn btn-primary pull-right\" translate=LISTING_UNCLAIMED ng-click=confirm()><button ng-show=\"listing.type !== \'WANTED\' && listing.type !== \'LOST\'\" type=button class=\"btn btn-primary pull-right\" translate=LISTING_UNSOLD ng-click=confirm()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/listings/views/delete-listing-modal.html","<div><div class=modal-header><h3 translate=LISTING_DELETE_HEADER></h3></div><div class=modal-body><p translate=LISTING_DELETE_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=DELETE_BTN ng-click=confirm()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/listings/views/help-modal.html","<div style=\"padding: 15px\"><div class=modal-header><h3 translate=MKP_MODAL_TEXT_1></h3></div><div class=modal-body><div translate=MKP_MODAL_TEXT_2></div></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-left\" translate=OK_GOT_IT ng-click=close() style=\"margin-left: 10px\"></div></div>");
$templateCache.put("app/listings/views/listings-list.html","<section class=\"listing-list-view listings-background\" post-likes><div class=\"page-view-header clearfix post-header {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div><div premium-ad></div><div><div class=page-subheader-title><svg ng-click=onBackArrowTap() id=header-back-button class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <strong translate=TOPNAV_LISTINGS class=page-view-header__title style=\"padding-right: 0\"></strong></div></div></div></div><ng-include ng-if=showAppcueMarketplaceInfo src=\"\'app/base/appcues/marketplace-modal.html\'\"></ng-include><div class=\"post-composer page-container-header-from-top\" style=\"margin-bottom: -4px;\n    margin-top: -3px !important\"><div class=post-composer-marketplace style=\"margin-top: 9px\"><div ng-click=\"openMobilePostWriter(\'FOR_SALE\')\"><div><svg style=\"width: 22px; height: 22px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=100px height=100px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><path fill=#eb004e d=\"M58,13h-8.546l-6.701-7.659C42.562,5.125,42.288,5,42,5H28c-0.288,0-0.562,0.125-0.753,0.341L20.546,13H6 c-2.757,0-5,2.243-5,5v36c0,2.757,2.243,5,5,5h52c2.757,0,5-2.243,5-5V18C63,15.243,60.757,13,58,13z M13,26c-1.103,0-2-0.897-2-2 s0.897-2,2-2s2,0.897,2,2S14.103,26,13,26z M35,50c-7.732,0-14-6.268-14-14s6.268-14,14-14s14,6.268,14,14S42.732,50,35,50z\"></path></g></svg></div><div translate=TEXT_SELL_OFFER></div></div><div ng-click=\"openMobilePostWriter(\'LOST\')\"><div><svg style=\"width: 22px; height: 22px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><path d=M56,8a6.006,6.006,0,0,0-6-6H14A6.006,6.006,0,0,0,8,8V61a1,1,0,0,0,1.52.854L32,48.171,54.48,61.854A1,1,0,0,0,56,61Z fill=#eb004e></path></g></svg></div><div translate=TEXT_LOST></div></div><div ng-click=\"openMobilePostWriter(\'WANTED\')\"><div><svg style=\"width: 22px; height: 22px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><path d=M56.305,8.874A16.244,16.244,0,0,0,44.781,4h-.149A15.945,15.945,0,0,0,32,10.162,15.944,15.944,0,0,0,19.37,4h-.065A16.339,16.339,0,0,0,3,20.455C3,36.107,30.2,58.812,31.362,59.771a1,1,0,0,0,1.276,0C33.8,58.812,61,36.107,61,20.463A16.237,16.237,0,0,0,56.305,8.874ZM44.693,5Z fill=#eb004e></path></g></svg></div><div translate=TEXT_WANT></div></div><div ng-click=openSearch()><div><svg style=\"width: 22px; height: 22px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\"><g transform=\"translate(0, 0)\"><path d=M30.414,27.586,22.77,19.942a12.038,12.038,0,1,0-2.828,2.828l7.644,7.644ZM3,13A10,10,0,1,1,13,23,10.011,10.011,0,0,1,3,13Z fill=#eb004e></path></g></svg></div><div translate=TEXT_SEARCH></div></div></div></div><div style=\"margin-top: 0!important; max-width: 620px; margin: auto\"><div ng-show=searchOpened class=post-header><div class=page-view-subheader style=\"margin-bottom: 10px\"><div><div><div><div class=is-relative><input type=search class=form-control placeholder=\"{{ \'SEARCH_TXT\' | translate }}\" ng-model=searchTxt> <svg style=\"width: 20px; height: 20px; position: absolute; top: 6px; right: 6px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><line data-color=color-2 fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 x1=44 y1=44 x2=32.7 y2=32.7 stroke-linejoin=miter></line><circle fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 cx=20 cy=20 r=18 stroke-linejoin=miter></circle></g></svg></div></div></div></div></div></div><div style=\"margin-top: 10px\"><div><aside id=list-post-id class=\"marketplace-posts group-posts\" ng-if=\"listings.length !== 0; \"><div class=row><div class=column><div ng-repeat=\"listing in listings;\"><div ng-click=openPost(listing.id) class=non-odd-card ng-if=\"$index % 2 == 0\"><div><div ng-if=listing.photo style=\"background-size: cover; background-position: center; position: relative; padding-bottom: 100%; background-image: url(\'{{listing.photo}}\')\"></div><div ng-if=!listing.photo class=mkp-no-image-container><div class=mkp-no-image>NO PICTURE</div></div></div><div style=\"margin: 10px\"><div style=\"font-weight: bold; font-size: 16px; overflow: hidden\">{{listing.title}}</div><div style=\"font-weight: bold\"><span ng-if=listing.currency style=\"float: left\" translate=\"{{ listing.currency }}_SHORT\"></span> {{ listing.price }}</div></div></div></div></div><div class=column><div ng-repeat=\"listing in listings;\"><div ng-click=openPost(listing.id) class=odd-card ng-if=\"$index % 2 != 0\"><div><div ng-if=listing.photo style=\"background-size: cover; background-position: center; position: relative; padding-bottom: 100%; background-image: url(\'{{listing.photo}}\')\"></div><div ng-if=!listing.photo class=mkp-no-image-container><div class=mkp-no-image>NO PICTURE</div></div></div><div style=\"margin: 10px\"><div style=\"font-weight: bold; font-size: 16px\">{{listing.title}}</div><div style=\"font-weight: bold\"><span ng-if=listing.currency style=\"float: left\" translate=\"{{ listing.currency }}_SHORT\"></span> {{ listing.price }}</div></div></div></div></div></div><div ng-show=hasMoreListings() class=vi-loader><div><svg class=circular viewBox=\"25 25 50 50\"><circle class=path cx=50 cy=50 r=20 fill=none stroke-width=4 stroke-miterlimit=10></circle></svg></div></div></aside><div class=empty-state ng-if=\"listings.length == 0 && viewState.isReady\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><line data-color=color-2 x1=20 y1=44 x2=44 y2=44 fill=none stroke=#4aa0f0 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></line><circle data-color=color-2 cx=19.5 cy=29.5 r=2.5 fill=none stroke=#4aa0f0 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></circle><circle data-color=color-2 cx=44.5 cy=29.5 r=2.5 fill=none stroke=#4aa0f0 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></circle><circle cx=32 cy=32 r=28 fill=none stroke=#4aa0f0 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></circle><circle data-color=color-2 data-stroke=none cx=19.5 cy=29.5 r=2.5 fill=#4aa0f0></circle><circle data-color=color-2 data-stroke=none cx=44.5 cy=29.5 r=2.5 fill=#4aa0f0></circle></g></svg><h4 translate=EMPTY_TITLE_LISTINGS></h4><p translate=EMPTY_DESCR_LISTINGS></p></div></div></div></div></section>");
$templateCache.put("app/listings/views/listings-view.html","<section class=\"listing-list-view listings-background\"><div class=\"page-view-header clearfix post-header {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div><div premium-ad></div><div><div class=page-subheader-title><svg ng-click=onBackArrowTap() id=header-back-button class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <strong translate=TOPNAV_LISTINGS class=page-view-header__title style=\"padding-right: 0\"></strong></div></div></div></div><div class=page-container-header-from-top><section class=\"group-view group-view--post\" add-participants ng-class=\"{\'is-visible\':viewState.isInitiated }\"><div class=post-top><div><aside class=group-posts><div class=post-item mw=\"{{ userId == postUserId ? true : false }}\"><div class=post-container style=\"border: solid 1px #b6c2db\"><div class=post-item-details><div class=padding-post style=\"padding-bottom: 0\"><nav class=\"has-dropdown-click is-relative more-dots\" style=\"margin-top: 0; position: absolute; top: 1px; right: 2px; z-index: 11; height: 50px\"><ul ng-if=listing.menuOpened class=dropdown-menu style=\"right: 1px!important; background: #fff!important\"><li ng-if=!listing.mine><a ng-click=\"composeTo({ id: listing.createdById })\"><span translate=SEND_MESS_TO></span> <span>{{ listing.createdByFirstName }}</span></a></li><li ng-if=!listing.mine><a translate=LISTING_REPORT_HEADER ng-click=report()></a></li><li ng-if=listing.mine><a translate=LISTING_ACTION_EDIT ui-sref=\"composer_mkp.post({\'id\': listing.id})\"></a></li><li ng-if=listing.mine><a translate=LISTING_ACTION_DELETE ng-click=delete()></a></li><li ng-if=\"listing.mine && !listing.sold\"><a ng-if=\"listing.type !==\'WANTED\' && listing.type !==\'LOST\'\" translate=LISTING_SOLD ng-click=markSold()></a> <a ng-if=\"listing.type ===\'WANTED\' || listing.type ===\'LOST\'\" translate=LISTING_CLAIMED ng-click=markSold()></a></li><li ng-if=\"listing.mine && listing.sold\"><a ng-if=\"listing.type !==\'WANTED\' && listing.type !==\'LOST\'\" translate=LISTING_UNSOLD ng-click=markAvailable()></a> <a ng-if=\"listing.type ===\'WANTED\' || listing.type ===\'LOST\'\" translate=LISTING_UNCLAIMED ng-click=markAvailable()></a></li><li><a translate=WHO_CAN_SEE_POST target=_blank href=https://help.classlist.com/hc/en-us/articles/213258969-Who-will-see-what-I-ve-posted-and-how-will-they-know-it-s-there-></a></li></ul><svg ng-click=togglePostMenu() style=\"transform: rotate(90deg); height: 45px; margin-top: 0; position: relative; padding: 1px 15px; width: 48px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\"><g transform=\"translate(0, 0)\"><circle fill=#627293 cx=4 cy=16 r=3></circle><circle data-color=color-2 fill=#627293 cx=16 cy=16 r=3></circle><circle fill=#627293 cx=28 cy=16 r=3></circle></g></svg></nav><div class=vi-row><div class=vi-col-left><figure class=post-item-avatar ui-sref=\"classlist.details.contact({ \'id\': listing.createdById })\"><avatar class=\"visible-xs visible-sm\" source=\"{{ listing.createdByAvatar }}\" name=\"{{ ::listing.createdByName }}\" width=40 height=40 my=false></avatar><avatar class=\"visible-md visible-lg\" source=\"{{ listing.createdByAvatar }}\" name=\"{{ ::listing.createdByName }}\" width=60 height=60 my=false></avatar></figure></div><div class=vi-col-middle><div><h4 style=\"margin-right: 30px; display: block\"><a style=\"line-height: 20px\" ui-sref=\"classlist.details.contact({ \'id\': listing.createdById })\" class=\"HEADER2 post-username\">{{ listing.createdByName }}</a></h4><div style=\"display: inline-block\"><time style=\"color: #009e6c\"><span translate=AT></span>{{listing.postedAt | date:\'h:mm a\' }}, {{listing.postedAt | date:\'MMM dd\'}}</time></div></div></div></div></div><div class=mkp-spacer></div><div class=listing-labels-container style=\"{{ listing.photos.length > 0 ? \'height: 0\' : \'\' }}\"><div class=\"listing-post listing-labels {{ listing.photos.length > 0 ? \'active\' : \'\' }} listing-margin-picture\"><div style=\"z-index: 1; position: relative\"><div><div ng-repeat=\"c in types\"><div style=\"{{ listing.sold ? \'background: #ff5a5a;\' : \'\' }} margin-left: 10px\" ng-show=\"listing.type == c\" class=\"category-item-post category-item-post_{{c.toLowerCase()}}\"><span class=category-name style=\"color: #fff\" ng-if=\"listing.sold && listing.type !== \'WANTED\' && listing.type !==\'LOST\'\" translate=LABEL_SOLD></span> <span class=category-name style=\"color: #fff\" ng-if=\"listing.sold && (listing.type === \'WANTED\' || listing.type ===\'LOST\')\" translate=LABEL_CLAIMED></span><div ng-show=\"!listing.sold && listing.type == c\" class=\"category-item-post category-item-post_{{c.toLowerCase()}}\"><span class=category-name translate=\"POST_CAT_{{c | uppercase}}\"></span></div></div></div><div ng-if=\"listing.type === \'FOR_SALE\'\" style=\"float: left; margin-left: 6px\"><div class=\"price-without-photo listing-type-{{listing.type.toLowerCase()}}\" style=\"height: auto\"><span class=price-without-photo_text>{{ listing.price }}</span></div></div><div style=\"float: left; margin-left: 6px\"><div class=\"price-without-photo listing-type-{{listing.type.toLowerCase()}}\" style=\"height: auto\"><span class=price-without-photo_text>{{ getCategory(listing.category)}}</span></div></div><div ng-if=listing.charitable style=\"float: left; margin-left: 6px\"><div class=\"price-without-photo listing-type-general\" style=\"height: auto\"><span class=price-without-photo_text translate=LISTING_CHARITY_LISTING></span></div></div></div></div></div></div><div class=\"padding-post photo-padding\"><div class=view-post-pictures-separator><div ng-repeat=\"photo in listing.photos\" style=\"text-align: center\"><img alt=\"\" ng-click=openPicture(photo.url) ng-src=\"{{ photo.url }}=s584-c\" style=\"max-width: 100%; cursor: pointer; width: 100%\"></div></div></div><div class=padding-post><div style=\"overflow: auto\" class=text><div style=\"font-size: 16px; color: #6d7279; font-weight: 600; margin-bottom: 5px; word-break: break-word\">{{ listing.title }}</div><span count-chars ng-bind-html=listing.description class=multiple-line-text style=\"word-break: break-word\"></span></div></div><div ng-show=!listing.mine class=\"padding-post padding-top-zero\" style=\"padding-bottom: 0\"><div style=\"text-align: center\"><a id=post-button-id class=\"btn btn-default btn-default-gray mobile-post-button ng-scope\" ng-click=\"composeTo({ id: listing.createdById })\" style=\"position: relative; max-width: 200px; margin-top: 0;color: #768F9B!important; min-width: 130px; margin-bottom: 15px\"><span translate=CONTACT_SELLER></span> {{ listing.createdByFirstName }}</a></div></div></div></div></div></aside></div><div id=\"home-post-ad-{{ ad.id }}\" ad-id=\"{{ ad.id }}\" class=home-post-ad ng-if=ad><post-adv post-context=POST_VIEW class=enter link-name=ad.callToAction title=ad.title artwork=ad.artwork logo=ad.logo body=ad.body link=ad.link domain=ad.domain style=\"padding: 10px 0\"></post-adv></div><div style=\"text-align: center; margin-top: 35px\"><button type=button class=\"btn btn-primary btn-primary-pink\" ui-sref=listings.list><span translate=SEE_MORE_LISTINGS></span></button></div></div></section></div></section>");
$templateCache.put("app/listings/views/report-listing-modal.html","<div><div class=modal-header><h3 translate=LISTING_REPORT_HEADER></h3></div><div class=modal-body><p translate=LISTING_REPORT_TEXT></p><textarea ng-model=reportReason autoresize-textarea style=\"border: 1px solid #91969d; padding: 10px; width: 100%\"></textarea></div><div class=modal-footer><button ng-disabled=\"!reportReason || reportReason === \'\'\" type=button class=\"btn btn-primary pull-right\" translate=REPORT_BTN ng-click=report()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/listings/views/sold-modal.html","<div><div class=modal-header><h3 ng-show=\"listing.type === \'WANTED\' || listing.type === \'LOST\'\" translate=LISTING_CLAIMED></h3><h3 ng-show=\"listing.type !== \'WANTED\' && listing.type !== \'LOST\'\" translate=LISTING_SOLD></h3></div><div class=modal-body><p ng-show=\"listing.type === \'WANTED\' || listing.type === \'LOST\'\" translate=LISTING_MARK_CLAIMED_TEXT></p><p ng-show=\"listing.type !== \'WANTED\' && listing.type !== \'LOST\'\" translate=LISTING_MARK_SOLD_TEXT></p></div><div class=modal-footer><button ng-show=\"listing.type === \'WANTED\' || listing.type === \'LOST\'\" type=button class=\"btn btn-primary pull-right\" translate=LISTING_CLAIMED ng-click=confirm()><button ng-show=\"listing.type !== \'WANTED\' && listing.type !== \'LOST\'\" type=button class=\"btn btn-primary pull-right\" translate=LISTING_SOLD ng-click=confirm()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/listings/views/wrapper.html","<div class=\"content-logged listings\"><div ui-view autoscroll=false></div></div>");
$templateCache.put("app/nonmember/views/wrapper.html","<section><div ng-if=!loading><div ng-if=!current_user.approved class=\"just-approved-tooltip {{ !verifyEmailDismissed && !current_user.emailVerified ? \'from-top\' : \'\' }}\"><h4 translate=NON_MEMBER_TEXT_1 translate-values=\"{ \'firstName\': active_user.firstName }\"></h4><p translate=NON_MEMBER_TEXT_2></p><h2 translate=NON_MEMBER_TEXT_3></h2><p><span translate=NON_MEMBER_TEXT_4></span> <a target=_blank href=https://help.classlist.com/hc/en-us/articles/360017089978-1-minute-video-tour-for-parents translate=NON_MEMBER_TEXT_4_1></a><span translate=NON_MEMBER_TEXT_4_2></span></p></div></div><section class=demo-view><div class=demo-post-list><div><div class=demo-header><div></div><div></div></div><div class=demo-picture></div></div><div><div class=demo-header><div></div><div></div></div><div class=demo-picture></div></div></div></section></section>");
$templateCache.put("app/notifications/views/notifications.html","<section class=notifications-view add-participants ng-class=\"{\'is-visible\':viewState.isInitiated}\"><section class=\"page-view-header {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div><div premium-ad></div><div><div class=page-subheader-title><svg ng-click=goback() id=header-back-button class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#005cb8 stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <strong class=page-view-header__title translate=NAV_MANAGE_NOTIFICATIONS></strong><div class=\"pull-right mark-all-read\"><a class=link translate=MARK_ALL_READ ng-click=markAllRead()></a> <span class=\"icon dripicons-gear\" ng-click=goNotificationSettings()></span></div></div></div></div></section><div class=\"page-container-header-from-top notifications-list\" ng-class=\"{\'show\':viewState.showNewNotifications}\"><div class=empty-state ng-show=\"!viewState.fetchingNotifications && notificationsLength == 0\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><line data-color=color-2 x1=20 y1=44 x2=44 y2=44 fill=none stroke=#4aa0f0 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></line><circle data-color=color-2 cx=19.5 cy=29.5 r=2.5 fill=none stroke=#4aa0f0 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></circle><circle data-color=color-2 cx=44.5 cy=29.5 r=2.5 fill=none stroke=#4aa0f0 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></circle><circle cx=32 cy=32 r=28 fill=none stroke=#4aa0f0 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></circle><circle data-color=color-2 data-stroke=none cx=19.5 cy=29.5 r=2.5 fill=#4aa0f0></circle><circle data-color=color-2 data-stroke=none cx=44.5 cy=29.5 r=2.5 fill=#4aa0f0></circle></g></svg><h4 translate=EMPTY_TITLE_NOTIF></h4><p translate=EMPTY_DESCR_NOTIF></p></div><div ng-if=\"!nativeNotificationsEnabled && isNative\" class=native-notif-off-label-notifications><div><span translate=NOTIFICATIONS_OFF_NOTIFICATIONS></span> <a ng-click=openNativeNotificationSettings()><span translate=NOTIFICATIONS_ON_SETTINGS_1></span></a></div></div><ul class=notification-items><li ng-repeat=\"m in notifications\" class=clearfix notify={{$index}}><div ng-if=\"m.event !== \'SYSTEM\'\" class=\"thread {{ !m.read ? \'active\' : \'\' }}\" ng-click=notifRedirect(m)><div class=auto-overflow><figure class=classlist-item-avatar style=\"width: 40px; height: 40px; float: left; margin-right: 10px\"><avatar source=\"{{ m.avatar }}\" width=40 height=40 name=\"{{ m.letters }}\" my=false></avatar></figure><div class=detail><div ng-if=m.title ng-bind-html=m.title></div><span ng-bind-html=m.message></span></div></div><div><time style=\"text-align: left\">{{ m.timestamp | timeago }}</time></div></div><a ng-if=\"m.event === \'SYSTEM\'\" class=notifications-a href={{m.extra}} target=_blank><div class=\"thread {{ !m.read ? \'active\' : \'\' }}\"><div class=auto-overflow><img alt=\"\" width=60 height=60 class=avatar alt=avatar onerror=\"this.src=\'assets/icons/default-avatar.png\'\" ng-src={{m.avatar}}><div class=detail><div ng-if=m.title ng-bind-html=m.title></div><span style=\"font-weight: normal\" ng-bind-html=m.message></span></div></div><div><time>{{ m.timestamp | timeago }}</time></div></div></a><div id=\"home-post-ad-{{ ad.id }}\" ad-id=\"{{ ad.id }}\" post-index=\"{{ $index }}\" class=\"home-post-ad d-none-760\" ng-if=\"$index === 4 && ad\" style=\"min-height: 250px\"><post-adv post-context=NOTIFICATION_VIEW class=enter link-name=ad.callToAction title=ad.title artwork=ad.artwork logo=ad.logo body=ad.body link=ad.link domain=ad.domain style=\"padding: 10px 0\"></post-adv></div><!--\n				<div ng-if=\"$index === 1 && ads\">\n					<div class=\"right-side-ad-container\">\n						<div class=\"right-side-ad-sponsored\">Sponsored</div>\n						<a class=\"right-side-ad-btn\" href=\"https://app.classlist.com/business\" translate=\"CREATE_AD\" target=\"_blank\"></a>\n					</div>\n					<div class=\"row\" style=\"margin: 0 !important;\">\n						<div ng-repeat=\"ad in ads\" class=\"col-xs-4 right-side-ad-border\">\n							<div class=\"right-side-ad-title\">{{ad.title}}</div>\n							<div ng-bind-html=\"ad.description\" class=\"right-side-ad-desc\"></div>\n							<carousel images=\"ad.artwork\" link=\"{{ad.link}}\" small=\"true\" rightside=\"true\">\n							</carousel>\n						</div>\n					</div>\n				</div>\n				--></li></ul><p class=loading ng-show=viewState.fetchingNotifications translate=LOADING_TXT></p></div></section>");
$templateCache.put("app/notifications/views/wrapper.html","<div class=notifications-background><div class=\"content-logged notifications-page\"><div autoscroll=false><ng-include src=\"\'app/notifications/views/notifications.html\'\"></ng-include></div></div></div>");
$templateCache.put("app/post/views/edit.html","<div class=\"page-view-header post-header clearfix\"><div style=\"padding: 0\"><div style=\"position: relative\"><div class=\"vi-row page-view-header__text\" style=\"padding-left: 0\"><div class=vi-col-left><svg id=header-back-button ng-click=back() class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg></div><div class=\"vi-col-right page-view-header__text\" style=\"width: 90px\"><!-- <strong class=\"page-view-header__title header-text\" translate=\"POST_HEADER\"></strong> --> <button id=post-button-update-id class=\"btn btn-primary btn-primary-pink pull-right\" ng-disabled=\"!viewState.isReady || (bodyWithoutEntities.length > regexes.max.postBody) || (((!post.body || post.body.length == 0) && post.linkPreview ==\'\') && (!post.attachments || post.attachments.length == 0))\" translate=UPDATE_BTN ng-click=update() style=\"margin-top: 7px; margin-right: 15px\"></button></div><div class=vi-col-middle><strong class=page-view-header__title style=\"padding: 0px 65px; padding-right: 0; padding-top: 4px\"><div class=\"is-relative post-group-select\"><div class=composer-group-title ng-if=post.groupName>{{post.groupName}}</div></div></strong></div></div></div></div></div><div class=\"edit-post form-group\"><div class=post-container add-participants ng-class=\"{\'is-visible\':viewState.isInitiated}\"><div class=\"composer-post-mobile post-padding text-container\"><div style=\"background: #fff\"><mentionsuggestor draftbody={{draftPost.body}} postid={{post.id}} commentbody=getPostBody(bodyWithTags) autoresize-textarea class=\"form-control post-title-text post-title-text_share post-mobile-area mention-container\" style=\"margin-bottom: 0; color: #000; border-bottom: none!important; position: relative\" placeholder=\"Write something to this group here\" type=post></mentionsuggestor><div class=title-input style=\"border-top: none!important; font-size: 13px; font-weight: 500; text-align: right; color: #91969d; padding-bottom: 10px; padding-top: 0\"><p ng-if=\"bodyWithoutEntities && bodyWithoutEntities.length\">{{ (bodyWithoutEntities ? ((1500-bodyWithoutEntities.length) > 0 ? (1500-bodyWithoutEntities.length) : 0) : 1500) }}/1500</p></div></div><div ng-show=\"post && bodyWithoutEntities.length > regexes.max.postBody\" class=error-text-stripe><span class=error-text-stripe_text translate=ERR_POST_CHAR_LIMIT translate-values=\"{actual:bodyWithoutEntities.length, max: regexes.max.postBody}\"></span></div></div><div><div style=\"padding: 0 20px; margin-bottom: 15px\"><div class=sub-section style=\"margin-bottom: 0; height: 32px\"><div class=auto-overflow ng-if=\"!post.attachments || (post.attachments && post.attachments.length < 1000)\"><div class=post-links style=\"cursor: pointer\"><span class=\"icon-link photo-icon\" ng-if=\"!post.attachments || (post.attachments && post.attachments.length < 1000)\" style=\"margin-left: 5px\"><span ng-class=\"{\'disable\': post.linkPreview !== \'\'}\" ng-click=uploadImage() style=\"float: left\"><svg style=\"width: 22px; height: 36px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><path fill=#005cb8 d=\"M58,13h-8.546l-6.701-7.659C42.562,5.125,42.288,5,42,5H28c-0.288,0-0.562,0.125-0.753,0.341L20.546,13H6 c-2.757,0-5,2.243-5,5v36c0,2.757,2.243,5,5,5h52c2.757,0,5-2.243,5-5V18C63,15.243,60.757,13,58,13z M13,26c-1.103,0-2-0.897-2-2 s0.897-2,2-2s2,0.897,2,2S14.103,26,13,26z M35,50c-7.732,0-14-6.268-14-14s6.268-14,14-14s14,6.268,14,14S42.732,50,35,50z\"></path></g></svg> </span><span ng-class=\"{\'disable\': post.linkPreview !== \'\'}\" ng-click=uploadAttachment() style=\"float: left; margin-left: 20px\"><svg style=\"width: 22px; height: 36px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><path fill=none stroke=#005cb8 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M27.8,16.5l-9.9,9.9 c-3.1,3.1-8.2,3.1-11.3,0l0,0c-3.1-3.1-3.1-8.2,0-11.3L16.8,4.9c2.1-2.1,5.6-2.1,7.8,0l0,0c2.1,2.1,2.1,5.6,0,7.8l-9.5,9.5 c-1.2,1.2-3.1,1.2-4.2,0l0,0c-1.2-1.2-1.2-3.1,0-4.2L20,8.7\" stroke-linejoin=miter></path></g></svg> </span><a style=\"float: right; font-size: 13px; line-height: 38px\" href=https://help.classlist.com/hc/en-us/articles/211584605-Community-Guidelines-rules-for-users target=_blank>Community guidelines</a></span></div></div></div></div></div><div class=post-files-list><div ng-if=\"post.files && post.files.length > 0\"><div ng-repeat=\"att in post.files track by $index\"><a href=\"{{ att.url }}\" target=_blank>{{ att.name }}</a> <span ng-click=removeFile($index) class=delete-pic-button><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><polygon fill=#ffffff points=\"44,17.171 32,29.171 20,17.171 17.171,20 29.171,32 17.171,44 20,46.829 32,34.829 44,46.829 46.829,44 34.829,32 46.829,20 \"></polygon></g></svg></span></div></div></div><br><div><div><div ng-show=\"post.type != \'group\' && viewState.isReady\" style=\"padding: 0 20px\"><div class=sub-section><label translate=LISTING_TYPE></label><div class=auto-overflow><button ng-repeat=\"c in categories\" id={{c}} is-selected=\"{{post.category == c}}\" ng-click=selectCategory(c) ng-class=\"{\'category-item category-item_{{c}} {{c}}-selected\': post.category == c, \'category-item category-item_{{c}}\':post.category != c}\"><div class=\"circle-icon category-color_{{c}}\"><span ng-if=\"c == \'general\'\" class=dripicons-web></span> <span ng-if=\"c == \'free\'\" class=dripicons-gift></span> <span ng-if=\"c == \'wanted\'\" class=dripicons-preview></span> <span ng-if=\"c == \'jobs\'\" class=dripicons-suitcase></span> <span ng-if=\"c == \'lost_found\'\" class=dripicons-flashlight></span> <span ng-if=\"c == \'for_sale\'\" class=dripicons-tag></span> <span ng-if=\"c == \'offer\'\" class=dripicons-tag></span></div><span class=category-name translate=\"POST_CAT_{{c | uppercase}}\"></span></button></div></div><div class=sub-section ng-if=hasPrice><label translate=POST_PRICE></label><div><input focus=true type=text class=\"price form-control\" ng-model=post.price maxlength=15 placeholder=\"{{ \'POST_ENTER_PRICE\' | translate}}\"></div></div></div><div ng-if=\"post.linkPreview && post.linkPreview !== \'\'\"><span ng-click=deleteLinkPreview() class=\"dripicons-cross icon remove-link-preview-buttom\"></span><linkpreview url={{post.linkPreview}} on-success=onPreviewSuccess(url)></linkpreview></div><div class=sub-section><div style=\"overflow: auto\"><div ng-repeat=\"att in post.attachments track by $index\" class=post-img-preview ng-if=att.url style=\"margin-bottom: 3px;text-align: center\"><img alt=\"\" id=post-previewer ng-src=\"{{ att.url }}\" style=\"width: 100%\"> <span class=delete-button-wrap ng-click=removePhoto($index)><span class=delete-pic-button><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><polygon fill=#ffffff points=\"44,17.171 32,29.171 20,17.171 17.171,20 29.171,32 17.171,44 20,46.829 32,34.829 44,46.829 46.829,44 34.829,32 46.829,20 \"></polygon></g></svg> </span></span><span ng-if=att.blob class=edit-button-wrap><span class=edit-button ng-click=editPhoto($index)><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><path fill=#ffffff d=M21,18V3c0-0.552-0.448-1-1-1h-4c-0.552,0-1,0.448-1,1v15H21z></path><path fill=#ffffff d=M43,46h6V16c0-0.552-0.448-1-1-1H3c-0.552,0-1,0.448-1,1v4c0,0.552,0.448,1,1,1h40V46z></path><path fill=#ffffff d=M43,51v10c0,0.552,0.448,1,1,1h4c0.552,0,1-0.448,1-1V51H43z></path><path fill=#ffffff d=M61,43H21V23h-6v25c0,0.552,0.448,1,1,1h45c0.552,0,1-0.448,1-1v-4C62,43.448,61.552,43,61,43z></path><path data-color=color-2 fill=#ffffff d=\"M51,14c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l10-10 c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-10,10C51.512,13.902,51.256,14,51,14z\"></path><path data-color=color-2 fill=#ffffff d=\"M24,41c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l16-16 c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-16,16C24.512,40.902,24.256,41,24,41z\"></path></g></svg> <span>Edit</span></span></span></div></div></div><!-- <div style=\"padding: 0 20px; overflow: auto;\">\n					<button id=\"post-button-update-id\"  class=\"btn btn-primary pull-right\" ng-disabled=\"!viewState.isReady || (post.body.length > regexes.max.postBody) || ((!post.body || post.body.length == 0) && (!post.attachments || post.attachments.length == 0))\" translate=\"UPDATE_BTN\" ng-click=\"update()\">\n					</button>\n					<button id=\"post-button-cancel-id\" class=\"btn btn-default pull-right btn-border\" translate=\"CANCEL_BTN\" ng-click=\"back()\">\n					</button>\n				</div> --></div></div></div></div>");
$templateCache.put("app/post/views/post.html","<div post-likes class=\"hidden-content {{ viewState.isInitiated ? \'visible-content\' : \'\' }}\"><div class=\"page-view-header clearfix post-header {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div style=\"padding: 0\"><div class=premium-ad-clear style=\"padding: 0 15px\"><div premium-ad></div></div><div style=\"position: relative\"><div><svg id=header-back-button ng-click=back() style=\"padding-right: 30px; width: 70px\" class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <strong class=\"page-view-header__title full_width\" style=\"margin-right: 10px;float: left\"><span ng-if=\"posts.post.type != \'listing\'\">{{posts.post.groupName}}</span><span ng-if=\"posts.post.type == \'listing\'\">Marketplace</span></strong></div></div></div></div><div class=page-container-header-from-top><section class=\"group-view group-view--post\" add-participants ng-class=\"{\'is-visible\':viewState.isInitiated }\"><div class=post-top><div><aside class=group-posts><post-asset on-group-name-tap=onGroupNameTap(group) update-comments=updatePostComments(post) readonly-post=1 ng-repeat=\"p in posts_array\" post-content=p archived-group=p.archived post-context=HOME_VIEW class=enter user-avatar=active_user.avatar user-id=active_user.id user-name=userName post-events=events></post-asset></aside></div><div id=\"home-post-ad-{{ ad.id }}\" ad-id=\"{{ ad.id }}\" class=home-post-ad ng-if=ad><post-adv post-context=POST_VIEW class=enter link-name=ad.callToAction title=ad.title artwork=ad.artwork logo=ad.logo body=ad.body link=ad.link domain=ad.domain style=\"padding: 10px 0\"></post-adv></div><div style=\"text-align: center; margin-top: 35px\"><button type=button class=\"btn btn-primary btn-primary-pink\" ng-click=seeMore()><span ng-if=\"posts.post.type != \'listing\'\" translate=SEE_MORE_POSTS></span> <span ng-if=\"posts.post.type == \'listing\'\" translate=SEE_MORE_LISTINGS></span></button></div></div></section></div><div class=sample-popup ng-if=\"posts.post.type == \'announcement\' && posts.post.sample\" style=\"top: 30%; left: 25%\"><span class=dripicons-cross ng-click=dismissSample(posts.post)></span><div class=sample-padding><div class=sample-container><span translate=SAMPLE_ANN_DESCR_1></span></div><br><div class=sample-container-big><span translate=SAMPLE_ANN_DESCR_2></span></div><br><div class=sample-container><span translate=SAMPLE_ANN_DESCR_3></span></div><br><div class=sample-container><span translate=SAMPLE_ANN_DESCR_4></span></div></div><div class=arrow></div></div></div>");
$templateCache.put("app/post/views/wrapper.html","<div class=\"content-logged post\"><div autoscroll=false><div ui-view autoscroll=false></div></div></div>");
$templateCache.put("app/profile/views/add-family-modal.html","<div><div class=modal-header><h3 ng-if=!newFamily.id class=modal-title translate=ADD_FAMILY_TITLE></h3><h3 ng-if=newFamily.id class=modal-title translate=EDIT_FAMILY_TITLE></h3></div><div class=modal-body><form novalidate name=ap><div class=form-group><div class=with-icon><input class=form-control type=text name=firstName placeholder=\"{{\'FIRSTNAME_PHOLDER\' | translate }}\" ng-model=newFamily.firstName ng-minlength=regexes.min.name ng-maxlength=regexes.max.name maxlength={{::regexes.max.name}} remove-chars=nameField required><div class=error-text-red ng-show=\"(newFamily.firstName.length === 0 || newFamily.firstName.length === undefined) && isClicked >= 1\"><p translate=ERR_FAMILY_MEMBER_FIRST_NAME></p></div><div class=error-text-red ng-show=\"(newFamily.firstName.length < regexes.min.name) && isClicked >= 1\"><p translate=ERR_FAMILY_MEMBER_FIRST_NAME_SHORT></p></div></div></div><div class=form-group><div class=with-icon><input class=form-control type=text name=lastName placeholder=\"{{\'LASTNAME_PHOLDER\' | translate }}\" ng-model=newFamily.lastName ng-minlength=regexes.min.name ng-maxlength=regexes.max.name maxlength={{::regexes.max.name}} remove-chars=nameField required><div class=error-text-red ng-show=\"(newFamily.lastName.length === 0 || newFamily.lastName.length === undefined) && isClicked >= 1\"><p translate=ERR_FAMILY_MEMBER_LAST_NAME></p></div><div class=error-text-red ng-show=\"(newFamily.lastName.length < regexes.min.name) && isClicked >= 1\"><p translate=ERR_FAMILY_MEMBER_LAST_NAME_SHORT></p></div></div></div><div class=form-group><div class=with-icon><input type=email class=form-control placeholder=\"{{ \'EMAIL_NON_REQ_PHOLDER\' | translate }}\" ng-model=newFamily.email name=email ng-minlength=regexes.min.email ng-maxlength=regexes.max.email maxlength={{::regexes.max.email}} remove-space autocomplete=off><validation-icons is-valid=ap.email.$valid is-dirty=ap.email.$dirty></validation-icons></div></div><div class=\"row form-group\"><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=with-icon><input type=tel class=form-control placeholder=\"{{ \'PHONE_NUM_NON_REQ_PHOLDER\' | translate }}\" ng-model=newFamily.phoneNumber name=phoneNumber ng-minlength=regexes.min.phone ng-maxlength=regexes.max.phone maxlength={{regexes.max.phone}} remove-space remove-chars=number><validation-icons is-valid=ap.phoneNumber.$valid is-dirty=ap.phoneNumber.$dirty></validation-icons></div></div></div><div class=form-group><div class=is-relative><relationship ng-model=newFamily.relationshipId is-required=true></relationship><label class=select-placeholder translate=RELATIONSHIP_PHOLDER ng-hide=\"newFamily.relationshipId.length > 0\"></label><span class=\"dripicons-chevron-down select-arrow\"></span><div class=error-text-red ng-show=\"newFamily.relationshipId === null && isClicked >= 1\"><p translate=ERR_FAMILY_MEMBER_RELATIONSHIP></p></div></div></div><div class=form-group><input type=checkbox ng-model=newFamily.sendInvite ng-init=\"newFamily.sendInvite=true\" class=vertical-top><div class=single-line-label style=\"font-size: 12px\" ng-if=!integration><span translate=SEND_INVITE_FAMILY_MEMBER_LONG></span></div></div></form></div><div class=modal-footer><a ng-if=newFamily.id ng-click=delete() class=red-link><span translate=DELETE_BTN></span> </a><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary btn-primary-pink\" type=button ng-click=\"save(); isClicked = isClicked + 1\"><span translate=SAVE_BTN></span></button></div></div>");
$templateCache.put("app/profile/views/add-family.html","<div class=content-logged><section class=page-view-header><div><div><div class=page-subheader-title><svg ng-click=goback() id=header-back-button class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <strong ng-if=!editingId class=page-view-header__title translate=ADD_FAMILY_HEADER></strong> <strong ng-if=editingId class=page-view-header__title translate=EDIT_FAMILY_HEADER></strong></div></div></div></section><div class=setup-page style=\"border-top: none; padding: 20px\"><div><div class=settings-header style=\"line-height: 40px; margin-bottom: 5px\">Contact details</div><form novalidate name=ap><div class=form-group><div><input class=form-control type=text name=firstName placeholder=\"{{\'FIRSTNAME_PHOLDER\' | translate }}\" ng-model=newFamily.firstName ng-minlength=regexes.min.name ng-maxlength=regexes.max.name maxlength={{::regexes.max.name}} remove-chars=nameField required><div class=error-text-red ng-show=\"(newFamily.firstName.length === 0 || newFamily.firstName.length === undefined) && isClicked >= 1\"><p translate=ERR_FAMILY_MEMBER_FIRST_NAME></p></div><div class=error-text-red ng-show=\"(newFamily.firstName.length < regexes.min.name) && isClicked >= 1\"><p translate=ERR_FAMILY_MEMBER_FIRST_NAME_SHORT></p></div></div></div><div class=form-group><div><input class=form-control type=text name=lastName placeholder=\"{{\'LASTNAME_PHOLDER\' | translate }}\" ng-model=newFamily.lastName ng-minlength=regexes.min.name ng-maxlength=regexes.max.name maxlength={{::regexes.max.name}} remove-chars=nameField required><div class=error-text-red ng-show=\"(newFamily.lastName.length === 0 || newFamily.lastName.length === undefined) && isClicked >= 1\"><p translate=ERR_FAMILY_MEMBER_LAST_NAME></p></div><div class=error-text-red ng-show=\"(newFamily.lastName.length < regexes.min.name) && isClicked >= 1\"><p translate=ERR_FAMILY_MEMBER_LAST_NAME_SHORT></p></div></div></div><div class=form-group><div class=with-icon><input type=email class=form-control placeholder=\"{{ \'EMAIL_NON_REQ_PHOLDER\' | translate }}\" ng-model=newFamily.email name=email ng-minlength=regexes.min.email ng-maxlength=regexes.max.email maxlength={{::regexes.max.email}} remove-space autocomplete=off><validation-icons is-valid=ap.email.$valid is-dirty=ap.email.$dirty></validation-icons></div><div class=error-text-red ng-show=\"(!newFamily.email || !ap.email.$valid) && isClicked >= 1\"><p translate=ERR_FAMILY_MEMBER_EMAIL></p></div></div><div class=\"row form-group\"><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=with-icon><input type=tel class=form-control placeholder=\"{{ \'PHONE_NUM_NON_REQ_PHOLDER\' | translate }}\" ng-model=newFamily.phoneNumber name=phoneNumber ng-minlength=regexes.min.phone ng-maxlength=regexes.max.phone maxlength={{regexes.max.phone}} remove-space remove-chars=number><validation-icons is-valid=ap.phoneNumber.$valid is-dirty=ap.phoneNumber.$dirty></validation-icons></div></div></div><br><div class=settings-header style=\"line-height: 40px; margin-bottom: 5px\">Relationship to children</div><div ng-if=\"!pupilsList || pupilsList.length == 0\"><p translate=ME_DETAILS_NO_PUPILS></p></div><div><div class=pupils-list><div class=\"vi-row pupil\" ng-repeat=\"p in pupilsList\"><div class=vi-col-left style=\"padding: 0; width: 40px\"><label class=check-large style=\"margin-top: 4px\"><input type=checkbox ng-model=p.selected></label></div><div class=\"vi-col-middle identity identity-middle\" style=\"width: 80%; max-width: 300px\"><strong ng-click=\"p.selected = !p.selected\">{{ p.firstName }} {{ p.lastName }}</strong><div ng-show=p.selected><div class=is-relative><relationship ng-model=p.relationshipId is-required=true></relationship><label class=select-placeholder translate=RELATIONSHIP_PHOLDER ng-hide=\"p.relationshipId > 0\"></label><span class=\"dripicons-chevron-down select-arrow\"></span><div class=error-text-red ng-show=\"(!p.relationshipId || p.relationshipId == \'0\') && isClicked >= 1\"><p translate=ERR_FAMILY_MEMBER_RELATIONSHIP></p></div></div><!-- <div class=\"error-text-red\" ng-if=\"p.invalid && !p.relationshipId\">\n										Select the relationship to child\n									</div> --></div></div></div></div></div><br><div class=form-group><div><span translate=SEND_INVITE_FAMILY_MEMBER_LONG ng-if=!integration></span></div></div></form><div><button class=\"btn btn-primary btn-primary-pink\" ng-disabled=saving style=\"float: none\" type=button ng-click=\"save(); isClicked = isClicked + 1\"><span translate=SAVE_AND_INVITE_BTN ng-if=!integration></span> <span translate=ADD_TO_PROFILE ng-if=integration></span></button></div><div ng-if=editingId><div class=delete-button-separator></div><a ng-click=delete() class=red-link-normal><span translate=DELETE_FAMILY_MEMBER_BTN></span></a></div></div></div></div>");
$templateCache.put("app/profile/views/check-profile-modal.html","<div class=event-addlocation-modal style=\"padding: 10px; padding-right: 0\"><div class=modal-header><h3 translate=MOVEUP_HEADER style=\"line-height: 32px !important\"></h3></div><div class=modal-body><div class=textWrapper style=\"font-weight: 500\" translate=MOVEUP_DESCRIPTION></div><div><br><div class=textWrapper ng-click=onTickBoxClicked()><div class=vi-row><div class=vi-col-left style=\"width: 30px\"><label><input ng-model=showAgainCheck type=checkbox checked style=\"float: left\"></label></div><div class=vi-col-middle style=\"padding-top:0 !important\"><div translate=\"DON\'T_SHOW_AGAIN\">Don\'t show me this again</div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=GOTIT_BTN ng-click=close()></div></div></div>");
$templateCache.put("app/profile/views/delete-account-modal.html","<div><div class=modal-header><h3 ng-if=\"schools.length > 1\" translate=DELETE_ACCOUNT_HEADER_MULTIPLE_SCHOOLS translate-values=\"{\'school\': active_school.name }\"></h3><h3 ng-if=\"schools.length === 1\" translate=DELETE_ACCOUNT_HEADER_SINGLE_SCHOOL translate-values=\"{\'school\': active_school.name }\"></h3></div><div class=modal-body><p ng-if=\"schools.length > 1\" translate=DELETE_ACCOUNT_TEXT translate-values=\"{\'school\': active_school.name }\"></p><p ng-if=\"schools.length === 1\" translate=DELETE_ACCOUNT_SINGLE_SCHOOL></p><p translate=INSERT_PASSWORD></p><input id=delete-pwd-id type=password class=form-control placeholder=Password ng-model=vm.password ng-minlength=2 ng-maxlength=250 maxlength=250 required><div translate=\"{{ deletingAccountError }}\" class=\"alert alert-error\" ng-show=deletingAccountError></div></div><div class=modal-footer><button ng-if=\"schools.length > 1\" id=delete-account-btn-id type=button class=\"btn btn-primary pull-right\" ng-disabled=\"!vm.password || deletingAccount\" translate=DELETE_BTN ng-click=confirm()><button ng-if=\"schools.length === 1\" id=delete-account-btn-id type=button class=\"btn btn-primary pull-right\" ng-disabled=\"!vm.password || deletingAccount\" translate=REMOVE_BTN ng-click=confirm()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/profile/views/delete-family-modal.html","<div><div class=modal-header><h3 translate=DELETE_FAMILY_HEADER></h3></div><div class=modal-body><p ng-if=!isMember class=add-members-text translate=DELETE_FAMILY_TEXT></p><p ng-if=isMember class=add-members-text translate=DELETE_FAMILY_TEXT_MEMBER></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" ng-disabled=deleting translate=DELETE_BTN ng-click=confirm() ng-disabled=deletingGroup><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/profile/views/delete-pupil-modal.html","<div><div class=modal-header><h3 translate=DELETE_PUPIL_HEADER></h3></div><div class=modal-body><p ng-if=!_pupil.multipleParents class=add-members-text translate=DELETE_PUPIL_TEXT></p><p ng-if=_pupil.multipleParents class=add-members-text translate=DELETE_LINKED_PUPIL_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" ng-disabled=deleting translate=DELETE_BTN ng-click=confirm() ng-disabled=deletingGroup><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/profile/views/logout-confirm-modal.html","<div><div class=modal-header><h3 translate-values=\"{\'school\': active_school.name }\">Sign out</h3></div><div class=modal-body>Are you sure you want to sign out?</div><div class=modal-footer><button id=delete-account-btn-id type=button class=\"btn btn-primary btn-primary-pink pull-right\" ng-disabled=loggingOut ng-click=confirm()>Sign out</button> <button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/profile/views/manage-family.html","<div class=profile-settings-family ng-class=\"{\'is-visible\':viewState.isReady}\" style=\"overflow: hidden\"><div class=family-member ng-repeat=\"member in family\"><div class=identity><figure class=avatar><span class=dripicons-user></span></figure><strong>{{::member.firstName }} {{::member.lastName }}</strong> <em>{{ nameRelation(member.relationshipId) }}</em></div><p ng-if=member.email><span class=\"icon dripicons-mail\"></span> {{::member.email}} <a ng-click=sendInviteFamily(member.id) translate=SEND_INVITE_FAMILY_MEMBER ng-if=\"!member.member && !integration\"></a></p><p ng-if=member.email><span class=\"icon dripicons-mail\"></span> {{::member.email}} <a ng-click=sendInviteFamily(member.id) translate=ADD_TO_PROFILE ng-if=\"!member.member && integration\"></a></p><p ng-if=member.phoneNumber><span class=\"icon dripicons-phone\"></span>{{::member.phoneNumber}}</p><a class=cancel ng-click=removeMember(member.id) ng-if=member.id><span class=dripicons-cross></span></a></div><div ng-hide=viewState.hasFamily><img alt=\"\" src=assets/images/profile-add-family.svg width=184 height=auto style=\"margin:0 0 15px 0\"><p translate=ADD_FAMILY_MEMBER></p></div><div style=\"overflow: hidden; padding: 3px 0\"><button type=button class=\"btn btn-primary pull-right btn-primary-pink\" ng-click=openAddFamilyModal() translate=ADD_CONTACT></button></div></div>");
$templateCache.put("app/profile/views/manage-pupils.html","<section class=profile-settings-pupil ng-class=\"{\'is-visible\':viewState.isReady}\"><div class=pupils-list><div class=pupil ng-repeat=\"p in pupils | orderBy: \'firstName\'\"><figure class=avatar ng-class=\"{{\'female\':p.genderId == 3002,\'male\':p.genderId == 3001, \'nonbinary\':p.genderId == 3003, \'notdefined\':p.genderId == 3004, \'nodata\':!p.genderId || p.genderId == 0}\"><img alt=\"\" src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg width=28 ng-if=\"p.gender == 3002\"> <img alt=\"\" src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg width=28 ng-if=\"p.gender == 3001\"> <img alt=\"\" ng-src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg width=28 ng-if=\"p.genderId == 3003\"> <img alt=\"\" ng-src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg width=28 ng-if=\"p.genderId == 3004\"> <img alt=\"\" ng-src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg width=28 ng-if=\"!p.genderId || p.genderId == 0\"></figure><div class=identity><strong>{{ p.firstName }} {{ p.lastName }}</strong> <em><span>{{ relationToPupils(myUser.relationshipId, p.genderId) }}</span><!-- <span ng-if=\"p.gender === \'Female\'\" translate=\"PUPIL_DAUGHTER\"></span>\n					<span ng-if=\"p.gender === \'Male\'\" translate=\"PUPIL_SON\"></span></em> --> <em>{{ p.secondTierName }} <span ng-if=p.secondTierName>-</span> {{p.firstTierName}}</em> <em ng-if=\"p.monthId !== \'0\'\"><figure class=\"emblem icon-birthday-cake\" ui-sref=classlist.all href=#/classlist/all><span class=\"dripicons-birthday-cake icon-birthday-cake\" width=18 height=20></span></figure><div><span class=birth-month ng-if=\"p.monthId === \'2001\'\" translate=PUPIL_JAN></span> <span class=birth-month ng-if=\"p.monthId === \'2002\'\" translate=PUPIL_FEB></span> <span class=birth-month ng-if=\"p.monthId === \'2003\'\" translate=PUPIL_MAR></span> <span class=birth-month ng-if=\"p.monthId === \'2004\'\" translate=PUPIL_APR></span> <span class=birth-month ng-if=\"p.monthId === \'2005\'\" translate=PUPIL_MAY></span> <span class=birth-month ng-if=\"p.monthId === \'2006\'\" translate=PUPIL_JUN></span> <span class=birth-month ng-if=\"p.monthId === \'2007\'\" translate=PUPIL_JUL></span> <span class=birth-month ng-if=\"p.monthId === \'2008\'\" translate=PUPIL_AUG></span> <span class=birth-month ng-if=\"p.monthId === \'2009\'\" translate=PUPIL_SEP></span> <span class=birth-month ng-if=\"p.monthId === \'2010\'\" translate=PUPIL_OCT></span> <span class=birth-month ng-if=\"p.monthId === \'2011\'\" translate=PUPIL_NOV></span> <span class=birth-month ng-if=\"p.monthId === \'2012\'\" translate=PUPIL_DEC></span></div></em></em></div><div><a class=edit ng-click=openAddPupil(p) ng-if=p.id><span class=\"icon dripicons-pencil\"></span></a> <a class=cancel ng-click=removePupil(p) ng-if=p.id><span class=dripicons-cross></span></a></div></div></div><div style=\"overflow: auto; padding: 3px 0\"><button type=button class=\"btn btn-primary pull-right btn-primary-pink\" ng-click=openAddPupilModal() style=\"font-style: initial\"><span translate=ADD_PUPIL_BTN></span></button></div></section>");
$templateCache.put("app/profile/views/notification-mail-settings.html","<div class=\"content-logged off profile\"><section class=\"page-view-header classlist-header {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div style=\"padding: 0\"><div class=premium-ad-clear style=\"padding: 0 15px\"><div premium-ad></div></div><div style=\"position: relative\"><svg id=header-back-button ng-click=goback() class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <strong class=page-view-header__title translate=NAV_MANAGE_EMAIL_NOTIFICATION_SETTINGS></strong></div></div></section><section class=profile-settings-notifications ng-class=\"{\'is-visible\':viewState.isReady}\"><form name=pn novalidate><div class=notification-settings-list><p translate=NOTIFICATIONS_DIGEST_TEXT style=\"color: #8a94a2\"></p><div class=item-children><input ng-change=onAllChecked() class=pull-right type=checkbox ng-model=selectedAll style=\"margin-top: 0\"><div><p><b style=\"color: #6d7279\">Select/Deselect All</b></p></div></div><div ng-repeat=\"n in notificationSettings\"><h4>{{ n.name }}</h4><div class=item-children ng-repeat=\"c in n.children\"><input ng-change=onChecked(c) id=\"notification_1_{{ $index }}\" class=pull-right type=checkbox ng-model=c.value><div><p>{{ c.translation }}</p><span>{{ c.description }}</span></div></div></div></div></form></section></div>");
$templateCache.put("app/profile/views/notification-settings.html","<div class=\"content-logged off profile\"><section class=\"page-view-header classlist-header {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div style=\"padding: 0\"><div class=premium-ad-clear style=\"padding: 0 15px\"><div premium-ad></div></div><div style=\"position: relative\"><svg id=header-back-button ng-click=goback() class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <strong class=page-view-header__title translate=NAV_MANAGE_PUSH_NOTIFICATION_SETTINGS></strong></div></div></section><section class=profile-settings-notifications ng-class=\"{\'is-visible\':viewState.isReady}\"><form name=pn novalidate><div ng-if=isNative class=native-notif-off-label-profile><h1 translate=PUSH_NOTIFICATIONS></h1><div ng-if=!nativeNotificationsEnabled><div translate=NOTIFICATIONS_OFF_SETTINGS></div><br><div><button type=button class=\"btn btn-primary\" ng-click=openNativeNotificationSettings()><span translate=OPEN_SETTINGS></span></button></div></div><div ng-if=nativeNotificationsEnabled><span translate=NOTIFICATIONS_ON_SETTINGS></span> <a ng-click=openNativeNotificationSettings() translate=NOTIFICATIONS_ON_SETTINGS_1></a>.</div></div><div class=notification-settings-list><h1 ng-if=isNative translate=NOTIFICATIONS_APP_NOTIFICATIONS_HEADER style=\"margin-bottom: 10px\"></h1><p translate=NOTIFICATIONS_APP_NOTIFICATIONS_TEXT style=\"color: #8a94a2\"></p><div class=item-children><input ng-change=onAllChecked() class=pull-right type=checkbox ng-model=selectedAll style=\"margin-top: 0\"><div><p><b style=\"color: #6d7279\">Select/Deselect All</b></p></div></div><div ng-repeat=\"n in notificationSettings\"><h4>{{ n.name }}</h4><div class=item-children ng-repeat=\"c in n.children\"><input ng-change=onChecked() id=\"notification_1_{{ $index }}\" class=pull-right type=checkbox ng-model=c.value><div><p>{{ c.translation }}</p><span>{{ c.description }}</span></div></div></div></div></form></section></div>");
$templateCache.put("app/profile/views/only-ambassador-modal.html","<div><div class=modal-header><h3>Warning</h3></div><div class=modal-body><p translate=DELETE_ACCOUNT_ONLY_AMBASSADOR></p></div><div class=modal-footer><button type=button class=\"btn btn-default\" translate=OK_BTN ng-click=close()></button></div></div>");
$templateCache.put("app/profile/views/payment-settings.html","<section class=profile-settings-pupil ng-class=\"{\'is-visible\':viewState.isReady}\"><div ng-if=!hasAccount><h4 translate=PAYMENT_PROVIDER_DETAILS_1></h4><p translate=PAYMENT_PROVIDER_DETAILS_TEXT_1></p><div></div></div><div ng-if=hasAccount><h4 translate=PAYMENT_PROVIDER_DETAILS></h4><p><span translate=PAYMENT_PROVIDER_DETAILS_TEXT></span> <a ng-click=removePayment() translate=CONTACT_US></a>.</p><div></div></div><div style=\"overflow: auto; padding: 3px 0; margin-top: 20px\"><button type=button class=\"btn btn-primary btn-primary-pink pull-right\" ng-click=gotoPaymentSettings() style=\"font-style: initial\"><span ng-if=!hasAccount translate=PAYMENT_PROVIDER_DETAILS_BUTTON_1></span> <span ng-if=hasAccount translate=PAYMENT_PROVIDER_DETAILS_BUTTON></span></button></div></section>");
$templateCache.put("app/profile/views/privacy-settings.html","<div class=\"content-logged off profile\"><section class=\"page-view-header classlist-header {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div style=\"padding: 0\"><div class=premium-ad-clear><div premium-ad></div></div><div style=\"position: relative\"><svg id=header-back-button ng-click=goback() class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <strong class=page-view-header__title translate=NAV_MANAGE_PRIVACY></strong></div></div></section><section class=profile-settings-privacy ng-class=\"{\'is-visible\':viewState.isReady}\" style=\"padding: 0; margin:0\"><form name=ps novalidate><!-- Parent Map Permission --><div class=privacy-subheader translate=PRIVACY_MAP_OPTION></div><div class=privacy-optin-section><div class=map-icon><a href=#/classlist/map/0/ ><img src=https://storage.googleapis.com/classlist-branding/app-assets/privacy-map-icon.svg></a></div><div class=optin-header><span class=\"icons dripicons-location\"></span> <span translate=PRIVACY_APPR_HOME_ADDRESS></span></div><div class=checkbox-container><span class=checkbox-div><input type=checkbox name=checkbox class=checkbox ng-model=runSchoolShare></span><label for=checkbox class=text translate=PRIVACY_WHOLE_SCHOOL></label></div><div class=privacy-help>See who else lives along your school run or in your neighbourhood. <a href=https://help.classlist.com/hc/en-us/articles/209336529-The-Parent-Map target=_blank>Learn more</a></div></div><!-- Parent Map Permission END --><!-- Other Permission --><div class=privacy-subheader translate=PRIVACY_PROFILE_OPTION></div><div ng-repeat=\"s in privacySettings\"><!-- Home Address --><div class=privacy-optin-section ng-if=\"s.name === \'ADDRESS\'\"><div class=optin-header><span class=\"icons dripicons-home\"></span> <span translate=PRIVACY_HOME_ADDRESS></span></div><div class=checkbox-container><div class=checkbox-group><span class=checkbox-div><input ng-model=s.shareWithClass ng-disabled=s.sharedWithClassLocked type=checkbox name=checkbox class=checkbox></span><label for=checkbox class=text translate=PRIVACY_CLASS></label></div><div class=checkbox-group><span class=checkbox-div><input ng-model=s.shareWithYear ng-disabled=s.sharedWithYearLocked type=checkbox name=checkbox class=checkbox></span><label for=checkbox class=text translate=PRIVACY_YEAR></label></div></div></div><!-- Phone Number --><div class=privacy-optin-section ng-if=\"s.name === \'PHONE\'\"><div class=optin-header><span class=\"icons dripicons-phone\"></span> <span translate=PRIVACY_PHONE_NUMBER></span></div><div class=checkbox-container><div class=checkbox-group><span class=checkbox-div><input ng-model=s.shareWithClass ng-disabled=s.sharedWithClassLocked type=checkbox name=checkbox class=checkbox></span><label for=checkbox class=text translate=PRIVACY_CLASS></label></div><div class=checkbox-group><span class=checkbox-div><input ng-model=s.shareWithYear ng-disabled=s.sharedWithYearLocked type=checkbox name=checkbox class=checkbox></span><label for=checkbox class=text translate=PRIVACY_YEAR></label></div></div></div><!-- Family Contacts --><div class=privacy-optin-section ng-if=\"s.name === \'FAMILY_DETAILS\'\"><div class=optin-header><span class=\"icons dripicons-user-group\"></span> <span translate=PRIVACY_FAMILY_CONTACTS></span></div><div class=checkbox-container><div class=checkbox-group><span class=checkbox-div><input ng-model=s.shareWithClass ng-disabled=s.sharedWithClassLocked type=checkbox name=checkbox class=checkbox></span><label for=checkbox class=text translate=PRIVACY_CLASS></label></div><div class=checkbox-group><span class=checkbox-div><input ng-model=s.shareWithYear ng-disabled=s.sharedWithYearLocked type=checkbox name=checkbox class=checkbox></span><label for=checkbox class=text translate=PRIVACY_YEAR></label></div></div></div><!-- Other Permission END --></div><div class=privacy-optin-section><div class=privacy-help>If you choose not to show your contact details on your profile, parents can still get in touch with you via Classlist Messages.</div><div style=\"padding: 10px 22px 20px\"><button type=button class=\"btn btn-primary btn-primary-pink\" ng-click=save() ng-disabled=ps.$pristine><span translate=SAVE_BTN></span></button></div></div></form></section></div>");
$templateCache.put("app/profile/views/profile-password.html","<div class=\"content-logged off profile\"><section class=\"page-view-header classlist-header {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div style=\"padding: 0\"><div class=premium-ad-clear style=\"padding: 0 15px\"><div premium-ad></div></div><div style=\"position: relative\"><svg id=header-back-button ng-click=goback() class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <strong class=page-view-header__title translate=NAV_MANAGE_CHANGE_PASSWORD></strong></div></div></section><div class=profile-settings-basic ng-class=\"{\'is-visible\':viewState.isReady}\"><form name=cp novalidate autocomplete=off><div class=\"row form-group\"><div class=col-md-12><div class=with-icon style=\"border: none\"><input type=password class=form-control placeholder=\"{{ \'OLD_PWD_PHOLDER\' | translate }}\" ng-model=pwd.oldPassword name=oldPassword required ng-maxlength=regexes.max.password maxlength={{::regexes.max.password}} remove-space required autocomplete=new-password><validation-icons is-valid=cp.oldPassword.$valid is-dirty=cp.oldPassword.$dirty></validation-icons></div></div></div><div class=\"row form-group\"><div class=col-md-12><div class=with-icon style=\"border: none\"><input type=password class=form-control placeholder=\"{{ \'NEW_PWD_PHOLDER\' | translate }}\" ng-model=pwd.newPassword name=newPassword required ng-minlength=regexes.min.password ng-maxlength=regexes.max.password maxlength={{::regexes.max.password}} remove-space required autocomplete=off ng-change=validatePassword()><validation-icons is-valid=cp.newPassword.$valid is-dirty=cp.newPassword.$dirty ng-if=isPasswordValid></validation-icons></div></div></div><div class=\"row form-group\"><div class=col-md-12><div class=with-icon style=\"border: none\"><input type=password class=form-control placeholder=\"{{ \'CONF_NEW_PWD_PHOLDER\' | translate }}\" ng-model=pwd.confirmPassword name=confirmPassword required ng-minlength=regexes.min.password ng-maxlength=regexes.max.password maxlength={{::regexes.max.password}} remove-space required autocomplete=off><validation-icons is-valid=cp.confirmPassword.$valid is-dirty=cp.confirmPassword.$dirty ng-if=isPasswordValid></validation-icons></div></div></div><div style=\"font-size: 12px; color: #888; font-weight: 600\">Password must be at least 8 characters long, include at least one uppercase letter, one lowercase letter, one number, and one special character.</div><div ng-show=\"pwd.confirmPassword !== pwd.newPassword && cp.confirmPassword.$dirty && cp.newPassword.$dirty\"><div><p class=text-danger translate=ERR_PWD_MISMATCH></p></div></div></form><br><div><div><button type=button class=\"btn btn-primary btn-primary-pink\" ng-disabled=\"cp.$invalid || pwd.confirmPassword !== pwd.newPassword || !pwd.confirmPassword || !pwd.newPassword || !isPasswordValid || saving\" ng-click=updatePassword()><span translate=SAVE_BTN></span></button></div></div></div></div>");
$templateCache.put("app/profile/views/profile-settings.html","<div class=\"content-logged off profile\"><section class=\"page-view-header classlist-header\"><div style=\"padding: 0\"><div style=\"position: relative\"><svg id=header-back-button ng-click=goback() class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <strong class=page-view-header__title translate=ACCOUNT_SETTINGS></strong></div></div></section><div class=profile-settings-basic ng-class=\"{\'is-visible\':viewState.isReady}\"><div class=settings-header style=\"line-height: 40px\">Contact information</div><p ng-if=integration translate=EMAIL_CHANGE_INTEGRATION_WARNING></p><form name=bd novalidate autocomplete=off><div class=\"row form-group\"><div class=col-md-12><div class=with-icon style=\"border: none\"><input type=email class=form-control placeholder=\"{{ \'EMAIL_PHOLDER\' | translate }}\" ng-model=myUser.email name=email ng-minlength=regexes.min.email ng-maxlength=regexes.max.email maxlength={{::regexes.max.email}} remove-space required ng-disabled=integration><validation-icons is-valid=bd.email.$valid is-dirty=bd.email.$dirty></validation-icons></div></div></div><div class=\"row form-group\"><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=with-icon style=\"border: none\"><input type=tel class=form-control placeholder=\"{{ \'PHONE_NUM_NON_REQ_PHOLDER\' | translate }}\" ng-model=myUser.phoneNumber name=phoneNumber maxlength={{regexes.max.phone}} remove-space remove-chars=number><!-- <validation-icons is-valid=\"bd.phoneNumber.$valid\" is-dirty=\"bd.phoneNumber.$dirty\"></validation-icons> --><div ng-if=invalidPhone style=\"color: red; font-size: 12px\" translate=INVALID_PHONE_NUMBER></div></div></div></div></form><div><div><validation-errors></validation-errors></div></div><br><div><div style=\"overflow: auto\"><button type=button class=\"btn btn-primary btn-primary-pink\" ng-disabled=cp.$invalid ng-click=update()><span translate=SAVE_BTN></span></button></div></div><div style=\"background-color: #e5e5e5; margin-top: 25px; margin-bottom: 25px; height: 1px\"></div><form name=cp novalidate autocomplete=off><div class=settings-header style=\"line-height: 40px\"><b ng-if=\"schools.length === 1\" translate=DELETE_ACCOUNT_HEADER_SINGLE_SCHOOL></b> <b ng-if=\"schools.length > 1\" translate=DELETE_ACCOUNT_HEADER_MULTIPLE_SCHOOLS translate-values=\"{\'school\': active_school.name }\"></b></div><div class=form-group><div><p ng-if=\"schools.length === 1\" translate=DELETE_ACCOUNT_SINGLE_SCHOOL translate-values=\"{\'school\': active_school.name }\"></p><p ng-if=\"schools.length > 1\" translate=DELETE_ACCOUNT_TEXT_1 translate-values=\"{\'school\': active_school.name }\"></p></div><div><a id=delete-account-id ng-click=deleteAccount()><span ng-if=\"schools.length === 1\" translate=DELETE_SCHOOL_BTN></span> <span ng-if=\"schools.length > 1\" translate=REMOVE_SCHOOL_BTN></span></a></div></div></form></div></div>");
$templateCache.put("app/profile/views/wrapper.html","<div class=\"content-logged off profile\"><section class=\"page-view-header classlist-header {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div style=\"padding: 0\"><div class=premium-ad-clear style=\"padding: 0 15px\"><div premium-ad></div></div><div style=\"position: relative\"><svg id=header-back-button ng-click=goback() class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <strong class=page-view-header__title translate=PROFILE_AND_SETTINGS></strong></div></div></section><div><div class=profile-card><div class=\"profile-info clearfix\"><div class=vi-row><div class=vi-col-left style=\"width: 62px\"><div class=edit-logo-holder><figure class=\"avatar pull-left\"><avatar source=\"{{ active_user.avatar }}\" name=\"{{ active_user.firstName + \' \' + active_user.lastName }}\" my=true></avatar></figure></div></div><div class=vi-col-middle><div class=name profile-updater><p id=name-container-id>{{active_user.firstName}} {{active_user.lastName}}</p><a href=#/classlist/details/{{active_user.id}}/contact translate=VIEW_EDIT_PROFILE></a></div></div></div></div></div></div><div><div class=profile-sections-mobile><div><nav class=\"profile-settings-menu clearfix\"><a href=#/classlist/details/{{active_user.id}}/contact ng-click=setScrollToChildren()><svg style=\"width: 25px; height: 40px; float: left; margin-right: 12px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><path fill=none stroke=#444444 stroke-width=4 stroke-linecap=square stroke-miterlimit=10 d=\"M57.207,10.793 c-6.39-6.39-16.751-6.39-23.142,0c-0.787,0.787-1.472,1.636-2.066,2.529c-0.593-0.892-1.279-1.742-2.066-2.529 c-6.39-6.39-16.751-6.39-23.142,0c-6.391,6.39-6.391,16.751,0,23.142L32,59.142l25.207-25.207 C63.598,27.544,63.598,17.183,57.207,10.793z\" stroke-linejoin=miter></path></g></svg> <span translate=NAV_MANAGE_FAMILY></span></a></nav></div><div ng-repeat=\"sec in sections\"><nav class=\"profile-settings-menu clearfix\"><a ui-sref={{sec.url}} ui-sref-active=active ng-click=setActive(sec)><svg ng-if=\"sec.icon == \'dripicons-user\'\" style=\"width: 25px; height: 40px; float: left; margin-right: 12px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><path data-color=color-2 fill=none stroke=#444444 stroke-width=4 stroke-linecap=square stroke-miterlimit=10 d=\"M38,40H26 c-9.941,0-18,8.059-18,18v0c0,0,9,4,24,4s24-4,24-4v0C56,48.059,47.941,40,38,40z\" stroke-linejoin=miter></path><path fill=none stroke=#444444 stroke-width=4 stroke-linecap=square stroke-miterlimit=10 d=\"M18,16 c0-7.732,6.268-14,14-14s14,6.268,14,14s-6.268,16-14,16S18,23.732,18,16z\" stroke-linejoin=miter></path></g></svg> <svg ng-if=\"sec.icon == \'dripicons-card\'\" style=\"width: 25px; height: 40px; float: left; margin-right: 12px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><line data-color=color-2 fill=none stroke=#444444 stroke-width=4 stroke-linecap=square stroke-miterlimit=10 x1=2 y1=22 x2=62 y2=22 stroke-linejoin=miter></line><line data-color=color-2 fill=none stroke=#444444 stroke-width=4 stroke-linecap=square stroke-miterlimit=10 x1=2 y1=32 x2=62 y2=32 stroke-linejoin=miter></line><line data-color=color-2 fill=none stroke=#444444 stroke-width=4 stroke-linecap=square stroke-miterlimit=10 x1=10 y1=44 x2=24 y2=44 stroke-linejoin=miter></line><line data-color=color-2 fill=none stroke=#444444 stroke-width=4 stroke-linecap=square stroke-miterlimit=10 x1=48 y1=44 x2=54 y2=44 stroke-linejoin=miter></line><path fill=none stroke=#444444 stroke-width=4 stroke-linecap=square stroke-miterlimit=10 d=\"M2,50V14 c0-2.209,1.791-4,4-4h52c2.209,0,4,1.791,4,4v36c0,2.209-1.791,4-4,4H6C3.791,54,2,52.209,2,50z\" stroke-linejoin=miter></path></g></svg> <svg ng-if=\"sec.icon == \'dripicons-user-id\'\" style=\"width: 24px; height: 40px; float: left; margin-right: 12px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><path data-cap=butt fill=none stroke=#444444 stroke-width=4 stroke-miterlimit=10 d=\"M12,22v20c0,4.971,8.954,9,20,9 c11.046,0,20-4.029,20-9V22\" stroke-linecap=butt stroke-linejoin=miter></path><polyline data-cap=butt data-color=color-2 fill=none stroke=#444444 stroke-width=4 stroke-miterlimit=10 points=\"44,54 49,61 39,61 44,54 44,26 \" stroke-linecap=butt stroke-linejoin=miter></polyline><polygon fill=none stroke=#444444 stroke-width=4 stroke-linecap=square stroke-miterlimit=10 points=\"32,32 4,18 32,4 60,18 \" stroke-linejoin=miter></polygon></g></svg> <svg ng-if=\"sec.icon == \'dripicons-lock\'\" style=\"width: 25px; height: 40px; float: left; margin-right: 12px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><path data-color=color-2 fill=none stroke=#444444 stroke-width=4 stroke-linecap=square stroke-miterlimit=10 d=\"M44,21v-7 c0-6.627-5.373-12-12-12h0c-6.627,0-12,5.373-12,12v7\" stroke-linejoin=miter></path><path fill=none stroke=#444444 stroke-width=4 stroke-linecap=square stroke-miterlimit=10 d=\"M50,62H14 c-2.209,0-4-1.791-4-4V30c0-2.209,1.791-4,4-4h36c2.209,0,4,1.791,4,4v28C54,60.209,52.209,62,50,62z\" stroke-linejoin=miter></path><line data-color=color-2 fill=none stroke=#444444 stroke-width=4 stroke-linecap=square stroke-miterlimit=10 x1=32 y1=47 x2=32 y2=53 stroke-linejoin=miter></line><circle data-color=color-2 fill=none stroke=#444444 stroke-width=4 stroke-linecap=square stroke-miterlimit=10 cx=32 cy=41 r=6 stroke-linejoin=miter></circle></g></svg> <svg ng-if=\"sec.icon == \'dripicons-bell\'\" style=\"width: 22px; margin-left: 3px; height: 40px; float: left; margin-right: 12px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><path data-color=color-2 fill=none stroke=#444444 stroke-width=4 stroke-linecap=square stroke-miterlimit=10 d=\"M30,40 c0,3.3-2.7,6-6,6s-6-2.7-6-6\" stroke-linejoin=miter></path><path fill=none stroke=#444444 stroke-width=4 stroke-linecap=square stroke-miterlimit=10 d=\"M38,26c0-5.1,0-10,0-10 c0-7.7-6.3-14-14-14S10,8.3,10,16c0,0,0,4.9,0,10c0,8-4,14-4,14h36C42,40,38,34,38,26z\" stroke-linejoin=miter></path></g></svg> <svg ng-if=\"sec.icon == \'dripicons-mail\'\" style=\"width: 22px; margin-left: 3px; height: 40px; float: left; margin-right: 12px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><polyline data-cap=butt data-color=color-2 points=\"1.614 3.558 12 13 22.385 3.559\" fill=none stroke=#444444 stroke-miterlimit=10 stroke-width=2 stroke-linecap=butt stroke-linejoin=miter></polyline><rect x=1 y=3 width=22 height=18 rx=2 ry=2 fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></rect></g></svg> <svg ng-if=\"sec.icon == \'dripicons-heart\'\" style=\"width: 25px; height: 40px; float: left; margin-right: 12px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><path fill=none stroke=#444444 stroke-width=4 stroke-linecap=square stroke-miterlimit=10 d=\"M57.207,10.793 c-6.39-6.39-16.751-6.39-23.142,0c-0.787,0.787-1.472,1.636-2.066,2.529c-0.593-0.892-1.279-1.742-2.066-2.529 c-6.39-6.39-16.751-6.39-23.142,0c-6.391,6.39-6.391,16.751,0,23.142L32,59.142l25.207-25.207 C63.598,27.544,63.598,17.183,57.207,10.793z\" stroke-linejoin=miter></path></g></svg> <svg ng-if=\"sec.icon == \'dripicons-password\'\" xmlns=http://www.w3.org/2000/svg style=\"width: 22px; margin-left: 2px; height: 40px; float: left; margin-right: 12px\" xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><path d=M49,3,24.525,27.375a17.112,17.112,0,1,0,12.1,12.1L41,35V27h8V19h8l4-4V3Z fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></path><circle data-color=color-2 cx=18.5 cy=45.5 r=5.5 fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></circle></g></svg> <svg ng-if=\"sec.icon == \'dripicons-remove-school\'\" xmlns=http://www.w3.org/2000/svg style=\"width: 22px; margin-left: 2px; height: 40px; float: left; margin-right: 12px\" xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><path d=M49,3,24.525,27.375a17.112,17.112,0,1,0,12.1,12.1L41,35V27h8V19h8l4-4V3Z fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></path><circle data-color=color-2 cx=18.5 cy=45.5 r=5.5 fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></circle></g></svg> <span translate={{sec.label}}></span></a></nav><!-- <div ng-if=\"activeSection.label == sec.label\">\n					<div ui-view autoscroll=\"false\" style=\"margin-top: 20px; margin-bottom: 20px;\"></div>\n				</div> --></div><div><nav class=\"profile-settings-menu clearfix\"><a ng-click=logoutProfile()><span translate=SIGNOUT_BTN></span></a></nav></div></div></div></div>");
$templateCache.put("app/pupil/views/add-pupil-modal.html","<div><div class=modal-header><h3 class=modal-title translate=ADD_PUPIL_TITLE></h3></div><div class=modal-body><form novalidate name=ap><div class=form-group><input class=form-control type=text name=firstName placeholder=\"{{\'PUPIL_FIRSTNAME_PHOLDER\' | translate }}\" ng-model=newPupil.firstName ng-minlength=regexes.min.name ng-maxlength=regexes.max.name maxlength={{::regexes.max.name}} remove-chars=nameField required><div class=error-text-red ng-show=\"(newPupil.firstName.length === 0 || newPupil.firstName.length === undefined) && isClicked >= 1\"><p translate=ERR_PUPIL_FIRSTNAME></p></div><div class=error-text-red ng-show=\"(newPupil.firstName.length < regexes.min.name) && isClicked >= 1\"><p translate=ERR_PUPIL_FIRSTNAME_SHORT></p></div></div><div class=form-group><input class=form-control type=text name=lastName placeholder=\"{{\'PUPIL_LASTNAME_PHOLDER\' | translate }}\" ng-model=newPupil.lastName ng-minlength=regexes.min.pup_lastname ng-maxlength=regexes.max.name maxlength={{::regexes.max.name}} remove-chars=nameField required><div class=error-text-red ng-show=\"(newPupil.lastName.length === 0 || newPupil.lastName.length === undefined) && isClicked >= 1\"><p translate=ERR_PUPIL_LASTNAME></p></div></div><div class=\"row form-group\"><div class=\"col-md-6 col-sm-6 col-xs-6\"><div class=is-relative><months ng-model=newPupil.monthId is-required=false></months><label class=select-placeholder translate=PUPIL_DOB_MONTH_PHOLDER ng-hide=\"newPupil.monthId.length > 0\"></label><span class=\"dripicons-chevron-down select-arrow\"></span></div></div></div><div class=form-group><class-picker ng-model=newPupil.tier></class-picker><div class=error-text-red ng-show=\"newPupil.tier === null && isClicked >= 1\"><p translate=ERR_PUPIL_TIER></p></div></div><div class=form-group><div><div class=is-relative><relationship ng-model=newPupil.relationshipId is-required=true></relationship><label class=select-placeholder translate=RELATIONSHIP_PHOLDER ng-hide=\"newPupil.relationshipId.length > 0\"></label><span class=\"dripicons-chevron-down select-arrow\"></span></div></div></div></form></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" save-pupil-button type=button ng-click=\"save(); isClicked = isClicked + 1\" ng-init=\"isClicked = 0\"><span translate=SAVE_BTN></span></button></div></div>");
$templateCache.put("app/pupil/views/add-pupil.html","<div class=content-logged><section class=page-view-header><div><div><div class=page-subheader-title><svg ng-click=goback() id=header-back-button class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <strong ng-if=!editingId class=page-view-header__title translate=ADD_PUPIL_HEADER></strong> <strong ng-if=editingId class=page-view-header__title translate=EDIT_PUPIL_HEADER></strong></div></div></div></section><div class=setup-page style=\"border-top: none; padding: 20px\"><di><div class=settings-header style=\"line-height: 40px; margin-bottom: 5px\">Child details</div><form novalidate name=ap><div class=form-group><input class=form-control type=text name=firstName placeholder=\"{{\'PUPIL_FIRSTNAME_PHOLDER\' | translate }}\" ng-model=newPupil.firstName ng-minlength=regexes.min.name ng-maxlength=regexes.max.name maxlength={{::regexes.max.name}} remove-chars=nameField required><div class=error-text-red ng-show=\"(newPupil.firstName.length === 0 || newPupil.firstName.length === undefined) && isClicked >= 1\"><p translate=ERR_PUPIL_FIRSTNAME></p></div><div class=error-text-red ng-show=\"(newPupil.firstName.length > 0 && newPupil.firstName.length < regexes.min.name) && isClicked >= 1\"><p translate=ERR_PUPIL_FIRSTNAME_SHORT></p></div></div><div class=form-group><input class=form-control type=text name=lastName placeholder=\"{{\'PUPIL_LASTNAME_PHOLDER\' | translate }}\" ng-model=newPupil.lastName ng-minlength=regexes.min.pup_lastname ng-maxlength=regexes.max.name maxlength={{::regexes.max.name}} remove-chars=nameField required><div class=error-text-red ng-show=\"(newPupil.lastName.length === 0 || newPupil.lastName.length === undefined) && isClicked >= 1\"><p translate=ERR_PUPIL_LASTNAME></p></div></div><div class=form-group><div><div class=is-relative><months ng-model=newPupil.monthId is-required=false></months><label class=select-placeholder translate=PUPIL_DOB_MONTH_PHOLDER ng-hide=\"newPupil.monthId.length > 0\"></label><span class=\"dripicons-chevron-down select-arrow\"></span></div></div></div><div class=form-group><class-picker ng-model=newPupil.tier></class-picker><div class=error-text-red ng-show=\"(!newPupil.tier || !newPupil.tier.id) && isClicked >= 1\"><p translate=ERR_PUPIL_TIER></p></div></div><br><div class=settings-header style=\"line-height: 40px; margin-bottom: 5px\">Your relationship to child</div><div class=form-group><div><div class=is-relative><relationship ng-model=newPupil.relationshipId is-required=true></relationship><label class=select-placeholder translate=RELATIONSHIP_PHOLDER ng-hide=\"newPupil.relationshipId > 0\"></label><span class=\"dripicons-chevron-down select-arrow\"></span></div></div><div class=error-text-red ng-show=\"!newPupil.relationshipId && isClicked >= 1\"><p translate=ERR_PUPIL_YOUR_RELATIONSHIP></p></div></div><br><div class=settings-header style=\"line-height: 40px; margin-bottom: 5px\">Family members</div><div ng-if=\"!familyList || familyList.length == 0\"><p translate=ME_DETAILS_NO_FAMILYMEMBER></p></div><div class=form-group><div class=pupils-list><div class=\"vi-row pupil\" ng-repeat=\"p in familyList\"><div class=vi-col-left style=\"padding: 0; width: 40px\"><label class=check-large style=\"margin-top: 4px\"><input type=checkbox ng-model=p.selected></label></div><div class=\"vi-col-middle identity identity-middle\" style=\"width: 80%; max-width: 300px\"><strong ng-click=\"p.selected = !p.selected\">{{ p.firstName }} {{ p.lastName }}</strong><div ng-show=p.selected><div class=is-relative><relationship ng-model=p.relationshipId is-required=true></relationship><label class=select-placeholder translate=RELATIONSHIP_PHOLDER ng-hide=\"p.relationshipId > 0\"></label><span class=\"dripicons-chevron-down select-arrow\"></span><div class=error-text-red ng-show=\"(!p.relationshipId || p.relationshipId == \'0\') && isClicked >= 1\"><p translate=ERR_FAMILY_MEMBER_RELATIONSHIP></p></div></div><!-- <div class=\"error-text-red\" ng-if=\"p.invalid && !p.relationshipId\">\n										Select the relationship to child\n									</div> --></div></div></div></div></div></form><br><div><button class=\"btn btn-primary btn-primary-pink\" save-pupil-button type=button ng-click=\"save(); isClicked = isClicked + 1\" ng-init=\"isClicked = 0\" ng-disabled=saving><span translate=SAVE_BTN></span></button></div><div ng-if=editingId><div class=delete-button-separator></div><a ng-click=delete() class=red-link-normal><span translate=DELETE_PUPIL_BTN></span></a></div></di></div></div>");
$templateCache.put("app/pupil/views/edit-pupil-modal.html","<div><div class=modal-header><h3 class=modal-title translate=EDIT_PUPIL_TITLE></h3></div><div class=modal-body><form novalidate name=ap><div class=form-group><input class=form-control type=text name=firstName placeholder=\"{{\'PUPIL_FIRSTNAME_PHOLDER\' | translate }}\" ng-model=newPupil.firstName ng-minlength=regexes.min.name ng-maxlength=regexes.max.name maxlength={{regexes.max.name}} remove-chars=nameField required><div class=error-text-red ng-show=\"(newPupil.firstName.length === 0 || newPupil.firstName.length === undefined) && isClicked >= 1\"><p translate=ERR_PUPIL_FIRSTNAME></p></div><div class=error-text-red ng-show=\"(newPupil.firstName.length < regexes.min.name) && isClicked >= 1\"><p translate=ERR_PUPIL_FIRSTNAME_SHORT></p></div></div><div class=form-group><input class=form-control type=text name=lastName placeholder=\"{{\'PUPIL_LASTNAME_PHOLDER\' | translate }}\" ng-model=newPupil.lastName ng-minlength=regexes.min.pup_lastname ng-maxlength=regexes.max.name maxlength={{regexes.max.name}} remove-chars=nameField required><div class=error-text-red ng-show=\"(newPupil.lastName.length === 0 || newPupil.lastName.length === undefined) && isClicked >= 1\"><p translate=ERR_PUPIL_LASTNAME></p></div></div><div class=form-group><div><div class=is-relative><months ng-model=newPupil.monthId is-required=false></months><label class=select-placeholder translate=PUPIL_DOB_MONTH_PHOLDER ng-hide=\"newPupil.monthId > 0\"></label><span class=\"dripicons-chevron-down select-arrow\"></span></div></div></div><div class=form-group><class-picker ng-model=newPupil.tier></class-picker><div class=error-text-red ng-show=\"newPupil.tier === null && isClicked >= 1\"><p translate=ERR_PUPIL_TIER></p></div></div><div class=form-group><div><div class=is-relative><relationship ng-model=newPupil.relationshipId is-required=true></relationship><label class=select-placeholder translate=RELATIONSHIP_PHOLDER ng-hide=\"newPupil.relationshipId.length > 0\"></label><span class=\"dripicons-chevron-down select-arrow\"></span></div></div></div></form></div><div class=modal-footer><a ng-click=delete() class=red-link><span translate=DELETE_BTN></span> </a><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" save-pupil-button type=button ng-click=\"save(); isClicked = isClicked + 1\" ng-init=\"isClicked = 0\"><span translate=SAVE_BTN></span></button></div></div>");
$templateCache.put("app/raffle/views/details.html","<section class=raffle-view><div class=page-view-header><div><div style=\"position: relative\"><svg id=header-back-button ui-sref=events.list() class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg></div><strong class=\"page-view-header__title elipsis-text\" style=\"max-width: 95%;\n					overflow: hidden;\n					font-size: 14px;\n					vertical-align: middle\">{{raffle.title}}</strong></div></div><div><div style=\"padding: 0 !important\"><div class=raffle-picture-container><h2 ng-bind-html=raffle.description></h2><div class=raffle-picture><div class=img style=\"background-image: url({{raffle.imagePath}})\"></div></div><div class=raffle-countdown><!-- Hiding the countdown after the raffle has ended --> <span translate=OUR_DRAWS ng-if=\"raffle.status === \'ACTIVE\'\"></span><div class=countdown-container ng-if=\"raffle.status === \'ACTIVE\'\"><div id=countdown><ul><li><span id=days>00</span>DAYS</li><li><span id=hours>00</span>HOURS</li><li><span id=minutes>00</span>MINS</li><li><span id=seconds>00</span>SECS</li></ul></div></div><!-- Countdown END--><div class=sales-end translate=SALES_END></div><br><!-- The raffle is ongoing and users haven\'t bought any tickets --> <button ng-if=\"ticketsAvailable && !raffle.parentPurchasedTickets\" type=button class=\"btn btn-primary get-tickets\" translate=GET_TICKETS ui-sref=\"raffle.enter({raffle_id: raffle_id})\"></button><!-- The raffle is ongoing and users have bought some tickets --> <button ng-if=\"ticketsAvailable && raffle.parentPurchasedTickets\" type=button class=\"btn btn-primary get-tickets\" translate=GET_MORE_TICKETS ui-sref=\"raffle.enter({raffle_id: raffle_id})\"></button><!-- After the raffle has ended --><div ng-if=\"raffle && raffle.status !== \'ACTIVE\'\"><div class=ended-up><span class=\"icon dripicons-hourglass\"></span> The raffle has ended on</div><div class=ended-date>{{raffle.drawDateString}}</div></div><div class=text-link ng-if=\"raffle && raffle.parentPurchasedTickets\"><a ui-sref=\"raffle.view({raffle_id: raffle_id})\" translate=VIEW_TICKETS></a></div></div></div></div></div><div class=prizes-section><h2 translate=RAFFLE_PRIZES></h2><div class=prize-container ng-repeat=\"prize in prizes\"><div class=left-side><div class=prize-img style=\"background-image: url({{prize.imagePath}})\"></div></div><div class=right-side><h2>{{prize.title}}</h2><p ng-bind-html=prize.description></p></div></div><div class=text-link><button class=\"btn btn-ghost\" ng-if=\"raffle.prizes.length > 3 && prizes.length <= 3\" ng-click=setPrizeList(true) translate=VIEW_MORE_PRIZES></button></div></div></section>");
$templateCache.put("app/raffle/views/enter.html","<section class=raffle-view><div class=page-view-header><div><div style=\"position: relative\"><svg id=header-back-button ui-sref=\"raffle.details({raffle_id: raffle_id})\" class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg></div><strong class=\"page-view-header__title elipsis-text\" style=\"max-width: 95%;\n					overflow: hidden;\n					font-size: 14px;\n					vertical-align: middle\">{{raffle.title}}</strong></div></div><div class=question-section><h2 translate=BUY_TICKETS></h2><h1 translate=ENTER_RAFFLE></h1><h3>{{raffle.question.question}}</h3><div class=answer-boxes><div ng-repeat=\"x in raffle.question.options\"><button type=button class=buttonanswer ng-click=checkAnswer(x) ng-class=\"{\'correct\': x.option === selectedAnswer.option && x.correct, \'wrong\': x.option === selectedAnswer.option && !x.correct}\">{{x.option}}</button><br><span ng-if=\"x.option === selectedAnswer.option && x.correct\">Correct answer!</span></div></div><div class=clear></div><div><button ng-disabled=!selectedAnswer.correct type=button class=\"btn btn-primary btn-select\" ui-sref=\"raffle.tickets({raffle_id: raffle_id})\">Select tickets</button></div></div></section>");
$templateCache.put("app/raffle/views/select-tickets.html","<section class=raffle-view><div class=page-view-header><div><div style=\"position: relative\"><svg id=header-back-button ui-sref=\"raffle.details({raffle_id: raffle_id})\" class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg></div><strong class=\"page-view-header__title elipsis-text\" style=\"max-width: 95%;\n					overflow: hidden;\n					font-size: 14px;\n					vertical-align: middle\">{{raffle.title}}</strong></div></div><!-- Before Payment --><div ng-show=!paid><div class=title-section style=\"padding-left: 30px;\n				border-bottom: 2px solid #e7e8f6;\n				padding-bottom: 10px\"><p style=\"font-weight: 600; margin-bottom: 5px\" translate=PER_TICKET translate-values=\"{ price: raffle.currency + raffle.price.toFixed(2) }\"></p><p translate=PER_TICKET_DESC style=\"color: #627293\"></p></div><div class=select-ticket-section style=\"padding-top: 5%\"><div class=radio-options style=\"padding-left: 10px\"><label><input style=\"margin-top: -3px\" type=radio name=ticketOption ng-model=selectedOption ng-value=0 ng-change=onOptionChange()> <span style=\"padding-left: 10px\">Choose an option</span></label></div><div class=bundle-container-preview style=\"padding-top: 30px; padding-bottom: 40px\"><a class=bundles-preview ng-repeat=\"ticket in raffle.tickets\" ng-click=selectTicket(ticket) ng-class=\"{\'selected\': ticket.id === selectedTicket.id}\"><div class=box><div>{{ticket.count}}</div><div>TICKET{{ticket.count !== 1 ? \'S\' : \'\'}}</div></div><span ng-bind-html=\"ticket.currency + ticket.price.toFixed(2)\"></span></a></div><div class=radio-options style=\"padding-left: 10px\"><label><input style=\"margin-top: -3px\" type=radio name=ticketOption ng-model=selectedOption ng-value=-1 ng-change=onOptionChange()> <span style=\"padding-left: 25px\">I want more tickets</span></label><div class=custom-ticket-input ng-show=\"selectedOption === -1\" style=\"padding-left: 45px\"><label style=\"font-weight: normal; font-size: 12px\">Choose how many tickets: <input type=number ng-model=customTicketCount ng-disabled=\"selectedOption !== -1\" ng-blur=updateCustomTicket() style=\"text-align: right\"></label><span>tickets for <span ng-bind-html=\"raffle.currency + (raffle.price * customTicketCount).toFixed(2)\"></span></span></div></div></div><!-- Creadit card section will open after selected a ticket --><div class=title-section ng-show=selectedTicket.price><h2>Total amount to pay <span ng-bind-html=\"raffle.tickets[0].currency + selectedTicket.price.toFixed(2)\"></span><br><div class=pay-secure>Pay by debit card only</div></h2></div><div class=form-section ng-show=selectedTicket.price><form class=stripe><div class=div-form><label ng-if=raffle.onlyDebitPaymentAccepted for=card-element>Debit card number</label><label ng-if=!raffle.onlyDebitPaymentAccepted for=card-element>Credit or debit card number</label><div id=card-element></div><span id=card-errors class=error-span></span></div><button ng-disabled=buying type=button translate=PAY_NOW class=\"btn btn-primary\" style=\"width: 95% !important\" ng-class=\"{\'disabled\': buying}\" ng-click=stripeSubmit()></button></form></div></div><!-- After Payment --><div ng-show=paid><div style=\"padding: 0 !important\"><div class=raffle-picture-container><h2 ng-bind-html=raffle.description></h2><div class=raffle-picture><div class=img style=\"background-image: url({{raffle.imagePath}})\"></div></div></div></div><!-- Confirmed buying tickets --><div ng-show=!error><div class=tickets-info><h2>Congratulations, it’s confirmed!</h2><p>You purchased {{selectedTicket.count}} ticket(s) for the draw on {{raffle.drawDate | date:\'LLLL d, y hh:mm a\' : \'GMT\'}}.</p><div class=result-info>The results will be notified by email.</div></div><div class=btn-area><div class=btn-area ng-if=ticketsAvailable><button type=button class=\"btn btn-primary\" translate=GET_MORE_TICKETS ui-sref=\"raffle.enter({raffle_id: raffle_id})\"></button></div><button type=button class=\"btn btn-ghost\" translate=VIEW_TICKETS ui-sref=\"raffle.view({raffle_id: raffle_id})\"></button></div></div><!-- Something wrong --><div ng-show=error><div class=tickets-info><h2>We’re sorry, something has gone wrong.</h2><p>Would you like to try again?</p></div><div class=btn-area><button type=button class=\"btn btn-primary\" translate=GET_TICKETS ng-click=reset()></button></div></div></div></section>");
$templateCache.put("app/raffle/views/view-tickets.html","<section class=raffle-view><div class=page-view-header><div><div style=\"position: relative\"><svg id=header-back-button ui-sref=\"raffle.details({raffle_id: raffle_id})\" class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg></div><strong class=\"page-view-header__title elipsis-text\" style=\"max-width: 95%;\n					overflow: hidden;\n					font-size: 14px;\n					vertical-align: middle\">{{title}}</strong></div></div><div class=purchased-tickets-section><h2 translate=YOUR_TICKETS_RAFFLE translate-values=\"{ \'title\': title }\"></h2></div><div ng-repeat=\"t in tickets\"><div class=purchased-tickets-section><div class=purchased-tickets><h3>{{t.tickets.length}} Ticket(s)</h3><span>Purchased on the {{t.date | date: \'dd MMM yyyy\'}}</span><h3 class=how-much ng-bind-html=\"t.currencyHtml + t.total.toFixed(2)\"></h3></div></div><div class=tickets-section><div class=ticket-box ng-repeat=\"ticket in t.tickets\">{{ticket.ticketRefNumber}}</div></div><div ng-show=\"purchaseTicketAvailable && $first\"><div class=button-area ng-if=ticketsAvailable><button type=button class=\"btn btn-primary\" translate=GET_MORE_TICKETS ui-sref=\"raffle.enter({raffle_id: raffle_id})\"></button></div></div></div></section>");
$templateCache.put("app/raffle/views/wrapper.html","<div class=\"content-logged events\"><div ui-view autoscroll=false></div></div>");
$templateCache.put("app/recommendations/views/suggest.html","<article class=recommendations-view ng-show=viewState.isReady><div class=\"page-view-header clearfix {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div><div class=premium-ad-clear style=\"padding: 0 15px\"><div premium-ad></div></div><div><div class=page-subheader-title><svg ng-click=goback() id=header-back-button class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <strong class=page-view-header__title translate=SUGGEST_BUSINESS></strong></div></div></div></div><section class=page-container-header-from-top style=\"background: #fff; padding: 20px; border: 1px solid #ddd\"><div><div><div translate=SUGGEST_BUSINESS_TEXT_1 style=\"margin-top: 10px\"></div><br><form novalidate name=ap><div class=form-group><input class=form-control type=text name=businessName placeholder=\"{{\'BUSINESS_NAME\' | translate }}\" ng-model=business.name required></div><div class=form-group><input class=form-control type=text name=businessAddress placeholder=\"{{\'BUSINESS_ADDRESS\' | translate }}\" ng-model=business.address required></div><div class=form-group><input class=form-control type=text name=businessWebsite placeholder=\"{{\'BUSINESS_WEBSITE\' | translate }}\" ng-model=business.website></div><div class=form-group><input class=form-control type=number name=businessPhone placeholder=\"{{\'BUSINESS_PHONE\' | translate }}\" ng-model=business.phone remove-chars=number></div><div class=form-group><input class=form-control type=text name=businessContact placeholder=\"{{\'BUSINESS_CONTACT\' | translate }}\" ng-model=business.contactname required></div></form></div><div style=\"text-align: right\"><button class=\"btn btn-default\" type=button ng-click=back()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=send() ng-disabled=\"business.name === \'\' || business.address === \'\' || isLoading\"><span translate=OK_BTN></span></button></div></div></section></article>");
$templateCache.put("app/recommendations/views/view.html","<article class=recommendations-view ng-show=viewState.isReady><div class=\"page-view-header clearfix {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div><div premium-ad></div><div><div class=page-subheader-title><svg ng-click=goback() id=header-back-button class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <strong class=page-view-header__title translate=\"RECOMM_{{ type }}\"></strong> <a href={{dashboardLink}} target=_blank class=pull-right style=\"margin-top: 7px\"><button type=button class=\"btn btn-primary btn-primary-pink\"><span translate=RECOMM_DASHBOARD_BTN></span></button> </a><a ng-if=\"viewState.isAdvertiser == 2 && adlist && adlist.length > 0\" href={{dashboardLink}} target=_blank class=pull-right style=\"margin-top: 7px\"><button type=button class=\"btn btn-primary btn-primary-pink\"><span translate=RECOMM_REGISTER_BTN></span></button></a></div></div></div></div><section><div><div class=page-view-subheader><div><div class=row><div class=col-md-6><div class=is-relative><input ng-keydown=blurSearch($event) type=search class=\"form-control recomm-search-input\" placeholder=\"{{ \'SEARCH_TXT\' | translate }}\" ng-model=query ng-keyup=searchContacts()> <svg style=\"width: 20px; height: 20px; position: absolute; top: 6px; right: 6px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><line data-color=color-2 fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 x1=44 y1=44 x2=32.7 y2=32.7 stroke-linejoin=miter></line><circle fill=none stroke=#444444 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 cx=20 cy=20 r=18 stroke-linejoin=miter></circle></g></svg></div></div><div class=col-md-6><div class=is-relative><select class=form-control ng-model=categoryType ng-change=openCategory()><option translate=RECOMM_ALL value=ALL></option><option translate=RECOMM_CHILDREN_EDUCATION value=CHILDREN_EDUCATION></option><option translate=RECOMM_HEALTH_WELLNESS value=HEALTH_WELLNESS></option><option translate=\"RECOMM_HOME_GARDEN \" value=HOME_GARDEN></option><option translate=RECOMM_PROPERTY_SALE_RENTAL value=PROPERTY_SALE_RENTAL></option><option translate=RECOMM_SHOPPING_STYLE value=SHOPPING_STYLE></option><option translate=RECOMM_TRAVEL_ENTERTAINMENT value=TRAVEL_ENTERTAINMENT></option><option translate=\"RECOMM_PROFESSIONAL_SERVICES \" value=PROFESSIONAL_SERVICES></option><option translate=RECOMM_EVENTS_ACTIVITIES value=EVENTS_ACTIVITIES></option><option translate=RECOMM_OTHER value=OTHER></option></select><span class=\"dripicons-chevron-down select-arrow\"></span></div></div></div></div></div><div><div ng-if=\"adlist.length == 0\" style=\"padding: 0 15px\"><div class=\"row right-registration\"><div class=col-md-6><div><div translate=RECOMM_VIEW_TITLE_EMPTY></div><a ng-if=\"viewState.isAdvertiser == 1\" href={{dashboardLink}} target=_blank><button type=button class=\"btn btn-primary btn-primary-pink\"><span translate=RECOMM_DASHBOARD_BTN></span></button> </a><a ng-if=\"viewState.isAdvertiser == 2\" href={{dashboardLink}} target=_blank><button type=button class=\"btn btn-primary btn-primary-pink\"><span translate=RECOMM_REGISTER_BTN></span></button></a></div></div><div class=col-md-6><div><div translate=RECOMM_REG_TEXT_2></div><button type=button class=\"btn btn-primary\" ng-click=suggest()><span translate=RECOMM_SUGGEST_BTN></span></button></div></div></div></div><div><div class=\"section-cards mobile-cards\"><div><section style=cursor:pointer ng-if=\"adlist && adlist.length > 0\" ng-click=suggest()><p translate=RECOMM_SUGGEST_BTN_NEW style=\"margin: 0;\n								font-size: 17px;\n								color: #777\"></p></section><section ng-repeat=\"item in adlist | filter:query\"><div header><div class=row><div class=\"col-md-2 col-sm-2 col-xs-2\"><figure class=avatar style=\"margin-top: 6px; height: 40px; width: 40px\"><avatar source={{item.companyAvatar}} name=\"{{ item.title }}\" width=40 height=40></avatar></figure></div><div class=\"col-md-8 col-sm-8 col-xs-8\"><h3>{{ item.title }}</h3><p ng-if=item.parent translate=CLASSLIST_PARENT></p></div><div ng-if=item.mostLoved class=\"col-md-2 col-sm-2 col-xs-2 icon-mostloved\"><span class=\"dripicons-trophy icon\"></span><div translate=RECC_MOST_LOVED></div></div></div></div><div><p ng-bind-html=item.description></p></div><div ng-if=item.address class=card-bold><span class=\"dripicons-location icon\"></span><p>{{item.address}}</p></div><div ng-if=item.phone class=card-bold><span class=\"dripicons-phone icon\"></span><p>{{item.phone}}</p></div><div ng-if=item.tags class=card-bold><span class=\"dripicons-tags icon\"></span><p>{{ getTagsString(item.tags) }}</p></div><div footer><a class=ad-link href=\"{{ item.link }}\" target=_blank>{{ getDomainFromUrl(item.linkText) }}</a><div class=loveit-container><img alt=\"\" ng-if=item.liked src=assets/icons/heart_enabled.svg class=loveit ng-click=likeAd(item)> <img alt=\"\" ng-if=!item.liked src=assets/icons/heart_disabled.svg class=loveit ng-click=likeAd(item)> <span ng-if=item.like class=love-counter>{{ item.like }}</span></div></div></section></div></div><div class=\"section-cards desktop-cards\" style=\"overflow: auto\"><div style=\"float: left; width: 50%\"><section style=cursor:pointer ng-if=\"adlist && adlist.length > 0\" ng-click=suggest()><p translate=RECOMM_SUGGEST_BTN_NEW style=\"margin: 0;\n								font-size: 17px;\n								color: #777\"></p></section><section ng-repeat=\"item in adlist | filter:query\" ng-if=\"$index % 2 == 0\"><div header><div class=row><div class=\"col-md-2 col-sm-2 col-xs-2\"><figure class=avatar style=\"margin-top: 6px; height: 40px; width: 40px\"><avatar source={{item.companyAvatar}} name=\"{{ item.title }}\" width=40 height=40></avatar></figure></div><div class=\"col-md-8 col-sm-8 col-xs-8\"><h3>{{ item.title }}</h3><p ng-if=item.parent translate=CLASSLIST_PARENT></p></div><div ng-if=item.mostLoved class=\"col-md-2 col-sm-2 col-xs-2 icon-mostloved\"><span class=\"dripicons-trophy icon\"></span><div translate=RECC_MOST_LOVED></div></div></div></div><div><p ng-bind-html=item.description></p></div><div ng-if=item.address class=card-bold><span class=\"dripicons-location icon\"></span><p>{{item.address}}</p></div><div ng-if=item.phone class=card-bold><span class=\"dripicons-phone icon\"></span><p>{{item.phone}}</p></div><div ng-if=item.tags class=card-bold><span class=\"dripicons-tags icon\"></span><p>{{ getTagsString(item.tags) }}</p></div><div footer><a class=ad-link href=\"{{ item.link }}\" target=_blank>{{ getDomainFromUrl(item.linkText) }}</a><div class=loveit-container><img alt=\"\" ng-if=item.liked src=assets/icons/heart_enabled.svg class=loveit ng-click=likeAd(item)> <img alt=\"\" ng-if=!item.liked src=assets/icons/heart_disabled.svg class=loveit ng-click=likeAd(item)> <span ng-if=item.like class=love-counter>{{ item.like }}</span></div></div></section></div><div style=\"width: 50%; float: left\"><section ng-repeat=\"item in adlist | filter:query\" ng-if=\"$index % 2 != 0\"><div header><div class=row><div class=\"col-md-2 col-sm-2 col-xs-2\"><figure class=avatar style=\"margin-top: 6px; height: 40px; width: 40px\"><avatar source={{item.companyAvatar}} name=\"{{ item.title }}\" width=40 height=40></avatar></figure></div><div class=\"col-md-8 col-sm-8 col-xs-8\"><h3>{{ item.title }}</h3><p ng-if=item.parent translate=CLASSLIST_PARENT></p></div><div ng-if=item.mostLoved class=\"col-md-2 col-sm-2 col-xs-2 icon-mostloved\"><span class=\"dripicons-trophy icon\"></span><div translate=RECC_MOST_LOVED></div></div></div></div><div><p ng-bind-html=item.description></p></div><div ng-if=item.address class=card-bold><span class=\"dripicons-location icon\"></span><p>{{item.address}}</p></div><div ng-if=item.phone class=card-bold><span class=\"dripicons-phone icon\"></span><p>{{item.phone}}</p></div><div ng-if=item.tags class=card-bold><span class=\"dripicons-tags icon\"></span><p>{{ getTagsString(item.tags) }}</p></div><div footer><a class=ad-link href=\"{{ item.link }}\" target=_blank>{{ getDomainFromUrl(item.linkText) }}</a><div class=loveit-container><img alt=\"\" ng-if=item.liked src=assets/icons/heart_enabled.svg class=loveit ng-click=likeAd(item)> <img alt=\"\" ng-if=!item.liked src=assets/icons/heart_disabled.svg class=loveit ng-click=likeAd(item)> <span ng-if=item.like class=love-counter>{{ item.like }}</span></div></div></section></div></div></div></div></div></section></article>");
$templateCache.put("app/recommendations/views/wrapper.html","<div class=content-logged suggest-business><div ui-view autoscroll=false></div></div>");
$templateCache.put("app/runmap/views/not-on-runmap.html","<div class=\"modal-colored wheat\"><div class=modal-body><h3 translate=SCHOOLRUNMAP_DISABLED_P1></h3><p translate=SCHOOLRUNMAP_DISABLED_P2></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=VIEWPROFILE_BTN ui-sref=profile ng-click=close()></div></div>");
$templateCache.put("app/runmap/views/school-run-map-address.html","<div ng-show=viewState.isReady><div class=\"page-view-header {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div><div premium-ad></div><div><strong class=page-view-header__title translate=SHOOLRUNMAP_ADDRESS_HEADLINE></strong></div></div></div><form name=bd ng-show=viewState.isReady><div class=page-container-header-from-top><div style=\"padding: 0 20px; padding-top: 20px\"><div><legend translate=SCHOOLRUNMAP_ADDRESS_TITLE class=\"col-md-12 address-title\"></legend><div class=form-group><div><input type=text class=\"form-control address-form\" name=houseName autocomplete=off ng-model=myUser.address.houseName placeholder=\"{{\'HOUSENAME_PHOLDER\' | translate }}\" ng-maxlength=regexes.max.address maxlength={{regexes.max.address}}></div></div><div class=form-group><div><input type=text class=\"form-control address-form\" autocomplete=off name=streetName ng-model=myUser.address.streetAddress placeholder=\"{{\'STREETNAME_PHOLDER\' | translate }}\" ng-maxlength=regexes.max.address maxlength={{regexes.max.address}}><div class=error-text-red ng-show=\"myUser.address.streetAddress.length === 0 && isOptInClicked\"><p translate=ERR_RUNMAP_STREET></p></div></div></div><div class=\"row form-group\"><div class=\"col-md-6 col-sm-6 col-xs-6\"><input type=text class=\"form-control address-form\" autocomplete=off name=city ng-model=myUser.address.city placeholder=\"{{\'CITY_PHOLDER\' | translate }}\" ng-maxlength=regexes.max.address maxlength={{regexes.max.address}}><div class=error-text-red ng-show=\"myUser.address.city.length === 0  && isOptInClicked\"><p translate=ERR_RUNMAP_CITY></p></div></div><div class=\"col-md-6 col-sm-6 col-xs-6\"><input type=text class=\"form-control address-form\" autocomplete=off name=state ng-model=myUser.address.stateCounty placeholder=\"{{\'STATE_PHOLDER\' | translate }}\" ng-maxlength=regexes.max.address maxlength={{regexes.max.address}}></div></div><div class=\"row form-group\"><div class=\"col-md-6 col-sm-6 col-xs-6\"><input type=text class=\"form-control address-form\" autocomplete=off name=postCode ng-model=myUser.address.postCode placeholder=\"{{\'POSTCODE_PHOLDER\' | translate }}\" remove-chars=address ng-maxlength=regexes.max.postcode maxlength={{regexes.max.postcode}}><div class=error-text-red ng-show=\"myUser.address.postCode.length === 0  && isOptInClicked\"><p translate=ERR_RUNMAP_POSTCODE></p></div></div><div class=\"col-md-6 col-sm-6 col-xs-6\"><div class=\"is-relative address-form\"><countries class=address-label ng-model=myUser.address.countryId is-required=true></countries><label class=select-placeholder translate=COUNTRY_PHOLDER ng-hide=\"myUser.address.countryId.length > 0\"></label><span class=\"dripicons-chevron-down select-arrow\"></span></div></div></div><div class=form-group><div class=address-checkbox-div><p><span class=address-checkbox><input type=checkbox class=checkbox ng-model=myUser.runSchoolShare></span><span class=address-text translate=SCHOOLRUNMAP_ADDRESS_APPROVAL></span></p><div class=error-text-red ng-show=\"!myUser.runSchoolShare  && isOptInClicked\"><p translate=ERR_RUNMAP_TERMS></p></div></div></div><div class=buttons><div style=\"height: 45px\"><button type=button ng-disabled=viewState.updating class=\"btn btn-primary pull-right\" ng-click=update()><span translate=SAVE_BTN></span></button></div></div></div><div class=opt-in-image><p translate=OPTIN_MAP_TEXT></p></div></div></div></form></div>");
$templateCache.put("app/runmap/views/school-run-map.html","<div class=school-run-map><div class=\"page-view-header {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div><div premium-ad></div><div><strong class=page-view-header__title translate=SHOOLRUNMAP_HEADLINE></strong></div></div></div><div class=page-container-header-from-top style=\"margin-top: 0!important\"><div class=page-view-subheader><div class=row><div class=col-md-6><div class=is-relative><select class=form-control ng-model=filter.class ng-change=filterByClass(false) ng-options=\"f.id as f.name for f in mapConfig.filters\"></select><span class=\"dripicons-chevron-down select-arrow\"></span></div></div><div class=\"col-md-6 search-input\"><div class=is-relative><input type=search class=form-control placeholder=Search ng-model=filter.search> <span class=\"dripicons-search search-icon\"></span><div class=dropdown-menu ng-show=selectedSearch><a ng-repeat=\"s in mapConfig.parents | filter:search\" ng-click=setFindUser(s)><span>{{s.name}}</span> (<span ng-repeat=\"pupil in s.pupils\">{{pupil.name}}{{$last ? \'\' : \', \'}}</span>)</a></div></div></div></div></div><div style=\"margin-top: 20px\"><div><section class=map-wrapper><aside class=\"map-parent-overlay col-md-4 col-sm-8 col-xs-12\" ng-show=viewState.isParentVisible><figure class=avatar><avatar source={{parentDetails.avatar}} name=\"{{ parentDetails.firstName + \' \' + parentDetails.lastName }}\" width=80 height=80></avatar></figure><div class=map-parent-details><p><strong>{{ parentDetails.firstName }} {{ parentDetails.lastName }} ({{parentDetails.relationship}})</strong></p><p><span ng-show=\"parentDetails.email !== undefined\" translate=PUPILS_SEMICOL></span> <span class=pupil ng-repeat=\"p in parentDetails.pupils\">{{ p.firstName }}</span></p></div><a class=close ng-click=toggleParentOverlay()><span class=dripicons-cross></span></a><div class=\"buttons clearfix\"><a ng-show=\"parentDetails.email !== undefined\" ui-sref=\"classlist.details({\'id\':parentDetails.id })\"><span ng-show=\"parentDetails.email !== undefined\" class=\"icon dripicons-user\"></span> <span ng-show=\"parentDetails.email !== undefined\" translate=PROFILE_BTN></span> </a><a ng-click=composeTo(parentDetails)><span class=\"icon dripicons-message\"></span> <span translate=MESSAGE_BTN></span></a></div><div class=map-parent-details><div ng-show=\"parentDetails.email === undefined\"><p><span translate=SCHOOLRUNMAP_NOT_IN_YEAR></span></p></div><div class=address><p ng-show=\"parentDetails.email.length > 0\"><span class=\"icon dripicons-mail\"></span> {{parentDetails.email}}</p><p ng-show=\"parentDetails.phoneNumber.length > 0\"><span class=\"icon dripicons-phone\"></span> {{parentDetails.phoneNumber}}</p><p ng-show=\"parentDetails.address.houseName.length > 0 ||\n														parentDetails.address.streetAddress.length > 0 ||\n														parentDetails.address.stateCounty.length > 0 ||\n														parentDetails.address.city.length > 0 ||\n														parentDetails.address.postCode.length > 0\"><span class=\"icon dripicons-location\"></span> <span class=address-line ng-if=parentDetails.address.houseName>{{parentDetails.address.houseName}}</span> <span class=address-line ng-if=parentDetails.address.streetAddress>{{parentDetails.address.streetAddress}}<br></span><span class=address-line ng-if=parentDetails.address.stateCounty>{{parentDetails.address.stateCounty}}<br></span><span class=address-line ng-if=parentDetails.address.city>{{parentDetails.address.city}}<br></span><span class=address-line ng-if=parentDetails.address.postCode>{{parentDetails.address.postCode}}<br></span></p></div></div></aside></section></div><div class=map-mobile-border><runmap config=mapConfig myname=myname></runmap></div><div><div class=\"row hidden-sm hidden-xs jumbotron\"><div class=col-md-4><h3 translate=SCHOOLRUNMAP_GOGREEN></h3></div><div class=col-md-2></div><div class=col-md-6><h4 translate=SCHOOLRUNMAP_SAVESTIME_H></h4><p translate=SCHOOLRUNMAP_SAVESTIME_P></p><h4 translate=SCHOOLRUNMAP_SAFE_H></h4><p translate=SCHOOLRUNMAP_SAFE_P></p></div></div></div></div></div></div>");
$templateCache.put("app/runmap/views/wrapper.html","<section class=content-logged><ng-include src=\"\'app/runmap/views/school-run-map.html\'\" ng-show=\"isEnabled == true\"></ng-include></section><section class=content-logged><ng-include src=\"\'app/runmap/views/school-run-map-address.html\'\" ng-show=\"isEnabled == false\"></ng-include></section>");
$templateCache.put("app/schoolpage/views/info-modal-1.html","<div class=\"assign-parent-admin info-modal\"><div class=modal-header><h3 translate=IM1_TITLE></h3></div><div class=modal-body><p><span translate=IM1_DESCR></span></p></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=OK_BTN></span></button></div></div>");
$templateCache.put("app/schoolpage/views/info-modal-2.html","<div class=\"assign-parent-admin info-modal\"><div class=modal-header><h3 translate=IM4_TITLE></h3></div><div class=modal-body><p><span translate=IM4_DESCR></span></p></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=OK_BTN></span></button></div></div>");
$templateCache.put("app/schoolpage/views/info-modal-3.html","<div class=\"assign-parent-admin info-modal\"><div class=modal-header><h3 translate=IM2_TITLE></h3></div><div class=modal-body><p><span translate=IM2_DESCR></span></p></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=OK_BTN></span></button></div></div>");
$templateCache.put("app/schoolpage/views/school-page.html","<div class=\"content-logged schoolpage\" photo-upload><div ng-if=premium_ad class=\"page-view-header premium-ad-header premium-ad-short\"><div class=no-border><div premium-ad></div></div></div><div><div><div><div class=school-picture style=\"background: url(\'assets/images/School-Page.svg\'); background-position: center!important; background-repeat: no-repeat!important; background-size: 100% auto!important\"><div style=\"background: url({{school.cover}}); height: 100%; background-size: 100%\"></div><div class=school-logo style=\"background: url({{getServingURL(school.logo, 80, true)}}), url(\'assets/icons/default-school-logo.png\'); background-size: 100%; background-position: center\"></div></div><div class=school-title><span class=name-margin>{{ school.name }}</span></div><section class=border-top-none><span class=angular-with-newlines>{{ school.descr }}</span></section><section><label translate=DETAILS></label><div><div class=contact-list><div ng-if=\"school.address || school.city\"><span class=\"dripicons-location contact-icon icon\"></span> <span>{{ school.address ? (school.address + \', \') : \'\' }} {{ school.postCode ? (school.postCode + \', \') : \'\' }} {{ school.stateCounty ? (school.stateCounty + \', \') : \'\' }} {{ school.city ? (school.city + \', \') : \'\' }} {{ school.country ? (school.country) : \'\' }}</span></div><div ng-if=school.phoneNumber><span class=\"dripicons-phone contact-icon icon\"></span> <span>{{ school.phoneNumber }}</span></div><div ng-if=school.email><span class=\"dripicons-mail contact-icon icon\"></span> <span>{{ school.email }}</span></div></div></div></section><section><label translate=HELPFUL_LINKS></label><div class=link-item ng-repeat=\"link in school.links\"><a href={{createLink(link.href)}} ng-attr-target=\"{{isExternalLink(link.href) ? \'_blank\' : undefined}}\" class=link>{{ link.text }}</a></div></section><section ng-if=\"school.parentPercentage > 50\"><label translate=YOUR_CLASSLIST_COMMUNITY></label><div><div class=big-label-blue>{{school.parentPercentage}}%</div><div class=row><div class=\"col-md-7 f-left\"><div class=progress-bar-blue><div style=\"width: {{school.parentPercentage}}%\"></div></div><div translate=PARENTS_ON_CLASSLIST></div></div><div class=col-md-5><div class=invite-button><button type=button class=\"btn btn-ghost bulk-button ng-scope\" translate=BULK_EMAIL_BTN ui-sref=invite href=#/invite></button></div></div></div></div></section><section><label>{{ school.helpTitle }}</label><div ng-bind-html=::school.helpDescription></div></section></div><div><section class=no-margin><label translate=AMBASSADORS></label><span ng-click=\"openInfo($event, 1)\" class=\"icon dripicons-information\"></span><div><div class=\"row ambassador-list small\"><div class=ambasador-item ng-repeat=\"amba in school.ambassadors\" ng-click=openUser(amba)><figure class=comment-item-avatar style=\"width: 40px; height: 40px; float: left; margin-right: 10px\"><avatar source=\"{{ amba.avatar }}\" name=\"{{ amba.name }}\" width=60 height=60 my=false></avatar></figure><div><div class=a-name>{{ amba.name }}</div><div class=a-label>{{amba.label}}</div></div></div></div></div></section><section class=no-margin><div><label translate=SCHOOL_COMMUNITY></label><span ng-click=\"openInfo($event, 2)\" class=\"icon dripicons-information\"></span><div class=\"row ambassador-list small\"><div class=ambasador-item ng-repeat=\"comm in school.communityReps\" ng-click=openUser(comm)><figure class=comment-item-avatar style=\"width: 40px; height: 40px; float: left; margin-right: 10px\"><avatar source=\"{{ comm.avatar }}\" name=\"{{ comm.name }}\" width=60 height=60 my=false></avatar></figure><div><div class=a-name>{{ comm.name }}</div><div class=a-label>{{ comm.label }}</div></div></div></div></div></section><section><div><label><span translate=CLASS_REPS></span><span ng-click=\"openInfo($event, 3)\" class=\"icon dripicons-information\"></span></label><div ng-repeat=\"item in reps_list\" class=\"row rep-item\"><div class=col-md-3><span>{{item.name}}</span></div><div class=\"col-md-9 padding-zero\"><div class=\"ambassador-list small\"><a ng-if=!item.reps ng-click=\"sendMessage(school.ambassadors, item.name)\"><svg style=\"width: 25px; float: left; height: 25px; margin-right: 8px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><path d=M31,10V6.5A4.5,4.5,0,0,1,35.5,2h0A4.5,4.5,0,0,1,40,6.5V29 fill=none stroke=#3677d9 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></path><path d=M40,8.5A4.5,4.5,0,0,1,44.5,4h0A4.5,4.5,0,0,1,49,8.5V29 fill=none stroke=#3677d9 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></path><path d=M49,13s.125-4,4-4a3.708,3.708,0,0,1,4,4V42A20,20,0,0,1,37,62H30.571a20,20,0,0,1-14.483-6.207L4.839,43.981a4.218,4.218,0,0,1,.072-5.892h0a4.218,4.218,0,0,1,4.766-.84l8.054,3.759A3,3,0,0,0,22,38.289V8.5A4.5,4.5,0,0,1,26.5,4h0A4.5,4.5,0,0,1,31,8.5V29 fill=none stroke=#3677d9 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></path></g></svg> <span style=\"line-height: 25px\" translate=CLASS_REP_VOLUNTEER_QUESTION></span></a><div ng-repeat=\"user in item.reps\" class=ambasador-item ng-click=openUser(user)><figure class=comment-item-avatar style=\"width: 40px; height: 40px; float: left; margin-right: 10px\"><avatar source=\"{{ user.avatar }}\" name=\"{{ user.name }}\" width=60 height=60 my=false></avatar></figure><div><div class=a-name>{{ user.name }}</div><div class=a-label>{{ user.label }}</div></div></div></div></div></div></div></section></div></div></div></div>");
$templateCache.put("app/schoolpage/views/wrapper.html","<div><div ui-view autoscroll=false></div></div>");
$templateCache.put("app/schoolrequest/views/schoolrequest-start.html","<script type=text/ng-template id=customTemplate.html><div ng-if=\"match.model.id != -1\" class=\"school-item\">\n		<figure class=\"school-logo\">\n			<img alt=\"\" ng-src=\"{{match.model.avatar}}\" width=\"30\" height=\"30\" onerror=\"this.src=\'assets/icons/default-school-logo.png\'\" />\n		</figure>\n		<p class=\"school-name\" ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"></p> {{ match.avatar }}\n	</div>\n	<div ng-if=\"match.model.id == -1\" class=\"school-item\">\n		<p class=\"school-name\" style=\"padding-left: 14px;\">\n			<span style=\"color: #eb004e; text-indent: 0px !important;\" translate=\"CANT_FIND_SCHOOL\"></span>\n		</p>\n	</div></script><div class=\"content-logged schoolrequest-start\" ng-class=\"{\'is-visible\':viewState.isReady}\"><div class=mobile-school-request><div class=slides><section><figure class=\"section-anchor clearfix\" ng-class=\"{ \'active\': activeSlide == 0 }\"><span class=number>1</span><figcaption translate=REQUEST_INDEX_TITLE_1></figcaption></figure><div class=\"slide section-content\"><div ng-show=\"activeSlide == 0\"><div class=slide-content><div class=title translate=REQUEST_SLIDE_1_TITLE></div><div class=req-search-container ng-class=\"{\'no-school-margin\': noSchool}\"><input type=text ng-model=search placeholder=\"{{ \'REQ_SCHOOL_SEARCH_PHOLDER\' | translate }}\" uib-typeahead=\"search.name for search in searchNewSchool($viewValue)\" typeahead-wait-ms=100 typeahead-min-length=3 typeahead-on-select=pickSchool($item) typeahead-template-url=customTemplate.html class=form-control id=typeaheader autocomplete=off><p ng-if=integrated style=\"margin-top: 20px\">We’re sorry, you cannot register at this school without an email invitation.<br>Please check your email for a unique link, or contact the school for an invitation.</p></div></div><div class=footer-btn><button ui-sref=home type=button class=\"btn btn-default pull-left\" href=#><span translate=CANCEL_BTN class=ng-scope></span></button> <button ng-disabled=integrated ng-click=gotoSlide(1) ng-disabled=!schoolId type=button class=\"btn btn-primary pull-right\" href=#><span translate=CONTINUE_BTN class=ng-scope></span></button></div></div></div></section><section id=/events/create/time-location><figure class=\"section-anchor clearfix\" ng-class=\"{ \'active\': activeSlide == 1 }\"><span class=number>2</span><figcaption translate=REQUEST_INDEX_TITLE_2></figcaption></figure><div class=section-content><div ng-show=\"activeSlide == 1\"><div class=slide-content><div class=title translate=REQUEST_SLIDE_2_TITLE></div><div class=add-pupil-but><button ng-click=addPupils() type=button class=\"btn btn-ghost pull-right\"><span translate=ADD_PUPIL_BTN class=ng-scope></span></button></div><div style=\"min-height: 50px\"><div class=\"pupils-list row\"><div class=pupil ng-repeat=\"p in pupils | orderBy: \'firstName\'\"><figure class=avatar ng-class=\"{\'female\':p.genderId == 3002,\'male\':p.genderId == 3001, \'nonbinary\':p.genderId == 3003, \'notdefined\':p.genderId == 3004, \'nodata\':!p.genderId || p.genderId == 0}\"><img alt=\"\" ng-src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg width=28 ng-if=\"p.genderId == 3002\"> <img alt=\"\" ng-src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg width=28 ng-if=\"p.genderId == 3001\"> <img alt=\"\" ng-src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg width=28 ng-if=\"p.genderId == 3003\"> <img alt=\"\" ng-src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg width=28 ng-if=\"p.genderId == 3004\"> <img alt=\"\" ng-src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg width=28 ng-if=\"!p.genderId || p.genderId == 0\"></figure><div class=identity><div><strong>{{ p.firstName }} {{ p.lastName }}</strong></div><em ng-if=\"p.genderId != \'0\'\"><span ng-if=\"p.genderId == 3003 || p.genderId == 3004\" translate=PUPIL_CHILD></span> <span ng-if=\"p.genderId == 3002\" translate=PUPIL_DAUGHTER></span> <span ng-if=\"p.genderId == 3001\" translate=PUPIL_SON></span></em> <em>{{ p.tier.name }}</em> <em ng-if=p.monthId><figure class=\"emblem icon-birthday-cake\" ui-sref=classlist.all href=#/classlist/all><span class=\"dripicons-birthday-cake icon-birthday-cake\" width=18 height=20></span></figure><div><span class=birth-month ng-if=\"p.monthId === \'2001\'\" translate=PUPIL_JAN></span> <span class=birth-month ng-if=\"p.monthId === \'2002\'\" translate=PUPIL_FEB></span> <span class=birth-month ng-if=\"p.monthId === \'2003\'\" translate=PUPIL_MAR></span> <span class=birth-month ng-if=\"p.monthId === \'2004\'\" translate=PUPIL_APR></span> <span class=birth-month ng-if=\"p.monthId === \'2005\'\" translate=PUPIL_MAY></span> <span class=birth-month ng-if=\"p.monthId === \'2006\'\" translate=PUPIL_JUN></span> <span class=birth-month ng-if=\"p.monthId === \'2007\'\" translate=PUPIL_JUL></span> <span class=birth-month ng-if=\"p.monthId === \'2008\'\" translate=PUPIL_AUG></span> <span class=birth-month ng-if=\"p.monthId === \'2009\'\" translate=PUPIL_SEP></span> <span class=birth-month ng-if=\"p.monthId === \'2010\'\" translate=PUPIL_OCT></span> <span class=birth-month ng-if=\"p.monthId === \'2011\'\" translate=PUPIL_NOV></span> <span class=birth-month ng-if=\"p.monthId === \'2012\'\" translate=PUPIL_DEC></span></div></em></div><div><a class=cancel ng-click=removePupil(p)><span class=dripicons-cross></span></a></div></div></div></div></div><div class=footer-btn><button ui-sref=home type=button class=\"btn btn-default pull-left\"><span translate=CANCEL_BTN class=ng-scope></span></button> <button ng-if=\"pupils.length > 0\" ng-disabled=!viewState.isReady ng-click=apply() type=button class=\"btn btn-primary pull-right\"><span translate=APPLY_BUTTON class=ng-scope></span></button></div></div></div></section><section><figure class=\"section-anchor clearfix\" ng-class=\"{ \'active\': activeSlide == 2 }\"><span class=number>3</span><figcaption translate=REQUEST_INDEX_TITLE_3></figcaption></figure><div ng-show=\"activeSlide == 2\" class=section-content style=\"border: none\"><div ng-if=!viewState.isAutoApproved><div class=slide-content><div class=row><div class=col-md-12><div class=title translate=REQUEST_SLIDE_3_TITLE translate-values=\"{ \'name\': schoolName }\"></div><br><p translate=PENDING_APPROVAL_TEXT1></p><span translate=SCHOOL_REQUEST_DOWNOAD_TEXT></span><div class=mobile-border></div></div></div></div><div class=footer-btn><p translate=REQUEST_SLIDE_3_FOOTER translate-values=\"{ \'name\': active_school.name }\" class=slide_footer></p><div><button ui-sref=home type=button class=\"btn btn-primary pull-right\" href=#><span translate=YES_PLEASE_BTN class=ng-scope></span></button></div></div></div><div ng-if=viewState.isAutoApproved><div class=slide-content><div class=row><div class=col-md-12><br><p translate=YOUR_SCHOOL_READY></p><div class=mobile-border></div></div></div></div><div class=footer-btn><button ui-sref=home type=button class=\"btn btn-default pull-left\"><span translate=MAYBE_LATER class=ng-scope></span></button> <button ng-click=goToNewSchool(schoolId) type=button class=\"btn btn-primary pull-right\"><span translate=VIEW_NEW_SCHOOL class=ng-scope></span></button></div></div></div></section></div></div></div>");
$templateCache.put("app/search/views/search-list.html","<div class=\"groups-list-container content-logged\"><div class=page-container-header-from-top style=\"margin-top: 0!important\"><div class=\"page-view-header clearfix\"><div><div><div class=page-subheader-title><svg ng-click=back() id=header-back-button class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <input id=search-bar autofocus type=search class=form-control style=\"height: 47px; margin-left: 44px; border: none; width: 90%\" placeholder=\"{{ \'SEARCH_START_TYPING\' | translate }}\" ng-model=keyword ng-keyup=searchForPosts($event.target.value)></div></div></div></div><div style=\"margin-top: -10px\"><div><section class=groups-list><div class=group-box ng-repeat=\"post in posts track by $index\"><div style=\"overflow: auto\" ng-click=openItem(post)><div class=vi-row><div class=vi-col-middle><div><div class=group-names><div class=group-names-child><div class=group-name>{{post.title}}</div><div class=group-type-container><span class=group-type ng-bind-html=highlight(removeLinks(post.body))></span></div></div></div></div></div></div></div></div></section></div></div></div></div>");
$templateCache.put("app/stream/views/delete-post-modal.html","<div><div class=modal-header><h3 translate=DELETE_POST_HEADER></h3></div><div class=modal-body><p translate=DELETE_POST_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=OK_BTN ng-click=confirm()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/stream/views/mark-sold-modal.html","<div><div class=modal-header><h3 translate=MARK_SOLD_HEADER></h3></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=OK_BTN ng-click=confirm()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/stream/views/no-pupil-modal.html","<div class=no-pupils-modal><div class=modal-header><h3 translate=EMPTY_HOME_TEXT_1></h3></div><div class=modal-body><p translate=EMPTY_CLASSLIST_TEXT_2></p></div><div class=modal-footer><a type=button class=\"btn btn-default\" translate=LATER_BTN ng-click=close()></a> <a href=#/profile type=button class=\"btn btn-default\" translate=EMPTY_CLASSLIST_TEXT_3></a></div></div>");
$templateCache.put("app/stream/views/post-groups-modal.html","<div class=likes-modal><div class=modal-header><div style=\"font-weight: 600; font-size: 15px\"><span>{{ _groups.length }}</span> <span translate=GROUPS_TEXT></span></div></div><div class=show-participants><ul class=basket><li ng-click=openGroup(group) ng-repeat=\"group in _groups track by $index\" style=\"cursor: pointer\"><div class=participant><figure class=avatar><avatar source=\"{{ group.avatar }}\" name=\"{{ group.title }}\" width=40 height=40></avatar></figure>{{ group.title }}</div></li></ul></div><div class=modal-footer><button class=\"btn btn-ghost\" type=button ng-click=\"close(); isClicked = isClicked + 1\" ng-init=\"isClicked = 0\" style=\"margin-right: 14px\"><span translate=DONE_BTN></span></button></div></div>");
$templateCache.put("app/stream/views/post-likes-modal.html","<div class=likes-modal><div class=modal-header><div style=\"font-weight: 600; font-size: 15px\"><span>{{ object.likes.length }}</span> <span ng-if=\"object.type != \'welcome\' && object.type != \'thanks\'\" translate=LIKES></span> <span ng-if=\"object.type == \'welcome\'\" translate=WELCOMES></span> <span ng-if=\"object.type != \'welcome\' && object.type == \'thanks\'\" translate=THANK_YOUS></span></div></div><div class=show-participants><ul class=basket><li ng-click=openLiker(item) ng-repeat=\"item in object.likes track by $index\"><div class=participant><figure class=avatar><avatar source={{item.avatar}} name=\"{{ item.firstName + \' \' + item.lastName }}\" width=40 height=40></avatar></figure>{{item.firstName}} {{item.lastName}}</div></li></ul></div><div class=modal-footer><button class=\"btn btn-ghost\" type=button ng-click=\"close(); isClicked = isClicked + 1\" ng-init=\"isClicked = 0\"><span translate=DONE_BTN></span></button></div></div>");
$templateCache.put("app/stream/views/posts.html","<section class=home-view add-participants ng-class=\"{\'is-visible\':viewState.isInitiated}\" post-likes><div class=\"page-view-header clearfix post-header {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div><div premium-ad></div><div><div class=page-subheader-title><svg ng-click=onBackArrowTap() id=header-back-button class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <strong class=\"page-view-header__title bold-header-title\" style=\"padding-right: 0; color: #6d7279\"><span ng-if=currentGroup.archived>Archived -</span>	{{ currentGroup.title }}</strong><nav ng-if=\"currentGroup.id != -1\" class=\"has-dropdown is-relative more-dots\" style=\"margin-top: 0; position: absolute; top: 1px; right: 2px; width: 40px; z-index: 11; height: 50px; float: right\"><ul class=dropdown-menu style=\"right: 1px!important; background: #fff!important\"><li ng-click=onGroupTap(currentGroup)><a translate=GROUP_INFO></a></li></ul><svg style=\"transform: rotate(90deg); height: 45px; margin-top: 0; position: relative; padding: 1px 15px; width: 48px; right: -10px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\"><g transform=\"translate(0, 0)\"><circle fill=#4a9fef cx=4 cy=16 r=3></circle><circle data-color=color-2 fill=#4a9fef cx=16 cy=16 r=3></circle><circle fill=#4a9fef cx=28 cy=16 r=3></circle></g></svg></nav></div></div></div></div><div class=home-refresh-label ng-click=preGetPosts()><span translate=NEW_POSTS_LABEL></span></div><a class=post-composer ng-if=\"currentGroup.postEnabled && !currentGroup.archived\"><div ng-click=\"menuPlus($event, tierId)\"><div class=vi-row><div class=vi-col-middle><div class=create-a-post><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=20px height=20px viewBox=\"0 0 32 32\"><g transform=\"translate(0, 0)\"><path d=M26,31H2a1,1,0,0,1-1-1V6A1,1,0,0,1,2,5H14V7H3V29H25V18h2V30A1,1,0,0,1,26,31Z fill=#EB004E></path><path data-color=color-2 d=M30.707,5.293l-4-4a1,1,0,0,0-1.414,0l-14,14a1,1,0,0,0-.241.391l-2,6A1,1,0,0,0,10,23a.987.987,0,0,0,.316-.052l6-2a1,1,0,0,0,.391-.241l14-14A1,1,0,0,0,30.707,5.293Z fill=#EB004E></path></g></svg> <span style=\"color: #EB004E; font-size: 16px;\n						font-weight: 800\">Write a post</span></div></div></div></div></a><div ng-if=currentGroup.archived style=\"padding-bottom: 20px\"></div><aside class=group-posts><ng-include ng-if=\"showAppcueIntroduce && !currentGroup.archived\" src=\"\'app/base/appcues/introduce-yourself-modal.html\'\"></ng-include><div class=empty-state ng-if=\"posts.length == 0 && postsLoaded == true\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><line data-color=color-2 x1=20 y1=44 x2=44 y2=44 fill=none stroke=#4aa0f0 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></line><circle data-color=color-2 cx=19.5 cy=29.5 r=2.5 fill=none stroke=#4aa0f0 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></circle><circle data-color=color-2 cx=44.5 cy=29.5 r=2.5 fill=none stroke=#4aa0f0 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></circle><circle cx=32 cy=32 r=28 fill=none stroke=#4aa0f0 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></circle><circle data-color=color-2 data-stroke=none cx=19.5 cy=29.5 r=2.5 fill=#4aa0f0></circle><circle data-color=color-2 data-stroke=none cx=44.5 cy=29.5 r=2.5 fill=#4aa0f0></circle></g></svg><h4 translate=EMPTY_TITLE_HOME></h4><p translate=EMPTY_DESCR_HOME></p></div><div ng-repeat=\"p in posts\" class=post-in-posts><post-asset ng-show=!p.isAdv update-comments=updatePostComments(post) on-group-name-tap=onGroupNameTap(group) archived-group=currentGroup.archived post-content=p post-context=HOME_VIEW class=enter user-avatar=active_user.avatar user-id=active_user.id post-user-id=active_user.id user-name=userName post-events=events></post-asset><div id=\"home-post-ad-{{ p.id }}\" ad-id=\"{{ p.id }}\" post-index=\"{{ $index }}\" class=home-post-ad ng-if=p.isAdv style=\"min-height: 250px\"><post-adv post-context=HOME_VIEW class=enter link-name=p.callToAction title=p.title artwork=p.artwork logo=p.logo body=p.body link=p.link domain=p.domain></post-adv></div></div><section class=demo-view ng-if=\"!posts || posts.length == 0\"><div class=demo-post-list><div><div class=demo-header><div></div><div></div></div><div class=demo-picture></div></div><div><div class=demo-header><div></div><div></div></div><div class=demo-picture></div></div></div></section><div ng-show=\"hasMorePosts() || showSpinner\" class=vi-loader><div><svg class=circular viewBox=\"25 25 50 50\"><circle class=path cx=50 cy=50 r=20 fill=none stroke-width=4 stroke-miterlimit=10></circle></svg></div></div></aside></section>");
$templateCache.put("app/stream/views/update-app-modal.html","<div><div class=modal-body><p translate=UPDATE_APP_TEXT_1></p></div><div class=modal-footer style=\"padding-top: 0\"><div><div><a type=button class=\"btn btn-primary pull-right\" translate=UPDATE href=https://itunes.apple.com/us/app/classlist/id1058636226 target=_blank></a></div></div></div></div>");
$templateCache.put("app/stream/views/wrapper.html","<div class=home-background><div class=\"content-logged home\"><div autoscroll=false><ng-include src=\"\'app/stream/views/posts.html\'\"></ng-include></div></div></div>");}]);